(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ScratchRender"] = factory();
	else
		root["ScratchRender"] = factory();
})(self, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/scratch-svg-renderer/src/bitmap-adapter.js":
/*!*****************************************************************!*\
  !*** ./node_modules/scratch-svg-renderer/src/bitmap-adapter.js ***!
  \*****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var base64js = __webpack_require__(/*! base64-js */ "./node_modules/scratch-svg-renderer/node_modules/base64-js/index.js");

/**
 * Adapts Scratch 2.0 bitmaps for use in scratch 3.0
 */
var BitmapAdapter = /*#__PURE__*/function () {
  /**
   * @param {?function} makeImage HTML image constructor. Tests can provide this.
   * @param {?function} makeCanvas HTML canvas constructor. Tests can provide this.
   */
  function BitmapAdapter(makeImage, makeCanvas) {
    _classCallCheck(this, BitmapAdapter);
    this._makeImage = makeImage ? makeImage : function () {
      return new Image();
    };
    this._makeCanvas = makeCanvas ? makeCanvas : function () {
      return document.createElement('canvas');
    };
  }

  /**
   * Return a canvas with the resized version of the given image, done using nearest-neighbor interpolation
   * @param {CanvasImageSource} image The image to resize
   * @param {int} newWidth The desired post-resize width of the image
   * @param {int} newHeight The desired post-resize height of the image
   * @returns {HTMLCanvasElement} A canvas with the resized image drawn on it.
   */
  return _createClass(BitmapAdapter, [{
    key: "resize",
    value: function resize(image, newWidth, newHeight) {
      // We want to always resize using nearest-neighbor interpolation. However, canvas implementations are free to
      // use linear interpolation (or other "smooth" interpolation methods) when downscaling:
      // https://bugzilla.mozilla.org/show_bug.cgi?id=1360415
      // It seems we can get around this by resizing in two steps: first width, then height. This will always result
      // in nearest-neighbor interpolation, even when downscaling.
      var stretchWidthCanvas = this._makeCanvas();
      stretchWidthCanvas.width = newWidth;
      stretchWidthCanvas.height = image.height;
      var context = stretchWidthCanvas.getContext('2d');
      context.imageSmoothingEnabled = false;
      context.drawImage(image, 0, 0, stretchWidthCanvas.width, stretchWidthCanvas.height);
      var stretchHeightCanvas = this._makeCanvas();
      stretchHeightCanvas.width = newWidth;
      stretchHeightCanvas.height = newHeight;
      context = stretchHeightCanvas.getContext('2d');
      context.imageSmoothingEnabled = false;
      context.drawImage(stretchWidthCanvas, 0, 0, stretchHeightCanvas.width, stretchHeightCanvas.height);
      return stretchHeightCanvas;
    }

    /**
     * Scratch 2.0 had resolution 1 and 2 bitmaps. All bitmaps in Scratch 3.0 are equivalent
     * to resolution 2 bitmaps. Therefore, converting a resolution 1 bitmap means doubling
     * it in width and height.
     * @param {!string} dataURI Base 64 encoded image data of the bitmap
     * @param {!function} callback Node-style callback that returns updated dataURI if conversion succeeded
     */
  }, {
    key: "convertResolution1Bitmap",
    value: function convertResolution1Bitmap(dataURI, callback) {
      var _this = this;
      var image = this._makeImage();
      image.src = dataURI;
      image.onload = function () {
        callback(null, _this.resize(image, image.width * 2, image.height * 2).toDataURL());
      };
      image.onerror = function () {
        callback('Image load failed');
      };
    }

    /**
     * Given width/height of an uploaded item, return width/height the image will be resized
     * to in Scratch 3.0
     * @param {!number} oldWidth original width
     * @param {!number} oldHeight original height
     * @return {object} Array of new width, new height
     */
  }, {
    key: "getResizedWidthHeight",
    value: function getResizedWidthHeight(oldWidth, oldHeight) {
      var STAGE_WIDTH = 480;
      var STAGE_HEIGHT = 360;
      var STAGE_RATIO = STAGE_WIDTH / STAGE_HEIGHT;

      // If both dimensions are smaller than or equal to corresponding stage dimension,
      // double both dimensions
      if (oldWidth <= STAGE_WIDTH && oldHeight <= STAGE_HEIGHT) {
        return {
          width: oldWidth * 2,
          height: oldHeight * 2
        };
      }

      // If neither dimension is larger than 2x corresponding stage dimension,
      // this is an in-between image, return it as is
      if (oldWidth <= STAGE_WIDTH * 2 && oldHeight <= STAGE_HEIGHT * 2) {
        return {
          width: oldWidth,
          height: oldHeight
        };
      }
      var imageRatio = oldWidth / oldHeight;
      // Otherwise, figure out how to resize
      if (imageRatio >= STAGE_RATIO) {
        // Wide Image
        return {
          width: STAGE_WIDTH * 2,
          height: STAGE_WIDTH * 2 / imageRatio
        };
      }
      // In this case we have either:
      // - A wide image, but not with as big a ratio between width and height,
      // making it so that fitting the width to double stage size would leave
      // the height too big to fit in double the stage height
      // - A square image that's still larger than the double at least
      // one of the stage dimensions, so pick the smaller of the two dimensions (to fit)
      // - A tall image
      // In any of these cases, resize the image to fit the height to double the stage height
      return {
        width: STAGE_HEIGHT * 2 * imageRatio,
        height: STAGE_HEIGHT * 2
      };
    }

    /**
     * Given bitmap data, resize as necessary.
     * @param {ArrayBuffer | string} fileData Base 64 encoded image data of the bitmap
     * @param {string} fileType The MIME type of this file
     * @returns {Promise} Resolves to resized image data Uint8Array
     */
  }, {
    key: "importBitmap",
    value: function importBitmap(fileData, fileType) {
      var _this2 = this;
      var dataURI = fileData;
      if (fileData instanceof ArrayBuffer) {
        dataURI = this.convertBinaryToDataURI(fileData, fileType);
      }
      return new Promise(function (resolve, reject) {
        var image = _this2._makeImage();
        image.src = dataURI;
        image.onload = function () {
          var newSize = _this2.getResizedWidthHeight(image.width, image.height);
          if (newSize.width === image.width && newSize.height === image.height) {
            // No change
            resolve(_this2.convertDataURIToBinary(dataURI));
          } else {
            var resizedDataURI = _this2.resize(image, newSize.width, newSize.height).toDataURL();
            resolve(_this2.convertDataURIToBinary(resizedDataURI));
          }
        };
        image.onerror = function () {
          // TODO: reject with an Error (breaking API change!)
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('Image load failed');
        };
      });
    }

    // TODO consolidate with scratch-vm/src/util/base64-util.js
    // From https://gist.github.com/borismus/1032746
  }, {
    key: "convertDataURIToBinary",
    value: function convertDataURIToBinary(dataURI) {
      var BASE64_MARKER = ';base64,';
      var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
      var base64 = dataURI.substring(base64Index);
      var raw = window.atob(base64);
      var rawLength = raw.length;
      var array = new Uint8Array(new ArrayBuffer(rawLength));
      for (var i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
      return array;
    }
  }, {
    key: "convertBinaryToDataURI",
    value: function convertBinaryToDataURI(arrayBuffer, contentType) {
      return "data:".concat(contentType, ";base64,").concat(base64js.fromByteArray(new Uint8Array(arrayBuffer)));
    }
  }]);
}();
module.exports = BitmapAdapter;

/***/ }),

/***/ "./node_modules/scratch-svg-renderer/src/fixup-svg-string.js":
/*!*******************************************************************!*\
  !*** ./node_modules/scratch-svg-renderer/src/fixup-svg-string.js ***!
  \*******************************************************************/
/***/ (function(module) {

/**
 * Fixup svg string prior to parsing.
 * @param {!string} svgString String of the svg to fix.
 * @returns {!string} fixed svg that should be parseable.
 */
module.exports = function (svgString) {
  // Add root svg namespace if it does not exist.
  var svgAttrs = svgString.match(/<svg [^>]*>/);
  if (svgAttrs && svgAttrs[0].indexOf('xmlns=') === -1) {
    svgString = svgString.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ');
  }

  // There are some SVGs from Illustrator that use undeclared entities.
  // Just replace those entities with fake namespace references to prevent
  // DOMParser from crashing
  if (svgAttrs && svgAttrs[0].indexOf('&ns_') !== -1 && svgString.indexOf('<!DOCTYPE') === -1) {
    svgString = svgString.replace(svgAttrs[0], svgAttrs[0].replace(/&ns_[^;]+;/g, 'http://ns.adobe.com/Extensibility/1.0/'));
  }

  // Some SVGs exported from Photoshop have been found to have an invalid mime type
  // Chrome and Safari won't render these SVGs, so we correct it here
  if (svgString.includes('data:img/png')) {
    svgString = svgString.replace(
    // capture entire image tag with xlink:href=and the quote - dont capture data: bit
    /(<image[^>]+?xlink:href=["'])data:img\/png/g,
    // use the captured <image ..... xlink:href=" then append the right data uri mime type
    function ($0, $1) {
      return "".concat($1, "data:image/png");
    });
  }

  // Some SVGs from Inkscape attempt to bind a prefix to a reserved namespace name.
  // This will cause SVG parsing to fail, so replace these with a dummy namespace name.
  // This namespace name is only valid for "xml", and if we bind "xmlns:xml" to the dummy namespace,
  // parsing will fail yet again, so exclude "xmlns:xml" declarations.
  var xmlnsRegex = /(<[^>]+?xmlns:(?!xml=)[^ ]+=)"http:\/\/www.w3.org\/XML\/1998\/namespace"/g;
  if (svgString.match(xmlnsRegex) !== null) {
    svgString = svgString.replace(
    // capture the entire attribute
    xmlnsRegex,
    // use the captured attribute name; replace only the URL
    function ($0, $1) {
      return "".concat($1, "\"http://dummy.namespace\"");
    });
  }

  // Strip `svg:` prefix (sometimes added by Inkscape) from all tags. They interfere with DOMPurify (prefixed tag
  // names are not recognized) and the paint editor.
  // This matches opening and closing tags--the capture group captures the slash if it exists, and it is reinserted
  // in the replacement text.
  svgString = svgString.replace(/<(\/?)\s*svg:/g, '<$1');

  // The <metadata> element is not needed for rendering and sometimes contains
  // unparseable garbage from Illustrator :( Empty out the contents.
  // Note: [\s\S] matches everything including newlines, which .* does not
  svgString = svgString.replace(/<metadata>[\s\S]*<\/metadata>/, '<metadata></metadata>');

  // Empty script tags and javascript executing
  svgString = svgString.replace(/<script[\s\S]*>[\s\S]*<\/script>/, '<script></script>');
  return svgString;
};

/***/ }),

/***/ "./node_modules/scratch-svg-renderer/src/font-converter.js":
/*!*****************************************************************!*\
  !*** ./node_modules/scratch-svg-renderer/src/font-converter.js ***!
  \*****************************************************************/
/***/ (function(module) {

/**
 * @fileOverview Convert 2.0 fonts to 3.0 fonts.
 */

/**
 * Given an SVG, replace Scratch 2.0 fonts with new 3.0 fonts. Add defaults where there are none.
 * @param {SVGElement} svgTag The SVG dom object
 * @return {void}
 */
var convertFonts = function convertFonts(svgTag) {
  // Collect all text elements into a list.
  var textElements = [];
  var _collectText = function collectText(domElement) {
    if (domElement.localName === 'text') {
      textElements.push(domElement);
    }
    for (var i = 0; i < domElement.childNodes.length; i++) {
      _collectText(domElement.childNodes[i]);
    }
  };
  _collectText(svgTag);
  // If there's an old font-family, switch to the new one.
  for (var _i = 0, _textElements = textElements; _i < _textElements.length; _i++) {
    var textElement = _textElements[_i];
    // If there's no font-family provided, provide one.
    if (!textElement.getAttribute('font-family') || textElement.getAttribute('font-family') === 'Helvetica') {
      textElement.setAttribute('font-family', 'Sans Serif');
    } else if (textElement.getAttribute('font-family') === 'Mystery') {
      textElement.setAttribute('font-family', 'Curly');
    } else if (textElement.getAttribute('font-family') === 'Gloria') {
      textElement.setAttribute('font-family', 'Handwriting');
    } else if (textElement.getAttribute('font-family') === 'Donegal') {
      textElement.setAttribute('font-family', 'Serif');
    }
  }
};
module.exports = convertFonts;

/***/ }),

/***/ "./node_modules/scratch-svg-renderer/src/font-inliner.js":
/*!***************************************************************!*\
  !*** ./node_modules/scratch-svg-renderer/src/font-inliner.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * @fileOverview Import bitmap data into Scratch 3.0, resizing image as necessary.
 */
var getFonts = __webpack_require__(/*! scratch-render-fonts */ "./node_modules/scratch-render-fonts/src/index.js");

/**
 * Given SVG data, inline the fonts. This allows them to be rendered correctly when set
 * as the source of an HTMLImageElement. Here is a note from tmickel:
 *   // Inject fonts that are needed.
 *   // It would be nice if there were another way to get the SVG-in-canvas
 *   // to render the correct font family, but I couldn't find any other way.
 *   // Other things I tried:
 *   // Just injecting the font-family into the document: no effect.
 *   // External stylesheet linked to by SVG: no effect.
 *   // Using a <link> or <style>@import</style> to link to font-family
 *   // injected into the document: no effect.
 * @param {string} svgString The string representation of the svg to modify
 * @return {string} The svg with any needed fonts inlined
 */
var inlineSvgFonts = function inlineSvgFonts(svgString) {
  var FONTS = getFonts();
  // Make it clear that this function only operates on strings.
  // If we don't explicitly throw this here, the function silently fails.
  if (typeof svgString !== 'string') {
    throw new Error('SVG to be inlined is not a string');
  }

  // Collect fonts that need injection.
  var fontsNeeded = new Set();
  var fontRegex = /font-family="([^"]*)"/g;
  var matches = fontRegex.exec(svgString);
  while (matches) {
    fontsNeeded.add(matches[1]);
    matches = fontRegex.exec(svgString);
  }
  if (fontsNeeded.size > 0) {
    var str = '<defs><style>';
    var _iterator = _createForOfIteratorHelper(fontsNeeded),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var font = _step.value;
        if (Object.prototype.hasOwnProperty.call(FONTS, font)) {
          str += "".concat(FONTS[font]);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    str += '</style></defs>';
    svgString = svgString.replace(/<svg[^>]*>/, "$&".concat(str));
    return svgString;
  }
  return svgString;
};
module.exports = inlineSvgFonts;

/***/ }),

/***/ "./node_modules/scratch-svg-renderer/src/index.js":
/*!********************************************************!*\
  !*** ./node_modules/scratch-svg-renderer/src/index.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SVGRenderer = __webpack_require__(/*! ./svg-renderer */ "./node_modules/scratch-svg-renderer/src/svg-renderer.js");
var BitmapAdapter = __webpack_require__(/*! ./bitmap-adapter */ "./node_modules/scratch-svg-renderer/src/bitmap-adapter.js");
var inlineSvgFonts = __webpack_require__(/*! ./font-inliner */ "./node_modules/scratch-svg-renderer/src/font-inliner.js");
var loadSvgString = __webpack_require__(/*! ./load-svg-string */ "./node_modules/scratch-svg-renderer/src/load-svg-string.js");
var sanitizeSvg = __webpack_require__(/*! ./sanitize-svg */ "./node_modules/scratch-svg-renderer/src/sanitize-svg.js");
var serializeSvgToString = __webpack_require__(/*! ./serialize-svg-to-string */ "./node_modules/scratch-svg-renderer/src/serialize-svg-to-string.js");
var SvgElement = __webpack_require__(/*! ./svg-element */ "./node_modules/scratch-svg-renderer/src/svg-element.js");
var convertFonts = __webpack_require__(/*! ./font-converter */ "./node_modules/scratch-svg-renderer/src/font-converter.js");
// /**
//  * Export for NPM & Node.js
//  * @type {RenderWebGL}
//  */
module.exports = {
  BitmapAdapter: BitmapAdapter,
  convertFonts: convertFonts,
  inlineSvgFonts: inlineSvgFonts,
  loadSvgString: loadSvgString,
  sanitizeSvg: sanitizeSvg,
  serializeSvgToString: serializeSvgToString,
  SvgElement: SvgElement,
  SVGRenderer: SVGRenderer
};

/***/ }),

/***/ "./node_modules/scratch-svg-renderer/src/load-svg-string.js":
/*!******************************************************************!*\
  !*** ./node_modules/scratch-svg-renderer/src/load-svg-string.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var DOMPurify = __webpack_require__(/*! isomorphic-dompurify */ "./node_modules/isomorphic-dompurify/browser.js");
var SvgElement = __webpack_require__(/*! ./svg-element */ "./node_modules/scratch-svg-renderer/src/svg-element.js");
var convertFonts = __webpack_require__(/*! ./font-converter */ "./node_modules/scratch-svg-renderer/src/font-converter.js");
var fixupSvgString = __webpack_require__(/*! ./fixup-svg-string */ "./node_modules/scratch-svg-renderer/src/fixup-svg-string.js");
var transformStrokeWidths = __webpack_require__(/*! ./transform-applier */ "./node_modules/scratch-svg-renderer/src/transform-applier.js");

/**
 * @param {SVGElement} svgTag the tag to search within
 * @param {string} [tagName] svg tag to search for (or collect all elements if not given)
 * @return {Array} a list of elements with the given tagname
 */
var collectElements = function collectElements(svgTag, tagName) {
  var elts = [];
  var _collectElementsInner = function collectElementsInner(domElement) {
    if ((domElement.localName === tagName || typeof tagName === 'undefined') && domElement.getAttribute) {
      elts.push(domElement);
    }
    for (var i = 0; i < domElement.childNodes.length; i++) {
      _collectElementsInner(domElement.childNodes[i]);
    }
  };
  _collectElementsInner(svgTag);
  return elts;
};

/**
 * Fix SVGs to comply with SVG spec. Scratch 2 defaults to x2 = 0 when x2 is missing, but
 * SVG defaults to x2 = 1 when missing.
 * @param {SVGSVGElement} svgTag the SVG tag to apply the transformation to
 */
var transformGradients = function transformGradients(svgTag) {
  var linearGradientElements = collectElements(svgTag, 'linearGradient');

  // For each gradient element, supply x2 if necessary.
  var _iterator = _createForOfIteratorHelper(linearGradientElements),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var gradientElement = _step.value;
      if (!gradientElement.getAttribute('x2')) {
        gradientElement.setAttribute('x2', '0');
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

/**
 * Fix SVGs to match appearance in Scratch 2, which used nearest neighbor scaling for bitmaps
 * within SVGs.
 * @param {SVGSVGElement} svgTag the SVG tag to apply the transformation to
 */
var transformImages = function transformImages(svgTag) {
  var imageElements = collectElements(svgTag, 'image');

  // For each image element, set image rendering to pixelated
  var pixelatedImages = 'image-rendering: optimizespeed; image-rendering: pixelated;';
  var _iterator2 = _createForOfIteratorHelper(imageElements),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var elt = _step2.value;
      if (elt.getAttribute('style')) {
        elt.setAttribute('style', "".concat(pixelatedImages, " ").concat(elt.getAttribute('style')));
      } else {
        elt.setAttribute('style', pixelatedImages);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};

/**
 * Transforms an SVG's text elements for Scratch 2.0 quirks.
 * These quirks include:
 * 1. `x` and `y` properties are removed/ignored.
 * 2. Alignment is set to `text-before-edge`.
 * 3. Line-breaks are converted to explicit <tspan> elements.
 * 4. Any required fonts are injected.
 * @param {SVGSVGElement} svgTag the SVG tag to apply the transformation to
 */
var transformText = function transformText(svgTag) {
  // Collect all text elements into a list.
  var textElements = [];
  var _collectText = function collectText(domElement) {
    if (domElement.localName === 'text') {
      textElements.push(domElement);
    }
    for (var i = 0; i < domElement.childNodes.length; i++) {
      _collectText(domElement.childNodes[i]);
    }
  };
  _collectText(svgTag);
  convertFonts(svgTag);
  // For each text element, apply quirks.
  for (var _i = 0, _textElements = textElements; _i < _textElements.length; _i++) {
    var textElement = _textElements[_i];
    // Remove x and y attributes - they are not used in Scratch.
    textElement.removeAttribute('x');
    textElement.removeAttribute('y');
    // Set text-before-edge alignment:
    // Scratch renders all text like this.
    textElement.setAttribute('alignment-baseline', 'text-before-edge');
    textElement.setAttribute('xml:space', 'preserve');
    // If there's no font size provided, provide one.
    if (!textElement.getAttribute('font-size')) {
      textElement.setAttribute('font-size', '18');
    }
    var text = textElement.textContent;

    // Fix line breaks in text, which are not natively supported by SVG.
    // Only fix if text does not have child tspans.
    // @todo this will not work for font sizes with units such as em, percent
    // However, text made in scratch 2 should only ever export size 22 font.
    var fontSize = parseFloat(textElement.getAttribute('font-size'));
    var tx = 2;
    var ty = 0;
    var spacing = 1.2;
    // Try to match the position and spacing of Scratch 2.0's fonts.
    // Different fonts seem to use different line spacing.
    // Scratch 2 always uses alignment-baseline=text-before-edge
    // However, most SVG readers don't support this attribute
    // or don't support it alongside use of tspan, so the translations
    // here are to make up for that.
    if (textElement.getAttribute('font-family') === 'Handwriting') {
      spacing = 2;
      ty = -11 * fontSize / 22;
    } else if (textElement.getAttribute('font-family') === 'Scratch') {
      spacing = 0.89;
      ty = -3 * fontSize / 22;
    } else if (textElement.getAttribute('font-family') === 'Curly') {
      spacing = 1.38;
      ty = -6 * fontSize / 22;
    } else if (textElement.getAttribute('font-family') === 'Marker') {
      spacing = 1.45;
      ty = -6 * fontSize / 22;
    } else if (textElement.getAttribute('font-family') === 'Sans Serif') {
      spacing = 1.13;
      ty = -3 * fontSize / 22;
    } else if (textElement.getAttribute('font-family') === 'Serif') {
      spacing = 1.25;
      ty = -4 * fontSize / 22;
    }
    if (textElement.transform.baseVal.numberOfItems === 0) {
      var transform = svgTag.createSVGTransform();
      textElement.transform.baseVal.appendItem(transform);
    }

    // Right multiply matrix by a translation of (tx, ty)
    var mtx = textElement.transform.baseVal.getItem(0).matrix;
    mtx.e += mtx.a * tx + mtx.c * ty;
    mtx.f += mtx.b * tx + mtx.d * ty;
    if (text && textElement.childElementCount === 0) {
      textElement.textContent = '';
      var lines = text.split('\n');
      text = '';
      var _iterator3 = _createForOfIteratorHelper(lines),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var line = _step3.value;
          var tspanNode = SvgElement.create('tspan');
          tspanNode.setAttribute('x', '0');
          tspanNode.setAttribute('style', 'white-space: pre');
          tspanNode.setAttribute('dy', "".concat(spacing, "em"));
          tspanNode.textContent = line ? line : ' ';
          textElement.appendChild(tspanNode);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }
};

/**
 * Find the largest stroke width in the svg. If a shape has no
 * `stroke` property, it has a stroke-width of 0. If it has a `stroke`,
 * it is by default a stroke-width of 1.
 * This is used to enlarge the computed bounding box, which doesn't take
 * stroke width into account.
 * @param {SVGSVGElement} rootNode The root SVG node to traverse.
 * @return {number} The largest stroke width in the SVG.
 */
var findLargestStrokeWidth = function findLargestStrokeWidth(rootNode) {
  var largestStrokeWidth = 0;
  var _collectStrokeWidths = function collectStrokeWidths(domElement) {
    if (domElement.getAttribute) {
      if (domElement.getAttribute('stroke')) {
        largestStrokeWidth = Math.max(largestStrokeWidth, 1);
      }
      if (domElement.getAttribute('stroke-width')) {
        largestStrokeWidth = Math.max(largestStrokeWidth, Number(domElement.getAttribute('stroke-width')) || 0);
      }
    }
    for (var i = 0; i < domElement.childNodes.length; i++) {
      _collectStrokeWidths(domElement.childNodes[i]);
    }
  };
  _collectStrokeWidths(rootNode);
  return largestStrokeWidth;
};

/**
 * Transform the measurements of the SVG.
 * In Scratch 2.0, SVGs are drawn without respect to the width,
 * height, and viewBox attribute on the tag. The exporter
 * does output these properties - but they appear to be incorrect often.
 * To address the incorrect measurements, we append the DOM to the
 * document, and then use SVG's native `getBBox` to find the real
 * drawn dimensions. This ensures things drawn in negative dimensions,
 * outside the given viewBox, etc., are all eventually drawn to the canvas.
 * I tried to do this several other ways: stripping the width/height/viewBox
 * attributes and then drawing (Firefox won't draw anything),
 * or inflating them and then measuring a canvas. But this seems to be
 * a natural and performant way.
 * @param {SVGSVGElement} svgTag the SVG tag to apply the transformation to
 */
var transformMeasurements = function transformMeasurements(svgTag) {
  // Append the SVG dom to the document.
  // This allows us to use `getBBox` on the page,
  // which returns the full bounding-box of all drawn SVG
  // elements, similar to how Scratch 2.0 did measurement.
  var svgSpot = document.createElement('span');
  // Since we're adding user-provided SVG to document.body,
  // sanitizing is required. This should not affect bounding box calculation.
  // outerHTML is attribute of Element (and not HTMLElement), so use it instead of
  // calling serializer or toString()
  // NOTE: svgTag remains untouched!
  var rawValue = svgTag.outerHTML;
  var sanitizedValue = DOMPurify.sanitize(rawValue, {
    // Use SVG profile (no HTML elements)
    USE_PROFILES: {
      svg: true
    },
    // Remove some tags that Scratch does not use.
    FORBID_TAGS: ['a', 'audio', 'canvas', 'video'],
    // Allow data URI in image tags (e.g. SVGs converted from bitmap)
    ADD_DATA_URI_TAGS: ['image']
  });
  var bbox;
  try {
    // Insert sanitized value.
    svgSpot.innerHTML = sanitizedValue;
    document.body.appendChild(svgSpot);
    // Take the bounding box. We have to get elements via svgSpot
    // because we added it via innerHTML.
    bbox = svgSpot.children[0].getBBox();
  } finally {
    // Always destroy the element, even if, for example, getBBox throws.
    document.body.removeChild(svgSpot);
  }

  // Enlarge the bbox from the largest found stroke width
  // This may have false-positives, but at least the bbox will always
  // contain the full graphic including strokes.
  // If the width or height is zero however, don't enlarge since
  // they won't have a stroke width that needs to be enlarged.
  var halfStrokeWidth;
  if (bbox.width === 0 || bbox.height === 0) {
    halfStrokeWidth = 0;
  } else {
    halfStrokeWidth = findLargestStrokeWidth(svgTag) / 2;
  }
  var width = bbox.width + halfStrokeWidth * 2;
  var height = bbox.height + halfStrokeWidth * 2;
  var x = bbox.x - halfStrokeWidth;
  var y = bbox.y - halfStrokeWidth;

  // Set the correct measurements on the SVG tag
  svgTag.setAttribute('width', width);
  svgTag.setAttribute('height', height);
  svgTag.setAttribute('viewBox', "".concat(x, " ").concat(y, " ").concat(width, " ").concat(height));
};

/**
 * Find all instances of a URL-referenced `stroke` in the svg. In 2.0, all gradient strokes
 * have a round `stroke-linejoin` and `stroke-linecap`... for some reason.
 * @param {SVGSVGElement} svgTag the SVG tag to apply the transformation to
 */
var setGradientStrokeRoundedness = function setGradientStrokeRoundedness(svgTag) {
  var elements = collectElements(svgTag);
  var _iterator4 = _createForOfIteratorHelper(elements),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var elt = _step4.value;
      if (!elt.style) continue;
      var stroke = elt.style.stroke || elt.getAttribute('stroke');
      if (stroke && stroke.match(/^url\(#.*\)$/)) {
        elt.style['stroke-linejoin'] = 'round';
        elt.style['stroke-linecap'] = 'round';
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
};

/**
 * In-place, convert passed SVG to something consistent that will be rendered the way we want them to be.
 * @param {SVGSvgElement} svgTag root SVG node to operate upon
 * @param {boolean} [fromVersion2] True if we should perform conversion from version 2 to version 3 svg.
 */
var normalizeSvg = function normalizeSvg(svgTag, fromVersion2) {
  if (fromVersion2) {
    // Fix gradients. Scratch 2 exports no x2 when x2 = 0, but
    // SVG default is that x2 is 1. This must be done before
    // transformStrokeWidths since transformStrokeWidths affects
    // gradients.
    transformGradients(svgTag);
  }
  transformStrokeWidths(svgTag, window);
  transformImages(svgTag);
  if (fromVersion2) {
    // Transform all text elements.
    transformText(svgTag);
    // Transform measurements.
    transformMeasurements(svgTag);
    // Fix stroke roundedness.
    setGradientStrokeRoundedness(svgTag);
  } else if (!svgTag.getAttribute('viewBox')) {
    // Renderer expects a view box.
    transformMeasurements(svgTag);
  } else if (!svgTag.getAttribute('width') || !svgTag.getAttribute('height')) {
    svgTag.setAttribute('width', svgTag.viewBox.baseVal.width);
    svgTag.setAttribute('height', svgTag.viewBox.baseVal.height);
  }
};

/**
 * Load an SVG string and normalize it. All the steps before drawing/measuring.
 * Currently, this will normalize stroke widths (see transform-applier.js) and render all embedded images pixelated.
 * The returned SVG will be guaranteed to always have a `width`, `height` and `viewBox`.
 * In addition, if the `fromVersion2` parameter is `true`, several "quirks-mode" transformations will be applied which
 * mimic Scratch 2.0's SVG rendering.
 * @param {!string} svgString String of SVG data to draw in quirks-mode.
 * @param {boolean} [fromVersion2] True if we should perform conversion from version 2 to version 3 svg.
 * @return {SVGSVGElement} The normalized SVG element.
 */
var loadSvgString = function loadSvgString(svgString, fromVersion2) {
  // Parse string into SVG XML.
  var parser = new DOMParser();
  svgString = fixupSvgString(svgString);
  var svgDom = parser.parseFromString(svgString, 'text/xml');
  if (svgDom.childNodes.length < 1 || svgDom.documentElement.localName !== 'svg') {
    throw new Error('Document does not appear to be SVG.');
  }
  var svgTag = svgDom.documentElement;
  normalizeSvg(svgTag, fromVersion2);
  return svgTag;
};
module.exports = loadSvgString;

/***/ }),

/***/ "./node_modules/scratch-svg-renderer/src/sanitize-svg.js":
/*!***************************************************************!*\
  !*** ./node_modules/scratch-svg-renderer/src/sanitize-svg.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * @fileOverview Sanitize the content of an SVG aggressively, to make it as safe
 * as possible
 */
var fixupSvgString = __webpack_require__(/*! ./fixup-svg-string */ "./node_modules/scratch-svg-renderer/src/fixup-svg-string.js");
var _require = __webpack_require__(/*! css-tree */ "./node_modules/css-tree/lib/index.js"),
  generate = _require.generate,
  parse = _require.parse,
  walk = _require.walk;
var DOMPurify = __webpack_require__(/*! isomorphic-dompurify */ "./node_modules/isomorphic-dompurify/browser.js");
var sanitizeSvg = {};
DOMPurify.addHook('beforeSanitizeAttributes', function (currentNode) {
  if (currentNode && currentNode.href && currentNode.href.baseVal) {
    var href = currentNode.href.baseVal.replace(/\s/g, '');
    // "data:" and "#" are valid hrefs
    if (href.slice(0, 5) !== 'data:' && href.slice(0, 1) !== '#') {
      if (currentNode.attributes.getNamedItem('xlink:href')) {
        currentNode.attributes.removeNamedItem('xlink:href');
        delete currentNode['xlink:href'];
      }
      if (currentNode.attributes.getNamedItem('href')) {
        currentNode.attributes.removeNamedItem('href');
        delete currentNode.href;
      }
    }
  }
  return currentNode;
});
DOMPurify.addHook('uponSanitizeElement', function (node, data) {
  if (data.tagName === 'style') {
    var ast = parse(node.textContent);
    var isModified = false;
    // Remove any @import rules as it could leak HTTP requests
    walk(ast, function (astNode, item, list) {
      if (astNode.type === 'Atrule' && astNode.name === 'import') {
        list.remove(item);
        isModified = true;
      }
    });
    if (isModified) {
      node.textContent = generate(ast);
    }
  }
});

// Use JS implemented TextDecoder and TextEncoder if it is not provided by the
// browser.
var _TextDecoder;
var _TextEncoder;
if (typeof TextDecoder === 'undefined' || typeof TextEncoder === 'undefined') {
  // Wait to require the text encoding polyfill until we know it's needed.
  // eslint-disable-next-line global-require
  var encoding = __webpack_require__(/*! fastestsmallesttextencoderdecoder */ "./node_modules/fastestsmallesttextencoderdecoder/EncoderDecoderTogether.min.js");
  _TextDecoder = encoding.TextDecoder;
  _TextEncoder = encoding.TextEncoder;
} else {
  _TextDecoder = TextDecoder;
  _TextEncoder = TextEncoder;
}

/**
 * Load an SVG Uint8Array of bytes and "sanitize" it
 * @param {!Uint8Array} rawData unsanitized SVG daata
 * @return {Uint8Array} sanitized SVG data
 */
sanitizeSvg.sanitizeByteStream = function (rawData) {
  var decoder = new _TextDecoder();
  var encoder = new _TextEncoder();
  var sanitizedText = sanitizeSvg.sanitizeSvgText(decoder.decode(rawData));
  return encoder.encode(sanitizedText);
};

/**
 * Load an SVG string and "sanitize" it. This is more aggressive than the handling in
 * fixup-svg-string.js, and thus more risky; there are known examples of SVGs that
 * it will clobber. We use DOMPurify's svg profile, which restricts many types of tag.
 * @param {!string} rawSvgText unsanitized SVG string
 * @return {string} sanitized SVG text
 */
sanitizeSvg.sanitizeSvgText = function (rawSvgText) {
  var sanitizedText = DOMPurify.sanitize(rawSvgText, {
    USE_PROFILES: {
      svg: true
    }
  });

  // Remove partial XML comment that is sometimes left in the HTML
  var badTag = sanitizedText.indexOf(']&gt;');
  if (badTag >= 0) {
    sanitizedText = sanitizedText.substring(5, sanitizedText.length);
  }

  // also use our custom fixup rules
  sanitizedText = fixupSvgString(sanitizedText);
  return sanitizedText;
};
module.exports = sanitizeSvg;

/***/ }),

/***/ "./node_modules/scratch-svg-renderer/src/serialize-svg-to-string.js":
/*!**************************************************************************!*\
  !*** ./node_modules/scratch-svg-renderer/src/serialize-svg-to-string.js ***!
  \**************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var inlineSvgFonts = __webpack_require__(/*! ./font-inliner */ "./node_modules/scratch-svg-renderer/src/font-inliner.js");

/**
 * Serialize a given SVG DOM to a string.
 * @param {SVGSVGElement} svgTag The SVG element to serialize.
 * @param {?boolean} shouldInjectFonts True if fonts should be included in the SVG as
 *     base64 data.
 * @returns {string} String representing current SVG data.
 */
var serializeSvgToString = function serializeSvgToString(svgTag, shouldInjectFonts) {
  var serializer = new XMLSerializer();
  var string = serializer.serializeToString(svgTag);
  if (shouldInjectFonts) {
    string = inlineSvgFonts(string);
  }
  return string;
};
module.exports = serializeSvgToString;

/***/ }),

/***/ "./node_modules/scratch-svg-renderer/src/svg-element.js":
/*!**************************************************************!*\
  !*** ./node_modules/scratch-svg-renderer/src/svg-element.js ***!
  \**************************************************************/
/***/ (function(module) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* Adapted from
 * Paper.js - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2016, Juerg Lehni & Jonathan Puckey
 * http://scratchdisk.com/ & http://jonathanpuckey.com/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 */
/**
 * @name SvgElement
 * @namespace
 * @private
 */
var SvgElement = /*#__PURE__*/function () {
  function SvgElement() {
    _classCallCheck(this, SvgElement);
  }
  return _createClass(SvgElement, null, [{
    key: "svg",
    get:
    // SVG related namespaces
    function get() {
      return 'http://www.w3.org/2000/svg';
    }
  }, {
    key: "xmlns",
    get: function get() {
      return 'http://www.w3.org/2000/xmlns';
    }
  }, {
    key: "xlink",
    get: function get() {
      return 'http://www.w3.org/1999/xlink';
    }

    // Mapping of attribute names to required namespaces:
  }, {
    key: "attributeNamespace",
    value: function attributeNamespace() {
      return {
        'href': SvgElement.xlink,
        'xlink': SvgElement.xmlns,
        // Only the xmlns attribute needs the trailing slash. See #984
        'xmlns': "".concat(SvgElement.xmlns, "/"),
        // IE needs the xmlns namespace when setting 'xmlns:xlink'. See #984
        'xmlns:xlink': "".concat(SvgElement.xmlns, "/")
      };
    }
  }, {
    key: "create",
    value: function create(tag, attributes, formatter) {
      return SvgElement.set(document.createElementNS(SvgElement.svg, tag), attributes, formatter);
    }
  }, {
    key: "get",
    value: function get(node, name) {
      var namespace = SvgElement.attributeNamespace[name];
      var value = namespace ? node.getAttributeNS(namespace, name) : node.getAttribute(name);
      return value === 'null' ? null : value;
    }
  }, {
    key: "set",
    value: function set(node, attributes, formatter) {
      for (var name in attributes) {
        var value = attributes[name];
        var namespace = SvgElement.attributeNamespace[name];
        if (typeof value === 'number' && formatter) {
          value = formatter.number(value);
        }
        if (namespace) {
          node.setAttributeNS(namespace, name, value);
        } else {
          node.setAttribute(name, value);
        }
      }
      return node;
    }
  }]);
}();
module.exports = SvgElement;

/***/ }),

/***/ "./node_modules/scratch-svg-renderer/src/svg-renderer.js":
/*!***************************************************************!*\
  !*** ./node_modules/scratch-svg-renderer/src/svg-renderer.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var loadSvgString = __webpack_require__(/*! ./load-svg-string */ "./node_modules/scratch-svg-renderer/src/load-svg-string.js");
var serializeSvgToString = __webpack_require__(/*! ./serialize-svg-to-string */ "./node_modules/scratch-svg-renderer/src/serialize-svg-to-string.js");

/**
 * Main quirks-mode SVG rendering code.
 * @deprecated Call into individual methods exported from this library instead.
 */
var SvgRenderer = /*#__PURE__*/function () {
  /**
   * Create a quirks-mode SVG renderer for a particular canvas.
   * @param {HTMLCanvasElement} [canvas] An optional canvas element to draw to. If this is not provided, the renderer
   * will create a new canvas.
   * @constructor
   */
  function SvgRenderer(canvas) {
    _classCallCheck(this, SvgRenderer);
    /**
     * The canvas that this SVG renderer will render to.
     * @type {HTMLCanvasElement}
     * @private
     */
    this._canvas = canvas || document.createElement('canvas');
    this._context = this._canvas.getContext('2d');

    /**
     * A measured SVG "viewbox"
     * @typedef {object} SvgRenderer#SvgMeasurements
     * @property {number} x - The left edge of the SVG viewbox.
     * @property {number} y - The top edge of the SVG viewbox.
     * @property {number} width - The width of the SVG viewbox.
     * @property {number} height - The height of the SVG viewbox.
     */

    /**
     * The measurement box of the currently loaded SVG.
     * @type {SvgRenderer#SvgMeasurements}
     * @private
     */
    this._measurements = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };

    /**
     * The `<img>` element with the contents of the currently loaded SVG.
     * @type {?HTMLImageElement}
     * @private
     */
    this._cachedImage = null;

    /**
     * True if this renderer's current SVG is loaded and can be rendered to the canvas.
     * @type {boolean}
     */
    this.loaded = false;
  }

  /**
   * @returns {!HTMLCanvasElement} this renderer's target canvas.
   */
  return _createClass(SvgRenderer, [{
    key: "canvas",
    get: function get() {
      return this._canvas;
    }

    /**
     * @return {Array<number>} the natural size, in Scratch units, of this SVG.
     */
  }, {
    key: "size",
    get: function get() {
      return [this._measurements.width, this._measurements.height];
    }

    /**
     * @return {Array<number>} the offset (upper left corner) of the SVG's view box.
     */
  }, {
    key: "viewOffset",
    get: function get() {
      return [this._measurements.x, this._measurements.y];
    }

    /**
     * Load an SVG string and normalize it. All the steps before drawing/measuring.
     * @param {!string} svgString String of SVG data to draw in quirks-mode.
     * @param {?boolean} fromVersion2 True if we should perform conversion from
     *     version 2 to version 3 svg.
     */
  }, {
    key: "loadString",
    value: function loadString(svgString, fromVersion2) {
      // New svg string invalidates the cached image
      this._cachedImage = null;
      var svgTag = loadSvgString(svgString, fromVersion2);
      this._svgTag = svgTag;
      this._measurements = {
        width: svgTag.viewBox.baseVal.width,
        height: svgTag.viewBox.baseVal.height,
        x: svgTag.viewBox.baseVal.x,
        y: svgTag.viewBox.baseVal.y
      };
    }

    /**
     * Load an SVG string, normalize it, and prepare it for (synchronous) rendering.
     * @param {!string} svgString String of SVG data to draw in quirks-mode.
     * @param {?boolean} fromVersion2 True if we should perform conversion from version 2 to version 3 svg.
     * @param {Function} [onFinish] - An optional callback to call when the SVG is loaded and can be rendered.
     */
  }, {
    key: "loadSVG",
    value: function loadSVG(svgString, fromVersion2, onFinish) {
      this.loadString(svgString, fromVersion2);
      this._createSVGImage(onFinish);
    }

    /**
     * Creates an <img> element for the currently loaded SVG string, then calls the callback once it's loaded.
     * @param {Function} [onFinish] - An optional callback to call when the <img> has loaded.
     */
  }, {
    key: "_createSVGImage",
    value: function _createSVGImage(onFinish) {
      var _this = this;
      if (this._cachedImage === null) this._cachedImage = new Image();
      var img = this._cachedImage;
      img.onload = function () {
        _this.loaded = true;
        if (onFinish) onFinish();
      };
      var svgText = this.toString(true /* shouldInjectFonts */);
      img.src = "data:image/svg+xml;utf8,".concat(encodeURIComponent(svgText));
      this.loaded = false;
    }

    /**
     * Serialize the active SVG DOM to a string.
     * @param {?boolean} shouldInjectFonts True if fonts should be included in the SVG as
     *     base64 data.
     * @returns {string} String representing current SVG data.
     * @deprecated Use the standalone `serializeSvgToString` export instead.
     */
  }, {
    key: "toString",
    value: function toString(shouldInjectFonts) {
      return serializeSvgToString(this._svgTag, shouldInjectFonts);
    }

    /**
     * Synchronously draw the loaded SVG to this renderer's `canvas`.
     * @param {number} [scale] - Optionally, also scale the image by this factor.
     */
  }, {
    key: "draw",
    value: function draw(scale) {
      if (!this.loaded) throw new Error('SVG image has not finished loading');
      this._drawFromImage(scale);
    }

    /**
     * Draw to the canvas from a loaded image element.
     * @param {number} [scale] - Optionally, also scale the image by this factor.
     **/
  }, {
    key: "_drawFromImage",
    value: function _drawFromImage(scale) {
      if (this._cachedImage === null) return;
      var ratio = Number.isFinite(scale) ? scale : 1;
      var bbox = this._measurements;
      this._canvas.width = bbox.width * ratio;
      this._canvas.height = bbox.height * ratio;
      // Even if the canvas at the current scale has a nonzero size, the image's dimensions are floored pre-scaling.
      // e.g. if an image has a width of 0.4 and is being rendered at 3x scale, the canvas will have a width of 1, but
      // the image's width will be rounded down to 0 on some browsers (Firefox) prior to being drawn at that scale.
      if (this._canvas.width <= 0 || this._canvas.height <= 0 || this._cachedImage.naturalWidth <= 0 || this._cachedImage.naturalHeight <= 0) return;
      this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
      this._context.setTransform(ratio, 0, 0, ratio, 0, 0);
      this._context.drawImage(this._cachedImage, 0, 0);
    }
  }]);
}();
module.exports = SvgRenderer;

/***/ }),

/***/ "./node_modules/scratch-svg-renderer/src/transform-applier.js":
/*!********************************************************************!*\
  !*** ./node_modules/scratch-svg-renderer/src/transform-applier.js ***!
  \********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var Matrix = __webpack_require__(/*! transformation-matrix */ "./node_modules/transformation-matrix/build-es/index.js");
var SvgElement = __webpack_require__(/*! ./svg-element */ "./node_modules/scratch-svg-renderer/src/svg-element.js");
var log = __webpack_require__(/*! ./util/log */ "./node_modules/scratch-svg-renderer/src/util/log.js");

/**
 * @fileOverview Apply transforms to match stroke width appearance in 2.0 and 3.0
 */

// Adapted from paper.js's Path.applyTransform
var _parseTransform = function _parseTransform(domElement) {
  var matrix = Matrix.identity();
  var string = domElement.attributes && domElement.attributes.transform && domElement.attributes.transform.value;
  if (!string) return matrix;
  // https://www.w3.org/TR/SVG/types.html#DataTypeTransformList
  // Parse SVG transform string. First we split at /)\s*/, to separate
  // commands
  var transforms = string.split(/\)\s*/g);
  var _iterator = _createForOfIteratorHelper(transforms),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var transform = _step.value;
      if (!transform) break;
      // Command come before the '(', values after
      var parts = transform.split(/\(\s*/);
      var command = parts[0].trim();
      var v = parts[1].split(/[\s,]+/g);
      // Convert values to floats
      for (var j = 0; j < v.length; j++) {
        v[j] = parseFloat(v[j]);
      }
      switch (command) {
        case 'matrix':
          matrix = Matrix.compose(matrix, {
            a: v[0],
            b: v[1],
            c: v[2],
            d: v[3],
            e: v[4],
            f: v[5]
          });
          break;
        case 'rotate':
          matrix = Matrix.compose(matrix, Matrix.rotateDEG(v[0], v[1] || 0, v[2] || 0));
          break;
        case 'translate':
          matrix = Matrix.compose(matrix, Matrix.translate(v[0], v[1] || 0));
          break;
        case 'scale':
          matrix = Matrix.compose(matrix, Matrix.scale(v[0], v[1] || v[0]));
          break;
        case 'skewX':
          matrix = Matrix.compose(matrix, Matrix.skewDEG(v[0], 0));
          break;
        case 'skewY':
          matrix = Matrix.compose(matrix, Matrix.skewDEG(0, v[0]));
          break;
        default:
          log.error("Couldn't parse: ".concat(command));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return matrix;
};

// Adapted from paper.js's Matrix.decompose
// Given a matrix, return the x and y scale factors of the matrix
var _getScaleFactor = function _getScaleFactor(matrix) {
  var a = matrix.a;
  var b = matrix.b;
  var c = matrix.c;
  var d = matrix.d;
  var det = a * d - b * c;
  if (a !== 0 || b !== 0) {
    var r = Math.sqrt(a * a + b * b);
    return {
      x: r,
      y: det / r
    };
  }
  if (c !== 0 || d !== 0) {
    var s = Math.sqrt(c * c + d * d);
    return {
      x: det / s,
      y: s
    };
  }
  // a = b = c = d = 0
  return {
    x: 0,
    y: 0
  };
};

// Returns null if matrix is not invertible. Otherwise returns given ellipse
// transformed by transform, an object {radiusX, radiusY, rotation}.
var _calculateTransformedEllipse = function _calculateTransformedEllipse(radiusX, radiusY, theta, transform) {
  theta = -theta * Math.PI / 180;
  var a = transform.a;
  var b = -transform.c;
  var c = -transform.b;
  var d = transform.d;
  // Since other parameters determine the translation of the ellipse in SVG, we do not need to worry
  // about what e and f are.
  var det = a * d - b * c;
  // Non-invertible matrix
  if (det === 0) return null;

  // rotA, rotB, and rotC represent Ax^2 + Bxy + Cy^2 = 1 coefficients for a rotated ellipse formula
  var sinT = Math.sin(theta);
  var cosT = Math.cos(theta);
  var sin2T = Math.sin(2 * theta);
  var rotA = cosT * cosT / radiusX / radiusX + sinT * sinT / radiusY / radiusY;
  var rotB = sin2T / radiusX / radiusX - sin2T / radiusY / radiusY;
  var rotC = sinT * sinT / radiusX / radiusX + cosT * cosT / radiusY / radiusY;

  // Calculate the ellipse formula of the transformed ellipse
  // A, B, and C represent Ax^2 + Bxy + Cy^2 = 1 / det / det coefficients in a transformed ellipse formula
  // scaled by inverse det squared (to preserve accuracy)
  var A = rotA * d * d - rotB * d * c + rotC * c * c;
  var B = -2 * rotA * b * d + rotB * a * d + rotB * b * c - 2 * rotC * a * c;
  var C = rotA * b * b - rotB * a * b + rotC * a * a;

  // Derive new radii and theta from the transformed ellipse formula
  var newRadiusXOverDet = Math.sqrt(2) * Math.sqrt((A + C - Math.sqrt(A * A + B * B - 2 * A * C + C * C)) / (-B * B + 4 * A * C));
  var newRadiusYOverDet = 1 / Math.sqrt(A + C - 1 / newRadiusXOverDet / newRadiusXOverDet);
  var temp = (A - 1 / newRadiusXOverDet / newRadiusXOverDet) / (1 / newRadiusYOverDet / newRadiusYOverDet - 1 / newRadiusXOverDet / newRadiusXOverDet);
  if (temp < 0 && Math.abs(temp) < 1e-8) temp = 0; // Fix floating point issue
  temp = Math.sqrt(temp);
  if (Math.abs(1 - temp) < 1e-8) temp = 1; // Fix floating point issue
  // Solve for which of the two possible thetas is correct
  var newTheta = Math.asin(temp);
  temp = B / (1 / newRadiusXOverDet / newRadiusXOverDet - 1 / newRadiusYOverDet / newRadiusYOverDet);
  var newTheta2 = -newTheta;
  if (Math.abs(Math.sin(2 * newTheta2) - temp) < Math.abs(Math.sin(2 * newTheta) - temp)) {
    newTheta = newTheta2;
  }
  return {
    radiusX: newRadiusXOverDet * det,
    radiusY: newRadiusYOverDet * det,
    rotation: -newTheta * 180 / Math.PI
  };
};

// Adapted from paper.js's PathItem.setPathData
var _transformPath = function _transformPath(pathString, transform) {
  if (!transform || Matrix.toString(transform) === Matrix.toString(Matrix.identity())) return pathString;
  // First split the path data into parts of command-coordinates pairs
  // Commands are any of these characters: mzlhvcsqta
  var parts = pathString && pathString.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig);
  var coords;
  var relative = false;
  var previous;
  var control;
  var current = {
    x: 0,
    y: 0
  };
  var start = {
    x: 0,
    y: 0
  };
  var result = '';
  var getCoord = function getCoord(index, coord) {
    var val = +coords[index];
    if (relative) {
      val += current[coord];
    }
    return val;
  };
  var getPoint = function getPoint(index) {
    return {
      x: getCoord(index, 'x'),
      y: getCoord(index + 1, 'y')
    };
  };
  var roundTo4Places = function roundTo4Places(num) {
    return Number(num.toFixed(4));
  };

  // Returns the transformed point as a string
  var getString = function getString(point) {
    var transformed = Matrix.applyToPoint(transform, point);
    return "".concat(roundTo4Places(transformed.x), " ").concat(roundTo4Places(transformed.y), " ");
  };
  for (var i = 0, l = parts && parts.length; i < l; i++) {
    var part = parts[i];
    var command = part[0];
    var lower = command.toLowerCase();
    // Match all coordinate values
    coords = part.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
    var length = coords && coords.length;
    relative = command === lower;
    // Fix issues with z in the middle of SVG path data, not followed by
    // a m command, see paper.js#413:
    if (previous === 'z' && !/[mz]/.test(lower)) {
      result += "M ".concat(current.x, " ").concat(current.y, " ");
    }
    switch (lower) {
      case 'm': // Move to
      case 'l':
        // Line to
        {
          var move = lower === 'm';
          for (var j = 0; j < length; j += 2) {
            result += move ? 'M ' : 'L ';
            current = getPoint(j);
            result += getString(current);
            if (move) {
              start = current;
              move = false;
            }
          }
          control = current;
          break;
        }
      case 'h': // Horizontal line
      case 'v':
        // Vertical line
        {
          var coord = lower === 'h' ? 'x' : 'y';
          current = {
            x: current.x,
            y: current.y
          }; // Clone as we're going to modify it.
          for (var _j = 0; _j < length; _j++) {
            current[coord] = getCoord(_j, coord);
            result += "L ".concat(getString(current));
          }
          control = current;
          break;
        }
      case 'c':
        // Cubic Bezier curve
        for (var _j2 = 0; _j2 < length; _j2 += 6) {
          var handle1 = getPoint(_j2);
          control = getPoint(_j2 + 2);
          current = getPoint(_j2 + 4);
          result += "C ".concat(getString(handle1)).concat(getString(control)).concat(getString(current));
        }
        break;
      case 's':
        // Smooth cubic Bezier curve
        for (var _j3 = 0; _j3 < length; _j3 += 4) {
          var _handle = /[cs]/.test(previous) ? {
            x: current.x * 2 - control.x,
            y: current.y * 2 - control.y
          } : current;
          control = getPoint(_j3);
          current = getPoint(_j3 + 2);
          result += "C ".concat(getString(_handle)).concat(getString(control)).concat(getString(current));
          previous = lower;
        }
        break;
      case 'q':
        // Quadratic Bezier curve
        for (var _j4 = 0; _j4 < length; _j4 += 4) {
          control = getPoint(_j4);
          current = getPoint(_j4 + 2);
          result += "Q ".concat(getString(control)).concat(getString(current));
        }
        break;
      case 't':
        // Smooth quadratic Bezier curve
        for (var _j5 = 0; _j5 < length; _j5 += 2) {
          control = /[qt]/.test(previous) ? {
            x: current.x * 2 - control.x,
            y: current.y * 2 - control.y
          } : current;
          current = getPoint(_j5);
          result += "Q ".concat(getString(control)).concat(getString(current));
          previous = lower;
        }
        break;
      case 'a':
        // Elliptical arc curve
        for (var _j6 = 0; _j6 < length; _j6 += 7) {
          current = getPoint(_j6 + 5);
          var rx = +coords[_j6];
          var ry = +coords[_j6 + 1];
          var rotation = +coords[_j6 + 2];
          var largeArcFlag = +coords[_j6 + 3];
          var clockwiseFlag = +coords[_j6 + 4];
          var newEllipse = _calculateTransformedEllipse(rx, ry, rotation, transform);
          var matrixScale = _getScaleFactor(transform);
          if (newEllipse) {
            if (matrixScale.x > 0 && matrixScale.y < 0 || matrixScale.x < 0 && matrixScale.y > 0) {
              clockwiseFlag = clockwiseFlag ^ 1;
            }
            result += "A ".concat(roundTo4Places(Math.abs(newEllipse.radiusX)), " ") + "".concat(roundTo4Places(Math.abs(newEllipse.radiusY)), " ") + "".concat(roundTo4Places(newEllipse.rotation), " ").concat(largeArcFlag, " ") + "".concat(clockwiseFlag, " ").concat(getString(current));
          } else {
            result += "L ".concat(getString(current));
          }
        }
        break;
      case 'z':
        // Close path
        result += "Z ";
        // Correctly handle relative m commands, see paper.js#1101:
        current = start;
        break;
    }
    previous = lower;
  }
  return result;
};
var GRAPHICS_ELEMENTS = ['circle', 'ellipse', 'image', 'line', 'path', 'polygon', 'polyline', 'rect', 'text', 'use'];
var CONTAINER_ELEMENTS = ['a', 'defs', 'g', 'marker', 'glyph', 'missing-glyph', 'pattern', 'svg', 'switch', 'symbol'];
var _isContainerElement = function _isContainerElement(element) {
  return element.tagName && CONTAINER_ELEMENTS.includes(element.tagName.toLowerCase());
};
var _isGraphicsElement = function _isGraphicsElement(element) {
  return element.tagName && GRAPHICS_ELEMENTS.includes(element.tagName.toLowerCase());
};
var _isPathWithTransformAndStroke = function _isPathWithTransformAndStroke(element, strokeWidth) {
  if (!element.attributes) return false;
  strokeWidth = element.attributes['stroke-width'] ? Number(element.attributes['stroke-width'].value) : Number(strokeWidth);
  return strokeWidth && element.tagName && element.tagName.toLowerCase() === 'path' && element.attributes.d && element.attributes.d.value;
};
var _quadraticMean = function _quadraticMean(a, b) {
  return Math.sqrt((a * a + b * b) / 2);
};
var _createGradient = function _createGradient(gradientId, svgTag, bbox, matrix) {
  // Adapted from Paper.js's SvgImport.getValue
  var getValue = function getValue(node, name, isString, allowNull, allowPercent, defaultValue) {
    // Interpret value as number. Never return NaN, but 0 instead.
    // If the value is a sequence of numbers, parseFloat will
    // return the first occurring number, which is enough for now.
    var value = SvgElement.get(node, name);
    var res;
    if (value === null) {
      if (defaultValue) {
        res = defaultValue;
        if (/%\s*$/.test(res)) {
          value = defaultValue;
          res = parseFloat(value);
        }
      } else if (allowNull) {
        res = null;
      } else if (isString) {
        res = '';
      } else {
        res = 0;
      }
    } else if (isString) {
      res = value;
    } else {
      res = parseFloat(value);
    }
    // Support for dimensions in percentage of the root size. If root-size
    // is not set (e.g. during <defs>), just scale the percentage value to
    // 0..1, as required by gradients with gradientUnits="objectBoundingBox"
    if (/%\s*$/.test(value)) {
      var size = allowPercent ? 1 : bbox[/x|^width/.test(name) ? 'width' : 'height'];
      return res / 100 * size;
    }
    return res;
  };
  var getPoint = function getPoint(node, x, y, allowNull, allowPercent, defaultX, defaultY) {
    x = getValue(node, x || 'x', false, allowNull, allowPercent, defaultX);
    y = getValue(node, y || 'y', false, allowNull, allowPercent, defaultY);
    return allowNull && (x === null || y === null) ? null : {
      x: x,
      y: y
    };
  };
  var defs = svgTag.getElementsByTagName('defs');
  if (defs.length === 0) {
    defs = SvgElement.create('defs');
    svgTag.appendChild(defs);
  } else {
    defs = defs[0];
  }

  // Clone the old gradient. We'll make a new one, since the gradient might be reused elsewhere
  // with different transform matrix
  var oldGradient = svgTag.getElementById(gradientId);
  if (!oldGradient) return;
  var radial = oldGradient.tagName.toLowerCase() === 'radialgradient';
  var newGradient = svgTag.getElementById(gradientId).cloneNode(true /* deep */);

  // Give the new gradient a new ID
  var matrixString = Matrix.toString(matrix);
  matrixString = matrixString.substring(8, matrixString.length - 1);
  var newGradientId = "".concat(gradientId, "-").concat(matrixString);
  newGradient.setAttribute('id', newGradientId);

  // This gradient already exists and was transformed before. Just reuse the already-transformed one.
  if (svgTag.getElementById(newGradientId)) {
    // This is the same code as in the end of the function, but I don't feel like wrapping the next 80 lines
    // in an `if (!svgTag.getElementById(newGradientId))` block
    return "url(#".concat(newGradientId, ")");
  }
  var scaleToBounds = getValue(newGradient, 'gradientUnits', true) !== 'userSpaceOnUse';
  var origin;
  var destination;
  var radius;
  var focal;
  if (radial) {
    origin = getPoint(newGradient, 'cx', 'cy', false, scaleToBounds, '50%', '50%');
    radius = getValue(newGradient, 'r', false, false, scaleToBounds, '50%');
    focal = getPoint(newGradient, 'fx', 'fy', true, scaleToBounds);
  } else {
    origin = getPoint(newGradient, 'x1', 'y1', false, scaleToBounds);
    destination = getPoint(newGradient, 'x2', 'y2', false, scaleToBounds, '1');
    if (origin.x === destination.x && origin.y === destination.y) {
      // If it's degenerate, use the color of the last stop, as described by
      // https://www.w3.org/TR/SVG/pservers.html#LinearGradientNotes
      var stops = newGradient.getElementsByTagName('stop');
      if (!stops.length || !stops[stops.length - 1].attributes || !stops[stops.length - 1].attributes['stop-color']) {
        return null;
      }
      return stops[stops.length - 1].attributes['stop-color'].value;
    }
  }

  // Transform points
  // Emulate SVG's gradientUnits="objectBoundingBox"
  if (scaleToBounds) {
    var boundsMatrix = Matrix.compose(Matrix.translate(bbox.x, bbox.y), Matrix.scale(bbox.width, bbox.height));
    origin = Matrix.applyToPoint(boundsMatrix, origin);
    if (destination) destination = Matrix.applyToPoint(boundsMatrix, destination);
    if (radius) {
      radius = _quadraticMean(bbox.width, bbox.height) * radius;
    }
    if (focal) focal = Matrix.applyToPoint(boundsMatrix, focal);
  }
  if (radial) {
    origin = Matrix.applyToPoint(matrix, origin);
    var matrixScale = _getScaleFactor(matrix);
    radius = _quadraticMean(matrixScale.x, matrixScale.y) * radius;
    if (focal) focal = Matrix.applyToPoint(matrix, focal);
  } else {
    var dot = function dot(a, b) {
      return a.x * b.x + a.y * b.y;
    };
    var multiply = function multiply(coefficient, v) {
      return {
        x: coefficient * v.x,
        y: coefficient * v.y
      };
    };
    var add = function add(a, b) {
      return {
        x: a.x + b.x,
        y: a.y + b.y
      };
    };
    var subtract = function subtract(a, b) {
      return {
        x: a.x - b.x,
        y: a.y - b.y
      };
    };

    // The line through origin and gradientPerpendicular is the line at which the gradient starts
    var gradientPerpendicular = Math.abs(origin.x - destination.x) < 1e-8 ? add(origin, {
      x: 1,
      y: (origin.x - destination.x) / (destination.y - origin.y)
    }) : add(origin, {
      x: (destination.y - origin.y) / (origin.x - destination.x),
      y: 1
    });

    // Transform points
    gradientPerpendicular = Matrix.applyToPoint(matrix, gradientPerpendicular);
    origin = Matrix.applyToPoint(matrix, origin);
    destination = Matrix.applyToPoint(matrix, destination);

    // Calculate the direction that the gradient has changed to
    var originToPerpendicular = subtract(gradientPerpendicular, origin);
    var originToDestination = subtract(destination, origin);
    var gradientDirection = Math.abs(originToPerpendicular.x) < 1e-8 ? {
      x: 1,
      y: -originToPerpendicular.x / originToPerpendicular.y
    } : {
      x: -originToPerpendicular.y / originToPerpendicular.x,
      y: 1
    };

    // Set the destination so that the gradient moves in the correct direction, by projecting the destination vector
    // onto the gradient direction vector
    var projectionCoeff = dot(originToDestination, gradientDirection) / dot(gradientDirection, gradientDirection);
    var projection = multiply(projectionCoeff, gradientDirection);
    destination = {
      x: origin.x + projection.x,
      y: origin.y + projection.y
    };
  }

  // Put values back into svg
  if (radial) {
    newGradient.setAttribute('cx', Number(origin.x.toFixed(4)));
    newGradient.setAttribute('cy', Number(origin.y.toFixed(4)));
    newGradient.setAttribute('r', Number(radius.toFixed(4)));
    if (focal) {
      newGradient.setAttribute('fx', Number(focal.x.toFixed(4)));
      newGradient.setAttribute('fy', Number(focal.y.toFixed(4)));
    }
  } else {
    newGradient.setAttribute('x1', Number(origin.x.toFixed(4)));
    newGradient.setAttribute('y1', Number(origin.y.toFixed(4)));
    newGradient.setAttribute('x2', Number(destination.x.toFixed(4)));
    newGradient.setAttribute('y2', Number(destination.y.toFixed(4)));
  }
  newGradient.setAttribute('gradientUnits', 'userSpaceOnUse');
  defs.appendChild(newGradient);
  return "url(#".concat(newGradientId, ")");
};

// Adapted from paper.js's SvgImport.getDefinition
var _parseUrl = function _parseUrl(value, windowRef) {
  // When url() comes from a style property, '#'' seems to be missing on
  // WebKit. We also get variations of quotes or no quotes, single or
  // double, so handle it all with one regular expression:
  var match = value && value.match(/\((?:["'#]*)([^"')]+)/);
  var name = match && match[1];
  var res = name && windowRef ?
  // This is required by Firefox, which can produce absolute
  // urls for local gradients, see paperjs#1001:
  name.replace("".concat(windowRef.location.href.split('#')[0], "#"), '') : name;
  return res;
};

/**
 * Scratch 2.0 displays stroke widths in a "normalized" way, that is,
 * if a shape with a stroke width has a transform applied, it will be
 * rendered with a stroke that is the same width all the way around,
 * instead of stretched looking.
 *
 * The vector paint editor also prefers to normalize the stroke width,
 * rather than keep track of transforms at the group level, as this
 * simplifies editing (e.g. stroke width 3 always means the same thickness)
 *
 * This function performs that normalization process, pushing transforms
 * on groups down to the leaf level and averaging out the stroke width
 * around the shapes. Note that this doens't just change stroke widths, it
 * changes path data and attributes throughout the SVG.
 *
 * @param {SVGElement} svgTag The SVG dom object
 * @param {Window} windowRef The window to use. Need to pass in for
 *     tests to work, as they get angry at even the mention of window.
 * @param {object} bboxForTesting The bounds to use. Need to pass in for
 *     tests only, because getBBox doesn't work in Node. This should
 *     be the bounds of the svgTag without including stroke width or transforms.
 * @return {void}
 */
var transformStrokeWidths = function transformStrokeWidths(svgTag, windowRef, bboxForTesting) {
  var inherited = Matrix.identity();
  var _applyTransforms = function applyTransforms(element, matrix, strokeWidth, fill, stroke) {
    if (_isContainerElement(element)) {
      // Push fills and stroke width down to leaves
      if (element.attributes['stroke-width']) {
        strokeWidth = element.attributes['stroke-width'].value;
      }
      if (element.attributes) {
        if (element.attributes.fill) fill = element.attributes.fill.value;
        if (element.attributes.stroke) stroke = element.attributes.stroke.value;
      }

      // If any child nodes don't take attributes, leave the attributes
      // at the parent level.
      for (var i = 0; i < element.childNodes.length; i++) {
        _applyTransforms(element.childNodes[i], Matrix.compose(matrix, _parseTransform(element)), strokeWidth, fill, stroke);
      }
      element.removeAttribute('transform');
      element.removeAttribute('stroke-width');
      element.removeAttribute('fill');
      element.removeAttribute('stroke');
    } else if (_isPathWithTransformAndStroke(element, strokeWidth)) {
      if (element.attributes['stroke-width']) {
        strokeWidth = element.attributes['stroke-width'].value;
      }
      if (element.attributes.fill) fill = element.attributes.fill.value;
      if (element.attributes.stroke) stroke = element.attributes.stroke.value;
      matrix = Matrix.compose(matrix, _parseTransform(element));
      if (Matrix.toString(matrix) === Matrix.toString(Matrix.identity())) {
        element.removeAttribute('transform');
        element.setAttribute('stroke-width', strokeWidth);
        if (fill) element.setAttribute('fill', fill);
        if (stroke) element.setAttribute('stroke', stroke);
        return;
      }

      // Transform gradient
      var fillGradientId = _parseUrl(fill, windowRef);
      var strokeGradientId = _parseUrl(stroke, windowRef);
      if (fillGradientId || strokeGradientId) {
        var doc = windowRef.document;
        // Need path bounds to transform gradient
        var svgSpot = doc.createElement('span');
        var bbox;
        if (bboxForTesting) {
          bbox = bboxForTesting;
        } else {
          try {
            doc.body.appendChild(svgSpot);
            var svg = SvgElement.set(doc.createElementNS(SvgElement.svg, 'svg'));
            var path = SvgElement.set(doc.createElementNS(SvgElement.svg, 'path'));
            path.setAttribute('d', element.attributes.d.value);
            svg.appendChild(path);
            svgSpot.appendChild(svg);
            // Take the bounding box.
            bbox = svg.getBBox();
          } finally {
            // Always destroy the element, even if, for example, getBBox throws.
            doc.body.removeChild(svgSpot);
          }
        }
        if (fillGradientId) {
          var newFillRef = _createGradient(fillGradientId, svgTag, bbox, matrix);
          if (newFillRef) fill = newFillRef;
        }
        if (strokeGradientId) {
          var newStrokeRef = _createGradient(strokeGradientId, svgTag, bbox, matrix);
          if (newStrokeRef) stroke = newStrokeRef;
        }
      }

      // Transform path data
      element.setAttribute('d', _transformPath(element.attributes.d.value, matrix));
      element.removeAttribute('transform');

      // Transform stroke width
      var matrixScale = _getScaleFactor(matrix);
      element.setAttribute('stroke-width', _quadraticMean(matrixScale.x, matrixScale.y) * strokeWidth);
      if (fill) element.setAttribute('fill', fill);
      if (stroke) element.setAttribute('stroke', stroke);
    } else if (_isGraphicsElement(element)) {
      // Push stroke width, fill, and stroke down to leaves
      if (strokeWidth && !element.attributes['stroke-width']) {
        element.setAttribute('stroke-width', strokeWidth);
      }
      if (fill && !element.attributes.fill) {
        element.setAttribute('fill', fill);
      }
      if (stroke && !element.attributes.stroke) {
        element.setAttribute('stroke', stroke);
      }

      // Push transform down to leaves
      matrix = Matrix.compose(matrix, _parseTransform(element));
      if (Matrix.toString(matrix) === Matrix.toString(Matrix.identity())) {
        element.removeAttribute('transform');
      } else {
        element.setAttribute('transform', Matrix.toString(matrix));
      }
    }
  };
  _applyTransforms(svgTag, inherited, 1 /* default SVG stroke width */);
};
module.exports = transformStrokeWidths;

/***/ }),

/***/ "./node_modules/scratch-svg-renderer/src/util/log.js":
/*!***********************************************************!*\
  !*** ./node_modules/scratch-svg-renderer/src/util/log.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var minilog = __webpack_require__(/*! minilog */ "./node_modules/minilog/lib/web/index.js");
minilog.enable();
module.exports = minilog('scratch-svg-render');

/***/ }),

/***/ "./src/BitmapSkin.js":
/*!***************************!*\
  !*** ./src/BitmapSkin.js ***!
  \***************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var twgl = __webpack_require__(/*! twgl.js */ "./node_modules/twgl.js/dist/4.x/twgl-full.module.js");
var Skin = __webpack_require__(/*! ./Skin */ "./src/Skin.js");
var BitmapSkin = /*#__PURE__*/function (_Skin) {
  /**
   * Create a new Bitmap Skin.
   * @extends Skin
   * @param {!int} id - The ID for this Skin.
   * @param {!RenderWebGL} renderer - The renderer which will use this skin.
   */
  function BitmapSkin(id, renderer) {
    var _this;
    _classCallCheck(this, BitmapSkin);
    _this = _callSuper(this, BitmapSkin, [id]);

    /** @type {!int} */
    _this._costumeResolution = 1;

    /** @type {!RenderWebGL} */
    _this._renderer = renderer;

    /** @type {Array<int>} */
    _this._textureSize = [0, 0];
    return _this;
  }

  /**
   * Dispose of this object. Do not use it after calling this method.
   */
  _inherits(BitmapSkin, _Skin);
  return _createClass(BitmapSkin, [{
    key: "dispose",
    value: function dispose() {
      if (this._texture) {
        this._renderer.gl.deleteTexture(this._texture);
        this._texture = null;
      }
      _superPropGet(BitmapSkin, "dispose", this, 3)([]);
    }

    /**
     * @return {Array<number>} the "native" size, in texels, of this skin.
     */
  }, {
    key: "size",
    get: function get() {
      return [this._textureSize[0] / this._costumeResolution, this._textureSize[1] / this._costumeResolution];
    }

    /**
     * @param {Array<number>} scale - The scaling factors to be used.
     * @return {WebGLTexture} The GL texture representation of this skin when drawing at the given scale.
     */
    // eslint-disable-next-line no-unused-vars
  }, {
    key: "getTexture",
    value: function getTexture(scale) {
      return this._texture || _superPropGet(BitmapSkin, "getTexture", this, 3)([]);
    }

    /**
     * Set the contents of this skin to a snapshot of the provided bitmap data.
     * @param {ImageData|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} bitmapData - new contents for this skin.
     * @param {int} [costumeResolution=1] - The resolution to use for this bitmap.
     * @param {Array<number>} [rotationCenter] - Optional rotation center for the bitmap. If not supplied, it will be
     * calculated from the bounding box
     * @fires Skin.event:WasAltered
     */
  }, {
    key: "setBitmap",
    value: function setBitmap(bitmapData, costumeResolution, rotationCenter) {
      if (!bitmapData.width || !bitmapData.height) {
        _superPropGet(BitmapSkin, "setEmptyImageData", this, 3)([]);
        return;
      }
      var gl = this._renderer.gl;

      // Preferably bitmapData is ImageData. ImageData speeds up updating
      // Silhouette and is better handled by more browsers in regards to
      // memory.
      var textureData = bitmapData;
      if (bitmapData instanceof HTMLCanvasElement) {
        // Given a HTMLCanvasElement get the image data to pass to webgl and
        // Silhouette.
        var context = bitmapData.getContext('2d');
        textureData = context.getImageData(0, 0, bitmapData.width, bitmapData.height);
      }
      if (this._texture === null) {
        var textureOptions = {
          auto: false,
          wrap: gl.CLAMP_TO_EDGE
        };
        this._texture = twgl.createTexture(gl, textureOptions);
      }
      this._setTexture(textureData);

      // Do these last in case any of the above throws an exception
      this._costumeResolution = costumeResolution || 2;
      this._textureSize = BitmapSkin._getBitmapSize(bitmapData);
      if (typeof rotationCenter === 'undefined') rotationCenter = this.calculateRotationCenter();
      this._rotationCenter[0] = rotationCenter[0];
      this._rotationCenter[1] = rotationCenter[1];
      this.emit(Skin.Events.WasAltered);
    }

    /**
     * @param {ImageData|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} bitmapData - bitmap data to inspect.
     * @returns {Array<int>} the width and height of the bitmap data, in pixels.
     * @private
     */
  }], [{
    key: "_getBitmapSize",
    value: function _getBitmapSize(bitmapData) {
      if (bitmapData instanceof HTMLImageElement) {
        return [bitmapData.naturalWidth || bitmapData.width, bitmapData.naturalHeight || bitmapData.height];
      }
      if (bitmapData instanceof HTMLVideoElement) {
        return [bitmapData.videoWidth || bitmapData.width, bitmapData.videoHeight || bitmapData.height];
      }

      // ImageData or HTMLCanvasElement
      return [bitmapData.width, bitmapData.height];
    }
  }]);
}(Skin);
module.exports = BitmapSkin;

/***/ }),

/***/ "./src/Drawable.js":
/*!*************************!*\
  !*** ./src/Drawable.js ***!
  \*************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var twgl = __webpack_require__(/*! twgl.js */ "./node_modules/twgl.js/dist/4.x/twgl-full.module.js");
var Rectangle = __webpack_require__(/*! ./Rectangle */ "./src/Rectangle.js");
var RenderConstants = __webpack_require__(/*! ./RenderConstants */ "./src/RenderConstants.js");
var ShaderManager = __webpack_require__(/*! ./ShaderManager */ "./src/ShaderManager.js");
var Skin = __webpack_require__(/*! ./Skin */ "./src/Skin.js");
var EffectTransform = __webpack_require__(/*! ./EffectTransform */ "./src/EffectTransform.js");
var log = __webpack_require__(/*! ./util/log */ "./src/util/log.js");

/**
 * An internal workspace for calculating texture locations from world vectors
 * this is REUSED for memory conservation reasons
 * @type {twgl.v3}
 */
var __isTouchingPosition = twgl.v3.create();
var FLOATING_POINT_ERROR_ALLOWANCE = 1e-6;

/**
 * Convert a scratch space location into a texture space float.  Uses the
 * internal __isTouchingPosition as a return value, so this should be copied
 * if you ever need to get two local positions and store both.  Requires that
 * the drawable inverseMatrix is up to date.
 *
 * @param {Drawable} drawable The drawable to get the inverse matrix and uniforms from
 * @param {twgl.v3} vec [x,y] scratch space vector
 * @return {twgl.v3} [x,y] texture space float vector - transformed by effects and matrix
 */
var getLocalPosition = function getLocalPosition(drawable, vec) {
  // Transfrom from world coordinates to Drawable coordinates.
  var localPosition = __isTouchingPosition;
  var v0 = vec[0];
  var v1 = vec[1];
  var m = drawable._inverseMatrix;
  // var v2 = v[2];
  var d = v0 * m[3] + v1 * m[7] + m[15];
  // The RenderWebGL quad flips the texture's X axis. So rendered bottom
  // left is 1, 0 and the top right is 0, 1. Flip the X axis so
  // localPosition matches that transformation.
  localPosition[0] = 0.5 - (v0 * m[0] + v1 * m[4] + m[12]) / d;
  localPosition[1] = (v0 * m[1] + v1 * m[5] + m[13]) / d + 0.5;
  // Fix floating point issues near 0. Filed https://github.com/LLK/scratch-render/issues/688 that
  // they're happening in the first place.
  // TODO: Check if this can be removed after render pull 479 is merged
  if (Math.abs(localPosition[0]) < FLOATING_POINT_ERROR_ALLOWANCE) localPosition[0] = 0;
  if (Math.abs(localPosition[1]) < FLOATING_POINT_ERROR_ALLOWANCE) localPosition[1] = 0;
  // Apply texture effect transform if the localPosition is within the drawable's space,
  // and any effects are currently active.
  if (drawable.enabledEffects !== 0 && localPosition[0] >= 0 && localPosition[0] < 1 && localPosition[1] >= 0 && localPosition[1] < 1) {
    EffectTransform.transformPoint(drawable, localPosition, localPosition);
  }
  return localPosition;
};
var Drawable = /*#__PURE__*/function () {
  /**
   * An object which can be drawn by the renderer.
   * @todo double-buffer all rendering state (position, skin, effects, etc.)
   * @param {!int} id - This Drawable's unique ID.
   * @constructor
   */
  function Drawable(id) {
    _classCallCheck(this, Drawable);
    /** @type {!int} */
    this._id = id;

    /**
     * The uniforms to be used by the vertex and pixel shaders.
     * Some of these are used by other parts of the renderer as well.
     * @type {Object.<string,*>}
     * @private
     */
    this._uniforms = {
      /**
       * The model matrix, to concat with projection at draw time.
       * @type {module:twgl/m4.Mat4}
       */
      u_modelMatrix: twgl.m4.identity(),
      /**
       * The color to use in the silhouette draw mode.
       * @type {Array<number>}
       */
      u_silhouetteColor: Drawable.color4fFromID(this._id)
    };

    // Effect values are uniforms too
    var numEffects = ShaderManager.EFFECTS.length;
    for (var index = 0; index < numEffects; ++index) {
      var effectName = ShaderManager.EFFECTS[index];
      var effectInfo = ShaderManager.EFFECT_INFO[effectName];
      var converter = effectInfo.converter;
      this._uniforms[effectInfo.uniformName] = converter(0);
    }
    this._position = twgl.v3.create(0, 0);
    this._scale = twgl.v3.create(100, 100);
    this._direction = 90;
    this._transformDirty = true;
    this._rotationMatrix = twgl.m4.identity();
    this._rotationTransformDirty = true;
    this._rotationAdjusted = twgl.v3.create();
    this._rotationCenterDirty = true;
    this._skinScale = twgl.v3.create(0, 0, 0);
    this._skinScaleDirty = true;
    this._inverseMatrix = twgl.m4.identity();
    this._inverseTransformDirty = true;
    this._visible = true;

    /** A bitmask identifying which effects are currently in use.
     * @readonly
     * @type {int} */
    this.enabledEffects = 0;

    /** @todo move convex hull functionality, maybe bounds functionality overall, to Skin classes */
    this._convexHullPoints = null;
    this._convexHullDirty = true;

    // The precise bounding box will be from the transformed convex hull points,
    // so initialize the array of transformed hull points in setConvexHullPoints.
    // Initializing it once per convex hull recalculation avoids unnecessary creation of twgl.v3 objects.
    this._transformedHullPoints = null;
    this._transformedHullDirty = true;
    this._skinWasAltered = this._skinWasAltered.bind(this);
    this.isTouching = this._isTouchingNever;
  }

  /**
   * Dispose of this Drawable. Do not use it after calling this method.
   */
  return _createClass(Drawable, [{
    key: "dispose",
    value: function dispose() {
      // Use the setter: disconnect events
      this.skin = null;
    }

    /**
     * Mark this Drawable's transform as dirty.
     * It will be recalculated next time it's needed.
     */
  }, {
    key: "setTransformDirty",
    value: function setTransformDirty() {
      this._transformDirty = true;
      this._inverseTransformDirty = true;
      this._transformedHullDirty = true;
    }

    /**
     * @returns {number} The ID for this Drawable.
     */
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }

    /**
     * @returns {Skin} the current skin for this Drawable.
     */
  }, {
    key: "skin",
    get: function get() {
      return this._skin;
    }

    /**
     * @param {Skin} newSkin - A new Skin for this Drawable.
     */,
    set: function set(newSkin) {
      if (this._skin !== newSkin) {
        if (this._skin) {
          this._skin.removeListener(Skin.Events.WasAltered, this._skinWasAltered);
        }
        this._skin = newSkin;
        if (this._skin) {
          this._skin.addListener(Skin.Events.WasAltered, this._skinWasAltered);
        }
        this._skinWasAltered();
      }
    }

    /**
     * @returns {Array<number>} the current scaling percentages applied to this Drawable. [100,100] is normal size.
     */
  }, {
    key: "scale",
    get: function get() {
      return [this._scale[0], this._scale[1]];
    }

    /**
     * @returns {object.<string, *>} the shader uniforms to be used when rendering this Drawable.
     */
  }, {
    key: "getUniforms",
    value: function getUniforms() {
      if (this._transformDirty) {
        this._calculateTransform();
      }
      return this._uniforms;
    }

    /**
     * @returns {boolean} whether this Drawable is visible.
     */
  }, {
    key: "getVisible",
    value: function getVisible() {
      return this._visible;
    }

    /**
     * Update the position if it is different. Marks the transform as dirty.
     * @param {Array.<number>} position A new position.
     */
  }, {
    key: "updatePosition",
    value: function updatePosition(position) {
      if (this._position[0] !== position[0] || this._position[1] !== position[1]) {
        this._position[0] = Math.round(position[0]);
        this._position[1] = Math.round(position[1]);
        this.setTransformDirty();
      }
    }

    /**
     * Update the direction if it is different. Marks the transform as dirty.
     * @param {number} direction A new direction.
     */
  }, {
    key: "updateDirection",
    value: function updateDirection(direction) {
      if (this._direction !== direction) {
        this._direction = direction;
        this._rotationTransformDirty = true;
        this.setTransformDirty();
      }
    }

    /**
     * Update the scale if it is different. Marks the transform as dirty.
     * @param {Array.<number>} scale A new scale.
     */
  }, {
    key: "updateScale",
    value: function updateScale(scale) {
      if (this._scale[0] !== scale[0] || this._scale[1] !== scale[1]) {
        this._scale[0] = scale[0];
        this._scale[1] = scale[1];
        this._rotationCenterDirty = true;
        this._skinScaleDirty = true;
        this.setTransformDirty();
      }
    }

    /**
     * Update visibility if it is different. Marks the convex hull as dirty.
     * @param {boolean} visible A new visibility state.
     */
  }, {
    key: "updateVisible",
    value: function updateVisible(visible) {
      if (this._visible !== visible) {
        this._visible = visible;
        this.setConvexHullDirty();
      }
    }

    /**
     * Update an effect. Marks the convex hull as dirty if the effect changes shape.
     * @param {string} effectName The name of the effect.
     * @param {number} rawValue A new effect value.
     */
  }, {
    key: "updateEffect",
    value: function updateEffect(effectName, rawValue) {
      var effectInfo = ShaderManager.EFFECT_INFO[effectName];
      if (rawValue) {
        this.enabledEffects |= effectInfo.mask;
      } else {
        this.enabledEffects &= ~effectInfo.mask;
      }
      var converter = effectInfo.converter;
      this._uniforms[effectInfo.uniformName] = converter(rawValue);
      if (effectInfo.shapeChanges) {
        this.setConvexHullDirty();
      }
    }

    /**
     * Update the position, direction, scale, or effect properties of this Drawable.
     * @deprecated Use specific update* methods instead.
     * @param {object.<string,*>} properties The new property values to set.
     */
  }, {
    key: "updateProperties",
    value: function updateProperties(properties) {
      if ('position' in properties) {
        this.updatePosition(properties.position);
      }
      if ('direction' in properties) {
        this.updateDirection(properties.direction);
      }
      if ('scale' in properties) {
        this.updateScale(properties.scale);
      }
      if ('visible' in properties) {
        this.updateVisible(properties.visible);
      }
      var numEffects = ShaderManager.EFFECTS.length;
      for (var index = 0; index < numEffects; ++index) {
        var effectName = ShaderManager.EFFECTS[index];
        if (effectName in properties) {
          this.updateEffect(effectName, properties[effectName]);
        }
      }
    }

    /**
     * Calculate the transform to use when rendering this Drawable.
     * @private
     */
  }, {
    key: "_calculateTransform",
    value: function _calculateTransform() {
      if (this._rotationTransformDirty) {
        var rotation = (270 - this._direction) * Math.PI / 180;

        // Calling rotationZ sets the destination matrix to a rotation
        // around the Z axis setting matrix components 0, 1, 4 and 5 with
        // cosine and sine values of the rotation.
        // twgl.m4.rotationZ(rotation, this._rotationMatrix);

        // twgl assumes the last value set to the matrix was anything.
        // Drawable knows, it was another rotationZ matrix, so we can skip
        // assigning the values that will never change.
        var c = Math.cos(rotation);
        var s = Math.sin(rotation);
        this._rotationMatrix[0] = c;
        this._rotationMatrix[1] = s;
        // this._rotationMatrix[2] = 0;
        // this._rotationMatrix[3] = 0;
        this._rotationMatrix[4] = -s;
        this._rotationMatrix[5] = c;
        // this._rotationMatrix[6] = 0;
        // this._rotationMatrix[7] = 0;
        // this._rotationMatrix[8] = 0;
        // this._rotationMatrix[9] = 0;
        // this._rotationMatrix[10] = 1;
        // this._rotationMatrix[11] = 0;
        // this._rotationMatrix[12] = 0;
        // this._rotationMatrix[13] = 0;
        // this._rotationMatrix[14] = 0;
        // this._rotationMatrix[15] = 1;

        this._rotationTransformDirty = false;
      }

      // Adjust rotation center relative to the skin.
      if (this._rotationCenterDirty && this.skin !== null) {
        // twgl version of the following in function work.
        // let rotationAdjusted = twgl.v3.subtract(
        //     this.skin.rotationCenter,
        //     twgl.v3.divScalar(this.skin.size, 2, this._rotationAdjusted),
        //     this._rotationAdjusted
        // );
        // rotationAdjusted = twgl.v3.multiply(
        //     rotationAdjusted, this._scale, rotationAdjusted
        // );
        // rotationAdjusted = twgl.v3.divScalar(
        //     rotationAdjusted, 100, rotationAdjusted
        // );
        // rotationAdjusted[1] *= -1; // Y flipped to Scratch coordinate.
        // rotationAdjusted[2] = 0; // Z coordinate is 0.

        // Locally assign rotationCenter and skinSize to keep from having
        // the Skin getter properties called twice while locally assigning
        // their components for readability.
        var rotationCenter = this.skin.rotationCenter;
        var skinSize = this.skin.size;
        var center0 = rotationCenter[0];
        var center1 = rotationCenter[1];
        var skinSize0 = skinSize[0];
        var skinSize1 = skinSize[1];
        var _scale = this._scale[0];
        var _scale2 = this._scale[1];
        var rotationAdjusted = this._rotationAdjusted;
        rotationAdjusted[0] = (center0 - skinSize0 / 2) * _scale / 100;
        rotationAdjusted[1] = (center1 - skinSize1 / 2) * _scale2 / 100 * -1;
        // rotationAdjusted[2] = 0;

        this._rotationCenterDirty = false;
      }
      if (this._skinScaleDirty && this.skin !== null) {
        // twgl version of the following in function work.
        // const scaledSize = twgl.v3.divScalar(
        //     twgl.v3.multiply(this.skin.size, this._scale),
        //     100
        // );
        // // was NaN because the vectors have only 2 components.
        // scaledSize[2] = 0;

        // Locally assign skinSize to keep from having the Skin getter
        // properties called twice.
        var _skinSize = this.skin.size;
        var scaledSize = this._skinScale;
        scaledSize[0] = _skinSize[0] * this._scale[0] / 100;
        scaledSize[1] = _skinSize[1] * this._scale[1] / 100;
        // scaledSize[2] = 0;

        this._skinScaleDirty = false;
      }
      var modelMatrix = this._uniforms.u_modelMatrix;

      // twgl version of the following in function work.
      // twgl.m4.identity(modelMatrix);
      // twgl.m4.translate(modelMatrix, this._position, modelMatrix);
      // twgl.m4.multiply(modelMatrix, this._rotationMatrix, modelMatrix);
      // twgl.m4.translate(modelMatrix, this._rotationAdjusted, modelMatrix);
      // twgl.m4.scale(modelMatrix, scaledSize, modelMatrix);

      // Drawable configures a 3D matrix for drawing in WebGL, but most values
      // will never be set because the inputs are on the X and Y position axis
      // and the Z rotation axis. Drawable can bring the work inside
      // _calculateTransform and greatly reduce the ammount of math and array
      // assignments needed.

      var scale0 = this._skinScale[0];
      var scale1 = this._skinScale[1];
      var rotation00 = this._rotationMatrix[0];
      var rotation01 = this._rotationMatrix[1];
      var rotation10 = this._rotationMatrix[4];
      var rotation11 = this._rotationMatrix[5];
      var adjusted0 = this._rotationAdjusted[0];
      var adjusted1 = this._rotationAdjusted[1];
      var position0 = this._position[0];
      var position1 = this._position[1];

      // Commented assignments show what the values are when the matrix was
      // instantiated. Those values will never change so they do not need to
      // be reassigned.
      modelMatrix[0] = scale0 * rotation00;
      modelMatrix[1] = scale0 * rotation01;
      // modelMatrix[2] = 0;
      // modelMatrix[3] = 0;
      modelMatrix[4] = scale1 * rotation10;
      modelMatrix[5] = scale1 * rotation11;
      // modelMatrix[6] = 0;
      // modelMatrix[7] = 0;
      // modelMatrix[8] = 0;
      // modelMatrix[9] = 0;
      // modelMatrix[10] = 1;
      // modelMatrix[11] = 0;
      modelMatrix[12] = rotation00 * adjusted0 + rotation10 * adjusted1 + position0;
      modelMatrix[13] = rotation01 * adjusted0 + rotation11 * adjusted1 + position1;
      // modelMatrix[14] = 0;
      // modelMatrix[15] = 1;

      this._transformDirty = false;
    }

    /**
     * Whether the Drawable needs convex hull points provided by the renderer.
     * @return {boolean} True when no convex hull known, or it's dirty.
     */
  }, {
    key: "needsConvexHullPoints",
    value: function needsConvexHullPoints() {
      return !this._convexHullPoints || this._convexHullDirty || this._convexHullPoints.length === 0;
    }

    /**
     * Set the convex hull to be dirty.
     * Do this whenever the Drawable's shape has possibly changed.
     */
  }, {
    key: "setConvexHullDirty",
    value: function setConvexHullDirty() {
      this._convexHullDirty = true;
    }

    /**
     * Set the convex hull points for the Drawable.
     * @param {Array<Array<number>>} points Convex hull points, as [[x, y], ...]
     */
  }, {
    key: "setConvexHullPoints",
    value: function setConvexHullPoints(points) {
      this._convexHullPoints = points;
      this._convexHullDirty = false;

      // Re-create the "transformed hull points" array.
      // We only do this when the hull points change to avoid unnecessary allocations and GC.
      this._transformedHullPoints = [];
      for (var i = 0; i < points.length; i++) {
        this._transformedHullPoints.push(twgl.v3.create());
      }
      this._transformedHullDirty = true;
    }

    /**
     * @function
     * @name isTouching
     * Check if the world position touches the skin.
     * The caller is responsible for ensuring this drawable's inverse matrix & its skin's silhouette are up-to-date.
     * @see updateCPURenderAttributes
     * @param {twgl.v3} vec World coordinate vector.
     * @return {boolean} True if the world position touches the skin.
     */

    // `updateCPURenderAttributes` sets this Drawable instance's `isTouching` method
    // to one of the following three functions:
    // If this drawable has no skin, set it to `_isTouchingNever`.
    // Otherwise, if this drawable uses nearest-neighbor scaling at its current scale, set it to `_isTouchingNearest`.
    // Otherwise, set it to `_isTouchingLinear`.
    // This allows several checks to be moved from the `isTouching` function to `updateCPURenderAttributes`.

    // eslint-disable-next-line no-unused-vars
  }, {
    key: "_isTouchingNever",
    value: function _isTouchingNever(vec) {
      return false;
    }
  }, {
    key: "_isTouchingNearest",
    value: function _isTouchingNearest(vec) {
      return this.skin.isTouchingNearest(getLocalPosition(this, vec));
    }
  }, {
    key: "_isTouchingLinear",
    value: function _isTouchingLinear(vec) {
      return this.skin.isTouchingLinear(getLocalPosition(this, vec));
    }

    /**
     * Get the precise bounds for a Drawable.
     * This function applies the transform matrix to the known convex hull,
     * and then finds the minimum box along the axes.
     * Before calling this, ensure the renderer has updated convex hull points.
     * @param {?Rectangle} result optional destination for bounds calculation
     * @return {!Rectangle} Bounds for a tight box around the Drawable.
     */
  }, {
    key: "getBounds",
    value: function getBounds(result) {
      if (this.needsConvexHullPoints()) {
        throw new Error('Needs updated convex hull points before bounds calculation.');
      }
      if (this._transformDirty) {
        this._calculateTransform();
      }
      var transformedHullPoints = this._getTransformedHullPoints();
      // Search through transformed points to generate box on axes.
      result = result || new Rectangle();
      result.initFromPointsAABB(transformedHullPoints);
      return result;
    }

    /**
     * Get the precise bounds for the upper 8px slice of the Drawable.
     * Used for calculating where to position a text bubble.
     * Before calling this, ensure the renderer has updated convex hull points.
     * @param {?Rectangle} result optional destination for bounds calculation
     * @return {!Rectangle} Bounds for a tight box around a slice of the Drawable.
     */
  }, {
    key: "getBoundsForBubble",
    value: function getBoundsForBubble(result) {
      if (this.needsConvexHullPoints()) {
        throw new Error('Needs updated convex hull points before bubble bounds calculation.');
      }
      if (this._transformDirty) {
        this._calculateTransform();
      }
      var slice = 8; // px, how tall the top slice to measure should be.
      var transformedHullPoints = this._getTransformedHullPoints();
      var maxY = Math.max.apply(null, transformedHullPoints.map(function (p) {
        return p[1];
      }));
      var filteredHullPoints = transformedHullPoints.filter(function (p) {
        return p[1] > maxY - slice;
      });
      // Search through filtered points to generate box on axes.
      result = result || new Rectangle();
      result.initFromPointsAABB(filteredHullPoints);
      return result;
    }

    /**
     * Get the rough axis-aligned bounding box for the Drawable.
     * Calculated by transforming the skin's bounds.
     * Note that this is less precise than the box returned by `getBounds`,
     * which is tightly snapped to account for a Drawable's transparent regions.
     * `getAABB` returns a much less accurate bounding box, but will be much
     * faster to calculate so may be desired for quick checks/optimizations.
     * @param {?Rectangle} result optional destination for bounds calculation
     * @return {!Rectangle} Rough axis-aligned bounding box for Drawable.
     */
  }, {
    key: "getAABB",
    value: function getAABB(result) {
      if (this._transformDirty) {
        this._calculateTransform();
      }
      var tm = this._uniforms.u_modelMatrix;
      result = result || new Rectangle();
      result.initFromModelMatrix(tm);
      return result;
    }

    /**
     * Return the best Drawable bounds possible without performing graphics queries.
     * I.e., returns the tight bounding box when the convex hull points are already
     * known, but otherwise return the rough AABB of the Drawable.
     * @param {?Rectangle} result optional destination for bounds calculation
     * @return {!Rectangle} Bounds for the Drawable.
     */
  }, {
    key: "getFastBounds",
    value: function getFastBounds(result) {
      if (!this.needsConvexHullPoints()) {
        return this.getBounds(result);
      }
      return this.getAABB(result);
    }

    /**
     * Transform all the convex hull points by the current Drawable's
     * transform. This allows us to skip recalculating the convex hull
     * for many Drawable updates, including translation, rotation, scaling.
     * @return {!Array.<!Array.number>} Array of glPoints which are Array<x, y>
     * @private
     */
  }, {
    key: "_getTransformedHullPoints",
    value: function _getTransformedHullPoints() {
      if (!this._transformedHullDirty) {
        return this._transformedHullPoints;
      }
      var projection = twgl.m4.ortho(-1, 1, -1, 1, -1, 1);
      var skinSize = this.skin.size;
      var halfXPixel = 1 / skinSize[0] / 2;
      var halfYPixel = 1 / skinSize[1] / 2;
      var tm = twgl.m4.multiply(this._uniforms.u_modelMatrix, projection);
      for (var i = 0; i < this._convexHullPoints.length; i++) {
        var point = this._convexHullPoints[i];
        var dstPoint = this._transformedHullPoints[i];
        dstPoint[0] = 0.5 + -point[0] / skinSize[0] - halfXPixel;
        dstPoint[1] = point[1] / skinSize[1] - 0.5 + halfYPixel;
        twgl.m4.transformPoint(tm, dstPoint, dstPoint);
      }
      this._transformedHullDirty = false;
      return this._transformedHullPoints;
    }

    /**
     * Update the transform matrix and calculate it's inverse for collision
     * and local texture position purposes.
     */
  }, {
    key: "updateMatrix",
    value: function updateMatrix() {
      if (this._transformDirty) {
        this._calculateTransform();
      }
      // Get the inverse of the model matrix or update it.
      if (this._inverseTransformDirty) {
        var inverse = this._inverseMatrix;
        twgl.m4.copy(this._uniforms.u_modelMatrix, inverse);
        // The normal matrix uses a z scaling of 0 causing model[10] to be
        // 0. Getting a 4x4 inverse is impossible without a scaling in x, y,
        // and z.
        inverse[10] = 1;
        twgl.m4.inverse(inverse, inverse);
        this._inverseTransformDirty = false;
      }
    }

    /**
     * Update everything necessary to render this drawable on the CPU.
     */
  }, {
    key: "updateCPURenderAttributes",
    value: function updateCPURenderAttributes() {
      this.updateMatrix();
      // CPU rendering always occurs at the "native" size, so no need to scale up this._scale
      if (this.skin) {
        this.skin.updateSilhouette(this._scale);
        if (this.skin.useNearest(this._scale, this)) {
          this.isTouching = this._isTouchingNearest;
        } else {
          this.isTouching = this._isTouchingLinear;
        }
      } else {
        log.warn("Could not find skin for drawable with id: ".concat(this._id));
        this.isTouching = this._isTouchingNever;
      }
    }

    /**
     * Respond to an internal change in the current Skin.
     * @private
     */
  }, {
    key: "_skinWasAltered",
    value: function _skinWasAltered() {
      this._rotationCenterDirty = true;
      this._skinScaleDirty = true;
      this.setConvexHullDirty();
      this.setTransformDirty();
    }

    /**
     * Calculate a color to represent the given ID number. At least one component of
     * the resulting color will be non-zero if the ID is not RenderConstants.ID_NONE.
     * @param {int} id The ID to convert.
     * @returns {Array<number>} An array of [r,g,b,a], each component in the range [0,1].
     */
  }], [{
    key: "color4fFromID",
    value: function color4fFromID(id) {
      id -= RenderConstants.ID_NONE;
      var r = (id >> 0 & 255) / 255.0;
      var g = (id >> 8 & 255) / 255.0;
      var b = (id >> 16 & 255) / 255.0;
      return [r, g, b, 1.0];
    }

    /**
     * Calculate the ID number represented by the given color. If all components of
     * the color are zero, the result will be RenderConstants.ID_NONE; otherwise the result
     * will be a valid ID.
     * @param {int} r The red value of the color, in the range [0,255].
     * @param {int} g The green value of the color, in the range [0,255].
     * @param {int} b The blue value of the color, in the range [0,255].
     * @returns {int} The ID represented by that color.
     */
  }, {
    key: "color3bToID",
    value: function color3bToID(r, g, b) {
      var id;
      id = (r & 255) << 0;
      id |= (g & 255) << 8;
      id |= (b & 255) << 16;
      return id + RenderConstants.ID_NONE;
    }

    /**
     * Sample a color from a drawable's texture.
     * The caller is responsible for ensuring this drawable's inverse matrix & its skin's silhouette are up-to-date.
     * @see updateCPURenderAttributes
     * @param {twgl.v3} vec The scratch space [x,y] vector
     * @param {Drawable} drawable The drawable to sample the texture from
     * @param {Uint8ClampedArray} dst The "color4b" representation of the texture at point.
     * @param {number} [effectMask] A bitmask for which effects to use. Optional.
     * @returns {Uint8ClampedArray} The dst object filled with the color4b
     */
  }, {
    key: "sampleColor4b",
    value: function sampleColor4b(vec, drawable, dst, effectMask) {
      var localPosition = getLocalPosition(drawable, vec);
      if (localPosition[0] < 0 || localPosition[1] < 0 || localPosition[0] > 1 || localPosition[1] > 1) {
        dst[0] = 0;
        dst[1] = 0;
        dst[2] = 0;
        dst[3] = 0;
        return dst;
      }
      var textColor =
      // commenting out to only use nearest for now
      // drawable.skin.useNearest(drawable._scale, drawable) ?
      drawable.skin._silhouette.colorAtNearest(localPosition, dst);
      // : drawable.skin._silhouette.colorAtLinear(localPosition, dst);

      if (drawable.enabledEffects === 0) return textColor;
      return EffectTransform.transformColor(drawable, textColor, effectMask);
    }
  }]);
}();
module.exports = Drawable;

/***/ }),

/***/ "./src/EffectTransform.js":
/*!********************************!*\
  !*** ./src/EffectTransform.js ***!
  \********************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @fileoverview
 * A utility to transform a texture coordinate to another texture coordinate
 * representing how the shaders apply effects.
 */

var twgl = __webpack_require__(/*! twgl.js */ "./node_modules/twgl.js/dist/4.x/twgl-full.module.js");
var _require = __webpack_require__(/*! ./util/color-conversions */ "./src/util/color-conversions.js"),
  rgbToHsv = _require.rgbToHsv,
  hsvToRgb = _require.hsvToRgb;
var ShaderManager = __webpack_require__(/*! ./ShaderManager */ "./src/ShaderManager.js");

/**
 * A texture coordinate is between 0 and 1. 0.5 is the center position.
 * @const {number}
 */
var CENTER_X = 0.5;

/**
 * A texture coordinate is between 0 and 1. 0.5 is the center position.
 * @const {number}
 */
var CENTER_Y = 0.5;

/**
 * Reused memory location for storing an HSV color value.
 * @type {Array<number>}
 */
var __hsv = [0, 0, 0];
var EffectTransform = /*#__PURE__*/function () {
  function EffectTransform() {
    _classCallCheck(this, EffectTransform);
  }
  return _createClass(EffectTransform, null, [{
    key: "transformColor",
    value:
    /**
     * Transform a color in-place given the drawable's effect uniforms.  Will apply
     * Ghost and Color and Brightness effects.
     * @param {Drawable} drawable The drawable to get uniforms from.
     * @param {Uint8ClampedArray} inOutColor The color to transform.
     * @param {number} [effectMask] A bitmask for which effects to use. Optional.
     * @returns {Uint8ClampedArray} dst filled with the transformed color
     */
    function transformColor(drawable, inOutColor, effectMask) {
      // If the color is fully transparent, don't bother attempting any transformations.
      if (inOutColor[3] === 0) {
        return inOutColor;
      }
      var effects = drawable.enabledEffects;
      if (typeof effectMask === 'number') effects &= effectMask;
      var uniforms = drawable.getUniforms();
      var enableColor = (effects & ShaderManager.EFFECT_INFO.color.mask) !== 0;
      var enableBrightness = (effects & ShaderManager.EFFECT_INFO.brightness.mask) !== 0;
      if (enableColor || enableBrightness) {
        // gl_FragColor.rgb /= gl_FragColor.a + epsilon;
        // Here, we're dividing by the (previously pre-multiplied) alpha to ensure HSV is properly calculated
        // for partially transparent pixels.
        // epsilon is present in the shader because dividing by 0 (fully transparent pixels) messes up calculations.
        // We're doing this with a Uint8ClampedArray here, so dividing by 0 just gives 255. We're later multiplying
        // by 0 again, so it won't affect results.
        var alpha = inOutColor[3] / 255;
        inOutColor[0] /= alpha;
        inOutColor[1] /= alpha;
        inOutColor[2] /= alpha;
        if (enableColor) {
          // vec3 hsv = convertRGB2HSV(gl_FragColor.xyz);
          var hsv = rgbToHsv(inOutColor, __hsv);

          // this code forces grayscale values to be slightly saturated
          // so that some slight change of hue will be visible
          // const float minLightness = 0.11 / 2.0;
          var minV = 0.11 / 2.0;
          // const float minSaturation = 0.09;
          var minS = 0.09;
          // if (hsv.z < minLightness) hsv = vec3(0.0, 1.0, minLightness);
          if (hsv[2] < minV) {
            hsv[0] = 0;
            hsv[1] = 1;
            hsv[2] = minV;
            // else if (hsv.y < minSaturation) hsv = vec3(0.0, minSaturation, hsv.z);
          } else if (hsv[1] < minS) {
            hsv[0] = 0;
            hsv[1] = minS;
          }

          // hsv.x = mod(hsv.x + u_color, 1.0);
          // if (hsv.x < 0.0) hsv.x += 1.0;
          hsv[0] = uniforms.u_color + hsv[0] + 1;

          // gl_FragColor.rgb = convertHSV2RGB(hsl);
          hsvToRgb(hsv, inOutColor);
        }
        if (enableBrightness) {
          var brightness = uniforms.u_brightness * 255;
          // gl_FragColor.rgb = clamp(gl_FragColor.rgb + vec3(u_brightness), vec3(0), vec3(1));
          // We don't need to clamp because the Uint8ClampedArray does that for us
          inOutColor[0] += brightness;
          inOutColor[1] += brightness;
          inOutColor[2] += brightness;
        }

        // gl_FragColor.rgb *= gl_FragColor.a + epsilon;
        // Now we're doing the reverse, premultiplying by the alpha once again.
        inOutColor[0] *= alpha;
        inOutColor[1] *= alpha;
        inOutColor[2] *= alpha;
      }
      if ((effects & ShaderManager.EFFECT_INFO.ghost.mask) !== 0) {
        // gl_FragColor *= u_ghost
        inOutColor[0] *= uniforms.u_ghost;
        inOutColor[1] *= uniforms.u_ghost;
        inOutColor[2] *= uniforms.u_ghost;
        inOutColor[3] *= uniforms.u_ghost;
      }
      return inOutColor;
    }

    /**
     * Transform a texture coordinate to one that would be select after applying shader effects.
     * @param {Drawable} drawable The drawable whose effects to emulate.
     * @param {twgl.v3} vec The texture coordinate to transform.
     * @param {twgl.v3} dst A place to store the output coordinate.
     * @return {twgl.v3} dst - The coordinate after being transform by effects.
     */
  }, {
    key: "transformPoint",
    value: function transformPoint(drawable, vec, dst) {
      twgl.v3.copy(vec, dst);
      var effects = drawable.enabledEffects;
      var uniforms = drawable.getUniforms();
      if ((effects & ShaderManager.EFFECT_INFO.mosaic.mask) !== 0) {
        // texcoord0 = fract(u_mosaic * texcoord0);
        dst[0] = uniforms.u_mosaic * dst[0] % 1;
        dst[1] = uniforms.u_mosaic * dst[1] % 1;
      }
      if ((effects & ShaderManager.EFFECT_INFO.pixelate.mask) !== 0) {
        var skinUniforms = drawable.skin.getUniforms();
        // vec2 pixelTexelSize = u_skinSize / u_pixelate;
        var texelX = skinUniforms.u_skinSize[0] / uniforms.u_pixelate;
        var texelY = skinUniforms.u_skinSize[1] / uniforms.u_pixelate;
        // texcoord0 = (floor(texcoord0 * pixelTexelSize) + kCenter) /
        //   pixelTexelSize;
        dst[0] = (Math.floor(dst[0] * texelX) + CENTER_X) / texelX;
        dst[1] = (Math.floor(dst[1] * texelY) + CENTER_Y) / texelY;
      }
      if ((effects & ShaderManager.EFFECT_INFO.whirl.mask) !== 0) {
        // const float kRadius = 0.5;
        var RADIUS = 0.5;
        // vec2 offset = texcoord0 - kCenter;
        var offsetX = dst[0] - CENTER_X;
        var offsetY = dst[1] - CENTER_Y;
        // float offsetMagnitude = length(offset);
        var offsetMagnitude = Math.sqrt(Math.pow(offsetX, 2) + Math.pow(offsetY, 2));
        // float whirlFactor = max(1.0 - (offsetMagnitude / kRadius), 0.0);
        var whirlFactor = Math.max(1.0 - offsetMagnitude / RADIUS, 0.0);
        // float whirlActual = u_whirl * whirlFactor * whirlFactor;
        var whirlActual = uniforms.u_whirl * whirlFactor * whirlFactor;
        // float sinWhirl = sin(whirlActual);
        var sinWhirl = Math.sin(whirlActual);
        // float cosWhirl = cos(whirlActual);
        var cosWhirl = Math.cos(whirlActual);
        // mat2 rotationMatrix = mat2(
        //     cosWhirl, -sinWhirl,
        //     sinWhirl, cosWhirl
        // );
        var rot1 = cosWhirl;
        var rot2 = -sinWhirl;
        var rot3 = sinWhirl;
        var rot4 = cosWhirl;

        // texcoord0 = rotationMatrix * offset + kCenter;
        dst[0] = rot1 * offsetX + rot3 * offsetY + CENTER_X;
        dst[1] = rot2 * offsetX + rot4 * offsetY + CENTER_Y;
      }
      if ((effects & ShaderManager.EFFECT_INFO.fisheye.mask) !== 0) {
        // vec2 vec = (texcoord0 - kCenter) / kCenter;
        var vX = (dst[0] - CENTER_X) / CENTER_X;
        var vY = (dst[1] - CENTER_Y) / CENTER_Y;
        // float vecLength = length(vec);
        var vLength = Math.sqrt(vX * vX + vY * vY);
        // float r = pow(min(vecLength, 1.0), u_fisheye) * max(1.0, vecLength);
        var r = Math.pow(Math.min(vLength, 1), uniforms.u_fisheye) * Math.max(1, vLength);
        // vec2 unit = vec / vecLength;
        var unitX = vX / vLength;
        var unitY = vY / vLength;
        // texcoord0 = kCenter + r * unit * kCenter;
        dst[0] = CENTER_X + r * unitX * CENTER_X;
        dst[1] = CENTER_Y + r * unitY * CENTER_Y;
      }
      return dst;
    }
  }]);
}();
module.exports = EffectTransform;

/***/ }),

/***/ "./src/PenSkin.js":
/*!************************!*\
  !*** ./src/PenSkin.js ***!
  \************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var twgl = __webpack_require__(/*! twgl.js */ "./node_modules/twgl.js/dist/4.x/twgl-full.module.js");
var RenderConstants = __webpack_require__(/*! ./RenderConstants */ "./src/RenderConstants.js");
var Skin = __webpack_require__(/*! ./Skin */ "./src/Skin.js");
var ShaderManager = __webpack_require__(/*! ./ShaderManager */ "./src/ShaderManager.js");

/**
 * Attributes to use when drawing with the pen
 * @typedef {object} PenSkin#PenAttributes
 * @property {number} [diameter] - The size (diameter) of the pen.
 * @property {Array<number>} [color4f] - The pen color as an array of [r,g,b,a], each component in the range [0,1].
 */

/**
 * The pen attributes to use when unspecified.
 * @type {PenSkin#PenAttributes}
 * @memberof PenSkin
 * @private
 * @const
 */
var DefaultPenAttributes = {
  color4f: [0, 0, 1, 1],
  diameter: 1
};

/**
 * Reused memory location for storing a premultiplied pen color.
 * @type {FloatArray}
 */
var __premultipliedColor = [0, 0, 0, 0];
var PenSkin = /*#__PURE__*/function (_Skin) {
  /**
   * Create a Skin which implements a Scratch pen layer.
   * @param {int} id - The unique ID for this Skin.
   * @param {RenderWebGL} renderer - The renderer which will use this Skin.
   * @extends Skin
   * @listens RenderWebGL#event:NativeSizeChanged
   */
  function PenSkin(id, renderer) {
    var _this;
    _classCallCheck(this, PenSkin);
    _this = _callSuper(this, PenSkin, [id]);

    /**
     * @private
     * @type {RenderWebGL}
     */
    _this._renderer = renderer;

    /** @type {Array<number>} */
    _this._size = null;

    /** @type {WebGLFramebuffer} */
    _this._framebuffer = null;

    /** @type {boolean} */
    _this._silhouetteDirty = false;

    /** @type {Uint8Array} */
    _this._silhouettePixels = null;

    /** @type {ImageData} */
    _this._silhouetteImageData = null;

    /** @type {object} */
    _this._lineOnBufferDrawRegionId = {
      enter: function enter() {
        return _this._enterDrawLineOnBuffer();
      },
      exit: function exit() {
        return _this._exitDrawLineOnBuffer();
      }
    };

    /** @type {object} */
    _this._usePenBufferDrawRegionId = {
      enter: function enter() {
        return _this._enterUsePenBuffer();
      },
      exit: function exit() {
        return _this._exitUsePenBuffer();
      }
    };

    /** @type {twgl.BufferInfo} */
    _this._lineBufferInfo = twgl.createBufferInfoFromArrays(_this._renderer.gl, {
      a_position: {
        numComponents: 2,
        data: [1, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 1]
      }
    });
    var NO_EFFECTS = 0;
    /** @type {twgl.ProgramInfo} */
    _this._lineShader = _this._renderer._shaderManager.getShader(ShaderManager.DRAW_MODE.line, NO_EFFECTS);
    _this.onNativeSizeChanged = _this.onNativeSizeChanged.bind(_this);
    _this._renderer.on(RenderConstants.Events.NativeSizeChanged, _this.onNativeSizeChanged);
    _this._setCanvasSize(renderer.getNativeSize());
    return _this;
  }

  /**
   * Dispose of this object. Do not use it after calling this method.
   */
  _inherits(PenSkin, _Skin);
  return _createClass(PenSkin, [{
    key: "dispose",
    value: function dispose() {
      this._renderer.removeListener(RenderConstants.Events.NativeSizeChanged, this.onNativeSizeChanged);
      this._renderer.gl.deleteTexture(this._texture);
      this._texture = null;
      _superPropGet(PenSkin, "dispose", this, 3)([]);
    }

    /**
     * @return {Array<number>} the "native" size, in texels, of this skin. [width, height]
     */
  }, {
    key: "size",
    get: function get() {
      return this._size;
    }
  }, {
    key: "useNearest",
    value: function useNearest(scale) {
      // Use nearest-neighbor interpolation when scaling up the pen skin-- this matches Scratch 2.0.
      // When scaling it down, use linear interpolation to avoid giving pen lines a "dashed" appearance.
      return Math.max(scale[0], scale[1]) >= 100;
    }

    /**
     * @param {Array<number>} scale The X and Y scaling factors to be used, as percentages of this skin's "native" size.
     * @return {WebGLTexture} The GL texture representation of this skin when drawing at the given size.
     */
    // eslint-disable-next-line no-unused-vars
  }, {
    key: "getTexture",
    value: function getTexture(scale) {
      return this._texture;
    }

    /**
     * Clear the pen layer.
     */
  }, {
    key: "clear",
    value: function clear() {
      this._renderer.enterDrawRegion(this._usePenBufferDrawRegionId);

      /* Reset framebuffer to transparent black */
      var gl = this._renderer.gl;
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      this._silhouetteDirty = true;
    }

    /**
     * Draw a point on the pen layer.
     * @param {PenAttributes} penAttributes - how the point should be drawn.
     * @param {number} x - the X coordinate of the point to draw.
     * @param {number} y - the Y coordinate of the point to draw.
     */
  }, {
    key: "drawPoint",
    value: function drawPoint(penAttributes, x, y) {
      this.drawLine(penAttributes, x, y, x, y);
    }

    /**
     * Draw a line on the pen layer.
     * @param {PenAttributes} penAttributes - how the line should be drawn.
     * @param {number} x0 - the X coordinate of the beginning of the line.
     * @param {number} y0 - the Y coordinate of the beginning of the line.
     * @param {number} x1 - the X coordinate of the end of the line.
     * @param {number} y1 - the Y coordinate of the end of the line.
     */
  }, {
    key: "drawLine",
    value: function drawLine(penAttributes, x0, y0, x1, y1) {
      // For compatibility with Scratch 2.0, offset pen lines of width 1 and 3 so they're pixel-aligned.
      // See https://github.com/LLK/scratch-render/pull/314
      var diameter = penAttributes.diameter || DefaultPenAttributes.diameter;
      var offset = diameter === 1 || diameter === 3 ? 0.5 : 0;
      this._drawLineOnBuffer(penAttributes, x0 + offset, y0 + offset, x1 + offset, y1 + offset);
      this._silhouetteDirty = true;
    }

    /**
     * Prepare to draw lines in the _lineOnBufferDrawRegionId region.
     */
  }, {
    key: "_enterDrawLineOnBuffer",
    value: function _enterDrawLineOnBuffer() {
      var gl = this._renderer.gl;
      twgl.bindFramebufferInfo(gl, this._framebuffer);
      gl.viewport(0, 0, this._size[0], this._size[1]);
      var currentShader = this._lineShader;
      gl.useProgram(currentShader.program);
      twgl.setBuffersAndAttributes(gl, currentShader, this._lineBufferInfo);
      var uniforms = {
        u_skin: this._texture,
        u_stageSize: this._size
      };
      twgl.setUniforms(currentShader, uniforms);
    }

    /**
     * Return to a base state from _lineOnBufferDrawRegionId.
     */
  }, {
    key: "_exitDrawLineOnBuffer",
    value: function _exitDrawLineOnBuffer() {
      var gl = this._renderer.gl;
      twgl.bindFramebufferInfo(gl, null);
    }

    /**
     * Prepare to do things with this PenSkin's framebuffer
     */
  }, {
    key: "_enterUsePenBuffer",
    value: function _enterUsePenBuffer() {
      twgl.bindFramebufferInfo(this._renderer.gl, this._framebuffer);
    }

    /**
     * Return to a base state
     */
  }, {
    key: "_exitUsePenBuffer",
    value: function _exitUsePenBuffer() {
      twgl.bindFramebufferInfo(this._renderer.gl, null);
    }

    /**
     * Draw a line on the framebuffer.
     * Note that the point coordinates are in the following coordinate space:
     * +y is down, (0, 0) is the center, and the coords range from (-width / 2, -height / 2) to (height / 2, width / 2).
     * @param {PenAttributes} penAttributes - how the line should be drawn.
     * @param {number} x0 - the X coordinate of the beginning of the line.
     * @param {number} y0 - the Y coordinate of the beginning of the line.
     * @param {number} x1 - the X coordinate of the end of the line.
     * @param {number} y1 - the Y coordinate of the end of the line.
     */
  }, {
    key: "_drawLineOnBuffer",
    value: function _drawLineOnBuffer(penAttributes, x0, y0, x1, y1) {
      var gl = this._renderer.gl;
      var currentShader = this._lineShader;
      this._renderer.enterDrawRegion(this._lineOnBufferDrawRegionId);

      // Premultiply pen color by pen transparency
      var penColor = penAttributes.color4f || DefaultPenAttributes.color4f;
      __premultipliedColor[0] = penColor[0] * penColor[3];
      __premultipliedColor[1] = penColor[1] * penColor[3];
      __premultipliedColor[2] = penColor[2] * penColor[3];
      __premultipliedColor[3] = penColor[3];

      // Fun fact: Doing this calculation in the shader has the potential to overflow the floating-point range.
      // 'mediump' precision is only required to have a range up to 2^14 (16384), so any lines longer than 2^7 (128)
      // can overflow that, because you're squaring the operands, and they could end up as "infinity".
      // Even GLSL's `length` function won't save us here:
      // https://asawicki.info/news_1596_watch_out_for_reduced_precision_normalizelength_in_opengl_es
      var lineDiffX = x1 - x0;
      var lineDiffY = y1 - y0;
      var lineLength = Math.sqrt(lineDiffX * lineDiffX + lineDiffY * lineDiffY);
      var uniforms = {
        u_lineColor: __premultipliedColor,
        u_lineThickness: penAttributes.diameter || DefaultPenAttributes.diameter,
        u_lineLength: lineLength,
        u_penPoints: [x0, -y0, lineDiffX, -lineDiffY]
      };
      twgl.setUniforms(currentShader, uniforms);
      twgl.drawBufferInfo(gl, this._lineBufferInfo, gl.TRIANGLES);
      this._silhouetteDirty = true;
    }

    /**
     * React to a change in the renderer's native size.
     * @param {object} event - The change event.
     */
  }, {
    key: "onNativeSizeChanged",
    value: function onNativeSizeChanged(event) {
      this._setCanvasSize(event.newSize);
    }

    /**
     * Set the size of the pen canvas.
     * @param {Array<int>} canvasSize - the new width and height for the canvas.
     * @private
     */
  }, {
    key: "_setCanvasSize",
    value: function _setCanvasSize(canvasSize) {
      var _canvasSize = _slicedToArray(canvasSize, 2),
        width = _canvasSize[0],
        height = _canvasSize[1];
      this._size = canvasSize;
      this._rotationCenter[0] = width / 2;
      this._rotationCenter[1] = height / 2;
      var gl = this._renderer.gl;
      this._texture = twgl.createTexture(gl, {
        mag: gl.NEAREST,
        min: gl.NEAREST,
        wrap: gl.CLAMP_TO_EDGE,
        width: width,
        height: height
      });
      var attachments = [{
        format: gl.RGBA,
        attachment: this._texture
      }];
      if (this._framebuffer) {
        twgl.resizeFramebufferInfo(gl, this._framebuffer, attachments, width, height);
      } else {
        this._framebuffer = twgl.createFramebufferInfo(gl, attachments, width, height);
      }
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      this._silhouettePixels = new Uint8Array(Math.floor(width * height * 4));
      this._silhouetteImageData = new ImageData(width, height);
      this._silhouetteDirty = true;
    }

    /**
     * If there have been pen operations that have dirtied the canvas, update
     * now before someone wants to use our silhouette.
     */
  }, {
    key: "updateSilhouette",
    value: function updateSilhouette() {
      if (this._silhouetteDirty) {
        this._renderer.enterDrawRegion(this._usePenBufferDrawRegionId);
        // Sample the framebuffer's pixels into the silhouette instance
        var gl = this._renderer.gl;
        gl.readPixels(0, 0, this._size[0], this._size[1], gl.RGBA, gl.UNSIGNED_BYTE, this._silhouettePixels);
        this._silhouetteImageData.data.set(this._silhouettePixels);
        this._silhouette.update(this._silhouetteImageData, true /* isPremultiplied */);
        this._silhouetteDirty = false;
      }
    }
  }]);
}(Skin);
module.exports = PenSkin;

/***/ }),

/***/ "./src/Rectangle.js":
/*!**************************!*\
  !*** ./src/Rectangle.js ***!
  \**************************/
/***/ (function(module) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Rectangle = /*#__PURE__*/function () {
  /**
   * A utility for creating and comparing axis-aligned rectangles.
   * Rectangles are always initialized to the "largest possible rectangle";
   * use one of the init* methods below to set up a particular rectangle.
   * @constructor
   */
  function Rectangle() {
    _classCallCheck(this, Rectangle);
    this.left = -Infinity;
    this.right = Infinity;
    this.bottom = -Infinity;
    this.top = Infinity;
  }

  /**
   * Initialize a Rectangle from given Scratch-coordinate bounds.
   * @param {number} left Left bound of the rectangle.
   * @param {number} right Right bound of the rectangle.
   * @param {number} bottom Bottom bound of the rectangle.
   * @param {number} top Top bound of the rectangle.
   */
  return _createClass(Rectangle, [{
    key: "initFromBounds",
    value: function initFromBounds(left, right, bottom, top) {
      this.left = left;
      this.right = right;
      this.bottom = bottom;
      this.top = top;
    }

    /**
     * Initialize a Rectangle to the minimum AABB around a set of points.
     * @param {Array<Array<number>>} points Array of [x, y] points.
     */
  }, {
    key: "initFromPointsAABB",
    value: function initFromPointsAABB(points) {
      this.left = Infinity;
      this.right = -Infinity;
      this.top = -Infinity;
      this.bottom = Infinity;
      for (var i = 0; i < points.length; i++) {
        var x = points[i][0];
        var y = points[i][1];
        if (x < this.left) {
          this.left = x;
        }
        if (x > this.right) {
          this.right = x;
        }
        if (y > this.top) {
          this.top = y;
        }
        if (y < this.bottom) {
          this.bottom = y;
        }
      }
    }

    /**
     * Initialize a Rectangle to a 1 unit square centered at 0 x 0 transformed
     * by a model matrix.
     * @param {Array.<number>} m A 4x4 matrix to transform the rectangle by.
     * @tutorial Rectangle-AABB-Matrix
     */
  }, {
    key: "initFromModelMatrix",
    value: function initFromModelMatrix(m) {
      // In 2D space, we will soon use the 2x2 "top left" scale and rotation
      // submatrix, while we store and the 1x2 "top right" that position
      // vector.
      var m30 = m[3 * 4 + 0];
      var m31 = m[3 * 4 + 1];

      // "Transform" a (0.5, 0.5) vector by the scale and rotation matrix but
      // sum the absolute of each component instead of use the signed values.
      var x = Math.abs(0.5 * m[0 * 4 + 0]) + Math.abs(0.5 * m[1 * 4 + 0]);
      var y = Math.abs(0.5 * m[0 * 4 + 1]) + Math.abs(0.5 * m[1 * 4 + 1]);

      // And adding them to the position components initializes our Rectangle.
      this.left = -x + m30;
      this.right = x + m30;
      this.top = y + m31;
      this.bottom = -y + m31;
    }

    /**
     * Determine if this Rectangle intersects some other.
     * Note that this is a comparison assuming the Rectangle was
     * initialized with Scratch-space bounds or points.
     * @param {!Rectangle} other Rectangle to check if intersecting.
     * @return {boolean} True if this Rectangle intersects other.
     */
  }, {
    key: "intersects",
    value: function intersects(other) {
      return this.left <= other.right && other.left <= this.right && this.top >= other.bottom && other.top >= this.bottom;
    }

    /**
     * Determine if this Rectangle fully contains some other.
     * Note that this is a comparison assuming the Rectangle was
     * initialized with Scratch-space bounds or points.
     * @param {!Rectangle} other Rectangle to check if fully contained.
     * @return {boolean} True if this Rectangle fully contains other.
     */
  }, {
    key: "contains",
    value: function contains(other) {
      return other.left > this.left && other.right < this.right && other.top < this.top && other.bottom > this.bottom;
    }

    /**
     * Clamp a Rectangle to bounds.
     * @param {number} left Left clamp.
     * @param {number} right Right clamp.
     * @param {number} bottom Bottom clamp.
     * @param {number} top Top clamp.
     */
  }, {
    key: "clamp",
    value: function clamp(left, right, bottom, top) {
      this.left = Math.max(this.left, left);
      this.right = Math.min(this.right, right);
      this.bottom = Math.max(this.bottom, bottom);
      this.top = Math.min(this.top, top);
      this.left = Math.min(this.left, right);
      this.right = Math.max(this.right, left);
      this.bottom = Math.min(this.bottom, top);
      this.top = Math.max(this.top, bottom);
    }

    /**
     * Push out the Rectangle to integer bounds.
     */
  }, {
    key: "snapToInt",
    value: function snapToInt() {
      this.left = Math.floor(this.left);
      this.right = Math.ceil(this.right);
      this.bottom = Math.floor(this.bottom);
      this.top = Math.ceil(this.top);
    }

    /**
     * Compute the intersection of two bounding Rectangles.
     * Could be an impossible box if they don't intersect.
     * @param {Rectangle} a One rectangle
     * @param {Rectangle} b Other rectangle
     * @param {?Rectangle} result A resulting storage rectangle  (safe to pass
     *                            a or b if you want to overwrite one)
     * @returns {Rectangle} resulting rectangle
     */
  }, {
    key: "width",
    get:
    /**
     * Width of the Rectangle.
     * @return {number} Width of rectangle.
     */
    function get() {
      return Math.abs(this.left - this.right);
    }

    /**
     * Height of the Rectangle.
     * @return {number} Height of rectangle.
     */
  }, {
    key: "height",
    get: function get() {
      return Math.abs(this.top - this.bottom);
    }
  }], [{
    key: "intersect",
    value: function intersect(a, b) {
      var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Rectangle();
      result.left = Math.max(a.left, b.left);
      result.right = Math.min(a.right, b.right);
      result.top = Math.min(a.top, b.top);
      result.bottom = Math.max(a.bottom, b.bottom);
      return result;
    }

    /**
     * Compute the union of two bounding Rectangles.
     * @param {Rectangle} a One rectangle
     * @param {Rectangle} b Other rectangle
     * @param {?Rectangle} result A resulting storage rectangle  (safe to pass
     *                            a or b if you want to overwrite one)
     * @returns {Rectangle} resulting rectangle
     */
  }, {
    key: "union",
    value: function union(a, b) {
      var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Rectangle();
      result.left = Math.min(a.left, b.left);
      result.right = Math.max(a.right, b.right);
      // Scratch Space - +y is up
      result.top = Math.max(a.top, b.top);
      result.bottom = Math.min(a.bottom, b.bottom);
      return result;
    }
  }]);
}();
module.exports = Rectangle;

/***/ }),

/***/ "./src/RenderConstants.js":
/*!********************************!*\
  !*** ./src/RenderConstants.js ***!
  \********************************/
/***/ (function(module) {

/** @module RenderConstants */

/**
 * Various constants meant for use throughout the renderer.
 * @enum
 */
module.exports = {
  /**
   * The ID value to use for "no item" or when an object has been disposed.
   * @const {int}
   */
  ID_NONE: -1,
  /**
   * Optimize for fewer than this number of Drawables sharing the same Skin.
   * Going above this may cause middleware warnings or a performance penalty but should otherwise behave correctly.
   * @const {int}
   */
  SKIN_SHARE_SOFT_LIMIT: 301,
  /**
   * @enum {string}
   */
  Events: {
    /**
     * NativeSizeChanged event
     *
     * @event RenderWebGL#event:NativeSizeChanged
     * @type {object}
     * @property {Array<int>} newSize - the new size of the renderer
     */
    NativeSizeChanged: 'NativeSizeChanged'
  }
};

/***/ }),

/***/ "./src/RenderWebGL.js":
/*!****************************!*\
  !*** ./src/RenderWebGL.js ***!
  \****************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var EventEmitter = __webpack_require__(/*! events */ "./node_modules/events/events.js");
var hull = __webpack_require__(/*! hull.js */ "./node_modules/hull.js/src/hull.js");
var twgl = __webpack_require__(/*! twgl.js */ "./node_modules/twgl.js/dist/4.x/twgl-full.module.js");
var BitmapSkin = __webpack_require__(/*! ./BitmapSkin */ "./src/BitmapSkin.js");
var Drawable = __webpack_require__(/*! ./Drawable */ "./src/Drawable.js");
var Rectangle = __webpack_require__(/*! ./Rectangle */ "./src/Rectangle.js");
var PenSkin = __webpack_require__(/*! ./PenSkin */ "./src/PenSkin.js");
var RenderConstants = __webpack_require__(/*! ./RenderConstants */ "./src/RenderConstants.js");
var ShaderManager = __webpack_require__(/*! ./ShaderManager */ "./src/ShaderManager.js");
var SVGSkin = __webpack_require__(/*! ./SVGSkin */ "./src/SVGSkin.js");
var TextBubbleSkin = __webpack_require__(/*! ./TextBubbleSkin */ "./src/TextBubbleSkin.js");
var EffectTransform = __webpack_require__(/*! ./EffectTransform */ "./src/EffectTransform.js");
var log = __webpack_require__(/*! ./util/log */ "./src/util/log.js");
var __isTouchingDrawablesPoint = twgl.v3.create();
var __candidatesBounds = new Rectangle();
var __fenceBounds = new Rectangle();
var __touchingColor = new Uint8ClampedArray(4);
var __blendColor = new Uint8ClampedArray(4);

// More pixels than this and we give up to the GPU and take the cost of readPixels
// Width * Height * Number of drawables at location
var __cpuTouchingColorPixelCount = 4e4;

/**
 * @callback RenderWebGL#idFilterFunc
 * @param {int} drawableID The ID to filter.
 * @return {bool} True if the ID passes the filter, otherwise false.
 */

/**
 * Maximum touch size for a picking check.
 * @todo Figure out a reasonable max size. Maybe this should be configurable?
 * @type {Array<int>}
 * @memberof RenderWebGL
 */
var MAX_TOUCH_SIZE = [3, 3];

/**
 * Passed to the uniforms for mask in touching color
 */
var MASK_TOUCHING_COLOR_TOLERANCE = 2;

/**
 * Maximum number of pixels in either dimension of "extracted drawable" data
 * @type {int}
 */
var MAX_EXTRACTED_DRAWABLE_DIMENSION = 2048;

/**
 * Determines if the mask color is "close enough" (only test the 6 top bits for
 * each color).  These bit masks are what scratch 2 used to use, so we do the same.
 * @param {Uint8Array} a A color3b or color4b value.
 * @param {Uint8Array} b A color3b or color4b value.
 * @returns {boolean} If the colors match within the parameters.
 */
var maskMatches = function maskMatches(a, b) {
  return (
    // has some non-alpha component to test against
    a[3] > 0 && (a[0] & 252) === (b[0] & 252) && (a[1] & 252) === (b[1] & 252) && (a[2] & 252) === (b[2] & 252)
  );
};

/**
 * Determines if the given color is "close enough" (only test the 5 top bits for
 * red and green, 4 bits for blue).  These bit masks are what scratch 2 used to use,
 * so we do the same.
 * @param {Uint8Array} a A color3b or color4b value.
 * @param {Uint8Array} b A color3b or color4b value / or a larger array when used with offsets
 * @param {number} offset An offset into the `b` array, which lets you use a larger array to test
 *                  multiple values at the same time.
 * @returns {boolean} If the colors match within the parameters.
 */
var colorMatches = function colorMatches(a, b, offset) {
  return (a[0] & 248) === (b[offset + 0] & 248) && (a[1] & 248) === (b[offset + 1] & 248) && (a[2] & 240) === (b[offset + 2] & 240);
};

/**
 * Sprite Fencing - The number of pixels a sprite is required to leave remaining
 * onscreen around the edge of the staging area.
 * @type {number}
 */
var FENCE_WIDTH = 15;
var RenderWebGL = /*#__PURE__*/function (_EventEmitter) {
  /**
   * Create a renderer for drawing Scratch sprites to a canvas using WebGL.
   * Coordinates will default to Scratch 2.0 values if unspecified.
   * The stage's "native" size will be calculated from the these coordinates.
   * For example, the defaults result in a native size of 480x360.
   * Queries such as "touching color?" will always execute at the native size.
   * @see RenderWebGL#setStageSize
   * @see RenderWebGL#resize
   * @param {canvas} canvas The canvas to draw onto.
   * @param {int} [xLeft=-240] The x-coordinate of the left edge.
   * @param {int} [xRight=240] The x-coordinate of the right edge.
   * @param {int} [yBottom=-180] The y-coordinate of the bottom edge.
   * @param {int} [yTop=180] The y-coordinate of the top edge.
   * @constructor
   * @listens RenderWebGL#event:NativeSizeChanged
   */
  function RenderWebGL(canvas, xLeft, xRight, yBottom, yTop) {
    var _this;
    _classCallCheck(this, RenderWebGL);
    _this = _callSuper(this, RenderWebGL);

    /** @type {WebGLRenderingContext} */
    var gl = _this._gl = RenderWebGL._getContext(canvas);
    if (!gl) {
      throw new Error('Could not get WebGL context: this browser or environment may not support WebGL.');
    }

    /** @type {RenderWebGL.UseGpuModes} */
    _this._useGpuMode = RenderWebGL.UseGpuModes.Automatic;

    /** @type {Drawable[]} */
    _this._allDrawables = [];

    /** @type {Skin[]} */
    _this._allSkins = [];

    /** @type {Array<int>} */
    _this._drawList = [];

    // A list of layer group names in the order they should appear
    // from furthest back to furthest in front.
    /** @type {Array<String>} */
    _this._groupOrdering = [];

    /**
     * @typedef LayerGroup
     * @property {int} groupIndex The relative position of this layer group in the group ordering
     * @property {int} drawListOffset The absolute position of this layer group in the draw list
     * This number gets updated as drawables get added to or deleted from the draw list.
     */

    // Map of group name to layer group
    /** @type {Object.<string, LayerGroup>} */
    _this._layerGroups = {};

    /** @type {int} */
    _this._nextDrawableId = RenderConstants.ID_NONE + 1;

    /** @type {int} */
    _this._nextSkinId = RenderConstants.ID_NONE + 1;

    /** @type {module:twgl/m4.Mat4} */
    _this._projection = twgl.m4.identity();

    /** @type {ShaderManager} */
    _this._shaderManager = new ShaderManager(gl);

    /** @type {HTMLCanvasElement} */
    _this._tempCanvas = document.createElement('canvas');

    /** @type {any} */
    _this._regionId = null;

    /** @type {function} */
    _this._exitRegion = null;

    /** @type {object} */
    _this._backgroundDrawRegionId = {
      enter: function enter() {
        return _this._enterDrawBackground();
      },
      exit: function exit() {
        return _this._exitDrawBackground();
      }
    };

    /** @type {Array.<snapshotCallback>} */
    _this._snapshotCallbacks = [];

    /** @type {Array<number>} */
    // Don't set this directly-- use setBackgroundColor so it stays in sync with _backgroundColor3b
    _this._backgroundColor4f = [0, 0, 0, 1];

    /** @type {Uint8ClampedArray} */
    // Don't set this directly-- use setBackgroundColor so it stays in sync with _backgroundColor4f
    _this._backgroundColor3b = new Uint8ClampedArray(3);
    _this._createGeometry();
    _this.on(RenderConstants.Events.NativeSizeChanged, _this.onNativeSizeChanged);
    _this.setBackgroundColor(1, 1, 1);
    _this.setStageSize(xLeft || -240, xRight || 240, yBottom || -180, yTop || 180);
    _this.resize(_this._nativeSize[0], _this._nativeSize[1]);
    gl.disable(gl.DEPTH_TEST);
    /** @todo disable when no partial transparency? */
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    return _this;
  }

  /**
   * @returns {WebGLRenderingContext} the WebGL rendering context associated with this renderer.
   */
  _inherits(RenderWebGL, _EventEmitter);
  return _createClass(RenderWebGL, [{
    key: "gl",
    get: function get() {
      return this._gl;
    }

    /**
     * @returns {HTMLCanvasElement} the canvas of the WebGL rendering context associated with this renderer.
     */
  }, {
    key: "canvas",
    get: function get() {
      return this._gl && this._gl.canvas;
    }

    /**
     * Set the physical size of the stage in device-independent pixels.
     * This will be multiplied by the device's pixel ratio on high-DPI displays.
     * @param {int} pixelsWide The desired width in device-independent pixels.
     * @param {int} pixelsTall The desired height in device-independent pixels.
     */
  }, {
    key: "resize",
    value: function resize(pixelsWide, pixelsTall) {
      var canvas = this._gl.canvas;
      var pixelRatio = window.devicePixelRatio || 1;
      var newWidth = pixelsWide * pixelRatio;
      var newHeight = pixelsTall * pixelRatio;

      // Certain operations, such as moving the color picker, call `resize` once per frame, even though the canvas
      // size doesn't change. To avoid unnecessary canvas updates, check that we *really* need to resize the canvas.
      if (canvas.width !== newWidth || canvas.height !== newHeight) {
        canvas.width = newWidth;
        canvas.height = newHeight;
        // Resizing the canvas causes it to be cleared, so redraw it.
        this.draw();
      }
    }

    /**
     * Set the background color for the stage. The stage will be cleared with this
     * color each frame.
     * @param {number} red The red component for the background.
     * @param {number} green The green component for the background.
     * @param {number} blue The blue component for the background.
     */
  }, {
    key: "setBackgroundColor",
    value: function setBackgroundColor(red, green, blue) {
      this._backgroundColor4f[0] = red;
      this._backgroundColor4f[1] = green;
      this._backgroundColor4f[2] = blue;
      this._backgroundColor3b[0] = red * 255;
      this._backgroundColor3b[1] = green * 255;
      this._backgroundColor3b[2] = blue * 255;
    }

    /**
     * Tell the renderer to draw various debug information to the provided canvas
     * during certain operations.
     * @param {canvas} canvas The canvas to use for debug output.
     */
  }, {
    key: "setDebugCanvas",
    value: function setDebugCanvas(canvas) {
      this._debugCanvas = canvas;
    }

    /**
     * Control the use of the GPU or CPU paths in `isTouchingColor`.
     * @param {RenderWebGL.UseGpuModes} useGpuMode - automatically decide, force CPU, or force GPU.
     */
  }, {
    key: "setUseGpuMode",
    value: function setUseGpuMode(useGpuMode) {
      this._useGpuMode = useGpuMode;
    }

    /**
     * Set logical size of the stage in Scratch units.
     * @param {int} xLeft The left edge's x-coordinate. Scratch 2 uses -240.
     * @param {int} xRight The right edge's x-coordinate. Scratch 2 uses 240.
     * @param {int} yBottom The bottom edge's y-coordinate. Scratch 2 uses -180.
     * @param {int} yTop The top edge's y-coordinate. Scratch 2 uses 180.
     */
  }, {
    key: "setStageSize",
    value: function setStageSize(xLeft, xRight, yBottom, yTop) {
      this._xLeft = xLeft;
      this._xRight = xRight;
      this._yBottom = yBottom;
      this._yTop = yTop;

      // swap yBottom & yTop to fit Scratch convention of +y=up
      this._projection = twgl.m4.ortho(xLeft, xRight, yBottom, yTop, -1, 1);
      this._setNativeSize(Math.abs(xRight - xLeft), Math.abs(yBottom - yTop));
    }

    /**
     * @return {Array<int>} the "native" size of the stage, which is used for pen, query renders, etc.
     */
  }, {
    key: "getNativeSize",
    value: function getNativeSize() {
      return [this._nativeSize[0], this._nativeSize[1]];
    }

    /**
     * Set the "native" size of the stage, which is used for pen, query renders, etc.
     * @param {int} width - the new width to set.
     * @param {int} height - the new height to set.
     * @private
     * @fires RenderWebGL#event:NativeSizeChanged
     */
  }, {
    key: "_setNativeSize",
    value: function _setNativeSize(width, height) {
      this._nativeSize = [width, height];
      this.emit(RenderConstants.Events.NativeSizeChanged, {
        newSize: this._nativeSize
      });
    }

    /**
     * Create a new bitmap skin from a snapshot of the provided bitmap data.
     * @param {ImageData|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} bitmapData - new contents for this skin.
     * @param {!int} [costumeResolution=1] - The resolution to use for this bitmap.
     * @param {?Array<number>} [rotationCenter] Optional: rotation center of the skin. If not supplied, the center of
     * the skin will be used.
     * @returns {!int} the ID for the new skin.
     */
  }, {
    key: "createBitmapSkin",
    value: function createBitmapSkin(bitmapData, costumeResolution, rotationCenter) {
      var skinId = this._nextSkinId++;
      var newSkin = new BitmapSkin(skinId, this);
      newSkin.setBitmap(bitmapData, costumeResolution, rotationCenter);
      this._allSkins[skinId] = newSkin;
      return skinId;
    }

    /**
     * Create a new SVG skin.
     * @param {!string} svgData - new SVG to use.
     * @param {?Array<number>} rotationCenter Optional: rotation center of the skin. If not supplied, the center of the
     * skin will be used
     * @returns {!int} the ID for the new skin.
     */
  }, {
    key: "createSVGSkin",
    value: function createSVGSkin(svgData, rotationCenter) {
      var skinId = this._nextSkinId++;
      var newSkin = new SVGSkin(skinId, this);
      newSkin.setSVG(svgData, rotationCenter);
      this._allSkins[skinId] = newSkin;
      return skinId;
    }

    /**
     * Create a new PenSkin - a skin which implements a Scratch pen layer.
     * @returns {!int} the ID for the new skin.
     */
  }, {
    key: "createPenSkin",
    value: function createPenSkin() {
      var skinId = this._nextSkinId++;
      var newSkin = new PenSkin(skinId, this);
      this._allSkins[skinId] = newSkin;
      return skinId;
    }

    /**
     * Create a new SVG skin using the text bubble svg creator. The rotation center
     * is always placed at the top left.
     * @param {!string} type - either "say" or "think".
     * @param {!string} text - the text for the bubble.
     * @param {!boolean} pointsLeft - which side the bubble is pointing.
     * @returns {!int} the ID for the new skin.
     */
  }, {
    key: "createTextSkin",
    value: function createTextSkin(type, text, pointsLeft) {
      var skinId = this._nextSkinId++;
      var newSkin = new TextBubbleSkin(skinId, this);
      newSkin.setTextBubble(type, text, pointsLeft);
      this._allSkins[skinId] = newSkin;
      return skinId;
    }

    /**
     * Update an existing SVG skin, or create an SVG skin if the previous skin was not SVG.
     * @param {!int} skinId the ID for the skin to change.
     * @param {!string} svgData - new SVG to use.
     * @param {?Array<number>} rotationCenter Optional: rotation center of the skin. If not supplied, the center of the
     * skin will be used
     */
  }, {
    key: "updateSVGSkin",
    value: function updateSVGSkin(skinId, svgData, rotationCenter) {
      if (this._allSkins[skinId] instanceof SVGSkin) {
        this._allSkins[skinId].setSVG(svgData, rotationCenter);
        return;
      }
      var newSkin = new SVGSkin(skinId, this);
      newSkin.setSVG(svgData, rotationCenter);
      this._reskin(skinId, newSkin);
    }

    /**
     * Update an existing bitmap skin, or create a bitmap skin if the previous skin was not bitmap.
     * @param {!int} skinId the ID for the skin to change.
     * @param {!ImageData|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imgData - new contents for this skin.
     * @param {!number} bitmapResolution - the resolution scale for a bitmap costume.
     * @param {?Array<number>} rotationCenter Optional: rotation center of the skin. If not supplied, the center of the
     * skin will be used
     */
  }, {
    key: "updateBitmapSkin",
    value: function updateBitmapSkin(skinId, imgData, bitmapResolution, rotationCenter) {
      if (this._allSkins[skinId] instanceof BitmapSkin) {
        this._allSkins[skinId].setBitmap(imgData, bitmapResolution, rotationCenter);
        return;
      }
      var newSkin = new BitmapSkin(skinId, this);
      newSkin.setBitmap(imgData, bitmapResolution, rotationCenter);
      this._reskin(skinId, newSkin);
    }
  }, {
    key: "_reskin",
    value: function _reskin(skinId, newSkin) {
      var oldSkin = this._allSkins[skinId];
      this._allSkins[skinId] = newSkin;

      // Tell drawables to update
      var _iterator = _createForOfIteratorHelper(this._allDrawables),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var drawable = _step.value;
          if (drawable && drawable.skin === oldSkin) {
            drawable.skin = newSkin;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      oldSkin.dispose();
    }

    /**
     * Update a skin using the text bubble svg creator.
     * @param {!int} skinId the ID for the skin to change.
     * @param {!string} type - either "say" or "think".
     * @param {!string} text - the text for the bubble.
     * @param {!boolean} pointsLeft - which side the bubble is pointing.
     */
  }, {
    key: "updateTextSkin",
    value: function updateTextSkin(skinId, type, text, pointsLeft) {
      if (this._allSkins[skinId] instanceof TextBubbleSkin) {
        this._allSkins[skinId].setTextBubble(type, text, pointsLeft);
        return;
      }
      var newSkin = new TextBubbleSkin(skinId, this);
      newSkin.setTextBubble(type, text, pointsLeft);
      this._reskin(skinId, newSkin);
    }

    /**
     * Destroy an existing skin. Do not use the skin or its ID after calling this.
     * @param {!int} skinId - The ID of the skin to destroy.
     */
  }, {
    key: "destroySkin",
    value: function destroySkin(skinId) {
      var oldSkin = this._allSkins[skinId];
      oldSkin.dispose();
      delete this._allSkins[skinId];
    }

    /**
     * Create a new Drawable and add it to the scene.
     * @param {string} group Layer group to add the drawable to
     * @returns {int} The ID of the new Drawable.
     */
  }, {
    key: "createDrawable",
    value: function createDrawable(group) {
      if (!group || !Object.prototype.hasOwnProperty.call(this._layerGroups, group)) {
        log.warn('Cannot create a drawable without a known layer group');
        return;
      }
      var drawableID = this._nextDrawableId++;
      var drawable = new Drawable(drawableID);
      this._allDrawables[drawableID] = drawable;
      this._addToDrawList(drawableID, group);
      drawable.skin = null;
      return drawableID;
    }

    /**
     * Set the layer group ordering for the renderer.
     * @param {Array<string>} groupOrdering The ordered array of layer group
     * names
     */
  }, {
    key: "setLayerGroupOrdering",
    value: function setLayerGroupOrdering(groupOrdering) {
      this._groupOrdering = groupOrdering;
      for (var i = 0; i < this._groupOrdering.length; i++) {
        this._layerGroups[this._groupOrdering[i]] = {
          groupIndex: i,
          drawListOffset: 0
        };
      }
    }
  }, {
    key: "_addToDrawList",
    value: function _addToDrawList(drawableID, group) {
      var currentLayerGroup = this._layerGroups[group];
      var currentGroupOrderingIndex = currentLayerGroup.groupIndex;
      var drawListOffset = this._endIndexForKnownLayerGroup(currentLayerGroup);
      this._drawList.splice(drawListOffset, 0, drawableID);
      this._updateOffsets('add', currentGroupOrderingIndex);
    }
  }, {
    key: "_updateOffsets",
    value: function _updateOffsets(updateType, currentGroupOrderingIndex) {
      for (var i = currentGroupOrderingIndex + 1; i < this._groupOrdering.length; i++) {
        var laterGroupName = this._groupOrdering[i];
        if (updateType === 'add') {
          this._layerGroups[laterGroupName].drawListOffset++;
        } else if (updateType === 'delete') {
          this._layerGroups[laterGroupName].drawListOffset--;
        }
      }
    }
  }, {
    key: "_visibleDrawList",
    get: function get() {
      var _this2 = this;
      return this._drawList.filter(function (id) {
        return _this2._allDrawables[id]._visible;
      });
    }

    // Given a layer group, return the index where it ends (non-inclusive),
    // e.g. the returned index does not have a drawable from this layer group in it)
  }, {
    key: "_endIndexForKnownLayerGroup",
    value: function _endIndexForKnownLayerGroup(layerGroup) {
      var groupIndex = layerGroup.groupIndex;
      if (groupIndex === this._groupOrdering.length - 1) {
        return this._drawList.length;
      }
      return this._layerGroups[this._groupOrdering[groupIndex + 1]].drawListOffset;
    }

    /**
     * Destroy a Drawable, removing it from the scene.
     * @param {int} drawableID The ID of the Drawable to remove.
     * @param {string} group Group name that the drawable belongs to
     */
  }, {
    key: "destroyDrawable",
    value: function destroyDrawable(drawableID, group) {
      if (!group || !Object.prototype.hasOwnProperty.call(this._layerGroups, group)) {
        log.warn('Cannot destroy drawable without known layer group.');
        return;
      }
      var drawable = this._allDrawables[drawableID];
      drawable.dispose();
      delete this._allDrawables[drawableID];
      var currentLayerGroup = this._layerGroups[group];
      var endIndex = this._endIndexForKnownLayerGroup(currentLayerGroup);
      var index = currentLayerGroup.drawListOffset;
      while (index < endIndex) {
        if (this._drawList[index] === drawableID) {
          break;
        }
        index++;
      }
      if (index < endIndex) {
        this._drawList.splice(index, 1);
        this._updateOffsets('delete', currentLayerGroup.groupIndex);
      } else {
        log.warn('Could not destroy drawable that could not be found in layer group.');
        return;
      }
    }

    /**
     * Returns the position of the given drawableID in the draw list. This is
     * the absolute position irrespective of layer group.
     * @param {number} drawableID The drawable ID to find.
     * @return {number} The postion of the given drawable ID.
     */
  }, {
    key: "getDrawableOrder",
    value: function getDrawableOrder(drawableID) {
      return this._drawList.indexOf(drawableID);
    }

    /**
     * Set a drawable's order in the drawable list (effectively, z/layer).
     * Can be used to move drawables to absolute positions in the list,
     * or relative to their current positions.
     * "go back N layers": setDrawableOrder(id, -N, true, 1); (assuming stage at 0).
     * "go to back": setDrawableOrder(id, 1); (assuming stage at 0).
     * "go to front": setDrawableOrder(id, Infinity);
     * @param {int} drawableID ID of Drawable to reorder.
     * @param {number} order New absolute order or relative order adjusment.
     * @param {string=} group Name of layer group drawable belongs to.
     * Reordering will not take place if drawable cannot be found within the bounds
     * of the layer group.
     * @param {boolean=} optIsRelative If set, `order` refers to a relative change.
     * @param {number=} optMin If set, order constrained to be at least `optMin`.
     * @return {?number} New order if changed, or null.
     */
  }, {
    key: "setDrawableOrder",
    value: function setDrawableOrder(drawableID, order, group, optIsRelative, optMin) {
      if (!group || !Object.prototype.hasOwnProperty.call(this._layerGroups, group)) {
        log.warn('Cannot set the order of a drawable without a known layer group.');
        return;
      }
      var currentLayerGroup = this._layerGroups[group];
      var startIndex = currentLayerGroup.drawListOffset;
      var endIndex = this._endIndexForKnownLayerGroup(currentLayerGroup);
      var oldIndex = startIndex;
      while (oldIndex < endIndex) {
        if (this._drawList[oldIndex] === drawableID) {
          break;
        }
        oldIndex++;
      }
      if (oldIndex < endIndex) {
        // Remove drawable from the list.
        if (order === 0) {
          return oldIndex;
        }
        var _ = this._drawList.splice(oldIndex, 1)[0];
        // Determine new index.
        var newIndex = order;
        if (optIsRelative) {
          newIndex += oldIndex;
        }
        var possibleMin = (optMin || 0) + startIndex;
        var min = possibleMin >= startIndex && possibleMin < endIndex ? possibleMin : startIndex;
        newIndex = Math.max(newIndex, min);
        newIndex = Math.min(newIndex, endIndex);

        // Insert at new index.
        this._drawList.splice(newIndex, 0, drawableID);
        return newIndex;
      }
      return null;
    }

    /**
     * Draw all current drawables and present the frame on the canvas.
     */
  }, {
    key: "draw",
    value: function draw() {
      this._doExitDrawRegion();
      var gl = this._gl;
      twgl.bindFramebufferInfo(gl, null);
      gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
      gl.clearColor.apply(gl, _toConsumableArray(this._backgroundColor4f));
      gl.clear(gl.COLOR_BUFFER_BIT);
      this._drawThese(this._drawList, ShaderManager.DRAW_MODE.default, this._projection, {
        framebufferWidth: gl.canvas.width,
        framebufferHeight: gl.canvas.height
      });
      if (this._snapshotCallbacks.length > 0) {
        var snapshot = gl.canvas.toDataURL();
        this._snapshotCallbacks.forEach(function (cb) {
          return cb(snapshot);
        });
        this._snapshotCallbacks = [];
      }
    }

    /**
     * Get the precise bounds for a Drawable.
     * @param {int} drawableID ID of Drawable to get bounds for.
     * @return {object} Bounds for a tight box around the Drawable.
     */
  }, {
    key: "getBounds",
    value: function getBounds(drawableID) {
      var drawable = this._allDrawables[drawableID];
      // Tell the Drawable about its updated convex hull, if necessary.
      if (drawable.needsConvexHullPoints()) {
        var points = this._getConvexHullPointsForDrawable(drawableID);
        drawable.setConvexHullPoints(points);
      }
      var bounds = drawable.getFastBounds();
      // In debug mode, draw the bounds.
      if (this._debugCanvas) {
        var gl = this._gl;
        this._debugCanvas.width = gl.canvas.width;
        this._debugCanvas.height = gl.canvas.height;
        var context = this._debugCanvas.getContext('2d');
        context.drawImage(gl.canvas, 0, 0);
        context.strokeStyle = '#FF0000';
        var pr = window.devicePixelRatio;
        context.strokeRect(pr * (bounds.left + this._nativeSize[0] / 2), pr * (-bounds.top + this._nativeSize[1] / 2), pr * (bounds.right - bounds.left), pr * (-bounds.bottom + bounds.top));
      }
      return bounds;
    }

    /**
     * Get the precise bounds for a Drawable around the top slice.
     * Used for positioning speech bubbles more closely to the sprite.
     * @param {int} drawableID ID of Drawable to get bubble bounds for.
     * @return {object} Bounds for a tight box around the Drawable top slice.
     */
  }, {
    key: "getBoundsForBubble",
    value: function getBoundsForBubble(drawableID) {
      var drawable = this._allDrawables[drawableID];
      // Tell the Drawable about its updated convex hull, if necessary.
      if (drawable.needsConvexHullPoints()) {
        var points = this._getConvexHullPointsForDrawable(drawableID);
        drawable.setConvexHullPoints(points);
      }
      var bounds = drawable.getBoundsForBubble();
      // In debug mode, draw the bounds.
      if (this._debugCanvas) {
        var gl = this._gl;
        this._debugCanvas.width = gl.canvas.width;
        this._debugCanvas.height = gl.canvas.height;
        var context = this._debugCanvas.getContext('2d');
        context.drawImage(gl.canvas, 0, 0);
        context.strokeStyle = '#FF0000';
        var pr = window.devicePixelRatio;
        context.strokeRect(pr * (bounds.left + this._nativeSize[0] / 2), pr * (-bounds.top + this._nativeSize[1] / 2), pr * (bounds.right - bounds.left), pr * (-bounds.bottom + bounds.top));
      }
      return bounds;
    }

    /**
     * Get the current skin (costume) size of a Drawable.
     * @param {int} drawableID The ID of the Drawable to measure.
     * @return {Array<number>} Skin size, width and height.
     */
  }, {
    key: "getCurrentSkinSize",
    value: function getCurrentSkinSize(drawableID) {
      var drawable = this._allDrawables[drawableID];
      return this.getSkinSize(drawable.skin.id);
    }

    /**
     * Get the size of a skin by ID.
     * @param {int} skinID The ID of the Skin to measure.
     * @return {Array<number>} Skin size, width and height.
     */
  }, {
    key: "getSkinSize",
    value: function getSkinSize(skinID) {
      var skin = this._allSkins[skinID];
      return skin.size;
    }

    /**
     * Get the rotation center of a skin by ID.
     * @param {int} skinID The ID of the Skin
     * @return {Array<number>} The rotationCenterX and rotationCenterY
     */
  }, {
    key: "getSkinRotationCenter",
    value: function getSkinRotationCenter(skinID) {
      var skin = this._allSkins[skinID];
      return skin.calculateRotationCenter();
    }

    /**
     * Check if a particular Drawable is touching a particular color.
     * Unlike touching drawable, if the "tester" is invisble, we will still test.
     * @param {int} drawableID The ID of the Drawable to check.
     * @param {Array<int>} color3b Test if the Drawable is touching this color.
     * @param {Array<int>} [mask3b] Optionally mask the check to this part of Drawable.
     * @returns {boolean} True iff the Drawable is touching the color.
     */
  }, {
    key: "isTouchingColor",
    value: function isTouchingColor(drawableID, color3b, mask3b) {
      var candidates = this._candidatesTouching(drawableID, this._visibleDrawList);
      var bounds;
      if (colorMatches(color3b, this._backgroundColor3b, 0)) {
        // If the color we're checking for is the background color, don't confine the check to
        // candidate drawables' bounds--since the background spans the entire stage, we must check
        // everything that lies inside the drawable.
        bounds = this._touchingBounds(drawableID);
        // e.g. empty costume, or off the stage
        if (bounds === null) return false;
      } else if (candidates.length === 0) {
        // If not checking for the background color, we can return early if there are no candidate drawables.
        return false;
      } else {
        bounds = this._candidatesBounds(candidates);
      }
      var maxPixelsForCPU = this._getMaxPixelsForCPU();
      var debugCanvasContext = this._debugCanvas && this._debugCanvas.getContext('2d');
      if (debugCanvasContext) {
        this._debugCanvas.width = bounds.width;
        this._debugCanvas.height = bounds.height;
      }

      // if there are just too many pixels to CPU render efficiently, we need to let readPixels happen
      if (bounds.width * bounds.height * (candidates.length + 1) >= maxPixelsForCPU) {
        this._isTouchingColorGpuStart(drawableID, candidates.map(function (_ref) {
          var id = _ref.id;
          return id;
        }).reverse(), bounds, color3b, mask3b);
      }
      var drawable = this._allDrawables[drawableID];
      var point = __isTouchingDrawablesPoint;
      var color = __touchingColor;
      var hasMask = Boolean(mask3b);
      drawable.updateCPURenderAttributes();

      // Masked drawable ignores ghost effect
      var effectMask = ~ShaderManager.EFFECT_INFO.ghost.mask;

      // Scratch Space - +y is top
      for (var y = bounds.bottom; y <= bounds.top; y++) {
        if (bounds.width * (y - bounds.bottom) * (candidates.length + 1) >= maxPixelsForCPU) {
          return this._isTouchingColorGpuFin(bounds, color3b, y - bounds.bottom);
        }
        for (var x = bounds.left; x <= bounds.right; x++) {
          point[1] = y;
          point[0] = x;
          // if we use a mask, check our sample color...
          if (hasMask ? maskMatches(Drawable.sampleColor4b(point, drawable, color, effectMask), mask3b) : drawable.isTouching(point)) {
            RenderWebGL.sampleColor3b(point, candidates, color);
            if (debugCanvasContext) {
              debugCanvasContext.fillStyle = "rgb(".concat(color[0], ",").concat(color[1], ",").concat(color[2], ")");
              debugCanvasContext.fillRect(x - bounds.left, bounds.bottom - y, 1, 1);
            }
            // ...and the target color is drawn at this pixel
            if (colorMatches(color, color3b, 0)) {
              return true;
            }
          }
        }
      }
      return false;
    }
  }, {
    key: "_getMaxPixelsForCPU",
    value: function _getMaxPixelsForCPU() {
      switch (this._useGpuMode) {
        case RenderWebGL.UseGpuModes.ForceCPU:
          return Infinity;
        case RenderWebGL.UseGpuModes.ForceGPU:
          return 0;
        case RenderWebGL.UseGpuModes.Automatic:
        default:
          return __cpuTouchingColorPixelCount;
      }
    }
  }, {
    key: "_enterDrawBackground",
    value: function _enterDrawBackground() {
      var gl = this.gl;
      var currentShader = this._shaderManager.getShader(ShaderManager.DRAW_MODE.background, 0);
      gl.disable(gl.BLEND);
      gl.useProgram(currentShader.program);
      twgl.setBuffersAndAttributes(gl, currentShader, this._bufferInfo);
    }
  }, {
    key: "_exitDrawBackground",
    value: function _exitDrawBackground() {
      var gl = this.gl;
      gl.enable(gl.BLEND);
    }
  }, {
    key: "_isTouchingColorGpuStart",
    value: function _isTouchingColorGpuStart(drawableID, candidateIDs, bounds, color3b, mask3b) {
      this._doExitDrawRegion();
      var gl = this._gl;
      twgl.bindFramebufferInfo(gl, this._queryBufferInfo);

      // Limit size of viewport to the bounds around the target Drawable,
      // and create the projection matrix for the draw.
      gl.viewport(0, 0, bounds.width, bounds.height);
      var projection = twgl.m4.ortho(bounds.left, bounds.right, bounds.top, bounds.bottom, -1, 1);

      // Clear the query buffer to fully transparent. This will be the color of pixels that fail the stencil test.
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
      var extraUniforms;
      if (mask3b) {
        extraUniforms = {
          u_colorMask: [mask3b[0] / 255, mask3b[1] / 255, mask3b[2] / 255],
          u_colorMaskTolerance: MASK_TOUCHING_COLOR_TOLERANCE / 255
        };
      }
      try {
        // Using the stencil buffer, mask out the drawing to either the drawable's alpha channel
        // or pixels of the drawable which match the mask color, depending on whether a mask color is given.
        // Masked-out pixels will not be checked.
        gl.enable(gl.STENCIL_TEST);
        gl.stencilFunc(gl.ALWAYS, 1, 1);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);
        gl.colorMask(false, false, false, false);
        this._drawThese([drawableID], mask3b ? ShaderManager.DRAW_MODE.colorMask : ShaderManager.DRAW_MODE.silhouette, projection, {
          extraUniforms: extraUniforms,
          ignoreVisibility: true,
          // Touching color ignores sprite visibility,
          effectMask: ~ShaderManager.EFFECT_INFO.ghost.mask
        });
        gl.stencilFunc(gl.EQUAL, 1, 1);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.colorMask(true, true, true, true);

        // Draw the background as a quad. Drawing a background with gl.clear will not mask to the stenciled area.
        this.enterDrawRegion(this._backgroundDrawRegionId);
        var uniforms = {
          u_backgroundColor: this._backgroundColor4f
        };
        var currentShader = this._shaderManager.getShader(ShaderManager.DRAW_MODE.background, 0);
        twgl.setUniforms(currentShader, uniforms);
        twgl.drawBufferInfo(gl, this._bufferInfo, gl.TRIANGLES);

        // Draw the candidate drawables on top of the background.
        this._drawThese(candidateIDs, ShaderManager.DRAW_MODE.default, projection, {
          idFilterFunc: function idFilterFunc(testID) {
            return testID !== drawableID;
          }
        });
      } finally {
        gl.colorMask(true, true, true, true);
        gl.disable(gl.STENCIL_TEST);
        this._doExitDrawRegion();
      }
    }
  }, {
    key: "_isTouchingColorGpuFin",
    value: function _isTouchingColorGpuFin(bounds, color3b, stop) {
      var gl = this._gl;
      var pixels = new Uint8Array(Math.floor(bounds.width * (bounds.height - stop) * 4));
      gl.readPixels(0, 0, bounds.width, bounds.height - stop, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
      if (this._debugCanvas) {
        this._debugCanvas.width = bounds.width;
        this._debugCanvas.height = bounds.height;
        var context = this._debugCanvas.getContext('2d');
        var imageData = context.getImageData(0, 0, bounds.width, bounds.height - stop);
        imageData.data.set(pixels);
        context.putImageData(imageData, 0, 0);
      }
      for (var pixelBase = 0; pixelBase < pixels.length; pixelBase += 4) {
        // Transparent pixels are masked (either by the drawable's alpha channel or color mask).
        if (pixels[pixelBase + 3] !== 0 && colorMatches(color3b, pixels, pixelBase)) {
          return true;
        }
      }
      return false;
    }

    /**
     * Check if a particular Drawable is touching any in a set of Drawables.
     * @param {int} drawableID The ID of the Drawable to check.
     * @param {?Array<int>} candidateIDs The Drawable IDs to check, otherwise all visible drawables in the renderer
     * @returns {boolean} True if the Drawable is touching one of candidateIDs.
     */
  }, {
    key: "isTouchingDrawables",
    value: function isTouchingDrawables(drawableID) {
      var _this3 = this;
      var candidateIDs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._drawList;
      var candidates = this._candidatesTouching(drawableID,
      // even if passed an invisible drawable, we will NEVER touch it!
      candidateIDs.filter(function (id) {
        return _this3._allDrawables[id]._visible;
      }));
      // if we are invisble we don't touch anything.
      if (candidates.length === 0 || !this._allDrawables[drawableID]._visible) {
        return false;
      }

      // Get the union of all the candidates intersections.
      var bounds = this._candidatesBounds(candidates);
      var drawable = this._allDrawables[drawableID];
      var point = __isTouchingDrawablesPoint;
      drawable.updateCPURenderAttributes();

      // This is an EXTREMELY brute force collision detector, but it is
      // still faster than asking the GPU to give us the pixels.
      for (var x = bounds.left; x <= bounds.right; x++) {
        // Scratch Space - +y is top
        point[0] = x;
        for (var y = bounds.bottom; y <= bounds.top; y++) {
          point[1] = y;
          if (drawable.isTouching(point)) {
            for (var index = 0; index < candidates.length; index++) {
              if (candidates[index].drawable.isTouching(point)) {
                return true;
              }
            }
          }
        }
      }
      return false;
    }

    /**
     * Convert a client based x/y position on the canvas to a Scratch 3 world space
     * Rectangle.  This creates recangles with a radius to cover selecting multiple
     * scratch pixels with touch / small render areas.
     *
     * @param {int} centerX The client x coordinate of the picking location.
     * @param {int} centerY The client y coordinate of the picking location.
     * @param {int} [width] The client width of the touch event (optional).
     * @param {int} [height] The client width of the touch event (optional).
     * @returns {Rectangle} Scratch world space rectangle, iterate bottom <= top,
     *                      left <= right.
     */
  }, {
    key: "clientSpaceToScratchBounds",
    value: function clientSpaceToScratchBounds(centerX, centerY) {
      var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var gl = this._gl;
      var clientToScratchX = this._nativeSize[0] / gl.canvas.clientWidth;
      var clientToScratchY = this._nativeSize[1] / gl.canvas.clientHeight;
      width *= clientToScratchX;
      height *= clientToScratchY;
      width = Math.max(1, Math.min(Math.round(width), MAX_TOUCH_SIZE[0]));
      height = Math.max(1, Math.min(Math.round(height), MAX_TOUCH_SIZE[1]));
      var x = centerX * clientToScratchX - (width - 1) / 2;
      // + because scratch y is inverted
      var y = centerY * clientToScratchY + (height - 1) / 2;
      var xOfs = width % 2 ? 0 : -0.5;
      // y is offset +0.5
      var yOfs = height % 2 ? 0 : -0.5;
      var bounds = new Rectangle();
      bounds.initFromBounds(Math.floor(this._xLeft + x + xOfs), Math.floor(this._xLeft + x + xOfs + width - 1), Math.ceil(this._yTop - y + yOfs), Math.ceil(this._yTop - y + yOfs + height - 1));
      return bounds;
    }

    /**
     * Determine if the drawable is touching a client based x/y.  Helper method for sensing
     * touching mouse-pointer.  Ignores visibility.
     *
     * @param {int} drawableID The ID of the drawable to check.
     * @param {int} centerX The client x coordinate of the picking location.
     * @param {int} centerY The client y coordinate of the picking location.
     * @param {int} [touchWidth] The client width of the touch event (optional).
     * @param {int} [touchHeight] The client height of the touch event (optional).
     * @returns {boolean} If the drawable has any pixels that would draw in the touch area
     */
  }, {
    key: "drawableTouching",
    value: function drawableTouching(drawableID, centerX, centerY, touchWidth, touchHeight) {
      var drawable = this._allDrawables[drawableID];
      if (!drawable) {
        return false;
      }
      var bounds = this.clientSpaceToScratchBounds(centerX, centerY, touchWidth, touchHeight);
      var worldPos = twgl.v3.create();
      drawable.updateCPURenderAttributes();
      for (worldPos[1] = bounds.bottom; worldPos[1] <= bounds.top; worldPos[1]++) {
        for (worldPos[0] = bounds.left; worldPos[0] <= bounds.right; worldPos[0]++) {
          if (drawable.isTouching(worldPos)) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * Detect which sprite, if any, is at the given location.
     * This function will pick all drawables that are visible, unless specific
     * candidate drawable IDs are provided.  Used for determining what is clicked
     * or dragged.  Will not select hidden / ghosted sprites.
     *
     * @param {int} centerX The client x coordinate of the picking location.
     * @param {int} centerY The client y coordinate of the picking location.
     * @param {int} [touchWidth] The client width of the touch event (optional).
     * @param {int} [touchHeight] The client height of the touch event (optional).
     * @param {Array<int>} [candidateIDs] The Drawable IDs to pick from, otherwise all visible drawables.
     * @returns {int} The ID of the topmost Drawable under the picking location, or
     * RenderConstants.ID_NONE if there is no Drawable at that location.
     */
  }, {
    key: "pick",
    value: function pick(centerX, centerY, touchWidth, touchHeight, candidateIDs) {
      var _this4 = this;
      var bounds = this.clientSpaceToScratchBounds(centerX, centerY, touchWidth, touchHeight);
      if (bounds.left === -Infinity || bounds.bottom === -Infinity) {
        return false;
      }
      candidateIDs = (candidateIDs || this._drawList).filter(function (id) {
        var drawable = _this4._allDrawables[id];
        // default pick list ignores visible and ghosted sprites.
        if (drawable.getVisible() && drawable.getUniforms().u_ghost !== 0) {
          var drawableBounds = drawable.getFastBounds();
          var inRange = bounds.intersects(drawableBounds);
          if (!inRange) return false;
          drawable.updateCPURenderAttributes();
          return true;
        }
        return false;
      });
      if (candidateIDs.length === 0) {
        return false;
      }
      var hits = [];
      var worldPos = twgl.v3.create(0, 0, 0);
      // Iterate over the scratch pixels and check if any candidate can be
      // touched at that point.
      for (worldPos[1] = bounds.bottom; worldPos[1] <= bounds.top; worldPos[1]++) {
        for (worldPos[0] = bounds.left; worldPos[0] <= bounds.right; worldPos[0]++) {
          // Check candidates in the reverse order they would have been
          // drawn. This will determine what candiate's silhouette pixel
          // would have been drawn at the point.
          for (var d = candidateIDs.length - 1; d >= 0; d--) {
            var id = candidateIDs[d];
            var drawable = this._allDrawables[id];
            if (drawable.isTouching(worldPos)) {
              hits[id] = (hits[id] || 0) + 1;
              break;
            }
          }
        }
      }

      // Bias toward selecting anything over nothing
      hits[RenderConstants.ID_NONE] = 0;
      var hit = RenderConstants.ID_NONE;
      for (var hitID in hits) {
        if (Object.prototype.hasOwnProperty.call(hits, hitID) && hits[hitID] > hits[hit]) {
          hit = hitID;
        }
      }
      return Number(hit);
    }

    /**
     * @typedef DrawableExtraction
     * @property {ImageData} data Raw pixel data for the drawable
     * @property {number} x The x coordinate of the drawable's bounding box's top-left corner, in 'CSS pixels'
     * @property {number} y The y coordinate of the drawable's bounding box's top-left corner, in 'CSS pixels'
     * @property {number} width The drawable's bounding box width, in 'CSS pixels'
     * @property {number} height The drawable's bounding box height, in 'CSS pixels'
     */

    /**
     * Return a drawable's pixel data and bounds in screen space.
     * @param {int} drawableID The ID of the drawable to get pixel data for
     * @return {DrawableExtraction} Data about the picked drawable
     */
  }, {
    key: "extractDrawableScreenSpace",
    value: function extractDrawableScreenSpace(drawableID) {
      var drawable = this._allDrawables[drawableID];
      if (!drawable) throw new Error("Could not extract drawable with ID ".concat(drawableID, "; it does not exist"));
      this._doExitDrawRegion();
      var nativeCenterX = this._nativeSize[0] * 0.5;
      var nativeCenterY = this._nativeSize[1] * 0.5;
      var scratchBounds = drawable.getFastBounds();
      var canvas = this.canvas;
      // Ratio of the screen-space scale of the stage's canvas to the "native size" of the stage
      var scaleFactor = canvas.width / this._nativeSize[0];

      // Bounds of the extracted drawable, in "canvas pixel space"
      // (origin is 0, 0, destination is the canvas width, height).
      var canvasSpaceBounds = new Rectangle();
      canvasSpaceBounds.initFromBounds((scratchBounds.left + nativeCenterX) * scaleFactor, (scratchBounds.right + nativeCenterX) * scaleFactor,
      // in "canvas space", +y is down, but Rectangle methods assume bottom < top, so swap them
      (nativeCenterY - scratchBounds.top) * scaleFactor, (nativeCenterY - scratchBounds.bottom) * scaleFactor);
      canvasSpaceBounds.snapToInt();

      // undo the transformation to transform the bounds, snapped to "canvas-pixel space", back to "Scratch space"
      // We have to transform -> snap -> invert transform so that the "Scratch-space" bounds are snapped in
      // "canvas-pixel space".
      scratchBounds.initFromBounds(canvasSpaceBounds.left / scaleFactor - nativeCenterX, canvasSpaceBounds.right / scaleFactor - nativeCenterX, nativeCenterY - canvasSpaceBounds.top / scaleFactor, nativeCenterY - canvasSpaceBounds.bottom / scaleFactor);
      var gl = this._gl;

      // Set a reasonable max limit width and height for the bufferInfo bounds
      var maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
      var clampedWidth = Math.min(MAX_EXTRACTED_DRAWABLE_DIMENSION, canvasSpaceBounds.width, maxTextureSize);
      var clampedHeight = Math.min(MAX_EXTRACTED_DRAWABLE_DIMENSION, canvasSpaceBounds.height, maxTextureSize);

      // Make a new bufferInfo since this._queryBufferInfo is limited to 480x360
      var bufferInfo = twgl.createFramebufferInfo(gl, [{
        format: gl.RGBA
      }], clampedWidth, clampedHeight);
      try {
        twgl.bindFramebufferInfo(gl, bufferInfo);

        // Limit size of viewport to the bounds around the target Drawable,
        // and create the projection matrix for the draw.
        gl.viewport(0, 0, clampedWidth, clampedHeight);
        var projection = twgl.m4.ortho(scratchBounds.left, scratchBounds.right, scratchBounds.top, scratchBounds.bottom, -1, 1);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        this._drawThese([drawableID], ShaderManager.DRAW_MODE.straightAlpha, projection, {
          // Don't apply the ghost effect. TODO: is this an intentional design decision?
          effectMask: ~ShaderManager.EFFECT_INFO.ghost.mask,
          // We're doing this in screen-space, so the framebuffer dimensions should be those of the canvas in
          // screen-space. This is used to ensure SVG skins are rendered at the proper resolution.
          framebufferWidth: canvas.width,
          framebufferHeight: canvas.height
        });
        var data = new Uint8Array(Math.floor(clampedWidth * clampedHeight * 4));
        gl.readPixels(0, 0, clampedWidth, clampedHeight, gl.RGBA, gl.UNSIGNED_BYTE, data);
        // readPixels can only read into a Uint8Array, but ImageData has to take a Uint8ClampedArray.
        // We can share the same underlying buffer between them to avoid having to copy any data.
        var imageData = new ImageData(new Uint8ClampedArray(data.buffer), clampedWidth, clampedHeight);

        // On high-DPI devices, the canvas' width (in canvas pixels) will be larger than its width in CSS pixels.
        // We want to return the CSS-space bounds,
        // so take into account the ratio between the canvas' pixel dimensions and its layout dimensions.
        // This is usually the same as 1 / window.devicePixelRatio, but if e.g. you zoom your browser window without
        // the canvas resizing, then it'll differ.
        var ratio = canvas.getBoundingClientRect().width / canvas.width;
        return {
          imageData: imageData,
          x: canvasSpaceBounds.left * ratio,
          y: canvasSpaceBounds.bottom * ratio,
          width: canvasSpaceBounds.width * ratio,
          height: canvasSpaceBounds.height * ratio
        };
      } finally {
        gl.deleteFramebuffer(bufferInfo.framebuffer);
      }
    }

    /**
     * @typedef ColorExtraction
     * @property {Uint8Array} data Raw pixel data for the drawable
     * @property {int} width Drawable bounding box width
     * @property {int} height Drawable bounding box height
     * @property {object} color Color object with RGBA properties at picked location
     */

    /**
     * Return drawable pixel data and color at a given position
     * @param {int} x The client x coordinate of the picking location.
     * @param {int} y The client y coordinate of the picking location.
     * @param {int} radius The client radius to extract pixels with.
     * @return {?ColorExtraction} Data about the picked color
     */
  }, {
    key: "extractColor",
    value: function extractColor(x, y, radius) {
      this._doExitDrawRegion();
      var scratchX = Math.round(this._nativeSize[0] * (x / this._gl.canvas.clientWidth - 0.5));
      var scratchY = Math.round(-this._nativeSize[1] * (y / this._gl.canvas.clientHeight - 0.5));
      var gl = this._gl;
      twgl.bindFramebufferInfo(gl, this._queryBufferInfo);
      var bounds = new Rectangle();
      bounds.initFromBounds(scratchX - radius, scratchX + radius, scratchY - radius, scratchY + radius);
      var pickX = scratchX - bounds.left;
      var pickY = bounds.top - scratchY;
      gl.viewport(0, 0, bounds.width, bounds.height);
      var projection = twgl.m4.ortho(bounds.left, bounds.right, bounds.top, bounds.bottom, -1, 1);
      gl.clearColor.apply(gl, _toConsumableArray(this._backgroundColor4f));
      gl.clear(gl.COLOR_BUFFER_BIT);
      this._drawThese(this._drawList, ShaderManager.DRAW_MODE.default, projection);
      var data = new Uint8Array(Math.floor(bounds.width * bounds.height * 4));
      gl.readPixels(0, 0, bounds.width, bounds.height, gl.RGBA, gl.UNSIGNED_BYTE, data);
      var pixelBase = Math.floor(4 * (pickY * bounds.width + pickX));
      var color = {
        r: data[pixelBase],
        g: data[pixelBase + 1],
        b: data[pixelBase + 2],
        a: data[pixelBase + 3]
      };
      if (this._debugCanvas) {
        this._debugCanvas.width = bounds.width;
        this._debugCanvas.height = bounds.height;
        var ctx = this._debugCanvas.getContext('2d');
        var imageData = ctx.createImageData(bounds.width, bounds.height);
        imageData.data.set(data);
        ctx.putImageData(imageData, 0, 0);
        ctx.strokeStyle = 'black';
        ctx.fillStyle = "rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(color.a, ")");
        ctx.rect(pickX - 4, pickY - 4, 8, 8);
        ctx.fill();
        ctx.stroke();
      }
      return {
        data: data,
        width: bounds.width,
        height: bounds.height,
        color: color
      };
    }

    /**
     * Get the candidate bounding box for a touching query.
     * @param {int} drawableID ID for drawable of query.
     * @return {?Rectangle} Rectangle bounds for touching query, or null.
     */
  }, {
    key: "_touchingBounds",
    value: function _touchingBounds(drawableID) {
      var drawable = this._allDrawables[drawableID];

      /** @todo remove this once URL-based skin setting is removed. */
      if (!drawable.skin || !drawable.skin.getTexture([100, 100])) return null;
      var bounds = drawable.getFastBounds();

      // Limit queries to the stage size.
      bounds.clamp(this._xLeft, this._xRight, this._yBottom, this._yTop);

      // Use integer coordinates for queries - weird things happen
      // when you provide float width/heights to gl.viewport and projection.
      bounds.snapToInt();
      if (bounds.width === 0 || bounds.height === 0) {
        // No space to query.
        return null;
      }
      return bounds;
    }

    /**
     * Filter a list of candidates for a touching query into only those that
     * could possibly intersect the given bounds.
     * @param {int} drawableID - ID for drawable of query.
     * @param {Array<int>} candidateIDs - Candidates for touching query.
     * @return {?Array< {id, drawable, intersection} >} Filtered candidates with useful data.
     */
  }, {
    key: "_candidatesTouching",
    value: function _candidatesTouching(drawableID, candidateIDs) {
      var bounds = this._touchingBounds(drawableID);
      var result = [];
      if (bounds === null) {
        return result;
      }
      // iterate through the drawables list BACKWARDS - we want the top most item to be the first we check
      for (var index = candidateIDs.length - 1; index >= 0; index--) {
        var id = candidateIDs[index];
        if (id !== drawableID) {
          var drawable = this._allDrawables[id];
          // Text bubbles aren't considered in "touching" queries
          if (drawable.skin instanceof TextBubbleSkin) continue;
          if (drawable.skin && drawable._visible) {
            // Update the CPU position data
            drawable.updateCPURenderAttributes();
            var candidateBounds = drawable.getFastBounds();

            // Push bounds out to integers. If a drawable extends out into half a pixel, that half-pixel still
            // needs to be tested. Plus, in some areas we construct another rectangle from the union of these,
            // and iterate over its pixels (width * height). Turns out that doesn't work so well when the
            // width/height aren't integers.
            candidateBounds.snapToInt();
            if (bounds.intersects(candidateBounds)) {
              result.push({
                id: id,
                drawable: drawable,
                intersection: Rectangle.intersect(bounds, candidateBounds)
              });
            }
          }
        }
      }
      return result;
    }

    /**
     * Helper to get the union bounds from a set of candidates returned from the above method
     * @private
     * @param {Array<object>} candidates info from _candidatesTouching
     * @return {Rectangle} the outer bounding box union
     */
  }, {
    key: "_candidatesBounds",
    value: function _candidatesBounds(candidates) {
      return candidates.reduce(function (memo, _ref2) {
        var intersection = _ref2.intersection;
        if (!memo) {
          return intersection;
        }
        // store the union of the two rectangles in our static rectangle instance
        return Rectangle.union(memo, intersection, __candidatesBounds);
      }, null);
    }

    /**
     * Update a drawable's skin.
     * @param {number} drawableID The drawable's id.
     * @param {number} skinId The skin to update to.
     */
  }, {
    key: "updateDrawableSkinId",
    value: function updateDrawableSkinId(drawableID, skinId) {
      var drawable = this._allDrawables[drawableID];
      // TODO: https://github.com/LLK/scratch-vm/issues/2288
      if (!drawable) return;
      drawable.skin = this._allSkins[skinId];
    }

    /**
     * Update a drawable's position.
     * @param {number} drawableID The drawable's id.
     * @param {Array.<number>} position The new position.
     */
  }, {
    key: "updateDrawablePosition",
    value: function updateDrawablePosition(drawableID, position) {
      var drawable = this._allDrawables[drawableID];
      // TODO: https://github.com/LLK/scratch-vm/issues/2288
      if (!drawable) return;
      drawable.updatePosition(position);
    }

    /**
     * Update a drawable's direction.
     * @param {number} drawableID The drawable's id.
     * @param {number} direction A new direction.
     */
  }, {
    key: "updateDrawableDirection",
    value: function updateDrawableDirection(drawableID, direction) {
      var drawable = this._allDrawables[drawableID];
      // TODO: https://github.com/LLK/scratch-vm/issues/2288
      if (!drawable) return;
      drawable.updateDirection(direction);
    }

    /**
     * Update a drawable's scale.
     * @param {number} drawableID The drawable's id.
     * @param {Array.<number>} scale A new scale.
     */
  }, {
    key: "updateDrawableScale",
    value: function updateDrawableScale(drawableID, scale) {
      var drawable = this._allDrawables[drawableID];
      // TODO: https://github.com/LLK/scratch-vm/issues/2288
      if (!drawable) return;
      drawable.updateScale(scale);
    }

    /**
     * Update a drawable's direction and scale together.
     * @param {number} drawableID The drawable's id.
     * @param {number} direction A new direction.
     * @param {Array.<number>} scale A new scale.
     */
  }, {
    key: "updateDrawableDirectionScale",
    value: function updateDrawableDirectionScale(drawableID, direction, scale) {
      var drawable = this._allDrawables[drawableID];
      // TODO: https://github.com/LLK/scratch-vm/issues/2288
      if (!drawable) return;
      drawable.updateDirection(direction);
      drawable.updateScale(scale);
    }

    /**
     * Update a drawable's visibility.
     * @param {number} drawableID The drawable's id.
     * @param {boolean} visible Will the drawable be visible?
     */
  }, {
    key: "updateDrawableVisible",
    value: function updateDrawableVisible(drawableID, visible) {
      var drawable = this._allDrawables[drawableID];
      // TODO: https://github.com/LLK/scratch-vm/issues/2288
      if (!drawable) return;
      drawable.updateVisible(visible);
    }

    /**
     * Update a drawable's visual effect.
     * @param {number} drawableID The drawable's id.
     * @param {string} effectName The effect to change.
     * @param {number} value A new effect value.
     */
  }, {
    key: "updateDrawableEffect",
    value: function updateDrawableEffect(drawableID, effectName, value) {
      var drawable = this._allDrawables[drawableID];
      // TODO: https://github.com/LLK/scratch-vm/issues/2288
      if (!drawable) return;
      drawable.updateEffect(effectName, value);
    }

    /**
     * Update the position, direction, scale, or effect properties of this Drawable.
     * @deprecated Use specific updateDrawable* methods instead.
     * @param {int} drawableID The ID of the Drawable to update.
     * @param {object.<string,*>} properties The new property values to set.
     */
  }, {
    key: "updateDrawableProperties",
    value: function updateDrawableProperties(drawableID, properties) {
      var drawable = this._allDrawables[drawableID];
      if (!drawable) {
        /**
         * @todo(https://github.com/LLK/scratch-vm/issues/2288) fix whatever's wrong in the VM which causes this, then add a warning or throw here.
         * Right now this happens so much on some projects that a warning or exception here can hang the browser.
         */
        return;
      }
      if ('skinId' in properties) {
        this.updateDrawableSkinId(drawableID, properties.skinId);
      }
      drawable.updateProperties(properties);
    }

    /**
     * Update the position object's x & y members to keep the drawable fenced in view.
     * @param {int} drawableID - The ID of the Drawable to update.
     * @param {Array.<number, number>} position to be fenced - An array of type [x, y]
     * @return {Array.<number, number>} The fenced position as an array [x, y]
     */
  }, {
    key: "getFencedPositionOfDrawable",
    value: function getFencedPositionOfDrawable(drawableID, position) {
      var x = position[0];
      var y = position[1];
      var drawable = this._allDrawables[drawableID];
      if (!drawable) {
        // @todo(https://github.com/LLK/scratch-vm/issues/2288) fix whatever's wrong in the VM which causes this, then add a warning or throw here.
        // Right now this happens so much on some projects that a warning or exception here can hang the browser.
        return [x, y];
      }
      var dx = x - drawable._position[0];
      var dy = y - drawable._position[1];
      var aabb = drawable._skin.getFenceBounds(drawable, __fenceBounds);
      var inset = Math.floor(Math.min(aabb.width, aabb.height) / 2);
      var sx = this._xRight - Math.min(FENCE_WIDTH, inset);
      if (aabb.right + dx < -sx) {
        x = Math.ceil(drawable._position[0] - (sx + aabb.right));
      } else if (aabb.left + dx > sx) {
        x = Math.floor(drawable._position[0] + (sx - aabb.left));
      }
      var sy = this._yTop - Math.min(FENCE_WIDTH, inset);
      if (aabb.top + dy < -sy) {
        y = Math.ceil(drawable._position[1] - (sy + aabb.top));
      } else if (aabb.bottom + dy > sy) {
        y = Math.floor(drawable._position[1] + (sy - aabb.bottom));
      }
      return [x, y];
    }

    /**
     * Clear a pen layer.
     * @param {int} penSkinID - the unique ID of a Pen Skin.
     */
  }, {
    key: "penClear",
    value: function penClear(penSkinID) {
      var skin = /** @type {PenSkin} */this._allSkins[penSkinID];
      skin.clear();
    }

    /**
     * Draw a point on a pen layer.
     * @param {int} penSkinID - the unique ID of a Pen Skin.
     * @param {PenAttributes} penAttributes - how the point should be drawn.
     * @param {number} x - the X coordinate of the point to draw.
     * @param {number} y - the Y coordinate of the point to draw.
     */
  }, {
    key: "penPoint",
    value: function penPoint(penSkinID, penAttributes, x, y) {
      var skin = /** @type {PenSkin} */this._allSkins[penSkinID];
      skin.drawPoint(penAttributes, x, y);
    }

    /**
     * Draw a line on a pen layer.
     * @param {int} penSkinID - the unique ID of a Pen Skin.
     * @param {PenAttributes} penAttributes - how the line should be drawn.
     * @param {number} x0 - the X coordinate of the beginning of the line.
     * @param {number} y0 - the Y coordinate of the beginning of the line.
     * @param {number} x1 - the X coordinate of the end of the line.
     * @param {number} y1 - the Y coordinate of the end of the line.
     */
  }, {
    key: "penLine",
    value: function penLine(penSkinID, penAttributes, x0, y0, x1, y1) {
      var skin = /** @type {PenSkin} */this._allSkins[penSkinID];
      skin.drawLine(penAttributes, x0, y0, x1, y1);
    }

    /**
     * Stamp a Drawable onto a pen layer.
     * @param {int} penSkinID - the unique ID of a Pen Skin.
     * @param {int} stampID - the unique ID of the Drawable to use as the stamp.
     */
  }, {
    key: "penStamp",
    value: function penStamp(penSkinID, stampID) {
      var stampDrawable = this._allDrawables[stampID];
      if (!stampDrawable) {
        return;
      }
      var bounds = this._touchingBounds(stampID);
      if (!bounds) {
        return;
      }
      this._doExitDrawRegion();
      var skin = /** @type {PenSkin} */this._allSkins[penSkinID];
      var gl = this._gl;
      twgl.bindFramebufferInfo(gl, skin._framebuffer);

      // Limit size of viewport to the bounds around the stamp Drawable and create the projection matrix for the draw.
      gl.viewport(this._nativeSize[0] * 0.5 + bounds.left, this._nativeSize[1] * 0.5 - bounds.top, bounds.width, bounds.height);
      var projection = twgl.m4.ortho(bounds.left, bounds.right, bounds.top, bounds.bottom, -1, 1);

      // Draw the stamped sprite onto the PenSkin's framebuffer.
      this._drawThese([stampID], ShaderManager.DRAW_MODE.default, projection, {
        ignoreVisibility: true
      });
      skin._silhouetteDirty = true;
    }

    /* ******
     * Truly internal functions: these support the functions above.
     ********/

    /**
     * Build geometry (vertex and index) buffers.
     * @private
     */
  }, {
    key: "_createGeometry",
    value: function _createGeometry() {
      var quad = {
        a_position: {
          numComponents: 2,
          data: [-0.5, -0.5, 0.5, -0.5, -0.5, 0.5, -0.5, 0.5, 0.5, -0.5, 0.5, 0.5]
        },
        a_texCoord: {
          numComponents: 2,
          data: [1, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 1]
        }
      };
      this._bufferInfo = twgl.createBufferInfoFromArrays(this._gl, quad);
    }

    /**
     * Respond to a change in the "native" rendering size. The native size is used by buffers which are fixed in size
     * regardless of the size of the main render target. This includes the buffers used for queries such as picking and
     * color-touching. The fixed size allows (more) consistent behavior across devices and presentation modes.
     * @param {object} event - The change event.
     * @private
     */
  }, {
    key: "onNativeSizeChanged",
    value: function onNativeSizeChanged(event) {
      var _event$newSize = _slicedToArray(event.newSize, 2),
        width = _event$newSize[0],
        height = _event$newSize[1];
      var gl = this._gl;
      var attachments = [{
        format: gl.RGBA
      }, {
        format: gl.DEPTH_STENCIL
      }];
      if (!this._pickBufferInfo) {
        this._pickBufferInfo = twgl.createFramebufferInfo(gl, attachments, MAX_TOUCH_SIZE[0], MAX_TOUCH_SIZE[1]);
      }

      /** @todo should we create this on demand to save memory? */
      // A 480x360 32-bpp buffer is 675 KiB.
      if (this._queryBufferInfo) {
        twgl.resizeFramebufferInfo(gl, this._queryBufferInfo, attachments, width, height);
      } else {
        this._queryBufferInfo = twgl.createFramebufferInfo(gl, attachments, width, height);
      }
    }

    /**
     * Enter a draw region.
     *
     * A draw region is where multiple draw operations are performed with the
     * same GL state. WebGL performs poorly when it changes state like blend
     * mode. Marking a collection of state values as a "region" the renderer
     * can skip superfluous extra state calls when it is already in that
     * region. Since one region may be entered from within another a exit
     * handle can also be registered that is called when a new region is about
     * to be entered to restore a common inbetween state.
     *
     * @param {any} regionId - id of the region to enter
     * @param {function} enter - handle to call when first entering a region
     * @param {function} exit - handle to call when leaving a region
     */
  }, {
    key: "enterDrawRegion",
    value: function enterDrawRegion(regionId) {
      var enter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : regionId.enter;
      var exit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : regionId.exit;
      if (this._regionId !== regionId) {
        this._doExitDrawRegion();
        this._regionId = regionId;
        enter();
        this._exitRegion = exit;
      }
    }

    /**
     * Forcefully exit the current region returning to a common inbetween GL
     * state.
     */
  }, {
    key: "_doExitDrawRegion",
    value: function _doExitDrawRegion() {
      if (this._exitRegion !== null) {
        this._exitRegion();
      }
      this._exitRegion = null;
      this._regionId = null;
    }

    /**
     * Draw a set of Drawables, by drawable ID
     * @param {Array<int>} drawables The Drawable IDs to draw, possibly this._drawList.
     * @param {ShaderManager.DRAW_MODE} drawMode Draw normally, silhouette, etc.
     * @param {module:twgl/m4.Mat4} projection The projection matrix to use.
     * @param {object} [opts] Options for drawing
     * @param {idFilterFunc} opts.filter An optional filter function.
     * @param {object.<string,*>} opts.extraUniforms Extra uniforms for the shaders.
     * @param {int} opts.effectMask Bitmask for effects to allow
     * @param {boolean} opts.ignoreVisibility Draw all, despite visibility (e.g. stamping, touching color)
     * @param {int} opts.framebufferWidth The width of the framebuffer being drawn onto. Defaults to "native" width
     * @param {int} opts.framebufferHeight The height of the framebuffer being drawn onto. Defaults to "native" height
     * @private
     */
  }, {
    key: "_drawThese",
    value: function _drawThese(drawables, drawMode, projection) {
      var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var gl = this._gl;
      var currentShader = null;
      var framebufferSpaceScaleDiffers = 'framebufferWidth' in opts && 'framebufferHeight' in opts && opts.framebufferWidth !== this._nativeSize[0] && opts.framebufferHeight !== this._nativeSize[1];
      var numDrawables = drawables.length;
      for (var drawableIndex = 0; drawableIndex < numDrawables; ++drawableIndex) {
        var drawableID = drawables[drawableIndex];

        // If we have a filter, check whether the ID fails
        if (opts.filter && !opts.filter(drawableID)) continue;
        var drawable = this._allDrawables[drawableID];
        /** @todo check if drawable is inside the viewport before anything else */

        // Hidden drawables (e.g., by a "hide" block) are not drawn unless
        // the ignoreVisibility flag is used (e.g. for stamping or touchingColor).
        if (!drawable.getVisible() && !opts.ignoreVisibility) continue;

        // drawableScale is the "framebuffer-pixel-space" scale of the drawable, as percentages of the drawable's
        // "native size" (so 100 = same as skin's "native size", 200 = twice "native size").
        // If the framebuffer dimensions are the same as the stage's "native" size, there's no need to calculate it.
        var drawableScale = framebufferSpaceScaleDiffers ? [drawable.scale[0] * opts.framebufferWidth / this._nativeSize[0], drawable.scale[1] * opts.framebufferHeight / this._nativeSize[1]] : drawable.scale;

        // If the skin or texture isn't ready yet, skip it.
        if (!drawable.skin || !drawable.skin.getTexture(drawableScale)) continue;
        var uniforms = {};
        var effectBits = drawable.enabledEffects;
        effectBits &= Object.prototype.hasOwnProperty.call(opts, 'effectMask') ? opts.effectMask : effectBits;
        var newShader = this._shaderManager.getShader(drawMode, effectBits);

        // Manually perform region check. Do not create functions inside a
        // loop.
        if (this._regionId !== newShader) {
          this._doExitDrawRegion();
          this._regionId = newShader;
          currentShader = newShader;
          gl.useProgram(currentShader.program);
          twgl.setBuffersAndAttributes(gl, currentShader, this._bufferInfo);
          Object.assign(uniforms, {
            u_projectionMatrix: projection
          });
        }
        Object.assign(uniforms, drawable.skin.getUniforms(drawableScale), drawable.getUniforms());

        // Apply extra uniforms after the Drawable's, to allow overwriting.
        if (opts.extraUniforms) {
          Object.assign(uniforms, opts.extraUniforms);
        }
        if (uniforms.u_skin) {
          twgl.setTextureParameters(gl, uniforms.u_skin, {
            minMag: drawable.skin.useNearest(drawableScale, drawable) ? gl.NEAREST : gl.LINEAR
          });
        }
        twgl.setUniforms(currentShader, uniforms);
        twgl.drawBufferInfo(gl, this._bufferInfo, gl.TRIANGLES);
      }
      this._regionId = null;
    }

    /**
     * Get the convex hull points for a particular Drawable.
     * To do this, calculate it based on the drawable's Silhouette.
     * @param {int} drawableID The Drawable IDs calculate convex hull for.
     * @return {Array<Array<number>>} points Convex hull points, as [[x, y], ...]
     */
  }, {
    key: "_getConvexHullPointsForDrawable",
    value: function _getConvexHullPointsForDrawable(drawableID) {
      var drawable = this._allDrawables[drawableID];
      var _drawable$skin$size = _slicedToArray(drawable.skin.size, 2),
        width = _drawable$skin$size[0],
        height = _drawable$skin$size[1];
      // No points in the hull if invisible or size is 0.
      if (!drawable.getVisible() || width === 0 || height === 0) {
        return [];
      }
      drawable.updateCPURenderAttributes();

      /**
       * Return the determinant of two vectors, the vector from A to B and the vector from A to C.
       *
       * The determinant is useful in this case to know if AC is counter-clockwise from AB.
       * A positive value means that AC is counter-clockwise from AB. A negative value means AC is clockwise from AB.
       *
       * @param {Float32Array} A A 2d vector in space.
       * @param {Float32Array} B A 2d vector in space.
       * @param {Float32Array} C A 2d vector in space.
       * @return {number} Greater than 0 if counter clockwise, less than if clockwise, 0 if all points are on a line.
       */
      var determinant = function determinant(A, B, C) {
        // AB = B - A
        // AC = C - A
        // det (AB BC) = AB0 * AC1 - AB1 * AC0
        return (B[0] - A[0]) * (C[1] - A[1]) - (B[1] - A[1]) * (C[0] - A[0]);
      };

      // This algorithm for calculating the convex hull somewhat resembles the monotone chain algorithm.
      // The main difference is that instead of sorting the points by x-coordinate, and y-coordinate in case of ties,
      // it goes through them by y-coordinate in the outer loop and x-coordinate in the inner loop.
      // This gives us "left" and "right" hulls, whereas the monotone chain algorithm gives "top" and "bottom" hulls.
      // Adapted from https://github.com/LLK/scratch-flash/blob/dcbeeb59d44c3be911545dfe54d46a32404f8e69/src/scratch/ScratchCostume.as#L369-L413

      var leftHull = [];
      var rightHull = [];

      // While convex hull algorithms usually push and pop values from the list of hull points,
      // here, we keep indices for the "last" point in each array. Any points past these indices are ignored.
      // This is functionally equivalent to pushing and popping from a "stack" of hull points.
      var leftEndPointIndex = -1;
      var rightEndPointIndex = -1;
      var _pixelPos = twgl.v3.create();
      var _effectPos = twgl.v3.create();
      var currentPoint;

      // *Not* Scratch Space-- +y is bottom
      // Loop over all rows of pixels, starting at the top
      for (var y = 0; y < height; y++) {
        _pixelPos[1] = y / height;

        // We start at the leftmost point, then go rightwards until we hit an opaque pixel
        var x = 0;
        for (; x < width; x++) {
          _pixelPos[0] = x / width;
          EffectTransform.transformPoint(drawable, _pixelPos, _effectPos);
          if (drawable.skin.isTouchingLinear(_effectPos)) {
            currentPoint = [x, y];
            break;
          }
        }

        // If we managed to loop all the way through, there are no opaque pixels on this row. Go to the next one
        if (x >= width) {
          continue;
        }

        // Because leftEndPointIndex is initialized to -1, this is skipped for the first two rows.
        // It runs only when there are enough points in the left hull to make at least one line.
        // If appending the current point to the left hull makes a counter-clockwise turn,
        // we want to append the current point. Otherwise, we decrement the index of the "last" hull point until the
        // current point makes a counter-clockwise turn.
        // This decrementing has the same effect as popping from the point list, but is hopefully faster.
        while (leftEndPointIndex > 0) {
          if (determinant(leftHull[leftEndPointIndex], leftHull[leftEndPointIndex - 1], currentPoint) > 0) {
            break;
          } else {
            // leftHull.pop();
            --leftEndPointIndex;
          }
        }

        // This has the same effect as pushing to the point list.
        // This "list head pointer" coding style leaves excess points dangling at the end of the list,
        // but that doesn't matter; we simply won't copy them over to the final hull.

        // leftHull.push(currentPoint);
        leftHull[++leftEndPointIndex] = currentPoint;

        // Now we repeat the process for the right side, looking leftwards for a pixel.
        for (x = width - 1; x >= 0; x--) {
          _pixelPos[0] = x / width;
          EffectTransform.transformPoint(drawable, _pixelPos, _effectPos);
          if (drawable.skin.isTouchingLinear(_effectPos)) {
            currentPoint = [x, y];
            break;
          }
        }

        // Because we're coming at this from the right, it goes clockwise this time.
        while (rightEndPointIndex > 0) {
          if (determinant(rightHull[rightEndPointIndex], rightHull[rightEndPointIndex - 1], currentPoint) < 0) {
            break;
          } else {
            --rightEndPointIndex;
          }
        }
        rightHull[++rightEndPointIndex] = currentPoint;
      }

      // Start off "hullPoints" with the left hull points.
      var hullPoints = leftHull;
      // This is where we get rid of those dangling extra points.
      hullPoints.length = leftEndPointIndex + 1;
      // Add points from the right side in reverse order so all points are ordered clockwise.
      for (var j = rightEndPointIndex; j >= 0; --j) {
        hullPoints.push(rightHull[j]);
      }

      // Simplify boundary points using hull.js.
      // TODO: Remove this; this algorithm already generates convex hulls.
      return hull(hullPoints, Infinity);
    }

    /**
     * Sample a "final" color from an array of drawables at a given scratch space.
     * Will blend any alpha values with the drawables "below" it.
     * @param {twgl.v3} vec Scratch Vector Space to sample
     * @param {Array<Drawables>} drawables A list of drawables with the "top most"
     *              drawable at index 0
     * @param {Uint8ClampedArray} dst The color3b space to store the answer in.
     * @return {Uint8ClampedArray} The dst vector with everything blended down.
     */
  }, {
    key: "requestSnapshot",
    value:
    /**
     * @callback RenderWebGL#snapshotCallback
     * @param {string} dataURI Data URI of the snapshot of the renderer
     */

    /**
     * @param {snapshotCallback} callback Function called in the next frame with the snapshot data
     */
    function requestSnapshot(callback) {
      this._snapshotCallbacks.push(callback);
    }
  }], [{
    key: "isSupported",
    value:
    /**
     * Check if this environment appears to support this renderer before attempting to create an instance.
     * Catching an exception from the constructor is also a valid way to test for (lack of) support.
     * @param {canvas} [optCanvas] - An optional canvas to use for the test. Otherwise a temporary canvas will be used.
     * @returns {boolean} - True if this environment appears to support this renderer, false otherwise.
     */
    function isSupported(optCanvas) {
      try {
        // Create the context the same way that the constructor will: attributes may make the difference.
        return !!RenderWebGL._getContext(optCanvas || document.createElement('canvas'));
      } catch (e) {
        return false;
      }
    }

    /**
     * Ask TWGL to create a rendering context with the attributes used by this renderer.
     * @param {canvas} canvas - attach the context to this canvas.
     * @returns {WebGLRenderingContext} - a TWGL rendering context (backed by either WebGL 1.0 or 2.0).
     * @private
     */
  }, {
    key: "_getContext",
    value: function _getContext(canvas) {
      var contextAttribs = {
        alpha: false,
        stencil: true,
        antialias: false
      };
      // getWebGLContext = try WebGL 1.0 only
      // getContext = try WebGL 2.0 and if that doesn't work, try WebGL 1.0
      // getWebGLContext || getContext = try WebGL 1.0 and if that doesn't work, try WebGL 2.0
      return twgl.getWebGLContext(canvas, contextAttribs) || twgl.getContext(canvas, contextAttribs);
    }
  }, {
    key: "sampleColor3b",
    value: function sampleColor3b(vec, drawables, dst) {
      dst = dst || new Uint8ClampedArray(3);
      dst.fill(0);
      var blendAlpha = 1;
      for (var index = 0; blendAlpha !== 0 && index < drawables.length; index++) {
        /*
        if (left > vec[0] || right < vec[0] ||
            bottom > vec[1] || top < vec[0]) {
            continue;
        }
        */
        Drawable.sampleColor4b(vec, drawables[index].drawable, __blendColor);
        // Equivalent to gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA)
        dst[0] += __blendColor[0] * blendAlpha;
        dst[1] += __blendColor[1] * blendAlpha;
        dst[2] += __blendColor[2] * blendAlpha;
        blendAlpha *= 1 - __blendColor[3] / 255;
      }
      // Backdrop could be transparent, so we need to go to the "clear color" of the
      // draw scene (white) as a fallback if everything was alpha
      dst[0] += blendAlpha * 255;
      dst[1] += blendAlpha * 255;
      dst[2] += blendAlpha * 255;
      return dst;
    }
  }]);
}(EventEmitter); // :3
RenderWebGL.prototype.canHazPixels = RenderWebGL.prototype.extractDrawableScreenSpace;

/**
 * Values for setUseGPU()
 * @enum {string}
 */
RenderWebGL.UseGpuModes = {
  /**
   * Heuristically decide whether to use the GPU path, the CPU path, or a dynamic mixture of the two.
   */
  Automatic: 'Automatic',
  /**
   * Always use the GPU path.
   */
  ForceGPU: 'ForceGPU',
  /**
   * Always use the CPU path.
   */
  ForceCPU: 'ForceCPU'
};
module.exports = RenderWebGL;

/***/ }),

/***/ "./src/SVGSkin.js":
/*!************************!*\
  !*** ./src/SVGSkin.js ***!
  \************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var twgl = __webpack_require__(/*! twgl.js */ "./node_modules/twgl.js/dist/4.x/twgl-full.module.js");
var Skin = __webpack_require__(/*! ./Skin */ "./src/Skin.js");
var _require = __webpack_require__(/*! scratch-svg-renderer */ "./node_modules/scratch-svg-renderer/src/index.js"),
  loadSvgString = _require.loadSvgString,
  serializeSvgToString = _require.serializeSvgToString;
var ShaderManager = __webpack_require__(/*! ./ShaderManager */ "./src/ShaderManager.js");
var MAX_TEXTURE_DIMENSION = 2048;

/**
 * All scaled renderings of the SVG are stored in an array. The 1.0 scale of
 * the SVG is stored at the 8th index. The smallest possible 1 / 256 scale
 * rendering is stored at the 0th index.
 * @const {number}
 */
var INDEX_OFFSET = 8;
var SVGSkin = /*#__PURE__*/function (_Skin) {
  /**
   * Create a new SVG skin.
   * @param {!int} id - The ID for this Skin.
   * @param {!RenderWebGL} renderer - The renderer which will use this skin.
   * @constructor
   * @extends Skin
   */
  function SVGSkin(id, renderer) {
    var _this;
    _classCallCheck(this, SVGSkin);
    _this = _callSuper(this, SVGSkin, [id]);

    /** @type {RenderWebGL} */
    _this._renderer = renderer;

    /** @type {HTMLImageElement} */
    _this._svgImage = document.createElement('img');

    /** @type {boolean} */
    _this._svgImageLoaded = false;

    /** @type {Array<number>} */
    _this._size = [0, 0];

    /** @type {HTMLCanvasElement} */
    _this._canvas = document.createElement('canvas');

    /** @type {CanvasRenderingContext2D} */
    _this._context = _this._canvas.getContext('2d');

    /** @type {Array<WebGLTexture>} */
    _this._scaledMIPs = [];

    /** @type {number} */
    _this._largestMIPScale = 0;

    /**
    * Ratio of the size of the SVG and the max size of the WebGL texture
    * @type {Number}
    */
    _this._maxTextureScale = 1;
    return _this;
  }

  /**
   * Dispose of this object. Do not use it after calling this method.
   */
  _inherits(SVGSkin, _Skin);
  return _createClass(SVGSkin, [{
    key: "dispose",
    value: function dispose() {
      this.resetMIPs();
      _superPropGet(SVGSkin, "dispose", this, 3)([]);
    }

    /**
     * @return {Array<number>} the natural size, in Scratch units, of this skin.
     */
  }, {
    key: "size",
    get: function get() {
      return [this._size[0], this._size[1]];
    }
  }, {
    key: "useNearest",
    value: function useNearest(scale, drawable) {
      // If the effect bits for mosaic, pixelate, whirl, or fisheye are set, use linear
      if ((drawable.enabledEffects & (ShaderManager.EFFECT_INFO.fisheye.mask | ShaderManager.EFFECT_INFO.whirl.mask | ShaderManager.EFFECT_INFO.pixelate.mask | ShaderManager.EFFECT_INFO.mosaic.mask)) !== 0) {
        return false;
      }

      // We can't use nearest neighbor unless we are a multiple of 90 rotation
      if (drawable._direction % 90 !== 0) {
        return false;
      }

      // Because SVG skins' bounding boxes are currently not pixel-aligned, the idea here is to hide blurriness
      // by using nearest-neighbor scaling if one screen-space pixel is "close enough" to one texture pixel.
      // If the scale of the skin is very close to 100 (0.99999 variance is okay I guess)
      // TODO: Make this check more precise. We should use nearest if there's less than one pixel's difference
      // between the screen-space and texture-space sizes of the skin. Mipmaps make this harder because there are
      // multiple textures (and hence multiple texture spaces) and we need to know which one to choose.
      if (Math.abs(scale[0]) > 99 && Math.abs(scale[0]) < 101 && Math.abs(scale[1]) > 99 && Math.abs(scale[1]) < 101) {
        return true;
      }
      return false;
    }

    /**
     * Create a MIP for a given scale.
     * @param {number} scale - The relative size of the MIP
     * @return {SVGMIP} An object that handles creating and updating SVG textures.
     */
  }, {
    key: "createMIP",
    value: function createMIP(scale) {
      var _this$_size = _slicedToArray(this._size, 2),
        width = _this$_size[0],
        height = _this$_size[1];
      this._canvas.width = width * scale;
      this._canvas.height = height * scale;
      if (this._canvas.width <= 0 || this._canvas.height <= 0 ||
      // Even if the canvas at the current scale has a nonzero size, the image's dimensions are floored
      // pre-scaling; e.g. if an image has a width of 0.4 and is being rendered at 3x scale, the canvas will have
      // a width of 1, but the image's width will be rounded down to 0 on some browsers (Firefox) prior to being
      // drawn at that scale, resulting in an IndexSizeError if we attempt to draw it.
      this._svgImage.naturalWidth <= 0 || this._svgImage.naturalHeight <= 0) return _superPropGet(SVGSkin, "getTexture", this, 3)([]);
      this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
      this._context.setTransform(scale, 0, 0, scale, 0, 0);
      this._context.drawImage(this._svgImage, 0, 0);

      // Pull out the ImageData from the canvas. ImageData speeds up
      // updating Silhouette and is better handled by more browsers in
      // regards to memory.
      var textureData = this._context.getImageData(0, 0, this._canvas.width, this._canvas.height);
      var textureOptions = {
        auto: false,
        wrap: this._renderer.gl.CLAMP_TO_EDGE,
        src: textureData,
        premultiplyAlpha: true
      };
      var mip = twgl.createTexture(this._renderer.gl, textureOptions);

      // Check if this is the largest MIP created so far. Currently, silhouettes only get scaled up.
      if (this._largestMIPScale < scale) {
        this._silhouette.update(textureData);
        this._largestMIPScale = scale;
      }
      return mip;
    }
  }, {
    key: "updateSilhouette",
    value: function updateSilhouette() {
      var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [100, 100];
      // Ensure a silhouette exists.
      this.getTexture(scale);
    }

    /**
     * @param {Array<number>} scale - The scaling factors to be used, each in the [0,100] range.
     * @return {WebGLTexture} The GL texture representation of this skin when drawing at the given scale.
     */
  }, {
    key: "getTexture",
    value: function getTexture(scale) {
      // The texture only ever gets uniform scale. Take the larger of the two axes.
      var scaleMax = scale ? Math.max(Math.abs(scale[0]), Math.abs(scale[1])) : 100;
      var requestedScale = Math.min(scaleMax / 100, this._maxTextureScale);

      // Math.ceil(Math.log2(scale)) means we use the "1x" texture at (0.5, 1] scale,
      // the "2x" texture at (1, 2] scale, the "4x" texture at (2, 4] scale, etc.
      // This means that one texture pixel will always be between 0.5x and 1x the size of one rendered pixel,
      // but never bigger than one rendered pixel--this prevents blurriness from blowing up the texture too much.
      var mipLevel = Math.max(Math.ceil(Math.log2(requestedScale)) + INDEX_OFFSET, 0);
      // Can't use bitwise stuff here because we need to handle negative exponents
      var mipScale = Math.pow(2, mipLevel - INDEX_OFFSET);
      if (this._svgImageLoaded && !this._scaledMIPs[mipLevel]) {
        this._scaledMIPs[mipLevel] = this.createMIP(mipScale);
      }
      return this._scaledMIPs[mipLevel] || _superPropGet(SVGSkin, "getTexture", this, 3)([]);
    }

    /**
     * Do a hard reset of the existing MIPs by deleting them.
     */
  }, {
    key: "resetMIPs",
    value: function resetMIPs() {
      var _this2 = this;
      this._scaledMIPs.forEach(function (oldMIP) {
        return _this2._renderer.gl.deleteTexture(oldMIP);
      });
      this._scaledMIPs.length = 0;
      this._largestMIPScale = 0;
    }

    /**
     * Set the contents of this skin to a snapshot of the provided SVG data.
     * @param {string} svgData - new SVG to use.
     * @param {Array<number>} [rotationCenter] - Optional rotation center for the SVG. If not supplied, it will be
     * calculated from the bounding box
     * @fires Skin.event:WasAltered
     */
  }, {
    key: "setSVG",
    value: function setSVG(svgData, rotationCenter) {
      var _this3 = this;
      var svgTag = loadSvgString(svgData);
      var svgText = serializeSvgToString(svgTag, true /* shouldInjectFonts */);
      this._svgImageLoaded = false;
      var _svgTag$viewBox$baseV = svgTag.viewBox.baseVal,
        x = _svgTag$viewBox$baseV.x,
        y = _svgTag$viewBox$baseV.y,
        width = _svgTag$viewBox$baseV.width,
        height = _svgTag$viewBox$baseV.height;
      // While we're setting the size before the image is loaded, this doesn't cause the skin to appear with the wrong
      // size for a few frames while the new image is loading, because we don't emit the `WasAltered` event, telling
      // drawables using this skin to update, until the image is loaded.
      // We need to do this because the VM reads the skin's `size` directly after calling `setSVG`.
      // TODO: return a Promise so that the VM can read the skin's `size` after the image is loaded.
      this._size[0] = width;
      this._size[1] = height;

      // If there is another load already in progress, replace the old onload to effectively cancel the old load
      this._svgImage.onload = function () {
        if (width === 0 || height === 0) {
          _superPropGet(SVGSkin, "setEmptyImageData", _this3, 3)([]);
          return;
        }
        var maxDimension = Math.ceil(Math.max(width, height));
        var testScale = 2;
        for (testScale; maxDimension * testScale <= MAX_TEXTURE_DIMENSION; testScale *= 2) {
          _this3._maxTextureScale = testScale;
        }
        _this3.resetMIPs();
        if (typeof rotationCenter === 'undefined') rotationCenter = _this3.calculateRotationCenter();
        // Compensate for viewbox offset.
        // See https://github.com/LLK/scratch-render/pull/90.
        _this3._rotationCenter[0] = rotationCenter[0] - x;
        _this3._rotationCenter[1] = rotationCenter[1] - y;
        _this3._svgImageLoaded = true;
        _this3.emit(Skin.Events.WasAltered);
      };
      this._svgImage.src = "data:image/svg+xml;utf8,".concat(encodeURIComponent(svgText));
    }
  }]);
}(Skin);
module.exports = SVGSkin;

/***/ }),

/***/ "./src/ShaderManager.js":
/*!******************************!*\
  !*** ./src/ShaderManager.js ***!
  \******************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var twgl = __webpack_require__(/*! twgl.js */ "./node_modules/twgl.js/dist/4.x/twgl-full.module.js");
var ShaderManager = /*#__PURE__*/function () {
  /**
   * @param {WebGLRenderingContext} gl WebGL rendering context to create shaders for
   * @constructor
   */
  function ShaderManager(gl) {
    _classCallCheck(this, ShaderManager);
    this._gl = gl;

    /**
     * The cache of all shaders compiled so far, filled on demand.
     * @type {Object<ShaderManager.DRAW_MODE, Array<ProgramInfo>>}
     * @private
     */
    this._shaderCache = {};
    for (var modeName in ShaderManager.DRAW_MODE) {
      if (Object.prototype.hasOwnProperty.call(ShaderManager.DRAW_MODE, modeName)) {
        this._shaderCache[modeName] = [];
      }
    }
  }

  /**
   * Fetch the shader for a particular set of active effects.
   * Build the shader if necessary.
   * @param {ShaderManager.DRAW_MODE} drawMode Draw normally, silhouette, etc.
   * @param {int} effectBits Bitmask representing the enabled effects.
   * @returns {ProgramInfo} The shader's program info.
   */
  return _createClass(ShaderManager, [{
    key: "getShader",
    value: function getShader(drawMode, effectBits) {
      var cache = this._shaderCache[drawMode];
      if (drawMode === ShaderManager.DRAW_MODE.silhouette) {
        // Silhouette mode isn't affected by these effects.
        effectBits &= ~(ShaderManager.EFFECT_INFO.color.mask | ShaderManager.EFFECT_INFO.brightness.mask);
      }
      var shader = cache[effectBits];
      if (!shader) {
        shader = cache[effectBits] = this._buildShader(drawMode, effectBits);
      }
      return shader;
    }

    /**
     * Build the shader for a particular set of active effects.
     * @param {ShaderManager.DRAW_MODE} drawMode Draw normally, silhouette, etc.
     * @param {int} effectBits Bitmask representing the enabled effects.
     * @returns {ProgramInfo} The new shader's program info.
     * @private
     */
  }, {
    key: "_buildShader",
    value: function _buildShader(drawMode, effectBits) {
      var numEffects = ShaderManager.EFFECTS.length;
      var defines = ["#define DRAW_MODE_".concat(drawMode)];
      for (var index = 0; index < numEffects; ++index) {
        if ((effectBits & 1 << index) !== 0) {
          defines.push("#define ENABLE_".concat(ShaderManager.EFFECTS[index]));
        }
      }
      var definesText = "".concat(defines.join('\n'), "\n");

      /* eslint-disable global-require */
      var vsFullText = definesText + __webpack_require__(/*! raw-loader!./shaders/sprite.vert */ "./node_modules/raw-loader/index.js!./src/shaders/sprite.vert");
      var fsFullText = definesText + __webpack_require__(/*! raw-loader!./shaders/sprite.frag */ "./node_modules/raw-loader/index.js!./src/shaders/sprite.frag");
      /* eslint-enable global-require */

      return twgl.createProgramInfo(this._gl, [vsFullText, fsFullText]);
    }
  }]);
}();
/**
 * @typedef {object} ShaderManager.Effect
 * @prop {int} mask - The bit in 'effectBits' representing the effect.
 * @prop {function} converter - A conversion function which takes a Scratch value (generally in the range
 *   0..100 or -100..100) and maps it to a value useful to the shader. This
 *   mapping may not be reversible.
 * @prop {boolean} shapeChanges - Whether the effect could change the drawn shape.
 */
/**
 * Mapping of each effect name to info about that effect.
 * @enum {ShaderManager.Effect}
 */
ShaderManager.EFFECT_INFO = {
  /** Color effect */
  color: {
    uniformName: 'u_color',
    mask: 1 << 0,
    converter: function converter(x) {
      return x / 200 % 1;
    },
    shapeChanges: false
  },
  /** Fisheye effect */
  fisheye: {
    uniformName: 'u_fisheye',
    mask: 1 << 1,
    converter: function converter(x) {
      return Math.max(0, (x + 100) / 100);
    },
    shapeChanges: true
  },
  /** Whirl effect */
  whirl: {
    uniformName: 'u_whirl',
    mask: 1 << 2,
    converter: function converter(x) {
      return -x * Math.PI / 180;
    },
    shapeChanges: true
  },
  /** Pixelate effect */
  pixelate: {
    uniformName: 'u_pixelate',
    mask: 1 << 3,
    converter: function converter(x) {
      return Math.abs(x) / 10;
    },
    shapeChanges: true
  },
  /** Mosaic effect */
  mosaic: {
    uniformName: 'u_mosaic',
    mask: 1 << 4,
    converter: function converter(x) {
      x = Math.round((Math.abs(x) + 10) / 10);
      /** @todo cap by Math.min(srcWidth, srcHeight) */
      return Math.max(1, Math.min(x, 512));
    },
    shapeChanges: true
  },
  /** Brightness effect */
  brightness: {
    uniformName: 'u_brightness',
    mask: 1 << 5,
    converter: function converter(x) {
      return Math.max(-100, Math.min(x, 100)) / 100;
    },
    shapeChanges: false
  },
  /** Ghost effect */
  ghost: {
    uniformName: 'u_ghost',
    mask: 1 << 6,
    converter: function converter(x) {
      return 1 - Math.max(0, Math.min(x, 100)) / 100;
    },
    shapeChanges: false
  }
};

/**
 * The name of each supported effect.
 * @type {Array}
 */
ShaderManager.EFFECTS = Object.keys(ShaderManager.EFFECT_INFO);

/**
 * The available draw modes.
 * @readonly
 * @enum {string}
 */
ShaderManager.DRAW_MODE = {
  /**
   * Draw normally. Its output will use premultiplied alpha.
   */
  default: 'default',
  /**
   * Draw with non-premultiplied alpha. Useful for reading pixels from GL into an ImageData object.
   */
  straightAlpha: 'straightAlpha',
  /**
   * Draw a silhouette using a solid color.
   */
  silhouette: 'silhouette',
  /**
   * Draw only the parts of the drawable which match a particular color.
   */
  colorMask: 'colorMask',
  /**
   * Draw a line with caps.
   */
  line: 'line',
  /**
   * Draw the background in a certain color. Must sometimes be used instead of gl.clear.
   */
  background: 'background'
};
module.exports = ShaderManager;

/***/ }),

/***/ "./src/Silhouette.js":
/*!***************************!*\
  !*** ./src/Silhouette.js ***!
  \***************************/
/***/ (function(module) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @fileoverview
 * A representation of a Skin's silhouette that can test if a point on the skin
 * renders a pixel where it is drawn.
 */

/**
 * <canvas> element used to update Silhouette data from skin bitmap data.
 * @type {CanvasElement}
 */
var __SilhouetteUpdateCanvas;

// Optimized Math.min and Math.max for integers;
// taken from https://web.archive.org/web/20190716181049/http://guihaire.com/code/?p=549
var intMin = function intMin(i, j) {
  return j ^ (i ^ j) & i - j >> 31;
};
var intMax = function intMax(i, j) {
  return i ^ (i ^ j) & i - j >> 31;
};

/**
 * Internal helper function (in hopes that compiler can inline).  Get a pixel
 * from silhouette data, or 0 if outside it's bounds.
 * @private
 * @param {Silhouette} silhouette - has data width and height
 * @param {number} x - x
 * @param {number} y - y
 * @return {number} Alpha value for x/y position
 */
var getPoint = function getPoint(_ref, x, y) {
  var width = _ref._width,
    height = _ref._height,
    data = _ref._colorData;
  // 0 if outside bounds, otherwise read from data.
  if (x >= width || y >= height || x < 0 || y < 0) {
    return 0;
  }
  return data[(y * width + x) * 4 + 3];
};

/**
 * Memory buffers for doing 4 corner sampling for linear interpolation
 */
var __cornerWork = [new Uint8ClampedArray(4), new Uint8ClampedArray(4), new Uint8ClampedArray(4), new Uint8ClampedArray(4)];

/**
 * Get the color from a given silhouette at an x/y local texture position.
 * Multiply color values by alpha for proper blending.
 * @param {Silhouette} $0 The silhouette to sample.
 * @param {number} x X position of texture [0, width).
 * @param {number} y Y position of texture [0, height).
 * @param {Uint8ClampedArray} dst A color 4b space.
 * @return {Uint8ClampedArray} The dst vector.
 */
var getColor4b = function getColor4b(_ref2, x, y, dst) {
  var width = _ref2._width,
    height = _ref2._height,
    data = _ref2._colorData;
  // Clamp coords to edge, matching GL_CLAMP_TO_EDGE.
  // (See github.com/LLK/scratch-render/blob/954cfff02b08069a082cbedd415c1fecd9b1e4fb/src/BitmapSkin.js#L88)
  x = intMax(0, intMin(x, width - 1));
  y = intMax(0, intMin(y, height - 1));

  // 0 if outside bounds, otherwise read from data.
  if (x >= width || y >= height || x < 0 || y < 0) {
    return dst.fill(0);
  }
  var offset = (y * width + x) * 4;
  // premultiply alpha
  var alpha = data[offset + 3] / 255;
  dst[0] = data[offset] * alpha;
  dst[1] = data[offset + 1] * alpha;
  dst[2] = data[offset + 2] * alpha;
  dst[3] = data[offset + 3];
  return dst;
};

/**
 * Get the color from a given silhouette at an x/y local texture position.
 * Do not multiply color values by alpha, as it has already been done.
 * @param {Silhouette} $0 The silhouette to sample.
 * @param {number} x X position of texture [0, width).
 * @param {number} y Y position of texture [0, height).
 * @param {Uint8ClampedArray} dst A color 4b space.
 * @return {Uint8ClampedArray} The dst vector.
 */
var getPremultipliedColor4b = function getPremultipliedColor4b(_ref3, x, y, dst) {
  var width = _ref3._width,
    height = _ref3._height,
    data = _ref3._colorData;
  // Clamp coords to edge, matching GL_CLAMP_TO_EDGE.
  x = intMax(0, intMin(x, width - 1));
  y = intMax(0, intMin(y, height - 1));
  var offset = (y * width + x) * 4;
  dst[0] = data[offset];
  dst[1] = data[offset + 1];
  dst[2] = data[offset + 2];
  dst[3] = data[offset + 3];
  return dst;
};
var Silhouette = /*#__PURE__*/function () {
  function Silhouette() {
    _classCallCheck(this, Silhouette);
    /**
     * The width of the data representing the current skin data.
     * @type {number}
     */
    this._width = 0;

    /**
     * The height of the data representing the current skin date.
     * @type {number}
     */
    this._height = 0;

    /**
     * The data representing a skin's silhouette shape.
     * @type {Uint8ClampedArray}
     */
    this._colorData = null;

    // By default, silhouettes are assumed not to contain premultiplied image data,
    // so when we get a color, we want to multiply it by its alpha channel.
    // Point `_getColor` to the version of the function that multiplies.
    this._getColor = getColor4b;
    this.colorAtNearest = this.colorAtLinear = function (_, dst) {
      return dst.fill(0);
    };
  }

  /**
   * Update this silhouette with the bitmapData for a skin.
   * @param {ImageData|HTMLCanvasElement|HTMLImageElement} bitmapData An image, canvas or other element that the skin
   * @param {boolean} isPremultiplied True if the source bitmap data comes premultiplied (e.g. from readPixels).
   * rendering can be queried from.
   */
  return _createClass(Silhouette, [{
    key: "update",
    value: function update(bitmapData) {
      var isPremultiplied = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var imageData;
      if (bitmapData instanceof ImageData) {
        // If handed ImageData directly, use it directly.
        imageData = bitmapData;
        this._width = bitmapData.width;
        this._height = bitmapData.height;
      } else {
        // Draw about anything else to our update canvas and poll image data
        // from that.
        var canvas = Silhouette._updateCanvas();
        var width = this._width = canvas.width = bitmapData.width;
        var height = this._height = canvas.height = bitmapData.height;
        var ctx = canvas.getContext('2d');
        if (!(width && height)) {
          return;
        }
        ctx.clearRect(0, 0, width, height);
        ctx.drawImage(bitmapData, 0, 0, width, height);
        imageData = ctx.getImageData(0, 0, width, height);
      }
      if (isPremultiplied) {
        this._getColor = getPremultipliedColor4b;
      } else {
        this._getColor = getColor4b;
      }
      this._colorData = imageData.data;
      // delete our custom overriden "uninitalized" color functions
      // let the prototype work for itself
      delete this.colorAtNearest;
      delete this.colorAtLinear;
    }

    /**
     * Sample a color from the silhouette at a given local position using
     * "nearest neighbor"
     * @param {twgl.v3} vec [x,y] texture space (0-1)
     * @param {Uint8ClampedArray} dst The memory buffer to store the value in. (4 bytes)
     * @returns {Uint8ClampedArray} dst
     */
  }, {
    key: "colorAtNearest",
    value: function colorAtNearest(vec, dst) {
      return this._getColor(this, Math.floor(vec[0] * (this._width - 1)), Math.floor(vec[1] * (this._height - 1)), dst);
    }

    /**
     * Sample a color from the silhouette at a given local position using
     * "linear interpolation"
     * @param {twgl.v3} vec [x,y] texture space (0-1)
     * @param {Uint8ClampedArray} dst The memory buffer to store the value in. (4 bytes)
     * @returns {Uint8ClampedArray} dst
     */
  }, {
    key: "colorAtLinear",
    value: function colorAtLinear(vec, dst) {
      var x = vec[0] * (this._width - 1);
      var y = vec[1] * (this._height - 1);
      var x1D = x % 1;
      var y1D = y % 1;
      var x0D = 1 - x1D;
      var y0D = 1 - y1D;
      var xFloor = Math.floor(x);
      var yFloor = Math.floor(y);
      var x0y0 = this._getColor(this, xFloor, yFloor, __cornerWork[0]);
      var x1y0 = this._getColor(this, xFloor + 1, yFloor, __cornerWork[1]);
      var x0y1 = this._getColor(this, xFloor, yFloor + 1, __cornerWork[2]);
      var x1y1 = this._getColor(this, xFloor + 1, yFloor + 1, __cornerWork[3]);
      dst[0] = x0y0[0] * x0D * y0D + x0y1[0] * x0D * y1D + x1y0[0] * x1D * y0D + x1y1[0] * x1D * y1D;
      dst[1] = x0y0[1] * x0D * y0D + x0y1[1] * x0D * y1D + x1y0[1] * x1D * y0D + x1y1[1] * x1D * y1D;
      dst[2] = x0y0[2] * x0D * y0D + x0y1[2] * x0D * y1D + x1y0[2] * x1D * y0D + x1y1[2] * x1D * y1D;
      dst[3] = x0y0[3] * x0D * y0D + x0y1[3] * x0D * y1D + x1y0[3] * x1D * y0D + x1y1[3] * x1D * y1D;
      return dst;
    }

    /**
     * Test if texture coordinate touches the silhouette using nearest neighbor.
     * @param {twgl.v3} vec A texture coordinate.
     * @return {boolean} If the nearest pixel has an alpha value.
     */
  }, {
    key: "isTouchingNearest",
    value: function isTouchingNearest(vec) {
      if (!this._colorData) return;
      return getPoint(this, Math.floor(vec[0] * (this._width - 1)), Math.floor(vec[1] * (this._height - 1))) > 0;
    }

    /**
     * Test to see if any of the 4 pixels used in the linear interpolate touch
     * the silhouette.
     * @param {twgl.v3} vec A texture coordinate.
     * @return {boolean} Any of the pixels have some alpha.
     */
  }, {
    key: "isTouchingLinear",
    value: function isTouchingLinear(vec) {
      if (!this._colorData) return;
      var x = Math.floor(vec[0] * (this._width - 1));
      var y = Math.floor(vec[1] * (this._height - 1));
      return getPoint(this, x, y) > 0 || getPoint(this, x + 1, y) > 0 || getPoint(this, x, y + 1) > 0 || getPoint(this, x + 1, y + 1) > 0;
    }

    /**
     * Get the canvas element reused by Silhouettes to update their data with.
     * @private
     * @return {CanvasElement} A canvas to draw bitmap data to.
     */
  }], [{
    key: "_updateCanvas",
    value: function _updateCanvas() {
      if (typeof __SilhouetteUpdateCanvas === 'undefined') {
        __SilhouetteUpdateCanvas = document.createElement('canvas');
      }
      return __SilhouetteUpdateCanvas;
    }
  }]);
}();
module.exports = Silhouette;

/***/ }),

/***/ "./src/Skin.js":
/*!*********************!*\
  !*** ./src/Skin.js ***!
  \*********************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var EventEmitter = __webpack_require__(/*! events */ "./node_modules/events/events.js");
var twgl = __webpack_require__(/*! twgl.js */ "./node_modules/twgl.js/dist/4.x/twgl-full.module.js");
var RenderConstants = __webpack_require__(/*! ./RenderConstants */ "./src/RenderConstants.js");
var Silhouette = __webpack_require__(/*! ./Silhouette */ "./src/Silhouette.js");
var Skin = /*#__PURE__*/function (_EventEmitter) {
  /**
   * Create a Skin, which stores and/or generates textures for use in rendering.
   * @param {int} id - The unique ID for this Skin.
   * @constructor
   */
  function Skin(id) {
    var _this;
    _classCallCheck(this, Skin);
    _this = _callSuper(this, Skin);

    /** @type {int} */
    _this._id = id;

    /** @type {Vec3} */
    _this._rotationCenter = twgl.v3.create(0, 0);

    /** @type {WebGLTexture} */
    _this._texture = null;

    /**
     * The uniforms to be used by the vertex and pixel shaders.
     * Some of these are used by other parts of the renderer as well.
     * @type {Object.<string,*>}
     * @private
     */
    _this._uniforms = {
      /**
       * The nominal (not necessarily current) size of the current skin.
       * @type {Array<number>}
       */
      u_skinSize: [0, 0],
      /**
       * The actual WebGL texture object for the skin.
       * @type {WebGLTexture}
       */
      u_skin: null
    };

    /**
     * A silhouette to store touching data, skins are responsible for keeping it up to date.
     * @private
     */
    _this._silhouette = new Silhouette();
    _this.setMaxListeners(RenderConstants.SKIN_SHARE_SOFT_LIMIT);
    return _this;
  }

  /**
   * Dispose of this object. Do not use it after calling this method.
   */
  _inherits(Skin, _EventEmitter);
  return _createClass(Skin, [{
    key: "dispose",
    value: function dispose() {
      this._id = RenderConstants.ID_NONE;
    }

    /**
     * @return {int} the unique ID for this Skin.
     */
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }

    /**
     * @returns {Vec3} the origin, in object space, about which this Skin should rotate.
     */
  }, {
    key: "rotationCenter",
    get: function get() {
      return this._rotationCenter;
    }

    /**
     * @abstract
     * @return {Array<number>} the "native" size, in texels, of this skin.
     */
  }, {
    key: "size",
    get: function get() {
      return [0, 0];
    }

    /**
     * Should this skin's texture be filtered with nearest-neighbor or linear interpolation at the given scale?
     * @param {?Array<Number>} scale The screen-space X and Y scaling factors at which this skin's texture will be
     * displayed, as percentages (100 means 1 "native size" unit is 1 screen pixel; 200 means 2 screen pixels, etc).
     * @param {Drawable} drawable The drawable that this skin's texture will be applied to.
     * @return {boolean} True if this skin's texture, as returned by {@link getTexture}, should be filtered with
     * nearest-neighbor interpolation.
     */
    // eslint-disable-next-line no-unused-vars
  }, {
    key: "useNearest",
    value: function useNearest(scale, drawable) {
      return true;
    }

    /**
     * Get the center of the current bounding box
     * @return {Array<number>} the center of the current bounding box
     */
  }, {
    key: "calculateRotationCenter",
    value: function calculateRotationCenter() {
      return [this.size[0] / 2, this.size[1] / 2];
    }

    /**
     * @abstract
     * @param {Array<number>} scale - The scaling factors to be used.
     * @return {WebGLTexture} The GL texture representation of this skin when drawing at the given size.
     */
    // eslint-disable-next-line no-unused-vars
  }, {
    key: "getTexture",
    value: function getTexture(scale) {
      return this._emptyImageTexture;
    }

    /**
     * Get the bounds of the drawable for determining its fenced position.
     * @param {Array<number>} drawable - The Drawable instance this skin is using.
     * @param {?Rectangle} result - Optional destination for bounds calculation.
     * @return {!Rectangle} The drawable's bounds. For compatibility with Scratch 2, we always use getAABB.
     */
  }, {
    key: "getFenceBounds",
    value: function getFenceBounds(drawable, result) {
      return drawable.getAABB(result);
    }

    /**
     * Update and returns the uniforms for this skin.
     * @param {Array<number>} scale - The scaling factors to be used.
     * @returns {object.<string, *>} the shader uniforms to be used when rendering with this Skin.
     */
  }, {
    key: "getUniforms",
    value: function getUniforms(scale) {
      this._uniforms.u_skin = this.getTexture(scale);
      this._uniforms.u_skinSize = this.size;
      return this._uniforms;
    }

    /**
     * If the skin defers silhouette operations until the last possible minute,
     * this will be called before isTouching uses the silhouette.
     * @abstract
     */
  }, {
    key: "updateSilhouette",
    value: function updateSilhouette() {}

    /**
     * Set this skin's texture to the given image.
     * @param {ImageData|HTMLCanvasElement} textureData - The canvas or image data to set the texture to.
     */
  }, {
    key: "_setTexture",
    value: function _setTexture(textureData) {
      var gl = this._renderer.gl;
      gl.bindTexture(gl.TEXTURE_2D, this._texture);
      // Premultiplied alpha is necessary for proper blending.
      // See http://www.realtimerendering.com/blog/gpus-prefer-premultiplication/
      gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureData);
      gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
      this._silhouette.update(textureData);
    }

    /**
     * Set the contents of this skin to an empty skin.
     * @fires Skin.event:WasAltered
     */
  }, {
    key: "setEmptyImageData",
    value: function setEmptyImageData() {
      // Free up the current reference to the _texture
      this._texture = null;
      if (!this._emptyImageData) {
        // Create a transparent pixel
        this._emptyImageData = new ImageData(1, 1);

        // Create a new texture and update the silhouette
        var gl = this._renderer.gl;
        var textureOptions = {
          auto: true,
          wrap: gl.CLAMP_TO_EDGE,
          src: this._emptyImageData
        };

        // Note: we're using _emptyImageTexture here instead of _texture
        // so that we can cache this empty texture for later use as needed.
        // this._texture can get modified by other skins (e.g. BitmapSkin
        // and SVGSkin, so we can't use that same field for caching)
        this._emptyImageTexture = twgl.createTexture(gl, textureOptions);
      }
      this._rotationCenter[0] = 0;
      this._rotationCenter[1] = 0;
      this._silhouette.update(this._emptyImageData);
      this.emit(Skin.Events.WasAltered);
    }

    /**
     * Does this point touch an opaque or translucent point on this skin?
     * Nearest Neighbor version
     * The caller is responsible for ensuring this skin's silhouette is up-to-date.
     * @see updateSilhouette
     * @see Drawable.updateCPURenderAttributes
     * @param {twgl.v3} vec A texture coordinate.
     * @return {boolean} Did it touch?
     */
  }, {
    key: "isTouchingNearest",
    value: function isTouchingNearest(vec) {
      return this._silhouette.isTouchingNearest(vec);
    }

    /**
     * Does this point touch an opaque or translucent point on this skin?
     * Linear Interpolation version
     * The caller is responsible for ensuring this skin's silhouette is up-to-date.
     * @see updateSilhouette
     * @see Drawable.updateCPURenderAttributes
     * @param {twgl.v3} vec A texture coordinate.
     * @return {boolean} Did it touch?
     */
  }, {
    key: "isTouchingLinear",
    value: function isTouchingLinear(vec) {
      return this._silhouette.isTouchingLinear(vec);
    }
  }]);
}(EventEmitter);
/**
 * These are the events which can be emitted by instances of this class.
 * @enum {string}
 */
Skin.Events = {
  /**
   * Emitted when anything about the Skin has been altered, such as the appearance or rotation center.
   * @event Skin.event:WasAltered
   */
  WasAltered: 'WasAltered'
};
module.exports = Skin;

/***/ }),

/***/ "./src/TextBubbleSkin.js":
/*!*******************************!*\
  !*** ./src/TextBubbleSkin.js ***!
  \*******************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var twgl = __webpack_require__(/*! twgl.js */ "./node_modules/twgl.js/dist/4.x/twgl-full.module.js");
var TextWrapper = __webpack_require__(/*! ./util/text-wrapper */ "./src/util/text-wrapper.js");
var CanvasMeasurementProvider = __webpack_require__(/*! ./util/canvas-measurement-provider */ "./src/util/canvas-measurement-provider.js");
var Skin = __webpack_require__(/*! ./Skin */ "./src/Skin.js");
var BubbleStyle = {
  MAX_LINE_WIDTH: 170,
  // Maximum width, in Scratch pixels, of a single line of text

  MIN_WIDTH: 50,
  // Minimum width, in Scratch pixels, of a text bubble
  STROKE_WIDTH: 4,
  // Thickness of the stroke around the bubble. Only half's visible because it's drawn under the fill
  PADDING: 10,
  // Padding around the text area
  CORNER_RADIUS: 16,
  // Radius of the rounded corners
  TAIL_HEIGHT: 12,
  // Height of the speech bubble's "tail". Probably should be a constant.

  FONT: 'Helvetica',
  // Font to render the text with
  FONT_SIZE: 14,
  // Font size, in Scratch pixels
  FONT_HEIGHT_RATIO: 0.9,
  // Height, in Scratch pixels, of the text, as a proportion of the font's size
  LINE_HEIGHT: 16,
  // Spacing between each line of text

  COLORS: {
    BUBBLE_FILL: 'white',
    BUBBLE_STROKE: 'rgba(0, 0, 0, 0.15)',
    TEXT_FILL: '#575E75'
  }
};
var TextBubbleSkin = /*#__PURE__*/function (_Skin) {
  /**
   * Create a new text bubble skin.
   * @param {!int} id - The ID for this Skin.
   * @param {!RenderWebGL} renderer - The renderer which will use this skin.
   * @constructor
   * @extends Skin
   */
  function TextBubbleSkin(id, renderer) {
    var _this;
    _classCallCheck(this, TextBubbleSkin);
    _this = _callSuper(this, TextBubbleSkin, [id]);

    /** @type {RenderWebGL} */
    _this._renderer = renderer;

    /** @type {HTMLCanvasElement} */
    _this._canvas = document.createElement('canvas');

    /** @type {Array<number>} */
    _this._size = [0, 0];

    /** @type {number} */
    _this._renderedScale = 0;

    /** @type {Array<string>} */
    _this._lines = [];

    /** @type {object} */
    _this._textAreaSize = {
      width: 0,
      height: 0
    };

    /** @type {string} */
    _this._bubbleType = '';

    /** @type {boolean} */
    _this._pointsLeft = false;

    /** @type {boolean} */
    _this._textDirty = true;

    /** @type {boolean} */
    _this._textureDirty = true;
    _this.measurementProvider = new CanvasMeasurementProvider(_this._canvas.getContext('2d'));
    _this.textWrapper = new TextWrapper(_this.measurementProvider);
    _this._restyleCanvas();
    return _this;
  }

  /**
   * Dispose of this object. Do not use it after calling this method.
   */
  _inherits(TextBubbleSkin, _Skin);
  return _createClass(TextBubbleSkin, [{
    key: "dispose",
    value: function dispose() {
      if (this._texture) {
        this._renderer.gl.deleteTexture(this._texture);
        this._texture = null;
      }
      this._canvas = null;
      _superPropGet(TextBubbleSkin, "dispose", this, 3)([]);
    }

    /**
     * @return {Array<number>} the dimensions, in Scratch units, of this skin.
     */
  }, {
    key: "size",
    get: function get() {
      if (this._textDirty) {
        this._reflowLines();
      }
      return this._size;
    }

    /**
     * Set parameters for this text bubble.
     * @param {!string} type - either "say" or "think".
     * @param {!string} text - the text for the bubble.
     * @param {!boolean} pointsLeft - which side the bubble is pointing.
     */
  }, {
    key: "setTextBubble",
    value: function setTextBubble(type, text, pointsLeft) {
      this._text = text;
      this._bubbleType = type;
      this._pointsLeft = pointsLeft;
      this._textDirty = true;
      this._textureDirty = true;
      this.emit(Skin.Events.WasAltered);
    }

    /**
     * Re-style the canvas after resizing it. This is necessary to ensure proper text measurement.
     */
  }, {
    key: "_restyleCanvas",
    value: function _restyleCanvas() {
      this._canvas.getContext('2d').font = "".concat(BubbleStyle.FONT_SIZE, "px ").concat(BubbleStyle.FONT, ", sans-serif");
    }

    /**
     * Update the array of wrapped lines and the text dimensions.
     */
  }, {
    key: "_reflowLines",
    value: function _reflowLines() {
      this._lines = this.textWrapper.wrapText(BubbleStyle.MAX_LINE_WIDTH, this._text);

      // Measure width of longest line to avoid extra-wide bubbles
      var longestLineWidth = 0;
      var _iterator = _createForOfIteratorHelper(this._lines),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var line = _step.value;
          longestLineWidth = Math.max(longestLineWidth, this.measurementProvider.measureText(line));
        }

        // Calculate the canvas-space sizes of the padded text area and full text bubble
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var paddedWidth = Math.max(longestLineWidth, BubbleStyle.MIN_WIDTH) + BubbleStyle.PADDING * 2;
      var paddedHeight = BubbleStyle.LINE_HEIGHT * this._lines.length + BubbleStyle.PADDING * 2;
      this._textAreaSize.width = paddedWidth;
      this._textAreaSize.height = paddedHeight;
      this._size[0] = paddedWidth + BubbleStyle.STROKE_WIDTH;
      this._size[1] = paddedHeight + BubbleStyle.STROKE_WIDTH + BubbleStyle.TAIL_HEIGHT;
      this._textDirty = false;
    }

    /**
     * Render this text bubble at a certain scale, using the current parameters, to the canvas.
     * @param {number} scale The scale to render the bubble at
     */
  }, {
    key: "_renderTextBubble",
    value: function _renderTextBubble(scale) {
      var ctx = this._canvas.getContext('2d');
      if (this._textDirty) {
        this._reflowLines();
      }

      // Calculate the canvas-space sizes of the padded text area and full text bubble
      var paddedWidth = this._textAreaSize.width;
      var paddedHeight = this._textAreaSize.height;

      // Resize the canvas to the correct screen-space size
      this._canvas.width = Math.ceil(this._size[0] * scale);
      this._canvas.height = Math.ceil(this._size[1] * scale);
      this._restyleCanvas();

      // Reset the transform before clearing to ensure 100% clearage
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);
      ctx.scale(scale, scale);
      ctx.translate(BubbleStyle.STROKE_WIDTH * 0.5, BubbleStyle.STROKE_WIDTH * 0.5);

      // If the text bubble points leftward, flip the canvas
      ctx.save();
      if (this._pointsLeft) {
        ctx.scale(-1, 1);
        ctx.translate(-paddedWidth, 0);
      }

      // Draw the bubble's rounded borders
      ctx.beginPath();
      ctx.moveTo(BubbleStyle.CORNER_RADIUS, paddedHeight);
      ctx.arcTo(0, paddedHeight, 0, paddedHeight - BubbleStyle.CORNER_RADIUS, BubbleStyle.CORNER_RADIUS);
      ctx.arcTo(0, 0, paddedWidth, 0, BubbleStyle.CORNER_RADIUS);
      ctx.arcTo(paddedWidth, 0, paddedWidth, paddedHeight, BubbleStyle.CORNER_RADIUS);
      ctx.arcTo(paddedWidth, paddedHeight, paddedWidth - BubbleStyle.CORNER_RADIUS, paddedHeight, BubbleStyle.CORNER_RADIUS);

      // Translate the canvas so we don't have to do a bunch of width/height arithmetic
      ctx.save();
      ctx.translate(paddedWidth - BubbleStyle.CORNER_RADIUS, paddedHeight);

      // Draw the bubble's "tail"
      if (this._bubbleType === 'say') {
        // For a speech bubble, draw one swoopy thing
        ctx.bezierCurveTo(0, 4, 4, 8, 4, 10);
        ctx.arcTo(4, 12, 2, 12, 2);
        ctx.bezierCurveTo(-1, 12, -11, 8, -16, 0);
        ctx.closePath();
      } else {
        // For a thinking bubble, draw a partial circle attached to the bubble...
        ctx.arc(-16, 0, 4, 0, Math.PI);
        ctx.closePath();

        // and two circles detached from it
        ctx.moveTo(-7, 7.25);
        ctx.arc(-9.25, 7.25, 2.25, 0, Math.PI * 2);
        ctx.moveTo(0, 9.5);
        ctx.arc(-1.5, 9.5, 1.5, 0, Math.PI * 2);
      }

      // Un-translate the canvas and fill + stroke the text bubble
      ctx.restore();
      ctx.fillStyle = BubbleStyle.COLORS.BUBBLE_FILL;
      ctx.strokeStyle = BubbleStyle.COLORS.BUBBLE_STROKE;
      ctx.lineWidth = BubbleStyle.STROKE_WIDTH;
      ctx.stroke();
      ctx.fill();

      // Un-flip the canvas if it was flipped
      ctx.restore();

      // Draw each line of text
      ctx.fillStyle = BubbleStyle.COLORS.TEXT_FILL;
      ctx.font = "".concat(BubbleStyle.FONT_SIZE, "px ").concat(BubbleStyle.FONT, ", sans-serif");
      var lines = this._lines;
      for (var lineNumber = 0; lineNumber < lines.length; lineNumber++) {
        var line = lines[lineNumber];
        ctx.fillText(line, BubbleStyle.PADDING, BubbleStyle.PADDING + BubbleStyle.LINE_HEIGHT * lineNumber + BubbleStyle.FONT_HEIGHT_RATIO * BubbleStyle.FONT_SIZE);
      }
      this._renderedScale = scale;
    }
  }, {
    key: "updateSilhouette",
    value: function updateSilhouette() {
      var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [100, 100];
      // Ensure a silhouette exists.
      this.getTexture(scale);
    }

    /**
     * @param {Array<number>} scale - The scaling factors to be used, each in the [0,100] range.
     * @return {WebGLTexture} The GL texture representation of this skin when drawing at the given scale.
     */
  }, {
    key: "getTexture",
    value: function getTexture(scale) {
      // The texture only ever gets uniform scale. Take the larger of the two axes.
      var scaleMax = scale ? Math.max(Math.abs(scale[0]), Math.abs(scale[1])) : 100;
      var requestedScale = scaleMax / 100;

      // If we already rendered the text bubble at this scale, we can skip re-rendering it.
      if (this._textureDirty || this._renderedScale !== requestedScale) {
        this._renderTextBubble(requestedScale);
        this._textureDirty = false;
        var context = this._canvas.getContext('2d');
        var textureData = context.getImageData(0, 0, this._canvas.width, this._canvas.height);
        var gl = this._renderer.gl;
        if (this._texture === null) {
          var textureOptions = {
            auto: false,
            wrap: gl.CLAMP_TO_EDGE
          };
          this._texture = twgl.createTexture(gl, textureOptions);
        }
        this._setTexture(textureData);
      }
      return this._texture;
    }
  }]);
}(Skin);
module.exports = TextBubbleSkin;

/***/ }),

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var RenderWebGL = __webpack_require__(/*! ./RenderWebGL */ "./src/RenderWebGL.js");

/**
 * Export for NPM & Node.js
 * @type {RenderWebGL}
 */
module.exports = RenderWebGL;

/***/ }),

/***/ "./src/util/canvas-measurement-provider.js":
/*!*************************************************!*\
  !*** ./src/util/canvas-measurement-provider.js ***!
  \*************************************************/
/***/ (function(module) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CanvasMeasurementProvider = /*#__PURE__*/function () {
  /**
   * @param {CanvasRenderingContext2D} ctx - provides a canvas rendering context
   * with 'font' set to the text style of the text to be wrapped.
   */
  function CanvasMeasurementProvider(ctx) {
    _classCallCheck(this, CanvasMeasurementProvider);
    this._ctx = ctx;
    this._cache = {};
  }

  // We don't need to set up or tear down anything here. Should these be removed altogether?

  /**
   * Called by the TextWrapper before a batch of zero or more calls to measureText().
   */
  return _createClass(CanvasMeasurementProvider, [{
    key: "beginMeasurementSession",
    value: function beginMeasurementSession() {}

    /**
     * Called by the TextWrapper after a batch of zero or more calls to measureText().
     */
  }, {
    key: "endMeasurementSession",
    value: function endMeasurementSession() {}

    /**
     * Measure a whole string as one unit.
     * @param {string} text - the text to measure.
     * @returns {number} - the length of the string.
     */
  }, {
    key: "measureText",
    value: function measureText(text) {
      if (!this._cache[text]) {
        this._cache[text] = this._ctx.measureText(text).width;
      }
      return this._cache[text];
    }
  }]);
}();
module.exports = CanvasMeasurementProvider;

/***/ }),

/***/ "./src/util/color-conversions.js":
/*!***************************************!*\
  !*** ./src/util/color-conversions.js ***!
  \***************************************/
/***/ (function(module) {

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Converts an RGB color value to HSV. Conversion formula
 * adapted from http://lolengine.net/blog/2013/01/13/fast-rgb-to-hsv.
 * Assumes r, g, and b are in the range [0, 255] and
 * returns h, s, and v in the range [0, 1].
 *
 * @param   {Array<number>} rgb   The RGB color value
 * @param   {number}        rgb.r The red color value
 * @param   {number}        rgb.g The green color value
 * @param   {number}        rgb.b The blue color value
 * @param   {Array<number>} dst   The array to store the HSV values in
 * @return  {Array<number>}       The `dst` array passed in
 */
var rgbToHsv = function rgbToHsv(_ref, dst) {
  var _ref2 = _slicedToArray(_ref, 3),
    r = _ref2[0],
    g = _ref2[1],
    b = _ref2[2];
  var K = 0.0;
  r /= 255;
  g /= 255;
  b /= 255;
  var tmp = 0;
  if (g < b) {
    tmp = g;
    g = b;
    b = tmp;
    K = -1;
  }
  if (r < g) {
    tmp = r;
    r = g;
    g = tmp;
    K = -2 / 6 - K;
  }
  var chroma = r - Math.min(g, b);
  var h = Math.abs(K + (g - b) / (6 * chroma + Number.EPSILON));
  var s = chroma / (r + Number.EPSILON);
  var v = r;
  dst[0] = h;
  dst[1] = s;
  dst[2] = v;
  return dst;
};

/**
 * Converts an HSV color value to RGB. Conversion formula
 * adapted from https://gist.github.com/mjackson/5311256.
 * Assumes h, s, and v are contained in the set [0, 1] and
 * returns r, g, and b in the set [0, 255].
 *
 * @param   {Array<number>}                hsv The HSV color value
 * @param   {number}                       hsv.h     The hue
 * @param   {number}                       hsv.s     The saturation
 * @param   {number}                       hsv.v     The value
 * @param   {Uint8Array|Uint8ClampedArray} dst The array to store the RGB values in
 * @return  {Uint8Array|Uint8ClampedArray}     The `dst` array passed in
 */
var hsvToRgb = function hsvToRgb(_ref3, dst) {
  var _ref4 = _slicedToArray(_ref3, 3),
    h = _ref4[0],
    s = _ref4[1],
    v = _ref4[2];
  if (s === 0) {
    dst[0] = dst[1] = dst[2] = v * 255 + 0.5;
    return dst;
  }

  // keep hue in [0,1) so the `switch(i)` below only needs 6 cases (0-5)
  h %= 1;
  var i = h * 6 | 0;
  var f = h * 6 - i;
  var p = v * (1 - s);
  var q = v * (1 - s * f);
  var t = v * (1 - s * (1 - f));
  var r = 0;
  var g = 0;
  var b = 0;
  switch (i) {
    case 0:
      r = v;
      g = t;
      b = p;
      break;
    case 1:
      r = q;
      g = v;
      b = p;
      break;
    case 2:
      r = p;
      g = v;
      b = t;
      break;
    case 3:
      r = p;
      g = q;
      b = v;
      break;
    case 4:
      r = t;
      g = p;
      b = v;
      break;
    case 5:
      r = v;
      g = p;
      b = q;
      break;
  }

  // Add 0.5 in order to round. Setting integer TypedArray elements implicitly floors.
  dst[0] = r * 255 + 0.5;
  dst[1] = g * 255 + 0.5;
  dst[2] = b * 255 + 0.5;
  return dst;
};
module.exports = {
  rgbToHsv: rgbToHsv,
  hsvToRgb: hsvToRgb
};

/***/ }),

/***/ "./src/util/log.js":
/*!*************************!*\
  !*** ./src/util/log.js ***!
  \*************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var minilog = __webpack_require__(/*! minilog */ "./node_modules/minilog/lib/web/index.js");
minilog.enable();
module.exports = minilog('scratch-render');

/***/ }),

/***/ "./src/util/text-wrapper.js":
/*!**********************************!*\
  !*** ./src/util/text-wrapper.js ***!
  \**********************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LineBreaker = __webpack_require__(/*! !ify-loader!linebreak */ "./node_modules/ify-loader/index.js!./node_modules/linebreak/src/linebreaker.js");
var GraphemeBreaker = __webpack_require__(/*! !ify-loader!grapheme-breaker */ "./node_modules/ify-loader/index.js!./node_modules/grapheme-breaker/src/GraphemeBreaker.js");

/**
 * Tell this text wrapper to use a specific measurement provider.
 * @typedef {object} MeasurementProvider - the new measurement provider.
 * @property {Function} beginMeasurementSession - this will be called before a batch of measurements are made.
 *      Optionally, this function may return an object to be provided to the endMeasurementSession function.
 * @property {Function} measureText - this will be called each time a piece of text must be measured.
 * @property {Function} endMeasurementSession - this will be called after a batch of measurements is finished.
 *      It will be passed whatever value beginMeasurementSession returned, if any.
 */

/**
 * Utility to wrap text across several lines, respecting Unicode grapheme clusters and, when possible, Unicode line
 * break opportunities.
 * Reference material:
 * - Unicode Standard Annex #14: http://unicode.org/reports/tr14/
 * - Unicode Standard Annex #29: http://unicode.org/reports/tr29/
 * - "JavaScript has a Unicode problem" by Mathias Bynens: https://mathiasbynens.be/notes/javascript-unicode
 */
var TextWrapper = /*#__PURE__*/function () {
  /**
   * Construct a text wrapper which will measure text using the specified measurement provider.
   * @param {MeasurementProvider} measurementProvider - a helper object to provide text measurement services.
   */
  function TextWrapper(measurementProvider) {
    _classCallCheck(this, TextWrapper);
    this._measurementProvider = measurementProvider;
    this._cache = {};
  }

  /**
   * Wrap the provided text into lines restricted to a maximum width. See Unicode Standard Annex (UAX) #14.
   * @param {number} maxWidth - the maximum allowed width of a line.
   * @param {string} text - the text to be wrapped. Will be split on whitespace.
   * @returns {Array.<string>} an array containing the wrapped lines of text.
   */
  return _createClass(TextWrapper, [{
    key: "wrapText",
    value: function wrapText(maxWidth, text) {
      // Normalize to canonical composition (see Unicode Standard Annex (UAX) #15)
      text = text.normalize();
      var cacheKey = "".concat(maxWidth, "-").concat(text);
      if (this._cache[cacheKey]) {
        return this._cache[cacheKey];
      }
      var measurementSession = this._measurementProvider.beginMeasurementSession();
      var breaker = new LineBreaker(text);
      var lastPosition = 0;
      var nextBreak;
      var currentLine = null;
      var lines = [];
      while (nextBreak = breaker.nextBreak()) {
        var word = text.slice(lastPosition, nextBreak.position).replace(/\n+$/, '');
        var proposedLine = (currentLine || '').concat(word);
        var proposedLineWidth = this._measurementProvider.measureText(proposedLine);
        if (proposedLineWidth > maxWidth) {
          // The next word won't fit on this line. Will it fit on a line by itself?
          var wordWidth = this._measurementProvider.measureText(word);
          if (wordWidth > maxWidth) {
            // The next word can't even fit on a line by itself. Consume it one grapheme cluster at a time.
            var lastCluster = 0;
            var nextCluster = void 0;
            while (lastCluster !== (nextCluster = GraphemeBreaker.nextBreak(word, lastCluster))) {
              var cluster = word.substring(lastCluster, nextCluster);
              proposedLine = (currentLine || '').concat(cluster);
              proposedLineWidth = this._measurementProvider.measureText(proposedLine);
              if (currentLine === null || proposedLineWidth <= maxWidth) {
                // first cluster of a new line or the cluster fits
                currentLine = proposedLine;
              } else {
                // no more can fit
                lines.push(currentLine);
                currentLine = cluster;
              }
              lastCluster = nextCluster;
            }
          } else {
            // The next word can fit on the next line. Finish the current line and move on.
            if (currentLine !== null) lines.push(currentLine);
            currentLine = word;
          }
        } else {
          // The next word fits on this line. Just keep going.
          currentLine = proposedLine;
        }

        // Did we find a \n or similar?
        if (nextBreak.required) {
          if (currentLine !== null) lines.push(currentLine);
          currentLine = null;
        }
        lastPosition = nextBreak.position;
      }
      currentLine = currentLine || '';
      if (currentLine.length > 0 || lines.length === 0) {
        lines.push(currentLine);
      }
      this._cache[cacheKey] = lines;
      this._measurementProvider.endMeasurementSession(measurementSession);
      return lines;
    }
  }]);
}();
module.exports = TextWrapper;

/***/ }),

/***/ "./node_modules/base64-js/lib/b64.js":
/*!*******************************************!*\
  !*** ./node_modules/base64-js/lib/b64.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, exports) {

var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

;(function (exports) {
	'use strict';

  var Arr = (typeof Uint8Array !== 'undefined')
    ? Uint8Array
    : Array

	var PLUS   = '+'.charCodeAt(0)
	var SLASH  = '/'.charCodeAt(0)
	var NUMBER = '0'.charCodeAt(0)
	var LOWER  = 'a'.charCodeAt(0)
	var UPPER  = 'A'.charCodeAt(0)
	var PLUS_URL_SAFE = '-'.charCodeAt(0)
	var SLASH_URL_SAFE = '_'.charCodeAt(0)

	function decode (elt) {
		var code = elt.charCodeAt(0)
		if (code === PLUS ||
		    code === PLUS_URL_SAFE)
			return 62 // '+'
		if (code === SLASH ||
		    code === SLASH_URL_SAFE)
			return 63 // '/'
		if (code < NUMBER)
			return -1 //no match
		if (code < NUMBER + 10)
			return code - NUMBER + 26 + 26
		if (code < UPPER + 26)
			return code - UPPER
		if (code < LOWER + 26)
			return code - LOWER + 26
	}

	function b64ToByteArray (b64) {
		var i, j, l, tmp, placeHolders, arr

		if (b64.length % 4 > 0) {
			throw new Error('Invalid string. Length must be a multiple of 4')
		}

		// the number of equal signs (place holders)
		// if there are two placeholders, than the two characters before it
		// represent one byte
		// if there is only one, then the three characters before it represent 2 bytes
		// this is just a cheap hack to not do indexOf twice
		var len = b64.length
		placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0

		// base64 is 4/3 + up to two characters of the original data
		arr = new Arr(b64.length * 3 / 4 - placeHolders)

		// if there are placeholders, only get up to the last complete 4 chars
		l = placeHolders > 0 ? b64.length - 4 : b64.length

		var L = 0

		function push (v) {
			arr[L++] = v
		}

		for (i = 0, j = 0; i < l; i += 4, j += 3) {
			tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
			push((tmp & 0xFF0000) >> 16)
			push((tmp & 0xFF00) >> 8)
			push(tmp & 0xFF)
		}

		if (placeHolders === 2) {
			tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
			push(tmp & 0xFF)
		} else if (placeHolders === 1) {
			tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
			push((tmp >> 8) & 0xFF)
			push(tmp & 0xFF)
		}

		return arr
	}

	function uint8ToBase64 (uint8) {
		var i,
			extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
			output = "",
			temp, length

		function encode (num) {
			return lookup.charAt(num)
		}

		function tripletToBase64 (num) {
			return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
		}

		// go through the array every three bytes, we'll deal with trailing stuff later
		for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
			temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
			output += tripletToBase64(temp)
		}

		// pad the end with zeros, but make sure to not forget the extra bytes
		switch (extraBytes) {
			case 1:
				temp = uint8[uint8.length - 1]
				output += encode(temp >> 2)
				output += encode((temp << 4) & 0x3F)
				output += '=='
				break
			case 2:
				temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
				output += encode(temp >> 10)
				output += encode((temp >> 4) & 0x3F)
				output += encode((temp << 2) & 0x3F)
				output += '='
				break
		}

		return output
	}

	exports.toByteArray = b64ToByteArray
	exports.fromByteArray = uint8ToBase64
}( false ? (0) : exports))


/***/ }),

/***/ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/Grand9K-Pixel.ttf":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/Grand9K-Pixel.ttf ***!
  \*******************************************************************************************************/
/***/ (function(module) {

module.exports = "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"

/***/ }),

/***/ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/Griffy-Regular.ttf":
/*!********************************************************************************************************!*\
  !*** ./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/Griffy-Regular.ttf ***!
  \********************************************************************************************************/
/***/ (function(module) {

module.exports = "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"

/***/ }),

/***/ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/Knewave.ttf":
/*!*************************************************************************************************!*\
  !*** ./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/Knewave.ttf ***!
  \*************************************************************************************************/
/***/ (function(module) {

module.exports = "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"

/***/ }),

/***/ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/NotoSans-Medium.ttf":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/NotoSans-Medium.ttf ***!
  \*********************************************************************************************************/
/***/ (function(module) {

module.exports = "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"

/***/ }),

/***/ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/Scratch.ttf":
/*!*************************************************************************************************!*\
  !*** ./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/Scratch.ttf ***!
  \*************************************************************************************************/
/***/ (function(module) {

module.exports = "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"

/***/ }),

/***/ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/SourceSerifPro-Regular.otf":
/*!****************************************************************************************************************!*\
  !*** ./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/SourceSerifPro-Regular.otf ***!
  \****************************************************************************************************************/
/***/ (function(module) {

module.exports = "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"

/***/ }),

/***/ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/handlee-regular.ttf":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/handlee-regular.ttf ***!
  \*********************************************************************************************************/
/***/ (function(module) {

module.exports = "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"

/***/ }),

/***/ "./node_modules/buffer/index.js":
/*!**************************************!*\
  !*** ./node_modules/buffer/index.js ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(/*! base64-js */ "./node_modules/buffer/node_modules/base64-js/index.js")
const ieee754 = __webpack_require__(/*! ieee754 */ "./node_modules/ieee754/index.js")
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

const K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ "./node_modules/buffer/node_modules/base64-js/index.js":
/*!*************************************************************!*\
  !*** ./node_modules/buffer/node_modules/base64-js/index.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "./node_modules/css-tree/data/index.js":
/*!*********************************************!*\
  !*** ./node_modules/css-tree/data/index.js ***!
  \*********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const mdnAtrules = __webpack_require__(/*! mdn-data/css/at-rules.json */ "./node_modules/mdn-data/css/at-rules.json");
const mdnProperties = __webpack_require__(/*! mdn-data/css/properties.json */ "./node_modules/mdn-data/css/properties.json");
const mdnSyntaxes = __webpack_require__(/*! mdn-data/css/syntaxes.json */ "./node_modules/mdn-data/css/syntaxes.json");
const patch = __webpack_require__(/*! ./patch.json */ "./node_modules/css-tree/data/patch.json");
const extendSyntax = /^\s*\|\s*/;

function preprocessAtrules(dict) {
    const result = Object.create(null);

    for (const atruleName in dict) {
        const atrule = dict[atruleName];
        let descriptors = null;

        if (atrule.descriptors) {
            descriptors = Object.create(null);

            for (const descriptor in atrule.descriptors) {
                descriptors[descriptor] = atrule.descriptors[descriptor].syntax;
            }
        }

        result[atruleName.substr(1)] = {
            prelude: atrule.syntax.trim().match(/^@\S+\s+([^;\{]*)/)[1].trim() || null,
            descriptors
        };
    }

    return result;
}

function patchDictionary(dict, patchDict) {
    const result = {};

    // copy all syntaxes for an original dict
    for (const key in dict) {
        result[key] = dict[key].syntax || dict[key];
    }

    // apply a patch
    for (const key in patchDict) {
        if (key in dict) {
            if (patchDict[key].syntax) {
                result[key] = extendSyntax.test(patchDict[key].syntax)
                    ? result[key] + ' ' + patchDict[key].syntax.trim()
                    : patchDict[key].syntax;
            } else {
                delete result[key];
            }
        } else {
            if (patchDict[key].syntax) {
                result[key] = patchDict[key].syntax.replace(extendSyntax, '');
            }
        }
    }

    return result;
}

function unpackSyntaxes(dict) {
    const result = {};

    for (const key in dict) {
        result[key] = dict[key].syntax;
    }

    return result;
}

function patchAtrules(dict, patchDict) {
    const result = {};

    // copy all syntaxes for an original dict
    for (const key in dict) {
        const patchDescriptors = (patchDict[key] && patchDict[key].descriptors) || null;

        result[key] = {
            prelude: key in patchDict && 'prelude' in patchDict[key]
                ? patchDict[key].prelude
                : dict[key].prelude || null,
            descriptors: dict[key].descriptors
                ? patchDictionary(dict[key].descriptors, patchDescriptors || {})
                : patchDescriptors && unpackSyntaxes(patchDescriptors)
        };
    }

    // apply a patch
    for (const key in patchDict) {
        if (!hasOwnProperty.call(dict, key)) {
            result[key] = {
                prelude: patchDict[key].prelude || null,
                descriptors: patchDict[key].descriptors && unpackSyntaxes(patchDict[key].descriptors)
            };
        }
    }

    return result;
}

module.exports = {
    types: patchDictionary(mdnSyntaxes, patch.syntaxes),
    atrules: patchAtrules(preprocessAtrules(mdnAtrules), patch.atrules),
    properties: patchDictionary(mdnProperties, patch.properties)
};


/***/ }),

/***/ "./node_modules/css-tree/lib/common/List.js":
/*!**************************************************!*\
  !*** ./node_modules/css-tree/lib/common/List.js ***!
  \**************************************************/
/***/ (function(module) {

//
//                              list
//                            ┌──────┐
//             ┌──────────────┼─head │
//             │              │ tail─┼──────────────┐
//             │              └──────┘              │
//             ▼                                    ▼
//            item        item        item        item
//          ┌──────┐    ┌──────┐    ┌──────┐    ┌──────┐
//  null ◀──┼─prev │◀───┼─prev │◀───┼─prev │◀───┼─prev │
//          │ next─┼───▶│ next─┼───▶│ next─┼───▶│ next─┼──▶ null
//          ├──────┤    ├──────┤    ├──────┤    ├──────┤
//          │ data │    │ data │    │ data │    │ data │
//          └──────┘    └──────┘    └──────┘    └──────┘
//

function createItem(data) {
    return {
        prev: null,
        next: null,
        data: data
    };
}

function allocateCursor(node, prev, next) {
    var cursor;

    if (cursors !== null) {
        cursor = cursors;
        cursors = cursors.cursor;
        cursor.prev = prev;
        cursor.next = next;
        cursor.cursor = node.cursor;
    } else {
        cursor = {
            prev: prev,
            next: next,
            cursor: node.cursor
        };
    }

    node.cursor = cursor;

    return cursor;
}

function releaseCursor(node) {
    var cursor = node.cursor;

    node.cursor = cursor.cursor;
    cursor.prev = null;
    cursor.next = null;
    cursor.cursor = cursors;
    cursors = cursor;
}

var cursors = null;
var List = function() {
    this.cursor = null;
    this.head = null;
    this.tail = null;
};

List.createItem = createItem;
List.prototype.createItem = createItem;

List.prototype.updateCursors = function(prevOld, prevNew, nextOld, nextNew) {
    var cursor = this.cursor;

    while (cursor !== null) {
        if (cursor.prev === prevOld) {
            cursor.prev = prevNew;
        }

        if (cursor.next === nextOld) {
            cursor.next = nextNew;
        }

        cursor = cursor.cursor;
    }
};

List.prototype.getSize = function() {
    var size = 0;
    var cursor = this.head;

    while (cursor) {
        size++;
        cursor = cursor.next;
    }

    return size;
};

List.prototype.fromArray = function(array) {
    var cursor = null;

    this.head = null;

    for (var i = 0; i < array.length; i++) {
        var item = createItem(array[i]);

        if (cursor !== null) {
            cursor.next = item;
        } else {
            this.head = item;
        }

        item.prev = cursor;
        cursor = item;
    }

    this.tail = cursor;

    return this;
};

List.prototype.toArray = function() {
    var cursor = this.head;
    var result = [];

    while (cursor) {
        result.push(cursor.data);
        cursor = cursor.next;
    }

    return result;
};

List.prototype.toJSON = List.prototype.toArray;

List.prototype.isEmpty = function() {
    return this.head === null;
};

List.prototype.first = function() {
    return this.head && this.head.data;
};

List.prototype.last = function() {
    return this.tail && this.tail.data;
};

List.prototype.each = function(fn, context) {
    var item;

    if (context === undefined) {
        context = this;
    }

    // push cursor
    var cursor = allocateCursor(this, null, this.head);

    while (cursor.next !== null) {
        item = cursor.next;
        cursor.next = item.next;

        fn.call(context, item.data, item, this);
    }

    // pop cursor
    releaseCursor(this);
};

List.prototype.forEach = List.prototype.each;

List.prototype.eachRight = function(fn, context) {
    var item;

    if (context === undefined) {
        context = this;
    }

    // push cursor
    var cursor = allocateCursor(this, this.tail, null);

    while (cursor.prev !== null) {
        item = cursor.prev;
        cursor.prev = item.prev;

        fn.call(context, item.data, item, this);
    }

    // pop cursor
    releaseCursor(this);
};

List.prototype.forEachRight = List.prototype.eachRight;

List.prototype.reduce = function(fn, initialValue, context) {
    var item;

    if (context === undefined) {
        context = this;
    }

    // push cursor
    var cursor = allocateCursor(this, null, this.head);
    var acc = initialValue;

    while (cursor.next !== null) {
        item = cursor.next;
        cursor.next = item.next;

        acc = fn.call(context, acc, item.data, item, this);
    }

    // pop cursor
    releaseCursor(this);

    return acc;
};

List.prototype.reduceRight = function(fn, initialValue, context) {
    var item;

    if (context === undefined) {
        context = this;
    }

    // push cursor
    var cursor = allocateCursor(this, this.tail, null);
    var acc = initialValue;

    while (cursor.prev !== null) {
        item = cursor.prev;
        cursor.prev = item.prev;

        acc = fn.call(context, acc, item.data, item, this);
    }

    // pop cursor
    releaseCursor(this);

    return acc;
};

List.prototype.nextUntil = function(start, fn, context) {
    if (start === null) {
        return;
    }

    var item;

    if (context === undefined) {
        context = this;
    }

    // push cursor
    var cursor = allocateCursor(this, null, start);

    while (cursor.next !== null) {
        item = cursor.next;
        cursor.next = item.next;

        if (fn.call(context, item.data, item, this)) {
            break;
        }
    }

    // pop cursor
    releaseCursor(this);
};

List.prototype.prevUntil = function(start, fn, context) {
    if (start === null) {
        return;
    }

    var item;

    if (context === undefined) {
        context = this;
    }

    // push cursor
    var cursor = allocateCursor(this, start, null);

    while (cursor.prev !== null) {
        item = cursor.prev;
        cursor.prev = item.prev;

        if (fn.call(context, item.data, item, this)) {
            break;
        }
    }

    // pop cursor
    releaseCursor(this);
};

List.prototype.some = function(fn, context) {
    var cursor = this.head;

    if (context === undefined) {
        context = this;
    }

    while (cursor !== null) {
        if (fn.call(context, cursor.data, cursor, this)) {
            return true;
        }

        cursor = cursor.next;
    }

    return false;
};

List.prototype.map = function(fn, context) {
    var result = new List();
    var cursor = this.head;

    if (context === undefined) {
        context = this;
    }

    while (cursor !== null) {
        result.appendData(fn.call(context, cursor.data, cursor, this));
        cursor = cursor.next;
    }

    return result;
};

List.prototype.filter = function(fn, context) {
    var result = new List();
    var cursor = this.head;

    if (context === undefined) {
        context = this;
    }

    while (cursor !== null) {
        if (fn.call(context, cursor.data, cursor, this)) {
            result.appendData(cursor.data);
        }
        cursor = cursor.next;
    }

    return result;
};

List.prototype.clear = function() {
    this.head = null;
    this.tail = null;
};

List.prototype.copy = function() {
    var result = new List();
    var cursor = this.head;

    while (cursor !== null) {
        result.insert(createItem(cursor.data));
        cursor = cursor.next;
    }

    return result;
};

List.prototype.prepend = function(item) {
    //      head
    //    ^
    // item
    this.updateCursors(null, item, this.head, item);

    // insert to the beginning of the list
    if (this.head !== null) {
        // new item <- first item
        this.head.prev = item;

        // new item -> first item
        item.next = this.head;
    } else {
        // if list has no head, then it also has no tail
        // in this case tail points to the new item
        this.tail = item;
    }

    // head always points to new item
    this.head = item;

    return this;
};

List.prototype.prependData = function(data) {
    return this.prepend(createItem(data));
};

List.prototype.append = function(item) {
    return this.insert(item);
};

List.prototype.appendData = function(data) {
    return this.insert(createItem(data));
};

List.prototype.insert = function(item, before) {
    if (before !== undefined && before !== null) {
        // prev   before
        //      ^
        //     item
        this.updateCursors(before.prev, item, before, item);

        if (before.prev === null) {
            // insert to the beginning of list
            if (this.head !== before) {
                throw new Error('before doesn\'t belong to list');
            }

            // since head points to before therefore list doesn't empty
            // no need to check tail
            this.head = item;
            before.prev = item;
            item.next = before;

            this.updateCursors(null, item);
        } else {

            // insert between two items
            before.prev.next = item;
            item.prev = before.prev;

            before.prev = item;
            item.next = before;
        }
    } else {
        // tail
        //      ^
        //      item
        this.updateCursors(this.tail, item, null, item);

        // insert to the ending of the list
        if (this.tail !== null) {
            // last item -> new item
            this.tail.next = item;

            // last item <- new item
            item.prev = this.tail;
        } else {
            // if list has no tail, then it also has no head
            // in this case head points to new item
            this.head = item;
        }

        // tail always points to new item
        this.tail = item;
    }

    return this;
};

List.prototype.insertData = function(data, before) {
    return this.insert(createItem(data), before);
};

List.prototype.remove = function(item) {
    //      item
    //       ^
    // prev     next
    this.updateCursors(item, item.prev, item, item.next);

    if (item.prev !== null) {
        item.prev.next = item.next;
    } else {
        if (this.head !== item) {
            throw new Error('item doesn\'t belong to list');
        }

        this.head = item.next;
    }

    if (item.next !== null) {
        item.next.prev = item.prev;
    } else {
        if (this.tail !== item) {
            throw new Error('item doesn\'t belong to list');
        }

        this.tail = item.prev;
    }

    item.prev = null;
    item.next = null;

    return item;
};

List.prototype.push = function(data) {
    this.insert(createItem(data));
};

List.prototype.pop = function() {
    if (this.tail !== null) {
        return this.remove(this.tail);
    }
};

List.prototype.unshift = function(data) {
    this.prepend(createItem(data));
};

List.prototype.shift = function() {
    if (this.head !== null) {
        return this.remove(this.head);
    }
};

List.prototype.prependList = function(list) {
    return this.insertList(list, this.head);
};

List.prototype.appendList = function(list) {
    return this.insertList(list);
};

List.prototype.insertList = function(list, before) {
    // ignore empty lists
    if (list.head === null) {
        return this;
    }

    if (before !== undefined && before !== null) {
        this.updateCursors(before.prev, list.tail, before, list.head);

        // insert in the middle of dist list
        if (before.prev !== null) {
            // before.prev <-> list.head
            before.prev.next = list.head;
            list.head.prev = before.prev;
        } else {
            this.head = list.head;
        }

        before.prev = list.tail;
        list.tail.next = before;
    } else {
        this.updateCursors(this.tail, list.tail, null, list.head);

        // insert to end of the list
        if (this.tail !== null) {
            // if destination list has a tail, then it also has a head,
            // but head doesn't change

            // dest tail -> source head
            this.tail.next = list.head;

            // dest tail <- source head
            list.head.prev = this.tail;
        } else {
            // if list has no a tail, then it also has no a head
            // in this case points head to new item
            this.head = list.head;
        }

        // tail always start point to new item
        this.tail = list.tail;
    }

    list.head = null;
    list.tail = null;

    return this;
};

List.prototype.replace = function(oldItem, newItemOrList) {
    if ('head' in newItemOrList) {
        this.insertList(newItemOrList, oldItem);
    } else {
        this.insert(newItemOrList, oldItem);
    }

    this.remove(oldItem);
};

module.exports = List;


/***/ }),

/***/ "./node_modules/css-tree/lib/common/OffsetToLocation.js":
/*!**************************************************************!*\
  !*** ./node_modules/css-tree/lib/common/OffsetToLocation.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var adoptBuffer = __webpack_require__(/*! ./adopt-buffer */ "./node_modules/css-tree/lib/common/adopt-buffer.js");
var isBOM = (__webpack_require__(/*! ../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").isBOM);

var N = 10;
var F = 12;
var R = 13;

function computeLinesAndColumns(host, source) {
    var sourceLength = source.length;
    var lines = adoptBuffer(host.lines, sourceLength); // +1
    var line = host.startLine;
    var columns = adoptBuffer(host.columns, sourceLength);
    var column = host.startColumn;
    var startOffset = source.length > 0 ? isBOM(source.charCodeAt(0)) : 0;

    for (var i = startOffset; i < sourceLength; i++) { // -1
        var code = source.charCodeAt(i);

        lines[i] = line;
        columns[i] = column++;

        if (code === N || code === R || code === F) {
            if (code === R && i + 1 < sourceLength && source.charCodeAt(i + 1) === N) {
                i++;
                lines[i] = line;
                columns[i] = column;
            }

            line++;
            column = 1;
        }
    }

    lines[i] = line;
    columns[i] = column;

    host.lines = lines;
    host.columns = columns;
}

var OffsetToLocation = function() {
    this.lines = null;
    this.columns = null;
    this.linesAndColumnsComputed = false;
};

OffsetToLocation.prototype = {
    setSource: function(source, startOffset, startLine, startColumn) {
        this.source = source;
        this.startOffset = typeof startOffset === 'undefined' ? 0 : startOffset;
        this.startLine = typeof startLine === 'undefined' ? 1 : startLine;
        this.startColumn = typeof startColumn === 'undefined' ? 1 : startColumn;
        this.linesAndColumnsComputed = false;
    },

    ensureLinesAndColumnsComputed: function() {
        if (!this.linesAndColumnsComputed) {
            computeLinesAndColumns(this, this.source);
            this.linesAndColumnsComputed = true;
        }
    },
    getLocation: function(offset, filename) {
        this.ensureLinesAndColumnsComputed();

        return {
            source: filename,
            offset: this.startOffset + offset,
            line: this.lines[offset],
            column: this.columns[offset]
        };
    },
    getLocationRange: function(start, end, filename) {
        this.ensureLinesAndColumnsComputed();

        return {
            source: filename,
            start: {
                offset: this.startOffset + start,
                line: this.lines[start],
                column: this.columns[start]
            },
            end: {
                offset: this.startOffset + end,
                line: this.lines[end],
                column: this.columns[end]
            }
        };
    }
};

module.exports = OffsetToLocation;


/***/ }),

/***/ "./node_modules/css-tree/lib/common/SyntaxError.js":
/*!*********************************************************!*\
  !*** ./node_modules/css-tree/lib/common/SyntaxError.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCustomError = __webpack_require__(/*! ../utils/createCustomError */ "./node_modules/css-tree/lib/utils/createCustomError.js");
var MAX_LINE_LENGTH = 100;
var OFFSET_CORRECTION = 60;
var TAB_REPLACEMENT = '    ';

function sourceFragment(error, extraLines) {
    function processLines(start, end) {
        return lines.slice(start, end).map(function(line, idx) {
            var num = String(start + idx + 1);

            while (num.length < maxNumLength) {
                num = ' ' + num;
            }

            return num + ' |' + line;
        }).join('\n');
    }

    var lines = error.source.split(/\r\n?|\n|\f/);
    var line = error.line;
    var column = error.column;
    var startLine = Math.max(1, line - extraLines) - 1;
    var endLine = Math.min(line + extraLines, lines.length + 1);
    var maxNumLength = Math.max(4, String(endLine).length) + 1;
    var cutLeft = 0;

    // column correction according to replaced tab before column
    column += (TAB_REPLACEMENT.length - 1) * (lines[line - 1].substr(0, column - 1).match(/\t/g) || []).length;

    if (column > MAX_LINE_LENGTH) {
        cutLeft = column - OFFSET_CORRECTION + 3;
        column = OFFSET_CORRECTION - 2;
    }

    for (var i = startLine; i <= endLine; i++) {
        if (i >= 0 && i < lines.length) {
            lines[i] = lines[i].replace(/\t/g, TAB_REPLACEMENT);
            lines[i] =
                (cutLeft > 0 && lines[i].length > cutLeft ? '\u2026' : '') +
                lines[i].substr(cutLeft, MAX_LINE_LENGTH - 2) +
                (lines[i].length > cutLeft + MAX_LINE_LENGTH - 1 ? '\u2026' : '');
        }
    }

    return [
        processLines(startLine, line),
        new Array(column + maxNumLength + 2).join('-') + '^',
        processLines(line, endLine)
    ].filter(Boolean).join('\n');
}

var SyntaxError = function(message, source, offset, line, column) {
    var error = createCustomError('SyntaxError', message);

    error.source = source;
    error.offset = offset;
    error.line = line;
    error.column = column;

    error.sourceFragment = function(extraLines) {
        return sourceFragment(error, isNaN(extraLines) ? 0 : extraLines);
    };
    Object.defineProperty(error, 'formattedMessage', {
        get: function() {
            return (
                'Parse error: ' + error.message + '\n' +
                sourceFragment(error, 2)
            );
        }
    });

    // for backward capability
    error.parseError = {
        offset: offset,
        line: line,
        column: column
    };

    return error;
};

module.exports = SyntaxError;


/***/ }),

/***/ "./node_modules/css-tree/lib/common/TokenStream.js":
/*!*********************************************************!*\
  !*** ./node_modules/css-tree/lib/common/TokenStream.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constants = __webpack_require__(/*! ../tokenizer/const */ "./node_modules/css-tree/lib/tokenizer/const.js");
var TYPE = constants.TYPE;
var NAME = constants.NAME;

var utils = __webpack_require__(/*! ../tokenizer/utils */ "./node_modules/css-tree/lib/tokenizer/utils.js");
var cmpStr = utils.cmpStr;

var EOF = TYPE.EOF;
var WHITESPACE = TYPE.WhiteSpace;
var COMMENT = TYPE.Comment;

var OFFSET_MASK = 0x00FFFFFF;
var TYPE_SHIFT = 24;

var TokenStream = function() {
    this.offsetAndType = null;
    this.balance = null;

    this.reset();
};

TokenStream.prototype = {
    reset: function() {
        this.eof = false;
        this.tokenIndex = -1;
        this.tokenType = 0;
        this.tokenStart = this.firstCharOffset;
        this.tokenEnd = this.firstCharOffset;
    },

    lookupType: function(offset) {
        offset += this.tokenIndex;

        if (offset < this.tokenCount) {
            return this.offsetAndType[offset] >> TYPE_SHIFT;
        }

        return EOF;
    },
    lookupOffset: function(offset) {
        offset += this.tokenIndex;

        if (offset < this.tokenCount) {
            return this.offsetAndType[offset - 1] & OFFSET_MASK;
        }

        return this.source.length;
    },
    lookupValue: function(offset, referenceStr) {
        offset += this.tokenIndex;

        if (offset < this.tokenCount) {
            return cmpStr(
                this.source,
                this.offsetAndType[offset - 1] & OFFSET_MASK,
                this.offsetAndType[offset] & OFFSET_MASK,
                referenceStr
            );
        }

        return false;
    },
    getTokenStart: function(tokenIndex) {
        if (tokenIndex === this.tokenIndex) {
            return this.tokenStart;
        }

        if (tokenIndex > 0) {
            return tokenIndex < this.tokenCount
                ? this.offsetAndType[tokenIndex - 1] & OFFSET_MASK
                : this.offsetAndType[this.tokenCount] & OFFSET_MASK;
        }

        return this.firstCharOffset;
    },

    // TODO: -> skipUntilBalanced
    getRawLength: function(startToken, mode) {
        var cursor = startToken;
        var balanceEnd;
        var offset = this.offsetAndType[Math.max(cursor - 1, 0)] & OFFSET_MASK;
        var type;

        loop:
        for (; cursor < this.tokenCount; cursor++) {
            balanceEnd = this.balance[cursor];

            // stop scanning on balance edge that points to offset before start token
            if (balanceEnd < startToken) {
                break loop;
            }

            type = this.offsetAndType[cursor] >> TYPE_SHIFT;

            // check token is stop type
            switch (mode(type, this.source, offset)) {
                case 1:
                    break loop;

                case 2:
                    cursor++;
                    break loop;

                default:
                    // fast forward to the end of balanced block
                    if (this.balance[balanceEnd] === cursor) {
                        cursor = balanceEnd;
                    }

                    offset = this.offsetAndType[cursor] & OFFSET_MASK;
            }
        }

        return cursor - this.tokenIndex;
    },
    isBalanceEdge: function(pos) {
        return this.balance[this.tokenIndex] < pos;
    },
    isDelim: function(code, offset) {
        if (offset) {
            return (
                this.lookupType(offset) === TYPE.Delim &&
                this.source.charCodeAt(this.lookupOffset(offset)) === code
            );
        }

        return (
            this.tokenType === TYPE.Delim &&
            this.source.charCodeAt(this.tokenStart) === code
        );
    },

    getTokenValue: function() {
        return this.source.substring(this.tokenStart, this.tokenEnd);
    },
    getTokenLength: function() {
        return this.tokenEnd - this.tokenStart;
    },
    substrToCursor: function(start) {
        return this.source.substring(start, this.tokenStart);
    },

    skipWS: function() {
        for (var i = this.tokenIndex, skipTokenCount = 0; i < this.tokenCount; i++, skipTokenCount++) {
            if ((this.offsetAndType[i] >> TYPE_SHIFT) !== WHITESPACE) {
                break;
            }
        }

        if (skipTokenCount > 0) {
            this.skip(skipTokenCount);
        }
    },
    skipSC: function() {
        while (this.tokenType === WHITESPACE || this.tokenType === COMMENT) {
            this.next();
        }
    },
    skip: function(tokenCount) {
        var next = this.tokenIndex + tokenCount;

        if (next < this.tokenCount) {
            this.tokenIndex = next;
            this.tokenStart = this.offsetAndType[next - 1] & OFFSET_MASK;
            next = this.offsetAndType[next];
            this.tokenType = next >> TYPE_SHIFT;
            this.tokenEnd = next & OFFSET_MASK;
        } else {
            this.tokenIndex = this.tokenCount;
            this.next();
        }
    },
    next: function() {
        var next = this.tokenIndex + 1;

        if (next < this.tokenCount) {
            this.tokenIndex = next;
            this.tokenStart = this.tokenEnd;
            next = this.offsetAndType[next];
            this.tokenType = next >> TYPE_SHIFT;
            this.tokenEnd = next & OFFSET_MASK;
        } else {
            this.tokenIndex = this.tokenCount;
            this.eof = true;
            this.tokenType = EOF;
            this.tokenStart = this.tokenEnd = this.source.length;
        }
    },

    forEachToken(fn) {
        for (var i = 0, offset = this.firstCharOffset; i < this.tokenCount; i++) {
            var start = offset;
            var item = this.offsetAndType[i];
            var end = item & OFFSET_MASK;
            var type = item >> TYPE_SHIFT;

            offset = end;

            fn(type, start, end, i);
        }
    },

    dump() {
        var tokens = new Array(this.tokenCount);

        this.forEachToken((type, start, end, index) => {
            tokens[index] = {
                idx: index,
                type: NAME[type],
                chunk: this.source.substring(start, end),
                balance: this.balance[index]
            };
        });

        return tokens;
    }
};

module.exports = TokenStream;


/***/ }),

/***/ "./node_modules/css-tree/lib/common/adopt-buffer.js":
/*!**********************************************************!*\
  !*** ./node_modules/css-tree/lib/common/adopt-buffer.js ***!
  \**********************************************************/
/***/ (function(module) {

var MIN_SIZE = 16 * 1024;
var SafeUint32Array = typeof Uint32Array !== 'undefined' ? Uint32Array : Array; // fallback on Array when TypedArray is not supported

module.exports = function adoptBuffer(buffer, size) {
    if (buffer === null || buffer.length < size) {
        return new SafeUint32Array(Math.max(size + 1024, MIN_SIZE));
    }

    return buffer;
};


/***/ }),

/***/ "./node_modules/css-tree/lib/convertor/create.js":
/*!*******************************************************!*\
  !*** ./node_modules/css-tree/lib/convertor/create.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var List = __webpack_require__(/*! ../common/List */ "./node_modules/css-tree/lib/common/List.js");

module.exports = function createConvertors(walk) {
    return {
        fromPlainObject: function(ast) {
            walk(ast, {
                enter: function(node) {
                    if (node.children && node.children instanceof List === false) {
                        node.children = new List().fromArray(node.children);
                    }
                }
            });

            return ast;
        },
        toPlainObject: function(ast) {
            walk(ast, {
                leave: function(node) {
                    if (node.children && node.children instanceof List) {
                        node.children = node.children.toArray();
                    }
                }
            });

            return ast;
        }
    };
};


/***/ }),

/***/ "./node_modules/css-tree/lib/definition-syntax/SyntaxError.js":
/*!********************************************************************!*\
  !*** ./node_modules/css-tree/lib/definition-syntax/SyntaxError.js ***!
  \********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCustomError = __webpack_require__(/*! ../utils/createCustomError */ "./node_modules/css-tree/lib/utils/createCustomError.js");

module.exports = function SyntaxError(message, input, offset) {
    var error = createCustomError('SyntaxError', message);

    error.input = input;
    error.offset = offset;
    error.rawMessage = message;
    error.message = error.rawMessage + '\n' +
        '  ' + error.input + '\n' +
        '--' + new Array((error.offset || error.input.length) + 1).join('-') + '^';

    return error;
};


/***/ }),

/***/ "./node_modules/css-tree/lib/definition-syntax/generate.js":
/*!*****************************************************************!*\
  !*** ./node_modules/css-tree/lib/definition-syntax/generate.js ***!
  \*****************************************************************/
/***/ (function(module) {

function noop(value) {
    return value;
}

function generateMultiplier(multiplier) {
    if (multiplier.min === 0 && multiplier.max === 0) {
        return '*';
    }

    if (multiplier.min === 0 && multiplier.max === 1) {
        return '?';
    }

    if (multiplier.min === 1 && multiplier.max === 0) {
        return multiplier.comma ? '#' : '+';
    }

    if (multiplier.min === 1 && multiplier.max === 1) {
        return '';
    }

    return (
        (multiplier.comma ? '#' : '') +
        (multiplier.min === multiplier.max
            ? '{' + multiplier.min + '}'
            : '{' + multiplier.min + ',' + (multiplier.max !== 0 ? multiplier.max : '') + '}'
        )
    );
}

function generateTypeOpts(node) {
    switch (node.type) {
        case 'Range':
            return (
                ' [' +
                (node.min === null ? '-∞' : node.min) +
                ',' +
                (node.max === null ? '∞' : node.max) +
                ']'
            );

        default:
            throw new Error('Unknown node type `' + node.type + '`');
    }
}

function generateSequence(node, decorate, forceBraces, compact) {
    var combinator = node.combinator === ' ' || compact ? node.combinator : ' ' + node.combinator + ' ';
    var result = node.terms.map(function(term) {
        return generate(term, decorate, forceBraces, compact);
    }).join(combinator);

    if (node.explicit || forceBraces) {
        result = (compact || result[0] === ',' ? '[' : '[ ') + result + (compact ? ']' : ' ]');
    }

    return result;
}

function generate(node, decorate, forceBraces, compact) {
    var result;

    switch (node.type) {
        case 'Group':
            result =
                generateSequence(node, decorate, forceBraces, compact) +
                (node.disallowEmpty ? '!' : '');
            break;

        case 'Multiplier':
            // return since node is a composition
            return (
                generate(node.term, decorate, forceBraces, compact) +
                decorate(generateMultiplier(node), node)
            );

        case 'Type':
            result = '<' + node.name + (node.opts ? decorate(generateTypeOpts(node.opts), node.opts) : '') + '>';
            break;

        case 'Property':
            result = '<\'' + node.name + '\'>';
            break;

        case 'Keyword':
            result = node.name;
            break;

        case 'AtKeyword':
            result = '@' + node.name;
            break;

        case 'Function':
            result = node.name + '(';
            break;

        case 'String':
        case 'Token':
            result = node.value;
            break;

        case 'Comma':
            result = ',';
            break;

        default:
            throw new Error('Unknown node type `' + node.type + '`');
    }

    return decorate(result, node);
}

module.exports = function(node, options) {
    var decorate = noop;
    var forceBraces = false;
    var compact = false;

    if (typeof options === 'function') {
        decorate = options;
    } else if (options) {
        forceBraces = Boolean(options.forceBraces);
        compact = Boolean(options.compact);
        if (typeof options.decorate === 'function') {
            decorate = options.decorate;
        }
    }

    return generate(node, decorate, forceBraces, compact);
};


/***/ }),

/***/ "./node_modules/css-tree/lib/definition-syntax/index.js":
/*!**************************************************************!*\
  !*** ./node_modules/css-tree/lib/definition-syntax/index.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
    SyntaxError: __webpack_require__(/*! ./SyntaxError */ "./node_modules/css-tree/lib/definition-syntax/SyntaxError.js"),
    parse: __webpack_require__(/*! ./parse */ "./node_modules/css-tree/lib/definition-syntax/parse.js"),
    generate: __webpack_require__(/*! ./generate */ "./node_modules/css-tree/lib/definition-syntax/generate.js"),
    walk: __webpack_require__(/*! ./walk */ "./node_modules/css-tree/lib/definition-syntax/walk.js")
};


/***/ }),

/***/ "./node_modules/css-tree/lib/definition-syntax/parse.js":
/*!**************************************************************!*\
  !*** ./node_modules/css-tree/lib/definition-syntax/parse.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Tokenizer = __webpack_require__(/*! ./tokenizer */ "./node_modules/css-tree/lib/definition-syntax/tokenizer.js");
var TAB = 9;
var N = 10;
var F = 12;
var R = 13;
var SPACE = 32;
var EXCLAMATIONMARK = 33;    // !
var NUMBERSIGN = 35;         // #
var AMPERSAND = 38;          // &
var APOSTROPHE = 39;         // '
var LEFTPARENTHESIS = 40;    // (
var RIGHTPARENTHESIS = 41;   // )
var ASTERISK = 42;           // *
var PLUSSIGN = 43;           // +
var COMMA = 44;              // ,
var HYPERMINUS = 45;         // -
var LESSTHANSIGN = 60;       // <
var GREATERTHANSIGN = 62;    // >
var QUESTIONMARK = 63;       // ?
var COMMERCIALAT = 64;       // @
var LEFTSQUAREBRACKET = 91;  // [
var RIGHTSQUAREBRACKET = 93; // ]
var LEFTCURLYBRACKET = 123;  // {
var VERTICALLINE = 124;      // |
var RIGHTCURLYBRACKET = 125; // }
var INFINITY = 8734;         // ∞
var NAME_CHAR = createCharMap(function(ch) {
    return /[a-zA-Z0-9\-]/.test(ch);
});
var COMBINATOR_PRECEDENCE = {
    ' ': 1,
    '&&': 2,
    '||': 3,
    '|': 4
};

function createCharMap(fn) {
    var array = typeof Uint32Array === 'function' ? new Uint32Array(128) : new Array(128);
    for (var i = 0; i < 128; i++) {
        array[i] = fn(String.fromCharCode(i)) ? 1 : 0;
    }
    return array;
}

function scanSpaces(tokenizer) {
    return tokenizer.substringToPos(
        tokenizer.findWsEnd(tokenizer.pos)
    );
}

function scanWord(tokenizer) {
    var end = tokenizer.pos;

    for (; end < tokenizer.str.length; end++) {
        var code = tokenizer.str.charCodeAt(end);
        if (code >= 128 || NAME_CHAR[code] === 0) {
            break;
        }
    }

    if (tokenizer.pos === end) {
        tokenizer.error('Expect a keyword');
    }

    return tokenizer.substringToPos(end);
}

function scanNumber(tokenizer) {
    var end = tokenizer.pos;

    for (; end < tokenizer.str.length; end++) {
        var code = tokenizer.str.charCodeAt(end);
        if (code < 48 || code > 57) {
            break;
        }
    }

    if (tokenizer.pos === end) {
        tokenizer.error('Expect a number');
    }

    return tokenizer.substringToPos(end);
}

function scanString(tokenizer) {
    var end = tokenizer.str.indexOf('\'', tokenizer.pos + 1);

    if (end === -1) {
        tokenizer.pos = tokenizer.str.length;
        tokenizer.error('Expect an apostrophe');
    }

    return tokenizer.substringToPos(end + 1);
}

function readMultiplierRange(tokenizer) {
    var min = null;
    var max = null;

    tokenizer.eat(LEFTCURLYBRACKET);

    min = scanNumber(tokenizer);

    if (tokenizer.charCode() === COMMA) {
        tokenizer.pos++;
        if (tokenizer.charCode() !== RIGHTCURLYBRACKET) {
            max = scanNumber(tokenizer);
        }
    } else {
        max = min;
    }

    tokenizer.eat(RIGHTCURLYBRACKET);

    return {
        min: Number(min),
        max: max ? Number(max) : 0
    };
}

function readMultiplier(tokenizer) {
    var range = null;
    var comma = false;

    switch (tokenizer.charCode()) {
        case ASTERISK:
            tokenizer.pos++;

            range = {
                min: 0,
                max: 0
            };

            break;

        case PLUSSIGN:
            tokenizer.pos++;

            range = {
                min: 1,
                max: 0
            };

            break;

        case QUESTIONMARK:
            tokenizer.pos++;

            range = {
                min: 0,
                max: 1
            };

            break;

        case NUMBERSIGN:
            tokenizer.pos++;

            comma = true;

            if (tokenizer.charCode() === LEFTCURLYBRACKET) {
                range = readMultiplierRange(tokenizer);
            } else {
                range = {
                    min: 1,
                    max: 0
                };
            }

            break;

        case LEFTCURLYBRACKET:
            range = readMultiplierRange(tokenizer);
            break;

        default:
            return null;
    }

    return {
        type: 'Multiplier',
        comma: comma,
        min: range.min,
        max: range.max,
        term: null
    };
}

function maybeMultiplied(tokenizer, node) {
    var multiplier = readMultiplier(tokenizer);

    if (multiplier !== null) {
        multiplier.term = node;
        return multiplier;
    }

    return node;
}

function maybeToken(tokenizer) {
    var ch = tokenizer.peek();

    if (ch === '') {
        return null;
    }

    return {
        type: 'Token',
        value: ch
    };
}

function readProperty(tokenizer) {
    var name;

    tokenizer.eat(LESSTHANSIGN);
    tokenizer.eat(APOSTROPHE);

    name = scanWord(tokenizer);

    tokenizer.eat(APOSTROPHE);
    tokenizer.eat(GREATERTHANSIGN);

    return maybeMultiplied(tokenizer, {
        type: 'Property',
        name: name
    });
}

// https://drafts.csswg.org/css-values-3/#numeric-ranges
// 4.1. Range Restrictions and Range Definition Notation
//
// Range restrictions can be annotated in the numeric type notation using CSS bracketed
// range notation—[min,max]—within the angle brackets, after the identifying keyword,
// indicating a closed range between (and including) min and max.
// For example, <integer [0, 10]> indicates an integer between 0 and 10, inclusive.
function readTypeRange(tokenizer) {
    // use null for Infinity to make AST format JSON serializable/deserializable
    var min = null; // -Infinity
    var max = null; // Infinity
    var sign = 1;

    tokenizer.eat(LEFTSQUAREBRACKET);

    if (tokenizer.charCode() === HYPERMINUS) {
        tokenizer.peek();
        sign = -1;
    }

    if (sign == -1 && tokenizer.charCode() === INFINITY) {
        tokenizer.peek();
    } else {
        min = sign * Number(scanNumber(tokenizer));
    }

    scanSpaces(tokenizer);
    tokenizer.eat(COMMA);
    scanSpaces(tokenizer);

    if (tokenizer.charCode() === INFINITY) {
        tokenizer.peek();
    } else {
        sign = 1;

        if (tokenizer.charCode() === HYPERMINUS) {
            tokenizer.peek();
            sign = -1;
        }

        max = sign * Number(scanNumber(tokenizer));
    }

    tokenizer.eat(RIGHTSQUAREBRACKET);

    // If no range is indicated, either by using the bracketed range notation
    // or in the property description, then [−∞,∞] is assumed.
    if (min === null && max === null) {
        return null;
    }

    return {
        type: 'Range',
        min: min,
        max: max
    };
}

function readType(tokenizer) {
    var name;
    var opts = null;

    tokenizer.eat(LESSTHANSIGN);
    name = scanWord(tokenizer);

    if (tokenizer.charCode() === LEFTPARENTHESIS &&
        tokenizer.nextCharCode() === RIGHTPARENTHESIS) {
        tokenizer.pos += 2;
        name += '()';
    }

    if (tokenizer.charCodeAt(tokenizer.findWsEnd(tokenizer.pos)) === LEFTSQUAREBRACKET) {
        scanSpaces(tokenizer);
        opts = readTypeRange(tokenizer);
    }

    tokenizer.eat(GREATERTHANSIGN);

    return maybeMultiplied(tokenizer, {
        type: 'Type',
        name: name,
        opts: opts
    });
}

function readKeywordOrFunction(tokenizer) {
    var name;

    name = scanWord(tokenizer);

    if (tokenizer.charCode() === LEFTPARENTHESIS) {
        tokenizer.pos++;

        return {
            type: 'Function',
            name: name
        };
    }

    return maybeMultiplied(tokenizer, {
        type: 'Keyword',
        name: name
    });
}

function regroupTerms(terms, combinators) {
    function createGroup(terms, combinator) {
        return {
            type: 'Group',
            terms: terms,
            combinator: combinator,
            disallowEmpty: false,
            explicit: false
        };
    }

    combinators = Object.keys(combinators).sort(function(a, b) {
        return COMBINATOR_PRECEDENCE[a] - COMBINATOR_PRECEDENCE[b];
    });

    while (combinators.length > 0) {
        var combinator = combinators.shift();
        for (var i = 0, subgroupStart = 0; i < terms.length; i++) {
            var term = terms[i];
            if (term.type === 'Combinator') {
                if (term.value === combinator) {
                    if (subgroupStart === -1) {
                        subgroupStart = i - 1;
                    }
                    terms.splice(i, 1);
                    i--;
                } else {
                    if (subgroupStart !== -1 && i - subgroupStart > 1) {
                        terms.splice(
                            subgroupStart,
                            i - subgroupStart,
                            createGroup(terms.slice(subgroupStart, i), combinator)
                        );
                        i = subgroupStart + 1;
                    }
                    subgroupStart = -1;
                }
            }
        }

        if (subgroupStart !== -1 && combinators.length) {
            terms.splice(
                subgroupStart,
                i - subgroupStart,
                createGroup(terms.slice(subgroupStart, i), combinator)
            );
        }
    }

    return combinator;
}

function readImplicitGroup(tokenizer) {
    var terms = [];
    var combinators = {};
    var token;
    var prevToken = null;
    var prevTokenPos = tokenizer.pos;

    while (token = peek(tokenizer)) {
        if (token.type !== 'Spaces') {
            if (token.type === 'Combinator') {
                // check for combinator in group beginning and double combinator sequence
                if (prevToken === null || prevToken.type === 'Combinator') {
                    tokenizer.pos = prevTokenPos;
                    tokenizer.error('Unexpected combinator');
                }

                combinators[token.value] = true;
            } else if (prevToken !== null && prevToken.type !== 'Combinator') {
                combinators[' '] = true;  // a b
                terms.push({
                    type: 'Combinator',
                    value: ' '
                });
            }

            terms.push(token);
            prevToken = token;
            prevTokenPos = tokenizer.pos;
        }
    }

    // check for combinator in group ending
    if (prevToken !== null && prevToken.type === 'Combinator') {
        tokenizer.pos -= prevTokenPos;
        tokenizer.error('Unexpected combinator');
    }

    return {
        type: 'Group',
        terms: terms,
        combinator: regroupTerms(terms, combinators) || ' ',
        disallowEmpty: false,
        explicit: false
    };
}

function readGroup(tokenizer) {
    var result;

    tokenizer.eat(LEFTSQUAREBRACKET);
    result = readImplicitGroup(tokenizer);
    tokenizer.eat(RIGHTSQUAREBRACKET);

    result.explicit = true;

    if (tokenizer.charCode() === EXCLAMATIONMARK) {
        tokenizer.pos++;
        result.disallowEmpty = true;
    }

    return result;
}

function peek(tokenizer) {
    var code = tokenizer.charCode();

    if (code < 128 && NAME_CHAR[code] === 1) {
        return readKeywordOrFunction(tokenizer);
    }

    switch (code) {
        case RIGHTSQUAREBRACKET:
            // don't eat, stop scan a group
            break;

        case LEFTSQUAREBRACKET:
            return maybeMultiplied(tokenizer, readGroup(tokenizer));

        case LESSTHANSIGN:
            return tokenizer.nextCharCode() === APOSTROPHE
                ? readProperty(tokenizer)
                : readType(tokenizer);

        case VERTICALLINE:
            return {
                type: 'Combinator',
                value: tokenizer.substringToPos(
                    tokenizer.nextCharCode() === VERTICALLINE
                        ? tokenizer.pos + 2
                        : tokenizer.pos + 1
                )
            };

        case AMPERSAND:
            tokenizer.pos++;
            tokenizer.eat(AMPERSAND);

            return {
                type: 'Combinator',
                value: '&&'
            };

        case COMMA:
            tokenizer.pos++;
            return {
                type: 'Comma'
            };

        case APOSTROPHE:
            return maybeMultiplied(tokenizer, {
                type: 'String',
                value: scanString(tokenizer)
            });

        case SPACE:
        case TAB:
        case N:
        case R:
        case F:
            return {
                type: 'Spaces',
                value: scanSpaces(tokenizer)
            };

        case COMMERCIALAT:
            code = tokenizer.nextCharCode();

            if (code < 128 && NAME_CHAR[code] === 1) {
                tokenizer.pos++;
                return {
                    type: 'AtKeyword',
                    name: scanWord(tokenizer)
                };
            }

            return maybeToken(tokenizer);

        case ASTERISK:
        case PLUSSIGN:
        case QUESTIONMARK:
        case NUMBERSIGN:
        case EXCLAMATIONMARK:
            // prohibited tokens (used as a multiplier start)
            break;

        case LEFTCURLYBRACKET:
            // LEFTCURLYBRACKET is allowed since mdn/data uses it w/o quoting
            // check next char isn't a number, because it's likely a disjoined multiplier
            code = tokenizer.nextCharCode();

            if (code < 48 || code > 57) {
                return maybeToken(tokenizer);
            }

            break;

        default:
            return maybeToken(tokenizer);
    }
}

function parse(source) {
    var tokenizer = new Tokenizer(source);
    var result = readImplicitGroup(tokenizer);

    if (tokenizer.pos !== source.length) {
        tokenizer.error('Unexpected input');
    }

    // reduce redundant groups with single group term
    if (result.terms.length === 1 && result.terms[0].type === 'Group') {
        result = result.terms[0];
    }

    return result;
}

// warm up parse to elimitate code branches that never execute
// fix soft deoptimizations (insufficient type feedback)
parse('[a&&<b>#|<\'c\'>*||e() f{2} /,(% g#{1,2} h{2,})]!');

module.exports = parse;


/***/ }),

/***/ "./node_modules/css-tree/lib/definition-syntax/tokenizer.js":
/*!******************************************************************!*\
  !*** ./node_modules/css-tree/lib/definition-syntax/tokenizer.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SyntaxError = __webpack_require__(/*! ./SyntaxError */ "./node_modules/css-tree/lib/definition-syntax/SyntaxError.js");

var TAB = 9;
var N = 10;
var F = 12;
var R = 13;
var SPACE = 32;

var Tokenizer = function(str) {
    this.str = str;
    this.pos = 0;
};

Tokenizer.prototype = {
    charCodeAt: function(pos) {
        return pos < this.str.length ? this.str.charCodeAt(pos) : 0;
    },
    charCode: function() {
        return this.charCodeAt(this.pos);
    },
    nextCharCode: function() {
        return this.charCodeAt(this.pos + 1);
    },
    nextNonWsCode: function(pos) {
        return this.charCodeAt(this.findWsEnd(pos));
    },
    findWsEnd: function(pos) {
        for (; pos < this.str.length; pos++) {
            var code = this.str.charCodeAt(pos);
            if (code !== R && code !== N && code !== F && code !== SPACE && code !== TAB) {
                break;
            }
        }

        return pos;
    },
    substringToPos: function(end) {
        return this.str.substring(this.pos, this.pos = end);
    },
    eat: function(code) {
        if (this.charCode() !== code) {
            this.error('Expect `' + String.fromCharCode(code) + '`');
        }

        this.pos++;
    },
    peek: function() {
        return this.pos < this.str.length ? this.str.charAt(this.pos++) : '';
    },
    error: function(message) {
        throw new SyntaxError(message, this.str, this.pos);
    }
};

module.exports = Tokenizer;


/***/ }),

/***/ "./node_modules/css-tree/lib/definition-syntax/walk.js":
/*!*************************************************************!*\
  !*** ./node_modules/css-tree/lib/definition-syntax/walk.js ***!
  \*************************************************************/
/***/ (function(module) {

var noop = function() {};

function ensureFunction(value) {
    return typeof value === 'function' ? value : noop;
}

module.exports = function(node, options, context) {
    function walk(node) {
        enter.call(context, node);

        switch (node.type) {
            case 'Group':
                node.terms.forEach(walk);
                break;

            case 'Multiplier':
                walk(node.term);
                break;

            case 'Type':
            case 'Property':
            case 'Keyword':
            case 'AtKeyword':
            case 'Function':
            case 'String':
            case 'Token':
            case 'Comma':
                break;

            default:
                throw new Error('Unknown type: ' + node.type);
        }

        leave.call(context, node);
    }

    var enter = noop;
    var leave = noop;

    if (typeof options === 'function') {
        enter = options;
    } else if (options) {
        enter = ensureFunction(options.enter);
        leave = ensureFunction(options.leave);
    }

    if (enter === noop && leave === noop) {
        throw new Error('Neither `enter` nor `leave` walker handler is set or both aren\'t a function');
    }

    walk(node, context);
};


/***/ }),

/***/ "./node_modules/css-tree/lib/generator/create.js":
/*!*******************************************************!*\
  !*** ./node_modules/css-tree/lib/generator/create.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var sourceMap = __webpack_require__(/*! ./sourceMap */ "./node_modules/css-tree/lib/generator/sourceMap.js");
var hasOwnProperty = Object.prototype.hasOwnProperty;

function processChildren(node, delimeter) {
    var list = node.children;
    var prev = null;

    if (typeof delimeter !== 'function') {
        list.forEach(this.node, this);
    } else {
        list.forEach(function(node) {
            if (prev !== null) {
                delimeter.call(this, prev);
            }

            this.node(node);
            prev = node;
        }, this);
    }
}

module.exports = function createGenerator(config) {
    function processNode(node) {
        if (hasOwnProperty.call(types, node.type)) {
            types[node.type].call(this, node);
        } else {
            throw new Error('Unknown node type: ' + node.type);
        }
    }

    var types = {};

    if (config.node) {
        for (var name in config.node) {
            types[name] = config.node[name].generate;
        }
    }

    return function(node, options) {
        var buffer = '';
        var handlers = {
            children: processChildren,
            node: processNode,
            chunk: function(chunk) {
                buffer += chunk;
            },
            result: function() {
                return buffer;
            }
        };

        if (options) {
            if (typeof options.decorator === 'function') {
                handlers = options.decorator(handlers);
            }

            if (options.sourceMap) {
                handlers = sourceMap(handlers);
            }
        }

        handlers.node(node);

        return handlers.result();
    };
};


/***/ }),

/***/ "./node_modules/css-tree/lib/generator/sourceMap.js":
/*!**********************************************************!*\
  !*** ./node_modules/css-tree/lib/generator/sourceMap.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SourceMapGenerator = (__webpack_require__(/*! source-map/lib/source-map-generator */ "./node_modules/source-map/lib/source-map-generator.js").SourceMapGenerator);
var trackNodes = {
    Atrule: true,
    Selector: true,
    Declaration: true
};

module.exports = function generateSourceMap(handlers) {
    var map = new SourceMapGenerator();
    var line = 1;
    var column = 0;
    var generated = {
        line: 1,
        column: 0
    };
    var original = {
        line: 0, // should be zero to add first mapping
        column: 0
    };
    var sourceMappingActive = false;
    var activatedGenerated = {
        line: 1,
        column: 0
    };
    var activatedMapping = {
        generated: activatedGenerated
    };

    var handlersNode = handlers.node;
    handlers.node = function(node) {
        if (node.loc && node.loc.start && trackNodes.hasOwnProperty(node.type)) {
            var nodeLine = node.loc.start.line;
            var nodeColumn = node.loc.start.column - 1;

            if (original.line !== nodeLine ||
                original.column !== nodeColumn) {
                original.line = nodeLine;
                original.column = nodeColumn;

                generated.line = line;
                generated.column = column;

                if (sourceMappingActive) {
                    sourceMappingActive = false;
                    if (generated.line !== activatedGenerated.line ||
                        generated.column !== activatedGenerated.column) {
                        map.addMapping(activatedMapping);
                    }
                }

                sourceMappingActive = true;
                map.addMapping({
                    source: node.loc.source,
                    original: original,
                    generated: generated
                });
            }
        }

        handlersNode.call(this, node);

        if (sourceMappingActive && trackNodes.hasOwnProperty(node.type)) {
            activatedGenerated.line = line;
            activatedGenerated.column = column;
        }
    };

    var handlersChunk = handlers.chunk;
    handlers.chunk = function(chunk) {
        for (var i = 0; i < chunk.length; i++) {
            if (chunk.charCodeAt(i) === 10) { // \n
                line++;
                column = 0;
            } else {
                column++;
            }
        }

        handlersChunk(chunk);
    };

    var handlersResult = handlers.result;
    handlers.result = function() {
        if (sourceMappingActive) {
            map.addMapping(activatedMapping);
        }

        return {
            css: handlersResult(),
            map: map
        };
    };

    return handlers;
};


/***/ }),

/***/ "./node_modules/css-tree/lib/index.js":
/*!********************************************!*\
  !*** ./node_modules/css-tree/lib/index.js ***!
  \********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./syntax */ "./node_modules/css-tree/lib/syntax/index.js");


/***/ }),

/***/ "./node_modules/css-tree/lib/lexer/Lexer.js":
/*!**************************************************!*\
  !*** ./node_modules/css-tree/lib/lexer/Lexer.js ***!
  \**************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SyntaxReferenceError = (__webpack_require__(/*! ./error */ "./node_modules/css-tree/lib/lexer/error.js").SyntaxReferenceError);
var SyntaxMatchError = (__webpack_require__(/*! ./error */ "./node_modules/css-tree/lib/lexer/error.js").SyntaxMatchError);
var names = __webpack_require__(/*! ../utils/names */ "./node_modules/css-tree/lib/utils/names.js");
var generic = __webpack_require__(/*! ./generic */ "./node_modules/css-tree/lib/lexer/generic.js");
var parse = __webpack_require__(/*! ../definition-syntax/parse */ "./node_modules/css-tree/lib/definition-syntax/parse.js");
var generate = __webpack_require__(/*! ../definition-syntax/generate */ "./node_modules/css-tree/lib/definition-syntax/generate.js");
var walk = __webpack_require__(/*! ../definition-syntax/walk */ "./node_modules/css-tree/lib/definition-syntax/walk.js");
var prepareTokens = __webpack_require__(/*! ./prepare-tokens */ "./node_modules/css-tree/lib/lexer/prepare-tokens.js");
var buildMatchGraph = (__webpack_require__(/*! ./match-graph */ "./node_modules/css-tree/lib/lexer/match-graph.js").buildMatchGraph);
var matchAsTree = (__webpack_require__(/*! ./match */ "./node_modules/css-tree/lib/lexer/match.js").matchAsTree);
var trace = __webpack_require__(/*! ./trace */ "./node_modules/css-tree/lib/lexer/trace.js");
var search = __webpack_require__(/*! ./search */ "./node_modules/css-tree/lib/lexer/search.js");
var getStructureFromConfig = (__webpack_require__(/*! ./structure */ "./node_modules/css-tree/lib/lexer/structure.js").getStructureFromConfig);
var cssWideKeywords = buildMatchGraph('inherit | initial | unset');
var cssWideKeywordsWithExpression = buildMatchGraph('inherit | initial | unset | <-ms-legacy-expression>');

function dumpMapSyntax(map, compact, syntaxAsAst) {
    var result = {};

    for (var name in map) {
        if (map[name].syntax) {
            result[name] = syntaxAsAst
                ? map[name].syntax
                : generate(map[name].syntax, { compact: compact });
        }
    }

    return result;
}

function dumpAtruleMapSyntax(map, compact, syntaxAsAst) {
    const result = {};

    for (const [name, atrule] of Object.entries(map)) {
        result[name] = {
            prelude: atrule.prelude && (
                syntaxAsAst
                    ? atrule.prelude.syntax
                    : generate(atrule.prelude.syntax, { compact })
            ),
            descriptors: atrule.descriptors && dumpMapSyntax(atrule.descriptors, compact, syntaxAsAst)
        };
    }

    return result;
}

function valueHasVar(tokens) {
    for (var i = 0; i < tokens.length; i++) {
        if (tokens[i].value.toLowerCase() === 'var(') {
            return true;
        }
    }

    return false;
}

function buildMatchResult(match, error, iterations) {
    return {
        matched: match,
        iterations: iterations,
        error: error,
        getTrace: trace.getTrace,
        isType: trace.isType,
        isProperty: trace.isProperty,
        isKeyword: trace.isKeyword
    };
}

function matchSyntax(lexer, syntax, value, useCommon) {
    var tokens = prepareTokens(value, lexer.syntax);
    var result;

    if (valueHasVar(tokens)) {
        return buildMatchResult(null, new Error('Matching for a tree with var() is not supported'));
    }

    if (useCommon) {
        result = matchAsTree(tokens, lexer.valueCommonSyntax, lexer);
    }

    if (!useCommon || !result.match) {
        result = matchAsTree(tokens, syntax.match, lexer);
        if (!result.match) {
            return buildMatchResult(
                null,
                new SyntaxMatchError(result.reason, syntax.syntax, value, result),
                result.iterations
            );
        }
    }

    return buildMatchResult(result.match, null, result.iterations);
}

var Lexer = function(config, syntax, structure) {
    this.valueCommonSyntax = cssWideKeywords;
    this.syntax = syntax;
    this.generic = false;
    this.atrules = {};
    this.properties = {};
    this.types = {};
    this.structure = structure || getStructureFromConfig(config);

    if (config) {
        if (config.types) {
            for (var name in config.types) {
                this.addType_(name, config.types[name]);
            }
        }

        if (config.generic) {
            this.generic = true;
            for (var name in generic) {
                this.addType_(name, generic[name]);
            }
        }

        if (config.atrules) {
            for (var name in config.atrules) {
                this.addAtrule_(name, config.atrules[name]);
            }
        }

        if (config.properties) {
            for (var name in config.properties) {
                this.addProperty_(name, config.properties[name]);
            }
        }
    }
};

Lexer.prototype = {
    structure: {},
    checkStructure: function(ast) {
        function collectWarning(node, message) {
            warns.push({
                node: node,
                message: message
            });
        }

        var structure = this.structure;
        var warns = [];

        this.syntax.walk(ast, function(node) {
            if (structure.hasOwnProperty(node.type)) {
                structure[node.type].check(node, collectWarning);
            } else {
                collectWarning(node, 'Unknown node type `' + node.type + '`');
            }
        });

        return warns.length ? warns : false;
    },

    createDescriptor: function(syntax, type, name, parent = null) {
        var ref = {
            type: type,
            name: name
        };
        var descriptor = {
            type: type,
            name: name,
            parent: parent,
            syntax: null,
            match: null
        };

        if (typeof syntax === 'function') {
            descriptor.match = buildMatchGraph(syntax, ref);
        } else {
            if (typeof syntax === 'string') {
                // lazy parsing on first access
                Object.defineProperty(descriptor, 'syntax', {
                    get: function() {
                        Object.defineProperty(descriptor, 'syntax', {
                            value: parse(syntax)
                        });

                        return descriptor.syntax;
                    }
                });
            } else {
                descriptor.syntax = syntax;
            }

            // lazy graph build on first access
            Object.defineProperty(descriptor, 'match', {
                get: function() {
                    Object.defineProperty(descriptor, 'match', {
                        value: buildMatchGraph(descriptor.syntax, ref)
                    });

                    return descriptor.match;
                }
            });
        }

        return descriptor;
    },
    addAtrule_: function(name, syntax) {
        if (!syntax) {
            return;
        }

        this.atrules[name] = {
            type: 'Atrule',
            name: name,
            prelude: syntax.prelude ? this.createDescriptor(syntax.prelude, 'AtrulePrelude', name) : null,
            descriptors: syntax.descriptors
                ? Object.keys(syntax.descriptors).reduce((res, descName) => {
                    res[descName] = this.createDescriptor(syntax.descriptors[descName], 'AtruleDescriptor', descName, name);
                    return res;
                }, {})
                : null
        };
    },
    addProperty_: function(name, syntax) {
        if (!syntax) {
            return;
        }

        this.properties[name] = this.createDescriptor(syntax, 'Property', name);
    },
    addType_: function(name, syntax) {
        if (!syntax) {
            return;
        }

        this.types[name] = this.createDescriptor(syntax, 'Type', name);

        if (syntax === generic['-ms-legacy-expression']) {
            this.valueCommonSyntax = cssWideKeywordsWithExpression;
        }
    },

    checkAtruleName: function(atruleName) {
        if (!this.getAtrule(atruleName)) {
            return new SyntaxReferenceError('Unknown at-rule', '@' + atruleName);
        }
    },
    checkAtrulePrelude: function(atruleName, prelude) {
        let error = this.checkAtruleName(atruleName);

        if (error) {
            return error;
        }

        var atrule = this.getAtrule(atruleName);

        if (!atrule.prelude && prelude) {
            return new SyntaxError('At-rule `@' + atruleName + '` should not contain a prelude');
        }

        if (atrule.prelude && !prelude) {
            return new SyntaxError('At-rule `@' + atruleName + '` should contain a prelude');
        }
    },
    checkAtruleDescriptorName: function(atruleName, descriptorName) {
        let error = this.checkAtruleName(atruleName);

        if (error) {
            return error;
        }

        var atrule = this.getAtrule(atruleName);
        var descriptor = names.keyword(descriptorName);

        if (!atrule.descriptors) {
            return new SyntaxError('At-rule `@' + atruleName + '` has no known descriptors');
        }

        if (!atrule.descriptors[descriptor.name] &&
            !atrule.descriptors[descriptor.basename]) {
            return new SyntaxReferenceError('Unknown at-rule descriptor', descriptorName);
        }
    },
    checkPropertyName: function(propertyName) {
        var property = names.property(propertyName);

        // don't match syntax for a custom property
        if (property.custom) {
            return new Error('Lexer matching doesn\'t applicable for custom properties');
        }

        if (!this.getProperty(propertyName)) {
            return new SyntaxReferenceError('Unknown property', propertyName);
        }
    },

    matchAtrulePrelude: function(atruleName, prelude) {
        var error = this.checkAtrulePrelude(atruleName, prelude);

        if (error) {
            return buildMatchResult(null, error);
        }

        if (!prelude) {
            return buildMatchResult(null, null);
        }

        return matchSyntax(this, this.getAtrule(atruleName).prelude, prelude, false);
    },
    matchAtruleDescriptor: function(atruleName, descriptorName, value) {
        var error = this.checkAtruleDescriptorName(atruleName, descriptorName);

        if (error) {
            return buildMatchResult(null, error);
        }

        var atrule = this.getAtrule(atruleName);
        var descriptor = names.keyword(descriptorName);

        return matchSyntax(this, atrule.descriptors[descriptor.name] || atrule.descriptors[descriptor.basename], value, false);
    },
    matchDeclaration: function(node) {
        if (node.type !== 'Declaration') {
            return buildMatchResult(null, new Error('Not a Declaration node'));
        }

        return this.matchProperty(node.property, node.value);
    },
    matchProperty: function(propertyName, value) {
        var error = this.checkPropertyName(propertyName);

        if (error) {
            return buildMatchResult(null, error);
        }

        return matchSyntax(this, this.getProperty(propertyName), value, true);
    },
    matchType: function(typeName, value) {
        var typeSyntax = this.getType(typeName);

        if (!typeSyntax) {
            return buildMatchResult(null, new SyntaxReferenceError('Unknown type', typeName));
        }

        return matchSyntax(this, typeSyntax, value, false);
    },
    match: function(syntax, value) {
        if (typeof syntax !== 'string' && (!syntax || !syntax.type)) {
            return buildMatchResult(null, new SyntaxReferenceError('Bad syntax'));
        }

        if (typeof syntax === 'string' || !syntax.match) {
            syntax = this.createDescriptor(syntax, 'Type', 'anonymous');
        }

        return matchSyntax(this, syntax, value, false);
    },

    findValueFragments: function(propertyName, value, type, name) {
        return search.matchFragments(this, value, this.matchProperty(propertyName, value), type, name);
    },
    findDeclarationValueFragments: function(declaration, type, name) {
        return search.matchFragments(this, declaration.value, this.matchDeclaration(declaration), type, name);
    },
    findAllFragments: function(ast, type, name) {
        var result = [];

        this.syntax.walk(ast, {
            visit: 'Declaration',
            enter: function(declaration) {
                result.push.apply(result, this.findDeclarationValueFragments(declaration, type, name));
            }.bind(this)
        });

        return result;
    },

    getAtrule: function(atruleName, fallbackBasename = true) {
        var atrule = names.keyword(atruleName);
        var atruleEntry = atrule.vendor && fallbackBasename
            ? this.atrules[atrule.name] || this.atrules[atrule.basename]
            : this.atrules[atrule.name];

        return atruleEntry || null;
    },
    getAtrulePrelude: function(atruleName, fallbackBasename = true) {
        const atrule = this.getAtrule(atruleName, fallbackBasename);

        return atrule && atrule.prelude || null;
    },
    getAtruleDescriptor: function(atruleName, name) {
        return this.atrules.hasOwnProperty(atruleName) && this.atrules.declarators
            ? this.atrules[atruleName].declarators[name] || null
            : null;
    },
    getProperty: function(propertyName, fallbackBasename = true) {
        var property = names.property(propertyName);
        var propertyEntry = property.vendor && fallbackBasename
            ? this.properties[property.name] || this.properties[property.basename]
            : this.properties[property.name];

        return propertyEntry || null;
    },
    getType: function(name) {
        return this.types.hasOwnProperty(name) ? this.types[name] : null;
    },

    validate: function() {
        function validate(syntax, name, broken, descriptor) {
            if (broken.hasOwnProperty(name)) {
                return broken[name];
            }

            broken[name] = false;
            if (descriptor.syntax !== null) {
                walk(descriptor.syntax, function(node) {
                    if (node.type !== 'Type' && node.type !== 'Property') {
                        return;
                    }

                    var map = node.type === 'Type' ? syntax.types : syntax.properties;
                    var brokenMap = node.type === 'Type' ? brokenTypes : brokenProperties;

                    if (!map.hasOwnProperty(node.name) || validate(syntax, node.name, brokenMap, map[node.name])) {
                        broken[name] = true;
                    }
                }, this);
            }
        }

        var brokenTypes = {};
        var brokenProperties = {};

        for (var key in this.types) {
            validate(this, key, brokenTypes, this.types[key]);
        }

        for (var key in this.properties) {
            validate(this, key, brokenProperties, this.properties[key]);
        }

        brokenTypes = Object.keys(brokenTypes).filter(function(name) {
            return brokenTypes[name];
        });
        brokenProperties = Object.keys(brokenProperties).filter(function(name) {
            return brokenProperties[name];
        });

        if (brokenTypes.length || brokenProperties.length) {
            return {
                types: brokenTypes,
                properties: brokenProperties
            };
        }

        return null;
    },
    dump: function(syntaxAsAst, pretty) {
        return {
            generic: this.generic,
            types: dumpMapSyntax(this.types, !pretty, syntaxAsAst),
            properties: dumpMapSyntax(this.properties, !pretty, syntaxAsAst),
            atrules: dumpAtruleMapSyntax(this.atrules, !pretty, syntaxAsAst)
        };
    },
    toString: function() {
        return JSON.stringify(this.dump());
    }
};

module.exports = Lexer;


/***/ }),

/***/ "./node_modules/css-tree/lib/lexer/error.js":
/*!**************************************************!*\
  !*** ./node_modules/css-tree/lib/lexer/error.js ***!
  \**************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const createCustomError = __webpack_require__(/*! ../utils/createCustomError */ "./node_modules/css-tree/lib/utils/createCustomError.js");
const generate = __webpack_require__(/*! ../definition-syntax/generate */ "./node_modules/css-tree/lib/definition-syntax/generate.js");
const defaultLoc = { offset: 0, line: 1, column: 1 };

function locateMismatch(matchResult, node) {
    const tokens = matchResult.tokens;
    const longestMatch = matchResult.longestMatch;
    const mismatchNode = longestMatch < tokens.length ? tokens[longestMatch].node || null : null;
    const badNode = mismatchNode !== node ? mismatchNode : null;
    let mismatchOffset = 0;
    let mismatchLength = 0;
    let entries = 0;
    let css = '';
    let start;
    let end;

    for (let i = 0; i < tokens.length; i++) {
        const token = tokens[i].value;

        if (i === longestMatch) {
            mismatchLength = token.length;
            mismatchOffset = css.length;
        }

        if (badNode !== null && tokens[i].node === badNode) {
            if (i <= longestMatch) {
                entries++;
            } else {
                entries = 0;
            }
        }

        css += token;
    }

    if (longestMatch === tokens.length || entries > 1) { // last
        start = fromLoc(badNode || node, 'end') || buildLoc(defaultLoc, css);
        end = buildLoc(start);
    } else {
        start = fromLoc(badNode, 'start') ||
            buildLoc(fromLoc(node, 'start') || defaultLoc, css.slice(0, mismatchOffset));
        end = fromLoc(badNode, 'end') ||
            buildLoc(start, css.substr(mismatchOffset, mismatchLength));
    }

    return {
        css,
        mismatchOffset,
        mismatchLength,
        start,
        end
    };
}

function fromLoc(node, point) {
    const value = node && node.loc && node.loc[point];

    if (value) {
        return 'line' in value ? buildLoc(value) : value;
    }

    return null;
}

function buildLoc({ offset, line, column }, extra) {
    const loc = {
        offset,
        line,
        column
    };

    if (extra) {
        const lines = extra.split(/\n|\r\n?|\f/);

        loc.offset += extra.length;
        loc.line += lines.length - 1;
        loc.column = lines.length === 1 ? loc.column + extra.length : lines.pop().length + 1;
    }

    return loc;
}

const SyntaxReferenceError = function(type, referenceName) {
    const error = createCustomError(
        'SyntaxReferenceError',
        type + (referenceName ? ' `' + referenceName + '`' : '')
    );

    error.reference = referenceName;

    return error;
};

const SyntaxMatchError = function(message, syntax, node, matchResult) {
    const error = createCustomError('SyntaxMatchError', message);
    const {
        css,
        mismatchOffset,
        mismatchLength,
        start,
        end
    } = locateMismatch(matchResult, node);

    error.rawMessage = message;
    error.syntax = syntax ? generate(syntax) : '<generic>';
    error.css = css;
    error.mismatchOffset = mismatchOffset;
    error.mismatchLength = mismatchLength;
    error.message = message + '\n' +
        '  syntax: ' + error.syntax + '\n' +
        '   value: ' + (css || '<empty string>') + '\n' +
        '  --------' + new Array(error.mismatchOffset + 1).join('-') + '^';

    Object.assign(error, start);
    error.loc = {
        source: (node && node.loc && node.loc.source) || '<unknown>',
        start,
        end
    };

    return error;
};

module.exports = {
    SyntaxReferenceError,
    SyntaxMatchError
};


/***/ }),

/***/ "./node_modules/css-tree/lib/lexer/generic-an-plus-b.js":
/*!**************************************************************!*\
  !*** ./node_modules/css-tree/lib/lexer/generic-an-plus-b.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isDigit = (__webpack_require__(/*! ../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").isDigit);
var cmpChar = (__webpack_require__(/*! ../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").cmpChar);
var TYPE = (__webpack_require__(/*! ../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var DELIM = TYPE.Delim;
var WHITESPACE = TYPE.WhiteSpace;
var COMMENT = TYPE.Comment;
var IDENT = TYPE.Ident;
var NUMBER = TYPE.Number;
var DIMENSION = TYPE.Dimension;
var PLUSSIGN = 0x002B;    // U+002B PLUS SIGN (+)
var HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
var N = 0x006E;           // U+006E LATIN SMALL LETTER N (n)
var DISALLOW_SIGN = true;
var ALLOW_SIGN = false;

function isDelim(token, code) {
    return token !== null && token.type === DELIM && token.value.charCodeAt(0) === code;
}

function skipSC(token, offset, getNextToken) {
    while (token !== null && (token.type === WHITESPACE || token.type === COMMENT)) {
        token = getNextToken(++offset);
    }

    return offset;
}

function checkInteger(token, valueOffset, disallowSign, offset) {
    if (!token) {
        return 0;
    }

    var code = token.value.charCodeAt(valueOffset);

    if (code === PLUSSIGN || code === HYPHENMINUS) {
        if (disallowSign) {
            // Number sign is not allowed
            return 0;
        }
        valueOffset++;
    }

    for (; valueOffset < token.value.length; valueOffset++) {
        if (!isDigit(token.value.charCodeAt(valueOffset))) {
            // Integer is expected
            return 0;
        }
    }

    return offset + 1;
}

// ... <signed-integer>
// ... ['+' | '-'] <signless-integer>
function consumeB(token, offset_, getNextToken) {
    var sign = false;
    var offset = skipSC(token, offset_, getNextToken);

    token = getNextToken(offset);

    if (token === null) {
        return offset_;
    }

    if (token.type !== NUMBER) {
        if (isDelim(token, PLUSSIGN) || isDelim(token, HYPHENMINUS)) {
            sign = true;
            offset = skipSC(getNextToken(++offset), offset, getNextToken);
            token = getNextToken(offset);

            if (token === null && token.type !== NUMBER) {
                return 0;
            }
        } else {
            return offset_;
        }
    }

    if (!sign) {
        var code = token.value.charCodeAt(0);
        if (code !== PLUSSIGN && code !== HYPHENMINUS) {
            // Number sign is expected
            return 0;
        }
    }

    return checkInteger(token, sign ? 0 : 1, sign, offset);
}

// An+B microsyntax https://www.w3.org/TR/css-syntax-3/#anb
module.exports = function anPlusB(token, getNextToken) {
    /* eslint-disable brace-style*/
    var offset = 0;

    if (!token) {
        return 0;
    }

    // <integer>
    if (token.type === NUMBER) {
        return checkInteger(token, 0, ALLOW_SIGN, offset); // b
    }

    // -n
    // -n <signed-integer>
    // -n ['+' | '-'] <signless-integer>
    // -n- <signless-integer>
    // <dashndashdigit-ident>
    else if (token.type === IDENT && token.value.charCodeAt(0) === HYPHENMINUS) {
        // expect 1st char is N
        if (!cmpChar(token.value, 1, N)) {
            return 0;
        }

        switch (token.value.length) {
            // -n
            // -n <signed-integer>
            // -n ['+' | '-'] <signless-integer>
            case 2:
                return consumeB(getNextToken(++offset), offset, getNextToken);

            // -n- <signless-integer>
            case 3:
                if (token.value.charCodeAt(2) !== HYPHENMINUS) {
                    return 0;
                }

                offset = skipSC(getNextToken(++offset), offset, getNextToken);
                token = getNextToken(offset);

                return checkInteger(token, 0, DISALLOW_SIGN, offset);

            // <dashndashdigit-ident>
            default:
                if (token.value.charCodeAt(2) !== HYPHENMINUS) {
                    return 0;
                }

                return checkInteger(token, 3, DISALLOW_SIGN, offset);
        }
    }

    // '+'? n
    // '+'? n <signed-integer>
    // '+'? n ['+' | '-'] <signless-integer>
    // '+'? n- <signless-integer>
    // '+'? <ndashdigit-ident>
    else if (token.type === IDENT || (isDelim(token, PLUSSIGN) && getNextToken(offset + 1).type === IDENT)) {
        // just ignore a plus
        if (token.type !== IDENT) {
            token = getNextToken(++offset);
        }

        if (token === null || !cmpChar(token.value, 0, N)) {
            return 0;
        }

        switch (token.value.length) {
            // '+'? n
            // '+'? n <signed-integer>
            // '+'? n ['+' | '-'] <signless-integer>
            case 1:
                return consumeB(getNextToken(++offset), offset, getNextToken);

            // '+'? n- <signless-integer>
            case 2:
                if (token.value.charCodeAt(1) !== HYPHENMINUS) {
                    return 0;
                }

                offset = skipSC(getNextToken(++offset), offset, getNextToken);
                token = getNextToken(offset);

                return checkInteger(token, 0, DISALLOW_SIGN, offset);

            // '+'? <ndashdigit-ident>
            default:
                if (token.value.charCodeAt(1) !== HYPHENMINUS) {
                    return 0;
                }

                return checkInteger(token, 2, DISALLOW_SIGN, offset);
        }
    }

    // <ndashdigit-dimension>
    // <ndash-dimension> <signless-integer>
    // <n-dimension>
    // <n-dimension> <signed-integer>
    // <n-dimension> ['+' | '-'] <signless-integer>
    else if (token.type === DIMENSION) {
        var code = token.value.charCodeAt(0);
        var sign = code === PLUSSIGN || code === HYPHENMINUS ? 1 : 0;

        for (var i = sign; i < token.value.length; i++) {
            if (!isDigit(token.value.charCodeAt(i))) {
                break;
            }
        }

        if (i === sign) {
            // Integer is expected
            return 0;
        }

        if (!cmpChar(token.value, i, N)) {
            return 0;
        }

        // <n-dimension>
        // <n-dimension> <signed-integer>
        // <n-dimension> ['+' | '-'] <signless-integer>
        if (i + 1 === token.value.length) {
            return consumeB(getNextToken(++offset), offset, getNextToken);
        } else {
            if (token.value.charCodeAt(i + 1) !== HYPHENMINUS) {
                return 0;
            }

            // <ndash-dimension> <signless-integer>
            if (i + 2 === token.value.length) {
                offset = skipSC(getNextToken(++offset), offset, getNextToken);
                token = getNextToken(offset);

                return checkInteger(token, 0, DISALLOW_SIGN, offset);
            }
            // <ndashdigit-dimension>
            else {
                return checkInteger(token, i + 2, DISALLOW_SIGN, offset);
            }
        }
    }

    return 0;
};


/***/ }),

/***/ "./node_modules/css-tree/lib/lexer/generic-urange.js":
/*!***********************************************************!*\
  !*** ./node_modules/css-tree/lib/lexer/generic-urange.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isHexDigit = (__webpack_require__(/*! ../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").isHexDigit);
var cmpChar = (__webpack_require__(/*! ../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").cmpChar);
var TYPE = (__webpack_require__(/*! ../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var IDENT = TYPE.Ident;
var DELIM = TYPE.Delim;
var NUMBER = TYPE.Number;
var DIMENSION = TYPE.Dimension;
var PLUSSIGN = 0x002B;     // U+002B PLUS SIGN (+)
var HYPHENMINUS = 0x002D;  // U+002D HYPHEN-MINUS (-)
var QUESTIONMARK = 0x003F; // U+003F QUESTION MARK (?)
var U = 0x0075;            // U+0075 LATIN SMALL LETTER U (u)

function isDelim(token, code) {
    return token !== null && token.type === DELIM && token.value.charCodeAt(0) === code;
}

function startsWith(token, code) {
    return token.value.charCodeAt(0) === code;
}

function hexSequence(token, offset, allowDash) {
    for (var pos = offset, hexlen = 0; pos < token.value.length; pos++) {
        var code = token.value.charCodeAt(pos);

        if (code === HYPHENMINUS && allowDash && hexlen !== 0) {
            if (hexSequence(token, offset + hexlen + 1, false) > 0) {
                return 6; // dissallow following question marks
            }

            return 0; // dash at the ending of a hex sequence is not allowed
        }

        if (!isHexDigit(code)) {
            return 0; // not a hex digit
        }

        if (++hexlen > 6) {
            return 0; // too many hex digits
        };
    }

    return hexlen;
}

function withQuestionMarkSequence(consumed, length, getNextToken) {
    if (!consumed) {
        return 0; // nothing consumed
    }

    while (isDelim(getNextToken(length), QUESTIONMARK)) {
        if (++consumed > 6) {
            return 0; // too many question marks
        }

        length++;
    }

    return length;
}

// https://drafts.csswg.org/css-syntax/#urange
// Informally, the <urange> production has three forms:
// U+0001
//      Defines a range consisting of a single code point, in this case the code point "1".
// U+0001-00ff
//      Defines a range of codepoints between the first and the second value, in this case
//      the range between "1" and "ff" (255 in decimal) inclusive.
// U+00??
//      Defines a range of codepoints where the "?" characters range over all hex digits,
//      in this case defining the same as the value U+0000-00ff.
// In each form, a maximum of 6 digits is allowed for each hexadecimal number (if you treat "?" as a hexadecimal digit).
//
// <urange> =
//   u '+' <ident-token> '?'* |
//   u <dimension-token> '?'* |
//   u <number-token> '?'* |
//   u <number-token> <dimension-token> |
//   u <number-token> <number-token> |
//   u '+' '?'+
module.exports = function urange(token, getNextToken) {
    var length = 0;

    // should start with `u` or `U`
    if (token === null || token.type !== IDENT || !cmpChar(token.value, 0, U)) {
        return 0;
    }

    token = getNextToken(++length);
    if (token === null) {
        return 0;
    }

    // u '+' <ident-token> '?'*
    // u '+' '?'+
    if (isDelim(token, PLUSSIGN)) {
        token = getNextToken(++length);
        if (token === null) {
            return 0;
        }

        if (token.type === IDENT) {
            // u '+' <ident-token> '?'*
            return withQuestionMarkSequence(hexSequence(token, 0, true), ++length, getNextToken);
        }

        if (isDelim(token, QUESTIONMARK)) {
            // u '+' '?'+
            return withQuestionMarkSequence(1, ++length, getNextToken);
        }

        // Hex digit or question mark is expected
        return 0;
    }

    // u <number-token> '?'*
    // u <number-token> <dimension-token>
    // u <number-token> <number-token>
    if (token.type === NUMBER) {
        if (!startsWith(token, PLUSSIGN)) {
            return 0;
        }

        var consumedHexLength = hexSequence(token, 1, true);
        if (consumedHexLength === 0) {
            return 0;
        }

        token = getNextToken(++length);
        if (token === null) {
            // u <number-token> <eof>
            return length;
        }

        if (token.type === DIMENSION || token.type === NUMBER) {
            // u <number-token> <dimension-token>
            // u <number-token> <number-token>
            if (!startsWith(token, HYPHENMINUS) || !hexSequence(token, 1, false)) {
                return 0;
            }

            return length + 1;
        }

        // u <number-token> '?'*
        return withQuestionMarkSequence(consumedHexLength, length, getNextToken);
    }

    // u <dimension-token> '?'*
    if (token.type === DIMENSION) {
        if (!startsWith(token, PLUSSIGN)) {
            return 0;
        }

        return withQuestionMarkSequence(hexSequence(token, 1, true), ++length, getNextToken);
    }

    return 0;
};


/***/ }),

/***/ "./node_modules/css-tree/lib/lexer/generic.js":
/*!****************************************************!*\
  !*** ./node_modules/css-tree/lib/lexer/generic.js ***!
  \****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var tokenizer = __webpack_require__(/*! ../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js");
var isIdentifierStart = tokenizer.isIdentifierStart;
var isHexDigit = tokenizer.isHexDigit;
var isDigit = tokenizer.isDigit;
var cmpStr = tokenizer.cmpStr;
var consumeNumber = tokenizer.consumeNumber;
var TYPE = tokenizer.TYPE;
var anPlusB = __webpack_require__(/*! ./generic-an-plus-b */ "./node_modules/css-tree/lib/lexer/generic-an-plus-b.js");
var urange = __webpack_require__(/*! ./generic-urange */ "./node_modules/css-tree/lib/lexer/generic-urange.js");

var cssWideKeywords = ['unset', 'initial', 'inherit'];
var calcFunctionNames = ['calc(', '-moz-calc(', '-webkit-calc('];

// https://www.w3.org/TR/css-values-3/#lengths
var LENGTH = {
    // absolute length units
    'px': true,
    'mm': true,
    'cm': true,
    'in': true,
    'pt': true,
    'pc': true,
    'q': true,

    // relative length units
    'em': true,
    'ex': true,
    'ch': true,
    'rem': true,

    // viewport-percentage lengths
    'vh': true,
    'vw': true,
    'vmin': true,
    'vmax': true,
    'vm': true
};

var ANGLE = {
    'deg': true,
    'grad': true,
    'rad': true,
    'turn': true
};

var TIME = {
    's': true,
    'ms': true
};

var FREQUENCY = {
    'hz': true,
    'khz': true
};

// https://www.w3.org/TR/css-values-3/#resolution (https://drafts.csswg.org/css-values/#resolution)
var RESOLUTION = {
    'dpi': true,
    'dpcm': true,
    'dppx': true,
    'x': true      // https://github.com/w3c/csswg-drafts/issues/461
};

// https://drafts.csswg.org/css-grid/#fr-unit
var FLEX = {
    'fr': true
};

// https://www.w3.org/TR/css3-speech/#mixing-props-voice-volume
var DECIBEL = {
    'db': true
};

// https://www.w3.org/TR/css3-speech/#voice-props-voice-pitch
var SEMITONES = {
    'st': true
};

// safe char code getter
function charCode(str, index) {
    return index < str.length ? str.charCodeAt(index) : 0;
}

function eqStr(actual, expected) {
    return cmpStr(actual, 0, actual.length, expected);
}

function eqStrAny(actual, expected) {
    for (var i = 0; i < expected.length; i++) {
        if (eqStr(actual, expected[i])) {
            return true;
        }
    }

    return false;
}

// IE postfix hack, i.e. 123\0 or 123px\9
function isPostfixIeHack(str, offset) {
    if (offset !== str.length - 2) {
        return false;
    }

    return (
        str.charCodeAt(offset) === 0x005C &&  // U+005C REVERSE SOLIDUS (\)
        isDigit(str.charCodeAt(offset + 1))
    );
}

function outOfRange(opts, value, numEnd) {
    if (opts && opts.type === 'Range') {
        var num = Number(
            numEnd !== undefined && numEnd !== value.length
                ? value.substr(0, numEnd)
                : value
        );

        if (isNaN(num)) {
            return true;
        }

        if (opts.min !== null && num < opts.min) {
            return true;
        }

        if (opts.max !== null && num > opts.max) {
            return true;
        }
    }

    return false;
}

function consumeFunction(token, getNextToken) {
    var startIdx = token.index;
    var length = 0;

    // balanced token consuming
    do {
        length++;

        if (token.balance <= startIdx) {
            break;
        }
    } while (token = getNextToken(length));

    return length;
}

// TODO: implement
// can be used wherever <length>, <frequency>, <angle>, <time>, <percentage>, <number>, or <integer> values are allowed
// https://drafts.csswg.org/css-values/#calc-notation
function calc(next) {
    return function(token, getNextToken, opts) {
        if (token === null) {
            return 0;
        }

        if (token.type === TYPE.Function && eqStrAny(token.value, calcFunctionNames)) {
            return consumeFunction(token, getNextToken);
        }

        return next(token, getNextToken, opts);
    };
}

function tokenType(expectedTokenType) {
    return function(token) {
        if (token === null || token.type !== expectedTokenType) {
            return 0;
        }

        return 1;
    };
}

function func(name) {
    name = name + '(';

    return function(token, getNextToken) {
        if (token !== null && eqStr(token.value, name)) {
            return consumeFunction(token, getNextToken);
        }

        return 0;
    };
}

// =========================
// Complex types
//

// https://drafts.csswg.org/css-values-4/#custom-idents
// 4.2. Author-defined Identifiers: the <custom-ident> type
// Some properties accept arbitrary author-defined identifiers as a component value.
// This generic data type is denoted by <custom-ident>, and represents any valid CSS identifier
// that would not be misinterpreted as a pre-defined keyword in that property’s value definition.
//
// See also: https://developer.mozilla.org/en-US/docs/Web/CSS/custom-ident
function customIdent(token) {
    if (token === null || token.type !== TYPE.Ident) {
        return 0;
    }

    var name = token.value.toLowerCase();

    // The CSS-wide keywords are not valid <custom-ident>s
    if (eqStrAny(name, cssWideKeywords)) {
        return 0;
    }

    // The default keyword is reserved and is also not a valid <custom-ident>
    if (eqStr(name, 'default')) {
        return 0;
    }

    // TODO: ignore property specific keywords (as described https://developer.mozilla.org/en-US/docs/Web/CSS/custom-ident)
    // Specifications using <custom-ident> must specify clearly what other keywords
    // are excluded from <custom-ident>, if any—for example by saying that any pre-defined keywords
    // in that property’s value definition are excluded. Excluded keywords are excluded
    // in all ASCII case permutations.

    return 1;
}

// https://drafts.csswg.org/css-variables/#typedef-custom-property-name
// A custom property is any property whose name starts with two dashes (U+002D HYPHEN-MINUS), like --foo.
// The <custom-property-name> production corresponds to this: it’s defined as any valid identifier
// that starts with two dashes, except -- itself, which is reserved for future use by CSS.
// NOTE: Current implementation treat `--` as a valid name since most (all?) major browsers treat it as valid.
function customPropertyName(token) {
    // ... defined as any valid identifier
    if (token === null || token.type !== TYPE.Ident) {
        return 0;
    }

    // ... that starts with two dashes (U+002D HYPHEN-MINUS)
    if (charCode(token.value, 0) !== 0x002D || charCode(token.value, 1) !== 0x002D) {
        return 0;
    }

    return 1;
}

// https://drafts.csswg.org/css-color-4/#hex-notation
// The syntax of a <hex-color> is a <hash-token> token whose value consists of 3, 4, 6, or 8 hexadecimal digits.
// In other words, a hex color is written as a hash character, "#", followed by some number of digits 0-9 or
// letters a-f (the case of the letters doesn’t matter - #00ff00 is identical to #00FF00).
function hexColor(token) {
    if (token === null || token.type !== TYPE.Hash) {
        return 0;
    }

    var length = token.value.length;

    // valid values (length): #rgb (4), #rgba (5), #rrggbb (7), #rrggbbaa (9)
    if (length !== 4 && length !== 5 && length !== 7 && length !== 9) {
        return 0;
    }

    for (var i = 1; i < length; i++) {
        if (!isHexDigit(token.value.charCodeAt(i))) {
            return 0;
        }
    }

    return 1;
}

function idSelector(token) {
    if (token === null || token.type !== TYPE.Hash) {
        return 0;
    }

    if (!isIdentifierStart(charCode(token.value, 1), charCode(token.value, 2), charCode(token.value, 3))) {
        return 0;
    }

    return 1;
}

// https://drafts.csswg.org/css-syntax/#any-value
// It represents the entirety of what a valid declaration can have as its value.
function declarationValue(token, getNextToken) {
    if (!token) {
        return 0;
    }

    var length = 0;
    var level = 0;
    var startIdx = token.index;

    // The <declaration-value> production matches any sequence of one or more tokens,
    // so long as the sequence ...
    scan:
    do {
        switch (token.type) {
            // ... does not contain <bad-string-token>, <bad-url-token>,
            case TYPE.BadString:
            case TYPE.BadUrl:
                break scan;

            // ... unmatched <)-token>, <]-token>, or <}-token>,
            case TYPE.RightCurlyBracket:
            case TYPE.RightParenthesis:
            case TYPE.RightSquareBracket:
                if (token.balance > token.index || token.balance < startIdx) {
                    break scan;
                }

                level--;
                break;

            // ... or top-level <semicolon-token> tokens
            case TYPE.Semicolon:
                if (level === 0) {
                    break scan;
                }

                break;

            // ... or <delim-token> tokens with a value of "!"
            case TYPE.Delim:
                if (token.value === '!' && level === 0) {
                    break scan;
                }

                break;

            case TYPE.Function:
            case TYPE.LeftParenthesis:
            case TYPE.LeftSquareBracket:
            case TYPE.LeftCurlyBracket:
                level++;
                break;
        }

        length++;

        // until balance closing
        if (token.balance <= startIdx) {
            break;
        }
    } while (token = getNextToken(length));

    return length;
}

// https://drafts.csswg.org/css-syntax/#any-value
// The <any-value> production is identical to <declaration-value>, but also
// allows top-level <semicolon-token> tokens and <delim-token> tokens
// with a value of "!". It represents the entirety of what valid CSS can be in any context.
function anyValue(token, getNextToken) {
    if (!token) {
        return 0;
    }

    var startIdx = token.index;
    var length = 0;

    // The <any-value> production matches any sequence of one or more tokens,
    // so long as the sequence ...
    scan:
    do {
        switch (token.type) {
            // ... does not contain <bad-string-token>, <bad-url-token>,
            case TYPE.BadString:
            case TYPE.BadUrl:
                break scan;

            // ... unmatched <)-token>, <]-token>, or <}-token>,
            case TYPE.RightCurlyBracket:
            case TYPE.RightParenthesis:
            case TYPE.RightSquareBracket:
                if (token.balance > token.index || token.balance < startIdx) {
                    break scan;
                }

                break;
        }

        length++;

        // until balance closing
        if (token.balance <= startIdx) {
            break;
        }
    } while (token = getNextToken(length));

    return length;
}

// =========================
// Dimensions
//

function dimension(type) {
    return function(token, getNextToken, opts) {
        if (token === null || token.type !== TYPE.Dimension) {
            return 0;
        }

        var numberEnd = consumeNumber(token.value, 0);

        // check unit
        if (type !== null) {
            // check for IE postfix hack, i.e. 123px\0 or 123px\9
            var reverseSolidusOffset = token.value.indexOf('\\', numberEnd);
            var unit = reverseSolidusOffset === -1 || !isPostfixIeHack(token.value, reverseSolidusOffset)
                ? token.value.substr(numberEnd)
                : token.value.substring(numberEnd, reverseSolidusOffset);

            if (type.hasOwnProperty(unit.toLowerCase()) === false) {
                return 0;
            }
        }

        // check range if specified
        if (outOfRange(opts, token.value, numberEnd)) {
            return 0;
        }

        return 1;
    };
}

// =========================
// Percentage
//

// §5.5. Percentages: the <percentage> type
// https://drafts.csswg.org/css-values-4/#percentages
function percentage(token, getNextToken, opts) {
    // ... corresponds to the <percentage-token> production
    if (token === null || token.type !== TYPE.Percentage) {
        return 0;
    }

    // check range if specified
    if (outOfRange(opts, token.value, token.value.length - 1)) {
        return 0;
    }

    return 1;
}

// =========================
// Numeric
//

// https://drafts.csswg.org/css-values-4/#numbers
// The value <zero> represents a literal number with the value 0. Expressions that merely
// evaluate to a <number> with the value 0 (for example, calc(0)) do not match <zero>;
// only literal <number-token>s do.
function zero(next) {
    if (typeof next !== 'function') {
        next = function() {
            return 0;
        };
    }

    return function(token, getNextToken, opts) {
        if (token !== null && token.type === TYPE.Number) {
            if (Number(token.value) === 0) {
                return 1;
            }
        }

        return next(token, getNextToken, opts);
    };
}

// § 5.3. Real Numbers: the <number> type
// https://drafts.csswg.org/css-values-4/#numbers
// Number values are denoted by <number>, and represent real numbers, possibly with a fractional component.
// ... It corresponds to the <number-token> production
function number(token, getNextToken, opts) {
    if (token === null) {
        return 0;
    }

    var numberEnd = consumeNumber(token.value, 0);
    var isNumber = numberEnd === token.value.length;
    if (!isNumber && !isPostfixIeHack(token.value, numberEnd)) {
        return 0;
    }

    // check range if specified
    if (outOfRange(opts, token.value, numberEnd)) {
        return 0;
    }

    return 1;
}

// §5.2. Integers: the <integer> type
// https://drafts.csswg.org/css-values-4/#integers
function integer(token, getNextToken, opts) {
    // ... corresponds to a subset of the <number-token> production
    if (token === null || token.type !== TYPE.Number) {
        return 0;
    }

    // The first digit of an integer may be immediately preceded by `-` or `+` to indicate the integer’s sign.
    var i = token.value.charCodeAt(0) === 0x002B ||       // U+002B PLUS SIGN (+)
            token.value.charCodeAt(0) === 0x002D ? 1 : 0; // U+002D HYPHEN-MINUS (-)

    // When written literally, an integer is one or more decimal digits 0 through 9 ...
    for (; i < token.value.length; i++) {
        if (!isDigit(token.value.charCodeAt(i))) {
            return 0;
        }
    }

    // check range if specified
    if (outOfRange(opts, token.value, i)) {
        return 0;
    }

    return 1;
}

module.exports = {
    // token types
    'ident-token': tokenType(TYPE.Ident),
    'function-token': tokenType(TYPE.Function),
    'at-keyword-token': tokenType(TYPE.AtKeyword),
    'hash-token': tokenType(TYPE.Hash),
    'string-token': tokenType(TYPE.String),
    'bad-string-token': tokenType(TYPE.BadString),
    'url-token': tokenType(TYPE.Url),
    'bad-url-token': tokenType(TYPE.BadUrl),
    'delim-token': tokenType(TYPE.Delim),
    'number-token': tokenType(TYPE.Number),
    'percentage-token': tokenType(TYPE.Percentage),
    'dimension-token': tokenType(TYPE.Dimension),
    'whitespace-token': tokenType(TYPE.WhiteSpace),
    'CDO-token': tokenType(TYPE.CDO),
    'CDC-token': tokenType(TYPE.CDC),
    'colon-token': tokenType(TYPE.Colon),
    'semicolon-token': tokenType(TYPE.Semicolon),
    'comma-token': tokenType(TYPE.Comma),
    '[-token': tokenType(TYPE.LeftSquareBracket),
    ']-token': tokenType(TYPE.RightSquareBracket),
    '(-token': tokenType(TYPE.LeftParenthesis),
    ')-token': tokenType(TYPE.RightParenthesis),
    '{-token': tokenType(TYPE.LeftCurlyBracket),
    '}-token': tokenType(TYPE.RightCurlyBracket),

    // token type aliases
    'string': tokenType(TYPE.String),
    'ident': tokenType(TYPE.Ident),

    // complex types
    'custom-ident': customIdent,
    'custom-property-name': customPropertyName,
    'hex-color': hexColor,
    'id-selector': idSelector, // element( <id-selector> )
    'an-plus-b': anPlusB,
    'urange': urange,
    'declaration-value': declarationValue,
    'any-value': anyValue,

    // dimensions
    'dimension': calc(dimension(null)),
    'angle': calc(dimension(ANGLE)),
    'decibel': calc(dimension(DECIBEL)),
    'frequency': calc(dimension(FREQUENCY)),
    'flex': calc(dimension(FLEX)),
    'length': calc(zero(dimension(LENGTH))),
    'resolution': calc(dimension(RESOLUTION)),
    'semitones': calc(dimension(SEMITONES)),
    'time': calc(dimension(TIME)),

    // percentage
    'percentage': calc(percentage),

    // numeric
    'zero': zero(),
    'number': calc(number),
    'integer': calc(integer),

    // old IE stuff
    '-ms-legacy-expression': func('expression')
};


/***/ }),

/***/ "./node_modules/css-tree/lib/lexer/match-graph.js":
/*!********************************************************!*\
  !*** ./node_modules/css-tree/lib/lexer/match-graph.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(/*! ../definition-syntax/parse */ "./node_modules/css-tree/lib/definition-syntax/parse.js");

var MATCH = { type: 'Match' };
var MISMATCH = { type: 'Mismatch' };
var DISALLOW_EMPTY = { type: 'DisallowEmpty' };
var LEFTPARENTHESIS = 40;  // (
var RIGHTPARENTHESIS = 41; // )

function createCondition(match, thenBranch, elseBranch) {
    // reduce node count
    if (thenBranch === MATCH && elseBranch === MISMATCH) {
        return match;
    }

    if (match === MATCH && thenBranch === MATCH && elseBranch === MATCH) {
        return match;
    }

    if (match.type === 'If' && match.else === MISMATCH && thenBranch === MATCH) {
        thenBranch = match.then;
        match = match.match;
    }

    return {
        type: 'If',
        match: match,
        then: thenBranch,
        else: elseBranch
    };
}

function isFunctionType(name) {
    return (
        name.length > 2 &&
        name.charCodeAt(name.length - 2) === LEFTPARENTHESIS &&
        name.charCodeAt(name.length - 1) === RIGHTPARENTHESIS
    );
}

function isEnumCapatible(term) {
    return (
        term.type === 'Keyword' ||
        term.type === 'AtKeyword' ||
        term.type === 'Function' ||
        term.type === 'Type' && isFunctionType(term.name)
    );
}

function buildGroupMatchGraph(combinator, terms, atLeastOneTermMatched) {
    switch (combinator) {
        case ' ':
            // Juxtaposing components means that all of them must occur, in the given order.
            //
            // a b c
            // =
            // match a
            //   then match b
            //     then match c
            //       then MATCH
            //       else MISMATCH
            //     else MISMATCH
            //   else MISMATCH
            var result = MATCH;

            for (var i = terms.length - 1; i >= 0; i--) {
                var term = terms[i];

                result = createCondition(
                    term,
                    result,
                    MISMATCH
                );
            };

            return result;

        case '|':
            // A bar (|) separates two or more alternatives: exactly one of them must occur.
            //
            // a | b | c
            // =
            // match a
            //   then MATCH
            //   else match b
            //     then MATCH
            //     else match c
            //       then MATCH
            //       else MISMATCH

            var result = MISMATCH;
            var map = null;

            for (var i = terms.length - 1; i >= 0; i--) {
                var term = terms[i];

                // reduce sequence of keywords into a Enum
                if (isEnumCapatible(term)) {
                    if (map === null && i > 0 && isEnumCapatible(terms[i - 1])) {
                        map = Object.create(null);
                        result = createCondition(
                            {
                                type: 'Enum',
                                map: map
                            },
                            MATCH,
                            result
                        );
                    }

                    if (map !== null) {
                        var key = (isFunctionType(term.name) ? term.name.slice(0, -1) : term.name).toLowerCase();
                        if (key in map === false) {
                            map[key] = term;
                            continue;
                        }
                    }
                }

                map = null;

                // create a new conditonal node
                result = createCondition(
                    term,
                    MATCH,
                    result
                );
            };

            return result;

        case '&&':
            // A double ampersand (&&) separates two or more components,
            // all of which must occur, in any order.

            // Use MatchOnce for groups with a large number of terms,
            // since &&-groups produces at least N!-node trees
            if (terms.length > 5) {
                return {
                    type: 'MatchOnce',
                    terms: terms,
                    all: true
                };
            }

            // Use a combination tree for groups with small number of terms
            //
            // a && b && c
            // =
            // match a
            //   then [b && c]
            //   else match b
            //     then [a && c]
            //     else match c
            //       then [a && b]
            //       else MISMATCH
            //
            // a && b
            // =
            // match a
            //   then match b
            //     then MATCH
            //     else MISMATCH
            //   else match b
            //     then match a
            //       then MATCH
            //       else MISMATCH
            //     else MISMATCH
            var result = MISMATCH;

            for (var i = terms.length - 1; i >= 0; i--) {
                var term = terms[i];
                var thenClause;

                if (terms.length > 1) {
                    thenClause = buildGroupMatchGraph(
                        combinator,
                        terms.filter(function(newGroupTerm) {
                            return newGroupTerm !== term;
                        }),
                        false
                    );
                } else {
                    thenClause = MATCH;
                }

                result = createCondition(
                    term,
                    thenClause,
                    result
                );
            };

            return result;

        case '||':
            // A double bar (||) separates two or more options:
            // one or more of them must occur, in any order.

            // Use MatchOnce for groups with a large number of terms,
            // since ||-groups produces at least N!-node trees
            if (terms.length > 5) {
                return {
                    type: 'MatchOnce',
                    terms: terms,
                    all: false
                };
            }

            // Use a combination tree for groups with small number of terms
            //
            // a || b || c
            // =
            // match a
            //   then [b || c]
            //   else match b
            //     then [a || c]
            //     else match c
            //       then [a || b]
            //       else MISMATCH
            //
            // a || b
            // =
            // match a
            //   then match b
            //     then MATCH
            //     else MATCH
            //   else match b
            //     then match a
            //       then MATCH
            //       else MATCH
            //     else MISMATCH
            var result = atLeastOneTermMatched ? MATCH : MISMATCH;

            for (var i = terms.length - 1; i >= 0; i--) {
                var term = terms[i];
                var thenClause;

                if (terms.length > 1) {
                    thenClause = buildGroupMatchGraph(
                        combinator,
                        terms.filter(function(newGroupTerm) {
                            return newGroupTerm !== term;
                        }),
                        true
                    );
                } else {
                    thenClause = MATCH;
                }

                result = createCondition(
                    term,
                    thenClause,
                    result
                );
            };

            return result;
    }
}

function buildMultiplierMatchGraph(node) {
    var result = MATCH;
    var matchTerm = buildMatchGraph(node.term);

    if (node.max === 0) {
        // disable repeating of empty match to prevent infinite loop
        matchTerm = createCondition(
            matchTerm,
            DISALLOW_EMPTY,
            MISMATCH
        );

        // an occurrence count is not limited, make a cycle;
        // to collect more terms on each following matching mismatch
        result = createCondition(
            matchTerm,
            null, // will be a loop
            MISMATCH
        );

        result.then = createCondition(
            MATCH,
            MATCH,
            result // make a loop
        );

        if (node.comma) {
            result.then.else = createCondition(
                { type: 'Comma', syntax: node },
                result,
                MISMATCH
            );
        }
    } else {
        // create a match node chain for [min .. max] interval with optional matches
        for (var i = node.min || 1; i <= node.max; i++) {
            if (node.comma && result !== MATCH) {
                result = createCondition(
                    { type: 'Comma', syntax: node },
                    result,
                    MISMATCH
                );
            }

            result = createCondition(
                matchTerm,
                createCondition(
                    MATCH,
                    MATCH,
                    result
                ),
                MISMATCH
            );
        }
    }

    if (node.min === 0) {
        // allow zero match
        result = createCondition(
            MATCH,
            MATCH,
            result
        );
    } else {
        // create a match node chain to collect [0 ... min - 1] required matches
        for (var i = 0; i < node.min - 1; i++) {
            if (node.comma && result !== MATCH) {
                result = createCondition(
                    { type: 'Comma', syntax: node },
                    result,
                    MISMATCH
                );
            }

            result = createCondition(
                matchTerm,
                result,
                MISMATCH
            );
        }
    }

    return result;
}

function buildMatchGraph(node) {
    if (typeof node === 'function') {
        return {
            type: 'Generic',
            fn: node
        };
    }

    switch (node.type) {
        case 'Group':
            var result = buildGroupMatchGraph(
                node.combinator,
                node.terms.map(buildMatchGraph),
                false
            );

            if (node.disallowEmpty) {
                result = createCondition(
                    result,
                    DISALLOW_EMPTY,
                    MISMATCH
                );
            }

            return result;

        case 'Multiplier':
            return buildMultiplierMatchGraph(node);

        case 'Type':
        case 'Property':
            return {
                type: node.type,
                name: node.name,
                syntax: node
            };

        case 'Keyword':
            return {
                type: node.type,
                name: node.name.toLowerCase(),
                syntax: node
            };

        case 'AtKeyword':
            return {
                type: node.type,
                name: '@' + node.name.toLowerCase(),
                syntax: node
            };

        case 'Function':
            return {
                type: node.type,
                name: node.name.toLowerCase() + '(',
                syntax: node
            };

        case 'String':
            // convert a one char length String to a Token
            if (node.value.length === 3) {
                return {
                    type: 'Token',
                    value: node.value.charAt(1),
                    syntax: node
                };
            }

            // otherwise use it as is
            return {
                type: node.type,
                value: node.value.substr(1, node.value.length - 2).replace(/\\'/g, '\''),
                syntax: node
            };

        case 'Token':
            return {
                type: node.type,
                value: node.value,
                syntax: node
            };

        case 'Comma':
            return {
                type: node.type,
                syntax: node
            };

        default:
            throw new Error('Unknown node type:', node.type);
    }
}

module.exports = {
    MATCH: MATCH,
    MISMATCH: MISMATCH,
    DISALLOW_EMPTY: DISALLOW_EMPTY,
    buildMatchGraph: function(syntaxTree, ref) {
        if (typeof syntaxTree === 'string') {
            syntaxTree = parse(syntaxTree);
        }

        return {
            type: 'MatchGraph',
            match: buildMatchGraph(syntaxTree),
            syntax: ref || null,
            source: syntaxTree
        };
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/lexer/match.js":
/*!**************************************************!*\
  !*** ./node_modules/css-tree/lib/lexer/match.js ***!
  \**************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasOwnProperty = Object.prototype.hasOwnProperty;
var matchGraph = __webpack_require__(/*! ./match-graph */ "./node_modules/css-tree/lib/lexer/match-graph.js");
var MATCH = matchGraph.MATCH;
var MISMATCH = matchGraph.MISMATCH;
var DISALLOW_EMPTY = matchGraph.DISALLOW_EMPTY;
var TYPE = (__webpack_require__(/*! ../tokenizer/const */ "./node_modules/css-tree/lib/tokenizer/const.js").TYPE);

var STUB = 0;
var TOKEN = 1;
var OPEN_SYNTAX = 2;
var CLOSE_SYNTAX = 3;

var EXIT_REASON_MATCH = 'Match';
var EXIT_REASON_MISMATCH = 'Mismatch';
var EXIT_REASON_ITERATION_LIMIT = 'Maximum iteration number exceeded (please fill an issue on https://github.com/csstree/csstree/issues)';

var ITERATION_LIMIT = 15000;
var totalIterationCount = 0;

function reverseList(list) {
    var prev = null;
    var next = null;
    var item = list;

    while (item !== null) {
        next = item.prev;
        item.prev = prev;
        prev = item;
        item = next;
    }

    return prev;
}

function areStringsEqualCaseInsensitive(testStr, referenceStr) {
    if (testStr.length !== referenceStr.length) {
        return false;
    }

    for (var i = 0; i < testStr.length; i++) {
        var testCode = testStr.charCodeAt(i);
        var referenceCode = referenceStr.charCodeAt(i);

        // testCode.toLowerCase() for U+0041 LATIN CAPITAL LETTER A (A) .. U+005A LATIN CAPITAL LETTER Z (Z).
        if (testCode >= 0x0041 && testCode <= 0x005A) {
            testCode = testCode | 32;
        }

        if (testCode !== referenceCode) {
            return false;
        }
    }

    return true;
}

function isContextEdgeDelim(token) {
    if (token.type !== TYPE.Delim) {
        return false;
    }

    // Fix matching for unicode-range: U+30??, U+FF00-FF9F
    // Probably we need to check out previous match instead
    return token.value !== '?';
}

function isCommaContextStart(token) {
    if (token === null) {
        return true;
    }

    return (
        token.type === TYPE.Comma ||
        token.type === TYPE.Function ||
        token.type === TYPE.LeftParenthesis ||
        token.type === TYPE.LeftSquareBracket ||
        token.type === TYPE.LeftCurlyBracket ||
        isContextEdgeDelim(token)
    );
}

function isCommaContextEnd(token) {
    if (token === null) {
        return true;
    }

    return (
        token.type === TYPE.RightParenthesis ||
        token.type === TYPE.RightSquareBracket ||
        token.type === TYPE.RightCurlyBracket ||
        token.type === TYPE.Delim
    );
}

function internalMatch(tokens, state, syntaxes) {
    function moveToNextToken() {
        do {
            tokenIndex++;
            token = tokenIndex < tokens.length ? tokens[tokenIndex] : null;
        } while (token !== null && (token.type === TYPE.WhiteSpace || token.type === TYPE.Comment));
    }

    function getNextToken(offset) {
        var nextIndex = tokenIndex + offset;

        return nextIndex < tokens.length ? tokens[nextIndex] : null;
    }

    function stateSnapshotFromSyntax(nextState, prev) {
        return {
            nextState: nextState,
            matchStack: matchStack,
            syntaxStack: syntaxStack,
            thenStack: thenStack,
            tokenIndex: tokenIndex,
            prev: prev
        };
    }

    function pushThenStack(nextState) {
        thenStack = {
            nextState: nextState,
            matchStack: matchStack,
            syntaxStack: syntaxStack,
            prev: thenStack
        };
    }

    function pushElseStack(nextState) {
        elseStack = stateSnapshotFromSyntax(nextState, elseStack);
    }

    function addTokenToMatch() {
        matchStack = {
            type: TOKEN,
            syntax: state.syntax,
            token: token,
            prev: matchStack
        };

        moveToNextToken();
        syntaxStash = null;

        if (tokenIndex > longestMatch) {
            longestMatch = tokenIndex;
        }
    }

    function openSyntax() {
        syntaxStack = {
            syntax: state.syntax,
            opts: state.syntax.opts || (syntaxStack !== null && syntaxStack.opts) || null,
            prev: syntaxStack
        };

        matchStack = {
            type: OPEN_SYNTAX,
            syntax: state.syntax,
            token: matchStack.token,
            prev: matchStack
        };
    }

    function closeSyntax() {
        if (matchStack.type === OPEN_SYNTAX) {
            matchStack = matchStack.prev;
        } else {
            matchStack = {
                type: CLOSE_SYNTAX,
                syntax: syntaxStack.syntax,
                token: matchStack.token,
                prev: matchStack
            };
        }

        syntaxStack = syntaxStack.prev;
    }

    var syntaxStack = null;
    var thenStack = null;
    var elseStack = null;

    // null – stashing allowed, nothing stashed
    // false – stashing disabled, nothing stashed
    // anithing else – fail stashable syntaxes, some syntax stashed
    var syntaxStash = null;

    var iterationCount = 0; // count iterations and prevent infinite loop
    var exitReason = null;

    var token = null;
    var tokenIndex = -1;
    var longestMatch = 0;
    var matchStack = {
        type: STUB,
        syntax: null,
        token: null,
        prev: null
    };

    moveToNextToken();

    while (exitReason === null && ++iterationCount < ITERATION_LIMIT) {
        // function mapList(list, fn) {
        //     var result = [];
        //     while (list) {
        //         result.unshift(fn(list));
        //         list = list.prev;
        //     }
        //     return result;
        // }
        // console.log('--\n',
        //     '#' + iterationCount,
        //     require('util').inspect({
        //         match: mapList(matchStack, x => x.type === TOKEN ? x.token && x.token.value : x.syntax ? ({ [OPEN_SYNTAX]: '<', [CLOSE_SYNTAX]: '</' }[x.type] || x.type) + '!' + x.syntax.name : null),
        //         token: token && token.value,
        //         tokenIndex,
        //         syntax: syntax.type + (syntax.id ? ' #' + syntax.id : '')
        //     }, { depth: null })
        // );
        switch (state.type) {
            case 'Match':
                if (thenStack === null) {
                    // turn to MISMATCH when some tokens left unmatched
                    if (token !== null) {
                        // doesn't mismatch if just one token left and it's an IE hack
                        if (tokenIndex !== tokens.length - 1 || (token.value !== '\\0' && token.value !== '\\9')) {
                            state = MISMATCH;
                            break;
                        }
                    }

                    // break the main loop, return a result - MATCH
                    exitReason = EXIT_REASON_MATCH;
                    break;
                }

                // go to next syntax (`then` branch)
                state = thenStack.nextState;

                // check match is not empty
                if (state === DISALLOW_EMPTY) {
                    if (thenStack.matchStack === matchStack) {
                        state = MISMATCH;
                        break;
                    } else {
                        state = MATCH;
                    }
                }

                // close syntax if needed
                while (thenStack.syntaxStack !== syntaxStack) {
                    closeSyntax();
                }

                // pop stack
                thenStack = thenStack.prev;
                break;

            case 'Mismatch':
                // when some syntax is stashed
                if (syntaxStash !== null && syntaxStash !== false) {
                    // there is no else branches or a branch reduce match stack
                    if (elseStack === null || tokenIndex > elseStack.tokenIndex) {
                        // restore state from the stash
                        elseStack = syntaxStash;
                        syntaxStash = false; // disable stashing
                    }
                } else if (elseStack === null) {
                    // no else branches -> break the main loop
                    // return a result - MISMATCH
                    exitReason = EXIT_REASON_MISMATCH;
                    break;
                }

                // go to next syntax (`else` branch)
                state = elseStack.nextState;

                // restore all the rest stack states
                thenStack = elseStack.thenStack;
                syntaxStack = elseStack.syntaxStack;
                matchStack = elseStack.matchStack;
                tokenIndex = elseStack.tokenIndex;
                token = tokenIndex < tokens.length ? tokens[tokenIndex] : null;

                // pop stack
                elseStack = elseStack.prev;
                break;

            case 'MatchGraph':
                state = state.match;
                break;

            case 'If':
                // IMPORTANT: else stack push must go first,
                // since it stores the state of thenStack before changes
                if (state.else !== MISMATCH) {
                    pushElseStack(state.else);
                }

                if (state.then !== MATCH) {
                    pushThenStack(state.then);
                }

                state = state.match;
                break;

            case 'MatchOnce':
                state = {
                    type: 'MatchOnceBuffer',
                    syntax: state,
                    index: 0,
                    mask: 0
                };
                break;

            case 'MatchOnceBuffer':
                var terms = state.syntax.terms;

                if (state.index === terms.length) {
                    // no matches at all or it's required all terms to be matched
                    if (state.mask === 0 || state.syntax.all) {
                        state = MISMATCH;
                        break;
                    }

                    // a partial match is ok
                    state = MATCH;
                    break;
                }

                // all terms are matched
                if (state.mask === (1 << terms.length) - 1) {
                    state = MATCH;
                    break;
                }

                for (; state.index < terms.length; state.index++) {
                    var matchFlag = 1 << state.index;

                    if ((state.mask & matchFlag) === 0) {
                        // IMPORTANT: else stack push must go first,
                        // since it stores the state of thenStack before changes
                        pushElseStack(state);
                        pushThenStack({
                            type: 'AddMatchOnce',
                            syntax: state.syntax,
                            mask: state.mask | matchFlag
                        });

                        // match
                        state = terms[state.index++];
                        break;
                    }
                }
                break;

            case 'AddMatchOnce':
                state = {
                    type: 'MatchOnceBuffer',
                    syntax: state.syntax,
                    index: 0,
                    mask: state.mask
                };
                break;

            case 'Enum':
                if (token !== null) {
                    var name = token.value.toLowerCase();

                    // drop \0 and \9 hack from keyword name
                    if (name.indexOf('\\') !== -1) {
                        name = name.replace(/\\[09].*$/, '');
                    }

                    if (hasOwnProperty.call(state.map, name)) {
                        state = state.map[name];
                        break;
                    }
                }

                state = MISMATCH;
                break;

            case 'Generic':
                var opts = syntaxStack !== null ? syntaxStack.opts : null;
                var lastTokenIndex = tokenIndex + Math.floor(state.fn(token, getNextToken, opts));

                if (!isNaN(lastTokenIndex) && lastTokenIndex > tokenIndex) {
                    while (tokenIndex < lastTokenIndex) {
                        addTokenToMatch();
                    }

                    state = MATCH;
                } else {
                    state = MISMATCH;
                }

                break;

            case 'Type':
            case 'Property':
                var syntaxDict = state.type === 'Type' ? 'types' : 'properties';
                var dictSyntax = hasOwnProperty.call(syntaxes, syntaxDict) ? syntaxes[syntaxDict][state.name] : null;

                if (!dictSyntax || !dictSyntax.match) {
                    throw new Error(
                        'Bad syntax reference: ' +
                        (state.type === 'Type'
                            ? '<' + state.name + '>'
                            : '<\'' + state.name + '\'>')
                    );
                }

                // stash a syntax for types with low priority
                if (syntaxStash !== false && token !== null && state.type === 'Type') {
                    var lowPriorityMatching =
                        // https://drafts.csswg.org/css-values-4/#custom-idents
                        // When parsing positionally-ambiguous keywords in a property value, a <custom-ident> production
                        // can only claim the keyword if no other unfulfilled production can claim it.
                        (state.name === 'custom-ident' && token.type === TYPE.Ident) ||

                        // https://drafts.csswg.org/css-values-4/#lengths
                        // ... if a `0` could be parsed as either a <number> or a <length> in a property (such as line-height),
                        // it must parse as a <number>
                        (state.name === 'length' && token.value === '0');

                    if (lowPriorityMatching) {
                        if (syntaxStash === null) {
                            syntaxStash = stateSnapshotFromSyntax(state, elseStack);
                        }

                        state = MISMATCH;
                        break;
                    }
                }

                openSyntax();
                state = dictSyntax.match;
                break;

            case 'Keyword':
                var name = state.name;

                if (token !== null) {
                    var keywordName = token.value;

                    // drop \0 and \9 hack from keyword name
                    if (keywordName.indexOf('\\') !== -1) {
                        keywordName = keywordName.replace(/\\[09].*$/, '');
                    }

                    if (areStringsEqualCaseInsensitive(keywordName, name)) {
                        addTokenToMatch();
                        state = MATCH;
                        break;
                    }
                }

                state = MISMATCH;
                break;

            case 'AtKeyword':
            case 'Function':
                if (token !== null && areStringsEqualCaseInsensitive(token.value, state.name)) {
                    addTokenToMatch();
                    state = MATCH;
                    break;
                }

                state = MISMATCH;
                break;

            case 'Token':
                if (token !== null && token.value === state.value) {
                    addTokenToMatch();
                    state = MATCH;
                    break;
                }

                state = MISMATCH;
                break;

            case 'Comma':
                if (token !== null && token.type === TYPE.Comma) {
                    if (isCommaContextStart(matchStack.token)) {
                        state = MISMATCH;
                    } else {
                        addTokenToMatch();
                        state = isCommaContextEnd(token) ? MISMATCH : MATCH;
                    }
                } else {
                    state = isCommaContextStart(matchStack.token) || isCommaContextEnd(token) ? MATCH : MISMATCH;
                }

                break;

            case 'String':
                var string = '';

                for (var lastTokenIndex = tokenIndex; lastTokenIndex < tokens.length && string.length < state.value.length; lastTokenIndex++) {
                    string += tokens[lastTokenIndex].value;
                }

                if (areStringsEqualCaseInsensitive(string, state.value)) {
                    while (tokenIndex < lastTokenIndex) {
                        addTokenToMatch();
                    }

                    state = MATCH;
                } else {
                    state = MISMATCH;
                }

                break;

            default:
                throw new Error('Unknown node type: ' + state.type);
        }
    }

    totalIterationCount += iterationCount;

    switch (exitReason) {
        case null:
            console.warn('[csstree-match] BREAK after ' + ITERATION_LIMIT + ' iterations');
            exitReason = EXIT_REASON_ITERATION_LIMIT;
            matchStack = null;
            break;

        case EXIT_REASON_MATCH:
            while (syntaxStack !== null) {
                closeSyntax();
            }
            break;

        default:
            matchStack = null;
    }

    return {
        tokens: tokens,
        reason: exitReason,
        iterations: iterationCount,
        match: matchStack,
        longestMatch: longestMatch
    };
}

function matchAsList(tokens, matchGraph, syntaxes) {
    var matchResult = internalMatch(tokens, matchGraph, syntaxes || {});

    if (matchResult.match !== null) {
        var item = reverseList(matchResult.match).prev;

        matchResult.match = [];

        while (item !== null) {
            switch (item.type) {
                case STUB:
                    break;

                case OPEN_SYNTAX:
                case CLOSE_SYNTAX:
                    matchResult.match.push({
                        type: item.type,
                        syntax: item.syntax
                    });
                    break;

                default:
                    matchResult.match.push({
                        token: item.token.value,
                        node: item.token.node
                    });
                    break;
            }

            item = item.prev;
        }
    }

    return matchResult;
}

function matchAsTree(tokens, matchGraph, syntaxes) {
    var matchResult = internalMatch(tokens, matchGraph, syntaxes || {});

    if (matchResult.match === null) {
        return matchResult;
    }

    var item = matchResult.match;
    var host = matchResult.match = {
        syntax: matchGraph.syntax || null,
        match: []
    };
    var hostStack = [host];

    // revert a list and start with 2nd item since 1st is a stub item
    item = reverseList(item).prev;

    // build a tree
    while (item !== null) {
        switch (item.type) {
            case OPEN_SYNTAX:
                host.match.push(host = {
                    syntax: item.syntax,
                    match: []
                });
                hostStack.push(host);
                break;

            case CLOSE_SYNTAX:
                hostStack.pop();
                host = hostStack[hostStack.length - 1];
                break;

            default:
                host.match.push({
                    syntax: item.syntax || null,
                    token: item.token.value,
                    node: item.token.node
                });
        }

        item = item.prev;
    }

    return matchResult;
}

module.exports = {
    matchAsList: matchAsList,
    matchAsTree: matchAsTree,
    getTotalIterationCount: function() {
        return totalIterationCount;
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/lexer/prepare-tokens.js":
/*!***********************************************************!*\
  !*** ./node_modules/css-tree/lib/lexer/prepare-tokens.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var tokenize = __webpack_require__(/*! ../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js");
var TokenStream = __webpack_require__(/*! ../common/TokenStream */ "./node_modules/css-tree/lib/common/TokenStream.js");
var tokenStream = new TokenStream();
var astToTokens = {
    decorator: function(handlers) {
        var curNode = null;
        var prev = { len: 0, node: null };
        var nodes = [prev];
        var buffer = '';

        return {
            children: handlers.children,
            node: function(node) {
                var tmp = curNode;
                curNode = node;
                handlers.node.call(this, node);
                curNode = tmp;
            },
            chunk: function(chunk) {
                buffer += chunk;
                if (prev.node !== curNode) {
                    nodes.push({
                        len: chunk.length,
                        node: curNode
                    });
                } else {
                    prev.len += chunk.length;
                }
            },
            result: function() {
                return prepareTokens(buffer, nodes);
            }
        };
    }
};

function prepareTokens(str, nodes) {
    var tokens = [];
    var nodesOffset = 0;
    var nodesIndex = 0;
    var currentNode = nodes ? nodes[nodesIndex].node : null;

    tokenize(str, tokenStream);

    while (!tokenStream.eof) {
        if (nodes) {
            while (nodesIndex < nodes.length && nodesOffset + nodes[nodesIndex].len <= tokenStream.tokenStart) {
                nodesOffset += nodes[nodesIndex++].len;
                currentNode = nodes[nodesIndex].node;
            }
        }

        tokens.push({
            type: tokenStream.tokenType,
            value: tokenStream.getTokenValue(),
            index: tokenStream.tokenIndex, // TODO: remove it, temporary solution
            balance: tokenStream.balance[tokenStream.tokenIndex], // TODO: remove it, temporary solution
            node: currentNode
        });
        tokenStream.next();
        // console.log({ ...tokens[tokens.length - 1], node: undefined });
    }

    return tokens;
}

module.exports = function(value, syntax) {
    if (typeof value === 'string') {
        return prepareTokens(value, null);
    }

    return syntax.generate(value, astToTokens);
};


/***/ }),

/***/ "./node_modules/css-tree/lib/lexer/search.js":
/*!***************************************************!*\
  !*** ./node_modules/css-tree/lib/lexer/search.js ***!
  \***************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var List = __webpack_require__(/*! ../common/List */ "./node_modules/css-tree/lib/common/List.js");

function getFirstMatchNode(matchNode) {
    if ('node' in matchNode) {
        return matchNode.node;
    }

    return getFirstMatchNode(matchNode.match[0]);
}

function getLastMatchNode(matchNode) {
    if ('node' in matchNode) {
        return matchNode.node;
    }

    return getLastMatchNode(matchNode.match[matchNode.match.length - 1]);
}

function matchFragments(lexer, ast, match, type, name) {
    function findFragments(matchNode) {
        if (matchNode.syntax !== null &&
            matchNode.syntax.type === type &&
            matchNode.syntax.name === name) {
            var start = getFirstMatchNode(matchNode);
            var end = getLastMatchNode(matchNode);

            lexer.syntax.walk(ast, function(node, item, list) {
                if (node === start) {
                    var nodes = new List();

                    do {
                        nodes.appendData(item.data);

                        if (item.data === end) {
                            break;
                        }

                        item = item.next;
                    } while (item !== null);

                    fragments.push({
                        parent: list,
                        nodes: nodes
                    });
                }
            });
        }

        if (Array.isArray(matchNode.match)) {
            matchNode.match.forEach(findFragments);
        }
    }

    var fragments = [];

    if (match.matched !== null) {
        findFragments(match.matched);
    }

    return fragments;
}

module.exports = {
    matchFragments: matchFragments
};


/***/ }),

/***/ "./node_modules/css-tree/lib/lexer/structure.js":
/*!******************************************************!*\
  !*** ./node_modules/css-tree/lib/lexer/structure.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var List = __webpack_require__(/*! ../common/List */ "./node_modules/css-tree/lib/common/List.js");
var hasOwnProperty = Object.prototype.hasOwnProperty;

function isValidNumber(value) {
    // Number.isInteger(value) && value >= 0
    return (
        typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value &&
        value >= 0
    );
}

function isValidLocation(loc) {
    return (
        Boolean(loc) &&
        isValidNumber(loc.offset) &&
        isValidNumber(loc.line) &&
        isValidNumber(loc.column)
    );
}

function createNodeStructureChecker(type, fields) {
    return function checkNode(node, warn) {
        if (!node || node.constructor !== Object) {
            return warn(node, 'Type of node should be an Object');
        }

        for (var key in node) {
            var valid = true;

            if (hasOwnProperty.call(node, key) === false) {
                continue;
            }

            if (key === 'type') {
                if (node.type !== type) {
                    warn(node, 'Wrong node type `' + node.type + '`, expected `' + type + '`');
                }
            } else if (key === 'loc') {
                if (node.loc === null) {
                    continue;
                } else if (node.loc && node.loc.constructor === Object) {
                    if (typeof node.loc.source !== 'string') {
                        key += '.source';
                    } else if (!isValidLocation(node.loc.start)) {
                        key += '.start';
                    } else if (!isValidLocation(node.loc.end)) {
                        key += '.end';
                    } else {
                        continue;
                    }
                }

                valid = false;
            } else if (fields.hasOwnProperty(key)) {
                for (var i = 0, valid = false; !valid && i < fields[key].length; i++) {
                    var fieldType = fields[key][i];

                    switch (fieldType) {
                        case String:
                            valid = typeof node[key] === 'string';
                            break;

                        case Boolean:
                            valid = typeof node[key] === 'boolean';
                            break;

                        case null:
                            valid = node[key] === null;
                            break;

                        default:
                            if (typeof fieldType === 'string') {
                                valid = node[key] && node[key].type === fieldType;
                            } else if (Array.isArray(fieldType)) {
                                valid = node[key] instanceof List;
                            }
                    }
                }
            } else {
                warn(node, 'Unknown field `' + key + '` for ' + type + ' node type');
            }

            if (!valid) {
                warn(node, 'Bad value for `' + type + '.' + key + '`');
            }
        }

        for (var key in fields) {
            if (hasOwnProperty.call(fields, key) &&
                hasOwnProperty.call(node, key) === false) {
                warn(node, 'Field `' + type + '.' + key + '` is missed');
            }
        }
    };
}

function processStructure(name, nodeType) {
    var structure = nodeType.structure;
    var fields = {
        type: String,
        loc: true
    };
    var docs = {
        type: '"' + name + '"'
    };

    for (var key in structure) {
        if (hasOwnProperty.call(structure, key) === false) {
            continue;
        }

        var docsTypes = [];
        var fieldTypes = fields[key] = Array.isArray(structure[key])
            ? structure[key].slice()
            : [structure[key]];

        for (var i = 0; i < fieldTypes.length; i++) {
            var fieldType = fieldTypes[i];
            if (fieldType === String || fieldType === Boolean) {
                docsTypes.push(fieldType.name);
            } else if (fieldType === null) {
                docsTypes.push('null');
            } else if (typeof fieldType === 'string') {
                docsTypes.push('<' + fieldType + '>');
            } else if (Array.isArray(fieldType)) {
                docsTypes.push('List'); // TODO: use type enum
            } else {
                throw new Error('Wrong value `' + fieldType + '` in `' + name + '.' + key + '` structure definition');
            }
        }

        docs[key] = docsTypes.join(' | ');
    }

    return {
        docs: docs,
        check: createNodeStructureChecker(name, fields)
    };
}

module.exports = {
    getStructureFromConfig: function(config) {
        var structure = {};

        if (config.node) {
            for (var name in config.node) {
                if (hasOwnProperty.call(config.node, name)) {
                    var nodeType = config.node[name];

                    if (nodeType.structure) {
                        structure[name] = processStructure(name, nodeType);
                    } else {
                        throw new Error('Missed `structure` field in `' + name + '` node type definition');
                    }
                }
            }
        }

        return structure;
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/lexer/trace.js":
/*!**************************************************!*\
  !*** ./node_modules/css-tree/lib/lexer/trace.js ***!
  \**************************************************/
/***/ (function(module) {

function getTrace(node) {
    function shouldPutToTrace(syntax) {
        if (syntax === null) {
            return false;
        }

        return (
            syntax.type === 'Type' ||
            syntax.type === 'Property' ||
            syntax.type === 'Keyword'
        );
    }

    function hasMatch(matchNode) {
        if (Array.isArray(matchNode.match)) {
            // use for-loop for better perfomance
            for (var i = 0; i < matchNode.match.length; i++) {
                if (hasMatch(matchNode.match[i])) {
                    if (shouldPutToTrace(matchNode.syntax)) {
                        result.unshift(matchNode.syntax);
                    }

                    return true;
                }
            }
        } else if (matchNode.node === node) {
            result = shouldPutToTrace(matchNode.syntax)
                ? [matchNode.syntax]
                : [];

            return true;
        }

        return false;
    }

    var result = null;

    if (this.matched !== null) {
        hasMatch(this.matched);
    }

    return result;
}

function testNode(match, node, fn) {
    var trace = getTrace.call(match, node);

    if (trace === null) {
        return false;
    }

    return trace.some(fn);
}

function isType(node, type) {
    return testNode(this, node, function(matchNode) {
        return matchNode.type === 'Type' && matchNode.name === type;
    });
}

function isProperty(node, property) {
    return testNode(this, node, function(matchNode) {
        return matchNode.type === 'Property' && matchNode.name === property;
    });
}

function isKeyword(node) {
    return testNode(this, node, function(matchNode) {
        return matchNode.type === 'Keyword';
    });
}

module.exports = {
    getTrace: getTrace,
    isType: isType,
    isProperty: isProperty,
    isKeyword: isKeyword
};


/***/ }),

/***/ "./node_modules/css-tree/lib/parser/create.js":
/*!****************************************************!*\
  !*** ./node_modules/css-tree/lib/parser/create.js ***!
  \****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var OffsetToLocation = __webpack_require__(/*! ../common/OffsetToLocation */ "./node_modules/css-tree/lib/common/OffsetToLocation.js");
var SyntaxError = __webpack_require__(/*! ../common/SyntaxError */ "./node_modules/css-tree/lib/common/SyntaxError.js");
var TokenStream = __webpack_require__(/*! ../common/TokenStream */ "./node_modules/css-tree/lib/common/TokenStream.js");
var List = __webpack_require__(/*! ../common/List */ "./node_modules/css-tree/lib/common/List.js");
var tokenize = __webpack_require__(/*! ../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js");
var constants = __webpack_require__(/*! ../tokenizer/const */ "./node_modules/css-tree/lib/tokenizer/const.js");
var { findWhiteSpaceStart, cmpStr } = __webpack_require__(/*! ../tokenizer/utils */ "./node_modules/css-tree/lib/tokenizer/utils.js");
var sequence = __webpack_require__(/*! ./sequence */ "./node_modules/css-tree/lib/parser/sequence.js");
var noop = function() {};

var TYPE = constants.TYPE;
var NAME = constants.NAME;
var WHITESPACE = TYPE.WhiteSpace;
var COMMENT = TYPE.Comment;
var IDENT = TYPE.Ident;
var FUNCTION = TYPE.Function;
var URL = TYPE.Url;
var HASH = TYPE.Hash;
var PERCENTAGE = TYPE.Percentage;
var NUMBER = TYPE.Number;
var NUMBERSIGN = 0x0023; // U+0023 NUMBER SIGN (#)
var NULL = 0;

function createParseContext(name) {
    return function() {
        return this[name]();
    };
}

function processConfig(config) {
    var parserConfig = {
        context: {},
        scope: {},
        atrule: {},
        pseudo: {}
    };

    if (config.parseContext) {
        for (var name in config.parseContext) {
            switch (typeof config.parseContext[name]) {
                case 'function':
                    parserConfig.context[name] = config.parseContext[name];
                    break;

                case 'string':
                    parserConfig.context[name] = createParseContext(config.parseContext[name]);
                    break;
            }
        }
    }

    if (config.scope) {
        for (var name in config.scope) {
            parserConfig.scope[name] = config.scope[name];
        }
    }

    if (config.atrule) {
        for (var name in config.atrule) {
            var atrule = config.atrule[name];

            if (atrule.parse) {
                parserConfig.atrule[name] = atrule.parse;
            }
        }
    }

    if (config.pseudo) {
        for (var name in config.pseudo) {
            var pseudo = config.pseudo[name];

            if (pseudo.parse) {
                parserConfig.pseudo[name] = pseudo.parse;
            }
        }
    }

    if (config.node) {
        for (var name in config.node) {
            parserConfig[name] = config.node[name].parse;
        }
    }

    return parserConfig;
}

module.exports = function createParser(config) {
    var parser = {
        scanner: new TokenStream(),
        locationMap: new OffsetToLocation(),

        filename: '<unknown>',
        needPositions: false,
        onParseError: noop,
        onParseErrorThrow: false,
        parseAtrulePrelude: true,
        parseRulePrelude: true,
        parseValue: true,
        parseCustomProperty: false,

        readSequence: sequence,

        createList: function() {
            return new List();
        },
        createSingleNodeList: function(node) {
            return new List().appendData(node);
        },
        getFirstListNode: function(list) {
            return list && list.first();
        },
        getLastListNode: function(list) {
            return list.last();
        },

        parseWithFallback: function(consumer, fallback) {
            var startToken = this.scanner.tokenIndex;

            try {
                return consumer.call(this);
            } catch (e) {
                if (this.onParseErrorThrow) {
                    throw e;
                }

                var fallbackNode = fallback.call(this, startToken);

                this.onParseErrorThrow = true;
                this.onParseError(e, fallbackNode);
                this.onParseErrorThrow = false;

                return fallbackNode;
            }
        },

        lookupNonWSType: function(offset) {
            do {
                var type = this.scanner.lookupType(offset++);
                if (type !== WHITESPACE) {
                    return type;
                }
            } while (type !== NULL);

            return NULL;
        },

        eat: function(tokenType) {
            if (this.scanner.tokenType !== tokenType) {
                var offset = this.scanner.tokenStart;
                var message = NAME[tokenType] + ' is expected';

                // tweak message and offset
                switch (tokenType) {
                    case IDENT:
                        // when identifier is expected but there is a function or url
                        if (this.scanner.tokenType === FUNCTION || this.scanner.tokenType === URL) {
                            offset = this.scanner.tokenEnd - 1;
                            message = 'Identifier is expected but function found';
                        } else {
                            message = 'Identifier is expected';
                        }
                        break;

                    case HASH:
                        if (this.scanner.isDelim(NUMBERSIGN)) {
                            this.scanner.next();
                            offset++;
                            message = 'Name is expected';
                        }
                        break;

                    case PERCENTAGE:
                        if (this.scanner.tokenType === NUMBER) {
                            offset = this.scanner.tokenEnd;
                            message = 'Percent sign is expected';
                        }
                        break;

                    default:
                        // when test type is part of another token show error for current position + 1
                        // e.g. eat(HYPHENMINUS) will fail on "-foo", but pointing on "-" is odd
                        if (this.scanner.source.charCodeAt(this.scanner.tokenStart) === tokenType) {
                            offset = offset + 1;
                        }
                }

                this.error(message, offset);
            }

            this.scanner.next();
        },

        consume: function(tokenType) {
            var value = this.scanner.getTokenValue();

            this.eat(tokenType);

            return value;
        },
        consumeFunctionName: function() {
            var name = this.scanner.source.substring(this.scanner.tokenStart, this.scanner.tokenEnd - 1);

            this.eat(FUNCTION);

            return name;
        },

        getLocation: function(start, end) {
            if (this.needPositions) {
                return this.locationMap.getLocationRange(
                    start,
                    end,
                    this.filename
                );
            }

            return null;
        },
        getLocationFromList: function(list) {
            if (this.needPositions) {
                var head = this.getFirstListNode(list);
                var tail = this.getLastListNode(list);
                return this.locationMap.getLocationRange(
                    head !== null ? head.loc.start.offset - this.locationMap.startOffset : this.scanner.tokenStart,
                    tail !== null ? tail.loc.end.offset - this.locationMap.startOffset : this.scanner.tokenStart,
                    this.filename
                );
            }

            return null;
        },

        error: function(message, offset) {
            var location = typeof offset !== 'undefined' && offset < this.scanner.source.length
                ? this.locationMap.getLocation(offset)
                : this.scanner.eof
                    ? this.locationMap.getLocation(findWhiteSpaceStart(this.scanner.source, this.scanner.source.length - 1))
                    : this.locationMap.getLocation(this.scanner.tokenStart);

            throw new SyntaxError(
                message || 'Unexpected input',
                this.scanner.source,
                location.offset,
                location.line,
                location.column
            );
        }
    };

    config = processConfig(config || {});
    for (var key in config) {
        parser[key] = config[key];
    }

    return function(source, options) {
        options = options || {};

        var context = options.context || 'default';
        var onComment = options.onComment;
        var ast;

        tokenize(source, parser.scanner);
        parser.locationMap.setSource(
            source,
            options.offset,
            options.line,
            options.column
        );

        parser.filename = options.filename || '<unknown>';
        parser.needPositions = Boolean(options.positions);
        parser.onParseError = typeof options.onParseError === 'function' ? options.onParseError : noop;
        parser.onParseErrorThrow = false;
        parser.parseAtrulePrelude = 'parseAtrulePrelude' in options ? Boolean(options.parseAtrulePrelude) : true;
        parser.parseRulePrelude = 'parseRulePrelude' in options ? Boolean(options.parseRulePrelude) : true;
        parser.parseValue = 'parseValue' in options ? Boolean(options.parseValue) : true;
        parser.parseCustomProperty = 'parseCustomProperty' in options ? Boolean(options.parseCustomProperty) : false;

        if (!parser.context.hasOwnProperty(context)) {
            throw new Error('Unknown context `' + context + '`');
        }

        if (typeof onComment === 'function') {
            parser.scanner.forEachToken((type, start, end) => {
                if (type === COMMENT) {
                    const loc = parser.getLocation(start, end);
                    const value = cmpStr(source, end - 2, end, '*/')
                        ? source.slice(start + 2, end - 2)
                        : source.slice(start + 2, end);

                    onComment(value, loc);
                }
            });
        }

        ast = parser.context[context].call(parser, options);

        if (!parser.scanner.eof) {
            parser.error();
        }

        return ast;
    };
};


/***/ }),

/***/ "./node_modules/css-tree/lib/parser/sequence.js":
/*!******************************************************!*\
  !*** ./node_modules/css-tree/lib/parser/sequence.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);
var WHITESPACE = TYPE.WhiteSpace;
var COMMENT = TYPE.Comment;

module.exports = function readSequence(recognizer) {
    var children = this.createList();
    var child = null;
    var context = {
        recognizer: recognizer,
        space: null,
        ignoreWS: false,
        ignoreWSAfter: false
    };

    this.scanner.skipSC();

    while (!this.scanner.eof) {
        switch (this.scanner.tokenType) {
            case COMMENT:
                this.scanner.next();
                continue;

            case WHITESPACE:
                if (context.ignoreWS) {
                    this.scanner.next();
                } else {
                    context.space = this.WhiteSpace();
                }
                continue;
        }

        child = recognizer.getNode.call(this, context);

        if (child === undefined) {
            break;
        }

        if (context.space !== null) {
            children.push(context.space);
            context.space = null;
        }

        children.push(child);

        if (context.ignoreWSAfter) {
            context.ignoreWSAfter = false;
            context.ignoreWS = true;
        } else {
            context.ignoreWS = false;
        }
    }

    return children;
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/atrule/font-face.js":
/*!**************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/atrule/font-face.js ***!
  \**************************************************************/
/***/ (function(module) {

module.exports = {
    parse: {
        prelude: null,
        block: function() {
            return this.Block(true);
        }
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/atrule/import.js":
/*!***********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/atrule/import.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var STRING = TYPE.String;
var IDENT = TYPE.Ident;
var URL = TYPE.Url;
var FUNCTION = TYPE.Function;
var LEFTPARENTHESIS = TYPE.LeftParenthesis;

module.exports = {
    parse: {
        prelude: function() {
            var children = this.createList();

            this.scanner.skipSC();

            switch (this.scanner.tokenType) {
                case STRING:
                    children.push(this.String());
                    break;

                case URL:
                case FUNCTION:
                    children.push(this.Url());
                    break;

                default:
                    this.error('String or url() is expected');
            }

            if (this.lookupNonWSType(0) === IDENT ||
                this.lookupNonWSType(0) === LEFTPARENTHESIS) {
                children.push(this.WhiteSpace());
                children.push(this.MediaQueryList());
            }

            return children;
        },
        block: null
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/atrule/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/atrule/index.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
    'font-face': __webpack_require__(/*! ./font-face */ "./node_modules/css-tree/lib/syntax/atrule/font-face.js"),
    'import': __webpack_require__(/*! ./import */ "./node_modules/css-tree/lib/syntax/atrule/import.js"),
    'media': __webpack_require__(/*! ./media */ "./node_modules/css-tree/lib/syntax/atrule/media.js"),
    'page': __webpack_require__(/*! ./page */ "./node_modules/css-tree/lib/syntax/atrule/page.js"),
    'supports': __webpack_require__(/*! ./supports */ "./node_modules/css-tree/lib/syntax/atrule/supports.js")
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/atrule/media.js":
/*!**********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/atrule/media.js ***!
  \**********************************************************/
/***/ (function(module) {

module.exports = {
    parse: {
        prelude: function() {
            return this.createSingleNodeList(
                this.MediaQueryList()
            );
        },
        block: function() {
            return this.Block(false);
        }
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/atrule/page.js":
/*!*********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/atrule/page.js ***!
  \*********************************************************/
/***/ (function(module) {

module.exports = {
    parse: {
        prelude: function() {
            return this.createSingleNodeList(
                this.SelectorList()
            );
        },
        block: function() {
            return this.Block(true);
        }
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/atrule/supports.js":
/*!*************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/atrule/supports.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var WHITESPACE = TYPE.WhiteSpace;
var COMMENT = TYPE.Comment;
var IDENT = TYPE.Ident;
var FUNCTION = TYPE.Function;
var COLON = TYPE.Colon;
var LEFTPARENTHESIS = TYPE.LeftParenthesis;

function consumeRaw() {
    return this.createSingleNodeList(
        this.Raw(this.scanner.tokenIndex, null, false)
    );
}

function parentheses() {
    this.scanner.skipSC();

    if (this.scanner.tokenType === IDENT &&
        this.lookupNonWSType(1) === COLON) {
        return this.createSingleNodeList(
            this.Declaration()
        );
    }

    return readSequence.call(this);
}

function readSequence() {
    var children = this.createList();
    var space = null;
    var child;

    this.scanner.skipSC();

    scan:
    while (!this.scanner.eof) {
        switch (this.scanner.tokenType) {
            case WHITESPACE:
                space = this.WhiteSpace();
                continue;

            case COMMENT:
                this.scanner.next();
                continue;

            case FUNCTION:
                child = this.Function(consumeRaw, this.scope.AtrulePrelude);
                break;

            case IDENT:
                child = this.Identifier();
                break;

            case LEFTPARENTHESIS:
                child = this.Parentheses(parentheses, this.scope.AtrulePrelude);
                break;

            default:
                break scan;
        }

        if (space !== null) {
            children.push(space);
            space = null;
        }

        children.push(child);
    }

    return children;
}

module.exports = {
    parse: {
        prelude: function() {
            var children = readSequence.call(this);

            if (this.getFirstListNode(children) === null) {
                this.error('Condition is expected');
            }

            return children;
        },
        block: function() {
            return this.Block(false);
        }
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/config/lexer.js":
/*!**********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/config/lexer.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var data = __webpack_require__(/*! ../../../data */ "./node_modules/css-tree/data/index.js");

module.exports = {
    generic: true,
    types: data.types,
    atrules: data.atrules,
    properties: data.properties,
    node: __webpack_require__(/*! ../node */ "./node_modules/css-tree/lib/syntax/node/index.js")
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/config/mix.js":
/*!********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/config/mix.js ***!
  \********************************************************/
/***/ (function(module) {

const hasOwnProperty = Object.prototype.hasOwnProperty;
const shape = {
    generic: true,
    types: appendOrAssign,
    atrules: {
        prelude: appendOrAssignOrNull,
        descriptors: appendOrAssignOrNull
    },
    properties: appendOrAssign,
    parseContext: assign,
    scope: deepAssign,
    atrule: ['parse'],
    pseudo: ['parse'],
    node: ['name', 'structure', 'parse', 'generate', 'walkContext']
};

function isObject(value) {
    return value && value.constructor === Object;
}

function copy(value) {
    return isObject(value)
        ? Object.assign({}, value)
        : value;
}

function assign(dest, src) {
    return Object.assign(dest, src);
}

function deepAssign(dest, src) {
    for (const key in src) {
        if (hasOwnProperty.call(src, key)) {
            if (isObject(dest[key])) {
                deepAssign(dest[key], copy(src[key]));
            } else {
                dest[key] = copy(src[key]);
            }
        }
    }

    return dest;
}

function append(a, b) {
    if (typeof b === 'string' && /^\s*\|/.test(b)) {
        return typeof a === 'string'
            ? a + b
            : b.replace(/^\s*\|\s*/, '');
    }

    return b || null;
}

function appendOrAssign(a, b) {
    if (typeof b === 'string') {
        return append(a, b);
    }

    const result = Object.assign({}, a);
    for (let key in b) {
        if (hasOwnProperty.call(b, key)) {
            result[key] = append(hasOwnProperty.call(a, key) ? a[key] : undefined, b[key]);
        }
    }

    return result;
}

function appendOrAssignOrNull(a, b) {
    const result = appendOrAssign(a, b);

    return !isObject(result) || Object.keys(result).length
        ? result
        : null;
}

function mix(dest, src, shape) {
    for (const key in shape) {
        if (hasOwnProperty.call(shape, key) === false) {
            continue;
        }

        if (shape[key] === true) {
            if (key in src) {
                if (hasOwnProperty.call(src, key)) {
                    dest[key] = copy(src[key]);
                }
            }
        } else if (shape[key]) {
            if (typeof shape[key] === 'function') {
                const fn = shape[key];
                dest[key] = fn({}, dest[key]);
                dest[key] = fn(dest[key] || {}, src[key]);
            } else if (isObject(shape[key])) {
                const result = {};

                for (let name in dest[key]) {
                    result[name] = mix({}, dest[key][name], shape[key]);
                }

                for (let name in src[key]) {
                    result[name] = mix(result[name] || {}, src[key][name], shape[key]);
                }

                dest[key] = result;
            } else if (Array.isArray(shape[key])) {
                const res = {};
                const innerShape = shape[key].reduce(function(s, k) {
                    s[k] = true;
                    return s;
                }, {});

                for (const [name, value] of Object.entries(dest[key] || {})) {
                    res[name] = {};
                    if (value) {
                        mix(res[name], value, innerShape);
                    }
                }

                for (const name in src[key]) {
                    if (hasOwnProperty.call(src[key], name)) {
                        if (!res[name]) {
                            res[name] = {};
                        }

                        if (src[key] && src[key][name]) {
                            mix(res[name], src[key][name], innerShape);
                        }
                    }
                }

                dest[key] = res;
            }
        }
    }
    return dest;
}

module.exports = (dest, src) => mix(dest, src, shape);


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/config/parser.js":
/*!***********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/config/parser.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
    parseContext: {
        default: 'StyleSheet',
        stylesheet: 'StyleSheet',
        atrule: 'Atrule',
        atrulePrelude: function(options) {
            return this.AtrulePrelude(options.atrule ? String(options.atrule) : null);
        },
        mediaQueryList: 'MediaQueryList',
        mediaQuery: 'MediaQuery',
        rule: 'Rule',
        selectorList: 'SelectorList',
        selector: 'Selector',
        block: function() {
            return this.Block(true);
        },
        declarationList: 'DeclarationList',
        declaration: 'Declaration',
        value: 'Value'
    },
    scope: __webpack_require__(/*! ../scope */ "./node_modules/css-tree/lib/syntax/scope/index.js"),
    atrule: __webpack_require__(/*! ../atrule */ "./node_modules/css-tree/lib/syntax/atrule/index.js"),
    pseudo: __webpack_require__(/*! ../pseudo */ "./node_modules/css-tree/lib/syntax/pseudo/index.js"),
    node: __webpack_require__(/*! ../node */ "./node_modules/css-tree/lib/syntax/node/index.js")
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/config/walker.js":
/*!***********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/config/walker.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
    node: __webpack_require__(/*! ../node */ "./node_modules/css-tree/lib/syntax/node/index.js")
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/create.js":
/*!****************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/create.js ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var List = __webpack_require__(/*! ../common/List */ "./node_modules/css-tree/lib/common/List.js");
var SyntaxError = __webpack_require__(/*! ../common/SyntaxError */ "./node_modules/css-tree/lib/common/SyntaxError.js");
var TokenStream = __webpack_require__(/*! ../common/TokenStream */ "./node_modules/css-tree/lib/common/TokenStream.js");
var Lexer = __webpack_require__(/*! ../lexer/Lexer */ "./node_modules/css-tree/lib/lexer/Lexer.js");
var definitionSyntax = __webpack_require__(/*! ../definition-syntax */ "./node_modules/css-tree/lib/definition-syntax/index.js");
var tokenize = __webpack_require__(/*! ../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js");
var createParser = __webpack_require__(/*! ../parser/create */ "./node_modules/css-tree/lib/parser/create.js");
var createGenerator = __webpack_require__(/*! ../generator/create */ "./node_modules/css-tree/lib/generator/create.js");
var createConvertor = __webpack_require__(/*! ../convertor/create */ "./node_modules/css-tree/lib/convertor/create.js");
var createWalker = __webpack_require__(/*! ../walker/create */ "./node_modules/css-tree/lib/walker/create.js");
var clone = __webpack_require__(/*! ../utils/clone */ "./node_modules/css-tree/lib/utils/clone.js");
var names = __webpack_require__(/*! ../utils/names */ "./node_modules/css-tree/lib/utils/names.js");
var mix = __webpack_require__(/*! ./config/mix */ "./node_modules/css-tree/lib/syntax/config/mix.js");

function createSyntax(config) {
    var parse = createParser(config);
    var walk = createWalker(config);
    var generate = createGenerator(config);
    var convert = createConvertor(walk);

    var syntax = {
        List: List,
        SyntaxError: SyntaxError,
        TokenStream: TokenStream,
        Lexer: Lexer,

        vendorPrefix: names.vendorPrefix,
        keyword: names.keyword,
        property: names.property,
        isCustomProperty: names.isCustomProperty,

        definitionSyntax: definitionSyntax,
        lexer: null,
        createLexer: function(config) {
            return new Lexer(config, syntax, syntax.lexer.structure);
        },

        tokenize: tokenize,
        parse: parse,
        walk: walk,
        generate: generate,

        find: walk.find,
        findLast: walk.findLast,
        findAll: walk.findAll,

        clone: clone,
        fromPlainObject: convert.fromPlainObject,
        toPlainObject: convert.toPlainObject,

        createSyntax: function(config) {
            return createSyntax(mix({}, config));
        },
        fork: function(extension) {
            var base = mix({}, config); // copy of config
            return createSyntax(
                typeof extension === 'function'
                    ? extension(base, Object.assign)
                    : mix(base, extension)
            );
        }
    };

    syntax.lexer = new Lexer({
        generic: true,
        types: config.types,
        atrules: config.atrules,
        properties: config.properties,
        node: config.node
    }, syntax);

    return syntax;
};

exports.create = function(config) {
    return createSyntax(mix({}, config));
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/function/expression.js":
/*!*****************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/function/expression.js ***!
  \*****************************************************************/
/***/ (function(module) {

// legacy IE function
// expression( <any-value> )
module.exports = function() {
    return this.createSingleNodeList(
        this.Raw(this.scanner.tokenIndex, null, false)
    );
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/function/var.js":
/*!**********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/function/var.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);
var rawMode = (__webpack_require__(/*! ../node/Raw */ "./node_modules/css-tree/lib/syntax/node/Raw.js").mode);

var COMMA = TYPE.Comma;
var WHITESPACE = TYPE.WhiteSpace;

// var( <ident> , <value>? )
module.exports = function() {
    var children = this.createList();

    this.scanner.skipSC();

    // NOTE: Don't check more than a first argument is an ident, rest checks are for lexer
    children.push(this.Identifier());

    this.scanner.skipSC();

    if (this.scanner.tokenType === COMMA) {
        children.push(this.Operator());

        const startIndex = this.scanner.tokenIndex;
        const value = this.parseCustomProperty
            ? this.Value(null)
            : this.Raw(this.scanner.tokenIndex, rawMode.exclamationMarkOrSemicolon, false);

        if (value.type === 'Value' && value.children.isEmpty()) {
            for (let offset = startIndex - this.scanner.tokenIndex; offset <= 0; offset++) {
                if (this.scanner.lookupType(offset) === WHITESPACE) {
                    value.children.appendData({
                        type: 'WhiteSpace',
                        loc: null,
                        value: ' '
                    });
                    break;
                }
            }
        }

        children.push(value);
    }

    return children;
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/index.js":
/*!***************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/index.js ***!
  \***************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function merge() {
    var dest = {};

    for (var i = 0; i < arguments.length; i++) {
        var src = arguments[i];
        for (var key in src) {
            dest[key] = src[key];
        }
    }

    return dest;
}

module.exports = (__webpack_require__(/*! ./create */ "./node_modules/css-tree/lib/syntax/create.js").create)(
    merge(
        __webpack_require__(/*! ./config/lexer */ "./node_modules/css-tree/lib/syntax/config/lexer.js"),
        __webpack_require__(/*! ./config/parser */ "./node_modules/css-tree/lib/syntax/config/parser.js"),
        __webpack_require__(/*! ./config/walker */ "./node_modules/css-tree/lib/syntax/config/walker.js")
    )
);
module.exports.version = __webpack_require__(/*! ../../package.json */ "./node_modules/css-tree/package.json").version;


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/AnPlusB.js":
/*!**********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/AnPlusB.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cmpChar = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").cmpChar);
var isDigit = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").isDigit);
var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var WHITESPACE = TYPE.WhiteSpace;
var COMMENT = TYPE.Comment;
var IDENT = TYPE.Ident;
var NUMBER = TYPE.Number;
var DIMENSION = TYPE.Dimension;
var PLUSSIGN = 0x002B;    // U+002B PLUS SIGN (+)
var HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
var N = 0x006E;           // U+006E LATIN SMALL LETTER N (n)
var DISALLOW_SIGN = true;
var ALLOW_SIGN = false;

function checkInteger(offset, disallowSign) {
    var pos = this.scanner.tokenStart + offset;
    var code = this.scanner.source.charCodeAt(pos);

    if (code === PLUSSIGN || code === HYPHENMINUS) {
        if (disallowSign) {
            this.error('Number sign is not allowed');
        }
        pos++;
    }

    for (; pos < this.scanner.tokenEnd; pos++) {
        if (!isDigit(this.scanner.source.charCodeAt(pos))) {
            this.error('Integer is expected', pos);
        }
    }
}

function checkTokenIsInteger(disallowSign) {
    return checkInteger.call(this, 0, disallowSign);
}

function expectCharCode(offset, code) {
    if (!cmpChar(this.scanner.source, this.scanner.tokenStart + offset, code)) {
        var msg = '';

        switch (code) {
            case N:
                msg = 'N is expected';
                break;
            case HYPHENMINUS:
                msg = 'HyphenMinus is expected';
                break;
        }

        this.error(msg, this.scanner.tokenStart + offset);
    }
}

// ... <signed-integer>
// ... ['+' | '-'] <signless-integer>
function consumeB() {
    var offset = 0;
    var sign = 0;
    var type = this.scanner.tokenType;

    while (type === WHITESPACE || type === COMMENT) {
        type = this.scanner.lookupType(++offset);
    }

    if (type !== NUMBER) {
        if (this.scanner.isDelim(PLUSSIGN, offset) ||
            this.scanner.isDelim(HYPHENMINUS, offset)) {
            sign = this.scanner.isDelim(PLUSSIGN, offset) ? PLUSSIGN : HYPHENMINUS;

            do {
                type = this.scanner.lookupType(++offset);
            } while (type === WHITESPACE || type === COMMENT);

            if (type !== NUMBER) {
                this.scanner.skip(offset);
                checkTokenIsInteger.call(this, DISALLOW_SIGN);
            }
        } else {
            return null;
        }
    }

    if (offset > 0) {
        this.scanner.skip(offset);
    }

    if (sign === 0) {
        type = this.scanner.source.charCodeAt(this.scanner.tokenStart);
        if (type !== PLUSSIGN && type !== HYPHENMINUS) {
            this.error('Number sign is expected');
        }
    }

    checkTokenIsInteger.call(this, sign !== 0);
    return sign === HYPHENMINUS ? '-' + this.consume(NUMBER) : this.consume(NUMBER);
}

// An+B microsyntax https://www.w3.org/TR/css-syntax-3/#anb
module.exports = {
    name: 'AnPlusB',
    structure: {
        a: [String, null],
        b: [String, null]
    },
    parse: function() {
        /* eslint-disable brace-style*/
        var start = this.scanner.tokenStart;
        var a = null;
        var b = null;

        // <integer>
        if (this.scanner.tokenType === NUMBER) {
            checkTokenIsInteger.call(this, ALLOW_SIGN);
            b = this.consume(NUMBER);
        }

        // -n
        // -n <signed-integer>
        // -n ['+' | '-'] <signless-integer>
        // -n- <signless-integer>
        // <dashndashdigit-ident>
        else if (this.scanner.tokenType === IDENT && cmpChar(this.scanner.source, this.scanner.tokenStart, HYPHENMINUS)) {
            a = '-1';

            expectCharCode.call(this, 1, N);

            switch (this.scanner.getTokenLength()) {
                // -n
                // -n <signed-integer>
                // -n ['+' | '-'] <signless-integer>
                case 2:
                    this.scanner.next();
                    b = consumeB.call(this);
                    break;

                // -n- <signless-integer>
                case 3:
                    expectCharCode.call(this, 2, HYPHENMINUS);

                    this.scanner.next();
                    this.scanner.skipSC();

                    checkTokenIsInteger.call(this, DISALLOW_SIGN);

                    b = '-' + this.consume(NUMBER);
                    break;

                // <dashndashdigit-ident>
                default:
                    expectCharCode.call(this, 2, HYPHENMINUS);
                    checkInteger.call(this, 3, DISALLOW_SIGN);
                    this.scanner.next();

                    b = this.scanner.substrToCursor(start + 2);
            }
        }

        // '+'? n
        // '+'? n <signed-integer>
        // '+'? n ['+' | '-'] <signless-integer>
        // '+'? n- <signless-integer>
        // '+'? <ndashdigit-ident>
        else if (this.scanner.tokenType === IDENT || (this.scanner.isDelim(PLUSSIGN) && this.scanner.lookupType(1) === IDENT)) {
            var sign = 0;
            a = '1';

            // just ignore a plus
            if (this.scanner.isDelim(PLUSSIGN)) {
                sign = 1;
                this.scanner.next();
            }

            expectCharCode.call(this, 0, N);

            switch (this.scanner.getTokenLength()) {
                // '+'? n
                // '+'? n <signed-integer>
                // '+'? n ['+' | '-'] <signless-integer>
                case 1:
                    this.scanner.next();
                    b = consumeB.call(this);
                    break;

                // '+'? n- <signless-integer>
                case 2:
                    expectCharCode.call(this, 1, HYPHENMINUS);

                    this.scanner.next();
                    this.scanner.skipSC();

                    checkTokenIsInteger.call(this, DISALLOW_SIGN);

                    b = '-' + this.consume(NUMBER);
                    break;

                // '+'? <ndashdigit-ident>
                default:
                    expectCharCode.call(this, 1, HYPHENMINUS);
                    checkInteger.call(this, 2, DISALLOW_SIGN);
                    this.scanner.next();

                    b = this.scanner.substrToCursor(start + sign + 1);
            }
        }

        // <ndashdigit-dimension>
        // <ndash-dimension> <signless-integer>
        // <n-dimension>
        // <n-dimension> <signed-integer>
        // <n-dimension> ['+' | '-'] <signless-integer>
        else if (this.scanner.tokenType === DIMENSION) {
            var code = this.scanner.source.charCodeAt(this.scanner.tokenStart);
            var sign = code === PLUSSIGN || code === HYPHENMINUS;

            for (var i = this.scanner.tokenStart + sign; i < this.scanner.tokenEnd; i++) {
                if (!isDigit(this.scanner.source.charCodeAt(i))) {
                    break;
                }
            }

            if (i === this.scanner.tokenStart + sign) {
                this.error('Integer is expected', this.scanner.tokenStart + sign);
            }

            expectCharCode.call(this, i - this.scanner.tokenStart, N);
            a = this.scanner.source.substring(start, i);

            // <n-dimension>
            // <n-dimension> <signed-integer>
            // <n-dimension> ['+' | '-'] <signless-integer>
            if (i + 1 === this.scanner.tokenEnd) {
                this.scanner.next();
                b = consumeB.call(this);
            } else {
                expectCharCode.call(this, i - this.scanner.tokenStart + 1, HYPHENMINUS);

                // <ndash-dimension> <signless-integer>
                if (i + 2 === this.scanner.tokenEnd) {
                    this.scanner.next();
                    this.scanner.skipSC();
                    checkTokenIsInteger.call(this, DISALLOW_SIGN);
                    b = '-' + this.consume(NUMBER);
                }
                // <ndashdigit-dimension>
                else {
                    checkInteger.call(this, i - this.scanner.tokenStart + 2, DISALLOW_SIGN);
                    this.scanner.next();
                    b = this.scanner.substrToCursor(i + 1);
                }
            }
        } else {
            this.error();
        }

        if (a !== null && a.charCodeAt(0) === PLUSSIGN) {
            a = a.substr(1);
        }

        if (b !== null && b.charCodeAt(0) === PLUSSIGN) {
            b = b.substr(1);
        }

        return {
            type: 'AnPlusB',
            loc: this.getLocation(start, this.scanner.tokenStart),
            a: a,
            b: b
        };
    },
    generate: function(node) {
        var a = node.a !== null && node.a !== undefined;
        var b = node.b !== null && node.b !== undefined;

        if (a) {
            this.chunk(
                node.a === '+1' ? '+n' : // eslint-disable-line operator-linebreak, indent
                node.a ===  '1' ?  'n' : // eslint-disable-line operator-linebreak, indent
                node.a === '-1' ? '-n' : // eslint-disable-line operator-linebreak, indent
                node.a + 'n'             // eslint-disable-line operator-linebreak, indent
            );

            if (b) {
                b = String(node.b);
                if (b.charAt(0) === '-' || b.charAt(0) === '+') {
                    this.chunk(b.charAt(0));
                    this.chunk(b.substr(1));
                } else {
                    this.chunk('+');
                    this.chunk(b);
                }
            }
        } else {
            this.chunk(String(node.b));
        }
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Atrule.js":
/*!*********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Atrule.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);
var rawMode = (__webpack_require__(/*! ./Raw */ "./node_modules/css-tree/lib/syntax/node/Raw.js").mode);

var ATKEYWORD = TYPE.AtKeyword;
var SEMICOLON = TYPE.Semicolon;
var LEFTCURLYBRACKET = TYPE.LeftCurlyBracket;
var RIGHTCURLYBRACKET = TYPE.RightCurlyBracket;

function consumeRaw(startToken) {
    return this.Raw(startToken, rawMode.leftCurlyBracketOrSemicolon, true);
}

function isDeclarationBlockAtrule() {
    for (var offset = 1, type; type = this.scanner.lookupType(offset); offset++) {
        if (type === RIGHTCURLYBRACKET) {
            return true;
        }

        if (type === LEFTCURLYBRACKET ||
            type === ATKEYWORD) {
            return false;
        }
    }

    return false;
}

module.exports = {
    name: 'Atrule',
    structure: {
        name: String,
        prelude: ['AtrulePrelude', 'Raw', null],
        block: ['Block', null]
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var name;
        var nameLowerCase;
        var prelude = null;
        var block = null;

        this.eat(ATKEYWORD);

        name = this.scanner.substrToCursor(start + 1);
        nameLowerCase = name.toLowerCase();
        this.scanner.skipSC();

        // parse prelude
        if (this.scanner.eof === false &&
            this.scanner.tokenType !== LEFTCURLYBRACKET &&
            this.scanner.tokenType !== SEMICOLON) {
            if (this.parseAtrulePrelude) {
                prelude = this.parseWithFallback(this.AtrulePrelude.bind(this, name), consumeRaw);

                // turn empty AtrulePrelude into null
                if (prelude.type === 'AtrulePrelude' && prelude.children.head === null) {
                    prelude = null;
                }
            } else {
                prelude = consumeRaw.call(this, this.scanner.tokenIndex);
            }

            this.scanner.skipSC();
        }

        switch (this.scanner.tokenType) {
            case SEMICOLON:
                this.scanner.next();
                break;

            case LEFTCURLYBRACKET:
                if (this.atrule.hasOwnProperty(nameLowerCase) &&
                    typeof this.atrule[nameLowerCase].block === 'function') {
                    block = this.atrule[nameLowerCase].block.call(this);
                } else {
                    // TODO: should consume block content as Raw?
                    block = this.Block(isDeclarationBlockAtrule.call(this));
                }

                break;
        }

        return {
            type: 'Atrule',
            loc: this.getLocation(start, this.scanner.tokenStart),
            name: name,
            prelude: prelude,
            block: block
        };
    },
    generate: function(node) {
        this.chunk('@');
        this.chunk(node.name);

        if (node.prelude !== null) {
            this.chunk(' ');
            this.node(node.prelude);
        }

        if (node.block) {
            this.node(node.block);
        } else {
            this.chunk(';');
        }
    },
    walkContext: 'atrule'
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/AtrulePrelude.js":
/*!****************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/AtrulePrelude.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var SEMICOLON = TYPE.Semicolon;
var LEFTCURLYBRACKET = TYPE.LeftCurlyBracket;

module.exports = {
    name: 'AtrulePrelude',
    structure: {
        children: [[]]
    },
    parse: function(name) {
        var children = null;

        if (name !== null) {
            name = name.toLowerCase();
        }

        this.scanner.skipSC();

        if (this.atrule.hasOwnProperty(name) &&
            typeof this.atrule[name].prelude === 'function') {
            // custom consumer
            children = this.atrule[name].prelude.call(this);
        } else {
            // default consumer
            children = this.readSequence(this.scope.AtrulePrelude);
        }

        this.scanner.skipSC();

        if (this.scanner.eof !== true &&
            this.scanner.tokenType !== LEFTCURLYBRACKET &&
            this.scanner.tokenType !== SEMICOLON) {
            this.error('Semicolon or block is expected');
        }

        if (children === null) {
            children = this.createList();
        }

        return {
            type: 'AtrulePrelude',
            loc: this.getLocationFromList(children),
            children: children
        };
    },
    generate: function(node) {
        this.children(node);
    },
    walkContext: 'atrulePrelude'
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/AttributeSelector.js":
/*!********************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/AttributeSelector.js ***!
  \********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var IDENT = TYPE.Ident;
var STRING = TYPE.String;
var COLON = TYPE.Colon;
var LEFTSQUAREBRACKET = TYPE.LeftSquareBracket;
var RIGHTSQUAREBRACKET = TYPE.RightSquareBracket;
var DOLLARSIGN = 0x0024;       // U+0024 DOLLAR SIGN ($)
var ASTERISK = 0x002A;         // U+002A ASTERISK (*)
var EQUALSSIGN = 0x003D;       // U+003D EQUALS SIGN (=)
var CIRCUMFLEXACCENT = 0x005E; // U+005E (^)
var VERTICALLINE = 0x007C;     // U+007C VERTICAL LINE (|)
var TILDE = 0x007E;            // U+007E TILDE (~)

function getAttributeName() {
    if (this.scanner.eof) {
        this.error('Unexpected end of input');
    }

    var start = this.scanner.tokenStart;
    var expectIdent = false;
    var checkColon = true;

    if (this.scanner.isDelim(ASTERISK)) {
        expectIdent = true;
        checkColon = false;
        this.scanner.next();
    } else if (!this.scanner.isDelim(VERTICALLINE)) {
        this.eat(IDENT);
    }

    if (this.scanner.isDelim(VERTICALLINE)) {
        if (this.scanner.source.charCodeAt(this.scanner.tokenStart + 1) !== EQUALSSIGN) {
            this.scanner.next();
            this.eat(IDENT);
        } else if (expectIdent) {
            this.error('Identifier is expected', this.scanner.tokenEnd);
        }
    } else if (expectIdent) {
        this.error('Vertical line is expected');
    }

    if (checkColon && this.scanner.tokenType === COLON) {
        this.scanner.next();
        this.eat(IDENT);
    }

    return {
        type: 'Identifier',
        loc: this.getLocation(start, this.scanner.tokenStart),
        name: this.scanner.substrToCursor(start)
    };
}

function getOperator() {
    var start = this.scanner.tokenStart;
    var code = this.scanner.source.charCodeAt(start);

    if (code !== EQUALSSIGN &&        // =
        code !== TILDE &&             // ~=
        code !== CIRCUMFLEXACCENT &&  // ^=
        code !== DOLLARSIGN &&        // $=
        code !== ASTERISK &&          // *=
        code !== VERTICALLINE         // |=
    ) {
        this.error('Attribute selector (=, ~=, ^=, $=, *=, |=) is expected');
    }

    this.scanner.next();

    if (code !== EQUALSSIGN) {
        if (!this.scanner.isDelim(EQUALSSIGN)) {
            this.error('Equal sign is expected');
        }

        this.scanner.next();
    }

    return this.scanner.substrToCursor(start);
}

// '[' <wq-name> ']'
// '[' <wq-name> <attr-matcher> [ <string-token> | <ident-token> ] <attr-modifier>? ']'
module.exports = {
    name: 'AttributeSelector',
    structure: {
        name: 'Identifier',
        matcher: [String, null],
        value: ['String', 'Identifier', null],
        flags: [String, null]
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var name;
        var matcher = null;
        var value = null;
        var flags = null;

        this.eat(LEFTSQUAREBRACKET);
        this.scanner.skipSC();

        name = getAttributeName.call(this);
        this.scanner.skipSC();

        if (this.scanner.tokenType !== RIGHTSQUAREBRACKET) {
            // avoid case `[name i]`
            if (this.scanner.tokenType !== IDENT) {
                matcher = getOperator.call(this);

                this.scanner.skipSC();

                value = this.scanner.tokenType === STRING
                    ? this.String()
                    : this.Identifier();

                this.scanner.skipSC();
            }

            // attribute flags
            if (this.scanner.tokenType === IDENT) {
                flags = this.scanner.getTokenValue();
                this.scanner.next();

                this.scanner.skipSC();
            }
        }

        this.eat(RIGHTSQUAREBRACKET);

        return {
            type: 'AttributeSelector',
            loc: this.getLocation(start, this.scanner.tokenStart),
            name: name,
            matcher: matcher,
            value: value,
            flags: flags
        };
    },
    generate: function(node) {
        var flagsPrefix = ' ';

        this.chunk('[');
        this.node(node.name);

        if (node.matcher !== null) {
            this.chunk(node.matcher);

            if (node.value !== null) {
                this.node(node.value);

                // space between string and flags is not required
                if (node.value.type === 'String') {
                    flagsPrefix = '';
                }
            }
        }

        if (node.flags !== null) {
            this.chunk(flagsPrefix);
            this.chunk(node.flags);
        }

        this.chunk(']');
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Block.js":
/*!********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Block.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);
var rawMode = (__webpack_require__(/*! ./Raw */ "./node_modules/css-tree/lib/syntax/node/Raw.js").mode);

var WHITESPACE = TYPE.WhiteSpace;
var COMMENT = TYPE.Comment;
var SEMICOLON = TYPE.Semicolon;
var ATKEYWORD = TYPE.AtKeyword;
var LEFTCURLYBRACKET = TYPE.LeftCurlyBracket;
var RIGHTCURLYBRACKET = TYPE.RightCurlyBracket;

function consumeRaw(startToken) {
    return this.Raw(startToken, null, true);
}
function consumeRule() {
    return this.parseWithFallback(this.Rule, consumeRaw);
}
function consumeRawDeclaration(startToken) {
    return this.Raw(startToken, rawMode.semicolonIncluded, true);
}
function consumeDeclaration() {
    if (this.scanner.tokenType === SEMICOLON) {
        return consumeRawDeclaration.call(this, this.scanner.tokenIndex);
    }

    var node = this.parseWithFallback(this.Declaration, consumeRawDeclaration);

    if (this.scanner.tokenType === SEMICOLON) {
        this.scanner.next();
    }

    return node;
}

module.exports = {
    name: 'Block',
    structure: {
        children: [[
            'Atrule',
            'Rule',
            'Declaration'
        ]]
    },
    parse: function(isDeclaration) {
        var consumer = isDeclaration ? consumeDeclaration : consumeRule;

        var start = this.scanner.tokenStart;
        var children = this.createList();

        this.eat(LEFTCURLYBRACKET);

        scan:
        while (!this.scanner.eof) {
            switch (this.scanner.tokenType) {
                case RIGHTCURLYBRACKET:
                    break scan;

                case WHITESPACE:
                case COMMENT:
                    this.scanner.next();
                    break;

                case ATKEYWORD:
                    children.push(this.parseWithFallback(this.Atrule, consumeRaw));
                    break;

                default:
                    children.push(consumer.call(this));
            }
        }

        if (!this.scanner.eof) {
            this.eat(RIGHTCURLYBRACKET);
        }

        return {
            type: 'Block',
            loc: this.getLocation(start, this.scanner.tokenStart),
            children: children
        };
    },
    generate: function(node) {
        this.chunk('{');
        this.children(node, function(prev) {
            if (prev.type === 'Declaration') {
                this.chunk(';');
            }
        });
        this.chunk('}');
    },
    walkContext: 'block'
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Brackets.js":
/*!***********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Brackets.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var LEFTSQUAREBRACKET = TYPE.LeftSquareBracket;
var RIGHTSQUAREBRACKET = TYPE.RightSquareBracket;

module.exports = {
    name: 'Brackets',
    structure: {
        children: [[]]
    },
    parse: function(readSequence, recognizer) {
        var start = this.scanner.tokenStart;
        var children = null;

        this.eat(LEFTSQUAREBRACKET);

        children = readSequence.call(this, recognizer);

        if (!this.scanner.eof) {
            this.eat(RIGHTSQUAREBRACKET);
        }

        return {
            type: 'Brackets',
            loc: this.getLocation(start, this.scanner.tokenStart),
            children: children
        };
    },
    generate: function(node) {
        this.chunk('[');
        this.children(node);
        this.chunk(']');
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/CDC.js":
/*!******************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/CDC.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var CDC = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE).CDC;

module.exports = {
    name: 'CDC',
    structure: [],
    parse: function() {
        var start = this.scanner.tokenStart;

        this.eat(CDC); // -->

        return {
            type: 'CDC',
            loc: this.getLocation(start, this.scanner.tokenStart)
        };
    },
    generate: function() {
        this.chunk('-->');
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/CDO.js":
/*!******************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/CDO.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var CDO = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE).CDO;

module.exports = {
    name: 'CDO',
    structure: [],
    parse: function() {
        var start = this.scanner.tokenStart;

        this.eat(CDO); // <!--

        return {
            type: 'CDO',
            loc: this.getLocation(start, this.scanner.tokenStart)
        };
    },
    generate: function() {
        this.chunk('<!--');
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/ClassSelector.js":
/*!****************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/ClassSelector.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var IDENT = TYPE.Ident;
var FULLSTOP = 0x002E; // U+002E FULL STOP (.)

// '.' ident
module.exports = {
    name: 'ClassSelector',
    structure: {
        name: String
    },
    parse: function() {
        if (!this.scanner.isDelim(FULLSTOP)) {
            this.error('Full stop is expected');
        }

        this.scanner.next();

        return {
            type: 'ClassSelector',
            loc: this.getLocation(this.scanner.tokenStart - 1, this.scanner.tokenEnd),
            name: this.consume(IDENT)
        };
    },
    generate: function(node) {
        this.chunk('.');
        this.chunk(node.name);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Combinator.js":
/*!*************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Combinator.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var IDENT = TYPE.Ident;
var PLUSSIGN = 0x002B;        // U+002B PLUS SIGN (+)
var SOLIDUS = 0x002F;         // U+002F SOLIDUS (/)
var GREATERTHANSIGN = 0x003E; // U+003E GREATER-THAN SIGN (>)
var TILDE = 0x007E;           // U+007E TILDE (~)

// + | > | ~ | /deep/
module.exports = {
    name: 'Combinator',
    structure: {
        name: String
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var code = this.scanner.source.charCodeAt(this.scanner.tokenStart);

        switch (code) {
            case GREATERTHANSIGN:
            case PLUSSIGN:
            case TILDE:
                this.scanner.next();
                break;

            case SOLIDUS:
                this.scanner.next();

                if (this.scanner.tokenType !== IDENT || this.scanner.lookupValue(0, 'deep') === false) {
                    this.error('Identifier `deep` is expected');
                }

                this.scanner.next();

                if (!this.scanner.isDelim(SOLIDUS)) {
                    this.error('Solidus is expected');
                }

                this.scanner.next();
                break;

            default:
                this.error('Combinator is expected');
        }

        return {
            type: 'Combinator',
            loc: this.getLocation(start, this.scanner.tokenStart),
            name: this.scanner.substrToCursor(start)
        };
    },
    generate: function(node) {
        this.chunk(node.name);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Comment.js":
/*!**********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Comment.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var COMMENT = TYPE.Comment;
var ASTERISK = 0x002A;        // U+002A ASTERISK (*)
var SOLIDUS = 0x002F;         // U+002F SOLIDUS (/)

// '/*' .* '*/'
module.exports = {
    name: 'Comment',
    structure: {
        value: String
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var end = this.scanner.tokenEnd;

        this.eat(COMMENT);

        if ((end - start + 2) >= 2 &&
            this.scanner.source.charCodeAt(end - 2) === ASTERISK &&
            this.scanner.source.charCodeAt(end - 1) === SOLIDUS) {
            end -= 2;
        }

        return {
            type: 'Comment',
            loc: this.getLocation(start, this.scanner.tokenStart),
            value: this.scanner.source.substring(start + 2, end)
        };
    },
    generate: function(node) {
        this.chunk('/*');
        this.chunk(node.value);
        this.chunk('*/');
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Declaration.js":
/*!**************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Declaration.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCustomProperty = (__webpack_require__(/*! ../../utils/names */ "./node_modules/css-tree/lib/utils/names.js").isCustomProperty);
var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);
var rawMode = (__webpack_require__(/*! ./Raw */ "./node_modules/css-tree/lib/syntax/node/Raw.js").mode);

var IDENT = TYPE.Ident;
var HASH = TYPE.Hash;
var COLON = TYPE.Colon;
var SEMICOLON = TYPE.Semicolon;
var DELIM = TYPE.Delim;
var WHITESPACE = TYPE.WhiteSpace;
var EXCLAMATIONMARK = 0x0021; // U+0021 EXCLAMATION MARK (!)
var NUMBERSIGN = 0x0023;      // U+0023 NUMBER SIGN (#)
var DOLLARSIGN = 0x0024;      // U+0024 DOLLAR SIGN ($)
var AMPERSAND = 0x0026;       // U+0026 ANPERSAND (&)
var ASTERISK = 0x002A;        // U+002A ASTERISK (*)
var PLUSSIGN = 0x002B;        // U+002B PLUS SIGN (+)
var SOLIDUS = 0x002F;         // U+002F SOLIDUS (/)

function consumeValueRaw(startToken) {
    return this.Raw(startToken, rawMode.exclamationMarkOrSemicolon, true);
}

function consumeCustomPropertyRaw(startToken) {
    return this.Raw(startToken, rawMode.exclamationMarkOrSemicolon, false);
}

function consumeValue() {
    var startValueToken = this.scanner.tokenIndex;
    var value = this.Value();

    if (value.type !== 'Raw' &&
        this.scanner.eof === false &&
        this.scanner.tokenType !== SEMICOLON &&
        this.scanner.isDelim(EXCLAMATIONMARK) === false &&
        this.scanner.isBalanceEdge(startValueToken) === false) {
        this.error();
    }

    return value;
}

module.exports = {
    name: 'Declaration',
    structure: {
        important: [Boolean, String],
        property: String,
        value: ['Value', 'Raw']
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var startToken = this.scanner.tokenIndex;
        var property = readProperty.call(this);
        var customProperty = isCustomProperty(property);
        var parseValue = customProperty ? this.parseCustomProperty : this.parseValue;
        var consumeRaw = customProperty ? consumeCustomPropertyRaw : consumeValueRaw;
        var important = false;
        var value;

        this.scanner.skipSC();
        this.eat(COLON);

        const valueStart = this.scanner.tokenIndex;

        if (!customProperty) {
            this.scanner.skipSC();
        }

        if (parseValue) {
            value = this.parseWithFallback(consumeValue, consumeRaw);
        } else {
            value = consumeRaw.call(this, this.scanner.tokenIndex);
        }

        if (customProperty && value.type === 'Value' && value.children.isEmpty()) {
            for (let offset = valueStart - this.scanner.tokenIndex; offset <= 0; offset++) {
                if (this.scanner.lookupType(offset) === WHITESPACE) {
                    value.children.appendData({
                        type: 'WhiteSpace',
                        loc: null,
                        value: ' '
                    });
                    break;
                }
            }
        }

        if (this.scanner.isDelim(EXCLAMATIONMARK)) {
            important = getImportant.call(this);
            this.scanner.skipSC();
        }

        // Do not include semicolon to range per spec
        // https://drafts.csswg.org/css-syntax/#declaration-diagram

        if (this.scanner.eof === false &&
            this.scanner.tokenType !== SEMICOLON &&
            this.scanner.isBalanceEdge(startToken) === false) {
            this.error();
        }

        return {
            type: 'Declaration',
            loc: this.getLocation(start, this.scanner.tokenStart),
            important: important,
            property: property,
            value: value
        };
    },
    generate: function(node) {
        this.chunk(node.property);
        this.chunk(':');
        this.node(node.value);

        if (node.important) {
            this.chunk(node.important === true ? '!important' : '!' + node.important);
        }
    },
    walkContext: 'declaration'
};

function readProperty() {
    var start = this.scanner.tokenStart;
    var prefix = 0;

    // hacks
    if (this.scanner.tokenType === DELIM) {
        switch (this.scanner.source.charCodeAt(this.scanner.tokenStart)) {
            case ASTERISK:
            case DOLLARSIGN:
            case PLUSSIGN:
            case NUMBERSIGN:
            case AMPERSAND:
                this.scanner.next();
                break;

            // TODO: not sure we should support this hack
            case SOLIDUS:
                this.scanner.next();
                if (this.scanner.isDelim(SOLIDUS)) {
                    this.scanner.next();
                }
                break;
        }
    }

    if (prefix) {
        this.scanner.skip(prefix);
    }

    if (this.scanner.tokenType === HASH) {
        this.eat(HASH);
    } else {
        this.eat(IDENT);
    }

    return this.scanner.substrToCursor(start);
}

// ! ws* important
function getImportant() {
    this.eat(DELIM);
    this.scanner.skipSC();

    var important = this.consume(IDENT);

    // store original value in case it differ from `important`
    // for better original source restoring and hacks like `!ie` support
    return important === 'important' ? true : important;
}


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/DeclarationList.js":
/*!******************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/DeclarationList.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);
var rawMode = (__webpack_require__(/*! ./Raw */ "./node_modules/css-tree/lib/syntax/node/Raw.js").mode);

var WHITESPACE = TYPE.WhiteSpace;
var COMMENT = TYPE.Comment;
var SEMICOLON = TYPE.Semicolon;

function consumeRaw(startToken) {
    return this.Raw(startToken, rawMode.semicolonIncluded, true);
}

module.exports = {
    name: 'DeclarationList',
    structure: {
        children: [[
            'Declaration'
        ]]
    },
    parse: function() {
        var children = this.createList();

        scan:
        while (!this.scanner.eof) {
            switch (this.scanner.tokenType) {
                case WHITESPACE:
                case COMMENT:
                case SEMICOLON:
                    this.scanner.next();
                    break;

                default:
                    children.push(this.parseWithFallback(this.Declaration, consumeRaw));
            }
        }

        return {
            type: 'DeclarationList',
            loc: this.getLocationFromList(children),
            children: children
        };
    },
    generate: function(node) {
        this.children(node, function(prev) {
            if (prev.type === 'Declaration') {
                this.chunk(';');
            }
        });
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Dimension.js":
/*!************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Dimension.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var consumeNumber = (__webpack_require__(/*! ../../tokenizer/utils */ "./node_modules/css-tree/lib/tokenizer/utils.js").consumeNumber);
var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var DIMENSION = TYPE.Dimension;

module.exports = {
    name: 'Dimension',
    structure: {
        value: String,
        unit: String
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var numberEnd = consumeNumber(this.scanner.source, start);

        this.eat(DIMENSION);

        return {
            type: 'Dimension',
            loc: this.getLocation(start, this.scanner.tokenStart),
            value: this.scanner.source.substring(start, numberEnd),
            unit: this.scanner.source.substring(numberEnd, this.scanner.tokenStart)
        };
    },
    generate: function(node) {
        this.chunk(node.value);
        this.chunk(node.unit);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Function.js":
/*!***********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Function.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var RIGHTPARENTHESIS = TYPE.RightParenthesis;

// <function-token> <sequence> )
module.exports = {
    name: 'Function',
    structure: {
        name: String,
        children: [[]]
    },
    parse: function(readSequence, recognizer) {
        var start = this.scanner.tokenStart;
        var name = this.consumeFunctionName();
        var nameLowerCase = name.toLowerCase();
        var children;

        children = recognizer.hasOwnProperty(nameLowerCase)
            ? recognizer[nameLowerCase].call(this, recognizer)
            : readSequence.call(this, recognizer);

        if (!this.scanner.eof) {
            this.eat(RIGHTPARENTHESIS);
        }

        return {
            type: 'Function',
            loc: this.getLocation(start, this.scanner.tokenStart),
            name: name,
            children: children
        };
    },
    generate: function(node) {
        this.chunk(node.name);
        this.chunk('(');
        this.children(node);
        this.chunk(')');
    },
    walkContext: 'function'
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Hash.js":
/*!*******************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Hash.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var HASH = TYPE.Hash;

// '#' ident
module.exports = {
    name: 'Hash',
    structure: {
        value: String
    },
    parse: function() {
        var start = this.scanner.tokenStart;

        this.eat(HASH);

        return {
            type: 'Hash',
            loc: this.getLocation(start, this.scanner.tokenStart),
            value: this.scanner.substrToCursor(start + 1)
        };
    },
    generate: function(node) {
        this.chunk('#');
        this.chunk(node.value);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/IdSelector.js":
/*!*************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/IdSelector.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var HASH = TYPE.Hash;

// <hash-token>
module.exports = {
    name: 'IdSelector',
    structure: {
        name: String
    },
    parse: function() {
        var start = this.scanner.tokenStart;

        // TODO: check value is an ident
        this.eat(HASH);

        return {
            type: 'IdSelector',
            loc: this.getLocation(start, this.scanner.tokenStart),
            name: this.scanner.substrToCursor(start + 1)
        };
    },
    generate: function(node) {
        this.chunk('#');
        this.chunk(node.name);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Identifier.js":
/*!*************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Identifier.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var IDENT = TYPE.Ident;

module.exports = {
    name: 'Identifier',
    structure: {
        name: String
    },
    parse: function() {
        return {
            type: 'Identifier',
            loc: this.getLocation(this.scanner.tokenStart, this.scanner.tokenEnd),
            name: this.consume(IDENT)
        };
    },
    generate: function(node) {
        this.chunk(node.name);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/MediaFeature.js":
/*!***************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/MediaFeature.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var IDENT = TYPE.Ident;
var NUMBER = TYPE.Number;
var DIMENSION = TYPE.Dimension;
var LEFTPARENTHESIS = TYPE.LeftParenthesis;
var RIGHTPARENTHESIS = TYPE.RightParenthesis;
var COLON = TYPE.Colon;
var DELIM = TYPE.Delim;

module.exports = {
    name: 'MediaFeature',
    structure: {
        name: String,
        value: ['Identifier', 'Number', 'Dimension', 'Ratio', null]
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var name;
        var value = null;

        this.eat(LEFTPARENTHESIS);
        this.scanner.skipSC();

        name = this.consume(IDENT);
        this.scanner.skipSC();

        if (this.scanner.tokenType !== RIGHTPARENTHESIS) {
            this.eat(COLON);
            this.scanner.skipSC();

            switch (this.scanner.tokenType) {
                case NUMBER:
                    if (this.lookupNonWSType(1) === DELIM) {
                        value = this.Ratio();
                    } else {
                        value = this.Number();
                    }

                    break;

                case DIMENSION:
                    value = this.Dimension();
                    break;

                case IDENT:
                    value = this.Identifier();

                    break;

                default:
                    this.error('Number, dimension, ratio or identifier is expected');
            }

            this.scanner.skipSC();
        }

        this.eat(RIGHTPARENTHESIS);

        return {
            type: 'MediaFeature',
            loc: this.getLocation(start, this.scanner.tokenStart),
            name: name,
            value: value
        };
    },
    generate: function(node) {
        this.chunk('(');
        this.chunk(node.name);
        if (node.value !== null) {
            this.chunk(':');
            this.node(node.value);
        }
        this.chunk(')');
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/MediaQuery.js":
/*!*************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/MediaQuery.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var WHITESPACE = TYPE.WhiteSpace;
var COMMENT = TYPE.Comment;
var IDENT = TYPE.Ident;
var LEFTPARENTHESIS = TYPE.LeftParenthesis;

module.exports = {
    name: 'MediaQuery',
    structure: {
        children: [[
            'Identifier',
            'MediaFeature',
            'WhiteSpace'
        ]]
    },
    parse: function() {
        this.scanner.skipSC();

        var children = this.createList();
        var child = null;
        var space = null;

        scan:
        while (!this.scanner.eof) {
            switch (this.scanner.tokenType) {
                case COMMENT:
                    this.scanner.next();
                    continue;

                case WHITESPACE:
                    space = this.WhiteSpace();
                    continue;

                case IDENT:
                    child = this.Identifier();
                    break;

                case LEFTPARENTHESIS:
                    child = this.MediaFeature();
                    break;

                default:
                    break scan;
            }

            if (space !== null) {
                children.push(space);
                space = null;
            }

            children.push(child);
        }

        if (child === null) {
            this.error('Identifier or parenthesis is expected');
        }

        return {
            type: 'MediaQuery',
            loc: this.getLocationFromList(children),
            children: children
        };
    },
    generate: function(node) {
        this.children(node);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/MediaQueryList.js":
/*!*****************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/MediaQueryList.js ***!
  \*****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var COMMA = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE).Comma;

module.exports = {
    name: 'MediaQueryList',
    structure: {
        children: [[
            'MediaQuery'
        ]]
    },
    parse: function(relative) {
        var children = this.createList();

        this.scanner.skipSC();

        while (!this.scanner.eof) {
            children.push(this.MediaQuery(relative));

            if (this.scanner.tokenType !== COMMA) {
                break;
            }

            this.scanner.next();
        }

        return {
            type: 'MediaQueryList',
            loc: this.getLocationFromList(children),
            children: children
        };
    },
    generate: function(node) {
        this.children(node, function() {
            this.chunk(',');
        });
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Nth.js":
/*!******************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Nth.js ***!
  \******************************************************/
/***/ (function(module) {

module.exports = {
    name: 'Nth',
    structure: {
        nth: ['AnPlusB', 'Identifier'],
        selector: ['SelectorList', null]
    },
    parse: function(allowOfClause) {
        this.scanner.skipSC();

        var start = this.scanner.tokenStart;
        var end = start;
        var selector = null;
        var query;

        if (this.scanner.lookupValue(0, 'odd') || this.scanner.lookupValue(0, 'even')) {
            query = this.Identifier();
        } else {
            query = this.AnPlusB();
        }

        this.scanner.skipSC();

        if (allowOfClause && this.scanner.lookupValue(0, 'of')) {
            this.scanner.next();

            selector = this.SelectorList();

            if (this.needPositions) {
                end = this.getLastListNode(selector.children).loc.end.offset;
            }
        } else {
            if (this.needPositions) {
                end = query.loc.end.offset;
            }
        }

        return {
            type: 'Nth',
            loc: this.getLocation(start, end),
            nth: query,
            selector: selector
        };
    },
    generate: function(node) {
        this.node(node.nth);
        if (node.selector !== null) {
            this.chunk(' of ');
            this.node(node.selector);
        }
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Number.js":
/*!*********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Number.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NUMBER = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE).Number;

module.exports = {
    name: 'Number',
    structure: {
        value: String
    },
    parse: function() {
        return {
            type: 'Number',
            loc: this.getLocation(this.scanner.tokenStart, this.scanner.tokenEnd),
            value: this.consume(NUMBER)
        };
    },
    generate: function(node) {
        this.chunk(node.value);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Operator.js":
/*!***********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Operator.js ***!
  \***********************************************************/
/***/ (function(module) {

// '/' | '*' | ',' | ':' | '+' | '-'
module.exports = {
    name: 'Operator',
    structure: {
        value: String
    },
    parse: function() {
        var start = this.scanner.tokenStart;

        this.scanner.next();

        return {
            type: 'Operator',
            loc: this.getLocation(start, this.scanner.tokenStart),
            value: this.scanner.substrToCursor(start)
        };
    },
    generate: function(node) {
        this.chunk(node.value);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Parentheses.js":
/*!**************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Parentheses.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var LEFTPARENTHESIS = TYPE.LeftParenthesis;
var RIGHTPARENTHESIS = TYPE.RightParenthesis;

module.exports = {
    name: 'Parentheses',
    structure: {
        children: [[]]
    },
    parse: function(readSequence, recognizer) {
        var start = this.scanner.tokenStart;
        var children = null;

        this.eat(LEFTPARENTHESIS);

        children = readSequence.call(this, recognizer);

        if (!this.scanner.eof) {
            this.eat(RIGHTPARENTHESIS);
        }

        return {
            type: 'Parentheses',
            loc: this.getLocation(start, this.scanner.tokenStart),
            children: children
        };
    },
    generate: function(node) {
        this.chunk('(');
        this.children(node);
        this.chunk(')');
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Percentage.js":
/*!*************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Percentage.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var consumeNumber = (__webpack_require__(/*! ../../tokenizer/utils */ "./node_modules/css-tree/lib/tokenizer/utils.js").consumeNumber);
var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var PERCENTAGE = TYPE.Percentage;

module.exports = {
    name: 'Percentage',
    structure: {
        value: String
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var numberEnd = consumeNumber(this.scanner.source, start);

        this.eat(PERCENTAGE);

        return {
            type: 'Percentage',
            loc: this.getLocation(start, this.scanner.tokenStart),
            value: this.scanner.source.substring(start, numberEnd)
        };
    },
    generate: function(node) {
        this.chunk(node.value);
        this.chunk('%');
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/PseudoClassSelector.js":
/*!**********************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/PseudoClassSelector.js ***!
  \**********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var IDENT = TYPE.Ident;
var FUNCTION = TYPE.Function;
var COLON = TYPE.Colon;
var RIGHTPARENTHESIS = TYPE.RightParenthesis;

// : [ <ident> | <function-token> <any-value>? ) ]
module.exports = {
    name: 'PseudoClassSelector',
    structure: {
        name: String,
        children: [['Raw'], null]
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var children = null;
        var name;
        var nameLowerCase;

        this.eat(COLON);

        if (this.scanner.tokenType === FUNCTION) {
            name = this.consumeFunctionName();
            nameLowerCase = name.toLowerCase();

            if (this.pseudo.hasOwnProperty(nameLowerCase)) {
                this.scanner.skipSC();
                children = this.pseudo[nameLowerCase].call(this);
                this.scanner.skipSC();
            } else {
                children = this.createList();
                children.push(
                    this.Raw(this.scanner.tokenIndex, null, false)
                );
            }

            this.eat(RIGHTPARENTHESIS);
        } else {
            name = this.consume(IDENT);
        }

        return {
            type: 'PseudoClassSelector',
            loc: this.getLocation(start, this.scanner.tokenStart),
            name: name,
            children: children
        };
    },
    generate: function(node) {
        this.chunk(':');
        this.chunk(node.name);

        if (node.children !== null) {
            this.chunk('(');
            this.children(node);
            this.chunk(')');
        }
    },
    walkContext: 'function'
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/PseudoElementSelector.js":
/*!************************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/PseudoElementSelector.js ***!
  \************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var IDENT = TYPE.Ident;
var FUNCTION = TYPE.Function;
var COLON = TYPE.Colon;
var RIGHTPARENTHESIS = TYPE.RightParenthesis;

// :: [ <ident> | <function-token> <any-value>? ) ]
module.exports = {
    name: 'PseudoElementSelector',
    structure: {
        name: String,
        children: [['Raw'], null]
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var children = null;
        var name;
        var nameLowerCase;

        this.eat(COLON);
        this.eat(COLON);

        if (this.scanner.tokenType === FUNCTION) {
            name = this.consumeFunctionName();
            nameLowerCase = name.toLowerCase();

            if (this.pseudo.hasOwnProperty(nameLowerCase)) {
                this.scanner.skipSC();
                children = this.pseudo[nameLowerCase].call(this);
                this.scanner.skipSC();
            } else {
                children = this.createList();
                children.push(
                    this.Raw(this.scanner.tokenIndex, null, false)
                );
            }

            this.eat(RIGHTPARENTHESIS);
        } else {
            name = this.consume(IDENT);
        }

        return {
            type: 'PseudoElementSelector',
            loc: this.getLocation(start, this.scanner.tokenStart),
            name: name,
            children: children
        };
    },
    generate: function(node) {
        this.chunk('::');
        this.chunk(node.name);

        if (node.children !== null) {
            this.chunk('(');
            this.children(node);
            this.chunk(')');
        }
    },
    walkContext: 'function'
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Ratio.js":
/*!********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Ratio.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isDigit = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").isDigit);
var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var NUMBER = TYPE.Number;
var DELIM = TYPE.Delim;
var SOLIDUS = 0x002F;  // U+002F SOLIDUS (/)
var FULLSTOP = 0x002E; // U+002E FULL STOP (.)

// Terms of <ratio> should be a positive numbers (not zero or negative)
// (see https://drafts.csswg.org/mediaqueries-3/#values)
// However, -o-min-device-pixel-ratio takes fractional values as a ratio's term
// and this is using by various sites. Therefore we relax checking on parse
// to test a term is unsigned number without an exponent part.
// Additional checking may be applied on lexer validation.
function consumeNumber() {
    this.scanner.skipWS();

    var value = this.consume(NUMBER);

    for (var i = 0; i < value.length; i++) {
        var code = value.charCodeAt(i);
        if (!isDigit(code) && code !== FULLSTOP) {
            this.error('Unsigned number is expected', this.scanner.tokenStart - value.length + i);
        }
    }

    if (Number(value) === 0) {
        this.error('Zero number is not allowed', this.scanner.tokenStart - value.length);
    }

    return value;
}

// <positive-integer> S* '/' S* <positive-integer>
module.exports = {
    name: 'Ratio',
    structure: {
        left: String,
        right: String
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var left = consumeNumber.call(this);
        var right;

        this.scanner.skipWS();

        if (!this.scanner.isDelim(SOLIDUS)) {
            this.error('Solidus is expected');
        }
        this.eat(DELIM);
        right = consumeNumber.call(this);

        return {
            type: 'Ratio',
            loc: this.getLocation(start, this.scanner.tokenStart),
            left: left,
            right: right
        };
    },
    generate: function(node) {
        this.chunk(node.left);
        this.chunk('/');
        this.chunk(node.right);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Raw.js":
/*!******************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Raw.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var tokenizer = __webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js");
var TYPE = tokenizer.TYPE;

var WhiteSpace = TYPE.WhiteSpace;
var Semicolon = TYPE.Semicolon;
var LeftCurlyBracket = TYPE.LeftCurlyBracket;
var Delim = TYPE.Delim;
var EXCLAMATIONMARK = 0x0021; // U+0021 EXCLAMATION MARK (!)

function getOffsetExcludeWS() {
    if (this.scanner.tokenIndex > 0) {
        if (this.scanner.lookupType(-1) === WhiteSpace) {
            return this.scanner.tokenIndex > 1
                ? this.scanner.getTokenStart(this.scanner.tokenIndex - 1)
                : this.scanner.firstCharOffset;
        }
    }

    return this.scanner.tokenStart;
}

// 0, 0, false
function balanceEnd() {
    return 0;
}

// LEFTCURLYBRACKET, 0, false
function leftCurlyBracket(tokenType) {
    return tokenType === LeftCurlyBracket ? 1 : 0;
}

// LEFTCURLYBRACKET, SEMICOLON, false
function leftCurlyBracketOrSemicolon(tokenType) {
    return tokenType === LeftCurlyBracket || tokenType === Semicolon ? 1 : 0;
}

// EXCLAMATIONMARK, SEMICOLON, false
function exclamationMarkOrSemicolon(tokenType, source, offset) {
    if (tokenType === Delim && source.charCodeAt(offset) === EXCLAMATIONMARK) {
        return 1;
    }

    return tokenType === Semicolon ? 1 : 0;
}

// 0, SEMICOLON, true
function semicolonIncluded(tokenType) {
    return tokenType === Semicolon ? 2 : 0;
}

module.exports = {
    name: 'Raw',
    structure: {
        value: String
    },
    parse: function(startToken, mode, excludeWhiteSpace) {
        var startOffset = this.scanner.getTokenStart(startToken);
        var endOffset;

        this.scanner.skip(
            this.scanner.getRawLength(startToken, mode || balanceEnd)
        );

        if (excludeWhiteSpace && this.scanner.tokenStart > startOffset) {
            endOffset = getOffsetExcludeWS.call(this);
        } else {
            endOffset = this.scanner.tokenStart;
        }

        return {
            type: 'Raw',
            loc: this.getLocation(startOffset, endOffset),
            value: this.scanner.source.substring(startOffset, endOffset)
        };
    },
    generate: function(node) {
        this.chunk(node.value);
    },

    mode: {
        default: balanceEnd,
        leftCurlyBracket: leftCurlyBracket,
        leftCurlyBracketOrSemicolon: leftCurlyBracketOrSemicolon,
        exclamationMarkOrSemicolon: exclamationMarkOrSemicolon,
        semicolonIncluded: semicolonIncluded
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Rule.js":
/*!*******************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Rule.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);
var rawMode = (__webpack_require__(/*! ./Raw */ "./node_modules/css-tree/lib/syntax/node/Raw.js").mode);

var LEFTCURLYBRACKET = TYPE.LeftCurlyBracket;

function consumeRaw(startToken) {
    return this.Raw(startToken, rawMode.leftCurlyBracket, true);
}

function consumePrelude() {
    var prelude = this.SelectorList();

    if (prelude.type !== 'Raw' &&
        this.scanner.eof === false &&
        this.scanner.tokenType !== LEFTCURLYBRACKET) {
        this.error();
    }

    return prelude;
}

module.exports = {
    name: 'Rule',
    structure: {
        prelude: ['SelectorList', 'Raw'],
        block: ['Block']
    },
    parse: function() {
        var startToken = this.scanner.tokenIndex;
        var startOffset = this.scanner.tokenStart;
        var prelude;
        var block;

        if (this.parseRulePrelude) {
            prelude = this.parseWithFallback(consumePrelude, consumeRaw);
        } else {
            prelude = consumeRaw.call(this, startToken);
        }

        block = this.Block(true);

        return {
            type: 'Rule',
            loc: this.getLocation(startOffset, this.scanner.tokenStart),
            prelude: prelude,
            block: block
        };
    },
    generate: function(node) {
        this.node(node.prelude);
        this.node(node.block);
    },
    walkContext: 'rule'
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Selector.js":
/*!***********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Selector.js ***!
  \***********************************************************/
/***/ (function(module) {

module.exports = {
    name: 'Selector',
    structure: {
        children: [[
            'TypeSelector',
            'IdSelector',
            'ClassSelector',
            'AttributeSelector',
            'PseudoClassSelector',
            'PseudoElementSelector',
            'Combinator',
            'WhiteSpace'
        ]]
    },
    parse: function() {
        var children = this.readSequence(this.scope.Selector);

        // nothing were consumed
        if (this.getFirstListNode(children) === null) {
            this.error('Selector is expected');
        }

        return {
            type: 'Selector',
            loc: this.getLocationFromList(children),
            children: children
        };
    },
    generate: function(node) {
        this.children(node);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/SelectorList.js":
/*!***************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/SelectorList.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var COMMA = TYPE.Comma;

module.exports = {
    name: 'SelectorList',
    structure: {
        children: [[
            'Selector',
            'Raw'
        ]]
    },
    parse: function() {
        var children = this.createList();

        while (!this.scanner.eof) {
            children.push(this.Selector());

            if (this.scanner.tokenType === COMMA) {
                this.scanner.next();
                continue;
            }

            break;
        }

        return {
            type: 'SelectorList',
            loc: this.getLocationFromList(children),
            children: children
        };
    },
    generate: function(node) {
        this.children(node, function() {
            this.chunk(',');
        });
    },
    walkContext: 'selector'
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/String.js":
/*!*********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/String.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var STRING = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE).String;

module.exports = {
    name: 'String',
    structure: {
        value: String
    },
    parse: function() {
        return {
            type: 'String',
            loc: this.getLocation(this.scanner.tokenStart, this.scanner.tokenEnd),
            value: this.consume(STRING)
        };
    },
    generate: function(node) {
        this.chunk(node.value);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/StyleSheet.js":
/*!*************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/StyleSheet.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var WHITESPACE = TYPE.WhiteSpace;
var COMMENT = TYPE.Comment;
var ATKEYWORD = TYPE.AtKeyword;
var CDO = TYPE.CDO;
var CDC = TYPE.CDC;
var EXCLAMATIONMARK = 0x0021; // U+0021 EXCLAMATION MARK (!)

function consumeRaw(startToken) {
    return this.Raw(startToken, null, false);
}

module.exports = {
    name: 'StyleSheet',
    structure: {
        children: [[
            'Comment',
            'CDO',
            'CDC',
            'Atrule',
            'Rule',
            'Raw'
        ]]
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var children = this.createList();
        var child;

        scan:
        while (!this.scanner.eof) {
            switch (this.scanner.tokenType) {
                case WHITESPACE:
                    this.scanner.next();
                    continue;

                case COMMENT:
                    // ignore comments except exclamation comments (i.e. /*! .. */) on top level
                    if (this.scanner.source.charCodeAt(this.scanner.tokenStart + 2) !== EXCLAMATIONMARK) {
                        this.scanner.next();
                        continue;
                    }

                    child = this.Comment();
                    break;

                case CDO: // <!--
                    child = this.CDO();
                    break;

                case CDC: // -->
                    child = this.CDC();
                    break;

                // CSS Syntax Module Level 3
                // §2.2 Error handling
                // At the "top level" of a stylesheet, an <at-keyword-token> starts an at-rule.
                case ATKEYWORD:
                    child = this.parseWithFallback(this.Atrule, consumeRaw);
                    break;

                // Anything else starts a qualified rule ...
                default:
                    child = this.parseWithFallback(this.Rule, consumeRaw);
            }

            children.push(child);
        }

        return {
            type: 'StyleSheet',
            loc: this.getLocation(start, this.scanner.tokenStart),
            children: children
        };
    },
    generate: function(node) {
        this.children(node);
    },
    walkContext: 'stylesheet'
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/TypeSelector.js":
/*!***************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/TypeSelector.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var IDENT = TYPE.Ident;
var ASTERISK = 0x002A;     // U+002A ASTERISK (*)
var VERTICALLINE = 0x007C; // U+007C VERTICAL LINE (|)

function eatIdentifierOrAsterisk() {
    if (this.scanner.tokenType !== IDENT &&
        this.scanner.isDelim(ASTERISK) === false) {
        this.error('Identifier or asterisk is expected');
    }

    this.scanner.next();
}

// ident
// ident|ident
// ident|*
// *
// *|ident
// *|*
// |ident
// |*
module.exports = {
    name: 'TypeSelector',
    structure: {
        name: String
    },
    parse: function() {
        var start = this.scanner.tokenStart;

        if (this.scanner.isDelim(VERTICALLINE)) {
            this.scanner.next();
            eatIdentifierOrAsterisk.call(this);
        } else {
            eatIdentifierOrAsterisk.call(this);

            if (this.scanner.isDelim(VERTICALLINE)) {
                this.scanner.next();
                eatIdentifierOrAsterisk.call(this);
            }
        }

        return {
            type: 'TypeSelector',
            loc: this.getLocation(start, this.scanner.tokenStart),
            name: this.scanner.substrToCursor(start)
        };
    },
    generate: function(node) {
        this.chunk(node.name);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/UnicodeRange.js":
/*!***************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/UnicodeRange.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isHexDigit = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").isHexDigit);
var cmpChar = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").cmpChar);
var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);
var NAME = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").NAME);

var IDENT = TYPE.Ident;
var NUMBER = TYPE.Number;
var DIMENSION = TYPE.Dimension;
var PLUSSIGN = 0x002B;     // U+002B PLUS SIGN (+)
var HYPHENMINUS = 0x002D;  // U+002D HYPHEN-MINUS (-)
var QUESTIONMARK = 0x003F; // U+003F QUESTION MARK (?)
var U = 0x0075;            // U+0075 LATIN SMALL LETTER U (u)

function eatHexSequence(offset, allowDash) {
    for (var pos = this.scanner.tokenStart + offset, len = 0; pos < this.scanner.tokenEnd; pos++) {
        var code = this.scanner.source.charCodeAt(pos);

        if (code === HYPHENMINUS && allowDash && len !== 0) {
            if (eatHexSequence.call(this, offset + len + 1, false) === 0) {
                this.error();
            }

            return -1;
        }

        if (!isHexDigit(code)) {
            this.error(
                allowDash && len !== 0
                    ? 'HyphenMinus' + (len < 6 ? ' or hex digit' : '') + ' is expected'
                    : (len < 6 ? 'Hex digit is expected' : 'Unexpected input'),
                pos
            );
        }

        if (++len > 6) {
            this.error('Too many hex digits', pos);
        };
    }

    this.scanner.next();
    return len;
}

function eatQuestionMarkSequence(max) {
    var count = 0;

    while (this.scanner.isDelim(QUESTIONMARK)) {
        if (++count > max) {
            this.error('Too many question marks');
        }

        this.scanner.next();
    }
}

function startsWith(code) {
    if (this.scanner.source.charCodeAt(this.scanner.tokenStart) !== code) {
        this.error(NAME[code] + ' is expected');
    }
}

// https://drafts.csswg.org/css-syntax/#urange
// Informally, the <urange> production has three forms:
// U+0001
//      Defines a range consisting of a single code point, in this case the code point "1".
// U+0001-00ff
//      Defines a range of codepoints between the first and the second value, in this case
//      the range between "1" and "ff" (255 in decimal) inclusive.
// U+00??
//      Defines a range of codepoints where the "?" characters range over all hex digits,
//      in this case defining the same as the value U+0000-00ff.
// In each form, a maximum of 6 digits is allowed for each hexadecimal number (if you treat "?" as a hexadecimal digit).
//
// <urange> =
//   u '+' <ident-token> '?'* |
//   u <dimension-token> '?'* |
//   u <number-token> '?'* |
//   u <number-token> <dimension-token> |
//   u <number-token> <number-token> |
//   u '+' '?'+
function scanUnicodeRange() {
    var hexLength = 0;

    // u '+' <ident-token> '?'*
    // u '+' '?'+
    if (this.scanner.isDelim(PLUSSIGN)) {
        this.scanner.next();

        if (this.scanner.tokenType === IDENT) {
            hexLength = eatHexSequence.call(this, 0, true);
            if (hexLength > 0) {
                eatQuestionMarkSequence.call(this, 6 - hexLength);
            }
            return;
        }

        if (this.scanner.isDelim(QUESTIONMARK)) {
            this.scanner.next();
            eatQuestionMarkSequence.call(this, 5);
            return;
        }

        this.error('Hex digit or question mark is expected');
        return;
    }

    // u <number-token> '?'*
    // u <number-token> <dimension-token>
    // u <number-token> <number-token>
    if (this.scanner.tokenType === NUMBER) {
        startsWith.call(this, PLUSSIGN);
        hexLength = eatHexSequence.call(this, 1, true);

        if (this.scanner.isDelim(QUESTIONMARK)) {
            eatQuestionMarkSequence.call(this, 6 - hexLength);
            return;
        }

        if (this.scanner.tokenType === DIMENSION ||
            this.scanner.tokenType === NUMBER) {
            startsWith.call(this, HYPHENMINUS);
            eatHexSequence.call(this, 1, false);
            return;
        }

        return;
    }

    // u <dimension-token> '?'*
    if (this.scanner.tokenType === DIMENSION) {
        startsWith.call(this, PLUSSIGN);
        hexLength = eatHexSequence.call(this, 1, true);

        if (hexLength > 0) {
            eatQuestionMarkSequence.call(this, 6 - hexLength);
        }

        return;
    }

    this.error();
}

module.exports = {
    name: 'UnicodeRange',
    structure: {
        value: String
    },
    parse: function() {
        var start = this.scanner.tokenStart;

        // U or u
        if (!cmpChar(this.scanner.source, start, U)) {
            this.error('U is expected');
        }

        if (!cmpChar(this.scanner.source, start + 1, PLUSSIGN)) {
            this.error('Plus sign is expected');
        }

        this.scanner.next();
        scanUnicodeRange.call(this);

        return {
            type: 'UnicodeRange',
            loc: this.getLocation(start, this.scanner.tokenStart),
            value: this.scanner.substrToCursor(start)
        };
    },
    generate: function(node) {
        this.chunk(node.value);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Url.js":
/*!******************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Url.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isWhiteSpace = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").isWhiteSpace);
var cmpStr = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").cmpStr);
var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var FUNCTION = TYPE.Function;
var URL = TYPE.Url;
var RIGHTPARENTHESIS = TYPE.RightParenthesis;

// <url-token> | <function-token> <string> )
module.exports = {
    name: 'Url',
    structure: {
        value: ['String', 'Raw']
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var value;

        switch (this.scanner.tokenType) {
            case URL:
                var rawStart = start + 4;
                var rawEnd = this.scanner.tokenEnd - 1;

                while (rawStart < rawEnd && isWhiteSpace(this.scanner.source.charCodeAt(rawStart))) {
                    rawStart++;
                }

                while (rawStart < rawEnd && isWhiteSpace(this.scanner.source.charCodeAt(rawEnd - 1))) {
                    rawEnd--;
                }

                value = {
                    type: 'Raw',
                    loc: this.getLocation(rawStart, rawEnd),
                    value: this.scanner.source.substring(rawStart, rawEnd)
                };

                this.eat(URL);
                break;

            case FUNCTION:
                if (!cmpStr(this.scanner.source, this.scanner.tokenStart, this.scanner.tokenEnd, 'url(')) {
                    this.error('Function name must be `url`');
                }

                this.eat(FUNCTION);
                this.scanner.skipSC();
                value = this.String();
                this.scanner.skipSC();
                this.eat(RIGHTPARENTHESIS);
                break;

            default:
                this.error('Url or Function is expected');
        }

        return {
            type: 'Url',
            loc: this.getLocation(start, this.scanner.tokenStart),
            value: value
        };
    },
    generate: function(node) {
        this.chunk('url');
        this.chunk('(');
        this.node(node.value);
        this.chunk(')');
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/Value.js":
/*!********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/Value.js ***!
  \********************************************************/
/***/ (function(module) {

module.exports = {
    name: 'Value',
    structure: {
        children: [[]]
    },
    parse: function() {
        var start = this.scanner.tokenStart;
        var children = this.readSequence(this.scope.Value);

        return {
            type: 'Value',
            loc: this.getLocation(start, this.scanner.tokenStart),
            children: children
        };
    },
    generate: function(node) {
        this.children(node);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/WhiteSpace.js":
/*!*************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/WhiteSpace.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var WHITESPACE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE).WhiteSpace;
var SPACE = Object.freeze({
    type: 'WhiteSpace',
    loc: null,
    value: ' '
});

module.exports = {
    name: 'WhiteSpace',
    structure: {
        value: String
    },
    parse: function() {
        this.eat(WHITESPACE);
        return SPACE;

        // return {
        //     type: 'WhiteSpace',
        //     loc: this.getLocation(this.scanner.tokenStart, this.scanner.tokenEnd),
        //     value: this.consume(WHITESPACE)
        // };
    },
    generate: function(node) {
        this.chunk(node.value);
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/node/index.js":
/*!********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/node/index.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
    AnPlusB: __webpack_require__(/*! ./AnPlusB */ "./node_modules/css-tree/lib/syntax/node/AnPlusB.js"),
    Atrule: __webpack_require__(/*! ./Atrule */ "./node_modules/css-tree/lib/syntax/node/Atrule.js"),
    AtrulePrelude: __webpack_require__(/*! ./AtrulePrelude */ "./node_modules/css-tree/lib/syntax/node/AtrulePrelude.js"),
    AttributeSelector: __webpack_require__(/*! ./AttributeSelector */ "./node_modules/css-tree/lib/syntax/node/AttributeSelector.js"),
    Block: __webpack_require__(/*! ./Block */ "./node_modules/css-tree/lib/syntax/node/Block.js"),
    Brackets: __webpack_require__(/*! ./Brackets */ "./node_modules/css-tree/lib/syntax/node/Brackets.js"),
    CDC: __webpack_require__(/*! ./CDC */ "./node_modules/css-tree/lib/syntax/node/CDC.js"),
    CDO: __webpack_require__(/*! ./CDO */ "./node_modules/css-tree/lib/syntax/node/CDO.js"),
    ClassSelector: __webpack_require__(/*! ./ClassSelector */ "./node_modules/css-tree/lib/syntax/node/ClassSelector.js"),
    Combinator: __webpack_require__(/*! ./Combinator */ "./node_modules/css-tree/lib/syntax/node/Combinator.js"),
    Comment: __webpack_require__(/*! ./Comment */ "./node_modules/css-tree/lib/syntax/node/Comment.js"),
    Declaration: __webpack_require__(/*! ./Declaration */ "./node_modules/css-tree/lib/syntax/node/Declaration.js"),
    DeclarationList: __webpack_require__(/*! ./DeclarationList */ "./node_modules/css-tree/lib/syntax/node/DeclarationList.js"),
    Dimension: __webpack_require__(/*! ./Dimension */ "./node_modules/css-tree/lib/syntax/node/Dimension.js"),
    Function: __webpack_require__(/*! ./Function */ "./node_modules/css-tree/lib/syntax/node/Function.js"),
    Hash: __webpack_require__(/*! ./Hash */ "./node_modules/css-tree/lib/syntax/node/Hash.js"),
    Identifier: __webpack_require__(/*! ./Identifier */ "./node_modules/css-tree/lib/syntax/node/Identifier.js"),
    IdSelector: __webpack_require__(/*! ./IdSelector */ "./node_modules/css-tree/lib/syntax/node/IdSelector.js"),
    MediaFeature: __webpack_require__(/*! ./MediaFeature */ "./node_modules/css-tree/lib/syntax/node/MediaFeature.js"),
    MediaQuery: __webpack_require__(/*! ./MediaQuery */ "./node_modules/css-tree/lib/syntax/node/MediaQuery.js"),
    MediaQueryList: __webpack_require__(/*! ./MediaQueryList */ "./node_modules/css-tree/lib/syntax/node/MediaQueryList.js"),
    Nth: __webpack_require__(/*! ./Nth */ "./node_modules/css-tree/lib/syntax/node/Nth.js"),
    Number: __webpack_require__(/*! ./Number */ "./node_modules/css-tree/lib/syntax/node/Number.js"),
    Operator: __webpack_require__(/*! ./Operator */ "./node_modules/css-tree/lib/syntax/node/Operator.js"),
    Parentheses: __webpack_require__(/*! ./Parentheses */ "./node_modules/css-tree/lib/syntax/node/Parentheses.js"),
    Percentage: __webpack_require__(/*! ./Percentage */ "./node_modules/css-tree/lib/syntax/node/Percentage.js"),
    PseudoClassSelector: __webpack_require__(/*! ./PseudoClassSelector */ "./node_modules/css-tree/lib/syntax/node/PseudoClassSelector.js"),
    PseudoElementSelector: __webpack_require__(/*! ./PseudoElementSelector */ "./node_modules/css-tree/lib/syntax/node/PseudoElementSelector.js"),
    Ratio: __webpack_require__(/*! ./Ratio */ "./node_modules/css-tree/lib/syntax/node/Ratio.js"),
    Raw: __webpack_require__(/*! ./Raw */ "./node_modules/css-tree/lib/syntax/node/Raw.js"),
    Rule: __webpack_require__(/*! ./Rule */ "./node_modules/css-tree/lib/syntax/node/Rule.js"),
    Selector: __webpack_require__(/*! ./Selector */ "./node_modules/css-tree/lib/syntax/node/Selector.js"),
    SelectorList: __webpack_require__(/*! ./SelectorList */ "./node_modules/css-tree/lib/syntax/node/SelectorList.js"),
    String: __webpack_require__(/*! ./String */ "./node_modules/css-tree/lib/syntax/node/String.js"),
    StyleSheet: __webpack_require__(/*! ./StyleSheet */ "./node_modules/css-tree/lib/syntax/node/StyleSheet.js"),
    TypeSelector: __webpack_require__(/*! ./TypeSelector */ "./node_modules/css-tree/lib/syntax/node/TypeSelector.js"),
    UnicodeRange: __webpack_require__(/*! ./UnicodeRange */ "./node_modules/css-tree/lib/syntax/node/UnicodeRange.js"),
    Url: __webpack_require__(/*! ./Url */ "./node_modules/css-tree/lib/syntax/node/Url.js"),
    Value: __webpack_require__(/*! ./Value */ "./node_modules/css-tree/lib/syntax/node/Value.js"),
    WhiteSpace: __webpack_require__(/*! ./WhiteSpace */ "./node_modules/css-tree/lib/syntax/node/WhiteSpace.js")
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/common/nth.js":
/*!***************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/common/nth.js ***!
  \***************************************************************/
/***/ (function(module) {

var DISALLOW_OF_CLAUSE = false;

module.exports = {
    parse: function nth() {
        return this.createSingleNodeList(
            this.Nth(DISALLOW_OF_CLAUSE)
        );
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/common/nthWithOfClause.js":
/*!***************************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/common/nthWithOfClause.js ***!
  \***************************************************************************/
/***/ (function(module) {

var ALLOW_OF_CLAUSE = true;

module.exports = {
    parse: function nthWithOfClause() {
        return this.createSingleNodeList(
            this.Nth(ALLOW_OF_CLAUSE)
        );
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/common/selectorList.js":
/*!************************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/common/selectorList.js ***!
  \************************************************************************/
/***/ (function(module) {

module.exports = {
    parse: function selectorList() {
        return this.createSingleNodeList(
            this.SelectorList()
        );
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/dir.js":
/*!********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/dir.js ***!
  \********************************************************/
/***/ (function(module) {

module.exports = {
    parse: function() {
        return this.createSingleNodeList(
            this.Identifier()
        );
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/has.js":
/*!********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/has.js ***!
  \********************************************************/
/***/ (function(module) {

module.exports = {
    parse: function() {
        return this.createSingleNodeList(
            this.SelectorList()
        );
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/index.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
    'dir': __webpack_require__(/*! ./dir */ "./node_modules/css-tree/lib/syntax/pseudo/dir.js"),
    'has': __webpack_require__(/*! ./has */ "./node_modules/css-tree/lib/syntax/pseudo/has.js"),
    'lang': __webpack_require__(/*! ./lang */ "./node_modules/css-tree/lib/syntax/pseudo/lang.js"),
    'matches': __webpack_require__(/*! ./matches */ "./node_modules/css-tree/lib/syntax/pseudo/matches.js"),
    'not': __webpack_require__(/*! ./not */ "./node_modules/css-tree/lib/syntax/pseudo/not.js"),
    'nth-child': __webpack_require__(/*! ./nth-child */ "./node_modules/css-tree/lib/syntax/pseudo/nth-child.js"),
    'nth-last-child': __webpack_require__(/*! ./nth-last-child */ "./node_modules/css-tree/lib/syntax/pseudo/nth-last-child.js"),
    'nth-last-of-type': __webpack_require__(/*! ./nth-last-of-type */ "./node_modules/css-tree/lib/syntax/pseudo/nth-last-of-type.js"),
    'nth-of-type': __webpack_require__(/*! ./nth-of-type */ "./node_modules/css-tree/lib/syntax/pseudo/nth-of-type.js"),
    'slotted': __webpack_require__(/*! ./slotted */ "./node_modules/css-tree/lib/syntax/pseudo/slotted.js")
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/lang.js":
/*!*********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/lang.js ***!
  \*********************************************************/
/***/ (function(module) {

module.exports = {
    parse: function() {
        return this.createSingleNodeList(
            this.Identifier()
        );
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/matches.js":
/*!************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/matches.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./common/selectorList */ "./node_modules/css-tree/lib/syntax/pseudo/common/selectorList.js");


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/not.js":
/*!********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/not.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./common/selectorList */ "./node_modules/css-tree/lib/syntax/pseudo/common/selectorList.js");


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/nth-child.js":
/*!**************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/nth-child.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./common/nthWithOfClause */ "./node_modules/css-tree/lib/syntax/pseudo/common/nthWithOfClause.js");


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/nth-last-child.js":
/*!*******************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/nth-last-child.js ***!
  \*******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./common/nthWithOfClause */ "./node_modules/css-tree/lib/syntax/pseudo/common/nthWithOfClause.js");


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/nth-last-of-type.js":
/*!*********************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/nth-last-of-type.js ***!
  \*********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./common/nth */ "./node_modules/css-tree/lib/syntax/pseudo/common/nth.js");


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/nth-of-type.js":
/*!****************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/nth-of-type.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./common/nth */ "./node_modules/css-tree/lib/syntax/pseudo/common/nth.js");


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/pseudo/slotted.js":
/*!************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/pseudo/slotted.js ***!
  \************************************************************/
/***/ (function(module) {

module.exports = {
    parse: function compoundSelector() {
        return this.createSingleNodeList(
            this.Selector()
        );
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/scope/atrulePrelude.js":
/*!*****************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/scope/atrulePrelude.js ***!
  \*****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
    getNode: __webpack_require__(/*! ./default */ "./node_modules/css-tree/lib/syntax/scope/default.js")
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/scope/default.js":
/*!***********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/scope/default.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cmpChar = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").cmpChar);
var cmpStr = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").cmpStr);
var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var IDENT = TYPE.Ident;
var STRING = TYPE.String;
var NUMBER = TYPE.Number;
var FUNCTION = TYPE.Function;
var URL = TYPE.Url;
var HASH = TYPE.Hash;
var DIMENSION = TYPE.Dimension;
var PERCENTAGE = TYPE.Percentage;
var LEFTPARENTHESIS = TYPE.LeftParenthesis;
var LEFTSQUAREBRACKET = TYPE.LeftSquareBracket;
var COMMA = TYPE.Comma;
var DELIM = TYPE.Delim;
var NUMBERSIGN = 0x0023;  // U+0023 NUMBER SIGN (#)
var ASTERISK = 0x002A;    // U+002A ASTERISK (*)
var PLUSSIGN = 0x002B;    // U+002B PLUS SIGN (+)
var HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
var SOLIDUS = 0x002F;     // U+002F SOLIDUS (/)
var U = 0x0075;           // U+0075 LATIN SMALL LETTER U (u)

module.exports = function defaultRecognizer(context) {
    switch (this.scanner.tokenType) {
        case HASH:
            return this.Hash();

        case COMMA:
            context.space = null;
            context.ignoreWSAfter = true;
            return this.Operator();

        case LEFTPARENTHESIS:
            return this.Parentheses(this.readSequence, context.recognizer);

        case LEFTSQUAREBRACKET:
            return this.Brackets(this.readSequence, context.recognizer);

        case STRING:
            return this.String();

        case DIMENSION:
            return this.Dimension();

        case PERCENTAGE:
            return this.Percentage();

        case NUMBER:
            return this.Number();

        case FUNCTION:
            return cmpStr(this.scanner.source, this.scanner.tokenStart, this.scanner.tokenEnd, 'url(')
                ? this.Url()
                : this.Function(this.readSequence, context.recognizer);

        case URL:
            return this.Url();

        case IDENT:
            // check for unicode range, it should start with u+ or U+
            if (cmpChar(this.scanner.source, this.scanner.tokenStart, U) &&
                cmpChar(this.scanner.source, this.scanner.tokenStart + 1, PLUSSIGN)) {
                return this.UnicodeRange();
            } else {
                return this.Identifier();
            }

        case DELIM:
            var code = this.scanner.source.charCodeAt(this.scanner.tokenStart);

            if (code === SOLIDUS ||
                code === ASTERISK ||
                code === PLUSSIGN ||
                code === HYPHENMINUS) {
                return this.Operator(); // TODO: replace with Delim
            }

            // TODO: produce a node with Delim node type

            if (code === NUMBERSIGN) {
                this.error('Hex or identifier is expected', this.scanner.tokenStart + 1);
            }

            break;
    }
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/scope/index.js":
/*!*********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/scope/index.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
    AtrulePrelude: __webpack_require__(/*! ./atrulePrelude */ "./node_modules/css-tree/lib/syntax/scope/atrulePrelude.js"),
    Selector: __webpack_require__(/*! ./selector */ "./node_modules/css-tree/lib/syntax/scope/selector.js"),
    Value: __webpack_require__(/*! ./value */ "./node_modules/css-tree/lib/syntax/scope/value.js")
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/scope/selector.js":
/*!************************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/scope/selector.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TYPE = (__webpack_require__(/*! ../../tokenizer */ "./node_modules/css-tree/lib/tokenizer/index.js").TYPE);

var DELIM = TYPE.Delim;
var IDENT = TYPE.Ident;
var DIMENSION = TYPE.Dimension;
var PERCENTAGE = TYPE.Percentage;
var NUMBER = TYPE.Number;
var HASH = TYPE.Hash;
var COLON = TYPE.Colon;
var LEFTSQUAREBRACKET = TYPE.LeftSquareBracket;
var NUMBERSIGN = 0x0023;      // U+0023 NUMBER SIGN (#)
var ASTERISK = 0x002A;        // U+002A ASTERISK (*)
var PLUSSIGN = 0x002B;        // U+002B PLUS SIGN (+)
var SOLIDUS = 0x002F;         // U+002F SOLIDUS (/)
var FULLSTOP = 0x002E;        // U+002E FULL STOP (.)
var GREATERTHANSIGN = 0x003E; // U+003E GREATER-THAN SIGN (>)
var VERTICALLINE = 0x007C;    // U+007C VERTICAL LINE (|)
var TILDE = 0x007E;           // U+007E TILDE (~)

function getNode(context) {
    switch (this.scanner.tokenType) {
        case LEFTSQUAREBRACKET:
            return this.AttributeSelector();

        case HASH:
            return this.IdSelector();

        case COLON:
            if (this.scanner.lookupType(1) === COLON) {
                return this.PseudoElementSelector();
            } else {
                return this.PseudoClassSelector();
            }

        case IDENT:
            return this.TypeSelector();

        case NUMBER:
        case PERCENTAGE:
            return this.Percentage();

        case DIMENSION:
            // throws when .123ident
            if (this.scanner.source.charCodeAt(this.scanner.tokenStart) === FULLSTOP) {
                this.error('Identifier is expected', this.scanner.tokenStart + 1);
            }
            break;

        case DELIM:
            var code = this.scanner.source.charCodeAt(this.scanner.tokenStart);

            switch (code) {
                case PLUSSIGN:
                case GREATERTHANSIGN:
                case TILDE:
                    context.space = null;
                    context.ignoreWSAfter = true;
                    return this.Combinator();

                case SOLIDUS:  // /deep/
                    return this.Combinator();

                case FULLSTOP:
                    return this.ClassSelector();

                case ASTERISK:
                case VERTICALLINE:
                    return this.TypeSelector();

                case NUMBERSIGN:
                    return this.IdSelector();
            }

            break;
    }
};

module.exports = {
    getNode: getNode
};


/***/ }),

/***/ "./node_modules/css-tree/lib/syntax/scope/value.js":
/*!*********************************************************!*\
  !*** ./node_modules/css-tree/lib/syntax/scope/value.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
    getNode: __webpack_require__(/*! ./default */ "./node_modules/css-tree/lib/syntax/scope/default.js"),
    'expression': __webpack_require__(/*! ../function/expression */ "./node_modules/css-tree/lib/syntax/function/expression.js"),
    'var': __webpack_require__(/*! ../function/var */ "./node_modules/css-tree/lib/syntax/function/var.js")
};


/***/ }),

/***/ "./node_modules/css-tree/lib/tokenizer/char-code-definitions.js":
/*!**********************************************************************!*\
  !*** ./node_modules/css-tree/lib/tokenizer/char-code-definitions.js ***!
  \**********************************************************************/
/***/ (function(module) {

var EOF = 0;

// https://drafts.csswg.org/css-syntax-3/
// § 4.2. Definitions

// digit
// A code point between U+0030 DIGIT ZERO (0) and U+0039 DIGIT NINE (9).
function isDigit(code) {
    return code >= 0x0030 && code <= 0x0039;
}

// hex digit
// A digit, or a code point between U+0041 LATIN CAPITAL LETTER A (A) and U+0046 LATIN CAPITAL LETTER F (F),
// or a code point between U+0061 LATIN SMALL LETTER A (a) and U+0066 LATIN SMALL LETTER F (f).
function isHexDigit(code) {
    return (
        isDigit(code) || // 0 .. 9
        (code >= 0x0041 && code <= 0x0046) || // A .. F
        (code >= 0x0061 && code <= 0x0066)    // a .. f
    );
}

// uppercase letter
// A code point between U+0041 LATIN CAPITAL LETTER A (A) and U+005A LATIN CAPITAL LETTER Z (Z).
function isUppercaseLetter(code) {
    return code >= 0x0041 && code <= 0x005A;
}

// lowercase letter
// A code point between U+0061 LATIN SMALL LETTER A (a) and U+007A LATIN SMALL LETTER Z (z).
function isLowercaseLetter(code) {
    return code >= 0x0061 && code <= 0x007A;
}

// letter
// An uppercase letter or a lowercase letter.
function isLetter(code) {
    return isUppercaseLetter(code) || isLowercaseLetter(code);
}

// non-ASCII code point
// A code point with a value equal to or greater than U+0080 <control>.
function isNonAscii(code) {
    return code >= 0x0080;
}

// name-start code point
// A letter, a non-ASCII code point, or U+005F LOW LINE (_).
function isNameStart(code) {
    return isLetter(code) || isNonAscii(code) || code === 0x005F;
}

// name code point
// A name-start code point, a digit, or U+002D HYPHEN-MINUS (-).
function isName(code) {
    return isNameStart(code) || isDigit(code) || code === 0x002D;
}

// non-printable code point
// A code point between U+0000 NULL and U+0008 BACKSPACE, or U+000B LINE TABULATION,
// or a code point between U+000E SHIFT OUT and U+001F INFORMATION SEPARATOR ONE, or U+007F DELETE.
function isNonPrintable(code) {
    return (
        (code >= 0x0000 && code <= 0x0008) ||
        (code === 0x000B) ||
        (code >= 0x000E && code <= 0x001F) ||
        (code === 0x007F)
    );
}

// newline
// U+000A LINE FEED. Note that U+000D CARRIAGE RETURN and U+000C FORM FEED are not included in this definition,
// as they are converted to U+000A LINE FEED during preprocessing.
// TODO: we doesn't do a preprocessing, so check a code point for U+000D CARRIAGE RETURN and U+000C FORM FEED
function isNewline(code) {
    return code === 0x000A || code === 0x000D || code === 0x000C;
}

// whitespace
// A newline, U+0009 CHARACTER TABULATION, or U+0020 SPACE.
function isWhiteSpace(code) {
    return isNewline(code) || code === 0x0020 || code === 0x0009;
}

// § 4.3.8. Check if two code points are a valid escape
function isValidEscape(first, second) {
    // If the first code point is not U+005C REVERSE SOLIDUS (\), return false.
    if (first !== 0x005C) {
        return false;
    }

    // Otherwise, if the second code point is a newline or EOF, return false.
    if (isNewline(second) || second === EOF) {
        return false;
    }

    // Otherwise, return true.
    return true;
}

// § 4.3.9. Check if three code points would start an identifier
function isIdentifierStart(first, second, third) {
    // Look at the first code point:

    // U+002D HYPHEN-MINUS
    if (first === 0x002D) {
        // If the second code point is a name-start code point or a U+002D HYPHEN-MINUS,
        // or the second and third code points are a valid escape, return true. Otherwise, return false.
        return (
            isNameStart(second) ||
            second === 0x002D ||
            isValidEscape(second, third)
        );
    }

    // name-start code point
    if (isNameStart(first)) {
        // Return true.
        return true;
    }

    // U+005C REVERSE SOLIDUS (\)
    if (first === 0x005C) {
        // If the first and second code points are a valid escape, return true. Otherwise, return false.
        return isValidEscape(first, second);
    }

    // anything else
    // Return false.
    return false;
}

// § 4.3.10. Check if three code points would start a number
function isNumberStart(first, second, third) {
    // Look at the first code point:

    // U+002B PLUS SIGN (+)
    // U+002D HYPHEN-MINUS (-)
    if (first === 0x002B || first === 0x002D) {
        // If the second code point is a digit, return true.
        if (isDigit(second)) {
            return 2;
        }

        // Otherwise, if the second code point is a U+002E FULL STOP (.)
        // and the third code point is a digit, return true.
        // Otherwise, return false.
        return second === 0x002E && isDigit(third) ? 3 : 0;
    }

    // U+002E FULL STOP (.)
    if (first === 0x002E) {
        // If the second code point is a digit, return true. Otherwise, return false.
        return isDigit(second) ? 2 : 0;
    }

    // digit
    if (isDigit(first)) {
        // Return true.
        return 1;
    }

    // anything else
    // Return false.
    return 0;
}

//
// Misc
//

// detect BOM (https://en.wikipedia.org/wiki/Byte_order_mark)
function isBOM(code) {
    // UTF-16BE
    if (code === 0xFEFF) {
        return 1;
    }

    // UTF-16LE
    if (code === 0xFFFE) {
        return 1;
    }

    return 0;
}

// Fast code category
//
// https://drafts.csswg.org/css-syntax/#tokenizer-definitions
// > non-ASCII code point
// >   A code point with a value equal to or greater than U+0080 <control>
// > name-start code point
// >   A letter, a non-ASCII code point, or U+005F LOW LINE (_).
// > name code point
// >   A name-start code point, a digit, or U+002D HYPHEN-MINUS (-)
// That means only ASCII code points has a special meaning and we define a maps for 0..127 codes only
var CATEGORY = new Array(0x80);
charCodeCategory.Eof = 0x80;
charCodeCategory.WhiteSpace = 0x82;
charCodeCategory.Digit = 0x83;
charCodeCategory.NameStart = 0x84;
charCodeCategory.NonPrintable = 0x85;

for (var i = 0; i < CATEGORY.length; i++) {
    switch (true) {
        case isWhiteSpace(i):
            CATEGORY[i] = charCodeCategory.WhiteSpace;
            break;

        case isDigit(i):
            CATEGORY[i] = charCodeCategory.Digit;
            break;

        case isNameStart(i):
            CATEGORY[i] = charCodeCategory.NameStart;
            break;

        case isNonPrintable(i):
            CATEGORY[i] = charCodeCategory.NonPrintable;
            break;

        default:
            CATEGORY[i] = i || charCodeCategory.Eof;
    }
}

function charCodeCategory(code) {
    return code < 0x80 ? CATEGORY[code] : charCodeCategory.NameStart;
};

module.exports = {
    isDigit: isDigit,
    isHexDigit: isHexDigit,
    isUppercaseLetter: isUppercaseLetter,
    isLowercaseLetter: isLowercaseLetter,
    isLetter: isLetter,
    isNonAscii: isNonAscii,
    isNameStart: isNameStart,
    isName: isName,
    isNonPrintable: isNonPrintable,
    isNewline: isNewline,
    isWhiteSpace: isWhiteSpace,
    isValidEscape: isValidEscape,
    isIdentifierStart: isIdentifierStart,
    isNumberStart: isNumberStart,

    isBOM: isBOM,
    charCodeCategory: charCodeCategory
};


/***/ }),

/***/ "./node_modules/css-tree/lib/tokenizer/const.js":
/*!******************************************************!*\
  !*** ./node_modules/css-tree/lib/tokenizer/const.js ***!
  \******************************************************/
/***/ (function(module) {

// CSS Syntax Module Level 3
// https://www.w3.org/TR/css-syntax-3/
var TYPE = {
    EOF: 0,                 // <EOF-token>
    Ident: 1,               // <ident-token>
    Function: 2,            // <function-token>
    AtKeyword: 3,           // <at-keyword-token>
    Hash: 4,                // <hash-token>
    String: 5,              // <string-token>
    BadString: 6,           // <bad-string-token>
    Url: 7,                 // <url-token>
    BadUrl: 8,              // <bad-url-token>
    Delim: 9,               // <delim-token>
    Number: 10,             // <number-token>
    Percentage: 11,         // <percentage-token>
    Dimension: 12,          // <dimension-token>
    WhiteSpace: 13,         // <whitespace-token>
    CDO: 14,                // <CDO-token>
    CDC: 15,                // <CDC-token>
    Colon: 16,              // <colon-token>     :
    Semicolon: 17,          // <semicolon-token> ;
    Comma: 18,              // <comma-token>     ,
    LeftSquareBracket: 19,  // <[-token>
    RightSquareBracket: 20, // <]-token>
    LeftParenthesis: 21,    // <(-token>
    RightParenthesis: 22,   // <)-token>
    LeftCurlyBracket: 23,   // <{-token>
    RightCurlyBracket: 24,  // <}-token>
    Comment: 25
};

var NAME = Object.keys(TYPE).reduce(function(result, key) {
    result[TYPE[key]] = key;
    return result;
}, {});

module.exports = {
    TYPE: TYPE,
    NAME: NAME
};


/***/ }),

/***/ "./node_modules/css-tree/lib/tokenizer/index.js":
/*!******************************************************!*\
  !*** ./node_modules/css-tree/lib/tokenizer/index.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TokenStream = __webpack_require__(/*! ../common/TokenStream */ "./node_modules/css-tree/lib/common/TokenStream.js");
var adoptBuffer = __webpack_require__(/*! ../common/adopt-buffer */ "./node_modules/css-tree/lib/common/adopt-buffer.js");

var constants = __webpack_require__(/*! ./const */ "./node_modules/css-tree/lib/tokenizer/const.js");
var TYPE = constants.TYPE;

var charCodeDefinitions = __webpack_require__(/*! ./char-code-definitions */ "./node_modules/css-tree/lib/tokenizer/char-code-definitions.js");
var isNewline = charCodeDefinitions.isNewline;
var isName = charCodeDefinitions.isName;
var isValidEscape = charCodeDefinitions.isValidEscape;
var isNumberStart = charCodeDefinitions.isNumberStart;
var isIdentifierStart = charCodeDefinitions.isIdentifierStart;
var charCodeCategory = charCodeDefinitions.charCodeCategory;
var isBOM = charCodeDefinitions.isBOM;

var utils = __webpack_require__(/*! ./utils */ "./node_modules/css-tree/lib/tokenizer/utils.js");
var cmpStr = utils.cmpStr;
var getNewlineLength = utils.getNewlineLength;
var findWhiteSpaceEnd = utils.findWhiteSpaceEnd;
var consumeEscaped = utils.consumeEscaped;
var consumeName = utils.consumeName;
var consumeNumber = utils.consumeNumber;
var consumeBadUrlRemnants = utils.consumeBadUrlRemnants;

var OFFSET_MASK = 0x00FFFFFF;
var TYPE_SHIFT = 24;

function tokenize(source, stream) {
    function getCharCode(offset) {
        return offset < sourceLength ? source.charCodeAt(offset) : 0;
    }

    // § 4.3.3. Consume a numeric token
    function consumeNumericToken() {
        // Consume a number and let number be the result.
        offset = consumeNumber(source, offset);

        // If the next 3 input code points would start an identifier, then:
        if (isIdentifierStart(getCharCode(offset), getCharCode(offset + 1), getCharCode(offset + 2))) {
            // Create a <dimension-token> with the same value and type flag as number, and a unit set initially to the empty string.
            // Consume a name. Set the <dimension-token>’s unit to the returned value.
            // Return the <dimension-token>.
            type = TYPE.Dimension;
            offset = consumeName(source, offset);
            return;
        }

        // Otherwise, if the next input code point is U+0025 PERCENTAGE SIGN (%), consume it.
        if (getCharCode(offset) === 0x0025) {
            // Create a <percentage-token> with the same value as number, and return it.
            type = TYPE.Percentage;
            offset++;
            return;
        }

        // Otherwise, create a <number-token> with the same value and type flag as number, and return it.
        type = TYPE.Number;
    }

    // § 4.3.4. Consume an ident-like token
    function consumeIdentLikeToken() {
        const nameStartOffset = offset;

        // Consume a name, and let string be the result.
        offset = consumeName(source, offset);

        // If string’s value is an ASCII case-insensitive match for "url",
        // and the next input code point is U+0028 LEFT PARENTHESIS ((), consume it.
        if (cmpStr(source, nameStartOffset, offset, 'url') && getCharCode(offset) === 0x0028) {
            // While the next two input code points are whitespace, consume the next input code point.
            offset = findWhiteSpaceEnd(source, offset + 1);

            // If the next one or two input code points are U+0022 QUOTATION MARK ("), U+0027 APOSTROPHE ('),
            // or whitespace followed by U+0022 QUOTATION MARK (") or U+0027 APOSTROPHE ('),
            // then create a <function-token> with its value set to string and return it.
            if (getCharCode(offset) === 0x0022 ||
                getCharCode(offset) === 0x0027) {
                type = TYPE.Function;
                offset = nameStartOffset + 4;
                return;
            }

            // Otherwise, consume a url token, and return it.
            consumeUrlToken();
            return;
        }

        // Otherwise, if the next input code point is U+0028 LEFT PARENTHESIS ((), consume it.
        // Create a <function-token> with its value set to string and return it.
        if (getCharCode(offset) === 0x0028) {
            type = TYPE.Function;
            offset++;
            return;
        }

        // Otherwise, create an <ident-token> with its value set to string and return it.
        type = TYPE.Ident;
    }

    // § 4.3.5. Consume a string token
    function consumeStringToken(endingCodePoint) {
        // This algorithm may be called with an ending code point, which denotes the code point
        // that ends the string. If an ending code point is not specified,
        // the current input code point is used.
        if (!endingCodePoint) {
            endingCodePoint = getCharCode(offset++);
        }

        // Initially create a <string-token> with its value set to the empty string.
        type = TYPE.String;

        // Repeatedly consume the next input code point from the stream:
        for (; offset < source.length; offset++) {
            var code = source.charCodeAt(offset);

            switch (charCodeCategory(code)) {
                // ending code point
                case endingCodePoint:
                    // Return the <string-token>.
                    offset++;
                    return;

                // EOF
                case charCodeCategory.Eof:
                    // This is a parse error. Return the <string-token>.
                    return;

                // newline
                case charCodeCategory.WhiteSpace:
                    if (isNewline(code)) {
                        // This is a parse error. Reconsume the current input code point,
                        // create a <bad-string-token>, and return it.
                        offset += getNewlineLength(source, offset, code);
                        type = TYPE.BadString;
                        return;
                    }
                    break;

                // U+005C REVERSE SOLIDUS (\)
                case 0x005C:
                    // If the next input code point is EOF, do nothing.
                    if (offset === source.length - 1) {
                        break;
                    }

                    var nextCode = getCharCode(offset + 1);

                    // Otherwise, if the next input code point is a newline, consume it.
                    if (isNewline(nextCode)) {
                        offset += getNewlineLength(source, offset + 1, nextCode);
                    } else if (isValidEscape(code, nextCode)) {
                        // Otherwise, (the stream starts with a valid escape) consume
                        // an escaped code point and append the returned code point to
                        // the <string-token>’s value.
                        offset = consumeEscaped(source, offset) - 1;
                    }
                    break;

                // anything else
                // Append the current input code point to the <string-token>’s value.
            }
        }
    }

    // § 4.3.6. Consume a url token
    // Note: This algorithm assumes that the initial "url(" has already been consumed.
    // This algorithm also assumes that it’s being called to consume an "unquoted" value, like url(foo).
    // A quoted value, like url("foo"), is parsed as a <function-token>. Consume an ident-like token
    // automatically handles this distinction; this algorithm shouldn’t be called directly otherwise.
    function consumeUrlToken() {
        // Initially create a <url-token> with its value set to the empty string.
        type = TYPE.Url;

        // Consume as much whitespace as possible.
        offset = findWhiteSpaceEnd(source, offset);

        // Repeatedly consume the next input code point from the stream:
        for (; offset < source.length; offset++) {
            var code = source.charCodeAt(offset);

            switch (charCodeCategory(code)) {
                // U+0029 RIGHT PARENTHESIS ())
                case 0x0029:
                    // Return the <url-token>.
                    offset++;
                    return;

                // EOF
                case charCodeCategory.Eof:
                    // This is a parse error. Return the <url-token>.
                    return;

                // whitespace
                case charCodeCategory.WhiteSpace:
                    // Consume as much whitespace as possible.
                    offset = findWhiteSpaceEnd(source, offset);

                    // If the next input code point is U+0029 RIGHT PARENTHESIS ()) or EOF,
                    // consume it and return the <url-token>
                    // (if EOF was encountered, this is a parse error);
                    if (getCharCode(offset) === 0x0029 || offset >= source.length) {
                        if (offset < source.length) {
                            offset++;
                        }
                        return;
                    }

                    // otherwise, consume the remnants of a bad url, create a <bad-url-token>,
                    // and return it.
                    offset = consumeBadUrlRemnants(source, offset);
                    type = TYPE.BadUrl;
                    return;

                // U+0022 QUOTATION MARK (")
                // U+0027 APOSTROPHE (')
                // U+0028 LEFT PARENTHESIS (()
                // non-printable code point
                case 0x0022:
                case 0x0027:
                case 0x0028:
                case charCodeCategory.NonPrintable:
                    // This is a parse error. Consume the remnants of a bad url,
                    // create a <bad-url-token>, and return it.
                    offset = consumeBadUrlRemnants(source, offset);
                    type = TYPE.BadUrl;
                    return;

                // U+005C REVERSE SOLIDUS (\)
                case 0x005C:
                    // If the stream starts with a valid escape, consume an escaped code point and
                    // append the returned code point to the <url-token>’s value.
                    if (isValidEscape(code, getCharCode(offset + 1))) {
                        offset = consumeEscaped(source, offset) - 1;
                        break;
                    }

                    // Otherwise, this is a parse error. Consume the remnants of a bad url,
                    // create a <bad-url-token>, and return it.
                    offset = consumeBadUrlRemnants(source, offset);
                    type = TYPE.BadUrl;
                    return;

                // anything else
                // Append the current input code point to the <url-token>’s value.
            }
        }
    }

    if (!stream) {
        stream = new TokenStream();
    }

    // ensure source is a string
    source = String(source || '');

    var sourceLength = source.length;
    var offsetAndType = adoptBuffer(stream.offsetAndType, sourceLength + 1); // +1 because of eof-token
    var balance = adoptBuffer(stream.balance, sourceLength + 1);
    var tokenCount = 0;
    var start = isBOM(getCharCode(0));
    var offset = start;
    var balanceCloseType = 0;
    var balanceStart = 0;
    var balancePrev = 0;

    // https://drafts.csswg.org/css-syntax-3/#consume-token
    // § 4.3.1. Consume a token
    while (offset < sourceLength) {
        var code = source.charCodeAt(offset);
        var type = 0;

        balance[tokenCount] = sourceLength;

        switch (charCodeCategory(code)) {
            // whitespace
            case charCodeCategory.WhiteSpace:
                // Consume as much whitespace as possible. Return a <whitespace-token>.
                type = TYPE.WhiteSpace;
                offset = findWhiteSpaceEnd(source, offset + 1);
                break;

            // U+0022 QUOTATION MARK (")
            case 0x0022:
                // Consume a string token and return it.
                consumeStringToken();
                break;

            // U+0023 NUMBER SIGN (#)
            case 0x0023:
                // If the next input code point is a name code point or the next two input code points are a valid escape, then:
                if (isName(getCharCode(offset + 1)) || isValidEscape(getCharCode(offset + 1), getCharCode(offset + 2))) {
                    // Create a <hash-token>.
                    type = TYPE.Hash;

                    // If the next 3 input code points would start an identifier, set the <hash-token>’s type flag to "id".
                    // if (isIdentifierStart(getCharCode(offset + 1), getCharCode(offset + 2), getCharCode(offset + 3))) {
                    //     // TODO: set id flag
                    // }

                    // Consume a name, and set the <hash-token>’s value to the returned string.
                    offset = consumeName(source, offset + 1);

                    // Return the <hash-token>.
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = TYPE.Delim;
                    offset++;
                }

                break;

            // U+0027 APOSTROPHE (')
            case 0x0027:
                // Consume a string token and return it.
                consumeStringToken();
                break;

            // U+0028 LEFT PARENTHESIS (()
            case 0x0028:
                // Return a <(-token>.
                type = TYPE.LeftParenthesis;
                offset++;
                break;

            // U+0029 RIGHT PARENTHESIS ())
            case 0x0029:
                // Return a <)-token>.
                type = TYPE.RightParenthesis;
                offset++;
                break;

            // U+002B PLUS SIGN (+)
            case 0x002B:
                // If the input stream starts with a number, ...
                if (isNumberStart(code, getCharCode(offset + 1), getCharCode(offset + 2))) {
                    // ... reconsume the current input code point, consume a numeric token, and return it.
                    consumeNumericToken();
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = TYPE.Delim;
                    offset++;
                }
                break;

            // U+002C COMMA (,)
            case 0x002C:
                // Return a <comma-token>.
                type = TYPE.Comma;
                offset++;
                break;

            // U+002D HYPHEN-MINUS (-)
            case 0x002D:
                // If the input stream starts with a number, reconsume the current input code point, consume a numeric token, and return it.
                if (isNumberStart(code, getCharCode(offset + 1), getCharCode(offset + 2))) {
                    consumeNumericToken();
                } else {
                    // Otherwise, if the next 2 input code points are U+002D HYPHEN-MINUS U+003E GREATER-THAN SIGN (->), consume them and return a <CDC-token>.
                    if (getCharCode(offset + 1) === 0x002D &&
                        getCharCode(offset + 2) === 0x003E) {
                        type = TYPE.CDC;
                        offset = offset + 3;
                    } else {
                        // Otherwise, if the input stream starts with an identifier, ...
                        if (isIdentifierStart(code, getCharCode(offset + 1), getCharCode(offset + 2))) {
                            // ... reconsume the current input code point, consume an ident-like token, and return it.
                            consumeIdentLikeToken();
                        } else {
                            // Otherwise, return a <delim-token> with its value set to the current input code point.
                            type = TYPE.Delim;
                            offset++;
                        }
                    }
                }
                break;

            // U+002E FULL STOP (.)
            case 0x002E:
                // If the input stream starts with a number, ...
                if (isNumberStart(code, getCharCode(offset + 1), getCharCode(offset + 2))) {
                    // ... reconsume the current input code point, consume a numeric token, and return it.
                    consumeNumericToken();
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = TYPE.Delim;
                    offset++;
                }

                break;

            // U+002F SOLIDUS (/)
            case 0x002F:
                // If the next two input code point are U+002F SOLIDUS (/) followed by a U+002A ASTERISK (*),
                if (getCharCode(offset + 1) === 0x002A) {
                    // ... consume them and all following code points up to and including the first U+002A ASTERISK (*)
                    // followed by a U+002F SOLIDUS (/), or up to an EOF code point.
                    type = TYPE.Comment;
                    offset = source.indexOf('*/', offset + 2) + 2;
                    if (offset === 1) {
                        offset = source.length;
                    }
                } else {
                    type = TYPE.Delim;
                    offset++;
                }
                break;

            // U+003A COLON (:)
            case 0x003A:
                // Return a <colon-token>.
                type = TYPE.Colon;
                offset++;
                break;

            // U+003B SEMICOLON (;)
            case 0x003B:
                // Return a <semicolon-token>.
                type = TYPE.Semicolon;
                offset++;
                break;

            // U+003C LESS-THAN SIGN (<)
            case 0x003C:
                // If the next 3 input code points are U+0021 EXCLAMATION MARK U+002D HYPHEN-MINUS U+002D HYPHEN-MINUS (!--), ...
                if (getCharCode(offset + 1) === 0x0021 &&
                    getCharCode(offset + 2) === 0x002D &&
                    getCharCode(offset + 3) === 0x002D) {
                    // ... consume them and return a <CDO-token>.
                    type = TYPE.CDO;
                    offset = offset + 4;
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = TYPE.Delim;
                    offset++;
                }

                break;

            // U+0040 COMMERCIAL AT (@)
            case 0x0040:
                // If the next 3 input code points would start an identifier, ...
                if (isIdentifierStart(getCharCode(offset + 1), getCharCode(offset + 2), getCharCode(offset + 3))) {
                    // ... consume a name, create an <at-keyword-token> with its value set to the returned value, and return it.
                    type = TYPE.AtKeyword;
                    offset = consumeName(source, offset + 1);
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = TYPE.Delim;
                    offset++;
                }

                break;

            // U+005B LEFT SQUARE BRACKET ([)
            case 0x005B:
                // Return a <[-token>.
                type = TYPE.LeftSquareBracket;
                offset++;
                break;

            // U+005C REVERSE SOLIDUS (\)
            case 0x005C:
                // If the input stream starts with a valid escape, ...
                if (isValidEscape(code, getCharCode(offset + 1))) {
                    // ... reconsume the current input code point, consume an ident-like token, and return it.
                    consumeIdentLikeToken();
                } else {
                    // Otherwise, this is a parse error. Return a <delim-token> with its value set to the current input code point.
                    type = TYPE.Delim;
                    offset++;
                }
                break;

            // U+005D RIGHT SQUARE BRACKET (])
            case 0x005D:
                // Return a <]-token>.
                type = TYPE.RightSquareBracket;
                offset++;
                break;

            // U+007B LEFT CURLY BRACKET ({)
            case 0x007B:
                // Return a <{-token>.
                type = TYPE.LeftCurlyBracket;
                offset++;
                break;

            // U+007D RIGHT CURLY BRACKET (})
            case 0x007D:
                // Return a <}-token>.
                type = TYPE.RightCurlyBracket;
                offset++;
                break;

            // digit
            case charCodeCategory.Digit:
                // Reconsume the current input code point, consume a numeric token, and return it.
                consumeNumericToken();
                break;

            // name-start code point
            case charCodeCategory.NameStart:
                // Reconsume the current input code point, consume an ident-like token, and return it.
                consumeIdentLikeToken();
                break;

            // EOF
            case charCodeCategory.Eof:
                // Return an <EOF-token>.
                break;

            // anything else
            default:
                // Return a <delim-token> with its value set to the current input code point.
                type = TYPE.Delim;
                offset++;
        }

        switch (type) {
            case balanceCloseType:
                balancePrev = balanceStart & OFFSET_MASK;
                balanceStart = balance[balancePrev];
                balanceCloseType = balanceStart >> TYPE_SHIFT;
                balance[tokenCount] = balancePrev;
                balance[balancePrev++] = tokenCount;
                for (; balancePrev < tokenCount; balancePrev++) {
                    if (balance[balancePrev] === sourceLength) {
                        balance[balancePrev] = tokenCount;
                    }
                }
                break;

            case TYPE.LeftParenthesis:
            case TYPE.Function:
                balance[tokenCount] = balanceStart;
                balanceCloseType = TYPE.RightParenthesis;
                balanceStart = (balanceCloseType << TYPE_SHIFT) | tokenCount;
                break;

            case TYPE.LeftSquareBracket:
                balance[tokenCount] = balanceStart;
                balanceCloseType = TYPE.RightSquareBracket;
                balanceStart = (balanceCloseType << TYPE_SHIFT) | tokenCount;
                break;

            case TYPE.LeftCurlyBracket:
                balance[tokenCount] = balanceStart;
                balanceCloseType = TYPE.RightCurlyBracket;
                balanceStart = (balanceCloseType << TYPE_SHIFT) | tokenCount;
                break;
        }

        offsetAndType[tokenCount++] = (type << TYPE_SHIFT) | offset;
    }

    // finalize buffers
    offsetAndType[tokenCount] = (TYPE.EOF << TYPE_SHIFT) | offset; // <EOF-token>
    balance[tokenCount] = sourceLength;
    balance[sourceLength] = sourceLength; // prevents false positive balance match with any token
    while (balanceStart !== 0) {
        balancePrev = balanceStart & OFFSET_MASK;
        balanceStart = balance[balancePrev];
        balance[balancePrev] = sourceLength;
    }

    // update stream
    stream.source = source;
    stream.firstCharOffset = start;
    stream.offsetAndType = offsetAndType;
    stream.tokenCount = tokenCount;
    stream.balance = balance;
    stream.reset();
    stream.next();

    return stream;
}

// extend tokenizer with constants
Object.keys(constants).forEach(function(key) {
    tokenize[key] = constants[key];
});

// extend tokenizer with static methods from utils
Object.keys(charCodeDefinitions).forEach(function(key) {
    tokenize[key] = charCodeDefinitions[key];
});
Object.keys(utils).forEach(function(key) {
    tokenize[key] = utils[key];
});

module.exports = tokenize;


/***/ }),

/***/ "./node_modules/css-tree/lib/tokenizer/utils.js":
/*!******************************************************!*\
  !*** ./node_modules/css-tree/lib/tokenizer/utils.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var charCodeDef = __webpack_require__(/*! ./char-code-definitions */ "./node_modules/css-tree/lib/tokenizer/char-code-definitions.js");
var isDigit = charCodeDef.isDigit;
var isHexDigit = charCodeDef.isHexDigit;
var isUppercaseLetter = charCodeDef.isUppercaseLetter;
var isName = charCodeDef.isName;
var isWhiteSpace = charCodeDef.isWhiteSpace;
var isValidEscape = charCodeDef.isValidEscape;

function getCharCode(source, offset) {
    return offset < source.length ? source.charCodeAt(offset) : 0;
}

function getNewlineLength(source, offset, code) {
    if (code === 13 /* \r */ && getCharCode(source, offset + 1) === 10 /* \n */) {
        return 2;
    }

    return 1;
}

function cmpChar(testStr, offset, referenceCode) {
    var code = testStr.charCodeAt(offset);

    // code.toLowerCase() for A..Z
    if (isUppercaseLetter(code)) {
        code = code | 32;
    }

    return code === referenceCode;
}

function cmpStr(testStr, start, end, referenceStr) {
    if (end - start !== referenceStr.length) {
        return false;
    }

    if (start < 0 || end > testStr.length) {
        return false;
    }

    for (var i = start; i < end; i++) {
        var testCode = testStr.charCodeAt(i);
        var referenceCode = referenceStr.charCodeAt(i - start);

        // testCode.toLowerCase() for A..Z
        if (isUppercaseLetter(testCode)) {
            testCode = testCode | 32;
        }

        if (testCode !== referenceCode) {
            return false;
        }
    }

    return true;
}

function findWhiteSpaceStart(source, offset) {
    for (; offset >= 0; offset--) {
        if (!isWhiteSpace(source.charCodeAt(offset))) {
            break;
        }
    }

    return offset + 1;
}

function findWhiteSpaceEnd(source, offset) {
    for (; offset < source.length; offset++) {
        if (!isWhiteSpace(source.charCodeAt(offset))) {
            break;
        }
    }

    return offset;
}

function findDecimalNumberEnd(source, offset) {
    for (; offset < source.length; offset++) {
        if (!isDigit(source.charCodeAt(offset))) {
            break;
        }
    }

    return offset;
}

// § 4.3.7. Consume an escaped code point
function consumeEscaped(source, offset) {
    // It assumes that the U+005C REVERSE SOLIDUS (\) has already been consumed and
    // that the next input code point has already been verified to be part of a valid escape.
    offset += 2;

    // hex digit
    if (isHexDigit(getCharCode(source, offset - 1))) {
        // Consume as many hex digits as possible, but no more than 5.
        // Note that this means 1-6 hex digits have been consumed in total.
        for (var maxOffset = Math.min(source.length, offset + 5); offset < maxOffset; offset++) {
            if (!isHexDigit(getCharCode(source, offset))) {
                break;
            }
        }

        // If the next input code point is whitespace, consume it as well.
        var code = getCharCode(source, offset);
        if (isWhiteSpace(code)) {
            offset += getNewlineLength(source, offset, code);
        }
    }

    return offset;
}

// §4.3.11. Consume a name
// Note: This algorithm does not do the verification of the first few code points that are necessary
// to ensure the returned code points would constitute an <ident-token>. If that is the intended use,
// ensure that the stream starts with an identifier before calling this algorithm.
function consumeName(source, offset) {
    // Let result initially be an empty string.
    // Repeatedly consume the next input code point from the stream:
    for (; offset < source.length; offset++) {
        var code = source.charCodeAt(offset);

        // name code point
        if (isName(code)) {
            // Append the code point to result.
            continue;
        }

        // the stream starts with a valid escape
        if (isValidEscape(code, getCharCode(source, offset + 1))) {
            // Consume an escaped code point. Append the returned code point to result.
            offset = consumeEscaped(source, offset) - 1;
            continue;
        }

        // anything else
        // Reconsume the current input code point. Return result.
        break;
    }

    return offset;
}

// §4.3.12. Consume a number
function consumeNumber(source, offset) {
    var code = source.charCodeAt(offset);

    // 2. If the next input code point is U+002B PLUS SIGN (+) or U+002D HYPHEN-MINUS (-),
    // consume it and append it to repr.
    if (code === 0x002B || code === 0x002D) {
        code = source.charCodeAt(offset += 1);
    }

    // 3. While the next input code point is a digit, consume it and append it to repr.
    if (isDigit(code)) {
        offset = findDecimalNumberEnd(source, offset + 1);
        code = source.charCodeAt(offset);
    }

    // 4. If the next 2 input code points are U+002E FULL STOP (.) followed by a digit, then:
    if (code === 0x002E && isDigit(source.charCodeAt(offset + 1))) {
        // 4.1 Consume them.
        // 4.2 Append them to repr.
        code = source.charCodeAt(offset += 2);

        // 4.3 Set type to "number".
        // TODO

        // 4.4 While the next input code point is a digit, consume it and append it to repr.

        offset = findDecimalNumberEnd(source, offset);
    }

    // 5. If the next 2 or 3 input code points are U+0045 LATIN CAPITAL LETTER E (E)
    // or U+0065 LATIN SMALL LETTER E (e), ... , followed by a digit, then:
    if (cmpChar(source, offset, 101 /* e */)) {
        var sign = 0;
        code = source.charCodeAt(offset + 1);

        // ... optionally followed by U+002D HYPHEN-MINUS (-) or U+002B PLUS SIGN (+) ...
        if (code === 0x002D || code === 0x002B) {
            sign = 1;
            code = source.charCodeAt(offset + 2);
        }

        // ... followed by a digit
        if (isDigit(code)) {
            // 5.1 Consume them.
            // 5.2 Append them to repr.

            // 5.3 Set type to "number".
            // TODO

            // 5.4 While the next input code point is a digit, consume it and append it to repr.
            offset = findDecimalNumberEnd(source, offset + 1 + sign + 1);
        }
    }

    return offset;
}

// § 4.3.14. Consume the remnants of a bad url
// ... its sole use is to consume enough of the input stream to reach a recovery point
// where normal tokenizing can resume.
function consumeBadUrlRemnants(source, offset) {
    // Repeatedly consume the next input code point from the stream:
    for (; offset < source.length; offset++) {
        var code = source.charCodeAt(offset);

        // U+0029 RIGHT PARENTHESIS ())
        // EOF
        if (code === 0x0029) {
            // Return.
            offset++;
            break;
        }

        if (isValidEscape(code, getCharCode(source, offset + 1))) {
            // Consume an escaped code point.
            // Note: This allows an escaped right parenthesis ("\)") to be encountered
            // without ending the <bad-url-token>. This is otherwise identical to
            // the "anything else" clause.
            offset = consumeEscaped(source, offset);
        }
    }

    return offset;
}

module.exports = {
    consumeEscaped: consumeEscaped,
    consumeName: consumeName,
    consumeNumber: consumeNumber,
    consumeBadUrlRemnants: consumeBadUrlRemnants,

    cmpChar: cmpChar,
    cmpStr: cmpStr,

    getNewlineLength: getNewlineLength,
    findWhiteSpaceStart: findWhiteSpaceStart,
    findWhiteSpaceEnd: findWhiteSpaceEnd
};


/***/ }),

/***/ "./node_modules/css-tree/lib/utils/clone.js":
/*!**************************************************!*\
  !*** ./node_modules/css-tree/lib/utils/clone.js ***!
  \**************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var List = __webpack_require__(/*! ../common/List */ "./node_modules/css-tree/lib/common/List.js");

module.exports = function clone(node) {
    var result = {};

    for (var key in node) {
        var value = node[key];

        if (value) {
            if (Array.isArray(value) || value instanceof List) {
                value = value.map(clone);
            } else if (value.constructor === Object) {
                value = clone(value);
            }
        }

        result[key] = value;
    }

    return result;
};


/***/ }),

/***/ "./node_modules/css-tree/lib/utils/createCustomError.js":
/*!**************************************************************!*\
  !*** ./node_modules/css-tree/lib/utils/createCustomError.js ***!
  \**************************************************************/
/***/ (function(module) {

module.exports = function createCustomError(name, message) {
    // use Object.create(), because some VMs prevent setting line/column otherwise
    // (iOS Safari 10 even throws an exception)
    var error = Object.create(SyntaxError.prototype);
    var errorStack = new Error();

    error.name = name;
    error.message = message;

    Object.defineProperty(error, 'stack', {
        get: function() {
            return (errorStack.stack || '').replace(/^(.+\n){1,3}/, name + ': ' + message + '\n');
        }
    });

    return error;
};


/***/ }),

/***/ "./node_modules/css-tree/lib/utils/names.js":
/*!**************************************************!*\
  !*** ./node_modules/css-tree/lib/utils/names.js ***!
  \**************************************************/
/***/ (function(module) {

var hasOwnProperty = Object.prototype.hasOwnProperty;
var keywords = Object.create(null);
var properties = Object.create(null);
var HYPHENMINUS = 45; // '-'.charCodeAt()

function isCustomProperty(str, offset) {
    offset = offset || 0;

    return str.length - offset >= 2 &&
           str.charCodeAt(offset) === HYPHENMINUS &&
           str.charCodeAt(offset + 1) === HYPHENMINUS;
}

function getVendorPrefix(str, offset) {
    offset = offset || 0;

    // verdor prefix should be at least 3 chars length
    if (str.length - offset >= 3) {
        // vendor prefix starts with hyper minus following non-hyper minus
        if (str.charCodeAt(offset) === HYPHENMINUS &&
            str.charCodeAt(offset + 1) !== HYPHENMINUS) {
            // vendor prefix should contain a hyper minus at the ending
            var secondDashIndex = str.indexOf('-', offset + 2);

            if (secondDashIndex !== -1) {
                return str.substring(offset, secondDashIndex + 1);
            }
        }
    }

    return '';
}

function getKeywordDescriptor(keyword) {
    if (hasOwnProperty.call(keywords, keyword)) {
        return keywords[keyword];
    }

    var name = keyword.toLowerCase();

    if (hasOwnProperty.call(keywords, name)) {
        return keywords[keyword] = keywords[name];
    }

    var custom = isCustomProperty(name, 0);
    var vendor = !custom ? getVendorPrefix(name, 0) : '';

    return keywords[keyword] = Object.freeze({
        basename: name.substr(vendor.length),
        name: name,
        vendor: vendor,
        prefix: vendor,
        custom: custom
    });
}

function getPropertyDescriptor(property) {
    if (hasOwnProperty.call(properties, property)) {
        return properties[property];
    }

    var name = property;
    var hack = property[0];

    if (hack === '/') {
        hack = property[1] === '/' ? '//' : '/';
    } else if (hack !== '_' &&
               hack !== '*' &&
               hack !== '$' &&
               hack !== '#' &&
               hack !== '+' &&
               hack !== '&') {
        hack = '';
    }

    var custom = isCustomProperty(name, hack.length);

    // re-use result when possible (the same as for lower case)
    if (!custom) {
        name = name.toLowerCase();
        if (hasOwnProperty.call(properties, name)) {
            return properties[property] = properties[name];
        }
    }

    var vendor = !custom ? getVendorPrefix(name, hack.length) : '';
    var prefix = name.substr(0, hack.length + vendor.length);

    return properties[property] = Object.freeze({
        basename: name.substr(prefix.length),
        name: name.substr(hack.length),
        hack: hack,
        vendor: vendor,
        prefix: prefix,
        custom: custom
    });
}

module.exports = {
    keyword: getKeywordDescriptor,
    property: getPropertyDescriptor,
    isCustomProperty: isCustomProperty,
    vendorPrefix: getVendorPrefix
};


/***/ }),

/***/ "./node_modules/css-tree/lib/walker/create.js":
/*!****************************************************!*\
  !*** ./node_modules/css-tree/lib/walker/create.js ***!
  \****************************************************/
/***/ (function(module) {

var hasOwnProperty = Object.prototype.hasOwnProperty;
var noop = function() {};

function ensureFunction(value) {
    return typeof value === 'function' ? value : noop;
}

function invokeForType(fn, type) {
    return function(node, item, list) {
        if (node.type === type) {
            fn.call(this, node, item, list);
        }
    };
}

function getWalkersFromStructure(name, nodeType) {
    var structure = nodeType.structure;
    var walkers = [];

    for (var key in structure) {
        if (hasOwnProperty.call(structure, key) === false) {
            continue;
        }

        var fieldTypes = structure[key];
        var walker = {
            name: key,
            type: false,
            nullable: false
        };

        if (!Array.isArray(structure[key])) {
            fieldTypes = [structure[key]];
        }

        for (var i = 0; i < fieldTypes.length; i++) {
            var fieldType = fieldTypes[i];
            if (fieldType === null) {
                walker.nullable = true;
            } else if (typeof fieldType === 'string') {
                walker.type = 'node';
            } else if (Array.isArray(fieldType)) {
                walker.type = 'list';
            }
        }

        if (walker.type) {
            walkers.push(walker);
        }
    }

    if (walkers.length) {
        return {
            context: nodeType.walkContext,
            fields: walkers
        };
    }

    return null;
}

function getTypesFromConfig(config) {
    var types = {};

    for (var name in config.node) {
        if (hasOwnProperty.call(config.node, name)) {
            var nodeType = config.node[name];

            if (!nodeType.structure) {
                throw new Error('Missed `structure` field in `' + name + '` node type definition');
            }

            types[name] = getWalkersFromStructure(name, nodeType);
        }
    }

    return types;
}

function createTypeIterator(config, reverse) {
    var fields = config.fields.slice();
    var contextName = config.context;
    var useContext = typeof contextName === 'string';

    if (reverse) {
        fields.reverse();
    }

    return function(node, context, walk, walkReducer) {
        var prevContextValue;

        if (useContext) {
            prevContextValue = context[contextName];
            context[contextName] = node;
        }

        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            var ref = node[field.name];

            if (!field.nullable || ref) {
                if (field.type === 'list') {
                    var breakWalk = reverse
                        ? ref.reduceRight(walkReducer, false)
                        : ref.reduce(walkReducer, false);

                    if (breakWalk) {
                        return true;
                    }
                } else if (walk(ref)) {
                    return true;
                }
            }
        }

        if (useContext) {
            context[contextName] = prevContextValue;
        }
    };
}

function createFastTraveralMap(iterators) {
    return {
        Atrule: {
            StyleSheet: iterators.StyleSheet,
            Atrule: iterators.Atrule,
            Rule: iterators.Rule,
            Block: iterators.Block
        },
        Rule: {
            StyleSheet: iterators.StyleSheet,
            Atrule: iterators.Atrule,
            Rule: iterators.Rule,
            Block: iterators.Block
        },
        Declaration: {
            StyleSheet: iterators.StyleSheet,
            Atrule: iterators.Atrule,
            Rule: iterators.Rule,
            Block: iterators.Block,
            DeclarationList: iterators.DeclarationList
        }
    };
}

module.exports = function createWalker(config) {
    var types = getTypesFromConfig(config);
    var iteratorsNatural = {};
    var iteratorsReverse = {};
    var breakWalk = Symbol('break-walk');
    var skipNode = Symbol('skip-node');

    for (var name in types) {
        if (hasOwnProperty.call(types, name) && types[name] !== null) {
            iteratorsNatural[name] = createTypeIterator(types[name], false);
            iteratorsReverse[name] = createTypeIterator(types[name], true);
        }
    }

    var fastTraversalIteratorsNatural = createFastTraveralMap(iteratorsNatural);
    var fastTraversalIteratorsReverse = createFastTraveralMap(iteratorsReverse);

    var walk = function(root, options) {
        function walkNode(node, item, list) {
            var enterRet = enter.call(context, node, item, list);

            if (enterRet === breakWalk) {
                debugger;
                return true;
            }

            if (enterRet === skipNode) {
                return false;
            }

            if (iterators.hasOwnProperty(node.type)) {
                if (iterators[node.type](node, context, walkNode, walkReducer)) {
                    return true;
                }
            }

            if (leave.call(context, node, item, list) === breakWalk) {
                return true;
            }

            return false;
        }

        var walkReducer = (ret, data, item, list) => ret || walkNode(data, item, list);
        var enter = noop;
        var leave = noop;
        var iterators = iteratorsNatural;
        var context = {
            break: breakWalk,
            skip: skipNode,

            root: root,
            stylesheet: null,
            atrule: null,
            atrulePrelude: null,
            rule: null,
            selector: null,
            block: null,
            declaration: null,
            function: null
        };

        if (typeof options === 'function') {
            enter = options;
        } else if (options) {
            enter = ensureFunction(options.enter);
            leave = ensureFunction(options.leave);

            if (options.reverse) {
                iterators = iteratorsReverse;
            }

            if (options.visit) {
                if (fastTraversalIteratorsNatural.hasOwnProperty(options.visit)) {
                    iterators = options.reverse
                        ? fastTraversalIteratorsReverse[options.visit]
                        : fastTraversalIteratorsNatural[options.visit];
                } else if (!types.hasOwnProperty(options.visit)) {
                    throw new Error('Bad value `' + options.visit + '` for `visit` option (should be: ' + Object.keys(types).join(', ') + ')');
                }

                enter = invokeForType(enter, options.visit);
                leave = invokeForType(leave, options.visit);
            }
        }

        if (enter === noop && leave === noop) {
            throw new Error('Neither `enter` nor `leave` walker handler is set or both aren\'t a function');
        }

        walkNode(root);
    };

    walk.break = breakWalk;
    walk.skip = skipNode;

    walk.find = function(ast, fn) {
        var found = null;

        walk(ast, function(node, item, list) {
            if (fn.call(this, node, item, list)) {
                found = node;
                return breakWalk;
            }
        });

        return found;
    };

    walk.findLast = function(ast, fn) {
        var found = null;

        walk(ast, {
            reverse: true,
            enter: function(node, item, list) {
                if (fn.call(this, node, item, list)) {
                    found = node;
                    return breakWalk;
                }
            }
        });

        return found;
    };

    walk.findAll = function(ast, fn) {
        var found = [];

        walk(ast, function(node, item, list) {
            if (fn.call(this, node, item, list)) {
                found.push(node);
            }
        });

        return found;
    };

    return walk;
};


/***/ }),

/***/ "./node_modules/dompurify/dist/purify.cjs.js":
/*!***************************************************!*\
  !*** ./node_modules/dompurify/dist/purify.cjs.js ***!
  \***************************************************/
/***/ (function(module) {

"use strict";
/*! @license DOMPurify 3.3.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.0/LICENSE */



const {
  entries,
  setPrototypeOf,
  isFrozen,
  getPrototypeOf,
  getOwnPropertyDescriptor
} = Object;
let {
  freeze,
  seal,
  create
} = Object; // eslint-disable-line import/no-mutable-exports
let {
  apply,
  construct
} = typeof Reflect !== 'undefined' && Reflect;
if (!freeze) {
  freeze = function freeze(x) {
    return x;
  };
}
if (!seal) {
  seal = function seal(x) {
    return x;
  };
}
if (!apply) {
  apply = function apply(func, thisArg) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    return func.apply(thisArg, args);
  };
}
if (!construct) {
  construct = function construct(Func) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return new Func(...args);
  };
}
const arrayForEach = unapply(Array.prototype.forEach);
const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
const arrayPop = unapply(Array.prototype.pop);
const arrayPush = unapply(Array.prototype.push);
const arraySplice = unapply(Array.prototype.splice);
const stringToLowerCase = unapply(String.prototype.toLowerCase);
const stringToString = unapply(String.prototype.toString);
const stringMatch = unapply(String.prototype.match);
const stringReplace = unapply(String.prototype.replace);
const stringIndexOf = unapply(String.prototype.indexOf);
const stringTrim = unapply(String.prototype.trim);
const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
const regExpTest = unapply(RegExp.prototype.test);
const typeErrorCreate = unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */
function unapply(func) {
  return function (thisArg) {
    if (thisArg instanceof RegExp) {
      thisArg.lastIndex = 0;
    }
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    return apply(func, thisArg, args);
  };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */
function unconstruct(Func) {
  return function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return construct(Func, args);
  };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */
function addToSet(set, array) {
  let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
  if (setPrototypeOf) {
    // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    setPrototypeOf(set, null);
  }
  let l = array.length;
  while (l--) {
    let element = array[l];
    if (typeof element === 'string') {
      const lcElement = transformCaseFunc(element);
      if (lcElement !== element) {
        // Config presets (e.g. tags.js, attrs.js) are immutable.
        if (!isFrozen(array)) {
          array[l] = lcElement;
        }
        element = lcElement;
      }
    }
    set[element] = true;
  }
  return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */
function cleanArray(array) {
  for (let index = 0; index < array.length; index++) {
    const isPropertyExist = objectHasOwnProperty(array, index);
    if (!isPropertyExist) {
      array[index] = null;
    }
  }
  return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */
function clone(object) {
  const newObject = create(null);
  for (const [property, value] of entries(object)) {
    const isPropertyExist = objectHasOwnProperty(object, property);
    if (isPropertyExist) {
      if (Array.isArray(value)) {
        newObject[property] = cleanArray(value);
      } else if (value && typeof value === 'object' && value.constructor === Object) {
        newObject[property] = clone(value);
      } else {
        newObject[property] = value;
      }
    }
  }
  return newObject;
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */
function lookupGetter(object, prop) {
  while (object !== null) {
    const desc = getOwnPropertyDescriptor(object, prop);
    if (desc) {
      if (desc.get) {
        return unapply(desc.get);
      }
      if (typeof desc.value === 'function') {
        return unapply(desc.value);
      }
    }
    object = getPrototypeOf(object);
  }
  function fallbackValue() {
    return null;
  }
  return fallbackValue;
}

const html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'search', 'section', 'select', 'shadow', 'slot', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);
const svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'enterkeyhint', 'exportparts', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'inputmode', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'part', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
const svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
const mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover', 'mprescripts']);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
const text = freeze(['#text']);

const html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'exportparts', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inert', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'part', 'pattern', 'placeholder', 'playsinline', 'popover', 'popovertarget', 'popovertargetaction', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'slot', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'wrap', 'xmlns', 'slot']);
const svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'amplitude', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'exponent', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'mask-type', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'slope', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'tablevalues', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
const mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
const xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

// eslint-disable-next-line unicorn/better-regex
const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const DOCTYPE_NAME = seal(/^html$/i);
const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);

var EXPRESSIONS = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ARIA_ATTR: ARIA_ATTR,
  ATTR_WHITESPACE: ATTR_WHITESPACE,
  CUSTOM_ELEMENT: CUSTOM_ELEMENT,
  DATA_ATTR: DATA_ATTR,
  DOCTYPE_NAME: DOCTYPE_NAME,
  ERB_EXPR: ERB_EXPR,
  IS_ALLOWED_URI: IS_ALLOWED_URI,
  IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
  MUSTACHE_EXPR: MUSTACHE_EXPR,
  TMPLIT_EXPR: TMPLIT_EXPR
});

/* eslint-disable @typescript-eslint/indent */
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const NODE_TYPE = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12 // Deprecated
};
const getGlobal = function getGlobal() {
  return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */
const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
  if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
    return null;
  }
  // Allow the callers to control the unique policy name
  // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
  // Policy creation with duplicate names throws in Trusted Types.
  let suffix = null;
  const ATTR_NAME = 'data-tt-policy-suffix';
  if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
    suffix = purifyHostElement.getAttribute(ATTR_NAME);
  }
  const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML(html) {
        return html;
      },
      createScriptURL(scriptUrl) {
        return scriptUrl;
      }
    });
  } catch (_) {
    // Policy creation failed (most likely another DOMPurify script has
    // already run). Skip creating the policy, as this will only cause errors
    // if TT are enforced.
    console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
    return null;
  }
};
const _createHooksMap = function _createHooksMap() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function createDOMPurify() {
  let window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
  const DOMPurify = root => createDOMPurify(root);
  DOMPurify.version = '3.3.0';
  DOMPurify.removed = [];
  if (!window || !window.document || window.document.nodeType !== NODE_TYPE.document || !window.Element) {
    // Not running in a browser, provide a factory function
    // so that you can pass your own Window
    DOMPurify.isSupported = false;
    return DOMPurify;
  }
  let {
    document
  } = window;
  const originalDocument = document;
  const currentScript = originalDocument.currentScript;
  const {
    DocumentFragment,
    HTMLTemplateElement,
    Node,
    Element,
    NodeFilter,
    NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap,
    HTMLFormElement,
    DOMParser,
    trustedTypes
  } = window;
  const ElementPrototype = Element.prototype;
  const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
  const remove = lookupGetter(ElementPrototype, 'remove');
  const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
  const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
  const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
  // As per issue #47, the web-components registry is inherited by a
  // new document created via createHTMLDocument. As per the spec
  // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
  // a new empty registry is used when creating a template contents owner
  // document, so we use that as our parent document to ensure nothing
  // is inherited.
  if (typeof HTMLTemplateElement === 'function') {
    const template = document.createElement('template');
    if (template.content && template.content.ownerDocument) {
      document = template.content.ownerDocument;
    }
  }
  let trustedTypesPolicy;
  let emptyHTML = '';
  const {
    implementation,
    createNodeIterator,
    createDocumentFragment,
    getElementsByTagName
  } = document;
  const {
    importNode
  } = originalDocument;
  let hooks = _createHooksMap();
  /**
   * Expose whether this browser supports running the full DOMPurify.
   */
  DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
  const {
    MUSTACHE_EXPR,
    ERB_EXPR,
    TMPLIT_EXPR,
    DATA_ATTR,
    ARIA_ATTR,
    IS_SCRIPT_OR_DATA,
    ATTR_WHITESPACE,
    CUSTOM_ELEMENT
  } = EXPRESSIONS;
  let {
    IS_ALLOWED_URI: IS_ALLOWED_URI$1
  } = EXPRESSIONS;
  /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */
  /* allowed element names */
  let ALLOWED_TAGS = null;
  const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...text]);
  /* Allowed attribute names */
  let ALLOWED_ATTR = null;
  const DEFAULT_ALLOWED_ATTR = addToSet({}, [...html, ...svg, ...mathMl, ...xml]);
  /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */
  let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
    tagNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: false
    }
  }));
  /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
  let FORBID_TAGS = null;
  /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
  let FORBID_ATTR = null;
  /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */
  const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
    tagCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    }
  }));
  /* Decide if ARIA attributes are okay */
  let ALLOW_ARIA_ATTR = true;
  /* Decide if custom data attributes are okay */
  let ALLOW_DATA_ATTR = true;
  /* Decide if unknown protocols are okay */
  let ALLOW_UNKNOWN_PROTOCOLS = false;
  /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */
  let ALLOW_SELF_CLOSE_IN_ATTR = true;
  /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */
  let SAFE_FOR_TEMPLATES = false;
  /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */
  let SAFE_FOR_XML = true;
  /* Decide if document with <html>... should be returned */
  let WHOLE_DOCUMENT = false;
  /* Track whether config is already set on this instance of DOMPurify. */
  let SET_CONFIG = false;
  /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */
  let FORCE_BODY = false;
  /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */
  let RETURN_DOM = false;
  /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */
  let RETURN_DOM_FRAGMENT = false;
  /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */
  let RETURN_TRUSTED_TYPE = false;
  /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */
  let SANITIZE_DOM = true;
  /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */
  let SANITIZE_NAMED_PROPS = false;
  const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
  /* Keep element content when removing element? */
  let KEEP_CONTENT = true;
  /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */
  let IN_PLACE = false;
  /* Allow usage of profiles like html, svg and mathMl */
  let USE_PROFILES = {};
  /* Tags to ignore content of when KEEP_CONTENT is true */
  let FORBID_CONTENTS = null;
  const DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
  /* Tags that are safe for data: URIs */
  let DATA_URI_TAGS = null;
  const DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
  /* Attributes safe for values like "javascript:" */
  let URI_SAFE_ATTRIBUTES = null;
  const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
  const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
  const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
  const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
  /* Document namespace */
  let NAMESPACE = HTML_NAMESPACE;
  let IS_EMPTY_INPUT = false;
  /* Allowed XHTML+XML namespaces */
  let ALLOWED_NAMESPACES = null;
  const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
  let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
  let HTML_INTEGRATION_POINTS = addToSet({}, ['annotation-xml']);
  // Certain elements are allowed in both SVG and HTML
  // namespace. We need to specify them explicitly
  // so that they don't get erroneously deleted from
  // HTML namespace.
  const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
  /* Parsing of strict XHTML documents */
  let PARSER_MEDIA_TYPE = null;
  const SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
  const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
  let transformCaseFunc = null;
  /* Keep a reference to config to pass to hooks */
  let CONFIG = null;
  /* Ideally, do not touch anything below this line */
  /* ______________________________________________ */
  const formElement = document.createElement('form');
  const isRegexOrFunction = function isRegexOrFunction(testValue) {
    return testValue instanceof RegExp || testValue instanceof Function;
  };
  /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */
  // eslint-disable-next-line complexity
  const _parseConfig = function _parseConfig() {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (CONFIG && CONFIG === cfg) {
      return;
    }
    /* Shield configuration object from tampering */
    if (!cfg || typeof cfg !== 'object') {
      cfg = {};
    }
    /* Shield configuration object from prototype pollution */
    cfg = clone(cfg);
    PARSER_MEDIA_TYPE =
    // eslint-disable-next-line unicorn/prefer-includes
    SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
    // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
    transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
    /* Set configuration parameters */
    ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
    ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
    URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
    DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
    FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
    FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
    FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
    USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
    ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
    SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
    RETURN_DOM = cfg.RETURN_DOM || false; // Default false
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
    FORCE_BODY = cfg.FORCE_BODY || false; // Default false
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
    SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
    IN_PLACE = cfg.IN_PLACE || false; // Default false
    IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
    NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
    MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
    HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
    CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
      CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
    }
    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }
    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }
    /* Parse profile info */
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, text);
      ALLOWED_ATTR = [];
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html$1);
        addToSet(ALLOWED_ATTR, html);
      }
      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg$1);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl$1);
        addToSet(ALLOWED_ATTR, mathMl);
        addToSet(ALLOWED_ATTR, xml);
      }
    }
    /* Merge configuration parameters */
    if (cfg.ADD_TAGS) {
      if (typeof cfg.ADD_TAGS === 'function') {
        EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
      } else {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }
        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }
    }
    if (cfg.ADD_ATTR) {
      if (typeof cfg.ADD_ATTR === 'function') {
        EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
      } else {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }
        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }
    }
    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
    }
    if (cfg.FORBID_CONTENTS) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = clone(FORBID_CONTENTS);
      }
      addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
    }
    /* Add #text in case KEEP_CONTENT is set to true */
    if (KEEP_CONTENT) {
      ALLOWED_TAGS['#text'] = true;
    }
    /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
    }
    /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ['tbody']);
      delete FORBID_TAGS.tbody;
    }
    if (cfg.TRUSTED_TYPES_POLICY) {
      if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      }
      if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      }
      // Overwrite existing TrustedTypes policy.
      trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
      // Sign local variables required by `sanitize`.
      emptyHTML = trustedTypesPolicy.createHTML('');
    } else {
      // Uninitialized policy, attempt to initialize the internal dompurify policy.
      if (trustedTypesPolicy === undefined) {
        trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
      }
      // If creating the internal policy succeeded sign internal variables.
      if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') {
        emptyHTML = trustedTypesPolicy.createHTML('');
      }
    }
    // Prevent further manipulation of configuration.
    // Not available in IE8, Safari 5, etc.
    if (freeze) {
      freeze(cfg);
    }
    CONFIG = cfg;
  };
  /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */
  const ALL_SVG_TAGS = addToSet({}, [...svg$1, ...svgFilters, ...svgDisallowed]);
  const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
  /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */
  const _checkValidNamespace = function _checkValidNamespace(element) {
    let parent = getParentNode(element);
    // In JSDOM, if we're inside shadow DOM, then parentNode
    // can be null. We just simulate parent in this case.
    if (!parent || !parent.tagName) {
      parent = {
        namespaceURI: NAMESPACE,
        tagName: 'template'
      };
    }
    const tagName = stringToLowerCase(element.tagName);
    const parentTagName = stringToLowerCase(parent.tagName);
    if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
      return false;
    }
    if (element.namespaceURI === SVG_NAMESPACE) {
      // The only way to switch from HTML namespace to SVG
      // is via <svg>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'svg';
      }
      // The only way to switch from MathML to SVG is via`
      // svg if parent is either <annotation-xml> or MathML
      // text integration points.
      if (parent.namespaceURI === MATHML_NAMESPACE) {
        return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
      }
      // We only allow elements that are defined in SVG
      // spec. All others are disallowed in SVG namespace.
      return Boolean(ALL_SVG_TAGS[tagName]);
    }
    if (element.namespaceURI === MATHML_NAMESPACE) {
      // The only way to switch from HTML namespace to MathML
      // is via <math>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'math';
      }
      // The only way to switch from SVG to MathML is via
      // <math> and HTML integration points
      if (parent.namespaceURI === SVG_NAMESPACE) {
        return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
      }
      // We only allow elements that are defined in MathML
      // spec. All others are disallowed in MathML namespace.
      return Boolean(ALL_MATHML_TAGS[tagName]);
    }
    if (element.namespaceURI === HTML_NAMESPACE) {
      // The only way to switch from SVG to HTML is via
      // HTML integration points, and from MathML to HTML
      // is via MathML text integration points
      if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      // We disallow tags that are specific for MathML
      // or SVG and should never appear in HTML namespace
      return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    }
    // For XHTML and XML documents that support custom namespaces
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
      return true;
    }
    // The code should never reach this place (this means
    // that the element somehow got namespace that is not
    // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
    // Return false just in case.
    return false;
  };
  /**
   * _forceRemove
   *
   * @param node a DOM node
   */
  const _forceRemove = function _forceRemove(node) {
    arrayPush(DOMPurify.removed, {
      element: node
    });
    try {
      // eslint-disable-next-line unicorn/prefer-dom-node-remove
      getParentNode(node).removeChild(node);
    } catch (_) {
      remove(node);
    }
  };
  /**
   * _removeAttribute
   *
   * @param name an Attribute name
   * @param element a DOM node
   */
  const _removeAttribute = function _removeAttribute(name, element) {
    try {
      arrayPush(DOMPurify.removed, {
        attribute: element.getAttributeNode(name),
        from: element
      });
    } catch (_) {
      arrayPush(DOMPurify.removed, {
        attribute: null,
        from: element
      });
    }
    element.removeAttribute(name);
    // We void attribute values for unremovable "is" attributes
    if (name === 'is') {
      if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
        try {
          _forceRemove(element);
        } catch (_) {}
      } else {
        try {
          element.setAttribute(name, '');
        } catch (_) {}
      }
    }
  };
  /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */
  const _initDocument = function _initDocument(dirty) {
    /* Create a HTML document */
    let doc = null;
    let leadingWhitespace = null;
    if (FORCE_BODY) {
      dirty = '<remove></remove>' + dirty;
    } else {
      /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
      const matches = stringMatch(dirty, /^[\r\n\t ]+/);
      leadingWhitespace = matches && matches[0];
    }
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
      // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
      dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
    }
    const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
    /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */
    if (NAMESPACE === HTML_NAMESPACE) {
      try {
        doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
      } catch (_) {}
    }
    /* Use createHTMLDocument in case DOMParser is not available */
    if (!doc || !doc.documentElement) {
      doc = implementation.createDocument(NAMESPACE, 'template', null);
      try {
        doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
      } catch (_) {
        // Syntax error if dirtyPayload is invalid xml
      }
    }
    const body = doc.body || doc.documentElement;
    if (dirty && leadingWhitespace) {
      body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
    }
    /* Work on whole document or just its body */
    if (NAMESPACE === HTML_NAMESPACE) {
      return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
    }
    return WHOLE_DOCUMENT ? doc.documentElement : body;
  };
  /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */
  const _createNodeIterator = function _createNodeIterator(root) {
    return createNodeIterator.call(root.ownerDocument || root, root,
    // eslint-disable-next-line no-bitwise
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
  };
  /**
   * _isClobbered
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */
  const _isClobbered = function _isClobbered(element) {
    return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
  };
  /**
   * Checks whether the given object is a DOM node.
   *
   * @param value object to check whether it's a DOM node
   * @return true is object is a DOM node
   */
  const _isNode = function _isNode(value) {
    return typeof Node === 'function' && value instanceof Node;
  };
  function _executeHooks(hooks, currentNode, data) {
    arrayForEach(hooks, hook => {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  }
  /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */
  const _sanitizeElements = function _sanitizeElements(currentNode) {
    let content = null;
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
    /* Check if element is clobbered or can clobber */
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Now let's check the element's type and name */
    const tagName = transformCaseFunc(currentNode.nodeName);
    /* Execute a hook if present */
    _executeHooks(hooks.uponSanitizeElement, currentNode, {
      tagName,
      allowedTags: ALLOWED_TAGS
    });
    /* Detect mXSS attempts abusing namespace confusion */
    if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove any occurrence of processing instructions */
    if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove any kind of possibly harmful comments */
    if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove element if anything forbids its presence */
    if (!(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName])) {
      /* Check if we have a custom element to handle */
      if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) {
          return false;
        }
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) {
          return false;
        }
      }
      /* Keep content except for bad-listed elements */
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
        const parentNode = getParentNode(currentNode) || currentNode.parentNode;
        const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
        if (childNodes && parentNode) {
          const childCount = childNodes.length;
          for (let i = childCount - 1; i >= 0; --i) {
            const childClone = cloneNode(childNodes[i], true);
            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
            parentNode.insertBefore(childClone, getNextSibling(currentNode));
          }
        }
      }
      _forceRemove(currentNode);
      return true;
    }
    /* Check whether element has a valid namespace */
    if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Make sure that older browsers don't get fallback-tag mXSS */
    if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Sanitize element content to be template-safe */
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
      /* Get the element's text content */
      content = currentNode.textContent;
      arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
        content = stringReplace(content, expr, ' ');
      });
      if (currentNode.textContent !== content) {
        arrayPush(DOMPurify.removed, {
          element: currentNode.cloneNode()
        });
        currentNode.textContent = content;
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeElements, currentNode, null);
    return false;
  };
  /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */
  // eslint-disable-next-line complexity
  const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
    /* Make sure attribute cannot clobber */
    if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
      return false;
    }
    /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */
    if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ; else if (EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
      if (
      // First condition does a very basic check if a) it's basically a valid custom element tagname AND
      // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
      _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) ||
      // Alternative, second condition checks if it's an `is`-attribute, AND
      // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
        return false;
      }
      /* Check value is safe. First, is attr inert? If so, is safe */
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if (value) {
      return false;
    } else ;
    return true;
  };
  /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */
  const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
    return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
  };
  /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */
  const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
    const {
      attributes
    } = currentNode;
    /* Check if we have attributes; if not we might have a text node */
    if (!attributes || _isClobbered(currentNode)) {
      return;
    }
    const hookEvent = {
      attrName: '',
      attrValue: '',
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR,
      forceKeepAttr: undefined
    };
    let l = attributes.length;
    /* Go backwards over all attributes; safely remove bad ones */
    while (l--) {
      const attr = attributes[l];
      const {
        name,
        namespaceURI,
        value: attrValue
      } = attr;
      const lcName = transformCaseFunc(name);
      const initValue = attrValue;
      let value = name === 'value' ? initValue : stringTrim(initValue);
      /* Execute a hook if present */
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
      _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
      value = hookEvent.attrValue;
      /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */
      if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
        // Remove the attribute with this value
        _removeAttribute(name, currentNode);
        // Prefix the value and later re-create the attribute with the sanitized value
        value = SANITIZE_NAMED_PROPS_PREFIX + value;
      }
      /* Work around a security issue with comments inside attributes */
      if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title|textarea)/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Make sure we cannot easily use animated hrefs, even if animations are allowed */
      if (lcName === 'attributename' && stringMatch(value, 'href')) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Did the hooks approve of the attribute? */
      if (hookEvent.forceKeepAttr) {
        continue;
      }
      /* Did the hooks approve of the attribute? */
      if (!hookEvent.keepAttr) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Work around a security issue in jQuery 3.0 */
      if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Sanitize attribute content to be template-safe */
      if (SAFE_FOR_TEMPLATES) {
        arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
          value = stringReplace(value, expr, ' ');
        });
      }
      /* Is `value` valid for this attribute? */
      const lcTag = transformCaseFunc(currentNode.nodeName);
      if (!_isValidAttribute(lcTag, lcName, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Handle attributes that require Trusted Types */
      if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
        if (namespaceURI) ; else {
          switch (trustedTypes.getAttributeType(lcTag, lcName)) {
            case 'TrustedHTML':
              {
                value = trustedTypesPolicy.createHTML(value);
                break;
              }
            case 'TrustedScriptURL':
              {
                value = trustedTypesPolicy.createScriptURL(value);
                break;
              }
          }
        }
      }
      /* Handle invalid data-* attribute set by try-catching it */
      if (value !== initValue) {
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }
          if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
          } else {
            arrayPop(DOMPurify.removed);
          }
        } catch (_) {
          _removeAttribute(name, currentNode);
        }
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
  };
  /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */
  const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
    let shadowNode = null;
    const shadowIterator = _createNodeIterator(fragment);
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
    while (shadowNode = shadowIterator.nextNode()) {
      /* Execute a hook if present */
      _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
      /* Sanitize tags and elements */
      _sanitizeElements(shadowNode);
      /* Check attributes next */
      _sanitizeAttributes(shadowNode);
      /* Deep shadow DOM detected */
      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(shadowNode.content);
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
  };
  // eslint-disable-next-line complexity
  DOMPurify.sanitize = function (dirty) {
    let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let body = null;
    let importedNode = null;
    let currentNode = null;
    let returnNode = null;
    /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */
    IS_EMPTY_INPUT = !dirty;
    if (IS_EMPTY_INPUT) {
      dirty = '<!-->';
    }
    /* Stringify, in case dirty is an object */
    if (typeof dirty !== 'string' && !_isNode(dirty)) {
      if (typeof dirty.toString === 'function') {
        dirty = dirty.toString();
        if (typeof dirty !== 'string') {
          throw typeErrorCreate('dirty is not a string, aborting');
        }
      } else {
        throw typeErrorCreate('toString is not a function');
      }
    }
    /* Return dirty HTML if DOMPurify cannot run */
    if (!DOMPurify.isSupported) {
      return dirty;
    }
    /* Assign config vars */
    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }
    /* Clean up removed elements */
    DOMPurify.removed = [];
    /* Check if dirty is correctly typed for IN_PLACE */
    if (typeof dirty === 'string') {
      IN_PLACE = false;
    }
    if (IN_PLACE) {
      /* Do some early pre-sanitization to avoid unsafe root nodes */
      if (dirty.nodeName) {
        const tagName = transformCaseFunc(dirty.nodeName);
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
        }
      }
    } else if (dirty instanceof Node) {
      /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */
      body = _initDocument('<!---->');
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') {
        /* Node is already a body, use as is */
        body = importedNode;
      } else if (importedNode.nodeName === 'HTML') {
        body = importedNode;
      } else {
        // eslint-disable-next-line unicorn/prefer-dom-node-append
        body.appendChild(importedNode);
      }
    } else {
      /* Exit directly if we have nothing to do */
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
      // eslint-disable-next-line unicorn/prefer-includes
      dirty.indexOf('<') === -1) {
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
      }
      /* Initialize the document to work on */
      body = _initDocument(dirty);
      /* Check we have a DOM node from the data */
      if (!body) {
        return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
      }
    }
    /* Remove first element node (ours) if FORCE_BODY is set */
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }
    /* Get node iterator */
    const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
    /* Now start iterating over the created document */
    while (currentNode = nodeIterator.nextNode()) {
      /* Sanitize tags and elements */
      _sanitizeElements(currentNode);
      /* Check attributes next */
      _sanitizeAttributes(currentNode);
      /* Shadow DOM detected, sanitize it */
      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(currentNode.content);
      }
    }
    /* If we sanitized `dirty` in-place, return it. */
    if (IN_PLACE) {
      return dirty;
    }
    /* Return sanitized string or DOM */
    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);
        while (body.firstChild) {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }
      if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
        /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */
        returnNode = importNode.call(originalDocument, returnNode, true);
      }
      return returnNode;
    }
    let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    /* Serialize doctype if allowed */
    if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
      serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
    }
    /* Sanitize final string template-safe */
    if (SAFE_FOR_TEMPLATES) {
      arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
        serializedHTML = stringReplace(serializedHTML, expr, ' ');
      });
    }
    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
  };
  DOMPurify.setConfig = function () {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _parseConfig(cfg);
    SET_CONFIG = true;
  };
  DOMPurify.clearConfig = function () {
    CONFIG = null;
    SET_CONFIG = false;
  };
  DOMPurify.isValidAttribute = function (tag, attr, value) {
    /* Initialize shared config vars if necessary. */
    if (!CONFIG) {
      _parseConfig({});
    }
    const lcTag = transformCaseFunc(tag);
    const lcName = transformCaseFunc(attr);
    return _isValidAttribute(lcTag, lcName, value);
  };
  DOMPurify.addHook = function (entryPoint, hookFunction) {
    if (typeof hookFunction !== 'function') {
      return;
    }
    arrayPush(hooks[entryPoint], hookFunction);
  };
  DOMPurify.removeHook = function (entryPoint, hookFunction) {
    if (hookFunction !== undefined) {
      const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
      return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
    }
    return arrayPop(hooks[entryPoint]);
  };
  DOMPurify.removeHooks = function (entryPoint) {
    hooks[entryPoint] = [];
  };
  DOMPurify.removeAllHooks = function () {
    hooks = _createHooksMap();
  };
  return DOMPurify;
}
var purify = createDOMPurify();

module.exports = purify;
//# sourceMappingURL=purify.cjs.js.map


/***/ }),

/***/ "./node_modules/events/events.js":
/*!***************************************!*\
  !*** ./node_modules/events/events.js ***!
  \***************************************/
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ "./node_modules/fastestsmallesttextencoderdecoder/EncoderDecoderTogether.min.js":
/*!**************************************************************************************!*\
  !*** ./node_modules/fastestsmallesttextencoderdecoder/EncoderDecoderTogether.min.js ***!
  \**************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";
(function(r){function x(){}function y(){}var z=String.fromCharCode,v={}.toString,A=v.call(r.SharedArrayBuffer),B=v(),q=r.Uint8Array,t=q||Array,w=q?ArrayBuffer:t,C=w.isView||function(g){return g&&"length"in g},D=v.call(w.prototype);w=y.prototype;var E=r.TextEncoder,a=new (q?Uint16Array:t)(32);x.prototype.decode=function(g){if(!C(g)){var l=v.call(g);if(l!==D&&l!==A&&l!==B)throw TypeError("Failed to execute 'decode' on 'TextDecoder': The provided value is not of type '(ArrayBuffer or ArrayBufferView)'");
g=q?new t(g):g||[]}for(var f=l="",b=0,c=g.length|0,u=c-32|0,e,d,h=0,p=0,m,k=0,n=-1;b<c;){for(e=b<=u?32:c-b|0;k<e;b=b+1|0,k=k+1|0){d=g[b]&255;switch(d>>4){case 15:m=g[b=b+1|0]&255;if(2!==m>>6||247<d){b=b-1|0;break}h=(d&7)<<6|m&63;p=5;d=256;case 14:m=g[b=b+1|0]&255,h<<=6,h|=(d&15)<<6|m&63,p=2===m>>6?p+4|0:24,d=d+256&768;case 13:case 12:m=g[b=b+1|0]&255,h<<=6,h|=(d&31)<<6|m&63,p=p+7|0,b<c&&2===m>>6&&h>>p&&1114112>h?(d=h,h=h-65536|0,0<=h&&(n=(h>>10)+55296|0,d=(h&1023)+56320|0,31>k?(a[k]=n,k=k+1|0,n=-1):
(m=n,n=d,d=m))):(d>>=8,b=b-d-1|0,d=65533),h=p=0,e=b<=u?32:c-b|0;default:a[k]=d;continue;case 11:case 10:case 9:case 8:}a[k]=65533}f+=z(a[0],a[1],a[2],a[3],a[4],a[5],a[6],a[7],a[8],a[9],a[10],a[11],a[12],a[13],a[14],a[15],a[16],a[17],a[18],a[19],a[20],a[21],a[22],a[23],a[24],a[25],a[26],a[27],a[28],a[29],a[30],a[31]);32>k&&(f=f.slice(0,k-32|0));if(b<c){if(a[0]=n,k=~n>>>31,n=-1,f.length<l.length)continue}else-1!==n&&(f+=z(n));l+=f;f=""}return l};w.encode=function(g){g=void 0===g?"":""+g;var l=g.length|
0,f=new t((l<<1)+8|0),b,c=0,u=!q;for(b=0;b<l;b=b+1|0,c=c+1|0){var e=g.charCodeAt(b)|0;if(127>=e)f[c]=e;else{if(2047>=e)f[c]=192|e>>6;else{a:{if(55296<=e)if(56319>=e){var d=g.charCodeAt(b=b+1|0)|0;if(56320<=d&&57343>=d){e=(e<<10)+d-56613888|0;if(65535<e){f[c]=240|e>>18;f[c=c+1|0]=128|e>>12&63;f[c=c+1|0]=128|e>>6&63;f[c=c+1|0]=128|e&63;continue}break a}e=65533}else 57343>=e&&(e=65533);!u&&b<<1<c&&b<<1<(c-7|0)&&(u=!0,d=new t(3*l),d.set(f),f=d)}f[c]=224|e>>12;f[c=c+1|0]=128|e>>6&63}f[c=c+1|0]=128|e&63}}return q?
f.subarray(0,c):f.slice(0,c)};E||(r.TextDecoder=x,r.TextEncoder=y)})(""+void 0==typeof __webpack_require__.g?""+void 0==typeof self?this:self:__webpack_require__.g);//AnonyCo
//# sourceMappingURL=https://cdn.jsdelivr.net/gh/AnonyCo/FastestSmallestTextEncoderDecoder/EncoderDecoderTogether.min.js.map


/***/ }),

/***/ "./node_modules/hull.js/src/convex.js":
/*!********************************************!*\
  !*** ./node_modules/hull.js/src/convex.js ***!
  \********************************************/
/***/ (function(module) {

function _cross(o, a, b) {
    return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]);
}

function _upperTangent(pointset) {
    var lower = [];
    for (var l = 0; l < pointset.length; l++) {
        while (lower.length >= 2 && (_cross(lower[lower.length - 2], lower[lower.length - 1], pointset[l]) <= 0)) {
            lower.pop();
        }
        lower.push(pointset[l]);
    }
    lower.pop();
    return lower;
}

function _lowerTangent(pointset) {
    var reversed = pointset.reverse(),
        upper = [];
    for (var u = 0; u < reversed.length; u++) {
        while (upper.length >= 2 && (_cross(upper[upper.length - 2], upper[upper.length - 1], reversed[u]) <= 0)) {
            upper.pop();
        }
        upper.push(reversed[u]);
    }
    upper.pop();
    return upper;
}

// pointset has to be sorted by X
function convex(pointset) {
    var convex,
        upper = _upperTangent(pointset),
        lower = _lowerTangent(pointset);
    convex = lower.concat(upper);
    convex.push(pointset[0]);  
    return convex;  
}

module.exports = convex;


/***/ }),

/***/ "./node_modules/hull.js/src/format.js":
/*!********************************************!*\
  !*** ./node_modules/hull.js/src/format.js ***!
  \********************************************/
/***/ (function(module) {

module.exports = {

    toXy: function(pointset, format) {
        if (format === undefined) {
            return pointset.slice();
        }
        return pointset.map(function(pt) {
            /*jslint evil: true */
            var _getXY = new Function('pt', 'return [pt' + format[0] + ',' + 'pt' + format[1] + '];');
            return _getXY(pt);
        });
    },

    fromXy: function(pointset, format) {
        if (format === undefined) {
            return pointset.slice();
        }
        return pointset.map(function(pt) {
            /*jslint evil: true */
            var _getObj = new Function('pt', 'var o = {}; o' + format[0] + '= pt[0]; o' + format[1] + '= pt[1]; return o;');
            return _getObj(pt);
        });
    }

}

/***/ }),

/***/ "./node_modules/hull.js/src/grid.js":
/*!******************************************!*\
  !*** ./node_modules/hull.js/src/grid.js ***!
  \******************************************/
/***/ (function(module) {

function Grid(points, cellSize) {
    this._cells = [];
    this._cellSize = cellSize;

    points.forEach(function(point) {
        var cellXY = this.point2CellXY(point),
            x = cellXY[0],
            y = cellXY[1];
        if (this._cells[x] === undefined) {
            this._cells[x] = [];
        }
        if (this._cells[x][y] === undefined) {
            this._cells[x][y] = [];
        }
        this._cells[x][y].push(point);
    }, this);
}

Grid.prototype = {
    cellPoints: function(x, y) { // (Number, Number) -> Array
        return (this._cells[x] !== undefined && this._cells[x][y] !== undefined) ? this._cells[x][y] : [];
    },

    rangePoints: function(bbox) { // (Array) -> Array
        var tlCellXY = this.point2CellXY([bbox[0], bbox[1]]),
            brCellXY = this.point2CellXY([bbox[2], bbox[3]]),
            points = [];

        for (var x = tlCellXY[0]; x <= brCellXY[0]; x++) {
            for (var y = tlCellXY[1]; y <= brCellXY[1]; y++) {
                points = points.concat(this.cellPoints(x, y));
            }
        }

        return points;
    },

    removePoint: function(point) { // (Array) -> Array
        var cellXY = this.point2CellXY(point),
            cell = this._cells[cellXY[0]][cellXY[1]],
            pointIdxInCell;
        
        for (var i = 0; i < cell.length; i++) {
            if (cell[i][0] === point[0] && cell[i][1] === point[1]) {
                pointIdxInCell = i;
                break;
            }
        }

        cell.splice(pointIdxInCell, 1);

        return cell;
    },

    point2CellXY: function(point) { // (Array) -> Array
        var x = parseInt(point[0] / this._cellSize),
            y = parseInt(point[1] / this._cellSize);
        return [x, y];
    },

    extendBbox: function(bbox, scaleFactor) { // (Array, Number) -> Array
        return [
            bbox[0] - (scaleFactor * this._cellSize),
            bbox[1] - (scaleFactor * this._cellSize),
            bbox[2] + (scaleFactor * this._cellSize),
            bbox[3] + (scaleFactor * this._cellSize)
        ];
    }
};

function grid(points, cellSize) {
    return new Grid(points, cellSize);
}

module.exports = grid;

/***/ }),

/***/ "./node_modules/hull.js/src/hull.js":
/*!******************************************!*\
  !*** ./node_modules/hull.js/src/hull.js ***!
  \******************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/*
 (c) 2014-2016, Andrii Heonia
 Hull.js, a JavaScript library for concave hull generation by set of points.
 https://github.com/AndriiHeonia/hull
*/



var intersect = __webpack_require__(/*! ./intersect.js */ "./node_modules/hull.js/src/intersect.js");
var grid = __webpack_require__(/*! ./grid.js */ "./node_modules/hull.js/src/grid.js");
var formatUtil = __webpack_require__(/*! ./format.js */ "./node_modules/hull.js/src/format.js");
var convexHull = __webpack_require__(/*! ./convex.js */ "./node_modules/hull.js/src/convex.js");

function _filterDuplicates(pointset) {
    return pointset.filter(function(el, idx, arr) {
        var prevEl = arr[idx - 1];
        return idx === 0 || !(prevEl[0] === el[0] && prevEl[1] === el[1]);
    });
}

function _sortByX(pointset) {
    return pointset.sort(function(a, b) {
        if (a[0] == b[0]) {
            return a[1] - b[1];
        } else {
            return a[0] - b[0];
        }
    });
}

function _sqLength(a, b) {
    return Math.pow(b[0] - a[0], 2) + Math.pow(b[1] - a[1], 2);
}

function _cos(o, a, b) {
    var aShifted = [a[0] - o[0], a[1] - o[1]],
        bShifted = [b[0] - o[0], b[1] - o[1]],
        sqALen = _sqLength(o, a),
        sqBLen = _sqLength(o, b),
        dot = aShifted[0] * bShifted[0] + aShifted[1] * bShifted[1];

    return dot / Math.sqrt(sqALen * sqBLen);
}

function _intersect(segment, pointset) {
    for (var i = 0; i < pointset.length - 1; i++) {
        var seg = [pointset[i], pointset[i + 1]];
        if (segment[0][0] === seg[0][0] && segment[0][1] === seg[0][1] ||
            segment[0][0] === seg[1][0] && segment[0][1] === seg[1][1]) {
            continue;
        }
        if (intersect(segment, seg)) {
            return true;
        }
    }
    return false;
}

function _occupiedArea(pointset) {
    var minX = Infinity,
        minY = Infinity,
        maxX = -Infinity,
        maxY = -Infinity;

    for (var i = pointset.length - 1; i >= 0; i--) {
        if (pointset[i][0] < minX) {
            minX = pointset[i][0];
        }
        if (pointset[i][1] < minY) {
            minY = pointset[i][1];
        }
        if (pointset[i][0] > maxX) {
            maxX = pointset[i][0];
        }
        if (pointset[i][1] > maxY) {
            maxY = pointset[i][1];
        }
    }

    return [
        maxX - minX, // width
        maxY - minY  // height
    ];
}

function _bBoxAround(edge) {
    return [
        Math.min(edge[0][0], edge[1][0]), // left
        Math.min(edge[0][1], edge[1][1]), // top
        Math.max(edge[0][0], edge[1][0]), // right
        Math.max(edge[0][1], edge[1][1])  // bottom
    ];
}

function _midPoint(edge, innerPoints, convex) {
    var point = null,
        angle1Cos = MAX_CONCAVE_ANGLE_COS,
        angle2Cos = MAX_CONCAVE_ANGLE_COS,
        a1Cos, a2Cos;

    for (var i = 0; i < innerPoints.length; i++) {
        a1Cos = _cos(edge[0], edge[1], innerPoints[i]);
        a2Cos = _cos(edge[1], edge[0], innerPoints[i]);

        if (a1Cos > angle1Cos && a2Cos > angle2Cos &&
            !_intersect([edge[0], innerPoints[i]], convex) &&
            !_intersect([edge[1], innerPoints[i]], convex)) {

            angle1Cos = a1Cos;
            angle2Cos = a2Cos;
            point = innerPoints[i];
        }
    }

    return point;
}

function _concave(convex, maxSqEdgeLen, maxSearchArea, grid, edgeSkipList) {
    var edge,
        keyInSkipList,
        scaleFactor,
        midPoint,
        bBoxAround,
        bBoxWidth,
        bBoxHeight,
        midPointInserted = false;

    for (var i = 0; i < convex.length - 1; i++) {
        edge = [convex[i], convex[i + 1]];
        keyInSkipList = edge[0].join() + ',' + edge[1].join();

        if (_sqLength(edge[0], edge[1]) < maxSqEdgeLen ||
            edgeSkipList[keyInSkipList] === true) { continue; }

        scaleFactor = 0;
        bBoxAround = _bBoxAround(edge);
        do {
            bBoxAround = grid.extendBbox(bBoxAround, scaleFactor);
            bBoxWidth = bBoxAround[2] - bBoxAround[0];
            bBoxHeight = bBoxAround[3] - bBoxAround[1];

            midPoint = _midPoint(edge, grid.rangePoints(bBoxAround), convex);            
            scaleFactor++;
        }  while (midPoint === null && (maxSearchArea[0] > bBoxWidth || maxSearchArea[1] > bBoxHeight));

        if (bBoxWidth >= maxSearchArea[0] && bBoxHeight >= maxSearchArea[1]) {
            edgeSkipList[keyInSkipList] = true;
        }

        if (midPoint !== null) {
            convex.splice(i + 1, 0, midPoint);
            grid.removePoint(midPoint);
            midPointInserted = true;
        }
    }

    if (midPointInserted) {
        return _concave(convex, maxSqEdgeLen, maxSearchArea, grid, edgeSkipList);
    }

    return convex;
}

function hull(pointset, concavity, format) {
    var convex,
        concave,
        innerPoints,
        occupiedArea,
        maxSearchArea,
        cellSize,
        points,
        maxEdgeLen = concavity || 20;

    if (pointset.length < 4) {
        return pointset.slice();
    }

    points = _filterDuplicates(_sortByX(formatUtil.toXy(pointset, format)));

    occupiedArea = _occupiedArea(points);
    maxSearchArea = [
        occupiedArea[0] * MAX_SEARCH_BBOX_SIZE_PERCENT,
        occupiedArea[1] * MAX_SEARCH_BBOX_SIZE_PERCENT
    ];

    convex = convexHull(points);
    innerPoints = points.filter(function(pt) {
        return convex.indexOf(pt) < 0;
    });

    cellSize = Math.ceil(1 / (points.length / (occupiedArea[0] * occupiedArea[1])));

    concave = _concave(
        convex, Math.pow(maxEdgeLen, 2),
        maxSearchArea, grid(innerPoints, cellSize), {});
 
    return formatUtil.fromXy(concave, format);
}

var MAX_CONCAVE_ANGLE_COS = Math.cos(90 / (180 / Math.PI)); // angle = 90 deg
var MAX_SEARCH_BBOX_SIZE_PERCENT = 0.6;

module.exports = hull;

/***/ }),

/***/ "./node_modules/hull.js/src/intersect.js":
/*!***********************************************!*\
  !*** ./node_modules/hull.js/src/intersect.js ***!
  \***********************************************/
/***/ (function(module) {

function ccw(x1, y1, x2, y2, x3, y3) {           
    var cw = ((y3 - y1) * (x2 - x1)) - ((y2 - y1) * (x3 - x1));
    return cw > 0 ? true : cw < 0 ? false : true; // colinear
}

function intersect(seg1, seg2) {
  var x1 = seg1[0][0], y1 = seg1[0][1],
      x2 = seg1[1][0], y2 = seg1[1][1],
      x3 = seg2[0][0], y3 = seg2[0][1],
      x4 = seg2[1][0], y4 = seg2[1][1];

    return ccw(x1, y1, x3, y3, x4, y4) !== ccw(x2, y2, x3, y3, x4, y4) && ccw(x1, y1, x2, y2, x3, y3) !== ccw(x1, y1, x2, y2, x4, y4);
}

module.exports = intersect;

/***/ }),

/***/ "./node_modules/ieee754/index.js":
/*!***************************************!*\
  !*** ./node_modules/ieee754/index.js ***!
  \***************************************/
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "./node_modules/ify-loader/index.js!./node_modules/grapheme-breaker/src/GraphemeBreaker.js":
/*!*************************************************************************************************!*\
  !*** ./node_modules/ify-loader/index.js!./node_modules/grapheme-breaker/src/GraphemeBreaker.js ***!
  \*************************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(/*! buffer */ "./node_modules/buffer/index.js")["Buffer"];
// Generated by CoffeeScript 1.8.0
(function() {
  var CR, Control, Extend, L, LF, LV, LVT, Regional_Indicator, SpacingMark, T, UnicodeTrie, V, classTrie, codePointAt, fs, shouldBreak, _ref;

  _ref = __webpack_require__(/*! ./classes.json */ "./node_modules/grapheme-breaker/src/classes.json"), CR = _ref.CR, LF = _ref.LF, Control = _ref.Control, Extend = _ref.Extend, Regional_Indicator = _ref.Regional_Indicator, SpacingMark = _ref.SpacingMark, L = _ref.L, V = _ref.V, T = _ref.T, LV = _ref.LV, LVT = _ref.LVT;

  UnicodeTrie = __webpack_require__(/*! unicode-trie */ "./node_modules/unicode-trie/index.js");

  

  classTrie = new UnicodeTrie(Buffer("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","base64"));

  codePointAt = function(str, idx) {
    var code, hi, low;
    idx = idx || 0;
    code = str.charCodeAt(idx);
    if ((0xD800 <= code && code <= 0xDBFF)) {
      hi = code;
      low = str.charCodeAt(idx + 1);
      if ((0xDC00 <= low && low <= 0xDFFF)) {
        return ((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000;
      }
      return hi;
    }
    if ((0xDC00 <= code && code <= 0xDFFF)) {
      hi = str.charCodeAt(idx - 1);
      low = code;
      if ((0xD800 <= hi && hi <= 0xDBFF)) {
        return ((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000;
      }
      return low;
    }
    return code;
  };

  shouldBreak = function(previous, current) {
    if (previous === CR && current === LF) {
      return false;
    } else if (previous === Control || previous === CR || previous === LF) {
      return true;
    } else if (current === Control || current === CR || current === LF) {
      return true;
    } else if (previous === L && (current === L || current === V || current === LV || current === LVT)) {
      return false;
    } else if ((previous === LV || previous === V) && (current === V || current === T)) {
      return false;
    } else if ((previous === LVT || previous === T) && current === T) {
      return false;
    } else if (previous === Regional_Indicator && current === Regional_Indicator) {
      return false;
    } else if (current === Extend) {
      return false;
    } else if (current === SpacingMark) {
      return false;
    }
    return true;
  };

  exports.nextBreak = function(string, index) {
    var i, next, prev, _i, _ref1, _ref2, _ref3, _ref4;
    if (index == null) {
      index = 0;
    }
    if (index < 0) {
      return 0;
    }
    if (index >= string.length - 1) {
      return string.length;
    }
    prev = classTrie.get(codePointAt(string, index));
    for (i = _i = _ref1 = index + 1, _ref2 = string.length; _i < _ref2; i = _i += 1) {
      if ((0xd800 <= (_ref3 = string.charCodeAt(i - 1)) && _ref3 <= 0xdbff) && (0xdc00 <= (_ref4 = string.charCodeAt(i)) && _ref4 <= 0xdfff)) {
        continue;
      }
      next = classTrie.get(codePointAt(string, i));
      if (shouldBreak(prev, next)) {
        return i;
      }
      prev = next;
    }
    return string.length;
  };

  exports.previousBreak = function(string, index) {
    var i, next, prev, _i, _ref1, _ref2, _ref3;
    if (index == null) {
      index = string.length;
    }
    if (index > string.length) {
      return string.length;
    }
    if (index <= 1) {
      return 0;
    }
    index--;
    next = classTrie.get(codePointAt(string, index));
    for (i = _i = _ref1 = index - 1; _i >= 0; i = _i += -1) {
      if ((0xd800 <= (_ref2 = string.charCodeAt(i)) && _ref2 <= 0xdbff) && (0xdc00 <= (_ref3 = string.charCodeAt(i + 1)) && _ref3 <= 0xdfff)) {
        continue;
      }
      prev = classTrie.get(codePointAt(string, i));
      if (shouldBreak(prev, next)) {
        return i + 1;
      }
      next = prev;
    }
    return 0;
  };

  exports["break"] = function(str) {
    var brk, index, res;
    res = [];
    index = 0;
    while ((brk = exports.nextBreak(str, index)) < str.length) {
      res.push(str.slice(index, brk));
      index = brk;
    }
    if (index < str.length) {
      res.push(str.slice(index));
    }
    return res;
  };

  exports.countBreaks = function(str) {
    var brk, count, index;
    count = 0;
    index = 0;
    while ((brk = exports.nextBreak(str, index)) < str.length) {
      index = brk;
      count++;
    }
    if (index < str.length) {
      count++;
    }
    return count;
  };

}).call(this);


/***/ }),

/***/ "./node_modules/ify-loader/index.js!./node_modules/linebreak/src/linebreaker.js":
/*!**************************************************************************************!*\
  !*** ./node_modules/ify-loader/index.js!./node_modules/linebreak/src/linebreaker.js ***!
  \**************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
  var AI, AL, BA, BK, CB, CI_BRK, CJ, CP_BRK, CR, DI_BRK, ID, IN_BRK, LF, LineBreaker, NL, NS, PR_BRK, SA, SG, SP, UnicodeTrie, WJ, XX, base64, characterClasses, classTrie, data, fs, pairTable, _ref, _ref1;

  UnicodeTrie = __webpack_require__(/*! unicode-trie */ "./node_modules/unicode-trie/index.js");

  

  base64 = __webpack_require__(/*! base64-js */ "./node_modules/base64-js/lib/b64.js");

  _ref = __webpack_require__(/*! ./classes */ "./node_modules/linebreak/src/classes.js"), BK = _ref.BK, CR = _ref.CR, LF = _ref.LF, NL = _ref.NL, CB = _ref.CB, BA = _ref.BA, SP = _ref.SP, WJ = _ref.WJ, SP = _ref.SP, BK = _ref.BK, LF = _ref.LF, NL = _ref.NL, AI = _ref.AI, AL = _ref.AL, SA = _ref.SA, SG = _ref.SG, XX = _ref.XX, CJ = _ref.CJ, ID = _ref.ID, NS = _ref.NS, characterClasses = _ref.characterClasses;

  _ref1 = __webpack_require__(/*! ./pairs */ "./node_modules/linebreak/src/pairs.js"), DI_BRK = _ref1.DI_BRK, IN_BRK = _ref1.IN_BRK, CI_BRK = _ref1.CI_BRK, CP_BRK = _ref1.CP_BRK, PR_BRK = _ref1.PR_BRK, pairTable = _ref1.pairTable;

  data = base64.toByteArray("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");

  classTrie = new UnicodeTrie(data);

  LineBreaker = (function() {
    var Break, mapClass, mapFirst;

    function LineBreaker(string) {
      this.string = string;
      this.pos = 0;
      this.lastPos = 0;
      this.curClass = null;
      this.nextClass = null;
    }

    LineBreaker.prototype.nextCodePoint = function() {
      var code, next;
      code = this.string.charCodeAt(this.pos++);
      next = this.string.charCodeAt(this.pos);
      if ((0xd800 <= code && code <= 0xdbff) && (0xdc00 <= next && next <= 0xdfff)) {
        this.pos++;
        return ((code - 0xd800) * 0x400) + (next - 0xdc00) + 0x10000;
      }
      return code;
    };

    mapClass = function(c) {
      switch (c) {
        case AI:
          return AL;
        case SA:
        case SG:
        case XX:
          return AL;
        case CJ:
          return NS;
        default:
          return c;
      }
    };

    mapFirst = function(c) {
      switch (c) {
        case LF:
        case NL:
          return BK;
        case CB:
          return BA;
        case SP:
          return WJ;
        default:
          return c;
      }
    };

    LineBreaker.prototype.nextCharClass = function(first) {
      if (first == null) {
        first = false;
      }
      return mapClass(classTrie.get(this.nextCodePoint()));
    };

    Break = (function() {
      function Break(position, required) {
        this.position = position;
        this.required = required != null ? required : false;
      }

      return Break;

    })();

    LineBreaker.prototype.nextBreak = function() {
      var cur, lastClass, shouldBreak;
      if (this.curClass == null) {
        this.curClass = mapFirst(this.nextCharClass());
      }
      while (this.pos < this.string.length) {
        this.lastPos = this.pos;
        lastClass = this.nextClass;
        this.nextClass = this.nextCharClass();
        if (this.curClass === BK || (this.curClass === CR && this.nextClass !== LF)) {
          this.curClass = mapFirst(mapClass(this.nextClass));
          return new Break(this.lastPos, true);
        }
        cur = (function() {
          switch (this.nextClass) {
            case SP:
              return this.curClass;
            case BK:
            case LF:
            case NL:
              return BK;
            case CR:
              return CR;
            case CB:
              return BA;
          }
        }).call(this);
        if (cur != null) {
          this.curClass = cur;
          if (this.nextClass === CB) {
            return new Break(this.lastPos);
          }
          continue;
        }
        shouldBreak = false;
        switch (pairTable[this.curClass][this.nextClass]) {
          case DI_BRK:
            shouldBreak = true;
            break;
          case IN_BRK:
            shouldBreak = lastClass === SP;
            break;
          case CI_BRK:
            shouldBreak = lastClass === SP;
            if (!shouldBreak) {
              continue;
            }
            break;
          case CP_BRK:
            if (lastClass !== SP) {
              continue;
            }
        }
        this.curClass = this.nextClass;
        if (shouldBreak) {
          return new Break(this.lastPos);
        }
      }
      if (this.pos >= this.string.length) {
        if (this.lastPos < this.string.length) {
          this.lastPos = this.string.length;
          return new Break(this.string.length);
        } else {
          return null;
        }
      }
    };

    return LineBreaker;

  })();

  module.exports = LineBreaker;

}).call(this);


/***/ }),

/***/ "./node_modules/isomorphic-dompurify/browser.js":
/*!******************************************************!*\
  !*** ./node_modules/isomorphic-dompurify/browser.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = window.DOMPurify || (window.DOMPurify = (__webpack_require__(/*! dompurify */ "./node_modules/dompurify/dist/purify.cjs.js")["default"]) || __webpack_require__(/*! dompurify */ "./node_modules/dompurify/dist/purify.cjs.js"));


/***/ }),

/***/ "./node_modules/linebreak/src/classes.js":
/*!***********************************************!*\
  !*** ./node_modules/linebreak/src/classes.js ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, exports) {

// Generated by CoffeeScript 1.7.1
(function() {
  var AI, AL, B2, BA, BB, BK, CB, CJ, CL, CM, CP, CR, EX, GL, H2, H3, HL, HY, ID, IN, IS, JL, JT, JV, LF, NL, NS, NU, OP, PO, PR, QU, RI, SA, SG, SP, SY, WJ, XX, ZW;

  exports.OP = OP = 0;

  exports.CL = CL = 1;

  exports.CP = CP = 2;

  exports.QU = QU = 3;

  exports.GL = GL = 4;

  exports.NS = NS = 5;

  exports.EX = EX = 6;

  exports.SY = SY = 7;

  exports.IS = IS = 8;

  exports.PR = PR = 9;

  exports.PO = PO = 10;

  exports.NU = NU = 11;

  exports.AL = AL = 12;

  exports.HL = HL = 13;

  exports.ID = ID = 14;

  exports.IN = IN = 15;

  exports.HY = HY = 16;

  exports.BA = BA = 17;

  exports.BB = BB = 18;

  exports.B2 = B2 = 19;

  exports.ZW = ZW = 20;

  exports.CM = CM = 21;

  exports.WJ = WJ = 22;

  exports.H2 = H2 = 23;

  exports.H3 = H3 = 24;

  exports.JL = JL = 25;

  exports.JV = JV = 26;

  exports.JT = JT = 27;

  exports.RI = RI = 28;

  exports.AI = AI = 29;

  exports.BK = BK = 30;

  exports.CB = CB = 31;

  exports.CJ = CJ = 32;

  exports.CR = CR = 33;

  exports.LF = LF = 34;

  exports.NL = NL = 35;

  exports.SA = SA = 36;

  exports.SG = SG = 37;

  exports.SP = SP = 38;

  exports.XX = XX = 39;

}).call(this);


/***/ }),

/***/ "./node_modules/linebreak/src/pairs.js":
/*!*********************************************!*\
  !*** ./node_modules/linebreak/src/pairs.js ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, exports) {

// Generated by CoffeeScript 1.7.1
(function() {
  var CI_BRK, CP_BRK, DI_BRK, IN_BRK, PR_BRK;

  exports.DI_BRK = DI_BRK = 0;

  exports.IN_BRK = IN_BRK = 1;

  exports.CI_BRK = CI_BRK = 2;

  exports.CP_BRK = CP_BRK = 3;

  exports.PR_BRK = PR_BRK = 4;

  exports.pairTable = [[PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, CP_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, DI_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, DI_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, PR_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK]];

}).call(this);


/***/ }),

/***/ "./node_modules/microee/index.js":
/*!***************************************!*\
  !*** ./node_modules/microee/index.js ***!
  \***************************************/
/***/ (function(module) {

function M() { this._events = {}; }
M.prototype = {
  on: function(ev, cb) {
    this._events || (this._events = {});
    var e = this._events;
    (e[ev] || (e[ev] = [])).push(cb);
    return this;
  },
  removeListener: function(ev, cb) {
    var e = this._events[ev] || [], i;
    for(i = e.length-1; i >= 0 && e[i]; i--){
      if(e[i] === cb || e[i].cb === cb) { e.splice(i, 1); }
    }
  },
  removeAllListeners: function(ev) {
    if(!ev) { this._events = {}; }
    else { this._events[ev] && (this._events[ev] = []); }
  },
  listeners: function(ev) {
    return (this._events ? this._events[ev] || [] : []);
  },
  emit: function(ev) {
    this._events || (this._events = {});
    var args = Array.prototype.slice.call(arguments, 1), i, e = this._events[ev] || [];
    for(i = e.length-1; i >= 0 && e[i]; i--){
      e[i].apply(this, args);
    }
    return this;
  },
  when: function(ev, cb) {
    return this.once(ev, cb, true);
  },
  once: function(ev, cb, when) {
    if(!cb) return this;
    function c() {
      if(!when) this.removeListener(ev, c);
      if(cb.apply(this, arguments) && when) this.removeListener(ev, c);
    }
    c.cb = cb;
    this.on(ev, c);
    return this;
  }
};
M.mixin = function(dest) {
  var o = M.prototype, k;
  for (k in o) {
    o.hasOwnProperty(k) && (dest.prototype[k] = o[k]);
  }
};
module.exports = M;


/***/ }),

/***/ "./node_modules/minilog/lib/common/filter.js":
/*!***************************************************!*\
  !*** ./node_modules/minilog/lib/common/filter.js ***!
  \***************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// default filter
var Transform = __webpack_require__(/*! ./transform.js */ "./node_modules/minilog/lib/common/transform.js");

var levelMap = { debug: 1, info: 2, warn: 3, error: 4 };

function Filter() {
  this.enabled = true;
  this.defaultResult = true;
  this.clear();
}

Transform.mixin(Filter);

// allow all matching, with level >= given level
Filter.prototype.allow = function(name, level) {
  this._white.push({ n: name, l: levelMap[level] });
  return this;
};

// deny all matching, with level <= given level
Filter.prototype.deny = function(name, level) {
  this._black.push({ n: name, l: levelMap[level] });
  return this;
};

Filter.prototype.clear = function() {
  this._white = [];
  this._black = [];
  return this;
};

function test(rule, name) {
  // use .test for RegExps
  return (rule.n.test ? rule.n.test(name) : rule.n == name);
};

Filter.prototype.test = function(name, level) {
  var i, len = Math.max(this._white.length, this._black.length);
  for(i = 0; i < len; i++) {
    if(this._white[i] && test(this._white[i], name) && levelMap[level] >= this._white[i].l) {
      return true;
    }
    if(this._black[i] && test(this._black[i], name) && levelMap[level] <= this._black[i].l) {
      return false;
    }
  }
  return this.defaultResult;
};

Filter.prototype.write = function(name, level, args) {
  if(!this.enabled || this.test(name, level)) {
    return this.emit('item', name, level, args);
  }
};

module.exports = Filter;


/***/ }),

/***/ "./node_modules/minilog/lib/common/minilog.js":
/*!****************************************************!*\
  !*** ./node_modules/minilog/lib/common/minilog.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Transform = __webpack_require__(/*! ./transform.js */ "./node_modules/minilog/lib/common/transform.js"),
    Filter = __webpack_require__(/*! ./filter.js */ "./node_modules/minilog/lib/common/filter.js");

var log = new Transform(),
    slice = Array.prototype.slice;

exports = module.exports = function create(name) {
  var o   = function() { log.write(name, undefined, slice.call(arguments)); return o; };
  o.debug = function() { log.write(name, 'debug', slice.call(arguments)); return o; };
  o.info  = function() { log.write(name, 'info',  slice.call(arguments)); return o; };
  o.warn  = function() { log.write(name, 'warn',  slice.call(arguments)); return o; };
  o.error = function() { log.write(name, 'error', slice.call(arguments)); return o; };
  o.log   = o.debug; // for interface compliance with Node and browser consoles
  o.suggest = exports.suggest;
  o.format = log.format;
  return o;
};

// filled in separately
exports.defaultBackend = exports.defaultFormatter = null;

exports.pipe = function(dest) {
  return log.pipe(dest);
};

exports.end = exports.unpipe = exports.disable = function(from) {
  return log.unpipe(from);
};

exports.Transform = Transform;
exports.Filter = Filter;
// this is the default filter that's applied when .enable() is called normally
// you can bypass it completely and set up your own pipes
exports.suggest = new Filter();

exports.enable = function() {
  if(exports.defaultFormatter) {
    return log.pipe(exports.suggest) // filter
              .pipe(exports.defaultFormatter) // formatter
              .pipe(exports.defaultBackend); // backend
  }
  return log.pipe(exports.suggest) // filter
            .pipe(exports.defaultBackend); // formatter
};



/***/ }),

/***/ "./node_modules/minilog/lib/common/transform.js":
/*!******************************************************!*\
  !*** ./node_modules/minilog/lib/common/transform.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var microee = __webpack_require__(/*! microee */ "./node_modules/microee/index.js");

// Implements a subset of Node's stream.Transform - in a cross-platform manner.
function Transform() {}

microee.mixin(Transform);

// The write() signature is different from Node's
// --> makes it much easier to work with objects in logs.
// One of the lessons from v1 was that it's better to target
// a good browser rather than the lowest common denominator
// internally.
// If you want to use external streams, pipe() to ./stringify.js first.
Transform.prototype.write = function(name, level, args) {
  this.emit('item', name, level, args);
};

Transform.prototype.end = function() {
  this.emit('end');
  this.removeAllListeners();
};

Transform.prototype.pipe = function(dest) {
  var s = this;
  // prevent double piping
  s.emit('unpipe', dest);
  // tell the dest that it's being piped to
  dest.emit('pipe', s);

  function onItem() {
    dest.write.apply(dest, Array.prototype.slice.call(arguments));
  }
  function onEnd() { !dest._isStdio && dest.end(); }

  s.on('item', onItem);
  s.on('end', onEnd);

  s.when('unpipe', function(from) {
    var match = (from === dest) || typeof from == 'undefined';
    if(match) {
      s.removeListener('item', onItem);
      s.removeListener('end', onEnd);
      dest.emit('unpipe');
    }
    return match;
  });

  return dest;
};

Transform.prototype.unpipe = function(from) {
  this.emit('unpipe', from);
  return this;
};

Transform.prototype.format = function(dest) {
  throw new Error([
    'Warning: .format() is deprecated in Minilog v2! Use .pipe() instead. For example:',
    'var Minilog = require(\'minilog\');',
    'Minilog',
    '  .pipe(Minilog.backends.console.formatClean)',
    '  .pipe(Minilog.backends.console);'].join('\n'));
};

Transform.mixin = function(dest) {
  var o = Transform.prototype, k;
  for (k in o) {
    o.hasOwnProperty(k) && (dest.prototype[k] = o[k]);
  }
};

module.exports = Transform;


/***/ }),

/***/ "./node_modules/minilog/lib/web/array.js":
/*!***********************************************!*\
  !*** ./node_modules/minilog/lib/web/array.js ***!
  \***********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Transform = __webpack_require__(/*! ../common/transform.js */ "./node_modules/minilog/lib/common/transform.js"),
    cache = [ ];

var logger = new Transform();

logger.write = function(name, level, args) {
  cache.push([ name, level, args ]);
};

// utility functions
logger.get = function() { return cache; };
logger.empty = function() { cache = []; };

module.exports = logger;


/***/ }),

/***/ "./node_modules/minilog/lib/web/console.js":
/*!*************************************************!*\
  !*** ./node_modules/minilog/lib/web/console.js ***!
  \*************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Transform = __webpack_require__(/*! ../common/transform.js */ "./node_modules/minilog/lib/common/transform.js");

var newlines = /\n+$/,
    logger = new Transform();

logger.write = function(name, level, args) {
  var i = args.length-1;
  if (typeof console === 'undefined' || !console.log) {
    return;
  }
  if(console.log.apply) {
    return console.log.apply(console, [name, level].concat(args));
  } else if(JSON && JSON.stringify) {
    // console.log.apply is undefined in IE8 and IE9
    // for IE8/9: make console.log at least a bit less awful
    if(args[i] && typeof args[i] == 'string') {
      args[i] = args[i].replace(newlines, '');
    }
    try {
      for(i = 0; i < args.length; i++) {
        args[i] = JSON.stringify(args[i]);
      }
    } catch(e) {}
    console.log(args.join(' '));
  }
};

logger.formatters = ['color', 'minilog'];
logger.color = __webpack_require__(/*! ./formatters/color.js */ "./node_modules/minilog/lib/web/formatters/color.js");
logger.minilog = __webpack_require__(/*! ./formatters/minilog.js */ "./node_modules/minilog/lib/web/formatters/minilog.js");

module.exports = logger;


/***/ }),

/***/ "./node_modules/minilog/lib/web/formatters/color.js":
/*!**********************************************************!*\
  !*** ./node_modules/minilog/lib/web/formatters/color.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Transform = __webpack_require__(/*! ../../common/transform.js */ "./node_modules/minilog/lib/common/transform.js"),
    color = __webpack_require__(/*! ./util.js */ "./node_modules/minilog/lib/web/formatters/util.js");

var colors = { debug: ['cyan'], info: ['purple' ], warn: [ 'yellow', true ], error: [ 'red', true ] },
    logger = new Transform();

logger.write = function(name, level, args) {
  var fn = console.log;
  if(console[level] && console[level].apply) {
    fn = console[level];
    fn.apply(console, [ '%c'+name+' %c'+level, color('gray'), color.apply(color, colors[level])].concat(args));
  }
};

// NOP, because piping the formatted logs can only cause trouble.
logger.pipe = function() { };

module.exports = logger;


/***/ }),

/***/ "./node_modules/minilog/lib/web/formatters/minilog.js":
/*!************************************************************!*\
  !*** ./node_modules/minilog/lib/web/formatters/minilog.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Transform = __webpack_require__(/*! ../../common/transform.js */ "./node_modules/minilog/lib/common/transform.js"),
    color = __webpack_require__(/*! ./util.js */ "./node_modules/minilog/lib/web/formatters/util.js"),
    colors = { debug: ['gray'], info: ['purple' ], warn: [ 'yellow', true ], error: [ 'red', true ] },
    logger = new Transform();

logger.write = function(name, level, args) {
  var fn = console.log;
  if(level != 'debug' && console[level]) {
    fn = console[level];
  }

  var subset = [], i = 0;
  if(level != 'info') {
    for(; i < args.length; i++) {
      if(typeof args[i] != 'string') break;
    }
    fn.apply(console, [ '%c'+name +' '+ args.slice(0, i).join(' '), color.apply(color, colors[level]) ].concat(args.slice(i)));
  } else {
    fn.apply(console, [ '%c'+name, color.apply(color, colors[level]) ].concat(args));
  }
};

// NOP, because piping the formatted logs can only cause trouble.
logger.pipe = function() { };

module.exports = logger;


/***/ }),

/***/ "./node_modules/minilog/lib/web/formatters/util.js":
/*!*********************************************************!*\
  !*** ./node_modules/minilog/lib/web/formatters/util.js ***!
  \*********************************************************/
/***/ (function(module) {

var hex = {
  black: '#000',
  red: '#c23621',
  green: '#25bc26',
  yellow: '#bbbb00',
  blue:  '#492ee1',
  magenta: '#d338d3',
  cyan: '#33bbc8',
  gray: '#808080',
  purple: '#708'
};
function color(fg, isInverse) {
  if(isInverse) {
    return 'color: #fff; background: '+hex[fg]+';';
  } else {
    return 'color: '+hex[fg]+';';
  }
}

module.exports = color;


/***/ }),

/***/ "./node_modules/minilog/lib/web/index.js":
/*!***********************************************!*\
  !*** ./node_modules/minilog/lib/web/index.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

var Minilog = __webpack_require__(/*! ../common/minilog.js */ "./node_modules/minilog/lib/common/minilog.js");

var oldEnable = Minilog.enable,
    oldDisable = Minilog.disable,
    isChrome = (typeof navigator != 'undefined' && /chrome/i.test(navigator.userAgent)),
    console = __webpack_require__(/*! ./console.js */ "./node_modules/minilog/lib/web/console.js");

// Use a more capable logging backend if on Chrome
Minilog.defaultBackend = (isChrome ? console.minilog : console);

// apply enable inputs from localStorage and from the URL
if(typeof window != 'undefined') {
  try {
    Minilog.enable(JSON.parse(window.localStorage['minilogSettings']));
  } catch(e) {}
  if(window.location && window.location.search) {
    var match = RegExp('[?&]minilog=([^&]*)').exec(window.location.search);
    match && Minilog.enable(decodeURIComponent(match[1]));
  }
}

// Make enable also add to localStorage
Minilog.enable = function() {
  oldEnable.call(Minilog, true);
  try { window.localStorage['minilogSettings'] = JSON.stringify(true); } catch(e) {}
  return this;
};

Minilog.disable = function() {
  oldDisable.call(Minilog);
  try { delete window.localStorage.minilogSettings; } catch(e) {}
  return this;
};

exports = module.exports = Minilog;

exports.backends = {
  array: __webpack_require__(/*! ./array.js */ "./node_modules/minilog/lib/web/array.js"),
  browser: Minilog.defaultBackend,
  localStorage: __webpack_require__(/*! ./localstorage.js */ "./node_modules/minilog/lib/web/localstorage.js"),
  jQuery: __webpack_require__(/*! ./jquery_simple.js */ "./node_modules/minilog/lib/web/jquery_simple.js")
};


/***/ }),

/***/ "./node_modules/minilog/lib/web/jquery_simple.js":
/*!*******************************************************!*\
  !*** ./node_modules/minilog/lib/web/jquery_simple.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Transform = __webpack_require__(/*! ../common/transform.js */ "./node_modules/minilog/lib/common/transform.js");

var cid = new Date().valueOf().toString(36);

function AjaxLogger(options) {
  this.url = options.url || '';
  this.cache = [];
  this.timer = null;
  this.interval = options.interval || 30*1000;
  this.enabled = true;
  this.jQuery = window.jQuery;
  this.extras = {};
}

Transform.mixin(AjaxLogger);

AjaxLogger.prototype.write = function(name, level, args) {
  if(!this.timer) { this.init(); }
  this.cache.push([name, level].concat(args));
};

AjaxLogger.prototype.init = function() {
  if(!this.enabled || !this.jQuery) return;
  var self = this;
  this.timer = setTimeout(function() {
    var i, logs = [], ajaxData, url = self.url;
    if(self.cache.length == 0) return self.init();
    // Test each log line and only log the ones that are valid (e.g. don't have circular references).
    // Slight performance hit but benefit is we log all valid lines.
    for(i = 0; i < self.cache.length; i++) {
      try {
        JSON.stringify(self.cache[i]);
        logs.push(self.cache[i]);
      } catch(e) { }
    }
    if(self.jQuery.isEmptyObject(self.extras)) {
        ajaxData = JSON.stringify({ logs: logs });
        url = self.url + '?client_id=' + cid;
    } else {
        ajaxData = JSON.stringify(self.jQuery.extend({logs: logs}, self.extras));
    }

    self.jQuery.ajax(url, {
      type: 'POST',
      cache: false,
      processData: false,
      data: ajaxData,
      contentType: 'application/json',
      timeout: 10000
    }).success(function(data, status, jqxhr) {
      if(data.interval) {
        self.interval = Math.max(1000, data.interval);
      }
    }).error(function() {
      self.interval = 30000;
    }).always(function() {
      self.init();
    });
    self.cache = [];
  }, this.interval);
};

AjaxLogger.prototype.end = function() {};

// wait until jQuery is defined. Useful if you don't control the load order.
AjaxLogger.jQueryWait = function(onDone) {
  if(typeof window !== 'undefined' && (window.jQuery || window.$)) {
    return onDone(window.jQuery || window.$);
  } else if (typeof window !== 'undefined') {
    setTimeout(function() { AjaxLogger.jQueryWait(onDone); }, 200);
  }
};

module.exports = AjaxLogger;


/***/ }),

/***/ "./node_modules/minilog/lib/web/localstorage.js":
/*!******************************************************!*\
  !*** ./node_modules/minilog/lib/web/localstorage.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Transform = __webpack_require__(/*! ../common/transform.js */ "./node_modules/minilog/lib/common/transform.js"),
    cache = false;

var logger = new Transform();

logger.write = function(name, level, args) {
  if(typeof window == 'undefined' || typeof JSON == 'undefined' || !JSON.stringify || !JSON.parse) return;
  try {
    if(!cache) { cache = (window.localStorage.minilog ? JSON.parse(window.localStorage.minilog) : []); }
    cache.push([ new Date().toString(), name, level, args ]);
    window.localStorage.minilog = JSON.stringify(cache);
  } catch(e) {}
};

module.exports = logger;

/***/ }),

/***/ "./node_modules/raw-loader/index.js!./src/shaders/sprite.frag":
/*!********************************************************************!*\
  !*** ./node_modules/raw-loader/index.js!./src/shaders/sprite.frag ***!
  \********************************************************************/
/***/ (function(module) {

module.exports = "precision mediump float;\n\n#ifdef DRAW_MODE_silhouette\nuniform vec4 u_silhouetteColor;\n#else // DRAW_MODE_silhouette\n# ifdef ENABLE_color\nuniform float u_color;\n# endif // ENABLE_color\n# ifdef ENABLE_brightness\nuniform float u_brightness;\n# endif // ENABLE_brightness\n#endif // DRAW_MODE_silhouette\n\n#ifdef DRAW_MODE_colorMask\nuniform vec3 u_colorMask;\nuniform float u_colorMaskTolerance;\n#endif // DRAW_MODE_colorMask\n\n#ifdef ENABLE_fisheye\nuniform float u_fisheye;\n#endif // ENABLE_fisheye\n#ifdef ENABLE_whirl\nuniform float u_whirl;\n#endif // ENABLE_whirl\n#ifdef ENABLE_pixelate\nuniform float u_pixelate;\nuniform vec2 u_skinSize;\n#endif // ENABLE_pixelate\n#ifdef ENABLE_mosaic\nuniform float u_mosaic;\n#endif // ENABLE_mosaic\n#ifdef ENABLE_ghost\nuniform float u_ghost;\n#endif // ENABLE_ghost\n\n#ifdef DRAW_MODE_line\nuniform vec4 u_lineColor;\nuniform float u_lineThickness;\nuniform float u_lineLength;\n#endif // DRAW_MODE_line\n\n#ifdef DRAW_MODE_background\nuniform vec4 u_backgroundColor;\n#endif // DRAW_MODE_background\n\nuniform sampler2D u_skin;\n\n#ifndef DRAW_MODE_background\nvarying vec2 v_texCoord;\n#endif\n\n// Add this to divisors to prevent division by 0, which results in NaNs propagating through calculations.\n// Smaller values can cause problems on some mobile devices.\nconst float epsilon = 1e-3;\n\n#if !defined(DRAW_MODE_silhouette) && (defined(ENABLE_color))\n// Branchless color conversions based on code from:\n// http://www.chilliant.com/rgb2hsv.html by Ian Taylor\n// Based in part on work by Sam Hocevar and Emil Persson\n// See also: https://en.wikipedia.org/wiki/HSL_and_HSV#Formal_derivation\n\n\n// Convert an RGB color to Hue, Saturation, and Value.\n// All components of input and output are expected to be in the [0,1] range.\nvec3 convertRGB2HSV(vec3 rgb)\n{\n\t// Hue calculation has 3 cases, depending on which RGB component is largest, and one of those cases involves a \"mod\"\n\t// operation. In order to avoid that \"mod\" we split the M==R case in two: one for G<B and one for B>G. The B>G case\n\t// will be calculated in the negative and fed through abs() in the hue calculation at the end.\n\t// See also: https://en.wikipedia.org/wiki/HSL_and_HSV#Hue_and_chroma\n\tconst vec4 hueOffsets = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);\n\n\t// temp1.xy = sort B & G (largest first)\n\t// temp1.z = the hue offset we'll use if it turns out that R is the largest component (M==R)\n\t// temp1.w = the hue offset we'll use if it turns out that R is not the largest component (M==G or M==B)\n\tvec4 temp1 = rgb.b > rgb.g ? vec4(rgb.bg, hueOffsets.wz) : vec4(rgb.gb, hueOffsets.xy);\n\n\t// temp2.x = the largest component of RGB (\"M\" / \"Max\")\n\t// temp2.yw = the smaller components of RGB, ordered for the hue calculation (not necessarily sorted by magnitude!)\n\t// temp2.z = the hue offset we'll use in the hue calculation\n\tvec4 temp2 = rgb.r > temp1.x ? vec4(rgb.r, temp1.yzx) : vec4(temp1.xyw, rgb.r);\n\n\t// m = the smallest component of RGB (\"min\")\n\tfloat m = min(temp2.y, temp2.w);\n\n\t// Chroma = M - m\n\tfloat C = temp2.x - m;\n\n\t// Value = M\n\tfloat V = temp2.x;\n\n\treturn vec3(\n\t\tabs(temp2.z + (temp2.w - temp2.y) / (6.0 * C + epsilon)), // Hue\n\t\tC / (temp2.x + epsilon), // Saturation\n\t\tV); // Value\n}\n\nvec3 convertHue2RGB(float hue)\n{\n\tfloat r = abs(hue * 6.0 - 3.0) - 1.0;\n\tfloat g = 2.0 - abs(hue * 6.0 - 2.0);\n\tfloat b = 2.0 - abs(hue * 6.0 - 4.0);\n\treturn clamp(vec3(r, g, b), 0.0, 1.0);\n}\n\nvec3 convertHSV2RGB(vec3 hsv)\n{\n\tvec3 rgb = convertHue2RGB(hsv.x);\n\tfloat c = hsv.z * hsv.y;\n\treturn rgb * c + hsv.z - c;\n}\n#endif // !defined(DRAW_MODE_silhouette) && (defined(ENABLE_color))\n\nconst vec2 kCenter = vec2(0.5, 0.5);\n\nvoid main()\n{\n\t#if !(defined(DRAW_MODE_line) || defined(DRAW_MODE_background))\n\tvec2 texcoord0 = v_texCoord;\n\n\t#ifdef ENABLE_mosaic\n\ttexcoord0 = fract(u_mosaic * texcoord0);\n\t#endif // ENABLE_mosaic\n\n\t#ifdef ENABLE_pixelate\n\t{\n\t\t// TODO: clean up \"pixel\" edges\n\t\tvec2 pixelTexelSize = u_skinSize / u_pixelate;\n\t\ttexcoord0 = (floor(texcoord0 * pixelTexelSize) + kCenter) / pixelTexelSize;\n\t}\n\t#endif // ENABLE_pixelate\n\n\t#ifdef ENABLE_whirl\n\t{\n\t\tconst float kRadius = 0.5;\n\t\tvec2 offset = texcoord0 - kCenter;\n\t\tfloat offsetMagnitude = length(offset);\n\t\tfloat whirlFactor = max(1.0 - (offsetMagnitude / kRadius), 0.0);\n\t\tfloat whirlActual = u_whirl * whirlFactor * whirlFactor;\n\t\tfloat sinWhirl = sin(whirlActual);\n\t\tfloat cosWhirl = cos(whirlActual);\n\t\tmat2 rotationMatrix = mat2(\n\t\t\tcosWhirl, -sinWhirl,\n\t\t\tsinWhirl, cosWhirl\n\t\t);\n\n\t\ttexcoord0 = rotationMatrix * offset + kCenter;\n\t}\n\t#endif // ENABLE_whirl\n\n\t#ifdef ENABLE_fisheye\n\t{\n\t\tvec2 vec = (texcoord0 - kCenter) / kCenter;\n\t\tfloat vecLength = length(vec);\n\t\tfloat r = pow(min(vecLength, 1.0), u_fisheye) * max(1.0, vecLength);\n\t\tvec2 unit = vec / vecLength;\n\n\t\ttexcoord0 = kCenter + r * unit * kCenter;\n\t}\n\t#endif // ENABLE_fisheye\n\n\tgl_FragColor = texture2D(u_skin, texcoord0);\n\n\t#if defined(ENABLE_color) || defined(ENABLE_brightness)\n\t// Divide premultiplied alpha values for proper color processing\n\t// Add epsilon to avoid dividing by 0 for fully transparent pixels\n\tgl_FragColor.rgb = clamp(gl_FragColor.rgb / (gl_FragColor.a + epsilon), 0.0, 1.0);\n\n\t#ifdef ENABLE_color\n\t{\n\t\tvec3 hsv = convertRGB2HSV(gl_FragColor.xyz);\n\n\t\t// this code forces grayscale values to be slightly saturated\n\t\t// so that some slight change of hue will be visible\n\t\tconst float minLightness = 0.11 / 2.0;\n\t\tconst float minSaturation = 0.09;\n\t\tif (hsv.z < minLightness) hsv = vec3(0.0, 1.0, minLightness);\n\t\telse if (hsv.y < minSaturation) hsv = vec3(0.0, minSaturation, hsv.z);\n\n\t\thsv.x = mod(hsv.x + u_color, 1.0);\n\t\tif (hsv.x < 0.0) hsv.x += 1.0;\n\n\t\tgl_FragColor.rgb = convertHSV2RGB(hsv);\n\t}\n\t#endif // ENABLE_color\n\n\t#ifdef ENABLE_brightness\n\tgl_FragColor.rgb = clamp(gl_FragColor.rgb + vec3(u_brightness), vec3(0), vec3(1));\n\t#endif // ENABLE_brightness\n\n\t// Re-multiply color values\n\tgl_FragColor.rgb *= gl_FragColor.a + epsilon;\n\n\t#endif // defined(ENABLE_color) || defined(ENABLE_brightness)\n\n\t#ifdef ENABLE_ghost\n\tgl_FragColor *= u_ghost;\n\t#endif // ENABLE_ghost\n\n\t#ifdef DRAW_MODE_silhouette\n\t// Discard fully transparent pixels for stencil test\n\tif (gl_FragColor.a == 0.0) {\n\t\tdiscard;\n\t}\n\t// switch to u_silhouetteColor only AFTER the alpha test\n\tgl_FragColor = u_silhouetteColor;\n\t#else // DRAW_MODE_silhouette\n\n\t#ifdef DRAW_MODE_colorMask\n\tvec3 maskDistance = abs(gl_FragColor.rgb - u_colorMask);\n\tvec3 colorMaskTolerance = vec3(u_colorMaskTolerance, u_colorMaskTolerance, u_colorMaskTolerance);\n\tif (any(greaterThan(maskDistance, colorMaskTolerance)))\n\t{\n\t\tdiscard;\n\t}\n\t#endif // DRAW_MODE_colorMask\n\t#endif // DRAW_MODE_silhouette\n\n\t#ifdef DRAW_MODE_straightAlpha\n\t// Un-premultiply alpha.\n\tgl_FragColor.rgb /= gl_FragColor.a + epsilon;\n\t#endif\n\n\t#endif // !(defined(DRAW_MODE_line) || defined(DRAW_MODE_background))\n\n\t#ifdef DRAW_MODE_line\n\t// Maaaaagic antialiased-line-with-round-caps shader.\n\n\t// \"along-the-lineness\". This increases parallel to the line.\n\t// It goes from negative before the start point, to 0.5 through the start to the end, then ramps up again\n\t// past the end point.\n\tfloat d = ((v_texCoord.x - clamp(v_texCoord.x, 0.0, u_lineLength)) * 0.5) + 0.5;\n\n\t// Distance from (0.5, 0.5) to (d, the perpendicular coordinate). When we're in the middle of the line,\n\t// d will be 0.5, so the distance will be 0 at points close to the line and will grow at points further from it.\n\t// For the \"caps\", d will ramp down/up, giving us rounding.\n\t// See https://www.youtube.com/watch?v=PMltMdi1Wzg for a rough outline of the technique used to round the lines.\n\tfloat line = distance(vec2(0.5), vec2(d, v_texCoord.y)) * 2.0;\n\t// Expand out the line by its thickness.\n\tline -= ((u_lineThickness - 1.0) * 0.5);\n\t// Because \"distance to the center of the line\" decreases the closer we get to the line, but we want more opacity\n\t// the closer we are to the line, invert it.\n\tgl_FragColor = u_lineColor * clamp(1.0 - line, 0.0, 1.0);\n\t#endif // DRAW_MODE_line\n\n\t#ifdef DRAW_MODE_background\n\tgl_FragColor = u_backgroundColor;\n\t#endif\n}\n"

/***/ }),

/***/ "./node_modules/raw-loader/index.js!./src/shaders/sprite.vert":
/*!********************************************************************!*\
  !*** ./node_modules/raw-loader/index.js!./src/shaders/sprite.vert ***!
  \********************************************************************/
/***/ (function(module) {

module.exports = "precision mediump float;\n\n#ifdef DRAW_MODE_line\nuniform vec2 u_stageSize;\nuniform float u_lineThickness;\nuniform float u_lineLength;\n// The X and Y components of u_penPoints hold the first pen point. The Z and W components hold the difference between\n// the second pen point and the first. This is done because calculating the difference in the shader leads to floating-\n// point error when both points have large-ish coordinates.\nuniform vec4 u_penPoints;\n\n// Add this to divisors to prevent division by 0, which results in NaNs propagating through calculations.\n// Smaller values can cause problems on some mobile devices.\nconst float epsilon = 1e-3;\n#endif\n\n#if !(defined(DRAW_MODE_line) || defined(DRAW_MODE_background))\nuniform mat4 u_projectionMatrix;\nuniform mat4 u_modelMatrix;\nattribute vec2 a_texCoord;\n#endif\n\nattribute vec2 a_position;\n\nvarying vec2 v_texCoord;\n\nvoid main() {\n\t#ifdef DRAW_MODE_line\n\t// Calculate a rotated (\"tight\") bounding box around the two pen points.\n\t// Yes, we're doing this 6 times (once per vertex), but on actual GPU hardware,\n\t// it's still faster than doing it in JS combined with the cost of uniformMatrix4fv.\n\n\t// Expand line bounds by sqrt(2) / 2 each side-- this ensures that all antialiased pixels\n\t// fall within the quad, even at a 45-degree diagonal\n\tvec2 position = a_position;\n\tfloat expandedRadius = (u_lineThickness * 0.5) + 1.4142135623730951;\n\n\t// The X coordinate increases along the length of the line. It's 0 at the center of the origin point\n\t// and is in pixel-space (so at n pixels along the line, its value is n).\n\tv_texCoord.x = mix(0.0, u_lineLength + (expandedRadius * 2.0), a_position.x) - expandedRadius;\n\t// The Y coordinate is perpendicular to the line. It's also in pixel-space.\n\tv_texCoord.y = ((a_position.y - 0.5) * expandedRadius) + 0.5;\n\n\tposition.x *= u_lineLength + (2.0 * expandedRadius);\n\tposition.y *= 2.0 * expandedRadius;\n\n\t// 1. Center around first pen point\n\tposition -= expandedRadius;\n\n\t// 2. Rotate quad to line angle\n\tvec2 pointDiff = u_penPoints.zw;\n\t// Ensure line has a nonzero length so it's rendered properly\n\t// As long as either component is nonzero, the line length will be nonzero\n\t// If the line is zero-length, give it a bit of horizontal length\n\tpointDiff.x = (abs(pointDiff.x) < epsilon && abs(pointDiff.y) < epsilon) ? epsilon : pointDiff.x;\n\t// The `normalized` vector holds rotational values equivalent to sine/cosine\n\t// We're applying the standard rotation matrix formula to the position to rotate the quad to the line angle\n\t// pointDiff can hold large values so we must divide by u_lineLength instead of calling GLSL's normalize function:\n\t// https://asawicki.info/news_1596_watch_out_for_reduced_precision_normalizelength_in_opengl_es\n\tvec2 normalized = pointDiff / max(u_lineLength, epsilon);\n\tposition = mat2(normalized.x, normalized.y, -normalized.y, normalized.x) * position;\n\n\t// 3. Translate quad\n\tposition += u_penPoints.xy;\n\n\t// 4. Apply view transform\n\tposition *= 2.0 / u_stageSize;\n\tgl_Position = vec4(position, 0, 1);\n\t#elif defined(DRAW_MODE_background)\n\tgl_Position = vec4(a_position * 2.0, 0, 1);\n\t#else\n\tgl_Position = u_projectionMatrix * u_modelMatrix * vec4(a_position, 0, 1);\n\tv_texCoord = a_texCoord;\n\t#endif\n}\n"

/***/ }),

/***/ "./node_modules/scratch-render-fonts/src/index.js":
/*!********************************************************!*\
  !*** ./node_modules/scratch-render-fonts/src/index.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// Synchronously load TTF fonts.
// First, have Webpack load their data as Base 64 strings.
let FONTS;

const getFonts = function () {
    if (FONTS) return FONTS;
    /* eslint-disable global-require */
    FONTS = {
        'Sans Serif': __webpack_require__(/*! base64-loader!./NotoSans-Medium.ttf */ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/NotoSans-Medium.ttf"),
        'Serif': __webpack_require__(/*! base64-loader!./SourceSerifPro-Regular.otf */ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/SourceSerifPro-Regular.otf"),
        'Handwriting': __webpack_require__(/*! base64-loader!./handlee-regular.ttf */ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/handlee-regular.ttf"),
        'Marker': __webpack_require__(/*! base64-loader!./Knewave.ttf */ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/Knewave.ttf"),
        'Curly': __webpack_require__(/*! base64-loader!./Griffy-Regular.ttf */ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/Griffy-Regular.ttf"),
        'Pixel': __webpack_require__(/*! base64-loader!./Grand9K-Pixel.ttf */ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/Grand9K-Pixel.ttf"),
        'Scratch': __webpack_require__(/*! base64-loader!./Scratch.ttf */ "./node_modules/base64-loader/index.js!./node_modules/scratch-render-fonts/src/Scratch.ttf")
    };
    /* eslint-enable global-require */

    // For each Base 64 string,
    // 1. Replace each with a usable @font-face tag that points to a Data URI.
    // 2. Inject the font into a style on `document.body`, so measurements
    //    can be accurately taken in SvgRenderer._transformMeasurements.
    for (const fontName in FONTS) {
        const fontData = FONTS[fontName];
        FONTS[fontName] = '@font-face {' +
            `font-family: "${fontName}";src: url("data:application/x-font-ttf;charset=utf-8;base64,${fontData}");}`;
    }

    if (!document.getElementById('scratch-font-styles')) {
        const documentStyleTag = document.createElement('style');
        documentStyleTag.id = 'scratch-font-styles';
        for (const fontName in FONTS) {
            documentStyleTag.textContent += FONTS[fontName];
        }
        document.body.insertBefore(documentStyleTag, document.body.firstChild);
    }

    return FONTS;
};

module.exports = getFonts;


/***/ }),

/***/ "./node_modules/scratch-svg-renderer/node_modules/base64-js/index.js":
/*!***************************************************************************!*\
  !*** ./node_modules/scratch-svg-renderer/node_modules/base64-js/index.js ***!
  \***************************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "./node_modules/source-map/lib/array-set.js":
/*!**************************************************!*\
  !*** ./node_modules/source-map/lib/array-set.js ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util = __webpack_require__(/*! ./util */ "./node_modules/source-map/lib/util.js");
var has = Object.prototype.hasOwnProperty;
var hasNativeMap = typeof Map !== "undefined";

/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */
function ArraySet() {
  this._array = [];
  this._set = hasNativeMap ? new Map() : Object.create(null);
}

/**
 * Static method for creating ArraySet instances from an existing array.
 */
ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
  var set = new ArraySet();
  for (var i = 0, len = aArray.length; i < len; i++) {
    set.add(aArray[i], aAllowDuplicates);
  }
  return set;
};

/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */
ArraySet.prototype.size = function ArraySet_size() {
  return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};

/**
 * Add the given string to this set.
 *
 * @param String aStr
 */
ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
  var sStr = hasNativeMap ? aStr : util.toSetString(aStr);
  var isDuplicate = hasNativeMap ? this.has(aStr) : has.call(this._set, sStr);
  var idx = this._array.length;
  if (!isDuplicate || aAllowDuplicates) {
    this._array.push(aStr);
  }
  if (!isDuplicate) {
    if (hasNativeMap) {
      this._set.set(aStr, idx);
    } else {
      this._set[sStr] = idx;
    }
  }
};

/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */
ArraySet.prototype.has = function ArraySet_has(aStr) {
  if (hasNativeMap) {
    return this._set.has(aStr);
  } else {
    var sStr = util.toSetString(aStr);
    return has.call(this._set, sStr);
  }
};

/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */
ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
  if (hasNativeMap) {
    var idx = this._set.get(aStr);
    if (idx >= 0) {
        return idx;
    }
  } else {
    var sStr = util.toSetString(aStr);
    if (has.call(this._set, sStr)) {
      return this._set[sStr];
    }
  }

  throw new Error('"' + aStr + '" is not in the set.');
};

/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */
ArraySet.prototype.at = function ArraySet_at(aIdx) {
  if (aIdx >= 0 && aIdx < this._array.length) {
    return this._array[aIdx];
  }
  throw new Error('No element indexed by ' + aIdx);
};

/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */
ArraySet.prototype.toArray = function ArraySet_toArray() {
  return this._array.slice();
};

exports.ArraySet = ArraySet;


/***/ }),

/***/ "./node_modules/source-map/lib/base64-vlq.js":
/*!***************************************************!*\
  !*** ./node_modules/source-map/lib/base64-vlq.js ***!
  \***************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

var base64 = __webpack_require__(/*! ./base64 */ "./node_modules/source-map/lib/base64.js");

// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011

var VLQ_BASE_SHIFT = 5;

// binary: 100000
var VLQ_BASE = 1 << VLQ_BASE_SHIFT;

// binary: 011111
var VLQ_BASE_MASK = VLQ_BASE - 1;

// binary: 100000
var VLQ_CONTINUATION_BIT = VLQ_BASE;

/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */
function toVLQSigned(aValue) {
  return aValue < 0
    ? ((-aValue) << 1) + 1
    : (aValue << 1) + 0;
}

/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */
function fromVLQSigned(aValue) {
  var isNegative = (aValue & 1) === 1;
  var shifted = aValue >> 1;
  return isNegative
    ? -shifted
    : shifted;
}

/**
 * Returns the base 64 VLQ encoded value.
 */
exports.encode = function base64VLQ_encode(aValue) {
  var encoded = "";
  var digit;

  var vlq = toVLQSigned(aValue);

  do {
    digit = vlq & VLQ_BASE_MASK;
    vlq >>>= VLQ_BASE_SHIFT;
    if (vlq > 0) {
      // There are still more digits in this value, so we must make sure the
      // continuation bit is marked.
      digit |= VLQ_CONTINUATION_BIT;
    }
    encoded += base64.encode(digit);
  } while (vlq > 0);

  return encoded;
};

/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */
exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
  var strLen = aStr.length;
  var result = 0;
  var shift = 0;
  var continuation, digit;

  do {
    if (aIndex >= strLen) {
      throw new Error("Expected more digits in base 64 VLQ value.");
    }

    digit = base64.decode(aStr.charCodeAt(aIndex++));
    if (digit === -1) {
      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
    }

    continuation = !!(digit & VLQ_CONTINUATION_BIT);
    digit &= VLQ_BASE_MASK;
    result = result + (digit << shift);
    shift += VLQ_BASE_SHIFT;
  } while (continuation);

  aOutParam.value = fromVLQSigned(result);
  aOutParam.rest = aIndex;
};


/***/ }),

/***/ "./node_modules/source-map/lib/base64.js":
/*!***********************************************!*\
  !*** ./node_modules/source-map/lib/base64.js ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, exports) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');

/**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */
exports.encode = function (number) {
  if (0 <= number && number < intToCharMap.length) {
    return intToCharMap[number];
  }
  throw new TypeError("Must be between 0 and 63: " + number);
};

/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */
exports.decode = function (charCode) {
  var bigA = 65;     // 'A'
  var bigZ = 90;     // 'Z'

  var littleA = 97;  // 'a'
  var littleZ = 122; // 'z'

  var zero = 48;     // '0'
  var nine = 57;     // '9'

  var plus = 43;     // '+'
  var slash = 47;    // '/'

  var littleOffset = 26;
  var numberOffset = 52;

  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
  if (bigA <= charCode && charCode <= bigZ) {
    return (charCode - bigA);
  }

  // 26 - 51: abcdefghijklmnopqrstuvwxyz
  if (littleA <= charCode && charCode <= littleZ) {
    return (charCode - littleA + littleOffset);
  }

  // 52 - 61: 0123456789
  if (zero <= charCode && charCode <= nine) {
    return (charCode - zero + numberOffset);
  }

  // 62: +
  if (charCode == plus) {
    return 62;
  }

  // 63: /
  if (charCode == slash) {
    return 63;
  }

  // Invalid base64 digit.
  return -1;
};


/***/ }),

/***/ "./node_modules/source-map/lib/mapping-list.js":
/*!*****************************************************!*\
  !*** ./node_modules/source-map/lib/mapping-list.js ***!
  \*****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util = __webpack_require__(/*! ./util */ "./node_modules/source-map/lib/util.js");

/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */
function generatedPositionAfter(mappingA, mappingB) {
  // Optimized for most common case
  var lineA = mappingA.generatedLine;
  var lineB = mappingB.generatedLine;
  var columnA = mappingA.generatedColumn;
  var columnB = mappingB.generatedColumn;
  return lineB > lineA || lineB == lineA && columnB >= columnA ||
         util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}

/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */
function MappingList() {
  this._array = [];
  this._sorted = true;
  // Serves as infimum
  this._last = {generatedLine: -1, generatedColumn: 0};
}

/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */
MappingList.prototype.unsortedForEach =
  function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
  };

/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */
MappingList.prototype.add = function MappingList_add(aMapping) {
  if (generatedPositionAfter(this._last, aMapping)) {
    this._last = aMapping;
    this._array.push(aMapping);
  } else {
    this._sorted = false;
    this._array.push(aMapping);
  }
};

/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */
MappingList.prototype.toArray = function MappingList_toArray() {
  if (!this._sorted) {
    this._array.sort(util.compareByGeneratedPositionsInflated);
    this._sorted = true;
  }
  return this._array;
};

exports.MappingList = MappingList;


/***/ }),

/***/ "./node_modules/source-map/lib/source-map-generator.js":
/*!*************************************************************!*\
  !*** ./node_modules/source-map/lib/source-map-generator.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var base64VLQ = __webpack_require__(/*! ./base64-vlq */ "./node_modules/source-map/lib/base64-vlq.js");
var util = __webpack_require__(/*! ./util */ "./node_modules/source-map/lib/util.js");
var ArraySet = (__webpack_require__(/*! ./array-set */ "./node_modules/source-map/lib/array-set.js").ArraySet);
var MappingList = (__webpack_require__(/*! ./mapping-list */ "./node_modules/source-map/lib/mapping-list.js").MappingList);

/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */
function SourceMapGenerator(aArgs) {
  if (!aArgs) {
    aArgs = {};
  }
  this._file = util.getArg(aArgs, 'file', null);
  this._sourceRoot = util.getArg(aArgs, 'sourceRoot', null);
  this._skipValidation = util.getArg(aArgs, 'skipValidation', false);
  this._sources = new ArraySet();
  this._names = new ArraySet();
  this._mappings = new MappingList();
  this._sourcesContents = null;
}

SourceMapGenerator.prototype._version = 3;

/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */
SourceMapGenerator.fromSourceMap =
  function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new SourceMapGenerator({
      file: aSourceMapConsumer.file,
      sourceRoot: sourceRoot
    });
    aSourceMapConsumer.eachMapping(function (mapping) {
      var newMapping = {
        generated: {
          line: mapping.generatedLine,
          column: mapping.generatedColumn
        }
      };

      if (mapping.source != null) {
        newMapping.source = mapping.source;
        if (sourceRoot != null) {
          newMapping.source = util.relative(sourceRoot, newMapping.source);
        }

        newMapping.original = {
          line: mapping.originalLine,
          column: mapping.originalColumn
        };

        if (mapping.name != null) {
          newMapping.name = mapping.name;
        }
      }

      generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var sourceRelative = sourceFile;
      if (sourceRoot !== null) {
        sourceRelative = util.relative(sourceRoot, sourceFile);
      }

      if (!generator._sources.has(sourceRelative)) {
        generator._sources.add(sourceRelative);
      }

      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        generator.setSourceContent(sourceFile, content);
      }
    });
    return generator;
  };

/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */
SourceMapGenerator.prototype.addMapping =
  function SourceMapGenerator_addMapping(aArgs) {
    var generated = util.getArg(aArgs, 'generated');
    var original = util.getArg(aArgs, 'original', null);
    var source = util.getArg(aArgs, 'source', null);
    var name = util.getArg(aArgs, 'name', null);

    if (!this._skipValidation) {
      this._validateMapping(generated, original, source, name);
    }

    if (source != null) {
      source = String(source);
      if (!this._sources.has(source)) {
        this._sources.add(source);
      }
    }

    if (name != null) {
      name = String(name);
      if (!this._names.has(name)) {
        this._names.add(name);
      }
    }

    this._mappings.add({
      generatedLine: generated.line,
      generatedColumn: generated.column,
      originalLine: original != null && original.line,
      originalColumn: original != null && original.column,
      source: source,
      name: name
    });
  };

/**
 * Set the source content for a source file.
 */
SourceMapGenerator.prototype.setSourceContent =
  function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) {
      source = util.relative(this._sourceRoot, source);
    }

    if (aSourceContent != null) {
      // Add the source content to the _sourcesContents map.
      // Create a new _sourcesContents map if the property is null.
      if (!this._sourcesContents) {
        this._sourcesContents = Object.create(null);
      }
      this._sourcesContents[util.toSetString(source)] = aSourceContent;
    } else if (this._sourcesContents) {
      // Remove the source file from the _sourcesContents map.
      // If the _sourcesContents map is empty, set the property to null.
      delete this._sourcesContents[util.toSetString(source)];
      if (Object.keys(this._sourcesContents).length === 0) {
        this._sourcesContents = null;
      }
    }
  };

/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */
SourceMapGenerator.prototype.applySourceMap =
  function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
      if (aSourceMapConsumer.file == null) {
        throw new Error(
          'SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' +
          'or the source map\'s "file" property. Both were omitted.'
        );
      }
      sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) {
      sourceFile = util.relative(sourceRoot, sourceFile);
    }
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new ArraySet();
    var newNames = new ArraySet();

    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function (mapping) {
      if (mapping.source === sourceFile && mapping.originalLine != null) {
        // Check if it can be mapped by the source map, then update the mapping.
        var original = aSourceMapConsumer.originalPositionFor({
          line: mapping.originalLine,
          column: mapping.originalColumn
        });
        if (original.source != null) {
          // Copy mapping
          mapping.source = original.source;
          if (aSourceMapPath != null) {
            mapping.source = util.join(aSourceMapPath, mapping.source)
          }
          if (sourceRoot != null) {
            mapping.source = util.relative(sourceRoot, mapping.source);
          }
          mapping.originalLine = original.line;
          mapping.originalColumn = original.column;
          if (original.name != null) {
            mapping.name = original.name;
          }
        }
      }

      var source = mapping.source;
      if (source != null && !newSources.has(source)) {
        newSources.add(source);
      }

      var name = mapping.name;
      if (name != null && !newNames.has(name)) {
        newNames.add(name);
      }

    }, this);
    this._sources = newSources;
    this._names = newNames;

    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        if (aSourceMapPath != null) {
          sourceFile = util.join(aSourceMapPath, sourceFile);
        }
        if (sourceRoot != null) {
          sourceFile = util.relative(sourceRoot, sourceFile);
        }
        this.setSourceContent(sourceFile, content);
      }
    }, this);
  };

/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */
SourceMapGenerator.prototype._validateMapping =
  function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource,
                                              aName) {
    // When aOriginal is truthy but has empty values for .line and .column,
    // it is most likely a programmer error. In this case we throw a very
    // specific error message to try to guide them the right way.
    // For example: https://github.com/Polymer/polymer-bundler/pull/519
    if (aOriginal && typeof aOriginal.line !== 'number' && typeof aOriginal.column !== 'number') {
        throw new Error(
            'original.line and original.column are not numbers -- you probably meant to omit ' +
            'the original mapping entirely and only map the generated position. If so, pass ' +
            'null for the original mapping instead of an object with empty or null values.'
        );
    }

    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
        && aGenerated.line > 0 && aGenerated.column >= 0
        && !aOriginal && !aSource && !aName) {
      // Case 1.
      return;
    }
    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
             && aOriginal && 'line' in aOriginal && 'column' in aOriginal
             && aGenerated.line > 0 && aGenerated.column >= 0
             && aOriginal.line > 0 && aOriginal.column >= 0
             && aSource) {
      // Cases 2 and 3.
      return;
    }
    else {
      throw new Error('Invalid mapping: ' + JSON.stringify({
        generated: aGenerated,
        source: aSource,
        original: aOriginal,
        name: aName
      }));
    }
  };

/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */
SourceMapGenerator.prototype._serializeMappings =
  function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = '';
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;

    var mappings = this._mappings.toArray();
    for (var i = 0, len = mappings.length; i < len; i++) {
      mapping = mappings[i];
      next = ''

      if (mapping.generatedLine !== previousGeneratedLine) {
        previousGeneratedColumn = 0;
        while (mapping.generatedLine !== previousGeneratedLine) {
          next += ';';
          previousGeneratedLine++;
        }
      }
      else {
        if (i > 0) {
          if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
            continue;
          }
          next += ',';
        }
      }

      next += base64VLQ.encode(mapping.generatedColumn
                                 - previousGeneratedColumn);
      previousGeneratedColumn = mapping.generatedColumn;

      if (mapping.source != null) {
        sourceIdx = this._sources.indexOf(mapping.source);
        next += base64VLQ.encode(sourceIdx - previousSource);
        previousSource = sourceIdx;

        // lines are stored 0-based in SourceMap spec version 3
        next += base64VLQ.encode(mapping.originalLine - 1
                                   - previousOriginalLine);
        previousOriginalLine = mapping.originalLine - 1;

        next += base64VLQ.encode(mapping.originalColumn
                                   - previousOriginalColumn);
        previousOriginalColumn = mapping.originalColumn;

        if (mapping.name != null) {
          nameIdx = this._names.indexOf(mapping.name);
          next += base64VLQ.encode(nameIdx - previousName);
          previousName = nameIdx;
        }
      }

      result += next;
    }

    return result;
  };

SourceMapGenerator.prototype._generateSourcesContent =
  function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function (source) {
      if (!this._sourcesContents) {
        return null;
      }
      if (aSourceRoot != null) {
        source = util.relative(aSourceRoot, source);
      }
      var key = util.toSetString(source);
      return Object.prototype.hasOwnProperty.call(this._sourcesContents, key)
        ? this._sourcesContents[key]
        : null;
    }, this);
  };

/**
 * Externalize the source map.
 */
SourceMapGenerator.prototype.toJSON =
  function SourceMapGenerator_toJSON() {
    var map = {
      version: this._version,
      sources: this._sources.toArray(),
      names: this._names.toArray(),
      mappings: this._serializeMappings()
    };
    if (this._file != null) {
      map.file = this._file;
    }
    if (this._sourceRoot != null) {
      map.sourceRoot = this._sourceRoot;
    }
    if (this._sourcesContents) {
      map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    }

    return map;
  };

/**
 * Render the source map being generated to a string.
 */
SourceMapGenerator.prototype.toString =
  function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
  };

exports.SourceMapGenerator = SourceMapGenerator;


/***/ }),

/***/ "./node_modules/source-map/lib/util.js":
/*!*********************************************!*\
  !*** ./node_modules/source-map/lib/util.js ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, exports) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

/**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */
function getArg(aArgs, aName, aDefaultValue) {
  if (aName in aArgs) {
    return aArgs[aName];
  } else if (arguments.length === 3) {
    return aDefaultValue;
  } else {
    throw new Error('"' + aName + '" is a required argument.');
  }
}
exports.getArg = getArg;

var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
var dataUrlRegexp = /^data:.+\,.+$/;

function urlParse(aUrl) {
  var match = aUrl.match(urlRegexp);
  if (!match) {
    return null;
  }
  return {
    scheme: match[1],
    auth: match[2],
    host: match[3],
    port: match[4],
    path: match[5]
  };
}
exports.urlParse = urlParse;

function urlGenerate(aParsedUrl) {
  var url = '';
  if (aParsedUrl.scheme) {
    url += aParsedUrl.scheme + ':';
  }
  url += '//';
  if (aParsedUrl.auth) {
    url += aParsedUrl.auth + '@';
  }
  if (aParsedUrl.host) {
    url += aParsedUrl.host;
  }
  if (aParsedUrl.port) {
    url += ":" + aParsedUrl.port
  }
  if (aParsedUrl.path) {
    url += aParsedUrl.path;
  }
  return url;
}
exports.urlGenerate = urlGenerate;

/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */
function normalize(aPath) {
  var path = aPath;
  var url = urlParse(aPath);
  if (url) {
    if (!url.path) {
      return aPath;
    }
    path = url.path;
  }
  var isAbsolute = exports.isAbsolute(path);

  var parts = path.split(/\/+/);
  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
    part = parts[i];
    if (part === '.') {
      parts.splice(i, 1);
    } else if (part === '..') {
      up++;
    } else if (up > 0) {
      if (part === '') {
        // The first part is blank if the path is absolute. Trying to go
        // above the root is a no-op. Therefore we can remove all '..' parts
        // directly after the root.
        parts.splice(i + 1, up);
        up = 0;
      } else {
        parts.splice(i, 2);
        up--;
      }
    }
  }
  path = parts.join('/');

  if (path === '') {
    path = isAbsolute ? '/' : '.';
  }

  if (url) {
    url.path = path;
    return urlGenerate(url);
  }
  return path;
}
exports.normalize = normalize;

/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */
function join(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }
  if (aPath === "") {
    aPath = ".";
  }
  var aPathUrl = urlParse(aPath);
  var aRootUrl = urlParse(aRoot);
  if (aRootUrl) {
    aRoot = aRootUrl.path || '/';
  }

  // `join(foo, '//www.example.org')`
  if (aPathUrl && !aPathUrl.scheme) {
    if (aRootUrl) {
      aPathUrl.scheme = aRootUrl.scheme;
    }
    return urlGenerate(aPathUrl);
  }

  if (aPathUrl || aPath.match(dataUrlRegexp)) {
    return aPath;
  }

  // `join('http://', 'www.example.com')`
  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
    aRootUrl.host = aPath;
    return urlGenerate(aRootUrl);
  }

  var joined = aPath.charAt(0) === '/'
    ? aPath
    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);

  if (aRootUrl) {
    aRootUrl.path = joined;
    return urlGenerate(aRootUrl);
  }
  return joined;
}
exports.join = join;

exports.isAbsolute = function (aPath) {
  return aPath.charAt(0) === '/' || urlRegexp.test(aPath);
};

/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */
function relative(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }

  aRoot = aRoot.replace(/\/$/, '');

  // It is possible for the path to be above the root. In this case, simply
  // checking whether the root is a prefix of the path won't work. Instead, we
  // need to remove components from the root one by one, until either we find
  // a prefix that fits, or we run out of components to remove.
  var level = 0;
  while (aPath.indexOf(aRoot + '/') !== 0) {
    var index = aRoot.lastIndexOf("/");
    if (index < 0) {
      return aPath;
    }

    // If the only part of the root that is left is the scheme (i.e. http://,
    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
    // have exhausted all components, so the path is not relative to the root.
    aRoot = aRoot.slice(0, index);
    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
      return aPath;
    }

    ++level;
  }

  // Make sure we add a "../" for each component we removed from the root.
  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
exports.relative = relative;

var supportsNullProto = (function () {
  var obj = Object.create(null);
  return !('__proto__' in obj);
}());

function identity (s) {
  return s;
}

/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */
function toSetString(aStr) {
  if (isProtoString(aStr)) {
    return '$' + aStr;
  }

  return aStr;
}
exports.toSetString = supportsNullProto ? identity : toSetString;

function fromSetString(aStr) {
  if (isProtoString(aStr)) {
    return aStr.slice(1);
  }

  return aStr;
}
exports.fromSetString = supportsNullProto ? identity : fromSetString;

function isProtoString(s) {
  if (!s) {
    return false;
  }

  var length = s.length;

  if (length < 9 /* "__proto__".length */) {
    return false;
  }

  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
      s.charCodeAt(length - 9) !== 95  /* '_' */) {
    return false;
  }

  for (var i = length - 10; i >= 0; i--) {
    if (s.charCodeAt(i) !== 36 /* '$' */) {
      return false;
    }
  }

  return true;
}

/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */
function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
  var cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0 || onlyCompareOriginal) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByOriginalPositions = compareByOriginalPositions;

/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */
function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0 || onlyCompareGenerated) {
    return cmp;
  }

  cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;

function strcmp(aStr1, aStr2) {
  if (aStr1 === aStr2) {
    return 0;
  }

  if (aStr1 === null) {
    return 1; // aStr2 !== null
  }

  if (aStr2 === null) {
    return -1; // aStr1 !== null
  }

  if (aStr1 > aStr2) {
    return 1;
  }

  return -1;
}

/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */
function compareByGeneratedPositionsInflated(mappingA, mappingB) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;

/**
 * Strip any JSON XSSI avoidance prefix from the string (as documented
 * in the source maps specification), and then parse the string as
 * JSON.
 */
function parseSourceMapInput(str) {
  return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ''));
}
exports.parseSourceMapInput = parseSourceMapInput;

/**
 * Compute the URL of a source given the the source root, the source's
 * URL, and the source map's URL.
 */
function computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
  sourceURL = sourceURL || '';

  if (sourceRoot) {
    // This follows what Chrome does.
    if (sourceRoot[sourceRoot.length - 1] !== '/' && sourceURL[0] !== '/') {
      sourceRoot += '/';
    }
    // The spec says:
    //   Line 4: An optional source root, useful for relocating source
    //   files on a server or removing repeated values in the
    //   “sources” entry.  This value is prepended to the individual
    //   entries in the “source” field.
    sourceURL = sourceRoot + sourceURL;
  }

  // Historically, SourceMapConsumer did not take the sourceMapURL as
  // a parameter.  This mode is still somewhat supported, which is why
  // this code block is conditional.  However, it's preferable to pass
  // the source map URL to SourceMapConsumer, so that this function
  // can implement the source URL resolution algorithm as outlined in
  // the spec.  This block is basically the equivalent of:
  //    new URL(sourceURL, sourceMapURL).toString()
  // ... except it avoids using URL, which wasn't available in the
  // older releases of node still supported by this library.
  //
  // The spec says:
  //   If the sources are not absolute URLs after prepending of the
  //   “sourceRoot”, the sources are resolved relative to the
  //   SourceMap (like resolving script src in a html document).
  if (sourceMapURL) {
    var parsed = urlParse(sourceMapURL);
    if (!parsed) {
      throw new Error("sourceMapURL could not be parsed");
    }
    if (parsed.path) {
      // Strip the last path component, but keep the "/".
      var index = parsed.path.lastIndexOf('/');
      if (index >= 0) {
        parsed.path = parsed.path.substring(0, index + 1);
      }
    }
    sourceURL = join(urlGenerate(parsed), sourceURL);
  }

  return normalize(sourceURL);
}
exports.computeSourceURL = computeSourceURL;


/***/ }),

/***/ "./node_modules/tiny-inflate/index.js":
/*!********************************************!*\
  !*** ./node_modules/tiny-inflate/index.js ***!
  \********************************************/
/***/ (function(module) {

var TINF_OK = 0;
var TINF_DATA_ERROR = -3;

function Tree() {
  this.table = new Uint16Array(16);   /* table of code length counts */
  this.trans = new Uint16Array(288);  /* code -> symbol translation table */
}

function Data(source, dest) {
  this.source = source;
  this.sourceIndex = 0;
  this.tag = 0;
  this.bitcount = 0;
  
  this.dest = dest;
  this.destLen = 0;
  
  this.ltree = new Tree();  /* dynamic length/symbol tree */
  this.dtree = new Tree();  /* dynamic distance tree */
}

/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */

var sltree = new Tree();
var sdtree = new Tree();

/* extra bits and base tables for length codes */
var length_bits = new Uint8Array(30);
var length_base = new Uint16Array(30);

/* extra bits and base tables for distance codes */
var dist_bits = new Uint8Array(30);
var dist_base = new Uint16Array(30);

/* special ordering of code length codes */
var clcidx = new Uint8Array([
  16, 17, 18, 0, 8, 7, 9, 6,
  10, 5, 11, 4, 12, 3, 13, 2,
  14, 1, 15
]);

/* used by tinf_decode_trees, avoids allocations every call */
var code_tree = new Tree();
var lengths = new Uint8Array(288 + 32);

/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */

/* build extra bits and base tables */
function tinf_build_bits_base(bits, base, delta, first) {
  var i, sum;

  /* build bits table */
  for (i = 0; i < delta; ++i) bits[i] = 0;
  for (i = 0; i < 30 - delta; ++i) bits[i + delta] = i / delta | 0;

  /* build base table */
  for (sum = first, i = 0; i < 30; ++i) {
    base[i] = sum;
    sum += 1 << bits[i];
  }
}

/* build the fixed huffman trees */
function tinf_build_fixed_trees(lt, dt) {
  var i;

  /* build fixed length tree */
  for (i = 0; i < 7; ++i) lt.table[i] = 0;

  lt.table[7] = 24;
  lt.table[8] = 152;
  lt.table[9] = 112;

  for (i = 0; i < 24; ++i) lt.trans[i] = 256 + i;
  for (i = 0; i < 144; ++i) lt.trans[24 + i] = i;
  for (i = 0; i < 8; ++i) lt.trans[24 + 144 + i] = 280 + i;
  for (i = 0; i < 112; ++i) lt.trans[24 + 144 + 8 + i] = 144 + i;

  /* build fixed distance tree */
  for (i = 0; i < 5; ++i) dt.table[i] = 0;

  dt.table[5] = 32;

  for (i = 0; i < 32; ++i) dt.trans[i] = i;
}

/* given an array of code lengths, build a tree */
var offs = new Uint16Array(16);

function tinf_build_tree(t, lengths, off, num) {
  var i, sum;

  /* clear code length count table */
  for (i = 0; i < 16; ++i) t.table[i] = 0;

  /* scan symbol lengths, and sum code length counts */
  for (i = 0; i < num; ++i) t.table[lengths[off + i]]++;

  t.table[0] = 0;

  /* compute offset table for distribution sort */
  for (sum = 0, i = 0; i < 16; ++i) {
    offs[i] = sum;
    sum += t.table[i];
  }

  /* create code->symbol translation table (symbols sorted by code) */
  for (i = 0; i < num; ++i) {
    if (lengths[off + i]) t.trans[offs[lengths[off + i]]++] = i;
  }
}

/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */

/* get one bit from source stream */
function tinf_getbit(d) {
  /* check if tag is empty */
  if (!d.bitcount--) {
    /* load next tag */
    d.tag = d.source[d.sourceIndex++];
    d.bitcount = 7;
  }

  /* shift bit out of tag */
  var bit = d.tag & 1;
  d.tag >>>= 1;

  return bit;
}

/* read a num bit value from a stream and add base */
function tinf_read_bits(d, num, base) {
  if (!num)
    return base;

  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }

  var val = d.tag & (0xffff >>> (16 - num));
  d.tag >>>= num;
  d.bitcount -= num;
  return val + base;
}

/* given a data stream and a tree, decode a symbol */
function tinf_decode_symbol(d, t) {
  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }
  
  var sum = 0, cur = 0, len = 0;
  var tag = d.tag;

  /* get more bits while code value is above sum */
  do {
    cur = 2 * cur + (tag & 1);
    tag >>>= 1;
    ++len;

    sum += t.table[len];
    cur -= t.table[len];
  } while (cur >= 0);
  
  d.tag = tag;
  d.bitcount -= len;

  return t.trans[sum + cur];
}

/* given a data stream, decode dynamic trees from it */
function tinf_decode_trees(d, lt, dt) {
  var hlit, hdist, hclen;
  var i, num, length;

  /* get 5 bits HLIT (257-286) */
  hlit = tinf_read_bits(d, 5, 257);

  /* get 5 bits HDIST (1-32) */
  hdist = tinf_read_bits(d, 5, 1);

  /* get 4 bits HCLEN (4-19) */
  hclen = tinf_read_bits(d, 4, 4);

  for (i = 0; i < 19; ++i) lengths[i] = 0;

  /* read code lengths for code length alphabet */
  for (i = 0; i < hclen; ++i) {
    /* get 3 bits code length (0-7) */
    var clen = tinf_read_bits(d, 3, 0);
    lengths[clcidx[i]] = clen;
  }

  /* build code length tree */
  tinf_build_tree(code_tree, lengths, 0, 19);

  /* decode code lengths for the dynamic trees */
  for (num = 0; num < hlit + hdist;) {
    var sym = tinf_decode_symbol(d, code_tree);

    switch (sym) {
      case 16:
        /* copy previous code length 3-6 times (read 2 bits) */
        var prev = lengths[num - 1];
        for (length = tinf_read_bits(d, 2, 3); length; --length) {
          lengths[num++] = prev;
        }
        break;
      case 17:
        /* repeat code length 0 for 3-10 times (read 3 bits) */
        for (length = tinf_read_bits(d, 3, 3); length; --length) {
          lengths[num++] = 0;
        }
        break;
      case 18:
        /* repeat code length 0 for 11-138 times (read 7 bits) */
        for (length = tinf_read_bits(d, 7, 11); length; --length) {
          lengths[num++] = 0;
        }
        break;
      default:
        /* values 0-15 represent the actual code lengths */
        lengths[num++] = sym;
        break;
    }
  }

  /* build dynamic trees */
  tinf_build_tree(lt, lengths, 0, hlit);
  tinf_build_tree(dt, lengths, hlit, hdist);
}

/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */

/* given a stream and two trees, inflate a block of data */
function tinf_inflate_block_data(d, lt, dt) {
  while (1) {
    var sym = tinf_decode_symbol(d, lt);

    /* check for end of block */
    if (sym === 256) {
      return TINF_OK;
    }

    if (sym < 256) {
      d.dest[d.destLen++] = sym;
    } else {
      var length, dist, offs;
      var i;

      sym -= 257;

      /* possibly get more bits from length code */
      length = tinf_read_bits(d, length_bits[sym], length_base[sym]);

      dist = tinf_decode_symbol(d, dt);

      /* possibly get more bits from distance code */
      offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);

      /* copy match */
      for (i = offs; i < offs + length; ++i) {
        d.dest[d.destLen++] = d.dest[i];
      }
    }
  }
}

/* inflate an uncompressed block of data */
function tinf_inflate_uncompressed_block(d) {
  var length, invlength;
  var i;
  
  /* unread from bitbuffer */
  while (d.bitcount > 8) {
    d.sourceIndex--;
    d.bitcount -= 8;
  }

  /* get length */
  length = d.source[d.sourceIndex + 1];
  length = 256 * length + d.source[d.sourceIndex];

  /* get one's complement of length */
  invlength = d.source[d.sourceIndex + 3];
  invlength = 256 * invlength + d.source[d.sourceIndex + 2];

  /* check length */
  if (length !== (~invlength & 0x0000ffff))
    return TINF_DATA_ERROR;

  d.sourceIndex += 4;

  /* copy block */
  for (i = length; i; --i)
    d.dest[d.destLen++] = d.source[d.sourceIndex++];

  /* make sure we start next block on a byte boundary */
  d.bitcount = 0;

  return TINF_OK;
}

/* inflate stream from source to dest */
function tinf_uncompress(source, dest) {
  var d = new Data(source, dest);
  var bfinal, btype, res;

  do {
    /* read final block flag */
    bfinal = tinf_getbit(d);

    /* read block type (2 bits) */
    btype = tinf_read_bits(d, 2, 0);

    /* decompress block */
    switch (btype) {
      case 0:
        /* decompress uncompressed block */
        res = tinf_inflate_uncompressed_block(d);
        break;
      case 1:
        /* decompress block with fixed huffman trees */
        res = tinf_inflate_block_data(d, sltree, sdtree);
        break;
      case 2:
        /* decompress block with dynamic huffman trees */
        tinf_decode_trees(d, d.ltree, d.dtree);
        res = tinf_inflate_block_data(d, d.ltree, d.dtree);
        break;
      default:
        res = TINF_DATA_ERROR;
    }

    if (res !== TINF_OK)
      throw new Error('Data error');

  } while (!bfinal);

  if (d.destLen < d.dest.length) {
    if (typeof d.dest.slice === 'function')
      return d.dest.slice(0, d.destLen);
    else
      return d.dest.subarray(0, d.destLen);
  }
  
  return d.dest;
}

/* -------------------- *
 * -- initialization -- *
 * -------------------- */

/* build fixed huffman trees */
tinf_build_fixed_trees(sltree, sdtree);

/* build extra bits and base tables */
tinf_build_bits_base(length_bits, length_base, 4, 3);
tinf_build_bits_base(dist_bits, dist_base, 2, 1);

/* fix a special case */
length_bits[28] = 0;
length_base[28] = 258;

module.exports = tinf_uncompress;


/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/applyToPoint.js":
/*!*********************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/applyToPoint.js ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   applyToPoint: function() { return /* binding */ applyToPoint; },
/* harmony export */   applyToPoints: function() { return /* binding */ applyToPoints; }
/* harmony export */ });
/**
 * Calculate a point transformed with an affine matrix
 * @param matrix Affine matrix
 * @param point Point
 * @returns {{x: number, y: number} | Array} Point
 */
function applyToPoint(matrix, point) {
  return Array.isArray(point) ? [matrix.a * point[0] + matrix.c * point[1] + matrix.e, matrix.b * point[0] + matrix.d * point[1] + matrix.f] : {
    x: matrix.a * point.x + matrix.c * point.y + matrix.e,
    y: matrix.b * point.x + matrix.d * point.y + matrix.f
  };
}

/**
 * Calculate an array of points transformed with an affine matrix
 * @param matrix Affine matrix
 * @param points Array of points
 * @returns {array} Array of points
 */
function applyToPoints(matrix, points) {
  return points.map(function (point) {
    return applyToPoint(matrix, point);
  });
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/fromObject.js":
/*!*******************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/fromObject.js ***!
  \*******************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   fromObject: function() { return /* binding */ fromObject; }
/* harmony export */ });
/**
 * Extract an affine matrix from an object that contains a,b,c,d,e,f keys
 * Each value could be a float or a string that contains a float
 * @param object
 * @return {{a: *, b: *, c: *, e: *, d: *, f: *}}}
 */
function fromObject(object) {
  return {
    a: parseFloat(object.a),
    b: parseFloat(object.b),
    c: parseFloat(object.c),
    d: parseFloat(object.d),
    e: parseFloat(object.e),
    f: parseFloat(object.f)
  };
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/fromString.js":
/*!*******************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/fromString.js ***!
  \*******************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   fromString: function() { return /* binding */ fromString; }
/* harmony export */ });
/**
 * @ignore
 * @type {RegExp}
 */
var matrixRegex = /^matrix\(\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*\)$/i;

/**
 * Parse a string matrix formatted as matrix(a,b,c,d,e,f)
 * @param string String with a matrix
 * @returns {{a: number, b: number, c: number, e: number, d: number, f: number}} Affine matrix
 */
function fromString(string) {
  var parsed = string.match(matrixRegex);
  if (parsed === null || parsed.length < 7) throw new Error("'" + string + "' is not a matrix");
  return {
    a: parseFloat(parsed[1]),
    b: parseFloat(parsed[2]),
    c: parseFloat(parsed[3]),
    d: parseFloat(parsed[4]),
    e: parseFloat(parsed[5]),
    f: parseFloat(parsed[6])
  };
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/fromTriangles.js":
/*!**********************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/fromTriangles.js ***!
  \**********************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   fromTriangles: function() { return /* binding */ fromTriangles; }
/* harmony export */ });
/* harmony import */ var _inverse__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./inverse */ "./node_modules/transformation-matrix/build-es/inverse.js");
/* harmony import */ var _transform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./transform */ "./node_modules/transformation-matrix/build-es/transform.js");
/* harmony import */ var _smoothMatrix__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./smoothMatrix */ "./node_modules/transformation-matrix/build-es/smoothMatrix.js");




/**
 * Returns a matrix that transforms a triangle t1 into another triangle t2, or throws an exception if it is impossible.
 * @param t1 {Array.<{x: number, y: number}> | Array.<Array<number>>} an array of points containing the three points for the first triangle
 * @param t2 {Array.<{x: number, y: number}> | Array.<Array<number>>} an array of points containing the three points for the second triangle
 * @returns {{a: number, b: number, c: number, e: number, d: number, f: number}} Affine matrix which transforms t1 to t2
 * @throws Exception if the matrix becomes not invertible
 */
function fromTriangles(t1, t2) {
  // point p = first point of the triangle
  var px1 = t1[0].x != null ? t1[0].x : t1[0][0];
  var py1 = t1[0].y != null ? t1[0].y : t1[0][1];
  var px2 = t2[0].x != null ? t2[0].x : t2[0][0];
  var py2 = t2[0].y != null ? t2[0].y : t2[0][1];

  // point q = second point of the triangle
  var qx1 = t1[1].x != null ? t1[1].x : t1[1][0];
  var qy1 = t1[1].y != null ? t1[1].y : t1[1][1];
  var qx2 = t2[1].x != null ? t2[1].x : t2[1][0];
  var qy2 = t2[1].y != null ? t2[1].y : t2[1][1];

  // point r = third point of the triangle
  var rx1 = t1[2].x != null ? t1[2].x : t1[2][0];
  var ry1 = t1[2].y != null ? t1[2].y : t1[2][1];
  var rx2 = t2[2].x != null ? t2[2].x : t2[2][0];
  var ry2 = t2[2].y != null ? t2[2].y : t2[2][1];

  var r1 = {
    a: px1 - rx1,
    b: py1 - ry1,
    c: qx1 - rx1,
    d: qy1 - ry1,
    e: rx1,
    f: ry1
  };
  var r2 = {
    a: px2 - rx2,
    b: py2 - ry2,
    c: qx2 - rx2,
    d: qy2 - ry2,
    e: rx2,
    f: ry2
  };

  var inverseR1 = (0,_inverse__WEBPACK_IMPORTED_MODULE_0__.inverse)(r1);
  var affineMatrix = (0,_transform__WEBPACK_IMPORTED_MODULE_1__.transform)([r2, inverseR1]);

  // round the matrix elements to smooth the finite inversion
  return (0,_smoothMatrix__WEBPACK_IMPORTED_MODULE_2__.smoothMatrix)(affineMatrix);
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/identity.js":
/*!*****************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/identity.js ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   identity: function() { return /* binding */ identity; }
/* harmony export */ });
/**
 * Identity matrix
 * @returns {{a: number, b: number, c: number, e: number, d: number, f: number}} Affine matrix
 */
function identity() {
  return {
    a: 1,
    c: 0,
    e: 0,
    b: 0,
    d: 1,
    f: 0
  };
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/index.js":
/*!**************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/index.js ***!
  \**************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   applyToPoint: function() { return /* reexport safe */ _applyToPoint__WEBPACK_IMPORTED_MODULE_0__.applyToPoint; },
/* harmony export */   applyToPoints: function() { return /* reexport safe */ _applyToPoint__WEBPACK_IMPORTED_MODULE_0__.applyToPoints; },
/* harmony export */   compose: function() { return /* reexport safe */ _transform__WEBPACK_IMPORTED_MODULE_11__.compose; },
/* harmony export */   fromObject: function() { return /* reexport safe */ _fromObject__WEBPACK_IMPORTED_MODULE_1__.fromObject; },
/* harmony export */   fromString: function() { return /* reexport safe */ _fromString__WEBPACK_IMPORTED_MODULE_2__.fromString; },
/* harmony export */   fromTriangles: function() { return /* reexport safe */ _fromTriangles__WEBPACK_IMPORTED_MODULE_13__.fromTriangles; },
/* harmony export */   identity: function() { return /* reexport safe */ _identity__WEBPACK_IMPORTED_MODULE_3__.identity; },
/* harmony export */   inverse: function() { return /* reexport safe */ _inverse__WEBPACK_IMPORTED_MODULE_4__.inverse; },
/* harmony export */   isAffineMatrix: function() { return /* reexport safe */ _isAffineMatrix__WEBPACK_IMPORTED_MODULE_5__.isAffineMatrix; },
/* harmony export */   rotate: function() { return /* reexport safe */ _rotate__WEBPACK_IMPORTED_MODULE_6__.rotate; },
/* harmony export */   rotateDEG: function() { return /* reexport safe */ _rotate__WEBPACK_IMPORTED_MODULE_6__.rotateDEG; },
/* harmony export */   scale: function() { return /* reexport safe */ _scale__WEBPACK_IMPORTED_MODULE_7__.scale; },
/* harmony export */   shear: function() { return /* reexport safe */ _shear__WEBPACK_IMPORTED_MODULE_8__.shear; },
/* harmony export */   skew: function() { return /* reexport safe */ _skew__WEBPACK_IMPORTED_MODULE_9__.skew; },
/* harmony export */   skewDEG: function() { return /* reexport safe */ _skew__WEBPACK_IMPORTED_MODULE_9__.skewDEG; },
/* harmony export */   smoothMatrix: function() { return /* reexport safe */ _smoothMatrix__WEBPACK_IMPORTED_MODULE_14__.smoothMatrix; },
/* harmony export */   toCSS: function() { return /* reexport safe */ _toString__WEBPACK_IMPORTED_MODULE_10__.toCSS; },
/* harmony export */   toSVG: function() { return /* reexport safe */ _toString__WEBPACK_IMPORTED_MODULE_10__.toSVG; },
/* harmony export */   toString: function() { return /* reexport safe */ _toString__WEBPACK_IMPORTED_MODULE_10__.toString; },
/* harmony export */   transform: function() { return /* reexport safe */ _transform__WEBPACK_IMPORTED_MODULE_11__.transform; },
/* harmony export */   translate: function() { return /* reexport safe */ _translate__WEBPACK_IMPORTED_MODULE_12__.translate; }
/* harmony export */ });
/* harmony import */ var _applyToPoint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./applyToPoint */ "./node_modules/transformation-matrix/build-es/applyToPoint.js");
/* harmony import */ var _fromObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./fromObject */ "./node_modules/transformation-matrix/build-es/fromObject.js");
/* harmony import */ var _fromString__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./fromString */ "./node_modules/transformation-matrix/build-es/fromString.js");
/* harmony import */ var _identity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./identity */ "./node_modules/transformation-matrix/build-es/identity.js");
/* harmony import */ var _inverse__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./inverse */ "./node_modules/transformation-matrix/build-es/inverse.js");
/* harmony import */ var _isAffineMatrix__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./isAffineMatrix */ "./node_modules/transformation-matrix/build-es/isAffineMatrix.js");
/* harmony import */ var _rotate__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./rotate */ "./node_modules/transformation-matrix/build-es/rotate.js");
/* harmony import */ var _scale__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./scale */ "./node_modules/transformation-matrix/build-es/scale.js");
/* harmony import */ var _shear__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./shear */ "./node_modules/transformation-matrix/build-es/shear.js");
/* harmony import */ var _skew__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./skew */ "./node_modules/transformation-matrix/build-es/skew.js");
/* harmony import */ var _toString__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./toString */ "./node_modules/transformation-matrix/build-es/toString.js");
/* harmony import */ var _transform__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./transform */ "./node_modules/transformation-matrix/build-es/transform.js");
/* harmony import */ var _translate__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./translate */ "./node_modules/transformation-matrix/build-es/translate.js");
/* harmony import */ var _fromTriangles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./fromTriangles */ "./node_modules/transformation-matrix/build-es/fromTriangles.js");
/* harmony import */ var _smoothMatrix__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./smoothMatrix */ "./node_modules/transformation-matrix/build-es/smoothMatrix.js");
















/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/inverse.js":
/*!****************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/inverse.js ***!
  \****************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   inverse: function() { return /* binding */ inverse; }
/* harmony export */ });
/**
 * Calculate a matrix that is the inverse of the provided matrix
 * @param matrix Affine matrix
 * @returns {{a: number, b: number, c: number, e: number, d: number, f: number}} Affine matrix
 */
function inverse(matrix) {
  // http://www.wolframalpha.com/input/?i=Inverse+%5B%7B%7Ba,c,e%7D,%7Bb,d,f%7D,%7B0,0,1%7D%7D%5D

  var a = matrix.a,
      b = matrix.b,
      c = matrix.c,
      d = matrix.d,
      e = matrix.e,
      f = matrix.f;


  var denom = a * d - b * c;

  return {
    a: d / denom,
    b: b / -denom,
    c: c / -denom,
    d: a / denom,
    e: (d * e - c * f) / -denom,
    f: (b * e - a * f) / denom
  };
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/isAffineMatrix.js":
/*!***********************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/isAffineMatrix.js ***!
  \***********************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   isAffineMatrix: function() { return /* binding */ isAffineMatrix; }
/* harmony export */ });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isNumeric = function isNumeric(n) {
  return typeof n === 'number' && !isNaN(n) && isFinite(n);
};
var isObject = function isObject(obj) {
  return obj != null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
};

/**
 * Check if the object contain an affine matrix
 * @param object
 * @return {boolean}
 */
function isAffineMatrix(object) {
  return isObject(object) && object.hasOwnProperty('a') && isNumeric(object.a) && object.hasOwnProperty('b') && isNumeric(object.b) && object.hasOwnProperty('c') && isNumeric(object.c) && object.hasOwnProperty('d') && isNumeric(object.d) && object.hasOwnProperty('e') && isNumeric(object.e) && object.hasOwnProperty('f') && isNumeric(object.f);
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/rotate.js":
/*!***************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/rotate.js ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   rotate: function() { return /* binding */ rotate; },
/* harmony export */   rotateDEG: function() { return /* binding */ rotateDEG; }
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils */ "./node_modules/transformation-matrix/build-es/utils.js");
/* harmony import */ var _translate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./translate */ "./node_modules/transformation-matrix/build-es/translate.js");
/* harmony import */ var _transform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./transform */ "./node_modules/transformation-matrix/build-es/transform.js");




var cos = Math.cos,
    sin = Math.sin,
    PI = Math.PI;
/**
 * Calculate a rotation matrix
 * @param angle Angle in radians
 * @param [cx] If (cx,cy) are supplied the rotate is about this point
 * @param [cy] If (cx,cy) are supplied the rotate is about this point
 * @returns {{a: number, b: number, c: number, e: number, d: number, f: number}} Affine matrix *
 */

function rotate(angle, cx, cy) {
  var cosAngle = cos(angle);
  var sinAngle = sin(angle);
  var rotationMatrix = {
    a: cosAngle,
    c: -sinAngle,
    e: 0,
    b: sinAngle,
    d: cosAngle,
    f: 0
  };
  if ((0,_utils__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(cx) || (0,_utils__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(cy)) {
    return rotationMatrix;
  }

  return (0,_transform__WEBPACK_IMPORTED_MODULE_2__.transform)([(0,_translate__WEBPACK_IMPORTED_MODULE_1__.translate)(cx, cy), rotationMatrix, (0,_translate__WEBPACK_IMPORTED_MODULE_1__.translate)(-cx, -cy)]);
}

/**
 * Calculate a rotation matrix with a DEG angle
 * @param angle Angle in degree
 * @param [cx] If (cx,cy) are supplied the rotate is about this point
 * @param [cy] If (cx,cy) are supplied the rotate is about this point
 * @returns {{a: number, b: number, c: number, e: number, d: number, f: number}} Affine matrix
 */
function rotateDEG(angle) {
  var cx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var cy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return rotate(angle * PI / 180, cx, cy);
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/scale.js":
/*!**************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/scale.js ***!
  \**************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   scale: function() { return /* binding */ scale; }
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils */ "./node_modules/transformation-matrix/build-es/utils.js");


/**
 * Calculate a scaling matrix
 * @param sx Scaling on axis x
 * @param [sy = sx] Scaling on axis y (default sx)
 * @returns {{a: number, b: number, c: number, e: number, d: number, f: number}} Affine matrix
 */
function scale(sx) {
  var sy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if ((0,_utils__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(sy)) sy = sx;
  return {
    a: sx,
    c: 0,
    e: 0,
    b: 0,
    d: sy,
    f: 0
  };
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/shear.js":
/*!**************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/shear.js ***!
  \**************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   shear: function() { return /* binding */ shear; }
/* harmony export */ });
/**
 * Calculate a shear matrix
 * @param shx Shear on axis x
 * @param shy Shear on axis y
 * @returns {{a: number, b: number, c: number, e: number, d: number, f: number}} Affine matrix
 */
function shear(shx, shy) {
  return {
    a: 1,
    c: shx,
    e: 0,
    b: shy,
    d: 1,
    f: 0
  };
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/skew.js":
/*!*************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/skew.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   skew: function() { return /* binding */ skew; },
/* harmony export */   skewDEG: function() { return /* binding */ skewDEG; }
/* harmony export */ });
// https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/skew
var tan = Math.tan;

/**
 * Calculate a skew matrix
 * @param ax Skew on axis x
 * @param ay Skew on axis y
 * @returns {{a: number, b: number, c: number, e: number, d: number, f: number}} Affine matrix
 */

function skew(ax, ay) {
  return {
    a: 1,
    c: tan(ax),
    e: 0,
    b: tan(ay),
    d: 1,
    f: 0
  };
}

/**
 * Calculate a skew matrix using DEG angles
 * @param ax Skew on axis x
 * @param ay Skew on axis y
 * @returns {{a: number, b: number, c: number, e: number, d: number, f: number}} Affine matrix
 */
function skewDEG(ax, ay) {
  return skew(ax * Math.PI / 180, ay * Math.PI / 180);
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/smoothMatrix.js":
/*!*********************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/smoothMatrix.js ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   smoothMatrix: function() { return /* binding */ smoothMatrix; }
/* harmony export */ });
/**
 * Rounds all elements of the given matrix using the given precision
 * @param m  {{a: number, b: number, c: number, d: number, e: number, f: number}} a matrix to round
 * @param [precision] a precision to use for Math.round. Defaults to 10000000000 (meaning which rounds to the 10th digit after the comma).
 * @returns {{a: number, b: number, c: number, d: number, e: number, f: number}} the rounded matrix
 */
function smoothMatrix(m) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000000000;

  return {
    a: Math.round(m.a * precision) / precision,
    b: Math.round(m.b * precision) / precision,
    c: Math.round(m.c * precision) / precision,
    d: Math.round(m.d * precision) / precision,
    e: Math.round(m.e * precision) / precision,
    f: Math.round(m.f * precision) / precision
  };
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/toString.js":
/*!*****************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/toString.js ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   toCSS: function() { return /* binding */ toCSS; },
/* harmony export */   toSVG: function() { return /* binding */ toSVG; },
/* harmony export */   toString: function() { return /* binding */ toString; }
/* harmony export */ });
/**
 * Serialize the matrix to a string that can be used with CSS or SVG
 * @param matrix Affine matrix
 * @returns {string} String that contains a matrix formatted as matrix(a,b,c,d,e,f)
 */
function toCSS(matrix) {
  return toString(matrix);
}

/**
 * Serialize the matrix to a string that can be used with CSS or SVG
 * @param matrix Affine matrix
 * @returns {string} String that contains a matrix formatted as matrix(a,b,c,d,e,f)
 */
function toSVG(matrix) {
  return toString(matrix);
}

/**
 * Serialize the matrix to a string that can be used with CSS or SVG
 * @param matrix Affine matrix
 * @returns {string} String that contains a matrix formatted as matrix(a,b,c,d,e,f)
 */
function toString(matrix) {
  return "matrix(" + matrix.a + "," + matrix.b + "," + matrix.c + "," + matrix.d + "," + matrix.e + "," + matrix.f + ")";
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/transform.js":
/*!******************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/transform.js ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   compose: function() { return /* binding */ compose; },
/* harmony export */   transform: function() { return /* binding */ transform; }
/* harmony export */ });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

/**
 * Merge multiple matrices into one
 * @param matrices {...object} list of matrices
 * @returns {{a: number, b: number, c: number, e: number, d: number, f: number}} Affine matrix
 */
function transform() {
  for (var _len = arguments.length, matrices = Array(_len), _key = 0; _key < _len; _key++) {
    matrices[_key] = arguments[_key];
  }

  matrices = Array.isArray(matrices[0]) ? matrices[0] : matrices;

  var multiply = function multiply(m1, m2) {
    return {
      a: m1.a * m2.a + m1.c * m2.b,
      c: m1.a * m2.c + m1.c * m2.d,
      e: m1.a * m2.e + m1.c * m2.f + m1.e,
      b: m1.b * m2.a + m1.d * m2.b,
      d: m1.b * m2.c + m1.d * m2.d,
      f: m1.b * m2.e + m1.d * m2.f + m1.f
    };
  };

  switch (matrices.length) {
    case 0:
      throw new Error('no matrices provided');

    case 1:
      return matrices[0];

    case 2:
      return multiply(matrices[0], matrices[1]);

    default:
      var _matrices = matrices,
          _matrices2 = _toArray(_matrices),
          m1 = _matrices2[0],
          m2 = _matrices2[1],
          rest = _matrices2.slice(2);

      var m = multiply(m1, m2);
      return transform.apply(undefined, [m].concat(_toConsumableArray(rest)));
  }
}

/**
 * Merge multiple matrices into one (alias of `transform`)
 * @param matrices {...object} list of matrices
 * @returns {{a: number, b: number, c: number, e: number, d: number, f: number}} Affine matrix
 */
function compose() {
  return transform.apply(undefined, arguments);
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/translate.js":
/*!******************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/translate.js ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   translate: function() { return /* binding */ translate; }
/* harmony export */ });
/**
 * Calculate a translate matrix
 * @param tx Translation on axis x
 * @param [ty = 0] Translation on axis y
 * @returns {{a: number, b: number, c: number, e: number, d: number, f: number}} Affine matrix
 */
function translate(tx) {
  var ty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  return {
    a: 1,
    c: 0,
    e: tx,
    b: 0,
    d: 1,
    f: ty
  };
}

/***/ }),

/***/ "./node_modules/transformation-matrix/build-es/utils.js":
/*!**************************************************************!*\
  !*** ./node_modules/transformation-matrix/build-es/utils.js ***!
  \**************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   isUndefined: function() { return /* binding */ isUndefined; }
/* harmony export */ });
function isUndefined(val) {
  return typeof val === 'undefined';
}

/***/ }),

/***/ "./node_modules/twgl.js/dist/4.x/twgl-full.module.js":
/*!***********************************************************!*\
  !*** ./node_modules/twgl.js/dist/4.x/twgl-full.module.js ***!
  \***********************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addExtensionsToContext: function() { return /* binding */ addExtensionsToContext; },
/* harmony export */   attributes: function() { return /* binding */ attributes; },
/* harmony export */   bindFramebufferInfo: function() { return /* binding */ bindFramebufferInfo; },
/* harmony export */   bindTransformFeedbackInfo: function() { return /* binding */ bindTransformFeedbackInfo; },
/* harmony export */   bindUniformBlock: function() { return /* binding */ bindUniformBlock; },
/* harmony export */   canFilter: function() { return /* binding */ canFilter; },
/* harmony export */   canGenerateMipmap: function() { return /* binding */ canGenerateMipmap; },
/* harmony export */   createAttribsFromArrays: function() { return /* binding */ createAttribsFromArrays; },
/* harmony export */   createAttributeSetters: function() { return /* binding */ createAttributeSetters; },
/* harmony export */   createBufferFromArray: function() { return /* binding */ createBufferFromArray; },
/* harmony export */   createBufferFromTypedArray: function() { return /* binding */ createBufferFromTypedArray; },
/* harmony export */   createBufferInfoFromArrays: function() { return /* binding */ createBufferInfoFromArrays; },
/* harmony export */   createBuffersFromArrays: function() { return /* binding */ createBuffersFromArrays; },
/* harmony export */   createFramebufferInfo: function() { return /* binding */ createFramebufferInfo; },
/* harmony export */   createProgram: function() { return /* binding */ createProgram; },
/* harmony export */   createProgramAsync: function() { return /* binding */ createProgramAsync; },
/* harmony export */   createProgramFromScripts: function() { return /* binding */ createProgramFromScripts; },
/* harmony export */   createProgramFromSources: function() { return /* binding */ createProgramFromSources; },
/* harmony export */   createProgramInfo: function() { return /* binding */ createProgramInfo; },
/* harmony export */   createProgramInfoAsync: function() { return /* binding */ createProgramInfoAsync; },
/* harmony export */   createProgramInfoFromProgram: function() { return /* binding */ createProgramInfoFromProgram; },
/* harmony export */   createSampler: function() { return /* binding */ createSampler; },
/* harmony export */   createSamplers: function() { return /* binding */ createSamplers; },
/* harmony export */   createTexture: function() { return /* binding */ createTexture; },
/* harmony export */   createTextures: function() { return /* binding */ createTextures; },
/* harmony export */   createTransformFeedback: function() { return /* binding */ createTransformFeedback; },
/* harmony export */   createTransformFeedbackInfo: function() { return /* binding */ createTransformFeedbackInfo; },
/* harmony export */   createUniformBlockInfo: function() { return /* binding */ createUniformBlockInfo; },
/* harmony export */   createUniformBlockInfoFromProgram: function() { return /* binding */ createUniformBlockInfoFromProgram; },
/* harmony export */   createUniformBlockSpecFromProgram: function() { return /* binding */ createUniformBlockSpecFromProgram; },
/* harmony export */   createUniformSetters: function() { return /* binding */ createUniformSetters; },
/* harmony export */   createVAOAndSetAttributes: function() { return /* binding */ createVAOAndSetAttributes; },
/* harmony export */   createVAOFromBufferInfo: function() { return /* binding */ createVAOFromBufferInfo; },
/* harmony export */   createVertexArrayInfo: function() { return /* binding */ createVertexArrayInfo; },
/* harmony export */   draw: function() { return /* binding */ draw; },
/* harmony export */   drawBufferInfo: function() { return /* binding */ drawBufferInfo; },
/* harmony export */   drawObjectList: function() { return /* binding */ drawObjectList; },
/* harmony export */   framebuffers: function() { return /* binding */ framebuffers; },
/* harmony export */   getArray_: function() { return /* binding */ getArray; },
/* harmony export */   getBytesPerElementForInternalFormat: function() { return /* binding */ getBytesPerElementForInternalFormat; },
/* harmony export */   getContext: function() { return /* binding */ getContext; },
/* harmony export */   getFormatAndTypeForInternalFormat: function() { return /* binding */ getFormatAndTypeForInternalFormat; },
/* harmony export */   getGLTypeForTypedArray: function() { return /* binding */ getGLTypeForTypedArray; },
/* harmony export */   getGLTypeForTypedArrayType: function() { return /* binding */ getGLTypeForTypedArrayType; },
/* harmony export */   getNumComponentsForFormat: function() { return /* binding */ getNumComponentsForFormat; },
/* harmony export */   getNumComponents_: function() { return /* binding */ getNumComponents; },
/* harmony export */   getTypedArrayTypeForGLType: function() { return /* binding */ getTypedArrayTypeForGLType; },
/* harmony export */   getWebGLContext: function() { return /* binding */ getWebGLContext; },
/* harmony export */   glEnumToString: function() { return /* binding */ glEnumToString; },
/* harmony export */   isArrayBuffer: function() { return /* binding */ isArrayBuffer; },
/* harmony export */   isWebGL1: function() { return /* binding */ isWebGL1; },
/* harmony export */   isWebGL2: function() { return /* binding */ isWebGL2; },
/* harmony export */   loadTextureFromUrl: function() { return /* binding */ loadTextureFromUrl; },
/* harmony export */   m4: function() { return /* binding */ m4; },
/* harmony export */   primitives: function() { return /* binding */ primitives; },
/* harmony export */   programs: function() { return /* binding */ programs; },
/* harmony export */   resizeCanvasToDisplaySize: function() { return /* binding */ resizeCanvasToDisplaySize; },
/* harmony export */   resizeFramebufferInfo: function() { return /* binding */ resizeFramebufferInfo; },
/* harmony export */   resizeTexture: function() { return /* binding */ resizeTexture; },
/* harmony export */   setAttribInfoBufferFromArray: function() { return /* binding */ setAttribInfoBufferFromArray; },
/* harmony export */   setAttributeDefaults_: function() { return /* binding */ setDefaults; },
/* harmony export */   setAttributePrefix: function() { return /* binding */ setAttributePrefix; },
/* harmony export */   setAttributes: function() { return /* binding */ setAttributes; },
/* harmony export */   setBlockUniforms: function() { return /* binding */ setBlockUniforms; },
/* harmony export */   setBuffersAndAttributes: function() { return /* binding */ setBuffersAndAttributes; },
/* harmony export */   setDefaultTextureColor: function() { return /* binding */ setDefaultTextureColor; },
/* harmony export */   setDefaults: function() { return /* binding */ setDefaults$2; },
/* harmony export */   setEmptyTexture: function() { return /* binding */ setEmptyTexture; },
/* harmony export */   setSamplerParameters: function() { return /* binding */ setSamplerParameters; },
/* harmony export */   setTextureDefaults_: function() { return /* binding */ setDefaults$1; },
/* harmony export */   setTextureFilteringForSize: function() { return /* binding */ setTextureFilteringForSize; },
/* harmony export */   setTextureFromArray: function() { return /* binding */ setTextureFromArray; },
/* harmony export */   setTextureFromElement: function() { return /* binding */ setTextureFromElement; },
/* harmony export */   setTextureParameters: function() { return /* binding */ setTextureParameters; },
/* harmony export */   setUniformBlock: function() { return /* binding */ setUniformBlock; },
/* harmony export */   setUniforms: function() { return /* binding */ setUniforms; },
/* harmony export */   setUniformsAndBindTextures: function() { return /* binding */ setUniformsAndBindTextures; },
/* harmony export */   textures: function() { return /* binding */ textures; },
/* harmony export */   typedarrays: function() { return /* binding */ typedarrays; },
/* harmony export */   utils: function() { return /* binding */ utils; },
/* harmony export */   v3: function() { return /* binding */ v3; },
/* harmony export */   vertexArrays: function() { return /* binding */ vertexArrays; }
/* harmony export */ });
/* @license twgl.js 4.24.0 Copyright (c) 2015, Gregg Tavares All Rights Reserved.
Available via the MIT license.
see: http://github.com/greggman/twgl.js for details */
/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

/**
 *
 * Vec3 math math functions.
 *
 * Almost all functions take an optional `dst` argument. If it is not passed in the
 * functions will create a new Vec3. In other words you can do this
 *
 *     var v = v3.cross(v1, v2);  // Creates a new Vec3 with the cross product of v1 x v2.
 *
 * or
 *
 *     var v = v3.create();
 *     v3.cross(v1, v2, v);  // Puts the cross product of v1 x v2 in v
 *
 * The first style is often easier but depending on where it's used it generates garbage where
 * as there is almost never allocation with the second style.
 *
 * It is always save to pass any vector as the destination. So for example
 *
 *     v3.cross(v1, v2, v1);  // Puts the cross product of v1 x v2 in v1
 *
 * @module twgl/v3
 */

let VecType = Float32Array;

/**
 * A JavaScript array with 3 values or a Float32Array with 3 values.
 * When created by the library will create the default type which is `Float32Array`
 * but can be set by calling {@link module:twgl/v3.setDefaultType}.
 * @typedef {(number[]|Float32Array)} Vec3
 * @memberOf module:twgl/v3
 */

/**
 * Sets the type this library creates for a Vec3
 * @param {constructor} ctor the constructor for the type. Either `Float32Array` or `Array`
 * @return {constructor} previous constructor for Vec3
 * @memberOf module:twgl/v3
 */
function setDefaultType(ctor) {
  const oldType = VecType;
  VecType = ctor;
  return oldType;
}

/**
 * Creates a vec3; may be called with x, y, z to set initial values.
 * @param {number} [x] Initial x value.
 * @param {number} [y] Initial y value.
 * @param {number} [z] Initial z value.
 * @return {module:twgl/v3.Vec3} the created vector
 * @memberOf module:twgl/v3
 */
function create(x, y, z) {
  const dst = new VecType(3);
  if (x) {
    dst[0] = x;
  }
  if (y) {
    dst[1] = y;
  }
  if (z) {
    dst[2] = z;
  }
  return dst;
}

/**
 * Adds two vectors; assumes a and b have the same dimension.
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} A vector tha tis the sum of a and b.
 * @memberOf module:twgl/v3
 */
function add(a, b, dst) {
  dst = dst || new VecType(3);

  dst[0] = a[0] + b[0];
  dst[1] = a[1] + b[1];
  dst[2] = a[2] + b[2];

  return dst;
}

/**
 * Subtracts two vectors.
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} A vector that is the difference of a and b.
 * @memberOf module:twgl/v3
 */
function subtract(a, b, dst) {
  dst = dst || new VecType(3);

  dst[0] = a[0] - b[0];
  dst[1] = a[1] - b[1];
  dst[2] = a[2] - b[2];

  return dst;
}

/**
 * Performs linear interpolation on two vectors.
 * Given vectors a and b and interpolation coefficient t, returns
 * a + t * (b - a).
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {number} t Interpolation coefficient.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The linear interpolated result.
 * @memberOf module:twgl/v3
 */
function lerp(a, b, t, dst) {
  dst = dst || new VecType(3);

  dst[0] = a[0] + t * (b[0] - a[0]);
  dst[1] = a[1] + t * (b[1] - a[1]);
  dst[2] = a[2] + t * (b[2] - a[2]);

  return dst;
}

/**
 * Performs linear interpolation on two vectors.
 * Given vectors a and b and interpolation coefficient vector t, returns
 * a + t * (b - a).
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} t Interpolation coefficients vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} the linear interpolated result.
 * @memberOf module:twgl/v3
 */
function lerpV(a, b, t, dst) {
  dst = dst || new VecType(3);

  dst[0] = a[0] + t[0] * (b[0] - a[0]);
  dst[1] = a[1] + t[1] * (b[1] - a[1]);
  dst[2] = a[2] + t[2] * (b[2] - a[2]);

  return dst;
}

/**
 * Return max values of two vectors.
 * Given vectors a and b returns
 * [max(a[0], b[0]), max(a[1], b[1]), max(a[2], b[2])].
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The max components vector.
 * @memberOf module:twgl/v3
 */
function max(a, b, dst) {
  dst = dst || new VecType(3);

  dst[0] = Math.max(a[0], b[0]);
  dst[1] = Math.max(a[1], b[1]);
  dst[2] = Math.max(a[2], b[2]);

  return dst;
}

/**
 * Return min values of two vectors.
 * Given vectors a and b returns
 * [min(a[0], b[0]), min(a[1], b[1]), min(a[2], b[2])].
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The min components vector.
 * @memberOf module:twgl/v3
 */
function min(a, b, dst) {
  dst = dst || new VecType(3);

  dst[0] = Math.min(a[0], b[0]);
  dst[1] = Math.min(a[1], b[1]);
  dst[2] = Math.min(a[2], b[2]);

  return dst;
}

/**
 * Multiplies a vector by a scalar.
 * @param {module:twgl/v3.Vec3} v The vector.
 * @param {number} k The scalar.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The scaled vector.
 * @memberOf module:twgl/v3
 */
function mulScalar(v, k, dst) {
  dst = dst || new VecType(3);

  dst[0] = v[0] * k;
  dst[1] = v[1] * k;
  dst[2] = v[2] * k;

  return dst;
}

/**
 * Divides a vector by a scalar.
 * @param {module:twgl/v3.Vec3} v The vector.
 * @param {number} k The scalar.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The scaled vector.
 * @memberOf module:twgl/v3
 */
function divScalar(v, k, dst) {
  dst = dst || new VecType(3);

  dst[0] = v[0] / k;
  dst[1] = v[1] / k;
  dst[2] = v[2] / k;

  return dst;
}

/**
 * Computes the cross product of two vectors; assumes both vectors have
 * three entries.
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The vector of a cross b.
 * @memberOf module:twgl/v3
 */
function cross(a, b, dst) {
  dst = dst || new VecType(3);

  const t1 = a[2] * b[0] - a[0] * b[2];
  const t2 = a[0] * b[1] - a[1] * b[0];
  dst[0] = a[1] * b[2] - a[2] * b[1];
  dst[1] = t1;
  dst[2] = t2;

  return dst;
}

/**
 * Computes the dot product of two vectors; assumes both vectors have
 * three entries.
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @return {number} dot product
 * @memberOf module:twgl/v3
 */
function dot(a, b) {
  return (a[0] * b[0]) + (a[1] * b[1]) + (a[2] * b[2]);
}

/**
 * Computes the length of vector
 * @param {module:twgl/v3.Vec3} v vector.
 * @return {number} length of vector.
 * @memberOf module:twgl/v3
 */
function length$1(v) {
  return Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2]);
}

/**
 * Computes the square of the length of vector
 * @param {module:twgl/v3.Vec3} v vector.
 * @return {number} square of the length of vector.
 * @memberOf module:twgl/v3
 */
function lengthSq(v) {
  return v[0] * v[0] + v[1] * v[1] + v[2] * v[2];
}

/**
 * Computes the distance between 2 points
 * @param {module:twgl/v3.Vec3} a vector.
 * @param {module:twgl/v3.Vec3} b vector.
 * @return {number} distance between a and b
 * @memberOf module:twgl/v3
 */
function distance(a, b) {
  const dx = a[0] - b[0];
  const dy = a[1] - b[1];
  const dz = a[2] - b[2];
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
}

/**
 * Computes the square of the distance between 2 points
 * @param {module:twgl/v3.Vec3} a vector.
 * @param {module:twgl/v3.Vec3} b vector.
 * @return {number} square of the distance between a and b
 * @memberOf module:twgl/v3
 */
function distanceSq(a, b) {
  const dx = a[0] - b[0];
  const dy = a[1] - b[1];
  const dz = a[2] - b[2];
  return dx * dx + dy * dy + dz * dz;
}

/**
 * Divides a vector by its Euclidean length and returns the quotient.
 * @param {module:twgl/v3.Vec3} a The vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The normalized vector.
 * @memberOf module:twgl/v3
 */
function normalize(a, dst) {
  dst = dst || new VecType(3);

  const lenSq = a[0] * a[0] + a[1] * a[1] + a[2] * a[2];
  const len = Math.sqrt(lenSq);
  if (len > 0.00001) {
    dst[0] = a[0] / len;
    dst[1] = a[1] / len;
    dst[2] = a[2] / len;
  } else {
    dst[0] = 0;
    dst[1] = 0;
    dst[2] = 0;
  }

  return dst;
}

/**
 * Negates a vector.
 * @param {module:twgl/v3.Vec3} v The vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} -v.
 * @memberOf module:twgl/v3
 */
function negate(v, dst) {
  dst = dst || new VecType(3);

  dst[0] = -v[0];
  dst[1] = -v[1];
  dst[2] = -v[2];

  return dst;
}

/**
 * Copies a vector.
 * @param {module:twgl/v3.Vec3} v The vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} A copy of v.
 * @memberOf module:twgl/v3
 */
function copy(v, dst) {
  dst = dst || new VecType(3);

  dst[0] = v[0];
  dst[1] = v[1];
  dst[2] = v[2];

  return dst;
}

/**
 * Multiplies a vector by another vector (component-wise); assumes a and
 * b have the same length.
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The vector of products of entries of a and
 *     b.
 * @memberOf module:twgl/v3
 */
function multiply(a, b, dst) {
  dst = dst || new VecType(3);

  dst[0] = a[0] * b[0];
  dst[1] = a[1] * b[1];
  dst[2] = a[2] * b[2];

  return dst;
}

/**
 * Divides a vector by another vector (component-wise); assumes a and
 * b have the same length.
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The vector of quotients of entries of a and
 *     b.
 * @memberOf module:twgl/v3
 */
function divide(a, b, dst) {
  dst = dst || new VecType(3);

  dst[0] = a[0] / b[0];
  dst[1] = a[1] / b[1];
  dst[2] = a[2] / b[2];

  return dst;
}

var v3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  add: add,
  copy: copy,
  create: create,
  cross: cross,
  distance: distance,
  distanceSq: distanceSq,
  divide: divide,
  divScalar: divScalar,
  dot: dot,
  lerp: lerp,
  lerpV: lerpV,
  length: length$1,
  lengthSq: lengthSq,
  max: max,
  min: min,
  mulScalar: mulScalar,
  multiply: multiply,
  negate: negate,
  normalize: normalize,
  setDefaultType: setDefaultType,
  subtract: subtract
});

/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

/**
 * 4x4 Matrix math math functions.
 *
 * Almost all functions take an optional `dst` argument. If it is not passed in the
 * functions will create a new matrix. In other words you can do this
 *
 *     const mat = m4.translation([1, 2, 3]);  // Creates a new translation matrix
 *
 * or
 *
 *     const mat = m4.create();
 *     m4.translation([1, 2, 3], mat);  // Puts translation matrix in mat.
 *
 * The first style is often easier but depending on where it's used it generates garbage where
 * as there is almost never allocation with the second style.
 *
 * It is always save to pass any matrix as the destination. So for example
 *
 *     const mat = m4.identity();
 *     const trans = m4.translation([1, 2, 3]);
 *     m4.multiply(mat, trans, mat);  // Multiplies mat * trans and puts result in mat.
 *
 * @module twgl/m4
 */
let MatType = Float32Array;

/**
 * A JavaScript array with 16 values or a Float32Array with 16 values.
 * When created by the library will create the default type which is `Float32Array`
 * but can be set by calling {@link module:twgl/m4.setDefaultType}.
 * @typedef {(number[]|Float32Array)} Mat4
 * @memberOf module:twgl/m4
 */

/**
 * Sets the type this library creates for a Mat4
 * @param {constructor} ctor the constructor for the type. Either `Float32Array` or `Array`
 * @return {constructor} previous constructor for Mat4
 * @memberOf module:twgl/m4
 */
function setDefaultType$1(ctor) {
  const oldType = MatType;
  MatType = ctor;
  return oldType;
}

/**
 * Negates a matrix.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} -m.
 * @memberOf module:twgl/m4
 */
function negate$1(m, dst) {
  dst = dst || new MatType(16);

  dst[ 0] = -m[ 0];
  dst[ 1] = -m[ 1];
  dst[ 2] = -m[ 2];
  dst[ 3] = -m[ 3];
  dst[ 4] = -m[ 4];
  dst[ 5] = -m[ 5];
  dst[ 6] = -m[ 6];
  dst[ 7] = -m[ 7];
  dst[ 8] = -m[ 8];
  dst[ 9] = -m[ 9];
  dst[10] = -m[10];
  dst[11] = -m[11];
  dst[12] = -m[12];
  dst[13] = -m[13];
  dst[14] = -m[14];
  dst[15] = -m[15];

  return dst;
}

/**
 * Creates a matrix.
 * @return {module:twgl/m4.Mat4} A new matrix.
 * @memberOf module:twgl/m4
 */
function create$1() {
  return new MatType(16).fill(0);
}

/**
 * Copies a matrix.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/m4.Mat4} [dst] The matrix. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} A copy of m.
 * @memberOf module:twgl/m4
 */
function copy$1(m, dst) {
  dst = dst || new MatType(16);

  dst[ 0] = m[ 0];
  dst[ 1] = m[ 1];
  dst[ 2] = m[ 2];
  dst[ 3] = m[ 3];
  dst[ 4] = m[ 4];
  dst[ 5] = m[ 5];
  dst[ 6] = m[ 6];
  dst[ 7] = m[ 7];
  dst[ 8] = m[ 8];
  dst[ 9] = m[ 9];
  dst[10] = m[10];
  dst[11] = m[11];
  dst[12] = m[12];
  dst[13] = m[13];
  dst[14] = m[14];
  dst[15] = m[15];

  return dst;
}

/**
 * Creates an n-by-n identity matrix.
 *
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} An n-by-n identity matrix.
 * @memberOf module:twgl/m4
 */
function identity(dst) {
  dst = dst || new MatType(16);

  dst[ 0] = 1;
  dst[ 1] = 0;
  dst[ 2] = 0;
  dst[ 3] = 0;
  dst[ 4] = 0;
  dst[ 5] = 1;
  dst[ 6] = 0;
  dst[ 7] = 0;
  dst[ 8] = 0;
  dst[ 9] = 0;
  dst[10] = 1;
  dst[11] = 0;
  dst[12] = 0;
  dst[13] = 0;
  dst[14] = 0;
  dst[15] = 1;

  return dst;
}

/**
 * Takes the transpose of a matrix.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The transpose of m.
 * @memberOf module:twgl/m4
 */
 function transpose(m, dst) {
  dst = dst || new MatType(16);
  if (dst === m) {
    let t;

    t = m[1];
    m[1] = m[4];
    m[4] = t;

    t = m[2];
    m[2] = m[8];
    m[8] = t;

    t = m[3];
    m[3] = m[12];
    m[12] = t;

    t = m[6];
    m[6] = m[9];
    m[9] = t;

    t = m[7];
    m[7] = m[13];
    m[13] = t;

    t = m[11];
    m[11] = m[14];
    m[14] = t;
    return dst;
  }

  const m00 = m[0 * 4 + 0];
  const m01 = m[0 * 4 + 1];
  const m02 = m[0 * 4 + 2];
  const m03 = m[0 * 4 + 3];
  const m10 = m[1 * 4 + 0];
  const m11 = m[1 * 4 + 1];
  const m12 = m[1 * 4 + 2];
  const m13 = m[1 * 4 + 3];
  const m20 = m[2 * 4 + 0];
  const m21 = m[2 * 4 + 1];
  const m22 = m[2 * 4 + 2];
  const m23 = m[2 * 4 + 3];
  const m30 = m[3 * 4 + 0];
  const m31 = m[3 * 4 + 1];
  const m32 = m[3 * 4 + 2];
  const m33 = m[3 * 4 + 3];

  dst[ 0] = m00;
  dst[ 1] = m10;
  dst[ 2] = m20;
  dst[ 3] = m30;
  dst[ 4] = m01;
  dst[ 5] = m11;
  dst[ 6] = m21;
  dst[ 7] = m31;
  dst[ 8] = m02;
  dst[ 9] = m12;
  dst[10] = m22;
  dst[11] = m32;
  dst[12] = m03;
  dst[13] = m13;
  dst[14] = m23;
  dst[15] = m33;

  return dst;
}

/**
 * Computes the inverse of a 4-by-4 matrix.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The inverse of m.
 * @memberOf module:twgl/m4
 */
function inverse(m, dst) {
  dst = dst || new MatType(16);

  const m00 = m[0 * 4 + 0];
  const m01 = m[0 * 4 + 1];
  const m02 = m[0 * 4 + 2];
  const m03 = m[0 * 4 + 3];
  const m10 = m[1 * 4 + 0];
  const m11 = m[1 * 4 + 1];
  const m12 = m[1 * 4 + 2];
  const m13 = m[1 * 4 + 3];
  const m20 = m[2 * 4 + 0];
  const m21 = m[2 * 4 + 1];
  const m22 = m[2 * 4 + 2];
  const m23 = m[2 * 4 + 3];
  const m30 = m[3 * 4 + 0];
  const m31 = m[3 * 4 + 1];
  const m32 = m[3 * 4 + 2];
  const m33 = m[3 * 4 + 3];
  const tmp_0  = m22 * m33;
  const tmp_1  = m32 * m23;
  const tmp_2  = m12 * m33;
  const tmp_3  = m32 * m13;
  const tmp_4  = m12 * m23;
  const tmp_5  = m22 * m13;
  const tmp_6  = m02 * m33;
  const tmp_7  = m32 * m03;
  const tmp_8  = m02 * m23;
  const tmp_9  = m22 * m03;
  const tmp_10 = m02 * m13;
  const tmp_11 = m12 * m03;
  const tmp_12 = m20 * m31;
  const tmp_13 = m30 * m21;
  const tmp_14 = m10 * m31;
  const tmp_15 = m30 * m11;
  const tmp_16 = m10 * m21;
  const tmp_17 = m20 * m11;
  const tmp_18 = m00 * m31;
  const tmp_19 = m30 * m01;
  const tmp_20 = m00 * m21;
  const tmp_21 = m20 * m01;
  const tmp_22 = m00 * m11;
  const tmp_23 = m10 * m01;

  const t0 = (tmp_0 * m11 + tmp_3 * m21 + tmp_4 * m31) -
      (tmp_1 * m11 + tmp_2 * m21 + tmp_5 * m31);
  const t1 = (tmp_1 * m01 + tmp_6 * m21 + tmp_9 * m31) -
      (tmp_0 * m01 + tmp_7 * m21 + tmp_8 * m31);
  const t2 = (tmp_2 * m01 + tmp_7 * m11 + tmp_10 * m31) -
      (tmp_3 * m01 + tmp_6 * m11 + tmp_11 * m31);
  const t3 = (tmp_5 * m01 + tmp_8 * m11 + tmp_11 * m21) -
      (tmp_4 * m01 + tmp_9 * m11 + tmp_10 * m21);

  const d = 1.0 / (m00 * t0 + m10 * t1 + m20 * t2 + m30 * t3);

  dst[ 0] = d * t0;
  dst[ 1] = d * t1;
  dst[ 2] = d * t2;
  dst[ 3] = d * t3;
  dst[ 4] = d * ((tmp_1 * m10 + tmp_2 * m20 + tmp_5 * m30) -
          (tmp_0 * m10 + tmp_3 * m20 + tmp_4 * m30));
  dst[ 5] = d * ((tmp_0 * m00 + tmp_7 * m20 + tmp_8 * m30) -
          (tmp_1 * m00 + tmp_6 * m20 + tmp_9 * m30));
  dst[ 6] = d * ((tmp_3 * m00 + tmp_6 * m10 + tmp_11 * m30) -
          (tmp_2 * m00 + tmp_7 * m10 + tmp_10 * m30));
  dst[ 7] = d * ((tmp_4 * m00 + tmp_9 * m10 + tmp_10 * m20) -
          (tmp_5 * m00 + tmp_8 * m10 + tmp_11 * m20));
  dst[ 8] = d * ((tmp_12 * m13 + tmp_15 * m23 + tmp_16 * m33) -
          (tmp_13 * m13 + tmp_14 * m23 + tmp_17 * m33));
  dst[ 9] = d * ((tmp_13 * m03 + tmp_18 * m23 + tmp_21 * m33) -
          (tmp_12 * m03 + tmp_19 * m23 + tmp_20 * m33));
  dst[10] = d * ((tmp_14 * m03 + tmp_19 * m13 + tmp_22 * m33) -
          (tmp_15 * m03 + tmp_18 * m13 + tmp_23 * m33));
  dst[11] = d * ((tmp_17 * m03 + tmp_20 * m13 + tmp_23 * m23) -
          (tmp_16 * m03 + tmp_21 * m13 + tmp_22 * m23));
  dst[12] = d * ((tmp_14 * m22 + tmp_17 * m32 + tmp_13 * m12) -
          (tmp_16 * m32 + tmp_12 * m12 + tmp_15 * m22));
  dst[13] = d * ((tmp_20 * m32 + tmp_12 * m02 + tmp_19 * m22) -
          (tmp_18 * m22 + tmp_21 * m32 + tmp_13 * m02));
  dst[14] = d * ((tmp_18 * m12 + tmp_23 * m32 + tmp_15 * m02) -
          (tmp_22 * m32 + tmp_14 * m02 + tmp_19 * m12));
  dst[15] = d * ((tmp_22 * m22 + tmp_16 * m02 + tmp_21 * m12) -
          (tmp_20 * m12 + tmp_23 * m22 + tmp_17 * m02));

  return dst;
}

/**
 * Multiplies two 4-by-4 matrices with a on the left and b on the right
 * @param {module:twgl/m4.Mat4} a The matrix on the left.
 * @param {module:twgl/m4.Mat4} b The matrix on the right.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The matrix product of a and b.
 * @memberOf module:twgl/m4
 */
function multiply$1(a, b, dst) {
  dst = dst || new MatType(16);

  const a00 = a[0];
  const a01 = a[1];
  const a02 = a[2];
  const a03 = a[3];
  const a10 = a[ 4 + 0];
  const a11 = a[ 4 + 1];
  const a12 = a[ 4 + 2];
  const a13 = a[ 4 + 3];
  const a20 = a[ 8 + 0];
  const a21 = a[ 8 + 1];
  const a22 = a[ 8 + 2];
  const a23 = a[ 8 + 3];
  const a30 = a[12 + 0];
  const a31 = a[12 + 1];
  const a32 = a[12 + 2];
  const a33 = a[12 + 3];
  const b00 = b[0];
  const b01 = b[1];
  const b02 = b[2];
  const b03 = b[3];
  const b10 = b[ 4 + 0];
  const b11 = b[ 4 + 1];
  const b12 = b[ 4 + 2];
  const b13 = b[ 4 + 3];
  const b20 = b[ 8 + 0];
  const b21 = b[ 8 + 1];
  const b22 = b[ 8 + 2];
  const b23 = b[ 8 + 3];
  const b30 = b[12 + 0];
  const b31 = b[12 + 1];
  const b32 = b[12 + 2];
  const b33 = b[12 + 3];

  dst[ 0] = a00 * b00 + a10 * b01 + a20 * b02 + a30 * b03;
  dst[ 1] = a01 * b00 + a11 * b01 + a21 * b02 + a31 * b03;
  dst[ 2] = a02 * b00 + a12 * b01 + a22 * b02 + a32 * b03;
  dst[ 3] = a03 * b00 + a13 * b01 + a23 * b02 + a33 * b03;
  dst[ 4] = a00 * b10 + a10 * b11 + a20 * b12 + a30 * b13;
  dst[ 5] = a01 * b10 + a11 * b11 + a21 * b12 + a31 * b13;
  dst[ 6] = a02 * b10 + a12 * b11 + a22 * b12 + a32 * b13;
  dst[ 7] = a03 * b10 + a13 * b11 + a23 * b12 + a33 * b13;
  dst[ 8] = a00 * b20 + a10 * b21 + a20 * b22 + a30 * b23;
  dst[ 9] = a01 * b20 + a11 * b21 + a21 * b22 + a31 * b23;
  dst[10] = a02 * b20 + a12 * b21 + a22 * b22 + a32 * b23;
  dst[11] = a03 * b20 + a13 * b21 + a23 * b22 + a33 * b23;
  dst[12] = a00 * b30 + a10 * b31 + a20 * b32 + a30 * b33;
  dst[13] = a01 * b30 + a11 * b31 + a21 * b32 + a31 * b33;
  dst[14] = a02 * b30 + a12 * b31 + a22 * b32 + a32 * b33;
  dst[15] = a03 * b30 + a13 * b31 + a23 * b32 + a33 * b33;

  return dst;
}

/**
 * Sets the translation component of a 4-by-4 matrix to the given
 * vector.
 * @param {module:twgl/m4.Mat4} a The matrix.
 * @param {module:twgl/v3.Vec3} v The vector.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The matrix with translation set.
 * @memberOf module:twgl/m4
 */
function setTranslation(a, v, dst) {
  dst = dst || identity();
  if (a !== dst) {
    dst[ 0] = a[ 0];
    dst[ 1] = a[ 1];
    dst[ 2] = a[ 2];
    dst[ 3] = a[ 3];
    dst[ 4] = a[ 4];
    dst[ 5] = a[ 5];
    dst[ 6] = a[ 6];
    dst[ 7] = a[ 7];
    dst[ 8] = a[ 8];
    dst[ 9] = a[ 9];
    dst[10] = a[10];
    dst[11] = a[11];
  }
  dst[12] = v[0];
  dst[13] = v[1];
  dst[14] = v[2];
  dst[15] = 1;
  return dst;
}

/**
 * Returns the translation component of a 4-by-4 matrix as a vector with 3
 * entries.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not passed a new one is created.
 * @return {module:twgl/v3.Vec3} The translation component of m.
 * @memberOf module:twgl/m4
 */
function getTranslation(m, dst) {
  dst = dst || create();
  dst[0] = m[12];
  dst[1] = m[13];
  dst[2] = m[14];
  return dst;
}

/**
 * Returns an axis of a 4x4 matrix as a vector with 3 entries
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {number} axis The axis 0 = x, 1 = y, 2 = z;
 * @return {module:twgl/v3.Vec3} [dst] vector.
 * @return {module:twgl/v3.Vec3} The axis component of m.
 * @memberOf module:twgl/m4
 */
function getAxis(m, axis, dst) {
  dst = dst || create();
  const off = axis * 4;
  dst[0] = m[off + 0];
  dst[1] = m[off + 1];
  dst[2] = m[off + 2];
  return dst;
}

/**
 * Sets an axis of a 4x4 matrix as a vector with 3 entries
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} v the axis vector
 * @param {number} axis The axis  0 = x, 1 = y, 2 = z;
 * @param {module:twgl/m4.Mat4} [dst] The matrix to set. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The matrix with axis set.
 * @memberOf module:twgl/m4
 */
function setAxis(a, v, axis, dst) {
  if (dst !== a) {
    dst = copy$1(a, dst);
  }
  const off = axis * 4;
  dst[off + 0] = v[0];
  dst[off + 1] = v[1];
  dst[off + 2] = v[2];
  return dst;
}

/**
 * Computes a 4-by-4 perspective transformation matrix given the angular height
 * of the frustum, the aspect ratio, and the near and far clipping planes.  The
 * arguments define a frustum extending in the negative z direction.  The given
 * angle is the vertical angle of the frustum, and the horizontal angle is
 * determined to produce the given aspect ratio.  The arguments near and far are
 * the distances to the near and far clipping planes.  Note that near and far
 * are not z coordinates, but rather they are distances along the negative
 * z-axis.  The matrix generated sends the viewing frustum to the unit box.
 * We assume a unit box extending from -1 to 1 in the x and y dimensions and
 * from 0 to 1 in the z dimension.
 * @param {number} fieldOfViewYInRadians The camera angle from top to bottom (in radians).
 * @param {number} aspect The aspect ratio width / height.
 * @param {number} zNear The depth (negative z coordinate)
 *     of the near clipping plane.
 * @param {number} zFar The depth (negative z coordinate)
 *     of the far clipping plane.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The perspective matrix.
 * @memberOf module:twgl/m4
 */
function perspective(fieldOfViewYInRadians, aspect, zNear, zFar, dst) {
  dst = dst || new MatType(16);

  const f = Math.tan(Math.PI * 0.5 - 0.5 * fieldOfViewYInRadians);
  const rangeInv = 1.0 / (zNear - zFar);

  dst[0]  = f / aspect;
  dst[1]  = 0;
  dst[2]  = 0;
  dst[3]  = 0;

  dst[4]  = 0;
  dst[5]  = f;
  dst[6]  = 0;
  dst[7]  = 0;

  dst[8]  = 0;
  dst[9]  = 0;
  dst[10] = (zNear + zFar) * rangeInv;
  dst[11] = -1;

  dst[12] = 0;
  dst[13] = 0;
  dst[14] = zNear * zFar * rangeInv * 2;
  dst[15] = 0;

  return dst;
}

/**
 * Computes a 4-by-4 orthogonal transformation matrix given the left, right,
 * bottom, and top dimensions of the near clipping plane as well as the
 * near and far clipping plane distances.
 * @param {number} left Left side of the near clipping plane viewport.
 * @param {number} right Right side of the near clipping plane viewport.
 * @param {number} bottom Bottom of the near clipping plane viewport.
 * @param {number} top Top of the near clipping plane viewport.
 * @param {number} near The depth (negative z coordinate)
 *     of the near clipping plane.
 * @param {number} far The depth (negative z coordinate)
 *     of the far clipping plane.
 * @param {module:twgl/m4.Mat4} [dst] Output matrix. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The perspective matrix.
 * @memberOf module:twgl/m4
 */
function ortho(left, right, bottom, top, near, far, dst) {
  dst = dst || new MatType(16);

  dst[0]  = 2 / (right - left);
  dst[1]  = 0;
  dst[2]  = 0;
  dst[3]  = 0;

  dst[4]  = 0;
  dst[5]  = 2 / (top - bottom);
  dst[6]  = 0;
  dst[7]  = 0;

  dst[8]  = 0;
  dst[9]  = 0;
  dst[10] = 2 / (near - far);
  dst[11] = 0;

  dst[12] = (right + left) / (left - right);
  dst[13] = (top + bottom) / (bottom - top);
  dst[14] = (far + near) / (near - far);
  dst[15] = 1;

  return dst;
}

/**
 * Computes a 4-by-4 perspective transformation matrix given the left, right,
 * top, bottom, near and far clipping planes. The arguments define a frustum
 * extending in the negative z direction. The arguments near and far are the
 * distances to the near and far clipping planes. Note that near and far are not
 * z coordinates, but rather they are distances along the negative z-axis. The
 * matrix generated sends the viewing frustum to the unit box. We assume a unit
 * box extending from -1 to 1 in the x and y dimensions and from 0 to 1 in the z
 * dimension.
 * @param {number} left The x coordinate of the left plane of the box.
 * @param {number} right The x coordinate of the right plane of the box.
 * @param {number} bottom The y coordinate of the bottom plane of the box.
 * @param {number} top The y coordinate of the right plane of the box.
 * @param {number} near The negative z coordinate of the near plane of the box.
 * @param {number} far The negative z coordinate of the far plane of the box.
 * @param {module:twgl/m4.Mat4} [dst] Output matrix. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The perspective projection matrix.
 * @memberOf module:twgl/m4
 */
function frustum(left, right, bottom, top, near, far, dst) {
  dst = dst || new MatType(16);

  const dx = (right - left);
  const dy = (top - bottom);
  const dz = (near - far);

  dst[ 0] = 2 * near / dx;
  dst[ 1] = 0;
  dst[ 2] = 0;
  dst[ 3] = 0;
  dst[ 4] = 0;
  dst[ 5] = 2 * near / dy;
  dst[ 6] = 0;
  dst[ 7] = 0;
  dst[ 8] = (left + right) / dx;
  dst[ 9] = (top + bottom) / dy;
  dst[10] = far / dz;
  dst[11] = -1;
  dst[12] = 0;
  dst[13] = 0;
  dst[14] = near * far / dz;
  dst[15] = 0;

  return dst;
}

let xAxis;
let yAxis;
let zAxis;

/**
 * Computes a 4-by-4 look-at transformation.
 *
 * This is a matrix which positions the camera itself. If you want
 * a view matrix (a matrix which moves things in front of the camera)
 * take the inverse of this.
 *
 * @param {module:twgl/v3.Vec3} eye The position of the eye.
 * @param {module:twgl/v3.Vec3} target The position meant to be viewed.
 * @param {module:twgl/v3.Vec3} up A vector pointing up.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The look-at matrix.
 * @memberOf module:twgl/m4
 */
function lookAt(eye, target, up, dst) {
  dst = dst || new MatType(16);

  xAxis = xAxis || create();
  yAxis = yAxis || create();
  zAxis = zAxis || create();

  normalize(
      subtract(eye, target, zAxis), zAxis);
  normalize(cross(up, zAxis, xAxis), xAxis);
  normalize(cross(zAxis, xAxis, yAxis), yAxis);

  dst[ 0] = xAxis[0];
  dst[ 1] = xAxis[1];
  dst[ 2] = xAxis[2];
  dst[ 3] = 0;
  dst[ 4] = yAxis[0];
  dst[ 5] = yAxis[1];
  dst[ 6] = yAxis[2];
  dst[ 7] = 0;
  dst[ 8] = zAxis[0];
  dst[ 9] = zAxis[1];
  dst[10] = zAxis[2];
  dst[11] = 0;
  dst[12] = eye[0];
  dst[13] = eye[1];
  dst[14] = eye[2];
  dst[15] = 1;

  return dst;
}

/**
 * Creates a 4-by-4 matrix which translates by the given vector v.
 * @param {module:twgl/v3.Vec3} v The vector by
 *     which to translate.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The translation matrix.
 * @memberOf module:twgl/m4
 */
function translation(v, dst) {
  dst = dst || new MatType(16);

  dst[ 0] = 1;
  dst[ 1] = 0;
  dst[ 2] = 0;
  dst[ 3] = 0;
  dst[ 4] = 0;
  dst[ 5] = 1;
  dst[ 6] = 0;
  dst[ 7] = 0;
  dst[ 8] = 0;
  dst[ 9] = 0;
  dst[10] = 1;
  dst[11] = 0;
  dst[12] = v[0];
  dst[13] = v[1];
  dst[14] = v[2];
  dst[15] = 1;
  return dst;
}

/**
 * Translates the given 4-by-4 matrix by the given vector v.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} v The vector by
 *     which to translate.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The translated matrix.
 * @memberOf module:twgl/m4
 */
function translate(m, v, dst) {
  dst = dst || new MatType(16);

  const v0 = v[0];
  const v1 = v[1];
  const v2 = v[2];
  const m00 = m[0];
  const m01 = m[1];
  const m02 = m[2];
  const m03 = m[3];
  const m10 = m[1 * 4 + 0];
  const m11 = m[1 * 4 + 1];
  const m12 = m[1 * 4 + 2];
  const m13 = m[1 * 4 + 3];
  const m20 = m[2 * 4 + 0];
  const m21 = m[2 * 4 + 1];
  const m22 = m[2 * 4 + 2];
  const m23 = m[2 * 4 + 3];
  const m30 = m[3 * 4 + 0];
  const m31 = m[3 * 4 + 1];
  const m32 = m[3 * 4 + 2];
  const m33 = m[3 * 4 + 3];

  if (m !== dst) {
    dst[ 0] = m00;
    dst[ 1] = m01;
    dst[ 2] = m02;
    dst[ 3] = m03;
    dst[ 4] = m10;
    dst[ 5] = m11;
    dst[ 6] = m12;
    dst[ 7] = m13;
    dst[ 8] = m20;
    dst[ 9] = m21;
    dst[10] = m22;
    dst[11] = m23;
  }

  dst[12] = m00 * v0 + m10 * v1 + m20 * v2 + m30;
  dst[13] = m01 * v0 + m11 * v1 + m21 * v2 + m31;
  dst[14] = m02 * v0 + m12 * v1 + m22 * v2 + m32;
  dst[15] = m03 * v0 + m13 * v1 + m23 * v2 + m33;

  return dst;
}

/**
 * Creates a 4-by-4 matrix which rotates around the x-axis by the given angle.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotation matrix.
 * @memberOf module:twgl/m4
 */
function rotationX(angleInRadians, dst) {
  dst = dst || new MatType(16);

  const c = Math.cos(angleInRadians);
  const s = Math.sin(angleInRadians);

  dst[ 0] = 1;
  dst[ 1] = 0;
  dst[ 2] = 0;
  dst[ 3] = 0;
  dst[ 4] = 0;
  dst[ 5] = c;
  dst[ 6] = s;
  dst[ 7] = 0;
  dst[ 8] = 0;
  dst[ 9] = -s;
  dst[10] = c;
  dst[11] = 0;
  dst[12] = 0;
  dst[13] = 0;
  dst[14] = 0;
  dst[15] = 1;

  return dst;
}

/**
 * Rotates the given 4-by-4 matrix around the x-axis by the given
 * angle.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotated matrix.
 * @memberOf module:twgl/m4
 */
function rotateX(m, angleInRadians, dst) {
  dst = dst || new MatType(16);

  const m10 = m[4];
  const m11 = m[5];
  const m12 = m[6];
  const m13 = m[7];
  const m20 = m[8];
  const m21 = m[9];
  const m22 = m[10];
  const m23 = m[11];
  const c = Math.cos(angleInRadians);
  const s = Math.sin(angleInRadians);

  dst[4]  = c * m10 + s * m20;
  dst[5]  = c * m11 + s * m21;
  dst[6]  = c * m12 + s * m22;
  dst[7]  = c * m13 + s * m23;
  dst[8]  = c * m20 - s * m10;
  dst[9]  = c * m21 - s * m11;
  dst[10] = c * m22 - s * m12;
  dst[11] = c * m23 - s * m13;

  if (m !== dst) {
    dst[ 0] = m[ 0];
    dst[ 1] = m[ 1];
    dst[ 2] = m[ 2];
    dst[ 3] = m[ 3];
    dst[12] = m[12];
    dst[13] = m[13];
    dst[14] = m[14];
    dst[15] = m[15];
  }

  return dst;
}

/**
 * Creates a 4-by-4 matrix which rotates around the y-axis by the given angle.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotation matrix.
 * @memberOf module:twgl/m4
 */
function rotationY(angleInRadians, dst) {
  dst = dst || new MatType(16);

  const c = Math.cos(angleInRadians);
  const s = Math.sin(angleInRadians);

  dst[ 0] = c;
  dst[ 1] = 0;
  dst[ 2] = -s;
  dst[ 3] = 0;
  dst[ 4] = 0;
  dst[ 5] = 1;
  dst[ 6] = 0;
  dst[ 7] = 0;
  dst[ 8] = s;
  dst[ 9] = 0;
  dst[10] = c;
  dst[11] = 0;
  dst[12] = 0;
  dst[13] = 0;
  dst[14] = 0;
  dst[15] = 1;

  return dst;
}

/**
 * Rotates the given 4-by-4 matrix around the y-axis by the given
 * angle.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotated matrix.
 * @memberOf module:twgl/m4
 */
function rotateY(m, angleInRadians, dst) {
  dst = dst || new MatType(16);

  const m00 = m[0 * 4 + 0];
  const m01 = m[0 * 4 + 1];
  const m02 = m[0 * 4 + 2];
  const m03 = m[0 * 4 + 3];
  const m20 = m[2 * 4 + 0];
  const m21 = m[2 * 4 + 1];
  const m22 = m[2 * 4 + 2];
  const m23 = m[2 * 4 + 3];
  const c = Math.cos(angleInRadians);
  const s = Math.sin(angleInRadians);

  dst[ 0] = c * m00 - s * m20;
  dst[ 1] = c * m01 - s * m21;
  dst[ 2] = c * m02 - s * m22;
  dst[ 3] = c * m03 - s * m23;
  dst[ 8] = c * m20 + s * m00;
  dst[ 9] = c * m21 + s * m01;
  dst[10] = c * m22 + s * m02;
  dst[11] = c * m23 + s * m03;

  if (m !== dst) {
    dst[ 4] = m[ 4];
    dst[ 5] = m[ 5];
    dst[ 6] = m[ 6];
    dst[ 7] = m[ 7];
    dst[12] = m[12];
    dst[13] = m[13];
    dst[14] = m[14];
    dst[15] = m[15];
  }

  return dst;
}

/**
 * Creates a 4-by-4 matrix which rotates around the z-axis by the given angle.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotation matrix.
 * @memberOf module:twgl/m4
 */
function rotationZ(angleInRadians, dst) {
  dst = dst || new MatType(16);

  const c = Math.cos(angleInRadians);
  const s = Math.sin(angleInRadians);

  dst[ 0] = c;
  dst[ 1] = s;
  dst[ 2] = 0;
  dst[ 3] = 0;
  dst[ 4] = -s;
  dst[ 5] = c;
  dst[ 6] = 0;
  dst[ 7] = 0;
  dst[ 8] = 0;
  dst[ 9] = 0;
  dst[10] = 1;
  dst[11] = 0;
  dst[12] = 0;
  dst[13] = 0;
  dst[14] = 0;
  dst[15] = 1;

  return dst;
}

/**
 * Rotates the given 4-by-4 matrix around the z-axis by the given
 * angle.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotated matrix.
 * @memberOf module:twgl/m4
 */
function rotateZ(m, angleInRadians, dst) {
  dst = dst || new MatType(16);

  const m00 = m[0 * 4 + 0];
  const m01 = m[0 * 4 + 1];
  const m02 = m[0 * 4 + 2];
  const m03 = m[0 * 4 + 3];
  const m10 = m[1 * 4 + 0];
  const m11 = m[1 * 4 + 1];
  const m12 = m[1 * 4 + 2];
  const m13 = m[1 * 4 + 3];
  const c = Math.cos(angleInRadians);
  const s = Math.sin(angleInRadians);

  dst[ 0] = c * m00 + s * m10;
  dst[ 1] = c * m01 + s * m11;
  dst[ 2] = c * m02 + s * m12;
  dst[ 3] = c * m03 + s * m13;
  dst[ 4] = c * m10 - s * m00;
  dst[ 5] = c * m11 - s * m01;
  dst[ 6] = c * m12 - s * m02;
  dst[ 7] = c * m13 - s * m03;

  if (m !== dst) {
    dst[ 8] = m[ 8];
    dst[ 9] = m[ 9];
    dst[10] = m[10];
    dst[11] = m[11];
    dst[12] = m[12];
    dst[13] = m[13];
    dst[14] = m[14];
    dst[15] = m[15];
  }

  return dst;
}

/**
 * Creates a 4-by-4 matrix which rotates around the given axis by the given
 * angle.
 * @param {module:twgl/v3.Vec3} axis The axis
 *     about which to rotate.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} A matrix which rotates angle radians
 *     around the axis.
 * @memberOf module:twgl/m4
 */
function axisRotation(axis, angleInRadians, dst) {
  dst = dst || new MatType(16);

  let x = axis[0];
  let y = axis[1];
  let z = axis[2];
  const n = Math.sqrt(x * x + y * y + z * z);
  x /= n;
  y /= n;
  z /= n;
  const xx = x * x;
  const yy = y * y;
  const zz = z * z;
  const c = Math.cos(angleInRadians);
  const s = Math.sin(angleInRadians);
  const oneMinusCosine = 1 - c;

  dst[ 0] = xx + (1 - xx) * c;
  dst[ 1] = x * y * oneMinusCosine + z * s;
  dst[ 2] = x * z * oneMinusCosine - y * s;
  dst[ 3] = 0;
  dst[ 4] = x * y * oneMinusCosine - z * s;
  dst[ 5] = yy + (1 - yy) * c;
  dst[ 6] = y * z * oneMinusCosine + x * s;
  dst[ 7] = 0;
  dst[ 8] = x * z * oneMinusCosine + y * s;
  dst[ 9] = y * z * oneMinusCosine - x * s;
  dst[10] = zz + (1 - zz) * c;
  dst[11] = 0;
  dst[12] = 0;
  dst[13] = 0;
  dst[14] = 0;
  dst[15] = 1;

  return dst;
}

/**
 * Rotates the given 4-by-4 matrix around the given axis by the
 * given angle.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} axis The axis
 *     about which to rotate.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotated matrix.
 * @memberOf module:twgl/m4
 */
function axisRotate(m, axis, angleInRadians, dst) {
  dst = dst || new MatType(16);

  let x = axis[0];
  let y = axis[1];
  let z = axis[2];
  const n = Math.sqrt(x * x + y * y + z * z);
  x /= n;
  y /= n;
  z /= n;
  const xx = x * x;
  const yy = y * y;
  const zz = z * z;
  const c = Math.cos(angleInRadians);
  const s = Math.sin(angleInRadians);
  const oneMinusCosine = 1 - c;

  const r00 = xx + (1 - xx) * c;
  const r01 = x * y * oneMinusCosine + z * s;
  const r02 = x * z * oneMinusCosine - y * s;
  const r10 = x * y * oneMinusCosine - z * s;
  const r11 = yy + (1 - yy) * c;
  const r12 = y * z * oneMinusCosine + x * s;
  const r20 = x * z * oneMinusCosine + y * s;
  const r21 = y * z * oneMinusCosine - x * s;
  const r22 = zz + (1 - zz) * c;

  const m00 = m[0];
  const m01 = m[1];
  const m02 = m[2];
  const m03 = m[3];
  const m10 = m[4];
  const m11 = m[5];
  const m12 = m[6];
  const m13 = m[7];
  const m20 = m[8];
  const m21 = m[9];
  const m22 = m[10];
  const m23 = m[11];

  dst[ 0] = r00 * m00 + r01 * m10 + r02 * m20;
  dst[ 1] = r00 * m01 + r01 * m11 + r02 * m21;
  dst[ 2] = r00 * m02 + r01 * m12 + r02 * m22;
  dst[ 3] = r00 * m03 + r01 * m13 + r02 * m23;
  dst[ 4] = r10 * m00 + r11 * m10 + r12 * m20;
  dst[ 5] = r10 * m01 + r11 * m11 + r12 * m21;
  dst[ 6] = r10 * m02 + r11 * m12 + r12 * m22;
  dst[ 7] = r10 * m03 + r11 * m13 + r12 * m23;
  dst[ 8] = r20 * m00 + r21 * m10 + r22 * m20;
  dst[ 9] = r20 * m01 + r21 * m11 + r22 * m21;
  dst[10] = r20 * m02 + r21 * m12 + r22 * m22;
  dst[11] = r20 * m03 + r21 * m13 + r22 * m23;

  if (m !== dst) {
    dst[12] = m[12];
    dst[13] = m[13];
    dst[14] = m[14];
    dst[15] = m[15];
  }

  return dst;
}

/**
 * Creates a 4-by-4 matrix which scales in each dimension by an amount given by
 * the corresponding entry in the given vector; assumes the vector has three
 * entries.
 * @param {module:twgl/v3.Vec3} v A vector of
 *     three entries specifying the factor by which to scale in each dimension.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The scaling matrix.
 * @memberOf module:twgl/m4
 */
function scaling(v, dst) {
  dst = dst || new MatType(16);

  dst[ 0] = v[0];
  dst[ 1] = 0;
  dst[ 2] = 0;
  dst[ 3] = 0;
  dst[ 4] = 0;
  dst[ 5] = v[1];
  dst[ 6] = 0;
  dst[ 7] = 0;
  dst[ 8] = 0;
  dst[ 9] = 0;
  dst[10] = v[2];
  dst[11] = 0;
  dst[12] = 0;
  dst[13] = 0;
  dst[14] = 0;
  dst[15] = 1;

  return dst;
}

/**
 * Scales the given 4-by-4 matrix in each dimension by an amount
 * given by the corresponding entry in the given vector; assumes the vector has
 * three entries.
 * @param {module:twgl/m4.Mat4} m The matrix to be modified.
 * @param {module:twgl/v3.Vec3} v A vector of three entries specifying the
 *     factor by which to scale in each dimension.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The scaled matrix.
 * @memberOf module:twgl/m4
 */
function scale(m, v, dst) {
  dst = dst || new MatType(16);

  const v0 = v[0];
  const v1 = v[1];
  const v2 = v[2];

  dst[ 0] = v0 * m[0 * 4 + 0];
  dst[ 1] = v0 * m[0 * 4 + 1];
  dst[ 2] = v0 * m[0 * 4 + 2];
  dst[ 3] = v0 * m[0 * 4 + 3];
  dst[ 4] = v1 * m[1 * 4 + 0];
  dst[ 5] = v1 * m[1 * 4 + 1];
  dst[ 6] = v1 * m[1 * 4 + 2];
  dst[ 7] = v1 * m[1 * 4 + 3];
  dst[ 8] = v2 * m[2 * 4 + 0];
  dst[ 9] = v2 * m[2 * 4 + 1];
  dst[10] = v2 * m[2 * 4 + 2];
  dst[11] = v2 * m[2 * 4 + 3];

  if (m !== dst) {
    dst[12] = m[12];
    dst[13] = m[13];
    dst[14] = m[14];
    dst[15] = m[15];
  }

  return dst;
}

/**
 * Takes a 4-by-4 matrix and a vector with 3 entries,
 * interprets the vector as a point, transforms that point by the matrix, and
 * returns the result as a vector with 3 entries.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} v The point.
 * @param {module:twgl/v3.Vec3} [dst] optional vec3 to store result. If not passed a new one is created.
 * @return {module:twgl/v3.Vec3} The transformed point.
 * @memberOf module:twgl/m4
 */
function transformPoint(m, v, dst) {
  dst = dst || create();
  const v0 = v[0];
  const v1 = v[1];
  const v2 = v[2];
  const d = v0 * m[0 * 4 + 3] + v1 * m[1 * 4 + 3] + v2 * m[2 * 4 + 3] + m[3 * 4 + 3];

  dst[0] = (v0 * m[0 * 4 + 0] + v1 * m[1 * 4 + 0] + v2 * m[2 * 4 + 0] + m[3 * 4 + 0]) / d;
  dst[1] = (v0 * m[0 * 4 + 1] + v1 * m[1 * 4 + 1] + v2 * m[2 * 4 + 1] + m[3 * 4 + 1]) / d;
  dst[2] = (v0 * m[0 * 4 + 2] + v1 * m[1 * 4 + 2] + v2 * m[2 * 4 + 2] + m[3 * 4 + 2]) / d;

  return dst;
}

/**
 * Takes a 4-by-4 matrix and a vector with 3 entries, interprets the vector as a
 * direction, transforms that direction by the matrix, and returns the result;
 * assumes the transformation of 3-dimensional space represented by the matrix
 * is parallel-preserving, i.e. any combination of rotation, scaling and
 * translation, but not a perspective distortion. Returns a vector with 3
 * entries.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} v The direction.
 * @param {module:twgl/v3.Vec3} [dst] optional Vec3 to store result. If not passed a new one is created.
 * @return {module:twgl/v3.Vec3} The transformed direction.
 * @memberOf module:twgl/m4
 */
function transformDirection(m, v, dst) {
  dst = dst || create();

  const v0 = v[0];
  const v1 = v[1];
  const v2 = v[2];

  dst[0] = v0 * m[0 * 4 + 0] + v1 * m[1 * 4 + 0] + v2 * m[2 * 4 + 0];
  dst[1] = v0 * m[0 * 4 + 1] + v1 * m[1 * 4 + 1] + v2 * m[2 * 4 + 1];
  dst[2] = v0 * m[0 * 4 + 2] + v1 * m[1 * 4 + 2] + v2 * m[2 * 4 + 2];

  return dst;
}

/**
 * Takes a 4-by-4 matrix m and a vector v with 3 entries, interprets the vector
 * as a normal to a surface, and computes a vector which is normal upon
 * transforming that surface by the matrix. The effect of this function is the
 * same as transforming v (as a direction) by the inverse-transpose of m.  This
 * function assumes the transformation of 3-dimensional space represented by the
 * matrix is parallel-preserving, i.e. any combination of rotation, scaling and
 * translation, but not a perspective distortion.  Returns a vector with 3
 * entries.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} v The normal.
 * @param {module:twgl/v3.Vec3} [dst] The direction. If not passed a new one is created.
 * @return {module:twgl/v3.Vec3} The transformed normal.
 * @memberOf module:twgl/m4
 */
function transformNormal(m, v, dst) {
  dst = dst || create();
  const mi = inverse(m);
  const v0 = v[0];
  const v1 = v[1];
  const v2 = v[2];

  dst[0] = v0 * mi[0 * 4 + 0] + v1 * mi[0 * 4 + 1] + v2 * mi[0 * 4 + 2];
  dst[1] = v0 * mi[1 * 4 + 0] + v1 * mi[1 * 4 + 1] + v2 * mi[1 * 4 + 2];
  dst[2] = v0 * mi[2 * 4 + 0] + v1 * mi[2 * 4 + 1] + v2 * mi[2 * 4 + 2];

  return dst;
}

var m4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  axisRotate: axisRotate,
  axisRotation: axisRotation,
  copy: copy$1,
  create: create$1,
  frustum: frustum,
  getAxis: getAxis,
  getTranslation: getTranslation,
  identity: identity,
  inverse: inverse,
  lookAt: lookAt,
  multiply: multiply$1,
  negate: negate$1,
  ortho: ortho,
  perspective: perspective,
  rotateX: rotateX,
  rotateY: rotateY,
  rotateZ: rotateZ,
  rotationX: rotationX,
  rotationY: rotationY,
  rotationZ: rotationZ,
  scale: scale,
  scaling: scaling,
  setAxis: setAxis,
  setDefaultType: setDefaultType$1,
  setTranslation: setTranslation,
  transformDirection: transformDirection,
  transformNormal: transformNormal,
  transformPoint: transformPoint,
  translate: translate,
  translation: translation,
  transpose: transpose
});

/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

/* DataType */
const BYTE                           = 0x1400;
const UNSIGNED_BYTE                  = 0x1401;
const SHORT                          = 0x1402;
const UNSIGNED_SHORT                 = 0x1403;
const INT                            = 0x1404;
const UNSIGNED_INT                   = 0x1405;
const FLOAT                          = 0x1406;
const UNSIGNED_SHORT_4_4_4_4       = 0x8033;
const UNSIGNED_SHORT_5_5_5_1       = 0x8034;
const UNSIGNED_SHORT_5_6_5         = 0x8363;
const HALF_FLOAT                   = 0x140B;
const UNSIGNED_INT_2_10_10_10_REV  = 0x8368;
const UNSIGNED_INT_10F_11F_11F_REV = 0x8C3B;
const UNSIGNED_INT_5_9_9_9_REV     = 0x8C3E;
const FLOAT_32_UNSIGNED_INT_24_8_REV = 0x8DAD;
const UNSIGNED_INT_24_8            = 0x84FA;

const glTypeToTypedArray = {};
{
  const tt = glTypeToTypedArray;
  tt[BYTE]                           = Int8Array;
  tt[UNSIGNED_BYTE]                  = Uint8Array;
  tt[SHORT]                          = Int16Array;
  tt[UNSIGNED_SHORT]                 = Uint16Array;
  tt[INT]                            = Int32Array;
  tt[UNSIGNED_INT]                   = Uint32Array;
  tt[FLOAT]                          = Float32Array;
  tt[UNSIGNED_SHORT_4_4_4_4]         = Uint16Array;
  tt[UNSIGNED_SHORT_5_5_5_1]         = Uint16Array;
  tt[UNSIGNED_SHORT_5_6_5]           = Uint16Array;
  tt[HALF_FLOAT]                     = Uint16Array;
  tt[UNSIGNED_INT_2_10_10_10_REV]    = Uint32Array;
  tt[UNSIGNED_INT_10F_11F_11F_REV]   = Uint32Array;
  tt[UNSIGNED_INT_5_9_9_9_REV]       = Uint32Array;
  tt[FLOAT_32_UNSIGNED_INT_24_8_REV] = Uint32Array;
  tt[UNSIGNED_INT_24_8]              = Uint32Array;
}

/**
 * Get the GL type for a typedArray
 * @param {ArrayBufferView} typedArray a typedArray
 * @return {number} the GL type for array. For example pass in an `Int8Array` and `gl.BYTE` will
 *   be returned. Pass in a `Uint32Array` and `gl.UNSIGNED_INT` will be returned
 * @memberOf module:twgl/typedArray
 */
function getGLTypeForTypedArray(typedArray) {
  if (typedArray instanceof Int8Array)         { return BYTE; }           // eslint-disable-line
  if (typedArray instanceof Uint8Array)        { return UNSIGNED_BYTE; }  // eslint-disable-line
  if (typedArray instanceof Uint8ClampedArray) { return UNSIGNED_BYTE; }  // eslint-disable-line
  if (typedArray instanceof Int16Array)        { return SHORT; }          // eslint-disable-line
  if (typedArray instanceof Uint16Array)       { return UNSIGNED_SHORT; } // eslint-disable-line
  if (typedArray instanceof Int32Array)        { return INT; }            // eslint-disable-line
  if (typedArray instanceof Uint32Array)       { return UNSIGNED_INT; }   // eslint-disable-line
  if (typedArray instanceof Float32Array)      { return FLOAT; }          // eslint-disable-line
  throw new Error('unsupported typed array type');
}

/**
 * Get the GL type for a typedArray type
 * @param {ArrayBufferView} typedArrayType a typedArray constructor
 * @return {number} the GL type for type. For example pass in `Int8Array` and `gl.BYTE` will
 *   be returned. Pass in `Uint32Array` and `gl.UNSIGNED_INT` will be returned
 * @memberOf module:twgl/typedArray
 */
function getGLTypeForTypedArrayType(typedArrayType) {
  if (typedArrayType === Int8Array)         { return BYTE; }           // eslint-disable-line
  if (typedArrayType === Uint8Array)        { return UNSIGNED_BYTE; }  // eslint-disable-line
  if (typedArrayType === Uint8ClampedArray) { return UNSIGNED_BYTE; }  // eslint-disable-line
  if (typedArrayType === Int16Array)        { return SHORT; }          // eslint-disable-line
  if (typedArrayType === Uint16Array)       { return UNSIGNED_SHORT; } // eslint-disable-line
  if (typedArrayType === Int32Array)        { return INT; }            // eslint-disable-line
  if (typedArrayType === Uint32Array)       { return UNSIGNED_INT; }   // eslint-disable-line
  if (typedArrayType === Float32Array)      { return FLOAT; }          // eslint-disable-line
  throw new Error('unsupported typed array type');
}

/**
 * Get the typed array constructor for a given GL type
 * @param {number} type the GL type. (eg: `gl.UNSIGNED_INT`)
 * @return {function} the constructor for a the corresponding typed array. (eg. `Uint32Array`).
 * @memberOf module:twgl/typedArray
 */
function getTypedArrayTypeForGLType(type) {
  const CTOR = glTypeToTypedArray[type];
  if (!CTOR) {
    throw new Error('unknown gl type');
  }
  return CTOR;
}

const isArrayBuffer = typeof SharedArrayBuffer !== 'undefined'
  ? function isArrayBufferOrSharedArrayBuffer(a) {
    return a && a.buffer && (a.buffer instanceof ArrayBuffer || a.buffer instanceof SharedArrayBuffer);
  }
  : function isArrayBuffer(a) {
    return a && a.buffer && a.buffer instanceof ArrayBuffer;
  };

var typedarrays = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getGLTypeForTypedArray: getGLTypeForTypedArray,
  getGLTypeForTypedArrayType: getGLTypeForTypedArrayType,
  getTypedArrayTypeForGLType: getTypedArrayTypeForGLType,
  isArrayBuffer: isArrayBuffer
});

/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

/* eslint no-console: "off" */

/**
 * Copy named properties
 *
 * @param {string[]} names names of properties to copy
 * @param {object} src object to copy properties from
 * @param {object} dst object to copy properties to
 * @private
 */
function copyNamedProperties(names, src, dst) {
  names.forEach(function(name) {
    const value = src[name];
    if (value !== undefined) {
      dst[name] = value;
    }
  });
}

/**
 * Copies properties from source to dest only if a matching key is in dest
 *
 * @param {Object.<string, ?>} src the source
 * @param {Object.<string, ?>} dst the dest
 * @private
 */
function copyExistingProperties(src, dst) {
  Object.keys(dst).forEach(function(key) {
    if (dst.hasOwnProperty(key) && src.hasOwnProperty(key)) {  /* eslint no-prototype-builtins: 0 */
      dst[key] = src[key];
    }
  });
}

function error(...args) {
  console.error(...args);
}

function warn(...args) {
  console.warn(...args);
}

function isBuffer(gl, t) {
  return typeof WebGLBuffer !== 'undefined' && t instanceof WebGLBuffer;
}

function isRenderbuffer(gl, t) {
  return typeof WebGLRenderbuffer !== 'undefined' && t instanceof WebGLRenderbuffer;
}

function isShader(gl, t) {
  return typeof WebGLShader !== 'undefined' && t instanceof WebGLShader;
}

function isTexture(gl, t) {
  return typeof WebGLTexture !== 'undefined' && t instanceof WebGLTexture;
}

function isSampler(gl, t) {
  return typeof WebGLSampler !== 'undefined' && t instanceof WebGLSampler;
}

/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

const STATIC_DRAW                  = 0x88e4;
const ARRAY_BUFFER                 = 0x8892;
const ELEMENT_ARRAY_BUFFER         = 0x8893;
const BUFFER_SIZE                  = 0x8764;

const BYTE$1                         = 0x1400;
const UNSIGNED_BYTE$1                = 0x1401;
const SHORT$1                        = 0x1402;
const UNSIGNED_SHORT$1               = 0x1403;
const INT$1                          = 0x1404;
const UNSIGNED_INT$1                 = 0x1405;
const FLOAT$1                        = 0x1406;
const defaults = {
  attribPrefix: "",
};

/**
 * Sets the default attrib prefix
 *
 * When writing shaders I prefer to name attributes with `a_`, uniforms with `u_` and varyings with `v_`
 * as it makes it clear where they came from. But, when building geometry I prefer using un-prefixed names.
 *
 * In other words I'll create arrays of geometry like this
 *
 *     var arrays = {
 *       position: ...
 *       normal: ...
 *       texcoord: ...
 *     };
 *
 * But need those mapped to attributes and my attributes start with `a_`.
 *
 * @deprecated see {@link module:twgl.setDefaults}
 * @param {string} prefix prefix for attribs
 * @memberOf module:twgl/attributes
 */
function setAttributePrefix(prefix) {
  defaults.attribPrefix = prefix;
}

function setDefaults(newDefaults) {
  copyExistingProperties(newDefaults, defaults);
}

function setBufferFromTypedArray(gl, type, buffer, array, drawType) {
  gl.bindBuffer(type, buffer);
  gl.bufferData(type, array, drawType || STATIC_DRAW);
}

/**
 * Given typed array creates a WebGLBuffer and copies the typed array
 * into it.
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @param {ArrayBuffer|SharedArrayBuffer|ArrayBufferView|WebGLBuffer} typedArray the typed array. Note: If a WebGLBuffer is passed in it will just be returned. No action will be taken
 * @param {number} [type] the GL bind type for the buffer. Default = `gl.ARRAY_BUFFER`.
 * @param {number} [drawType] the GL draw type for the buffer. Default = 'gl.STATIC_DRAW`.
 * @return {WebGLBuffer} the created WebGLBuffer
 * @memberOf module:twgl/attributes
 */
function createBufferFromTypedArray(gl, typedArray, type, drawType) {
  if (isBuffer(gl, typedArray)) {
    return typedArray;
  }
  type = type || ARRAY_BUFFER;
  const buffer = gl.createBuffer();
  setBufferFromTypedArray(gl, type, buffer, typedArray, drawType);
  return buffer;
}

function isIndices(name) {
  return name === "indices";
}

// This is really just a guess. Though I can't really imagine using
// anything else? Maybe for some compression?
function getNormalizationForTypedArray(typedArray) {
  if (typedArray instanceof Int8Array)    { return true; }  // eslint-disable-line
  if (typedArray instanceof Uint8Array)   { return true; }  // eslint-disable-line
  return false;
}

// This is really just a guess. Though I can't really imagine using
// anything else? Maybe for some compression?
function getNormalizationForTypedArrayType(typedArrayType) {
  if (typedArrayType === Int8Array)    { return true; }  // eslint-disable-line
  if (typedArrayType === Uint8Array)   { return true; }  // eslint-disable-line
  return false;
}

function getArray(array) {
  return array.length ? array : array.data;
}

const texcoordRE = /coord|texture/i;
const colorRE = /color|colour/i;

function guessNumComponentsFromName(name, length) {
  let numComponents;
  if (texcoordRE.test(name)) {
    numComponents = 2;
  } else if (colorRE.test(name)) {
    numComponents = 4;
  } else {
    numComponents = 3;  // position, normals, indices ...
  }

  if (length % numComponents > 0) {
    throw new Error(`Can not guess numComponents for attribute '${name}'. Tried ${numComponents} but ${length} values is not evenly divisible by ${numComponents}. You should specify it.`);
  }

  return numComponents;
}

function getNumComponents(array, arrayName) {
  return array.numComponents || array.size || guessNumComponentsFromName(arrayName, getArray(array).length);
}

function makeTypedArray(array, name) {
  if (isArrayBuffer(array)) {
    return array;
  }

  if (isArrayBuffer(array.data)) {
    return array.data;
  }

  if (Array.isArray(array)) {
    array = {
      data: array,
    };
  }

  let Type = array.type;
  if (!Type) {
    if (isIndices(name)) {
      Type = Uint16Array;
    } else {
      Type = Float32Array;
    }
  }
  return new Type(array.data);
}

/**
 * The info for an attribute. This is effectively just the arguments to `gl.vertexAttribPointer` plus the WebGLBuffer
 * for the attribute.
 *
 * @typedef {Object} AttribInfo
 * @property {number[]|ArrayBufferView} [value] a constant value for the attribute. Note: if this is set the attribute will be
 *    disabled and set to this constant value and all other values will be ignored.
 * @property {number} [numComponents] the number of components for this attribute.
 * @property {number} [size] synonym for `numComponents`.
 * @property {number} [type] the type of the attribute (eg. `gl.FLOAT`, `gl.UNSIGNED_BYTE`, etc...) Default = `gl.FLOAT`
 * @property {boolean} [normalize] whether or not to normalize the data. Default = false
 * @property {number} [offset] offset into buffer in bytes. Default = 0
 * @property {number} [stride] the stride in bytes per element. Default = 0
 * @property {number} [divisor] the divisor in instances. Default = undefined. Note: undefined = don't call gl.vertexAttribDivisor
 *    where as anything else = do call it with this value
 * @property {WebGLBuffer} buffer the buffer that contains the data for this attribute
 * @property {number} [drawType] the draw type passed to gl.bufferData. Default = gl.STATIC_DRAW
 * @memberOf module:twgl
 */

/**
 * Use this type of array spec when TWGL can't guess the type or number of components of an array
 * @typedef {Object} FullArraySpec
 * @property {number[]|ArrayBufferView} [value] a constant value for the attribute. Note: if this is set the attribute will be
 *    disabled and set to this constant value and all other values will be ignored.
 * @property {(number|number[]|ArrayBufferView)} data The data of the array. A number alone becomes the number of elements of type.
 * @property {number} [numComponents] number of components for `vertexAttribPointer`. Default is based on the name of the array.
 *    If `coord` is in the name assumes `numComponents = 2`.
 *    If `color` is in the name assumes `numComponents = 4`.
 *    otherwise assumes `numComponents = 3`
 * @property {constructor} [type] type. This is only used if `data` is a JavaScript array. It is the constructor for the typedarray. (eg. `Uint8Array`).
 * For example if you want colors in a `Uint8Array` you might have a `FullArraySpec` like `{ type: Uint8Array, data: [255,0,255,255, ...], }`.
 * @property {number} [size] synonym for `numComponents`.
 * @property {boolean} [normalize] normalize for `vertexAttribPointer`. Default is true if type is `Int8Array` or `Uint8Array` otherwise false.
 * @property {number} [stride] stride for `vertexAttribPointer`. Default = 0
 * @property {number} [offset] offset for `vertexAttribPointer`. Default = 0
 * @property {number} [divisor] divisor for `vertexAttribDivisor`. Default = undefined. Note: undefined = don't call gl.vertexAttribDivisor
 *    where as anything else = do call it with this value
 * @property {string} [attrib] name of attribute this array maps to. Defaults to same name as array prefixed by the default attribPrefix.
 * @property {string} [name] synonym for `attrib`.
 * @property {string} [attribName] synonym for `attrib`.
 * @property {WebGLBuffer} [buffer] Buffer to use for this attribute. This lets you use your own buffer
 *    but you will need to supply `numComponents` and `type`. You can effectively pass an `AttribInfo`
 *    to provide this. Example:
 *
 *         const bufferInfo1 = twgl.createBufferInfoFromArrays(gl, {
 *           position: [1, 2, 3, ... ],
 *         });
 *         const bufferInfo2 = twgl.createBufferInfoFromArrays(gl, {
 *           position: bufferInfo1.attribs.position,  // use the same buffer from bufferInfo1
 *         });
 *
 * @memberOf module:twgl
 */

/**
 * An individual array in {@link module:twgl.Arrays}
 *
 * When passed to {@link module:twgl.createBufferInfoFromArrays} if an ArraySpec is `number[]` or `ArrayBufferView`
 * the types will be guessed based on the name. `indices` will be `Uint16Array`, everything else will
 * be `Float32Array`. If an ArraySpec is a number it's the number of floats for an empty (zeroed) buffer.
 *
 * @typedef {(number|number[]|ArrayBufferView|module:twgl.FullArraySpec)} ArraySpec
 * @memberOf module:twgl
 */

/**
 * This is a JavaScript object of arrays by name. The names should match your shader's attributes. If your
 * attributes have a common prefix you can specify it by calling {@link module:twgl.setAttributePrefix}.
 *
 *     Bare JavaScript Arrays
 *
 *         var arrays = {
 *            position: [-1, 1, 0],
 *            normal: [0, 1, 0],
 *            ...
 *         }
 *
 *     Bare TypedArrays
 *
 *         var arrays = {
 *            position: new Float32Array([-1, 1, 0]),
 *            color: new Uint8Array([255, 128, 64, 255]),
 *            ...
 *         }
 *
 * *   Will guess at `numComponents` if not specified based on name.
 *
 *     If `coord` is in the name assumes `numComponents = 2`
 *
 *     If `color` is in the name assumes `numComponents = 4`
 *
 *     otherwise assumes `numComponents = 3`
 *
 * Objects with various fields. See {@link module:twgl.FullArraySpec}.
 *
 *     var arrays = {
 *       position: { numComponents: 3, data: [0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0], },
 *       texcoord: { numComponents: 2, data: [0, 0, 0, 1, 1, 0, 1, 1],                 },
 *       normal:   { numComponents: 3, data: [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1],     },
 *       indices:  { numComponents: 3, data: [0, 1, 2, 1, 2, 3],                       },
 *     };
 *
 * @typedef {Object.<string, module:twgl.ArraySpec>} Arrays
 * @memberOf module:twgl
 */


/**
 * Creates a set of attribute data and WebGLBuffers from set of arrays
 *
 * Given
 *
 *      var arrays = {
 *        position: { numComponents: 3, data: [0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0], },
 *        texcoord: { numComponents: 2, data: [0, 0, 0, 1, 1, 0, 1, 1],                 },
 *        normal:   { numComponents: 3, data: [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1],     },
 *        color:    { numComponents: 4, data: [255, 255, 255, 255, 255, 0, 0, 255, 0, 0, 255, 255], type: Uint8Array, },
 *        indices:  { numComponents: 3, data: [0, 1, 2, 1, 2, 3],                       },
 *      };
 *
 * returns something like
 *
 *      var attribs = {
 *        position: { numComponents: 3, type: gl.FLOAT,         normalize: false, buffer: WebGLBuffer, },
 *        texcoord: { numComponents: 2, type: gl.FLOAT,         normalize: false, buffer: WebGLBuffer, },
 *        normal:   { numComponents: 3, type: gl.FLOAT,         normalize: false, buffer: WebGLBuffer, },
 *        color:    { numComponents: 4, type: gl.UNSIGNED_BYTE, normalize: true,  buffer: WebGLBuffer, },
 *      };
 *
 * notes:
 *
 * *   Arrays can take various forms
 *
 *     Bare JavaScript Arrays
 *
 *         var arrays = {
 *            position: [-1, 1, 0],
 *            normal: [0, 1, 0],
 *            ...
 *         }
 *
 *     Bare TypedArrays
 *
 *         var arrays = {
 *            position: new Float32Array([-1, 1, 0]),
 *            color: new Uint8Array([255, 128, 64, 255]),
 *            ...
 *         }
 *
 * *   Will guess at `numComponents` if not specified based on name.
 *
 *     If `coord` is in the name assumes `numComponents = 2`
 *
 *     If `color` is in the name assumes `numComponents = 4`
 *
 *     otherwise assumes `numComponents = 3`
 *
 * @param {WebGLRenderingContext} gl The webgl rendering context.
 * @param {module:twgl.Arrays} arrays The arrays
 * @param {module:twgl.BufferInfo} [srcBufferInfo] a BufferInfo to copy from
 *   This lets you share buffers. Any arrays you supply will override
 *   the buffers from srcBufferInfo.
 * @return {Object.<string, module:twgl.AttribInfo>} the attribs
 * @memberOf module:twgl/attributes
 */
function createAttribsFromArrays(gl, arrays) {
  const attribs = {};
  Object.keys(arrays).forEach(function(arrayName) {
    if (!isIndices(arrayName)) {
      const array = arrays[arrayName];
      const attribName = array.attrib || array.name || array.attribName || (defaults.attribPrefix + arrayName);
      if (array.value) {
        if (!Array.isArray(array.value) && !isArrayBuffer(array.value)) {
          throw new Error('array.value is not array or typedarray');
        }
        attribs[attribName] = {
          value: array.value,
        };
      } else {
        let buffer;
        let type;
        let normalization;
        let numComponents;
        if (array.buffer && array.buffer instanceof WebGLBuffer) {
          buffer = array.buffer;
          numComponents = array.numComponents || array.size;
          type = array.type;
          normalization = array.normalize;
        } else if (typeof array === "number" || typeof array.data === "number") {
          const numValues = array.data || array;
          const arrayType = array.type || Float32Array;
          const numBytes = numValues * arrayType.BYTES_PER_ELEMENT;
          type = getGLTypeForTypedArrayType(arrayType);
          normalization = array.normalize !== undefined ? array.normalize : getNormalizationForTypedArrayType(arrayType);
          numComponents = array.numComponents || array.size || guessNumComponentsFromName(arrayName, numValues);
          buffer = gl.createBuffer();
          gl.bindBuffer(ARRAY_BUFFER, buffer);
          gl.bufferData(ARRAY_BUFFER, numBytes, array.drawType || STATIC_DRAW);
        } else {
          const typedArray = makeTypedArray(array, arrayName);
          buffer = createBufferFromTypedArray(gl, typedArray, undefined, array.drawType);
          type = getGLTypeForTypedArray(typedArray);
          normalization = array.normalize !== undefined ? array.normalize : getNormalizationForTypedArray(typedArray);
          numComponents = getNumComponents(array, arrayName);
        }
        attribs[attribName] = {
          buffer:        buffer,
          numComponents: numComponents,
          type:          type,
          normalize:     normalization,
          stride:        array.stride || 0,
          offset:        array.offset || 0,
          divisor:       array.divisor === undefined ? undefined : array.divisor,
          drawType:      array.drawType,
        };
      }
    }
  });
  gl.bindBuffer(ARRAY_BUFFER, null);
  return attribs;
}

/**
 * Sets the contents of a buffer attached to an attribInfo
 *
 * This is helper function to dynamically update a buffer.
 *
 * Let's say you make a bufferInfo
 *
 *     var arrays = {
 *        position: new Float32Array([0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0]),
 *        texcoord: new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]),
 *        normal:   new Float32Array([0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1]),
 *        indices:  new Uint16Array([0, 1, 2, 1, 2, 3]),
 *     };
 *     var bufferInfo = twgl.createBufferInfoFromArrays(gl, arrays);
 *
 *  And you want to dynamically update the positions. You could do this
 *
 *     // assuming arrays.position has already been updated with new data.
 *     twgl.setAttribInfoBufferFromArray(gl, bufferInfo.attribs.position, arrays.position);
 *
 * @param {WebGLRenderingContext} gl
 * @param {AttribInfo} attribInfo The attribInfo who's buffer contents to set. NOTE: If you have an attribute prefix
 *   the name of the attribute will include the prefix.
 * @param {ArraySpec} array Note: it is arguably inefficient to pass in anything but a typed array because anything
 *    else will have to be converted to a typed array before it can be used by WebGL. During init time that
 *    inefficiency is usually not important but if you're updating data dynamically best to be efficient.
 * @param {number} [offset] an optional offset into the buffer. This is only an offset into the WebGL buffer
 *    not the array. To pass in an offset into the array itself use a typed array and create an `ArrayBufferView`
 *    for the portion of the array you want to use.
 *
 *        var someArray = new Float32Array(1000); // an array with 1000 floats
 *        var someSubArray = new Float32Array(someArray.buffer, offsetInBytes, sizeInUnits); // a view into someArray
 *
 *    Now you can pass `someSubArray` into setAttribInfoBufferFromArray`
 * @memberOf module:twgl/attributes
 */
function setAttribInfoBufferFromArray(gl, attribInfo, array, offset) {
  array = makeTypedArray(array);
  if (offset !== undefined) {
    gl.bindBuffer(ARRAY_BUFFER, attribInfo.buffer);
    gl.bufferSubData(ARRAY_BUFFER, offset, array);
  } else {
    setBufferFromTypedArray(gl, ARRAY_BUFFER, attribInfo.buffer, array, attribInfo.drawType);
  }
}

function getBytesPerValueForGLType(gl, type) {
  if (type === BYTE$1)           return 1;  // eslint-disable-line
  if (type === UNSIGNED_BYTE$1)  return 1;  // eslint-disable-line
  if (type === SHORT$1)          return 2;  // eslint-disable-line
  if (type === UNSIGNED_SHORT$1) return 2;  // eslint-disable-line
  if (type === INT$1)            return 4;  // eslint-disable-line
  if (type === UNSIGNED_INT$1)   return 4;  // eslint-disable-line
  if (type === FLOAT$1)          return 4;  // eslint-disable-line
  return 0;
}

// Tries to get the number of elements from a set of arrays.
const positionKeys = ['position', 'positions', 'a_position'];
function getNumElementsFromNonIndexedArrays(arrays) {
  let key;
  let ii;
  for (ii = 0; ii < positionKeys.length; ++ii) {
    key = positionKeys[ii];
    if (key in arrays) {
      break;
    }
  }
  if (ii === positionKeys.length) {
    key = Object.keys(arrays)[0];
  }
  const array = arrays[key];
  const length = getArray(array).length;
  if (length === undefined) {
    return 1;   // There's no arrays
  }
  const numComponents = getNumComponents(array, key);
  const numElements = length / numComponents;
  if (length % numComponents > 0) {
    throw new Error(`numComponents ${numComponents} not correct for length ${length}`);
  }
  return numElements;
}

function getNumElementsFromAttributes(gl, attribs) {
  let key;
  let ii;
  for (ii = 0; ii < positionKeys.length; ++ii) {
    key = positionKeys[ii];
    if (key in attribs) {
      break;
    }
    key = defaults.attribPrefix + key;
    if (key in attribs) {
      break;
    }
  }
  if (ii === positionKeys.length) {
    key = Object.keys(attribs)[0];
  }
  const attrib = attribs[key];
  if (!attrib.buffer) {
    return 1; // There's no buffer
  }
  gl.bindBuffer(ARRAY_BUFFER, attrib.buffer);
  const numBytes = gl.getBufferParameter(ARRAY_BUFFER, BUFFER_SIZE);
  gl.bindBuffer(ARRAY_BUFFER, null);

  const bytesPerValue = getBytesPerValueForGLType(gl, attrib.type);
  const totalElements = numBytes / bytesPerValue;
  const numComponents = attrib.numComponents || attrib.size;
  // TODO: check stride
  const numElements = totalElements / numComponents;
  if (numElements % 1 !== 0) {
    throw new Error(`numComponents ${numComponents} not correct for length ${length}`);
  }
  return numElements;
}

/**
 * @typedef {Object} BufferInfo
 * @property {number} numElements The number of elements to pass to `gl.drawArrays` or `gl.drawElements`.
 * @property {number} [elementType] The type of indices `UNSIGNED_BYTE`, `UNSIGNED_SHORT` etc..
 * @property {WebGLBuffer} [indices] The indices `ELEMENT_ARRAY_BUFFER` if any indices exist.
 * @property {Object.<string, module:twgl.AttribInfo>} [attribs] The attribs appropriate to call `setAttributes`
 * @memberOf module:twgl
 */

/**
 * Creates a BufferInfo from an object of arrays.
 *
 * This can be passed to {@link module:twgl.setBuffersAndAttributes} and to
 * {@link module:twgl:drawBufferInfo}.
 *
 * Given an object like
 *
 *     var arrays = {
 *       position: { numComponents: 3, data: [0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0], },
 *       texcoord: { numComponents: 2, data: [0, 0, 0, 1, 1, 0, 1, 1],                 },
 *       normal:   { numComponents: 3, data: [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1],     },
 *       indices:  { numComponents: 3, data: [0, 1, 2, 1, 2, 3],                       },
 *     };
 *
 *  Creates an BufferInfo like this
 *
 *     bufferInfo = {
 *       numElements: 4,        // or whatever the number of elements is
 *       indices: WebGLBuffer,  // this property will not exist if there are no indices
 *       attribs: {
 *         position: { buffer: WebGLBuffer, numComponents: 3, },
 *         normal:   { buffer: WebGLBuffer, numComponents: 3, },
 *         texcoord: { buffer: WebGLBuffer, numComponents: 2, },
 *       },
 *     };
 *
 *  The properties of arrays can be JavaScript arrays in which case the number of components
 *  will be guessed.
 *
 *     var arrays = {
 *        position: [0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0],
 *        texcoord: [0, 0, 0, 1, 1, 0, 1, 1],
 *        normal:   [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1],
 *        indices:  [0, 1, 2, 1, 2, 3],
 *     };
 *
 *  They can also be TypedArrays
 *
 *     var arrays = {
 *        position: new Float32Array([0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0]),
 *        texcoord: new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]),
 *        normal:   new Float32Array([0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1]),
 *        indices:  new Uint16Array([0, 1, 2, 1, 2, 3]),
 *     };
 *
 *  Or AugmentedTypedArrays
 *
 *     var positions = createAugmentedTypedArray(3, 4);
 *     var texcoords = createAugmentedTypedArray(2, 4);
 *     var normals   = createAugmentedTypedArray(3, 4);
 *     var indices   = createAugmentedTypedArray(3, 2, Uint16Array);
 *
 *     positions.push([0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0]);
 *     texcoords.push([0, 0, 0, 1, 1, 0, 1, 1]);
 *     normals.push([0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1]);
 *     indices.push([0, 1, 2, 1, 2, 3]);
 *
 *     var arrays = {
 *        position: positions,
 *        texcoord: texcoords,
 *        normal:   normals,
 *        indices:  indices,
 *     };
 *
 * For the last example it is equivalent to
 *
 *     var bufferInfo = {
 *       attribs: {
 *         position: { numComponents: 3, buffer: gl.createBuffer(), },
 *         texcoord: { numComponents: 2, buffer: gl.createBuffer(), },
 *         normal: { numComponents: 3, buffer: gl.createBuffer(), },
 *       },
 *       indices: gl.createBuffer(),
 *       numElements: 6,
 *     };
 *
 *     gl.bindBuffer(gl.ARRAY_BUFFER, bufferInfo.attribs.position.buffer);
 *     gl.bufferData(gl.ARRAY_BUFFER, arrays.position, gl.STATIC_DRAW);
 *     gl.bindBuffer(gl.ARRAY_BUFFER, bufferInfo.attribs.texcoord.buffer);
 *     gl.bufferData(gl.ARRAY_BUFFER, arrays.texcoord, gl.STATIC_DRAW);
 *     gl.bindBuffer(gl.ARRAY_BUFFER, bufferInfo.attribs.normal.buffer);
 *     gl.bufferData(gl.ARRAY_BUFFER, arrays.normal, gl.STATIC_DRAW);
 *     gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, bufferInfo.indices);
 *     gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, arrays.indices, gl.STATIC_DRAW);
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @param {module:twgl.Arrays} arrays Your data
 * @param {module:twgl.BufferInfo} [srcBufferInfo] An existing
 *        buffer info to start from. WebGLBuffers etc specified
 *        in the srcBufferInfo will be used in a new BufferInfo
 *        with any arrays specified overriding the ones in
 *        srcBufferInfo.
 * @return {module:twgl.BufferInfo} A BufferInfo
 * @memberOf module:twgl/attributes
 */
function createBufferInfoFromArrays(gl, arrays, srcBufferInfo) {
  const newAttribs = createAttribsFromArrays(gl, arrays);
  const bufferInfo = Object.assign({}, srcBufferInfo ? srcBufferInfo : {});
  bufferInfo.attribs = Object.assign({}, srcBufferInfo ? srcBufferInfo.attribs : {}, newAttribs);
  const indices = arrays.indices;
  if (indices) {
    const newIndices = makeTypedArray(indices, "indices");
    bufferInfo.indices = createBufferFromTypedArray(gl, newIndices, ELEMENT_ARRAY_BUFFER);
    bufferInfo.numElements = newIndices.length;
    bufferInfo.elementType = getGLTypeForTypedArray(newIndices);
  } else if (!bufferInfo.numElements) {
    bufferInfo.numElements = getNumElementsFromAttributes(gl, bufferInfo.attribs);
  }

  return bufferInfo;
}

/**
 * Creates a buffer from an array, typed array, or array spec
 *
 * Given something like this
 *
 *     [1, 2, 3],
 *
 * or
 *
 *     new Uint16Array([1,2,3]);
 *
 * or
 *
 *     {
 *        data: [1, 2, 3],
 *        type: Uint8Array,
 *     }
 *
 * returns a WebGLBuffer that contains the given data.
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext.
 * @param {module:twgl.ArraySpec} array an array, typed array, or array spec.
 * @param {string} arrayName name of array. Used to guess the type if type can not be derived otherwise.
 * @return {WebGLBuffer} a WebGLBuffer containing the data in array.
 * @memberOf module:twgl/attributes
 */
function createBufferFromArray(gl, array, arrayName) {
  const type = arrayName === "indices" ? ELEMENT_ARRAY_BUFFER : ARRAY_BUFFER;
  const typedArray = makeTypedArray(array, arrayName);
  return createBufferFromTypedArray(gl, typedArray, type);
}

/**
 * Creates buffers from arrays or typed arrays
 *
 * Given something like this
 *
 *     var arrays = {
 *        positions: [1, 2, 3],
 *        normals: [0, 0, 1],
 *     }
 *
 * returns something like
 *
 *     buffers = {
 *       positions: WebGLBuffer,
 *       normals: WebGLBuffer,
 *     }
 *
 * If the buffer is named 'indices' it will be made an ELEMENT_ARRAY_BUFFER.
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext.
 * @param {module:twgl.Arrays} arrays
 * @return {Object<string, WebGLBuffer>} returns an object with one WebGLBuffer per array
 * @memberOf module:twgl/attributes
 */
function createBuffersFromArrays(gl, arrays) {
  const buffers = { };
  Object.keys(arrays).forEach(function(key) {
    buffers[key] = createBufferFromArray(gl, arrays[key], key);
  });

  // Ugh!
  if (arrays.indices) {
    buffers.numElements = arrays.indices.length;
    buffers.elementType = getGLTypeForTypedArray(makeTypedArray(arrays.indices));
  } else {
    buffers.numElements = getNumElementsFromNonIndexedArrays(arrays);
  }

  return buffers;
}

var attributes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createAttribsFromArrays: createAttribsFromArrays,
  createBuffersFromArrays: createBuffersFromArrays,
  createBufferFromArray: createBufferFromArray,
  createBufferFromTypedArray: createBufferFromTypedArray,
  createBufferInfoFromArrays: createBufferInfoFromArrays,
  setAttribInfoBufferFromArray: setAttribInfoBufferFromArray,
  setAttributePrefix: setAttributePrefix,
  setAttributeDefaults_: setDefaults,
  getNumComponents_: getNumComponents,
  getArray_: getArray
});

/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

const getArray$1 = getArray;  // eslint-disable-line
const getNumComponents$1 = getNumComponents;  // eslint-disable-line

/**
 * @typedef {(Int8Array|Uint8Array|Int16Array|Uint16Array|Int32Array|Uint32Array|Float32Array)} TypedArray
 */

/**
 * Add `push` to a typed array. It just keeps a 'cursor'
 * and allows use to `push` values into the array so we
 * don't have to manually compute offsets
 * @param {TypedArray} typedArray TypedArray to augment
 * @param {number} numComponents number of components.
 * @private
 */
function augmentTypedArray(typedArray, numComponents) {
  let cursor = 0;
  typedArray.push = function() {
    for (let ii = 0; ii < arguments.length; ++ii) {
      const value = arguments[ii];
      if (value instanceof Array || isArrayBuffer(value)) {
        for (let jj = 0; jj < value.length; ++jj) {
          typedArray[cursor++] = value[jj];
        }
      } else {
        typedArray[cursor++] = value;
      }
    }
  };
  typedArray.reset = function(opt_index) {
    cursor = opt_index || 0;
  };
  typedArray.numComponents = numComponents;
  Object.defineProperty(typedArray, 'numElements', {
    get: function() {
      return this.length / this.numComponents | 0;
    },
  });
  return typedArray;
}

/**
 * creates a typed array with a `push` function attached
 * so that you can easily *push* values.
 *
 * `push` can take multiple arguments. If an argument is an array each element
 * of the array will be added to the typed array.
 *
 * Example:
 *
 *     const array = createAugmentedTypedArray(3, 2);  // creates a Float32Array with 6 values
 *     array.push(1, 2, 3);
 *     array.push([4, 5, 6]);
 *     // array now contains [1, 2, 3, 4, 5, 6]
 *
 * Also has `numComponents` and `numElements` properties.
 *
 * @param {number} numComponents number of components
 * @param {number} numElements number of elements. The total size of the array will be `numComponents * numElements`.
 * @param {constructor} opt_type A constructor for the type. Default = `Float32Array`.
 * @return {ArrayBufferView} A typed array.
 * @memberOf module:twgl/primitives
 */
function createAugmentedTypedArray(numComponents, numElements, opt_type) {
  const Type = opt_type || Float32Array;
  return augmentTypedArray(new Type(numComponents * numElements), numComponents);
}

function allButIndices(name) {
  return name !== "indices";
}

/**
 * Given indexed vertices creates a new set of vertices un-indexed by expanding the indexed vertices.
 * @param {Object.<string, TypedArray>} vertices The indexed vertices to deindex
 * @return {Object.<string, TypedArray>} The deindexed vertices
 * @memberOf module:twgl/primitives
 */
function deindexVertices(vertices) {
  const indices = vertices.indices;
  const newVertices = {};
  const numElements = indices.length;

  function expandToUnindexed(channel) {
    const srcBuffer = vertices[channel];
    const numComponents = srcBuffer.numComponents;
    const dstBuffer = createAugmentedTypedArray(numComponents, numElements, srcBuffer.constructor);
    for (let ii = 0; ii < numElements; ++ii) {
      const ndx = indices[ii];
      const offset = ndx * numComponents;
      for (let jj = 0; jj < numComponents; ++jj) {
        dstBuffer.push(srcBuffer[offset + jj]);
      }
    }
    newVertices[channel] = dstBuffer;
  }

  Object.keys(vertices).filter(allButIndices).forEach(expandToUnindexed);

  return newVertices;
}

/**
 * flattens the normals of deindexed vertices in place.
 * @param {Object.<string, TypedArray>} vertices The deindexed vertices who's normals to flatten
 * @return {Object.<string, TypedArray>} The flattened vertices (same as was passed in)
 * @memberOf module:twgl/primitives
 */
function flattenNormals(vertices) {
  if (vertices.indices) {
    throw new Error('can not flatten normals of indexed vertices. deindex them first');
  }

  const normals = vertices.normal;
  const numNormals = normals.length;
  for (let ii = 0; ii < numNormals; ii += 9) {
    // pull out the 3 normals for this triangle
    const nax = normals[ii + 0];
    const nay = normals[ii + 1];
    const naz = normals[ii + 2];

    const nbx = normals[ii + 3];
    const nby = normals[ii + 4];
    const nbz = normals[ii + 5];

    const ncx = normals[ii + 6];
    const ncy = normals[ii + 7];
    const ncz = normals[ii + 8];

    // add them
    let nx = nax + nbx + ncx;
    let ny = nay + nby + ncy;
    let nz = naz + nbz + ncz;

    // normalize them
    const length = Math.sqrt(nx * nx + ny * ny + nz * nz);

    nx /= length;
    ny /= length;
    nz /= length;

    // copy them back in
    normals[ii + 0] = nx;
    normals[ii + 1] = ny;
    normals[ii + 2] = nz;

    normals[ii + 3] = nx;
    normals[ii + 4] = ny;
    normals[ii + 5] = nz;

    normals[ii + 6] = nx;
    normals[ii + 7] = ny;
    normals[ii + 8] = nz;
  }

  return vertices;
}

function applyFuncToV3Array(array, matrix, fn) {
  const len = array.length;
  const tmp = new Float32Array(3);
  for (let ii = 0; ii < len; ii += 3) {
    fn(matrix, [array[ii], array[ii + 1], array[ii + 2]], tmp);
    array[ii    ] = tmp[0];
    array[ii + 1] = tmp[1];
    array[ii + 2] = tmp[2];
  }
}

function transformNormal$1(mi, v, dst) {
  dst = dst || create();
  const v0 = v[0];
  const v1 = v[1];
  const v2 = v[2];

  dst[0] = v0 * mi[0 * 4 + 0] + v1 * mi[0 * 4 + 1] + v2 * mi[0 * 4 + 2];
  dst[1] = v0 * mi[1 * 4 + 0] + v1 * mi[1 * 4 + 1] + v2 * mi[1 * 4 + 2];
  dst[2] = v0 * mi[2 * 4 + 0] + v1 * mi[2 * 4 + 1] + v2 * mi[2 * 4 + 2];

  return dst;
}

/**
 * Reorients directions by the given matrix..
 * @param {(number[]|TypedArray)} array The array. Assumes value floats per element.
 * @param {module:twgl/m4.Mat4} matrix A matrix to multiply by.
 * @return {(number[]|TypedArray)} the same array that was passed in
 * @memberOf module:twgl/primitives
 */
function reorientDirections(array, matrix) {
  applyFuncToV3Array(array, matrix, transformDirection);
  return array;
}

/**
 * Reorients normals by the inverse-transpose of the given
 * matrix..
 * @param {(number[]|TypedArray)} array The array. Assumes value floats per element.
 * @param {module:twgl/m4.Mat4} matrix A matrix to multiply by.
 * @return {(number[]|TypedArray)} the same array that was passed in
 * @memberOf module:twgl/primitives
 */
function reorientNormals(array, matrix) {
  applyFuncToV3Array(array, inverse(matrix), transformNormal$1);
  return array;
}

/**
 * Reorients positions by the given matrix. In other words, it
 * multiplies each vertex by the given matrix.
 * @param {(number[]|TypedArray)} array The array. Assumes value floats per element.
 * @param {module:twgl/m4.Mat4} matrix A matrix to multiply by.
 * @return {(number[]|TypedArray)} the same array that was passed in
 * @memberOf module:twgl/primitives
 */
function reorientPositions(array, matrix) {
  applyFuncToV3Array(array, matrix, transformPoint);
  return array;
}

/**
 * @typedef {(number[]|TypedArray)} NativeArrayOrTypedArray
 */

/**
 * Reorients arrays by the given matrix. Assumes arrays have
 * names that contains 'pos' could be reoriented as positions,
 * 'binorm' or 'tan' as directions, and 'norm' as normals.
 *
 * @param {Object.<string, NativeArrayOrTypedArray>} arrays The vertices to reorient
 * @param {module:twgl/m4.Mat4} matrix matrix to reorient by.
 * @return {Object.<string, NativeArrayOrTypedArray>} same arrays that were passed in.
 * @memberOf module:twgl/primitives
 */
function reorientVertices(arrays, matrix) {
  Object.keys(arrays).forEach(function(name) {
    const array = arrays[name];
    if (name.indexOf("pos") >= 0) {
      reorientPositions(array, matrix);
    } else if (name.indexOf("tan") >= 0 || name.indexOf("binorm") >= 0) {
      reorientDirections(array, matrix);
    } else if (name.indexOf("norm") >= 0) {
      reorientNormals(array, matrix);
    }
  });
  return arrays;
}

/**
 * Creates XY quad BufferInfo
 *
 * The default with no parameters will return a 2x2 quad with values from -1 to +1.
 * If you want a unit quad with that goes from 0 to 1 you'd call it with
 *
 *     twgl.primitives.createXYQuadBufferInfo(gl, 1, 0.5, 0.5);
 *
 * If you want a unit quad centered above 0,0 you'd call it with
 *
 *     twgl.primitives.createXYQuadBufferInfo(gl, 1, 0, 0.5);
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} [size] the size across the quad. Defaults to 2 which means vertices will go from -1 to +1
 * @param {number} [xOffset] the amount to offset the quad in X
 * @param {number} [yOffset] the amount to offset the quad in Y
 * @return {Object.<string, WebGLBuffer>} the created XY Quad BufferInfo
 * @memberOf module:twgl/primitives
 * @function createXYQuadBuffers
 */

/**
 * Creates XY quad Buffers
 *
 * The default with no parameters will return a 2x2 quad with values from -1 to +1.
 * If you want a unit quad with that goes from 0 to 1 you'd call it with
 *
 *     twgl.primitives.createXYQuadBufferInfo(gl, 1, 0.5, 0.5);
 *
 * If you want a unit quad centered above 0,0 you'd call it with
 *
 *     twgl.primitives.createXYQuadBufferInfo(gl, 1, 0, 0.5);
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} [size] the size across the quad. Defaults to 2 which means vertices will go from -1 to +1
 * @param {number} [xOffset] the amount to offset the quad in X
 * @param {number} [yOffset] the amount to offset the quad in Y
 * @return {module:twgl.BufferInfo} the created XY Quad buffers
 * @memberOf module:twgl/primitives
 * @function createXYQuadBufferInfo
 */

/**
 * Creates XY quad vertices
 *
 * The default with no parameters will return a 2x2 quad with values from -1 to +1.
 * If you want a unit quad with that goes from 0 to 1 you'd call it with
 *
 *     twgl.primitives.createXYQuadVertices(1, 0.5, 0.5);
 *
 * If you want a unit quad centered above 0,0 you'd call it with
 *
 *     twgl.primitives.createXYQuadVertices(1, 0, 0.5);
 *
 * @param {number} [size] the size across the quad. Defaults to 2 which means vertices will go from -1 to +1
 * @param {number} [xOffset] the amount to offset the quad in X
 * @param {number} [yOffset] the amount to offset the quad in Y
 * @return {Object.<string, TypedArray>} the created XY Quad vertices
 * @memberOf module:twgl/primitives
 */
function createXYQuadVertices(size, xOffset, yOffset) {
  size = size || 2;
  xOffset = xOffset || 0;
  yOffset = yOffset || 0;
  size *= 0.5;
  return {
    position: {
      numComponents: 2,
      data: [
        xOffset + -1 * size, yOffset + -1 * size,
        xOffset +  1 * size, yOffset + -1 * size,
        xOffset + -1 * size, yOffset +  1 * size,
        xOffset +  1 * size, yOffset +  1 * size,
      ],
    },
    normal: [
      0, 0, 1,
      0, 0, 1,
      0, 0, 1,
      0, 0, 1,
    ],
    texcoord: [
      0, 0,
      1, 0,
      0, 1,
      1, 1,
    ],
    indices: [ 0, 1, 2, 2, 1, 3 ],
  };
}

/**
 * Creates XZ plane BufferInfo.
 *
 * The created plane has position, normal, and texcoord data
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} [width] Width of the plane. Default = 1
 * @param {number} [depth] Depth of the plane. Default = 1
 * @param {number} [subdivisionsWidth] Number of steps across the plane. Default = 1
 * @param {number} [subdivisionsDepth] Number of steps down the plane. Default = 1
 * @param {module:twgl/m4.Mat4} [matrix] A matrix by which to multiply all the vertices.
 * @return {module:twgl.BufferInfo} The created plane BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createPlaneBufferInfo
 */

/**
 * Creates XZ plane buffers.
 *
 * The created plane has position, normal, and texcoord data
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} [width] Width of the plane. Default = 1
 * @param {number} [depth] Depth of the plane. Default = 1
 * @param {number} [subdivisionsWidth] Number of steps across the plane. Default = 1
 * @param {number} [subdivisionsDepth] Number of steps down the plane. Default = 1
 * @param {module:twgl/m4.Mat4} [matrix] A matrix by which to multiply all the vertices.
 * @return {Object.<string, WebGLBuffer>} The created plane buffers.
 * @memberOf module:twgl/primitives
 * @function createPlaneBuffers
 */

/**
 * Creates XZ plane vertices.
 *
 * The created plane has position, normal, and texcoord data
 *
 * @param {number} [width] Width of the plane. Default = 1
 * @param {number} [depth] Depth of the plane. Default = 1
 * @param {number} [subdivisionsWidth] Number of steps across the plane. Default = 1
 * @param {number} [subdivisionsDepth] Number of steps down the plane. Default = 1
 * @param {module:twgl/m4.Mat4} [matrix] A matrix by which to multiply all the vertices.
 * @return {Object.<string, TypedArray>} The created plane vertices.
 * @memberOf module:twgl/primitives
 */
function createPlaneVertices(
    width,
    depth,
    subdivisionsWidth,
    subdivisionsDepth,
    matrix) {
  width = width || 1;
  depth = depth || 1;
  subdivisionsWidth = subdivisionsWidth || 1;
  subdivisionsDepth = subdivisionsDepth || 1;
  matrix = matrix || identity();

  const numVertices = (subdivisionsWidth + 1) * (subdivisionsDepth + 1);
  const positions = createAugmentedTypedArray(3, numVertices);
  const normals = createAugmentedTypedArray(3, numVertices);
  const texcoords = createAugmentedTypedArray(2, numVertices);

  for (let z = 0; z <= subdivisionsDepth; z++) {
    for (let x = 0; x <= subdivisionsWidth; x++) {
      const u = x / subdivisionsWidth;
      const v = z / subdivisionsDepth;
      positions.push(
          width * u - width * 0.5,
          0,
          depth * v - depth * 0.5);
      normals.push(0, 1, 0);
      texcoords.push(u, v);
    }
  }

  const numVertsAcross = subdivisionsWidth + 1;
  const indices = createAugmentedTypedArray(
      3, subdivisionsWidth * subdivisionsDepth * 2, Uint16Array);

  for (let z = 0; z < subdivisionsDepth; z++) {  // eslint-disable-line
    for (let x = 0; x < subdivisionsWidth; x++) {  // eslint-disable-line
      // Make triangle 1 of quad.
      indices.push(
          (z + 0) * numVertsAcross + x,
          (z + 1) * numVertsAcross + x,
          (z + 0) * numVertsAcross + x + 1);

      // Make triangle 2 of quad.
      indices.push(
          (z + 1) * numVertsAcross + x,
          (z + 1) * numVertsAcross + x + 1,
          (z + 0) * numVertsAcross + x + 1);
    }
  }

  const arrays = reorientVertices({
    position: positions,
    normal: normals,
    texcoord: texcoords,
    indices: indices,
  }, matrix);
  return arrays;
}

/**
 * Creates sphere BufferInfo.
 *
 * The created sphere has position, normal, and texcoord data
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius radius of the sphere.
 * @param {number} subdivisionsAxis number of steps around the sphere.
 * @param {number} subdivisionsHeight number of vertically on the sphere.
 * @param {number} [opt_startLatitudeInRadians] where to start the
 *     top of the sphere. Default = 0.
 * @param {number} [opt_endLatitudeInRadians] Where to end the
 *     bottom of the sphere. Default = Math.PI.
 * @param {number} [opt_startLongitudeInRadians] where to start
 *     wrapping the sphere. Default = 0.
 * @param {number} [opt_endLongitudeInRadians] where to end
 *     wrapping the sphere. Default = 2 * Math.PI.
 * @return {module:twgl.BufferInfo} The created sphere BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createSphereBufferInfo
 */

/**
 * Creates sphere buffers.
 *
 * The created sphere has position, normal, and texcoord data
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius radius of the sphere.
 * @param {number} subdivisionsAxis number of steps around the sphere.
 * @param {number} subdivisionsHeight number of vertically on the sphere.
 * @param {number} [opt_startLatitudeInRadians] where to start the
 *     top of the sphere. Default = 0.
 * @param {number} [opt_endLatitudeInRadians] Where to end the
 *     bottom of the sphere. Default = Math.PI.
 * @param {number} [opt_startLongitudeInRadians] where to start
 *     wrapping the sphere. Default = 0.
 * @param {number} [opt_endLongitudeInRadians] where to end
 *     wrapping the sphere. Default = 2 * Math.PI.
 * @return {Object.<string, WebGLBuffer>} The created sphere buffers.
 * @memberOf module:twgl/primitives
 * @function createSphereBuffers
 */

/**
 * Creates sphere vertices.
 *
 * The created sphere has position, normal, and texcoord data
 *
 * @param {number} radius radius of the sphere.
 * @param {number} subdivisionsAxis number of steps around the sphere.
 * @param {number} subdivisionsHeight number of vertically on the sphere.
 * @param {number} [opt_startLatitudeInRadians] where to start the
 *     top of the sphere. Default = 0.
 * @param {number} [opt_endLatitudeInRadians] Where to end the
 *     bottom of the sphere. Default = Math.PI.
 * @param {number} [opt_startLongitudeInRadians] where to start
 *     wrapping the sphere. Default = 0.
 * @param {number} [opt_endLongitudeInRadians] where to end
 *     wrapping the sphere. Default = 2 * Math.PI.
 * @return {Object.<string, TypedArray>} The created sphere vertices.
 * @memberOf module:twgl/primitives
 */
function createSphereVertices(
    radius,
    subdivisionsAxis,
    subdivisionsHeight,
    opt_startLatitudeInRadians,
    opt_endLatitudeInRadians,
    opt_startLongitudeInRadians,
    opt_endLongitudeInRadians) {
  if (subdivisionsAxis <= 0 || subdivisionsHeight <= 0) {
    throw new Error('subdivisionAxis and subdivisionHeight must be > 0');
  }

  opt_startLatitudeInRadians = opt_startLatitudeInRadians || 0;
  opt_endLatitudeInRadians = opt_endLatitudeInRadians || Math.PI;
  opt_startLongitudeInRadians = opt_startLongitudeInRadians || 0;
  opt_endLongitudeInRadians = opt_endLongitudeInRadians || (Math.PI * 2);

  const latRange = opt_endLatitudeInRadians - opt_startLatitudeInRadians;
  const longRange = opt_endLongitudeInRadians - opt_startLongitudeInRadians;

  // We are going to generate our sphere by iterating through its
  // spherical coordinates and generating 2 triangles for each quad on a
  // ring of the sphere.
  const numVertices = (subdivisionsAxis + 1) * (subdivisionsHeight + 1);
  const positions = createAugmentedTypedArray(3, numVertices);
  const normals   = createAugmentedTypedArray(3, numVertices);
  const texcoords = createAugmentedTypedArray(2, numVertices);

  // Generate the individual vertices in our vertex buffer.
  for (let y = 0; y <= subdivisionsHeight; y++) {
    for (let x = 0; x <= subdivisionsAxis; x++) {
      // Generate a vertex based on its spherical coordinates
      const u = x / subdivisionsAxis;
      const v = y / subdivisionsHeight;
      const theta = longRange * u + opt_startLongitudeInRadians;
      const phi = latRange * v + opt_startLatitudeInRadians;
      const sinTheta = Math.sin(theta);
      const cosTheta = Math.cos(theta);
      const sinPhi = Math.sin(phi);
      const cosPhi = Math.cos(phi);
      const ux = cosTheta * sinPhi;
      const uy = cosPhi;
      const uz = sinTheta * sinPhi;
      positions.push(radius * ux, radius * uy, radius * uz);
      normals.push(ux, uy, uz);
      texcoords.push(1 - u, v);
    }
  }

  const numVertsAround = subdivisionsAxis + 1;
  const indices = createAugmentedTypedArray(3, subdivisionsAxis * subdivisionsHeight * 2, Uint16Array);
  for (let x = 0; x < subdivisionsAxis; x++) {  // eslint-disable-line
    for (let y = 0; y < subdivisionsHeight; y++) {  // eslint-disable-line
      // Make triangle 1 of quad.
      indices.push(
          (y + 0) * numVertsAround + x,
          (y + 0) * numVertsAround + x + 1,
          (y + 1) * numVertsAround + x);

      // Make triangle 2 of quad.
      indices.push(
          (y + 1) * numVertsAround + x,
          (y + 0) * numVertsAround + x + 1,
          (y + 1) * numVertsAround + x + 1);
    }
  }

  return {
    position: positions,
    normal: normals,
    texcoord: texcoords,
    indices: indices,
  };
}

/**
 * Array of the indices of corners of each face of a cube.
 * @type {Array.<number[]>}
 * @private
 */
const CUBE_FACE_INDICES = [
  [3, 7, 5, 1],  // right
  [6, 2, 0, 4],  // left
  [6, 7, 3, 2],  // ??
  [0, 1, 5, 4],  // ??
  [7, 6, 4, 5],  // front
  [2, 3, 1, 0],  // back
];

/**
 * Creates a BufferInfo for a cube.
 *
 * The cube is created around the origin. (-size / 2, size / 2).
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} [size] width, height and depth of the cube.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createCubeBufferInfo
 */

/**
 * Creates the buffers and indices for a cube.
 *
 * The cube is created around the origin. (-size / 2, size / 2).
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} [size] width, height and depth of the cube.
 * @return {Object.<string, WebGLBuffer>} The created buffers.
 * @memberOf module:twgl/primitives
 * @function createCubeBuffers
 */

/**
 * Creates the vertices and indices for a cube.
 *
 * The cube is created around the origin. (-size / 2, size / 2).
 *
 * @param {number} [size] width, height and depth of the cube.
 * @return {Object.<string, TypedArray>} The created vertices.
 * @memberOf module:twgl/primitives
 */
function createCubeVertices(size) {
  size = size || 1;
  const k = size / 2;

  const cornerVertices = [
    [-k, -k, -k],
    [+k, -k, -k],
    [-k, +k, -k],
    [+k, +k, -k],
    [-k, -k, +k],
    [+k, -k, +k],
    [-k, +k, +k],
    [+k, +k, +k],
  ];

  const faceNormals = [
    [+1, +0, +0],
    [-1, +0, +0],
    [+0, +1, +0],
    [+0, -1, +0],
    [+0, +0, +1],
    [+0, +0, -1],
  ];

  const uvCoords = [
    [1, 0],
    [0, 0],
    [0, 1],
    [1, 1],
  ];

  const numVertices = 6 * 4;
  const positions = createAugmentedTypedArray(3, numVertices);
  const normals   = createAugmentedTypedArray(3, numVertices);
  const texcoords = createAugmentedTypedArray(2 , numVertices);
  const indices   = createAugmentedTypedArray(3, 6 * 2, Uint16Array);

  for (let f = 0; f < 6; ++f) {
    const faceIndices = CUBE_FACE_INDICES[f];
    for (let v = 0; v < 4; ++v) {
      const position = cornerVertices[faceIndices[v]];
      const normal = faceNormals[f];
      const uv = uvCoords[v];

      // Each face needs all four vertices because the normals and texture
      // coordinates are not all the same.
      positions.push(position);
      normals.push(normal);
      texcoords.push(uv);

    }
    // Two triangles make a square face.
    const offset = 4 * f;
    indices.push(offset + 0, offset + 1, offset + 2);
    indices.push(offset + 0, offset + 2, offset + 3);
  }

  return {
    position: positions,
    normal: normals,
    texcoord: texcoords,
    indices: indices,
  };
}

/**
 * Creates a BufferInfo for a truncated cone, which is like a cylinder
 * except that it has different top and bottom radii. A truncated cone
 * can also be used to create cylinders and regular cones. The
 * truncated cone will be created centered about the origin, with the
 * y axis as its vertical axis.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} bottomRadius Bottom radius of truncated cone.
 * @param {number} topRadius Top radius of truncated cone.
 * @param {number} height Height of truncated cone.
 * @param {number} radialSubdivisions The number of subdivisions around the
 *     truncated cone.
 * @param {number} verticalSubdivisions The number of subdivisions down the
 *     truncated cone.
 * @param {boolean} [opt_topCap] Create top cap. Default = true.
 * @param {boolean} [opt_bottomCap] Create bottom cap. Default = true.
 * @return {module:twgl.BufferInfo} The created cone BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createTruncatedConeBufferInfo
 */

/**
 * Creates buffers for a truncated cone, which is like a cylinder
 * except that it has different top and bottom radii. A truncated cone
 * can also be used to create cylinders and regular cones. The
 * truncated cone will be created centered about the origin, with the
 * y axis as its vertical axis.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} bottomRadius Bottom radius of truncated cone.
 * @param {number} topRadius Top radius of truncated cone.
 * @param {number} height Height of truncated cone.
 * @param {number} radialSubdivisions The number of subdivisions around the
 *     truncated cone.
 * @param {number} verticalSubdivisions The number of subdivisions down the
 *     truncated cone.
 * @param {boolean} [opt_topCap] Create top cap. Default = true.
 * @param {boolean} [opt_bottomCap] Create bottom cap. Default = true.
 * @return {Object.<string, WebGLBuffer>} The created cone buffers.
 * @memberOf module:twgl/primitives
 * @function createTruncatedConeBuffers
 */

/**
 * Creates vertices for a truncated cone, which is like a cylinder
 * except that it has different top and bottom radii. A truncated cone
 * can also be used to create cylinders and regular cones. The
 * truncated cone will be created centered about the origin, with the
 * y axis as its vertical axis. .
 *
 * @param {number} bottomRadius Bottom radius of truncated cone.
 * @param {number} topRadius Top radius of truncated cone.
 * @param {number} height Height of truncated cone.
 * @param {number} radialSubdivisions The number of subdivisions around the
 *     truncated cone.
 * @param {number} verticalSubdivisions The number of subdivisions down the
 *     truncated cone.
 * @param {boolean} [opt_topCap] Create top cap. Default = true.
 * @param {boolean} [opt_bottomCap] Create bottom cap. Default = true.
 * @return {Object.<string, TypedArray>} The created cone vertices.
 * @memberOf module:twgl/primitives
 */
function createTruncatedConeVertices(
    bottomRadius,
    topRadius,
    height,
    radialSubdivisions,
    verticalSubdivisions,
    opt_topCap,
    opt_bottomCap) {
  if (radialSubdivisions < 3) {
    throw new Error('radialSubdivisions must be 3 or greater');
  }

  if (verticalSubdivisions < 1) {
    throw new Error('verticalSubdivisions must be 1 or greater');
  }

  const topCap = (opt_topCap === undefined) ? true : opt_topCap;
  const bottomCap = (opt_bottomCap === undefined) ? true : opt_bottomCap;

  const extra = (topCap ? 2 : 0) + (bottomCap ? 2 : 0);

  const numVertices = (radialSubdivisions + 1) * (verticalSubdivisions + 1 + extra);
  const positions = createAugmentedTypedArray(3, numVertices);
  const normals   = createAugmentedTypedArray(3, numVertices);
  const texcoords = createAugmentedTypedArray(2, numVertices);
  const indices   = createAugmentedTypedArray(3, radialSubdivisions * (verticalSubdivisions + extra / 2) * 2, Uint16Array);

  const vertsAroundEdge = radialSubdivisions + 1;

  // The slant of the cone is constant across its surface
  const slant = Math.atan2(bottomRadius - topRadius, height);
  const cosSlant = Math.cos(slant);
  const sinSlant = Math.sin(slant);

  const start = topCap ? -2 : 0;
  const end = verticalSubdivisions + (bottomCap ? 2 : 0);

  for (let yy = start; yy <= end; ++yy) {
    let v = yy / verticalSubdivisions;
    let y = height * v;
    let ringRadius;
    if (yy < 0) {
      y = 0;
      v = 1;
      ringRadius = bottomRadius;
    } else if (yy > verticalSubdivisions) {
      y = height;
      v = 1;
      ringRadius = topRadius;
    } else {
      ringRadius = bottomRadius +
        (topRadius - bottomRadius) * (yy / verticalSubdivisions);
    }
    if (yy === -2 || yy === verticalSubdivisions + 2) {
      ringRadius = 0;
      v = 0;
    }
    y -= height / 2;
    for (let ii = 0; ii < vertsAroundEdge; ++ii) {
      const sin = Math.sin(ii * Math.PI * 2 / radialSubdivisions);
      const cos = Math.cos(ii * Math.PI * 2 / radialSubdivisions);
      positions.push(sin * ringRadius, y, cos * ringRadius);
      if (yy < 0) {
        normals.push(0, -1, 0);
      } else if (yy > verticalSubdivisions) {
        normals.push(0, 1, 0);
      } else if (ringRadius === 0.0) {
        normals.push(0, 0, 0);
      } else {
        normals.push(sin * cosSlant, sinSlant, cos * cosSlant);
      }
      texcoords.push((ii / radialSubdivisions), 1 - v);
    }
  }

  for (let yy = 0; yy < verticalSubdivisions + extra; ++yy) {  // eslint-disable-line
    if (yy === 1 && topCap || yy === verticalSubdivisions + extra - 2 && bottomCap) {
      continue;
    }
    for (let ii = 0; ii < radialSubdivisions; ++ii) {  // eslint-disable-line
      indices.push(vertsAroundEdge * (yy + 0) + 0 + ii,
                   vertsAroundEdge * (yy + 0) + 1 + ii,
                   vertsAroundEdge * (yy + 1) + 1 + ii);
      indices.push(vertsAroundEdge * (yy + 0) + 0 + ii,
                   vertsAroundEdge * (yy + 1) + 1 + ii,
                   vertsAroundEdge * (yy + 1) + 0 + ii);
    }
  }

  return {
    position: positions,
    normal: normals,
    texcoord: texcoords,
    indices: indices,
  };
}

/**
 * Expands RLE data
 * @param {number[]} rleData data in format of run-length, x, y, z, run-length, x, y, z
 * @param {number[]} [padding] value to add each entry with.
 * @return {number[]} the expanded rleData
 * @private
 */
function expandRLEData(rleData, padding) {
  padding = padding || [];
  const data = [];
  for (let ii = 0; ii < rleData.length; ii += 4) {
    const runLength = rleData[ii];
    const element = rleData.slice(ii + 1, ii + 4);
    element.push.apply(element, padding);
    for (let jj = 0; jj < runLength; ++jj) {
      data.push.apply(data, element);
    }
  }
  return data;
}

/**
 * Creates 3D 'F' BufferInfo.
 * An 'F' is useful because you can easily tell which way it is oriented.
 * The created 'F' has position, normal, texcoord, and color buffers.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function create3DFBufferInfo
 */

/**
 * Creates 3D 'F' buffers.
 * An 'F' is useful because you can easily tell which way it is oriented.
 * The created 'F' has position, normal, texcoord, and color buffers.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @return {Object.<string, WebGLBuffer>} The created buffers.
 * @memberOf module:twgl/primitives
 * @function create3DFBuffers
 */

/**
 * Creates 3D 'F' vertices.
 * An 'F' is useful because you can easily tell which way it is oriented.
 * The created 'F' has position, normal, texcoord, and color arrays.
 *
 * @return {Object.<string, TypedArray>} The created vertices.
 * @memberOf module:twgl/primitives
 */
function create3DFVertices() {

  const positions = [
    // left column front
    0,   0,  0,
    0, 150,  0,
    30,   0,  0,
    0, 150,  0,
    30, 150,  0,
    30,   0,  0,

    // top rung front
    30,   0,  0,
    30,  30,  0,
    100,   0,  0,
    30,  30,  0,
    100,  30,  0,
    100,   0,  0,

    // middle rung front
    30,  60,  0,
    30,  90,  0,
    67,  60,  0,
    30,  90,  0,
    67,  90,  0,
    67,  60,  0,

    // left column back
      0,   0,  30,
     30,   0,  30,
      0, 150,  30,
      0, 150,  30,
     30,   0,  30,
     30, 150,  30,

    // top rung back
     30,   0,  30,
    100,   0,  30,
     30,  30,  30,
     30,  30,  30,
    100,   0,  30,
    100,  30,  30,

    // middle rung back
     30,  60,  30,
     67,  60,  30,
     30,  90,  30,
     30,  90,  30,
     67,  60,  30,
     67,  90,  30,

    // top
      0,   0,   0,
    100,   0,   0,
    100,   0,  30,
      0,   0,   0,
    100,   0,  30,
      0,   0,  30,

    // top rung front
    100,   0,   0,
    100,  30,   0,
    100,  30,  30,
    100,   0,   0,
    100,  30,  30,
    100,   0,  30,

    // under top rung
    30,   30,   0,
    30,   30,  30,
    100,  30,  30,
    30,   30,   0,
    100,  30,  30,
    100,  30,   0,

    // between top rung and middle
    30,   30,   0,
    30,   60,  30,
    30,   30,  30,
    30,   30,   0,
    30,   60,   0,
    30,   60,  30,

    // top of middle rung
    30,   60,   0,
    67,   60,  30,
    30,   60,  30,
    30,   60,   0,
    67,   60,   0,
    67,   60,  30,

    // front of middle rung
    67,   60,   0,
    67,   90,  30,
    67,   60,  30,
    67,   60,   0,
    67,   90,   0,
    67,   90,  30,

    // bottom of middle rung.
    30,   90,   0,
    30,   90,  30,
    67,   90,  30,
    30,   90,   0,
    67,   90,  30,
    67,   90,   0,

    // front of bottom
    30,   90,   0,
    30,  150,  30,
    30,   90,  30,
    30,   90,   0,
    30,  150,   0,
    30,  150,  30,

    // bottom
    0,   150,   0,
    0,   150,  30,
    30,  150,  30,
    0,   150,   0,
    30,  150,  30,
    30,  150,   0,

    // left side
    0,   0,   0,
    0,   0,  30,
    0, 150,  30,
    0,   0,   0,
    0, 150,  30,
    0, 150,   0,
  ];

  const texcoords = [
    // left column front
    0.22, 0.19,
    0.22, 0.79,
    0.34, 0.19,
    0.22, 0.79,
    0.34, 0.79,
    0.34, 0.19,

    // top rung front
    0.34, 0.19,
    0.34, 0.31,
    0.62, 0.19,
    0.34, 0.31,
    0.62, 0.31,
    0.62, 0.19,

    // middle rung front
    0.34, 0.43,
    0.34, 0.55,
    0.49, 0.43,
    0.34, 0.55,
    0.49, 0.55,
    0.49, 0.43,

    // left column back
    0, 0,
    1, 0,
    0, 1,
    0, 1,
    1, 0,
    1, 1,

    // top rung back
    0, 0,
    1, 0,
    0, 1,
    0, 1,
    1, 0,
    1, 1,

    // middle rung back
    0, 0,
    1, 0,
    0, 1,
    0, 1,
    1, 0,
    1, 1,

    // top
    0, 0,
    1, 0,
    1, 1,
    0, 0,
    1, 1,
    0, 1,

    // top rung front
    0, 0,
    1, 0,
    1, 1,
    0, 0,
    1, 1,
    0, 1,

    // under top rung
    0, 0,
    0, 1,
    1, 1,
    0, 0,
    1, 1,
    1, 0,

    // between top rung and middle
    0, 0,
    1, 1,
    0, 1,
    0, 0,
    1, 0,
    1, 1,

    // top of middle rung
    0, 0,
    1, 1,
    0, 1,
    0, 0,
    1, 0,
    1, 1,

    // front of middle rung
    0, 0,
    1, 1,
    0, 1,
    0, 0,
    1, 0,
    1, 1,

    // bottom of middle rung.
    0, 0,
    0, 1,
    1, 1,
    0, 0,
    1, 1,
    1, 0,

    // front of bottom
    0, 0,
    1, 1,
    0, 1,
    0, 0,
    1, 0,
    1, 1,

    // bottom
    0, 0,
    0, 1,
    1, 1,
    0, 0,
    1, 1,
    1, 0,

    // left side
    0, 0,
    0, 1,
    1, 1,
    0, 0,
    1, 1,
    1, 0,
  ];

  const normals = expandRLEData([
    // left column front
    // top rung front
    // middle rung front
    18, 0, 0, 1,

    // left column back
    // top rung back
    // middle rung back
    18, 0, 0, -1,

    // top
    6, 0, 1, 0,

    // top rung front
    6, 1, 0, 0,

    // under top rung
    6, 0, -1, 0,

    // between top rung and middle
    6, 1, 0, 0,

    // top of middle rung
    6, 0, 1, 0,

    // front of middle rung
    6, 1, 0, 0,

    // bottom of middle rung.
    6, 0, -1, 0,

    // front of bottom
    6, 1, 0, 0,

    // bottom
    6, 0, -1, 0,

    // left side
    6, -1, 0, 0,
  ]);

  const colors = expandRLEData([
        // left column front
        // top rung front
        // middle rung front
      18, 200,  70, 120,

        // left column back
        // top rung back
        // middle rung back
      18, 80, 70, 200,

        // top
      6, 70, 200, 210,

        // top rung front
      6, 200, 200, 70,

        // under top rung
      6, 210, 100, 70,

        // between top rung and middle
      6, 210, 160, 70,

        // top of middle rung
      6, 70, 180, 210,

        // front of middle rung
      6, 100, 70, 210,

        // bottom of middle rung.
      6, 76, 210, 100,

        // front of bottom
      6, 140, 210, 80,

        // bottom
      6, 90, 130, 110,

        // left side
      6, 160, 160, 220,
  ], [255]);

  const numVerts = positions.length / 3;

  const arrays = {
    position: createAugmentedTypedArray(3, numVerts),
    texcoord: createAugmentedTypedArray(2,  numVerts),
    normal: createAugmentedTypedArray(3, numVerts),
    color: createAugmentedTypedArray(4, numVerts, Uint8Array),
    indices: createAugmentedTypedArray(3, numVerts / 3, Uint16Array),
  };

  arrays.position.push(positions);
  arrays.texcoord.push(texcoords);
  arrays.normal.push(normals);
  arrays.color.push(colors);

  for (let ii = 0; ii < numVerts; ++ii) {
    arrays.indices.push(ii);
  }

  return arrays;
}

/**
 * Creates crescent BufferInfo.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} verticalRadius The vertical radius of the crescent.
 * @param {number} outerRadius The outer radius of the crescent.
 * @param {number} innerRadius The inner radius of the crescent.
 * @param {number} thickness The thickness of the crescent.
 * @param {number} subdivisionsDown number of steps around the crescent.
 * @param {number} [startOffset] Where to start arc. Default 0.
 * @param {number} [endOffset] Where to end arg. Default 1.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createCresentBufferInfo
 */

/**
 * Creates crescent buffers.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} verticalRadius The vertical radius of the crescent.
 * @param {number} outerRadius The outer radius of the crescent.
 * @param {number} innerRadius The inner radius of the crescent.
 * @param {number} thickness The thickness of the crescent.
 * @param {number} subdivisionsDown number of steps around the crescent.
 * @param {number} [startOffset] Where to start arc. Default 0.
 * @param {number} [endOffset] Where to end arg. Default 1.
 * @return {Object.<string, WebGLBuffer>} The created buffers.
 * @memberOf module:twgl/primitives
 * @function createCresentBuffers
 */

/**
 * Creates crescent vertices.
 *
 * @param {number} verticalRadius The vertical radius of the crescent.
 * @param {number} outerRadius The outer radius of the crescent.
 * @param {number} innerRadius The inner radius of the crescent.
 * @param {number} thickness The thickness of the crescent.
 * @param {number} subdivisionsDown number of steps around the crescent.
 * @param {number} [startOffset] Where to start arc. Default 0.
 * @param {number} [endOffset] Where to end arg. Default 1.
 * @return {Object.<string, TypedArray>} The created vertices.
 * @memberOf module:twgl/primitives
 * @function createCresentBuffers
 */

/**
 * Creates crescent BufferInfo.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} verticalRadius The vertical radius of the crescent.
 * @param {number} outerRadius The outer radius of the crescent.
 * @param {number} innerRadius The inner radius of the crescent.
 * @param {number} thickness The thickness of the crescent.
 * @param {number} subdivisionsDown number of steps around the crescent.
 * @param {number} [startOffset] Where to start arc. Default 0.
 * @param {number} [endOffset] Where to end arg. Default 1.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createCrescentBufferInfo
 */

/**
 * Creates crescent buffers.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} verticalRadius The vertical radius of the crescent.
 * @param {number} outerRadius The outer radius of the crescent.
 * @param {number} innerRadius The inner radius of the crescent.
 * @param {number} thickness The thickness of the crescent.
 * @param {number} subdivisionsDown number of steps around the crescent.
 * @param {number} [startOffset] Where to start arc. Default 0.
 * @param {number} [endOffset] Where to end arg. Default 1.
 * @return {Object.<string, WebGLBuffer>} The created buffers.
 * @memberOf module:twgl/primitives
 * @function createCrescentBuffers
 */

/**
 * Creates crescent vertices.
 *
 * @param {number} verticalRadius The vertical radius of the crescent.
 * @param {number} outerRadius The outer radius of the crescent.
 * @param {number} innerRadius The inner radius of the crescent.
 * @param {number} thickness The thickness of the crescent.
 * @param {number} subdivisionsDown number of steps around the crescent.
 * @param {number} [startOffset] Where to start arc. Default 0.
 * @param {number} [endOffset] Where to end arg. Default 1.
 * @return {Object.<string, TypedArray>} The created vertices.
 * @memberOf module:twgl/primitives
 */
 function createCrescentVertices(
    verticalRadius,
    outerRadius,
    innerRadius,
    thickness,
    subdivisionsDown,
    startOffset,
    endOffset) {
  if (subdivisionsDown <= 0) {
    throw new Error('subdivisionDown must be > 0');
  }

  startOffset = startOffset || 0;
  endOffset   = endOffset || 1;

  const subdivisionsThick = 2;

  const offsetRange = endOffset - startOffset;
  const numVertices = (subdivisionsDown + 1) * 2 * (2 + subdivisionsThick);
  const positions   = createAugmentedTypedArray(3, numVertices);
  const normals     = createAugmentedTypedArray(3, numVertices);
  const texcoords   = createAugmentedTypedArray(2, numVertices);

  function lerp(a, b, s) {
    return a + (b - a) * s;
  }

  function createArc(arcRadius, x, normalMult, normalAdd, uMult, uAdd) {
    for (let z = 0; z <= subdivisionsDown; z++) {
      const uBack = x / (subdivisionsThick - 1);
      const v = z / subdivisionsDown;
      const xBack = (uBack - 0.5) * 2;
      const angle = (startOffset + (v * offsetRange)) * Math.PI;
      const s = Math.sin(angle);
      const c = Math.cos(angle);
      const radius = lerp(verticalRadius, arcRadius, s);
      const px = xBack * thickness;
      const py = c * verticalRadius;
      const pz = s * radius;
      positions.push(px, py, pz);
      const n = add(multiply([0, s, c], normalMult), normalAdd);
      normals.push(n);
      texcoords.push(uBack * uMult + uAdd, v);
    }
  }

  // Generate the individual vertices in our vertex buffer.
  for (let x = 0; x < subdivisionsThick; x++) {
    const uBack = (x / (subdivisionsThick - 1) - 0.5) * 2;
    createArc(outerRadius, x, [1, 1, 1], [0,     0, 0], 1, 0);
    createArc(outerRadius, x, [0, 0, 0], [uBack, 0, 0], 0, 0);
    createArc(innerRadius, x, [1, 1, 1], [0,     0, 0], 1, 0);
    createArc(innerRadius, x, [0, 0, 0], [uBack, 0, 0], 0, 1);
  }

  // Do outer surface.
  const indices = createAugmentedTypedArray(3, (subdivisionsDown * 2) * (2 + subdivisionsThick), Uint16Array);

  function createSurface(leftArcOffset, rightArcOffset) {
    for (let z = 0; z < subdivisionsDown; ++z) {
      // Make triangle 1 of quad.
      indices.push(
          leftArcOffset + z + 0,
          leftArcOffset + z + 1,
          rightArcOffset + z + 0);

      // Make triangle 2 of quad.
      indices.push(
          leftArcOffset + z + 1,
          rightArcOffset + z + 1,
          rightArcOffset + z + 0);
    }
  }

  const numVerticesDown = subdivisionsDown + 1;
  // front
  createSurface(numVerticesDown * 0, numVerticesDown * 4);
  // right
  createSurface(numVerticesDown * 5, numVerticesDown * 7);
  // back
  createSurface(numVerticesDown * 6, numVerticesDown * 2);
  // left
  createSurface(numVerticesDown * 3, numVerticesDown * 1);

  return {
    position: positions,
    normal:   normals,
    texcoord: texcoords,
    indices:  indices,
  };
}

/**
 * Creates cylinder BufferInfo. The cylinder will be created around the origin
 * along the y-axis.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius Radius of cylinder.
 * @param {number} height Height of cylinder.
 * @param {number} radialSubdivisions The number of subdivisions around the cylinder.
 * @param {number} verticalSubdivisions The number of subdivisions down the cylinder.
 * @param {boolean} [topCap] Create top cap. Default = true.
 * @param {boolean} [bottomCap] Create bottom cap. Default = true.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createCylinderBufferInfo
 */

 /**
  * Creates cylinder buffers. The cylinder will be created around the origin
  * along the y-axis.
  *
  * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
  * @param {number} radius Radius of cylinder.
  * @param {number} height Height of cylinder.
  * @param {number} radialSubdivisions The number of subdivisions around the cylinder.
  * @param {number} verticalSubdivisions The number of subdivisions down the cylinder.
  * @param {boolean} [topCap] Create top cap. Default = true.
  * @param {boolean} [bottomCap] Create bottom cap. Default = true.
  * @return {Object.<string, WebGLBuffer>} The created buffers.
  * @memberOf module:twgl/primitives
  * @function createCylinderBuffers
  */

 /**
  * Creates cylinder vertices. The cylinder will be created around the origin
  * along the y-axis.
  *
  * @param {number} radius Radius of cylinder.
  * @param {number} height Height of cylinder.
  * @param {number} radialSubdivisions The number of subdivisions around the cylinder.
  * @param {number} verticalSubdivisions The number of subdivisions down the cylinder.
  * @param {boolean} [topCap] Create top cap. Default = true.
  * @param {boolean} [bottomCap] Create bottom cap. Default = true.
  * @return {Object.<string, TypedArray>} The created vertices.
  * @memberOf module:twgl/primitives
  */
function createCylinderVertices(
    radius,
    height,
    radialSubdivisions,
    verticalSubdivisions,
    topCap,
    bottomCap) {
  return createTruncatedConeVertices(
      radius,
      radius,
      height,
      radialSubdivisions,
      verticalSubdivisions,
      topCap,
      bottomCap);
}

/**
 * Creates BufferInfo for a torus
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius radius of center of torus circle.
 * @param {number} thickness radius of torus ring.
 * @param {number} radialSubdivisions The number of subdivisions around the torus.
 * @param {number} bodySubdivisions The number of subdivisions around the body torus.
 * @param {boolean} [startAngle] start angle in radians. Default = 0.
 * @param {boolean} [endAngle] end angle in radians. Default = Math.PI * 2.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createTorusBufferInfo
 */

/**
 * Creates buffers for a torus
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius radius of center of torus circle.
 * @param {number} thickness radius of torus ring.
 * @param {number} radialSubdivisions The number of subdivisions around the torus.
 * @param {number} bodySubdivisions The number of subdivisions around the body torus.
 * @param {boolean} [startAngle] start angle in radians. Default = 0.
 * @param {boolean} [endAngle] end angle in radians. Default = Math.PI * 2.
 * @return {Object.<string, WebGLBuffer>} The created buffers.
 * @memberOf module:twgl/primitives
 * @function createTorusBuffers
 */

/**
 * Creates vertices for a torus
 *
 * @param {number} radius radius of center of torus circle.
 * @param {number} thickness radius of torus ring.
 * @param {number} radialSubdivisions The number of subdivisions around the torus.
 * @param {number} bodySubdivisions The number of subdivisions around the body torus.
 * @param {boolean} [startAngle] start angle in radians. Default = 0.
 * @param {boolean} [endAngle] end angle in radians. Default = Math.PI * 2.
 * @return {Object.<string, TypedArray>} The created vertices.
 * @memberOf module:twgl/primitives
 */
function createTorusVertices(
    radius,
    thickness,
    radialSubdivisions,
    bodySubdivisions,
    startAngle,
    endAngle) {
  if (radialSubdivisions < 3) {
    throw new Error('radialSubdivisions must be 3 or greater');
  }

  if (bodySubdivisions < 3) {
    throw new Error('verticalSubdivisions must be 3 or greater');
  }

  startAngle = startAngle || 0;
  endAngle = endAngle || Math.PI * 2;
  const range = endAngle - startAngle;

  const radialParts = radialSubdivisions + 1;
  const bodyParts   = bodySubdivisions + 1;
  const numVertices = radialParts * bodyParts;
  const positions   = createAugmentedTypedArray(3, numVertices);
  const normals     = createAugmentedTypedArray(3, numVertices);
  const texcoords   = createAugmentedTypedArray(2, numVertices);
  const indices     = createAugmentedTypedArray(3, (radialSubdivisions) * (bodySubdivisions) * 2, Uint16Array);

  for (let slice = 0; slice < bodyParts; ++slice) {
    const v = slice / bodySubdivisions;
    const sliceAngle = v * Math.PI * 2;
    const sliceSin = Math.sin(sliceAngle);
    const ringRadius = radius + sliceSin * thickness;
    const ny = Math.cos(sliceAngle);
    const y = ny * thickness;
    for (let ring = 0; ring < radialParts; ++ring) {
      const u = ring / radialSubdivisions;
      const ringAngle = startAngle + u * range;
      const xSin = Math.sin(ringAngle);
      const zCos = Math.cos(ringAngle);
      const x = xSin * ringRadius;
      const z = zCos * ringRadius;
      const nx = xSin * sliceSin;
      const nz = zCos * sliceSin;
      positions.push(x, y, z);
      normals.push(nx, ny, nz);
      texcoords.push(u, 1 - v);
    }
  }

  for (let slice = 0; slice < bodySubdivisions; ++slice) {  // eslint-disable-line
    for (let ring = 0; ring < radialSubdivisions; ++ring) {  // eslint-disable-line
      const nextRingIndex  = 1 + ring;
      const nextSliceIndex = 1 + slice;
      indices.push(radialParts * slice          + ring,
                   radialParts * nextSliceIndex + ring,
                   radialParts * slice          + nextRingIndex);
      indices.push(radialParts * nextSliceIndex + ring,
                   radialParts * nextSliceIndex + nextRingIndex,
                   radialParts * slice          + nextRingIndex);
    }
  }

  return {
    position: positions,
    normal:   normals,
    texcoord: texcoords,
    indices:  indices,
  };
}


/**
 * Creates a disc BufferInfo. The disc will be in the xz plane, centered at
 * the origin. When creating, at least 3 divisions, or pie
 * pieces, need to be specified, otherwise the triangles making
 * up the disc will be degenerate. You can also specify the
 * number of radial pieces `stacks`. A value of 1 for
 * stacks will give you a simple disc of pie pieces.  If you
 * want to create an annulus you can set `innerRadius` to a
 * value > 0. Finally, `stackPower` allows you to have the widths
 * increase or decrease as you move away from the center. This
 * is particularly useful when using the disc as a ground plane
 * with a fixed camera such that you don't need the resolution
 * of small triangles near the perimeter. For example, a value
 * of 2 will produce stacks whose outside radius increases with
 * the square of the stack index. A value of 1 will give uniform
 * stacks.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius Radius of the ground plane.
 * @param {number} divisions Number of triangles in the ground plane (at least 3).
 * @param {number} [stacks] Number of radial divisions (default=1).
 * @param {number} [innerRadius] Default 0.
 * @param {number} [stackPower] Power to raise stack size to for decreasing width.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createDiscBufferInfo
 */

/**
 * Creates disc buffers. The disc will be in the xz plane, centered at
 * the origin. When creating, at least 3 divisions, or pie
 * pieces, need to be specified, otherwise the triangles making
 * up the disc will be degenerate. You can also specify the
 * number of radial pieces `stacks`. A value of 1 for
 * stacks will give you a simple disc of pie pieces.  If you
 * want to create an annulus you can set `innerRadius` to a
 * value > 0. Finally, `stackPower` allows you to have the widths
 * increase or decrease as you move away from the center. This
 * is particularly useful when using the disc as a ground plane
 * with a fixed camera such that you don't need the resolution
 * of small triangles near the perimeter. For example, a value
 * of 2 will produce stacks whose outside radius increases with
 * the square of the stack index. A value of 1 will give uniform
 * stacks.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius Radius of the ground plane.
 * @param {number} divisions Number of triangles in the ground plane (at least 3).
 * @param {number} [stacks] Number of radial divisions (default=1).
 * @param {number} [innerRadius] Default 0.
 * @param {number} [stackPower] Power to raise stack size to for decreasing width.
 * @return {Object.<string, WebGLBuffer>} The created buffers.
 * @memberOf module:twgl/primitives
 * @function createDiscBuffers
 */

/**
 * Creates disc vertices. The disc will be in the xz plane, centered at
 * the origin. When creating, at least 3 divisions, or pie
 * pieces, need to be specified, otherwise the triangles making
 * up the disc will be degenerate. You can also specify the
 * number of radial pieces `stacks`. A value of 1 for
 * stacks will give you a simple disc of pie pieces.  If you
 * want to create an annulus you can set `innerRadius` to a
 * value > 0. Finally, `stackPower` allows you to have the widths
 * increase or decrease as you move away from the center. This
 * is particularly useful when using the disc as a ground plane
 * with a fixed camera such that you don't need the resolution
 * of small triangles near the perimeter. For example, a value
 * of 2 will produce stacks whose outside radius increases with
 * the square of the stack index. A value of 1 will give uniform
 * stacks.
 *
 * @param {number} radius Radius of the ground plane.
 * @param {number} divisions Number of triangles in the ground plane (at least 3).
 * @param {number} [stacks] Number of radial divisions (default=1).
 * @param {number} [innerRadius] Default 0.
 * @param {number} [stackPower] Power to raise stack size to for decreasing width.
 * @return {Object.<string, TypedArray>} The created vertices.
 * @memberOf module:twgl/primitives
 */
function createDiscVertices(
    radius,
    divisions,
    stacks,
    innerRadius,
    stackPower) {
  if (divisions < 3) {
    throw new Error('divisions must be at least 3');
  }

  stacks = stacks ? stacks : 1;
  stackPower = stackPower ? stackPower : 1;
  innerRadius = innerRadius ? innerRadius : 0;

  // Note: We don't share the center vertex because that would
  // mess up texture coordinates.
  const numVertices = (divisions + 1) * (stacks + 1);

  const positions = createAugmentedTypedArray(3, numVertices);
  const normals   = createAugmentedTypedArray(3, numVertices);
  const texcoords = createAugmentedTypedArray(2, numVertices);
  const indices   = createAugmentedTypedArray(3, stacks * divisions * 2, Uint16Array);

  let firstIndex = 0;
  const radiusSpan = radius - innerRadius;
  const pointsPerStack = divisions + 1;

  // Build the disk one stack at a time.
  for (let stack = 0; stack <= stacks; ++stack) {
    const stackRadius = innerRadius + radiusSpan * Math.pow(stack / stacks, stackPower);

    for (let i = 0; i <= divisions; ++i) {
      const theta = 2.0 * Math.PI * i / divisions;
      const x = stackRadius * Math.cos(theta);
      const z = stackRadius * Math.sin(theta);

      positions.push(x, 0, z);
      normals.push(0, 1, 0);
      texcoords.push(1 - (i / divisions), stack / stacks);
      if (stack > 0 && i !== divisions) {
        // a, b, c and d are the indices of the vertices of a quad.  unless
        // the current stack is the one closest to the center, in which case
        // the vertices a and b connect to the center vertex.
        const a = firstIndex + (i + 1);
        const b = firstIndex + i;
        const c = firstIndex + i - pointsPerStack;
        const d = firstIndex + (i + 1) - pointsPerStack;

        // Make a quad of the vertices a, b, c, d.
        indices.push(a, b, c);
        indices.push(a, c, d);
      }
    }

    firstIndex += divisions + 1;
  }

  return {
    position: positions,
    normal: normals,
    texcoord: texcoords,
    indices: indices,
  };
}

/**
 * creates a random integer between 0 and range - 1 inclusive.
 * @param {number} range
 * @return {number} random value between 0 and range - 1 inclusive.
 * @private
 */
function randInt(range) {
  return Math.random() * range | 0;
}

/**
 * Used to supply random colors
 * @callback RandomColorFunc
 * @param {number} ndx index of triangle/quad if unindexed or index of vertex if indexed
 * @param {number} channel 0 = red, 1 = green, 2 = blue, 3 = alpha
 * @return {number} a number from 0 to 255
 * @memberOf module:twgl/primitives
 */

/**
 * @typedef {Object} RandomVerticesOptions
 * @property {number} [vertsPerColor] Defaults to 3 for non-indexed vertices
 * @property {module:twgl/primitives.RandomColorFunc} [rand] A function to generate random numbers
 * @memberOf module:twgl/primitives
 */

/**
 * Creates an augmentedTypedArray of random vertex colors.
 * If the vertices are indexed (have an indices array) then will
 * just make random colors. Otherwise assumes they are triangles
 * and makes one random color for every 3 vertices.
 * @param {Object.<string, AugmentedTypedArray>} vertices Vertices as returned from one of the createXXXVertices functions.
 * @param {module:twgl/primitives.RandomVerticesOptions} [options] options.
 * @return {Object.<string, AugmentedTypedArray>} same vertices as passed in with `color` added.
 * @memberOf module:twgl/primitives
 */
function makeRandomVertexColors(vertices, options) {
  options = options || {};
  const numElements = vertices.position.numElements;
  const vColors = createAugmentedTypedArray(4, numElements, Uint8Array);
  const rand = options.rand || function(ndx, channel) {
    return channel < 3 ? randInt(256) : 255;
  };
  vertices.color = vColors;
  if (vertices.indices) {
    // just make random colors if index
    for (let ii = 0; ii < numElements; ++ii) {
      vColors.push(rand(ii, 0), rand(ii, 1), rand(ii, 2), rand(ii, 3));
    }
  } else {
    // make random colors per triangle
    const numVertsPerColor = options.vertsPerColor || 3;
    const numSets = numElements / numVertsPerColor;
    for (let ii = 0; ii < numSets; ++ii) {  // eslint-disable-line
      const color = [rand(ii, 0), rand(ii, 1), rand(ii, 2), rand(ii, 3)];
      for (let jj = 0; jj < numVertsPerColor; ++jj) {
        vColors.push(color);
      }
    }
  }
  return vertices;
}

/**
 * creates a function that calls fn to create vertices and then
 * creates a buffers for them
 * @private
 */
function createBufferFunc(fn) {
  return function(gl) {
    const arrays = fn.apply(this, Array.prototype.slice.call(arguments, 1));
    return createBuffersFromArrays(gl, arrays);
  };
}

/**
 * creates a function that calls fn to create vertices and then
 * creates a bufferInfo object for them
 * @private
 */
function createBufferInfoFunc(fn) {
  return function(gl) {
    const arrays = fn.apply(null,  Array.prototype.slice.call(arguments, 1));
    return createBufferInfoFromArrays(gl, arrays);
  };
}

const arraySpecPropertyNames = [
  "numComponents",
  "size",
  "type",
  "normalize",
  "stride",
  "offset",
  "attrib",
  "name",
  "attribName",
];

/**
 * Copy elements from one array to another
 *
 * @param {Array|TypedArray} src source array
 * @param {Array|TypedArray} dst dest array
 * @param {number} dstNdx index in dest to copy src
 * @param {number} [offset] offset to add to copied values
 * @private
 */
function copyElements(src, dst, dstNdx, offset) {
  offset = offset || 0;
  const length = src.length;
  for (let ii = 0; ii < length; ++ii) {
    dst[dstNdx + ii] = src[ii] + offset;
  }
}

/**
 * Creates an array of the same time
 *
 * @param {(number[]|ArrayBufferView|module:twgl.FullArraySpec)} srcArray array who's type to copy
 * @param {number} length size of new array
 * @return {(number[]|ArrayBufferView|module:twgl.FullArraySpec)} array with same type as srcArray
 * @private
 */
function createArrayOfSameType(srcArray, length) {
  const arraySrc = getArray$1(srcArray);
  const newArray = new arraySrc.constructor(length);
  let newArraySpec = newArray;
  // If it appears to have been augmented make new one augmented
  if (arraySrc.numComponents && arraySrc.numElements) {
    augmentTypedArray(newArray, arraySrc.numComponents);
  }
  // If it was a full spec make new one a full spec
  if (srcArray.data) {
    newArraySpec = {
      data: newArray,
    };
    copyNamedProperties(arraySpecPropertyNames, srcArray, newArraySpec);
  }
  return newArraySpec;
}

/**
 * Concatenates sets of vertices
 *
 * Assumes the vertices match in composition. For example
 * if one set of vertices has positions, normals, and indices
 * all sets of vertices must have positions, normals, and indices
 * and of the same type.
 *
 * Example:
 *
 *      const cubeVertices = twgl.primitives.createCubeVertices(2);
 *      const sphereVertices = twgl.primitives.createSphereVertices(1, 10, 10);
 *      // move the sphere 2 units up
 *      twgl.primitives.reorientVertices(
 *          sphereVertices, twgl.m4.translation([0, 2, 0]));
 *      // merge the sphere with the cube
 *      const cubeSphereVertices = twgl.primitives.concatVertices(
 *          [cubeVertices, sphereVertices]);
 *      // turn them into WebGL buffers and attrib data
 *      const bufferInfo = twgl.createBufferInfoFromArrays(gl, cubeSphereVertices);
 *
 * @param {module:twgl.Arrays[]} arrays Array of arrays of vertices
 * @return {module:twgl.Arrays} The concatenated vertices.
 * @memberOf module:twgl/primitives
 */
function concatVertices(arrayOfArrays) {
  const names = {};
  let baseName;
  // get names of all arrays.
  // and numElements for each set of vertices
  for (let ii = 0; ii < arrayOfArrays.length; ++ii) {
    const arrays = arrayOfArrays[ii];
    Object.keys(arrays).forEach(function(name) {  // eslint-disable-line
      if (!names[name]) {
        names[name] = [];
      }
      if (!baseName && name !== 'indices') {
        baseName = name;
      }
      const arrayInfo = arrays[name];
      const numComponents = getNumComponents$1(arrayInfo, name);
      const array = getArray$1(arrayInfo);
      const numElements = array.length / numComponents;
      names[name].push(numElements);
    });
  }

  // compute length of combined array
  // and return one for reference
  function getLengthOfCombinedArrays(name) {
    let length = 0;
    let arraySpec;
    for (let ii = 0; ii < arrayOfArrays.length; ++ii) {
      const arrays = arrayOfArrays[ii];
      const arrayInfo = arrays[name];
      const array = getArray$1(arrayInfo);
      length += array.length;
      if (!arraySpec || arrayInfo.data) {
        arraySpec = arrayInfo;
      }
    }
    return {
      length: length,
      spec: arraySpec,
    };
  }

  function copyArraysToNewArray(name, base, newArray) {
    let baseIndex = 0;
    let offset = 0;
    for (let ii = 0; ii < arrayOfArrays.length; ++ii) {
      const arrays = arrayOfArrays[ii];
      const arrayInfo = arrays[name];
      const array = getArray$1(arrayInfo);
      if (name === 'indices') {
        copyElements(array, newArray, offset, baseIndex);
        baseIndex += base[ii];
      } else {
        copyElements(array, newArray, offset);
      }
      offset += array.length;
    }
  }

  const base = names[baseName];

  const newArrays = {};
  Object.keys(names).forEach(function(name) {
    const info = getLengthOfCombinedArrays(name);
    const newArraySpec = createArrayOfSameType(info.spec, info.length);
    copyArraysToNewArray(name, base, getArray$1(newArraySpec));
    newArrays[name] = newArraySpec;
  });
  return newArrays;
}

/**
 * Creates a duplicate set of vertices
 *
 * This is useful for calling reorientVertices when you
 * also want to keep the original available
 *
 * @param {module:twgl.Arrays} arrays of vertices
 * @return {module:twgl.Arrays} The duplicated vertices.
 * @memberOf module:twgl/primitives
 */
function duplicateVertices(arrays) {
  const newArrays = {};
  Object.keys(arrays).forEach(function(name) {
    const arraySpec = arrays[name];
    const srcArray = getArray$1(arraySpec);
    const newArraySpec = createArrayOfSameType(arraySpec, srcArray.length);
    copyElements(srcArray, getArray$1(newArraySpec), 0);
    newArrays[name] = newArraySpec;
  });
  return newArrays;
}

const create3DFBufferInfo = createBufferInfoFunc(create3DFVertices);
const create3DFBuffers = createBufferFunc(create3DFVertices);
const createCubeBufferInfo = createBufferInfoFunc(createCubeVertices);
const createCubeBuffers = createBufferFunc(createCubeVertices);
const createPlaneBufferInfo = createBufferInfoFunc(createPlaneVertices);
const createPlaneBuffers = createBufferFunc(createPlaneVertices);
const createSphereBufferInfo = createBufferInfoFunc(createSphereVertices);
const createSphereBuffers = createBufferFunc(createSphereVertices);
const createTruncatedConeBufferInfo = createBufferInfoFunc(createTruncatedConeVertices);
const createTruncatedConeBuffers = createBufferFunc(createTruncatedConeVertices);
const createXYQuadBufferInfo = createBufferInfoFunc(createXYQuadVertices);
const createXYQuadBuffers = createBufferFunc(createXYQuadVertices);
const createCrescentBufferInfo = createBufferInfoFunc(createCrescentVertices);
const createCrescentBuffers = createBufferFunc(createCrescentVertices);
const createCylinderBufferInfo = createBufferInfoFunc(createCylinderVertices);
const createCylinderBuffers = createBufferFunc(createCylinderVertices);
const createTorusBufferInfo = createBufferInfoFunc(createTorusVertices);
const createTorusBuffers = createBufferFunc(createTorusVertices);
const createDiscBufferInfo = createBufferInfoFunc(createDiscVertices);
const createDiscBuffers = createBufferFunc(createDiscVertices);

// these were mis-spelled until 4.12
const createCresentBufferInfo = createCrescentBufferInfo;
const createCresentBuffers = createCrescentBuffers;
const createCresentVertices = createCrescentVertices;

var primitives = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create3DFBufferInfo: create3DFBufferInfo,
  create3DFBuffers: create3DFBuffers,
  create3DFVertices: create3DFVertices,
  createAugmentedTypedArray: createAugmentedTypedArray,
  createCubeBufferInfo: createCubeBufferInfo,
  createCubeBuffers: createCubeBuffers,
  createCubeVertices: createCubeVertices,
  createPlaneBufferInfo: createPlaneBufferInfo,
  createPlaneBuffers: createPlaneBuffers,
  createPlaneVertices: createPlaneVertices,
  createSphereBufferInfo: createSphereBufferInfo,
  createSphereBuffers: createSphereBuffers,
  createSphereVertices: createSphereVertices,
  createTruncatedConeBufferInfo: createTruncatedConeBufferInfo,
  createTruncatedConeBuffers: createTruncatedConeBuffers,
  createTruncatedConeVertices: createTruncatedConeVertices,
  createXYQuadBufferInfo: createXYQuadBufferInfo,
  createXYQuadBuffers: createXYQuadBuffers,
  createXYQuadVertices: createXYQuadVertices,
  createCresentBufferInfo: createCresentBufferInfo,
  createCresentBuffers: createCresentBuffers,
  createCresentVertices: createCresentVertices,
  createCrescentBufferInfo: createCrescentBufferInfo,
  createCrescentBuffers: createCrescentBuffers,
  createCrescentVertices: createCrescentVertices,
  createCylinderBufferInfo: createCylinderBufferInfo,
  createCylinderBuffers: createCylinderBuffers,
  createCylinderVertices: createCylinderVertices,
  createTorusBufferInfo: createTorusBufferInfo,
  createTorusBuffers: createTorusBuffers,
  createTorusVertices: createTorusVertices,
  createDiscBufferInfo: createDiscBufferInfo,
  createDiscBuffers: createDiscBuffers,
  createDiscVertices: createDiscVertices,
  deindexVertices: deindexVertices,
  flattenNormals: flattenNormals,
  makeRandomVertexColors: makeRandomVertexColors,
  reorientDirections: reorientDirections,
  reorientNormals: reorientNormals,
  reorientPositions: reorientPositions,
  reorientVertices: reorientVertices,
  concatVertices: concatVertices,
  duplicateVertices: duplicateVertices
});

/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

/**
 * Gets the gl version as a number
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @return {number} version of gl
 * @private
 */
//function getVersionAsNumber(gl) {
//  return parseFloat(gl.getParameter(gl.VERSION).substr(6));
//}

/**
 * Check if context is WebGL 2.0
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @return {bool} true if it's WebGL 2.0
 * @memberOf module:twgl
 */
function isWebGL2(gl) {
  // This is the correct check but it's slow
  //  return gl.getParameter(gl.VERSION).indexOf("WebGL 2.0") === 0;
  // This might also be the correct check but I'm assuming it's slow-ish
  // return gl instanceof WebGL2RenderingContext;
  return !!gl.texStorage2D;
}

/**
 * Check if context is WebGL 1.0
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @return {bool} true if it's WebGL 1.0
 * @memberOf module:twgl
 */
function isWebGL1(gl) {
  // This is the correct check but it's slow
  // const version = getVersionAsNumber(gl);
  // return version <= 1.0 && version > 0.0;  // because as of 2016/5 Edge returns 0.96
  // This might also be the correct check but I'm assuming it's slow-ish
  // return gl instanceof WebGLRenderingContext;
  return !gl.texStorage2D;
}

/**
 * Gets a string for WebGL enum
 *
 * Note: Several enums are the same. Without more
 * context (which function) it's impossible to always
 * give the correct enum. As it is, for matching values
 * it gives all enums. Checking the WebGL2RenderingContext
 * that means
 *
 *      0     = ZERO | POINT | NONE | NO_ERROR
 *      1     = ONE | LINES | SYNC_FLUSH_COMMANDS_BIT
 *      32777 = BLEND_EQUATION_RGB | BLEND_EQUATION_RGB
 *      36662 = COPY_READ_BUFFER | COPY_READ_BUFFER_BINDING
 *      36663 = COPY_WRITE_BUFFER | COPY_WRITE_BUFFER_BINDING
 *      36006 = FRAMEBUFFER_BINDING | DRAW_FRAMEBUFFER_BINDING
 *
 * It's also not useful for bits really unless you pass in individual bits.
 * In other words
 *
 *     const bits = gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT;
 *     twgl.glEnumToString(gl, bits);  // not going to work
 *
 * Note that some enums only exist on extensions. If you
 * want them to show up you need to pass the extension at least
 * once. For example
 *
 *     const ext = gl.getExtension('WEBGL_compressed_texture_s3tc');
 *     if (ext) {
 *        twgl.glEnumToString(ext, 0);  // just prime the function
 *
 *        ..later..
 *
 *        const internalFormat = ext.COMPRESSED_RGB_S3TC_DXT1_EXT;
 *        console.log(twgl.glEnumToString(gl, internalFormat));
 *
 * Notice I didn't have to pass the extension the second time. This means
 * you can have place that generically gets an enum for texture formats for example.
 * and as long as you primed the function with the extensions
 *
 * If you're using `twgl.addExtensionsToContext` to enable your extensions
 * then twgl will automatically get the extension's enums.
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext or any extension object
 * @param {number} value the value of the enum you want to look up.
 * @return {string} enum string or hex value
 * @memberOf module:twgl
 * @function glEnumToString
 */
const glEnumToString = (function() {
  const haveEnumsForType = {};
  const enums = {};

  function addEnums(gl) {
    const type = gl.constructor.name;
    if (!haveEnumsForType[type]) {
      for (const key in gl) {
        if (typeof gl[key] === 'number') {
          const existing = enums[gl[key]];
          enums[gl[key]] = existing ? `${existing} | ${key}` : key;
        }
      }
      haveEnumsForType[type] = true;
    }
  }

  return function glEnumToString(gl, value) {
    addEnums(gl);
    return enums[value] || (typeof value === 'number' ? `0x${value.toString(16)}` : value);
  };
}());

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  glEnumToString: glEnumToString,
  isWebGL1: isWebGL1,
  isWebGL2: isWebGL2
});

/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */
const defaults$1 = {
  textureColor: new Uint8Array([128, 192, 255, 255]),
  textureOptions: {},
  crossOrigin: undefined,
};
const isArrayBuffer$1 = isArrayBuffer;

// Should we make this on demand?
const getShared2DContext = function() {
  let s_ctx;
  return function getShared2DContext() {
    s_ctx = s_ctx ||
        ((typeof document !== 'undefined' && document.createElement)
          ? document.createElement("canvas").getContext("2d")
          : null);
    return s_ctx;
  };
}();

// NOTE: Chrome supports 2D canvas in a Worker (behind flag as of v64 but
//       not only does Firefox NOT support it but Firefox freezes immediately
//       if you try to create one instead of just returning null and continuing.
//  : (global.OffscreenCanvas && (new global.OffscreenCanvas(1, 1)).getContext("2d"));  // OffscreenCanvas may not support 2d

// NOTE: We can maybe remove some of the need for the 2d canvas. In WebGL2
// we can use the various unpack settings. Otherwise we could try using
// the ability of an ImageBitmap to be cut. Unfortunately cutting an ImageBitmap
// is async and the current TWGL code expects a non-Async result though that
// might not be a problem. ImageBitmap though is not available in Edge or Safari
// as of 2018-01-02

/* PixelFormat */
const ALPHA                          = 0x1906;
const RGB                            = 0x1907;
const RGBA                           = 0x1908;
const LUMINANCE                      = 0x1909;
const LUMINANCE_ALPHA                = 0x190A;
const DEPTH_COMPONENT                = 0x1902;
const DEPTH_STENCIL                  = 0x84F9;

/* TextureWrapMode */
// const REPEAT                         = 0x2901;
// const MIRRORED_REPEAT                = 0x8370;
const CLAMP_TO_EDGE                  = 0x812f;

/* TextureMagFilter */
const NEAREST                        = 0x2600;
const LINEAR                         = 0x2601;

/* TextureMinFilter */
// const NEAREST_MIPMAP_NEAREST         = 0x2700;
// const LINEAR_MIPMAP_NEAREST          = 0x2701;
// const NEAREST_MIPMAP_LINEAR          = 0x2702;
// const LINEAR_MIPMAP_LINEAR           = 0x2703;

/* Texture Target */
const TEXTURE_2D                     = 0x0de1;
const TEXTURE_CUBE_MAP               = 0x8513;
const TEXTURE_3D                     = 0x806f;
const TEXTURE_2D_ARRAY               = 0x8c1a;

/* Cubemap Targets */
const TEXTURE_CUBE_MAP_POSITIVE_X    = 0x8515;
const TEXTURE_CUBE_MAP_NEGATIVE_X    = 0x8516;
const TEXTURE_CUBE_MAP_POSITIVE_Y    = 0x8517;
const TEXTURE_CUBE_MAP_NEGATIVE_Y    = 0x8518;
const TEXTURE_CUBE_MAP_POSITIVE_Z    = 0x8519;
const TEXTURE_CUBE_MAP_NEGATIVE_Z    = 0x851a;

/* Texture Parameters */
const TEXTURE_MIN_FILTER             = 0x2801;
const TEXTURE_MAG_FILTER             = 0x2800;
const TEXTURE_WRAP_S                 = 0x2802;
const TEXTURE_WRAP_T                 = 0x2803;
const TEXTURE_WRAP_R                 = 0x8072;
const TEXTURE_MIN_LOD                = 0x813a;
const TEXTURE_MAX_LOD                = 0x813b;
const TEXTURE_BASE_LEVEL             = 0x813c;
const TEXTURE_MAX_LEVEL              = 0x813d;


/* Pixel store */
const UNPACK_ALIGNMENT                   = 0x0cf5;
const UNPACK_ROW_LENGTH                  = 0x0cf2;
const UNPACK_IMAGE_HEIGHT                = 0x806e;
const UNPACK_SKIP_PIXELS                 = 0x0cf4;
const UNPACK_SKIP_ROWS                   = 0x0cf3;
const UNPACK_SKIP_IMAGES                 = 0x806d;
const UNPACK_COLORSPACE_CONVERSION_WEBGL = 0x9243;
const UNPACK_PREMULTIPLY_ALPHA_WEBGL     = 0x9241;
const UNPACK_FLIP_Y_WEBGL                = 0x9240;

const R8                           = 0x8229;
const R8_SNORM                     = 0x8F94;
const R16F                         = 0x822D;
const R32F                         = 0x822E;
const R8UI                         = 0x8232;
const R8I                          = 0x8231;
const RG16UI                       = 0x823A;
const RG16I                        = 0x8239;
const RG32UI                       = 0x823C;
const RG32I                        = 0x823B;
const RG8                          = 0x822B;
const RG8_SNORM                    = 0x8F95;
const RG16F                        = 0x822F;
const RG32F                        = 0x8230;
const RG8UI                        = 0x8238;
const RG8I                         = 0x8237;
const R16UI                        = 0x8234;
const R16I                         = 0x8233;
const R32UI                        = 0x8236;
const R32I                         = 0x8235;
const RGB8                         = 0x8051;
const SRGB8                        = 0x8C41;
const RGB565                       = 0x8D62;
const RGB8_SNORM                   = 0x8F96;
const R11F_G11F_B10F               = 0x8C3A;
const RGB9_E5                      = 0x8C3D;
const RGB16F                       = 0x881B;
const RGB32F                       = 0x8815;
const RGB8UI                       = 0x8D7D;
const RGB8I                        = 0x8D8F;
const RGB16UI                      = 0x8D77;
const RGB16I                       = 0x8D89;
const RGB32UI                      = 0x8D71;
const RGB32I                       = 0x8D83;
const RGBA8                        = 0x8058;
const SRGB8_ALPHA8                 = 0x8C43;
const RGBA8_SNORM                  = 0x8F97;
const RGB5_A1                      = 0x8057;
const RGBA4                        = 0x8056;
const RGB10_A2                     = 0x8059;
const RGBA16F                      = 0x881A;
const RGBA32F                      = 0x8814;
const RGBA8UI                      = 0x8D7C;
const RGBA8I                       = 0x8D8E;
const RGB10_A2UI                   = 0x906F;
const RGBA16UI                     = 0x8D76;
const RGBA16I                      = 0x8D88;
const RGBA32I                      = 0x8D82;
const RGBA32UI                     = 0x8D70;

const DEPTH_COMPONENT16            = 0x81A5;
const DEPTH_COMPONENT24            = 0x81A6;
const DEPTH_COMPONENT32F           = 0x8CAC;
const DEPTH32F_STENCIL8            = 0x8CAD;
const DEPTH24_STENCIL8             = 0x88F0;

/* DataType */
const BYTE$2                         = 0x1400;
const UNSIGNED_BYTE$2                = 0x1401;
const SHORT$2                        = 0x1402;
const UNSIGNED_SHORT$2               = 0x1403;
const INT$2                          = 0x1404;
const UNSIGNED_INT$2                 = 0x1405;
const FLOAT$2                        = 0x1406;
const UNSIGNED_SHORT_4_4_4_4$1       = 0x8033;
const UNSIGNED_SHORT_5_5_5_1$1       = 0x8034;
const UNSIGNED_SHORT_5_6_5$1         = 0x8363;
const HALF_FLOAT$1                   = 0x140B;
const HALF_FLOAT_OES               = 0x8D61;  // Thanks Khronos for making this different >:(
const UNSIGNED_INT_2_10_10_10_REV$1  = 0x8368;
const UNSIGNED_INT_10F_11F_11F_REV$1 = 0x8C3B;
const UNSIGNED_INT_5_9_9_9_REV$1     = 0x8C3E;
const FLOAT_32_UNSIGNED_INT_24_8_REV$1 = 0x8DAD;
const UNSIGNED_INT_24_8$1            = 0x84FA;

const RG                           = 0x8227;
const RG_INTEGER                   = 0x8228;
const RED                          = 0x1903;
const RED_INTEGER                  = 0x8D94;
const RGB_INTEGER                  = 0x8D98;
const RGBA_INTEGER                 = 0x8D99;

const formatInfo = {};
{
  // NOTE: this is named `numColorComponents` vs `numComponents` so we can let Uglify mangle
  // the name.
  const f = formatInfo;
  f[ALPHA]           = { numColorComponents: 1, };
  f[LUMINANCE]       = { numColorComponents: 1, };
  f[LUMINANCE_ALPHA] = { numColorComponents: 2, };
  f[RGB]             = { numColorComponents: 3, };
  f[RGBA]            = { numColorComponents: 4, };
  f[RED]             = { numColorComponents: 1, };
  f[RED_INTEGER]     = { numColorComponents: 1, };
  f[RG]              = { numColorComponents: 2, };
  f[RG_INTEGER]      = { numColorComponents: 2, };
  f[RGB]             = { numColorComponents: 3, };
  f[RGB_INTEGER]     = { numColorComponents: 3, };
  f[RGBA]            = { numColorComponents: 4, };
  f[RGBA_INTEGER]    = { numColorComponents: 4, };
  f[DEPTH_COMPONENT] = { numColorComponents: 1, };
  f[DEPTH_STENCIL]   = { numColorComponents: 2, };
}

/**
 * @typedef {Object} TextureFormatDetails
 * @property {number} textureFormat format to pass texImage2D and similar functions.
 * @property {boolean} colorRenderable true if you can render to this format of texture.
 * @property {boolean} textureFilterable true if you can filter the texture, false if you can ony use `NEAREST`.
 * @property {number[]} type Array of possible types you can pass to texImage2D and similar function
 * @property {Object.<number,number>} bytesPerElementMap A map of types to bytes per element
 * @private
 */

let s_textureInternalFormatInfo;
function getTextureInternalFormatInfo(internalFormat) {
  if (!s_textureInternalFormatInfo) {
    // NOTE: these properties need unique names so we can let Uglify mangle the name.
    const t = {};
    // unsized formats
    t[ALPHA]              = { textureFormat: ALPHA,           colorRenderable: true,  textureFilterable: true,  bytesPerElement: [1, 2, 2, 4],        type: [UNSIGNED_BYTE$2, HALF_FLOAT$1, HALF_FLOAT_OES, FLOAT$2], };
    t[LUMINANCE]          = { textureFormat: LUMINANCE,       colorRenderable: true,  textureFilterable: true,  bytesPerElement: [1, 2, 2, 4],        type: [UNSIGNED_BYTE$2, HALF_FLOAT$1, HALF_FLOAT_OES, FLOAT$2], };
    t[LUMINANCE_ALPHA]    = { textureFormat: LUMINANCE_ALPHA, colorRenderable: true,  textureFilterable: true,  bytesPerElement: [2, 4, 4, 8],        type: [UNSIGNED_BYTE$2, HALF_FLOAT$1, HALF_FLOAT_OES, FLOAT$2], };
    t[RGB]                = { textureFormat: RGB,             colorRenderable: true,  textureFilterable: true,  bytesPerElement: [3, 6, 6, 12, 2],    type: [UNSIGNED_BYTE$2, HALF_FLOAT$1, HALF_FLOAT_OES, FLOAT$2, UNSIGNED_SHORT_5_6_5$1], };
    t[RGBA]               = { textureFormat: RGBA,            colorRenderable: true,  textureFilterable: true,  bytesPerElement: [4, 8, 8, 16, 2, 2], type: [UNSIGNED_BYTE$2, HALF_FLOAT$1, HALF_FLOAT_OES, FLOAT$2, UNSIGNED_SHORT_4_4_4_4$1, UNSIGNED_SHORT_5_5_5_1$1], };
    t[DEPTH_COMPONENT]    = { textureFormat: DEPTH_COMPONENT, colorRenderable: true,  textureFilterable: false, bytesPerElement: [2, 4],              type: [UNSIGNED_INT$2, UNSIGNED_SHORT$2], };

    // sized formats
    t[R8]                 = { textureFormat: RED,             colorRenderable: true,  textureFilterable: true,  bytesPerElement: [1],        type: [UNSIGNED_BYTE$2], };
    t[R8_SNORM]           = { textureFormat: RED,             colorRenderable: false, textureFilterable: true,  bytesPerElement: [1],        type: [BYTE$2], };
    t[R16F]               = { textureFormat: RED,             colorRenderable: false, textureFilterable: true,  bytesPerElement: [4, 2],     type: [FLOAT$2, HALF_FLOAT$1], };
    t[R32F]               = { textureFormat: RED,             colorRenderable: false, textureFilterable: false, bytesPerElement: [4],        type: [FLOAT$2], };
    t[R8UI]               = { textureFormat: RED_INTEGER,     colorRenderable: true,  textureFilterable: false, bytesPerElement: [1],        type: [UNSIGNED_BYTE$2], };
    t[R8I]                = { textureFormat: RED_INTEGER,     colorRenderable: true,  textureFilterable: false, bytesPerElement: [1],        type: [BYTE$2], };
    t[R16UI]              = { textureFormat: RED_INTEGER,     colorRenderable: true,  textureFilterable: false, bytesPerElement: [2],        type: [UNSIGNED_SHORT$2], };
    t[R16I]               = { textureFormat: RED_INTEGER,     colorRenderable: true,  textureFilterable: false, bytesPerElement: [2],        type: [SHORT$2], };
    t[R32UI]              = { textureFormat: RED_INTEGER,     colorRenderable: true,  textureFilterable: false, bytesPerElement: [4],        type: [UNSIGNED_INT$2], };
    t[R32I]               = { textureFormat: RED_INTEGER,     colorRenderable: true,  textureFilterable: false, bytesPerElement: [4],        type: [INT$2], };
    t[RG8]                = { textureFormat: RG,              colorRenderable: true,  textureFilterable: true,  bytesPerElement: [2],        type: [UNSIGNED_BYTE$2], };
    t[RG8_SNORM]          = { textureFormat: RG,              colorRenderable: false, textureFilterable: true,  bytesPerElement: [2],        type: [BYTE$2], };
    t[RG16F]              = { textureFormat: RG,              colorRenderable: false, textureFilterable: true,  bytesPerElement: [8, 4],     type: [FLOAT$2, HALF_FLOAT$1], };
    t[RG32F]              = { textureFormat: RG,              colorRenderable: false, textureFilterable: false, bytesPerElement: [8],        type: [FLOAT$2], };
    t[RG8UI]              = { textureFormat: RG_INTEGER,      colorRenderable: true,  textureFilterable: false, bytesPerElement: [2],        type: [UNSIGNED_BYTE$2], };
    t[RG8I]               = { textureFormat: RG_INTEGER,      colorRenderable: true,  textureFilterable: false, bytesPerElement: [2],        type: [BYTE$2], };
    t[RG16UI]             = { textureFormat: RG_INTEGER,      colorRenderable: true,  textureFilterable: false, bytesPerElement: [4],        type: [UNSIGNED_SHORT$2], };
    t[RG16I]              = { textureFormat: RG_INTEGER,      colorRenderable: true,  textureFilterable: false, bytesPerElement: [4],        type: [SHORT$2], };
    t[RG32UI]             = { textureFormat: RG_INTEGER,      colorRenderable: true,  textureFilterable: false, bytesPerElement: [8],        type: [UNSIGNED_INT$2], };
    t[RG32I]              = { textureFormat: RG_INTEGER,      colorRenderable: true,  textureFilterable: false, bytesPerElement: [8],        type: [INT$2], };
    t[RGB8]               = { textureFormat: RGB,             colorRenderable: true,  textureFilterable: true,  bytesPerElement: [3],        type: [UNSIGNED_BYTE$2], };
    t[SRGB8]              = { textureFormat: RGB,             colorRenderable: false, textureFilterable: true,  bytesPerElement: [3],        type: [UNSIGNED_BYTE$2], };
    t[RGB565]             = { textureFormat: RGB,             colorRenderable: true,  textureFilterable: true,  bytesPerElement: [3, 2],     type: [UNSIGNED_BYTE$2, UNSIGNED_SHORT_5_6_5$1], };
    t[RGB8_SNORM]         = { textureFormat: RGB,             colorRenderable: false, textureFilterable: true,  bytesPerElement: [3],        type: [BYTE$2], };
    t[R11F_G11F_B10F]     = { textureFormat: RGB,             colorRenderable: false, textureFilterable: true,  bytesPerElement: [12, 6, 4], type: [FLOAT$2, HALF_FLOAT$1, UNSIGNED_INT_10F_11F_11F_REV$1], };
    t[RGB9_E5]            = { textureFormat: RGB,             colorRenderable: false, textureFilterable: true,  bytesPerElement: [12, 6, 4], type: [FLOAT$2, HALF_FLOAT$1, UNSIGNED_INT_5_9_9_9_REV$1], };
    t[RGB16F]             = { textureFormat: RGB,             colorRenderable: false, textureFilterable: true,  bytesPerElement: [12, 6],    type: [FLOAT$2, HALF_FLOAT$1], };
    t[RGB32F]             = { textureFormat: RGB,             colorRenderable: false, textureFilterable: false, bytesPerElement: [12],       type: [FLOAT$2], };
    t[RGB8UI]             = { textureFormat: RGB_INTEGER,     colorRenderable: false, textureFilterable: false, bytesPerElement: [3],        type: [UNSIGNED_BYTE$2], };
    t[RGB8I]              = { textureFormat: RGB_INTEGER,     colorRenderable: false, textureFilterable: false, bytesPerElement: [3],        type: [BYTE$2], };
    t[RGB16UI]            = { textureFormat: RGB_INTEGER,     colorRenderable: false, textureFilterable: false, bytesPerElement: [6],        type: [UNSIGNED_SHORT$2], };
    t[RGB16I]             = { textureFormat: RGB_INTEGER,     colorRenderable: false, textureFilterable: false, bytesPerElement: [6],        type: [SHORT$2], };
    t[RGB32UI]            = { textureFormat: RGB_INTEGER,     colorRenderable: false, textureFilterable: false, bytesPerElement: [12],       type: [UNSIGNED_INT$2], };
    t[RGB32I]             = { textureFormat: RGB_INTEGER,     colorRenderable: false, textureFilterable: false, bytesPerElement: [12],       type: [INT$2], };
    t[RGBA8]              = { textureFormat: RGBA,            colorRenderable: true,  textureFilterable: true,  bytesPerElement: [4],        type: [UNSIGNED_BYTE$2], };
    t[SRGB8_ALPHA8]       = { textureFormat: RGBA,            colorRenderable: true,  textureFilterable: true,  bytesPerElement: [4],        type: [UNSIGNED_BYTE$2], };
    t[RGBA8_SNORM]        = { textureFormat: RGBA,            colorRenderable: false, textureFilterable: true,  bytesPerElement: [4],        type: [BYTE$2], };
    t[RGB5_A1]            = { textureFormat: RGBA,            colorRenderable: true,  textureFilterable: true,  bytesPerElement: [4, 2, 4],  type: [UNSIGNED_BYTE$2, UNSIGNED_SHORT_5_5_5_1$1, UNSIGNED_INT_2_10_10_10_REV$1], };
    t[RGBA4]              = { textureFormat: RGBA,            colorRenderable: true,  textureFilterable: true,  bytesPerElement: [4, 2],     type: [UNSIGNED_BYTE$2, UNSIGNED_SHORT_4_4_4_4$1], };
    t[RGB10_A2]           = { textureFormat: RGBA,            colorRenderable: true,  textureFilterable: true,  bytesPerElement: [4],        type: [UNSIGNED_INT_2_10_10_10_REV$1], };
    t[RGBA16F]            = { textureFormat: RGBA,            colorRenderable: false, textureFilterable: true,  bytesPerElement: [16, 8],    type: [FLOAT$2, HALF_FLOAT$1], };
    t[RGBA32F]            = { textureFormat: RGBA,            colorRenderable: false, textureFilterable: false, bytesPerElement: [16],       type: [FLOAT$2], };
    t[RGBA8UI]            = { textureFormat: RGBA_INTEGER,    colorRenderable: true,  textureFilterable: false, bytesPerElement: [4],        type: [UNSIGNED_BYTE$2], };
    t[RGBA8I]             = { textureFormat: RGBA_INTEGER,    colorRenderable: true,  textureFilterable: false, bytesPerElement: [4],        type: [BYTE$2], };
    t[RGB10_A2UI]         = { textureFormat: RGBA_INTEGER,    colorRenderable: true,  textureFilterable: false, bytesPerElement: [4],        type: [UNSIGNED_INT_2_10_10_10_REV$1], };
    t[RGBA16UI]           = { textureFormat: RGBA_INTEGER,    colorRenderable: true,  textureFilterable: false, bytesPerElement: [8],        type: [UNSIGNED_SHORT$2], };
    t[RGBA16I]            = { textureFormat: RGBA_INTEGER,    colorRenderable: true,  textureFilterable: false, bytesPerElement: [8],        type: [SHORT$2], };
    t[RGBA32I]            = { textureFormat: RGBA_INTEGER,    colorRenderable: true,  textureFilterable: false, bytesPerElement: [16],       type: [INT$2], };
    t[RGBA32UI]           = { textureFormat: RGBA_INTEGER,    colorRenderable: true,  textureFilterable: false, bytesPerElement: [16],       type: [UNSIGNED_INT$2], };
    // Sized Internal
    t[DEPTH_COMPONENT16]  = { textureFormat: DEPTH_COMPONENT, colorRenderable: true,  textureFilterable: false, bytesPerElement: [2, 4],     type: [UNSIGNED_SHORT$2, UNSIGNED_INT$2], };
    t[DEPTH_COMPONENT24]  = { textureFormat: DEPTH_COMPONENT, colorRenderable: true,  textureFilterable: false, bytesPerElement: [4],        type: [UNSIGNED_INT$2], };
    t[DEPTH_COMPONENT32F] = { textureFormat: DEPTH_COMPONENT, colorRenderable: true,  textureFilterable: false, bytesPerElement: [4],        type: [FLOAT$2], };
    t[DEPTH24_STENCIL8]   = { textureFormat: DEPTH_STENCIL,   colorRenderable: true,  textureFilterable: false, bytesPerElement: [4],        type: [UNSIGNED_INT_24_8$1], };
    t[DEPTH32F_STENCIL8]  = { textureFormat: DEPTH_STENCIL,   colorRenderable: true,  textureFilterable: false, bytesPerElement: [4],        type: [FLOAT_32_UNSIGNED_INT_24_8_REV$1], };

    Object.keys(t).forEach(function(internalFormat) {
      const info = t[internalFormat];
      info.bytesPerElementMap = {};
      info.bytesPerElement.forEach(function(bytesPerElement, ndx) {
        const type = info.type[ndx];
        info.bytesPerElementMap[type] = bytesPerElement;
      });
    });
    s_textureInternalFormatInfo = t;
  }
  return s_textureInternalFormatInfo[internalFormat];
}

/**
 * Gets the number of bytes per element for a given internalFormat / type
 * @param {number} internalFormat The internalFormat parameter from texImage2D etc..
 * @param {number} type The type parameter for texImage2D etc..
 * @return {number} the number of bytes per element for the given internalFormat, type combo
 * @memberOf module:twgl/textures
 */
function getBytesPerElementForInternalFormat(internalFormat, type) {
  const info = getTextureInternalFormatInfo(internalFormat);
  if (!info) {
    throw "unknown internal format";
  }
  const bytesPerElement = info.bytesPerElementMap[type];
  if (bytesPerElement === undefined) {
    throw "unknown internal format";
  }
  return bytesPerElement;
}

/**
 * Info related to a specific texture internalFormat as returned
 * from {@link module:twgl/textures.getFormatAndTypeForInternalFormat}.
 *
 * @typedef {Object} TextureFormatInfo
 * @property {number} format Format to pass to texImage2D and related functions
 * @property {number} type Type to pass to texImage2D and related functions
 * @memberOf module:twgl/textures
 */

/**
 * Gets the format and type for a given internalFormat
 *
 * @param {number} internalFormat The internal format
 * @return {module:twgl/textures.TextureFormatInfo} the corresponding format and type,
 * @memberOf module:twgl/textures
 */
function getFormatAndTypeForInternalFormat(internalFormat) {
  const info = getTextureInternalFormatInfo(internalFormat);
  if (!info) {
    throw "unknown internal format";
  }
  return {
    format: info.textureFormat,
    type: info.type[0],
  };
}

/**
 * Returns true if value is power of 2
 * @param {number} value number to check.
 * @return true if value is power of 2
 * @private
 */
function isPowerOf2(value) {
  return (value & (value - 1)) === 0;
}

/**
 * Gets whether or not we can generate mips for the given
 * internal format.
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {number} width The width parameter from texImage2D etc..
 * @param {number} height The height parameter from texImage2D etc..
 * @param {number} internalFormat The internalFormat parameter from texImage2D etc..
 * @return {boolean} true if we can generate mips
 * @memberOf module:twgl/textures
 */
function canGenerateMipmap(gl, width, height, internalFormat) {
  if (!isWebGL2(gl)) {
    return isPowerOf2(width) && isPowerOf2(height);
  }
  const info = getTextureInternalFormatInfo(internalFormat);
  if (!info) {
    throw "unknown internal format";
  }
  return info.colorRenderable && info.textureFilterable;
}

/**
 * Gets whether or not we can generate mips for the given format
 * @param {number} internalFormat The internalFormat parameter from texImage2D etc..
 * @return {boolean} true if we can generate mips
 * @memberOf module:twgl/textures
 */
function canFilter(internalFormat) {
  const info = getTextureInternalFormatInfo(internalFormat);
  if (!info) {
    throw "unknown internal format";
  }
  return info.textureFilterable;
}

/**
 * Gets the number of components for a given image format.
 * @param {number} format the format.
 * @return {number} the number of components for the format.
 * @memberOf module:twgl/textures
 */
function getNumComponentsForFormat(format) {
  const info = formatInfo[format];
  if (!info) {
    throw "unknown format: " + format;
  }
  return info.numColorComponents;
}

/**
 * Gets the texture type for a given array type.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @return {number} the gl texture type
 * @private
 */
function getTextureTypeForArrayType(gl, src, defaultType) {
  if (isArrayBuffer$1(src)) {
    return getGLTypeForTypedArray(src);
  }
  return defaultType || UNSIGNED_BYTE$2;
}

function guessDimensions(gl, target, width, height, numElements) {
  if (numElements % 1 !== 0) {
    throw "can't guess dimensions";
  }
  if (!width && !height) {
    const size = Math.sqrt(numElements / (target === TEXTURE_CUBE_MAP ? 6 : 1));
    if (size % 1 === 0) {
      width = size;
      height = size;
    } else {
      width = numElements;
      height = 1;
    }
  } else if (!height) {
    height = numElements / width;
    if (height % 1) {
      throw "can't guess dimensions";
    }
  } else if (!width) {
    width = numElements / height;
    if (width % 1) {
      throw "can't guess dimensions";
    }
  }
  return {
    width: width,
    height: height,
  };
}

/**
 * Sets the default texture color.
 *
 * The default texture color is used when loading textures from
 * urls. Because the URL will be loaded async we'd like to be
 * able to use the texture immediately. By putting a 1x1 pixel
 * color in the texture we can start using the texture before
 * the URL has loaded.
 *
 * @param {number[]} color Array of 4 values in the range 0 to 1
 * @deprecated see {@link module:twgl.setDefaults}
 * @memberOf module:twgl/textures
 */
function setDefaultTextureColor(color) {
  defaults$1.textureColor = new Uint8Array([color[0] * 255, color[1] * 255, color[2] * 255, color[3] * 255]);
}

function setDefaults$1(newDefaults) {
  copyExistingProperties(newDefaults, defaults$1);
  if (newDefaults.textureColor) {
    setDefaultTextureColor(newDefaults.textureColor);
  }
}

/**
 * A function to generate the source for a texture.
 * @callback TextureFunc
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @param {module:twgl.TextureOptions} options the texture options
 * @return {*} Returns any of the things documented for `src` for {@link module:twgl.TextureOptions}.
 * @memberOf module:twgl
 */

/**
 * Texture options passed to most texture functions. Each function will use whatever options
 * are appropriate for its needs. This lets you pass the same options to all functions.
 *
 * Note: A `TexImageSource` is defined in the WebGL spec as a `HTMLImageElement`, `HTMLVideoElement`,
 * `HTMLCanvasElement`, `ImageBitmap`, or `ImageData`.
 *
 * @typedef {Object} TextureOptions
 * @property {number} [target] the type of texture `gl.TEXTURE_2D` or `gl.TEXTURE_CUBE_MAP`. Defaults to `gl.TEXTURE_2D`.
 * @property {number} [level] the mip level to affect. Defaults to 0. Note, if set auto will be considered false unless explicitly set to true.
 * @property {number} [width] the width of the texture. Only used if src is an array or typed array or null.
 * @property {number} [height] the height of a texture. Only used if src is an array or typed array or null.
 * @property {number} [depth] the depth of a texture. Only used if src is an array or type array or null and target is `TEXTURE_3D` .
 * @property {number} [min] the min filter setting (eg. `gl.LINEAR`). Defaults to `gl.NEAREST_MIPMAP_LINEAR`
 *     or if texture is not a power of 2 on both dimensions then defaults to `gl.LINEAR`.
 * @property {number} [mag] the mag filter setting (eg. `gl.LINEAR`). Defaults to `gl.LINEAR`
 * @property {number} [minMag] both the min and mag filter settings.
 * @property {number} [internalFormat] internal format for texture. Defaults to `gl.RGBA`
 * @property {number} [format] format for texture. Defaults to `gl.RGBA`.
 * @property {number} [type] type for texture. Defaults to `gl.UNSIGNED_BYTE` unless `src` is ArrayBufferView. If `src`
 *     is ArrayBufferView defaults to type that matches ArrayBufferView type.
 * @property {number} [wrap] Texture wrapping for both S and T (and R if TEXTURE_3D or WebGLSampler). Defaults to `gl.REPEAT` for 2D unless src is WebGL1 and src not npot and `gl.CLAMP_TO_EDGE` for cube
 * @property {number} [wrapS] Texture wrapping for S. Defaults to `gl.REPEAT` and `gl.CLAMP_TO_EDGE` for cube. If set takes precedence over `wrap`.
 * @property {number} [wrapT] Texture wrapping for T. Defaults to `gl.REPEAT` and `gl.CLAMP_TO_EDGE` for cube. If set takes precedence over `wrap`.
 * @property {number} [wrapR] Texture wrapping for R. Defaults to `gl.REPEAT` and `gl.CLAMP_TO_EDGE` for cube. If set takes precedence over `wrap`.
 * @property {number} [minLod] TEXTURE_MIN_LOD setting
 * @property {number} [maxLod] TEXTURE_MAX_LOD setting
 * @property {number} [baseLevel] TEXTURE_BASE_LEVEL setting
 * @property {number} [maxLevel] TEXTURE_MAX_LEVEL setting
 * @property {number} [unpackAlignment] The `gl.UNPACK_ALIGNMENT` used when uploading an array. Defaults to 1.
 * @property {number[]|ArrayBufferView} [color] Color to initialize this texture with if loading an image asynchronously.
 *     The default use a blue 1x1 pixel texture. You can set another default by calling `twgl.setDefaults`
 *     or you can set an individual texture's initial color by setting this property. Example: `[1, .5, .5, 1]` = pink
 * @property {number} [premultiplyAlpha] Whether or not to premultiply alpha. Defaults to whatever the current setting is.
 *     This lets you set it once before calling `twgl.createTexture` or `twgl.createTextures` and only override
 *     the current setting for specific textures.
 * @property {number} [flipY] Whether or not to flip the texture vertically on upload. Defaults to whatever the current setting is.
 *     This lets you set it once before calling `twgl.createTexture` or `twgl.createTextures` and only override
 *     the current setting for specific textures.
 * @property {number} [colorspaceConversion] Whether or not to let the browser do colorspace conversion of the texture on upload. Defaults to whatever the current setting is.
 *     This lets you set it once before calling `twgl.createTexture` or `twgl.createTextures` and only override
 *     the current setting for specific textures.
 * @property {boolean} [auto] If `undefined` or `true`, in WebGL1, texture filtering is set automatically for non-power of 2 images and
 *    mips are generated for power of 2 images. In WebGL2 mips are generated if they can be. Note: if `level` is set above
 *    then then `auto` is assumed to be `false` unless explicity set to `true`.
 * @property {number[]} [cubeFaceOrder] The order that cube faces are pulled out of an img or set of images. The default is
 *
 *     [gl.TEXTURE_CUBE_MAP_POSITIVE_X,
 *      gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
 *      gl.TEXTURE_CUBE_MAP_POSITIVE_Y,
 *      gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
 *      gl.TEXTURE_CUBE_MAP_POSITIVE_Z,
 *      gl.TEXTURE_CUBE_MAP_NEGATIVE_Z]
 *
 * @property {(number[]|ArrayBufferView|TexImageSource|TexImageSource[]|string|string[]|module:twgl.TextureFunc)} [src] source for texture
 *
 *    If `string` then it's assumed to be a URL to an image. The image will be downloaded async. A usable
 *    1x1 pixel texture will be returned immediately. The texture will be updated once the image has downloaded.
 *    If `target` is `gl.TEXTURE_CUBE_MAP` will attempt to divide image into 6 square pieces. 1x6, 6x1, 3x2, 2x3.
 *    The pieces will be uploaded in `cubeFaceOrder`
 *
 *    If `string[]` or `TexImageSource[]` and target is `gl.TEXTURE_CUBE_MAP` then it must have 6 entries, one for each face of a cube map.
 *
 *    If `string[]` or `TexImageSource[]` and target is `gl.TEXTURE_2D_ARRAY` then each entry is a slice of the a 2d array texture
 *    and will be scaled to the specified width and height OR to the size of the first image that loads.
 *
 *    If `TexImageSource` then it wil be used immediately to create the contents of the texture. Examples `HTMLImageElement`,
 *    `HTMLCanvasElement`, `HTMLVideoElement`.
 *
 *    If `number[]` or `ArrayBufferView` it's assumed to be data for a texture. If `width` or `height` is
 *    not specified it is guessed as follows. First the number of elements is computed by `src.length / numComponents`
 *    where `numComponents` is derived from `format`. If `target` is `gl.TEXTURE_CUBE_MAP` then `numElements` is divided
 *    by 6. Then
 *
 *    *   If neither `width` nor `height` are specified and `sqrt(numElements)` is an integer then width and height
 *        are set to `sqrt(numElements)`. Otherwise `width = numElements` and `height = 1`.
 *
 *    *   If only one of `width` or `height` is specified then the other equals `numElements / specifiedDimension`.
 *
 * If `number[]` will be converted to `type`.
 *
 * If `src` is a function it will be called with a `WebGLRenderingContext` and these options.
 * Whatever it returns is subject to these rules. So it can return a string url, an `HTMLElement`
 * an array etc...
 *
 * If `src` is undefined then an empty texture will be created of size `width` by `height`.
 *
 * @property {string} [crossOrigin] What to set the crossOrigin property of images when they are downloaded.
 *    default: undefined. Also see {@link module:twgl.setDefaults}.
 *
 * @memberOf module:twgl
 */

/**
 * Sets any packing state that will be set based on the options.
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @private
 */
function setPackState(gl, options) {
  if (options.colorspaceConversion !== undefined) {
    gl.pixelStorei(UNPACK_COLORSPACE_CONVERSION_WEBGL, options.colorspaceConversion);
  }
  if (options.premultiplyAlpha !== undefined) {
    gl.pixelStorei(UNPACK_PREMULTIPLY_ALPHA_WEBGL, options.premultiplyAlpha);
  }
  if (options.flipY !== undefined) {
    gl.pixelStorei(UNPACK_FLIP_Y_WEBGL, options.flipY);
  }
}

/**
 * Set skip state to defaults
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @private
 */
function setSkipStateToDefault(gl) {
  gl.pixelStorei(UNPACK_ALIGNMENT, 4);
  if (isWebGL2(gl)) {
    gl.pixelStorei(UNPACK_ROW_LENGTH, 0);
    gl.pixelStorei(UNPACK_IMAGE_HEIGHT, 0);
    gl.pixelStorei(UNPACK_SKIP_PIXELS, 0);
    gl.pixelStorei(UNPACK_SKIP_ROWS, 0);
    gl.pixelStorei(UNPACK_SKIP_IMAGES, 0);
  }
}

/**
 * Sets the parameters of a texture or sampler
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {number|WebGLSampler} target texture target or sampler
 * @param {function()} parameteriFn texParameteri or samplerParameteri fn
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @private
 */
function setTextureSamplerParameters(gl, target, parameteriFn, options) {
  if (options.minMag) {
    parameteriFn.call(gl, target, TEXTURE_MIN_FILTER, options.minMag);
    parameteriFn.call(gl, target, TEXTURE_MAG_FILTER, options.minMag);
  }
  if (options.min) {
    parameteriFn.call(gl, target, TEXTURE_MIN_FILTER, options.min);
  }
  if (options.mag) {
    parameteriFn.call(gl, target, TEXTURE_MAG_FILTER, options.mag);
  }
  if (options.wrap) {
    parameteriFn.call(gl, target, TEXTURE_WRAP_S, options.wrap);
    parameteriFn.call(gl, target, TEXTURE_WRAP_T, options.wrap);
    if (target === TEXTURE_3D || isSampler(gl, target)) {
      parameteriFn.call(gl, target, TEXTURE_WRAP_R, options.wrap);
    }
  }
  if (options.wrapR) {
    parameteriFn.call(gl, target, TEXTURE_WRAP_R, options.wrapR);
  }
  if (options.wrapS) {
    parameteriFn.call(gl, target, TEXTURE_WRAP_S, options.wrapS);
  }
  if (options.wrapT) {
    parameteriFn.call(gl, target, TEXTURE_WRAP_T, options.wrapT);
  }
  if (options.minLod) {
    parameteriFn.call(gl, target, TEXTURE_MIN_LOD, options.minLod);
  }
  if (options.maxLod) {
    parameteriFn.call(gl, target, TEXTURE_MAX_LOD, options.maxLod);
  }
  if (options.baseLevel) {
    parameteriFn.call(gl, target, TEXTURE_BASE_LEVEL, options.baseLevel);
  }
  if (options.maxLevel) {
    parameteriFn.call(gl, target, TEXTURE_MAX_LEVEL, options.maxLevel);
  }
}

/**
 * Sets the texture parameters of a texture.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @memberOf module:twgl/textures
 */
function setTextureParameters(gl, tex, options) {
  const target = options.target || TEXTURE_2D;
  gl.bindTexture(target, tex);
  setTextureSamplerParameters(gl, target, gl.texParameteri, options);
}

/**
 * Sets the sampler parameters of a sampler.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLSampler} sampler the WebGLSampler to set parameters for
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @memberOf module:twgl/textures
 */
function setSamplerParameters(gl, sampler, options) {
  setTextureSamplerParameters(gl, sampler, gl.samplerParameteri, options);
}

/**
 * Creates a new sampler object and sets parameters.
 *
 * Example:
 *
 *      const sampler = twgl.createSampler(gl, {
 *        minMag: gl.NEAREST,         // sets both TEXTURE_MIN_FILTER and TEXTURE_MAG_FILTER
 *        wrap: gl.CLAMP_TO_NEAREST,  // sets both TEXTURE_WRAP_S and TEXTURE_WRAP_T and TEXTURE_WRAP_R
 *      });
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {Object.<string,module:twgl.TextureOptions>} options A object of TextureOptions one per sampler.
 * @return {Object.<string,WebGLSampler>} the created samplers by name
 * @private
 */
function createSampler(gl, options) {
  const sampler = gl.createSampler();
  setSamplerParameters(gl, sampler, options);
  return sampler;
}

/**
 * Creates a multiple sampler objects and sets parameters on each.
 *
 * Example:
 *
 *      const samplers = twgl.createSamplers(gl, {
 *        nearest: {
 *          minMag: gl.NEAREST,
 *        },
 *        nearestClampS: {
 *          minMag: gl.NEAREST,
 *          wrapS: gl.CLAMP_TO_NEAREST,
 *        },
 *        linear: {
 *          minMag: gl.LINEAR,
 *        },
 *        nearestClamp: {
 *          minMag: gl.NEAREST,
 *          wrap: gl.CLAMP_TO_EDGE,
 *        },
 *        linearClamp: {
 *          minMag: gl.LINEAR,
 *          wrap: gl.CLAMP_TO_EDGE,
 *        },
 *        linearClampT: {
 *          minMag: gl.LINEAR,
 *          wrapT: gl.CLAMP_TO_EDGE,
 *        },
 *      });
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set on the sampler
 * @private
 */
function createSamplers(gl, samplerOptions) {
  const samplers = {};
  Object.keys(samplerOptions).forEach(function(name) {
    samplers[name] = createSampler(gl, samplerOptions[name]);
  });
  return samplers;
}

/**
 * Makes a 1x1 pixel
 * If no color is passed in uses the default color which can be set by calling `setDefaultTextureColor`.
 * @param {(number[]|ArrayBufferView)} [color] The color using 0-1 values
 * @return {Uint8Array} Unit8Array with color.
 * @private
 */
function make1Pixel(color) {
  color = color || defaults$1.textureColor;
  if (isArrayBuffer$1(color)) {
    return color;
  }
  return new Uint8Array([color[0] * 255, color[1] * 255, color[2] * 255, color[3] * 255]);
}

/**
 * Sets filtering or generates mips for texture based on width or height
 * If width or height is not passed in uses `options.width` and//or `options.height`
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @param {number} [width] width of texture
 * @param {number} [height] height of texture
 * @param {number} [internalFormat] The internalFormat parameter from texImage2D etc..
 * @memberOf module:twgl/textures
 */
function setTextureFilteringForSize(gl, tex, options, width, height, internalFormat) {
  options = options || defaults$1.textureOptions;
  internalFormat = internalFormat || RGBA;
  const target = options.target || TEXTURE_2D;
  width = width || options.width;
  height = height || options.height;
  gl.bindTexture(target, tex);
  if (canGenerateMipmap(gl, width, height, internalFormat)) {
    gl.generateMipmap(target);
  } else {
    const filtering = canFilter(internalFormat) ? LINEAR : NEAREST;
    gl.texParameteri(target, TEXTURE_MIN_FILTER, filtering);
    gl.texParameteri(target, TEXTURE_MAG_FILTER, filtering);
    gl.texParameteri(target, TEXTURE_WRAP_S, CLAMP_TO_EDGE);
    gl.texParameteri(target, TEXTURE_WRAP_T, CLAMP_TO_EDGE);
  }
}

function shouldAutomaticallySetTextureFilteringForSize(options) {
  return options.auto === true || (options.auto === undefined && options.level === undefined);
}

/**
 * Gets an array of cubemap face enums
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @return {number[]} cubemap face enums
 * @private
 */
function getCubeFaceOrder(gl, options) {
  options = options || {};
  return options.cubeFaceOrder || [
      TEXTURE_CUBE_MAP_POSITIVE_X,
      TEXTURE_CUBE_MAP_NEGATIVE_X,
      TEXTURE_CUBE_MAP_POSITIVE_Y,
      TEXTURE_CUBE_MAP_NEGATIVE_Y,
      TEXTURE_CUBE_MAP_POSITIVE_Z,
      TEXTURE_CUBE_MAP_NEGATIVE_Z,
    ];
}

/**
 * @typedef {Object} FaceInfo
 * @property {number} face gl enum for texImage2D
 * @property {number} ndx face index (0 - 5) into source data
 * @ignore
 */

/**
 * Gets an array of FaceInfos
 * There's a bug in some NVidia drivers that will crash the driver if
 * `gl.TEXTURE_CUBE_MAP_POSITIVE_X` is not uploaded first. So, we take
 * the user's desired order from his faces to WebGL and make sure we
 * do the faces in WebGL order
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @return {FaceInfo[]} cubemap face infos. Arguably the `face` property of each element is redundant but
 *    it's needed internally to sort the array of `ndx` properties by `face`.
 * @private
 */
function getCubeFacesWithNdx(gl, options) {
  const faces = getCubeFaceOrder(gl, options);
  // work around bug in NVidia drivers. We have to upload the first face first else the driver crashes :(
  const facesWithNdx = faces.map(function(face, ndx) {
    return { face: face, ndx: ndx };
  });
  facesWithNdx.sort(function(a, b) {
    return a.face - b.face;
  });
  return facesWithNdx;
}

/**
 * Set a texture from the contents of an element. Will also set
 * texture filtering or generate mips based on the dimensions of the element
 * unless `options.auto === false`. If `target === gl.TEXTURE_CUBE_MAP` will
 * attempt to slice image into 1x6, 2x3, 3x2, or 6x1 images, one for each face.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {HTMLElement} element a canvas, img, or video element.
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @memberOf module:twgl/textures
 * @kind function
 */
function setTextureFromElement(gl, tex, element, options) {
  options = options || defaults$1.textureOptions;
  const target = options.target || TEXTURE_2D;
  const level = options.level || 0;
  let width = element.width;
  let height = element.height;
  const internalFormat = options.internalFormat || options.format || RGBA;
  const formatType = getFormatAndTypeForInternalFormat(internalFormat);
  const format = options.format || formatType.format;
  const type = options.type || formatType.type;
  setPackState(gl, options);
  gl.bindTexture(target, tex);
  if (target === TEXTURE_CUBE_MAP) {
    // guess the parts
    const imgWidth  = element.width;
    const imgHeight = element.height;
    let size;
    let slices;
    if (imgWidth / 6 === imgHeight) {
      // It's 6x1
      size = imgHeight;
      slices = [0, 0, 1, 0, 2, 0, 3, 0, 4, 0, 5, 0];
    } else if (imgHeight / 6 === imgWidth) {
      // It's 1x6
      size = imgWidth;
      slices = [0, 0, 0, 1, 0, 2, 0, 3, 0, 4, 0, 5];
    } else if (imgWidth / 3 === imgHeight / 2) {
      // It's 3x2
      size = imgWidth / 3;
      slices = [0, 0, 1, 0, 2, 0, 0, 1, 1, 1, 2, 1];
    } else if (imgWidth / 2 === imgHeight / 3) {
      // It's 2x3
      size = imgWidth / 2;
      slices = [0, 0, 1, 0, 0, 1, 1, 1, 0, 2, 1, 2];
    } else {
      throw "can't figure out cube map from element: " + (element.src ? element.src : element.nodeName);
    }
    const ctx = getShared2DContext();
    if (ctx) {
      ctx.canvas.width = size;
      ctx.canvas.height = size;
      width = size;
      height = size;
      getCubeFacesWithNdx(gl, options).forEach(function(f) {
        const xOffset = slices[f.ndx * 2 + 0] * size;
        const yOffset = slices[f.ndx * 2 + 1] * size;
        ctx.drawImage(element, xOffset, yOffset, size, size, 0, 0, size, size);
        gl.texImage2D(f.face, level, internalFormat, format, type, ctx.canvas);
      });
      // Free up the canvas memory
      ctx.canvas.width = 1;
      ctx.canvas.height = 1;
    } else if (typeof createImageBitmap !== 'undefined') {
      // NOTE: It seems like we should prefer ImageBitmap because unlike canvas it's
      // note lossy? (alpha is not premultiplied? although I'm not sure what
      width = size;
      height = size;
      getCubeFacesWithNdx(gl, options).forEach(function(f) {
        const xOffset = slices[f.ndx * 2 + 0] * size;
        const yOffset = slices[f.ndx * 2 + 1] * size;
        // We can't easily use a default texture color here as it would have to match
        // the type across all faces where as with a 2D one there's only one face
        // so we're replacing everything all at once. It also has to be the correct size.
        // On the other hand we need all faces to be the same size so as one face loads
        // the rest match else the texture will be un-renderable.
        gl.texImage2D(f.face, level, internalFormat, size, size, 0, format, type, null);
        createImageBitmap(element, xOffset, yOffset, size, size, {
          premultiplyAlpha: 'none',
          colorSpaceConversion: 'none',
        })
        .then(function(imageBitmap) {
          setPackState(gl, options);
          gl.bindTexture(target, tex);
          gl.texImage2D(f.face, level, internalFormat, format, type, imageBitmap);
          if (shouldAutomaticallySetTextureFilteringForSize(options)) {
            setTextureFilteringForSize(gl, tex, options, width, height, internalFormat);
          }
        });
      });
    }
  } else if (target === TEXTURE_3D || target === TEXTURE_2D_ARRAY) {
    const smallest = Math.min(element.width, element.height);
    const largest = Math.max(element.width, element.height);
    const depth = largest / smallest;
    if (depth % 1 !== 0) {
      throw "can not compute 3D dimensions of element";
    }
    const xMult = element.width  === largest ? 1 : 0;
    const yMult = element.height === largest ? 1 : 0;
    gl.pixelStorei(UNPACK_ALIGNMENT, 1);
    gl.pixelStorei(UNPACK_ROW_LENGTH, element.width);
    gl.pixelStorei(UNPACK_IMAGE_HEIGHT, 0);
    gl.pixelStorei(UNPACK_SKIP_IMAGES, 0);
    gl.texImage3D(target, level, internalFormat, smallest, smallest, smallest, 0, format, type, null);
    for (let d = 0; d < depth; ++d) {
      const srcX = d * smallest * xMult;
      const srcY = d * smallest * yMult;
      gl.pixelStorei(UNPACK_SKIP_PIXELS, srcX);
      gl.pixelStorei(UNPACK_SKIP_ROWS, srcY);
      gl.texSubImage3D(target, level, 0, 0, d, smallest, smallest, 1, format, type, element);
    }
    setSkipStateToDefault(gl);
  } else {
    gl.texImage2D(target, level, internalFormat, format, type, element);
  }
  if (shouldAutomaticallySetTextureFilteringForSize(options)) {
    setTextureFilteringForSize(gl, tex, options, width, height, internalFormat);
  }
  setTextureParameters(gl, tex, options);
}

function noop() {
}

/**
 * Checks whether the url's origin is the same so that we can set the `crossOrigin`
 * @param {string} url url to image
 * @returns {boolean} true if the window's origin is the same as image's url
 * @private
 */
function urlIsSameOrigin(url) {
  if (typeof document !== 'undefined') {
    // for IE really
    const a = document.createElement('a');
    a.href = url;
    return a.hostname === location.hostname &&
           a.port     === location.port &&
           a.protocol === location.protocol;
  } else {
    const localOrigin = (new URL(location.href)).origin;
    const urlOrigin = (new URL(url, location.href)).origin;
    return urlOrigin === localOrigin;
  }
}

function setToAnonymousIfUndefinedAndURLIsNotSameOrigin(url, crossOrigin) {
  return crossOrigin === undefined && !urlIsSameOrigin(url)
     ? 'anonymous'
     : crossOrigin;
}

/**
 * Loads an image
 * @param {string} url url to image
 * @param {string} crossOrigin
 * @param {function(err, img)} [callback] a callback that's passed an error and the image. The error will be non-null
 *     if there was an error
 * @return {HTMLImageElement} the image being loaded.
 * @private
 */
function loadImage(url, crossOrigin, callback) {
  callback = callback || noop;
  let img;
  crossOrigin = crossOrigin !== undefined ? crossOrigin : defaults$1.crossOrigin;
  crossOrigin = setToAnonymousIfUndefinedAndURLIsNotSameOrigin(url, crossOrigin);
  if (typeof Image !== 'undefined') {
    img = new Image();
    if (crossOrigin !== undefined) {
      img.crossOrigin = crossOrigin;
    }

    const clearEventHandlers = function clearEventHandlers() {
      img.removeEventListener('error', onError);  // eslint-disable-line
      img.removeEventListener('load', onLoad);  // eslint-disable-line
      img = null;
    };

    const onError = function onError() {
      const msg = "couldn't load image: " + url;
      error(msg);
      callback(msg, img);
      clearEventHandlers();
    };

    const onLoad = function onLoad() {
      callback(null, img);
      clearEventHandlers();
    };

    img.addEventListener('error', onError);
    img.addEventListener('load', onLoad);
    img.src = url;
    return img;
  } else if (typeof ImageBitmap !== 'undefined') {
    let err;
    let bm;
    const cb = function cb() {
      callback(err, bm);
    };

    const options = {};
    if (crossOrigin) {
      options.mode = 'cors'; // TODO: not sure how to translate image.crossOrigin
    }
    fetch(url, options).then(function(response) {
      if (!response.ok) {
        throw response;
      }
      return response.blob();
    }).then(function(blob) {
      return createImageBitmap(blob, {
        premultiplyAlpha: 'none',
        colorSpaceConversion: 'none',
      });
    }).then(function(bitmap) {
      // not sure if this works. We don't want
      // to catch the user's error. So, call
      // the callback in a timeout so we're
      // not in this scope inside the promise.
      bm = bitmap;
      setTimeout(cb);
    }).catch(function(e) {
      err = e;
      setTimeout(cb);
    });
    img = null;
  }
  return img;
}

/**
 * check if object is a TexImageSource
 *
 * @param {Object} obj Object to test
 * @return {boolean} true if object is a TexImageSource
 * @private
 */
function isTexImageSource(obj) {
  return (typeof ImageBitmap !== 'undefined' && obj instanceof ImageBitmap) ||
         (typeof ImageData !== 'undefined'  && obj instanceof ImageData) ||
         (typeof HTMLElement !== 'undefined'  && obj instanceof HTMLElement);
}

/**
 * if obj is an TexImageSource then just
 * uses it otherwise if obj is a string
 * then load it first.
 *
 * @param {string|TexImageSource} obj
 * @param {string} crossOrigin
 * @param {function(err, img)} [callback] a callback that's passed an error and the image. The error will be non-null
 *     if there was an error
 * @private
 */
function loadAndUseImage(obj, crossOrigin, callback) {
  if (isTexImageSource(obj)) {
    setTimeout(function() {
      callback(null, obj);
    });
    return obj;
  }

  return loadImage(obj, crossOrigin, callback);
}

/**
 * Sets a texture to a 1x1 pixel color. If `options.color === false` is nothing happens. If it's not set
 * the default texture color is used which can be set by calling `setDefaultTextureColor`.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @memberOf module:twgl/textures
 * @private
 */
function setTextureTo1PixelColor(gl, tex, options) {
  options = options || defaults$1.textureOptions;
  const target = options.target || TEXTURE_2D;
  gl.bindTexture(target, tex);
  if (options.color === false) {
    return;
  }
  // Assume it's a URL
  // Put 1x1 pixels in texture. That makes it renderable immediately regardless of filtering.
  const color = make1Pixel(options.color);
  if (target === TEXTURE_CUBE_MAP) {
    for (let ii = 0; ii < 6; ++ii) {
      gl.texImage2D(TEXTURE_CUBE_MAP_POSITIVE_X + ii, 0, RGBA, 1, 1, 0, RGBA, UNSIGNED_BYTE$2, color);
    }
  } else if (target === TEXTURE_3D || target === TEXTURE_2D_ARRAY) {
    gl.texImage3D(target, 0, RGBA, 1, 1, 1, 0, RGBA, UNSIGNED_BYTE$2, color);
  } else {
    gl.texImage2D(target, 0, RGBA, 1, 1, 0, RGBA, UNSIGNED_BYTE$2, color);
  }
}

/**
 * The src image(s) used to create a texture.
 *
 * When you call {@link module:twgl.createTexture} or {@link module:twgl.createTextures}
 * you can pass in urls for images to load into the textures. If it's a single url
 * then this will be a single HTMLImageElement. If it's an array of urls used for a cubemap
 * this will be a corresponding array of images for the cubemap.
 *
 * @typedef {HTMLImageElement|HTMLImageElement[]} TextureSrc
 * @memberOf module:twgl
 */

/**
 * A callback for when an image finished downloading and been uploaded into a texture
 * @callback TextureReadyCallback
 * @param {*} err If truthy there was an error.
 * @param {WebGLTexture} texture the texture.
 * @param {module:twgl.TextureSrc} source image(s) used to as the src for the texture
 * @memberOf module:twgl
 */

/**
 * A callback for when all images have finished downloading and been uploaded into their respective textures
 * @callback TexturesReadyCallback
 * @param {*} err If truthy there was an error.
 * @param {Object.<string, WebGLTexture>} textures the created textures by name. Same as returned by {@link module:twgl.createTextures}.
 * @param {Object.<string, module:twgl.TextureSrc>} sources the image(s) used for the texture by name.
 * @memberOf module:twgl
 */

/**
 * A callback for when an image finished downloading and been uploaded into a texture
 * @callback CubemapReadyCallback
 * @param {*} err If truthy there was an error.
 * @param {WebGLTexture} tex the texture.
 * @param {HTMLImageElement[]} imgs the images for each face.
 * @memberOf module:twgl
 */

/**
 * A callback for when an image finished downloading and been uploaded into a texture
 * @callback ThreeDReadyCallback
 * @param {*} err If truthy there was an error.
 * @param {WebGLTexture} tex the texture.
 * @param {HTMLImageElement[]} imgs the images for each slice.
 * @memberOf module:twgl
 */

/**
 * Loads a texture from an image from a Url as specified in `options.src`
 * If `options.color !== false` will set the texture to a 1x1 pixel color so that the texture is
 * immediately useable. It will be updated with the contents of the image once the image has finished
 * downloading. Filtering options will be set as appropriate for image unless `options.auto === false`.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set.
 * @param {module:twgl.TextureReadyCallback} [callback] A function to be called when the image has finished loading. err will
 *    be non null if there was an error.
 * @return {HTMLImageElement} the image being downloaded.
 * @memberOf module:twgl/textures
 */
function loadTextureFromUrl(gl, tex, options, callback) {
  callback = callback || noop;
  options = options || defaults$1.textureOptions;
  setTextureTo1PixelColor(gl, tex, options);
  // Because it's async we need to copy the options.
  options = Object.assign({}, options);
  const img = loadAndUseImage(options.src, options.crossOrigin, function(err, img) {
    if (err) {
      callback(err, tex, img);
    } else {
      setTextureFromElement(gl, tex, img, options);
      callback(null, tex, img);
    }
  });
  return img;
}

/**
 * Loads a cubemap from 6 urls or TexImageSources as specified in `options.src`. Will set the cubemap to a 1x1 pixel color
 * so that it is usable immediately unless `option.color === false`.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @param {module:twgl.CubemapReadyCallback} [callback] A function to be called when all the images have finished loading. err will
 *    be non null if there was an error.
 * @memberOf module:twgl/textures
 * @private
 */
function loadCubemapFromUrls(gl, tex, options, callback) {
  callback = callback || noop;
  const urls = options.src;
  if (urls.length !== 6) {
    throw "there must be 6 urls for a cubemap";
  }
  const level = options.level || 0;
  const internalFormat = options.internalFormat || options.format || RGBA;
  const formatType = getFormatAndTypeForInternalFormat(internalFormat);
  const format = options.format || formatType.format;
  const type = options.type || UNSIGNED_BYTE$2;
  const target = options.target || TEXTURE_2D;
  if (target !== TEXTURE_CUBE_MAP) {
    throw "target must be TEXTURE_CUBE_MAP";
  }
  setTextureTo1PixelColor(gl, tex, options);
  // Because it's async we need to copy the options.
  options = Object.assign({}, options);
  let numToLoad = 6;
  const errors = [];
  const faces = getCubeFaceOrder(gl, options);
  let imgs;  // eslint-disable-line

  function uploadImg(faceTarget) {
    return function(err, img) {
      --numToLoad;
      if (err) {
        errors.push(err);
      } else {
        if (img.width !== img.height) {
          errors.push("cubemap face img is not a square: " + img.src);
        } else {
          setPackState(gl, options);
          gl.bindTexture(target, tex);

          // So assuming this is the first image we now have one face that's img sized
          // and 5 faces that are 1x1 pixel so size the other faces
          if (numToLoad === 5) {
            // use the default order
            getCubeFaceOrder().forEach(function(otherTarget) {
              // Should we re-use the same face or a color?
              gl.texImage2D(otherTarget, level, internalFormat, format, type, img);
            });
          } else {
            gl.texImage2D(faceTarget, level, internalFormat, format, type, img);
          }

          if (shouldAutomaticallySetTextureFilteringForSize(options)) {
            gl.generateMipmap(target);
          }
        }
      }

      if (numToLoad === 0) {
        callback(errors.length ? errors : undefined, tex, imgs);
      }
    };
  }

  imgs = urls.map(function(url, ndx) {
    return loadAndUseImage(url, options.crossOrigin, uploadImg(faces[ndx]));
  });
}

/**
 * Loads a 2d array or 3d texture from urls OR TexImageSources as specified in `options.src`.
 * Will set the texture to a 1x1 pixel color
 * so that it is usable immediately unless `option.color === false`.
 *
 * If the width and height is not specified the width and height of the first
 * image loaded will be used. Note that since images are loaded async
 * which image downloads first is unknown.
 *
 * If an image is not the same size as the width and height it will be scaled
 * to that width and height.
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @param {module:twgl.ThreeDReadyCallback} [callback] A function to be called when all the images have finished loading. err will
 *    be non null if there was an error.
 * @memberOf module:twgl/textures
 * @private
 */
function loadSlicesFromUrls(gl, tex, options, callback) {
  callback = callback || noop;
  const urls = options.src;
  const internalFormat = options.internalFormat || options.format || RGBA;
  const formatType = getFormatAndTypeForInternalFormat(internalFormat);
  const format = options.format || formatType.format;
  const type = options.type || UNSIGNED_BYTE$2;
  const target = options.target || TEXTURE_2D_ARRAY;
  if (target !== TEXTURE_3D && target !== TEXTURE_2D_ARRAY) {
    throw "target must be TEXTURE_3D or TEXTURE_2D_ARRAY";
  }
  setTextureTo1PixelColor(gl, tex, options);
  // Because it's async we need to copy the options.
  options = Object.assign({}, options);
  let numToLoad = urls.length;
  const errors = [];
  let imgs;  // eslint-disable-line
  const level = options.level || 0;
  let width = options.width;
  let height = options.height;
  const depth = urls.length;
  let firstImage = true;

  function uploadImg(slice) {
    return function(err, img) {
      --numToLoad;
      if (err) {
        errors.push(err);
      } else {
        setPackState(gl, options);
        gl.bindTexture(target, tex);

        if (firstImage) {
          firstImage = false;
          width = options.width || img.width;
          height = options.height || img.height;
          gl.texImage3D(target, level, internalFormat, width, height, depth, 0, format, type, null);

          // put it in every slice otherwise some slices will be 0,0,0,0
          for (let s = 0; s < depth; ++s) {
            gl.texSubImage3D(target, level, 0, 0, s, width, height, 1, format, type, img);
          }
        } else {
          let src = img;
          let ctx;
          if (img.width !== width || img.height !== height) {
            // Size the image to fix
            ctx = getShared2DContext();
            src = ctx.canvas;
            ctx.canvas.width = width;
            ctx.canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
          }

          gl.texSubImage3D(target, level, 0, 0, slice, width, height, 1, format, type, src);

          // free the canvas memory
          if (ctx && src === ctx.canvas) {
            ctx.canvas.width = 0;
            ctx.canvas.height = 0;
          }
        }

        if (shouldAutomaticallySetTextureFilteringForSize(options)) {
          gl.generateMipmap(target);
        }
      }

      if (numToLoad === 0) {
        callback(errors.length ? errors : undefined, tex, imgs);
      }
    };
  }

  imgs = urls.map(function(url, ndx) {
    return loadAndUseImage(url, options.crossOrigin, uploadImg(ndx));
  });
}

/**
 * Sets a texture from an array or typed array. If the width or height is not provided will attempt to
 * guess the size. See {@link module:twgl.TextureOptions}.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {(number[]|ArrayBufferView)} src An array or typed arry with texture data.
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @memberOf module:twgl/textures
 */
function setTextureFromArray(gl, tex, src, options) {
  options = options || defaults$1.textureOptions;
  const target = options.target || TEXTURE_2D;
  gl.bindTexture(target, tex);
  let width = options.width;
  let height = options.height;
  let depth = options.depth;
  const level = options.level || 0;
  const internalFormat = options.internalFormat || options.format || RGBA;
  const formatType = getFormatAndTypeForInternalFormat(internalFormat);
  const format = options.format || formatType.format;
  const type = options.type || getTextureTypeForArrayType(gl, src, formatType.type);
  if (!isArrayBuffer$1(src)) {
    const Type = getTypedArrayTypeForGLType(type);
    src = new Type(src);
  } else if (src instanceof Uint8ClampedArray) {
    src = new Uint8Array(src.buffer);
  }

  const bytesPerElement = getBytesPerElementForInternalFormat(internalFormat, type);
  const numElements = src.byteLength / bytesPerElement;  // TODO: check UNPACK_ALIGNMENT?
  if (numElements % 1) {
    throw "length wrong size for format: " + glEnumToString(gl, format);
  }
  let dimensions;
  if (target === TEXTURE_3D || target === TEXTURE_2D_ARRAY) {
    if (!width && !height && !depth) {
      const size = Math.cbrt(numElements);
      if (size % 1 !== 0) {
        throw "can't guess cube size of array of numElements: " + numElements;
      }
      width = size;
      height = size;
      depth = size;
    } else if (width && (!height || !depth)) {
      dimensions = guessDimensions(gl, target, height, depth, numElements / width);
      height = dimensions.width;
      depth = dimensions.height;
    } else if (height && (!width || !depth)) {
      dimensions = guessDimensions(gl, target, width, depth, numElements / height);
      width = dimensions.width;
      depth = dimensions.height;
    } else {
      dimensions = guessDimensions(gl, target, width, height, numElements / depth);
      width = dimensions.width;
      height = dimensions.height;
    }
  } else {
    dimensions = guessDimensions(gl, target, width, height, numElements);
    width = dimensions.width;
    height = dimensions.height;
  }
  setSkipStateToDefault(gl);
  gl.pixelStorei(UNPACK_ALIGNMENT, options.unpackAlignment || 1);
  setPackState(gl, options);
  if (target === TEXTURE_CUBE_MAP) {
    const elementsPerElement = bytesPerElement / src.BYTES_PER_ELEMENT;
    const faceSize = numElements / 6 * elementsPerElement;

    getCubeFacesWithNdx(gl, options).forEach(f => {
      const offset = faceSize * f.ndx;
      const data = src.subarray(offset, offset + faceSize);
      gl.texImage2D(f.face, level, internalFormat, width, height, 0, format, type, data);
    });
  } else if (target === TEXTURE_3D || target === TEXTURE_2D_ARRAY) {
    gl.texImage3D(target, level, internalFormat, width, height, depth, 0, format, type, src);
  } else {
    gl.texImage2D(target, level, internalFormat, width, height, 0, format, type, src);
  }
  return {
    width: width,
    height: height,
    depth: depth,
    type: type,
  };
}

/**
 * Sets a texture with no contents of a certain size. In other words calls `gl.texImage2D` with `null`.
 * You must set `options.width` and `options.height`.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @memberOf module:twgl/textures
 */
function setEmptyTexture(gl, tex, options) {
  const target = options.target || TEXTURE_2D;
  gl.bindTexture(target, tex);
  const level = options.level || 0;
  const internalFormat = options.internalFormat || options.format || RGBA;
  const formatType = getFormatAndTypeForInternalFormat(internalFormat);
  const format = options.format || formatType.format;
  const type = options.type || formatType.type;
  setPackState(gl, options);
  if (target === TEXTURE_CUBE_MAP) {
    for (let ii = 0; ii < 6; ++ii) {
      gl.texImage2D(TEXTURE_CUBE_MAP_POSITIVE_X + ii, level, internalFormat, options.width, options.height, 0, format, type, null);
    }
  } else if (target === TEXTURE_3D || target === TEXTURE_2D_ARRAY) {
    gl.texImage3D(target, level, internalFormat, options.width, options.height, options.depth, 0, format, type, null);
  } else {
    gl.texImage2D(target, level, internalFormat, options.width, options.height, 0, format, type, null);
  }
}

/**
 * Creates a texture based on the options passed in.
 *
 * Note: may reset UNPACK_ALIGNMENT, UNPACK_ROW_LENGTH, UNPACK_IMAGE_HEIGHT, UNPACK_SKIP_IMAGES
 * UNPACK_SKIP_PIXELS, and UNPACK_SKIP_ROWS
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set.
 * @param {module:twgl.TextureReadyCallback} [callback] A callback called when an image has been downloaded and uploaded to the texture.
 * @return {WebGLTexture} the created texture.
 * @memberOf module:twgl/textures
 */
function createTexture(gl, options, callback) {
  callback = callback || noop;
  options = options || defaults$1.textureOptions;
  const tex = gl.createTexture();
  const target = options.target || TEXTURE_2D;
  let width  = options.width  || 1;
  let height = options.height || 1;
  const internalFormat = options.internalFormat || RGBA;
  gl.bindTexture(target, tex);
  if (target === TEXTURE_CUBE_MAP) {
    // this should have been the default for cubemaps :(
    gl.texParameteri(target, TEXTURE_WRAP_S, CLAMP_TO_EDGE);
    gl.texParameteri(target, TEXTURE_WRAP_T, CLAMP_TO_EDGE);
  }
  let src = options.src;
  if (src) {
    if (typeof src === "function") {
      src = src(gl, options);
    }
    if (typeof (src) === "string") {
      loadTextureFromUrl(gl, tex, options, callback);
    } else if (isArrayBuffer$1(src) ||
               (Array.isArray(src) && (
                    typeof src[0] === 'number' ||
                    Array.isArray(src[0]) ||
                    isArrayBuffer$1(src[0]))
               )
              ) {
      const dimensions = setTextureFromArray(gl, tex, src, options);
      width  = dimensions.width;
      height = dimensions.height;
    } else if (Array.isArray(src) && (typeof (src[0]) === 'string' || isTexImageSource(src[0]))) {
      if (target === TEXTURE_CUBE_MAP) {
        loadCubemapFromUrls(gl, tex, options, callback);
      } else {
        loadSlicesFromUrls(gl, tex, options, callback);
      }
    } else { // if (isTexImageSource(src))
      setTextureFromElement(gl, tex, src, options);
      width  = src.width;
      height = src.height;
    }
  } else {
    setEmptyTexture(gl, tex, options);
  }
  if (shouldAutomaticallySetTextureFilteringForSize(options)) {
    setTextureFilteringForSize(gl, tex, options, width, height, internalFormat);
  }
  setTextureParameters(gl, tex, options);
  return tex;
}

/**
 * Resizes a texture based on the options passed in.
 *
 * Note: This is not a generic resize anything function.
 * It's mostly used by {@link module:twgl.resizeFramebufferInfo}
 * It will use `options.src` if it exists to try to determine a `type`
 * otherwise it will assume `gl.UNSIGNED_BYTE`. No data is provided
 * for the texture. Texture parameters will be set accordingly
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the texture to resize
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @param {number} [width] the new width. If not passed in will use `options.width`
 * @param {number} [height] the new height. If not passed in will use `options.height`
 * @param {number} [depth] the new depth. If not passed in will use `options.depth`
 * @memberOf module:twgl/textures
 */
function resizeTexture(gl, tex, options, width, height, depth) {
  width = width || options.width;
  height = height || options.height;
  depth = depth || options.depth;
  const target = options.target || TEXTURE_2D;
  gl.bindTexture(target, tex);
  const level = options.level || 0;
  const internalFormat = options.internalFormat || options.format || RGBA;
  const formatType = getFormatAndTypeForInternalFormat(internalFormat);
  const format = options.format || formatType.format;
  let type;
  const src = options.src;
  if (!src) {
    type = options.type || formatType.type;
  } else if (isArrayBuffer$1(src) || (Array.isArray(src) && typeof (src[0]) === 'number')) {
    type = options.type || getTextureTypeForArrayType(gl, src, formatType.type);
  } else {
    type = options.type || formatType.type;
  }
  if (target === TEXTURE_CUBE_MAP) {
    for (let ii = 0; ii < 6; ++ii) {
      gl.texImage2D(TEXTURE_CUBE_MAP_POSITIVE_X + ii, level, internalFormat, width, height, 0, format, type, null);
    }
  } else if (target === TEXTURE_3D || target === TEXTURE_2D_ARRAY) {
    gl.texImage3D(target, level, internalFormat, width, height, depth, 0, format, type, null);
  } else {
    gl.texImage2D(target, level, internalFormat, width, height, 0, format, type, null);
  }
}

/**
 * Check if a src is an async request.
 * if src is a string we're going to download an image
 * if src is an array of strings we're going to download cubemap images
 * @param {*} src The src from a TextureOptions
 * @returns {bool} true if src is async.
 * @private
 */
function isAsyncSrc(src) {
  return typeof src === 'string' ||
         (Array.isArray(src) && typeof src[0] === 'string');
}

/**
 * Creates a bunch of textures based on the passed in options.
 *
 * Example:
 *
 *     const textures = twgl.createTextures(gl, {
 *       // a power of 2 image
 *       hftIcon: { src: "images/hft-icon-16.png", mag: gl.NEAREST },
 *       // a non-power of 2 image
 *       clover: { src: "images/clover.jpg" },
 *       // From a canvas
 *       fromCanvas: { src: ctx.canvas },
 *       // A cubemap from 6 images
 *       yokohama: {
 *         target: gl.TEXTURE_CUBE_MAP,
 *         src: [
 *           'images/yokohama/posx.jpg',
 *           'images/yokohama/negx.jpg',
 *           'images/yokohama/posy.jpg',
 *           'images/yokohama/negy.jpg',
 *           'images/yokohama/posz.jpg',
 *           'images/yokohama/negz.jpg',
 *         ],
 *       },
 *       // A cubemap from 1 image (can be 1x6, 2x3, 3x2, 6x1)
 *       goldengate: {
 *         target: gl.TEXTURE_CUBE_MAP,
 *         src: 'images/goldengate.jpg',
 *       },
 *       // A 2x2 pixel texture from a JavaScript array
 *       checker: {
 *         mag: gl.NEAREST,
 *         min: gl.LINEAR,
 *         src: [
 *           255,255,255,255,
 *           192,192,192,255,
 *           192,192,192,255,
 *           255,255,255,255,
 *         ],
 *       },
 *       // a 1x2 pixel texture from a typed array.
 *       stripe: {
 *         mag: gl.NEAREST,
 *         min: gl.LINEAR,
 *         format: gl.LUMINANCE,
 *         src: new Uint8Array([
 *           255,
 *           128,
 *           255,
 *           128,
 *           255,
 *           128,
 *           255,
 *           128,
 *         ]),
 *         width: 1,
 *       },
 *     });
 *
 * Now
 *
 * *   `textures.hftIcon` will be a 2d texture
 * *   `textures.clover` will be a 2d texture
 * *   `textures.fromCanvas` will be a 2d texture
 * *   `textures.yohohama` will be a cubemap texture
 * *   `textures.goldengate` will be a cubemap texture
 * *   `textures.checker` will be a 2d texture
 * *   `textures.stripe` will be a 2d texture
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {Object.<string,module:twgl.TextureOptions>} options A object of TextureOptions one per texture.
 * @param {module:twgl.TexturesReadyCallback} [callback] A callback called when all textures have been downloaded.
 * @return {Object.<string,WebGLTexture>} the created textures by name
 * @memberOf module:twgl/textures
 */
function createTextures(gl, textureOptions, callback) {
  callback = callback || noop;
  let numDownloading = 0;
  const errors = [];
  const textures = {};
  const images = {};

  function callCallbackIfReady() {
    if (numDownloading === 0) {
      setTimeout(function() {
        callback(errors.length ? errors : undefined, textures, images);
      }, 0);
    }
  }

  Object.keys(textureOptions).forEach(function(name) {
    const options = textureOptions[name];
    let onLoadFn;
    if (isAsyncSrc(options.src)) {
      onLoadFn = function(err, tex, img) {
        images[name] = img;
        --numDownloading;
        if (err) {
          errors.push(err);
        }
        callCallbackIfReady();
      };
      ++numDownloading;
    }
    textures[name] = createTexture(gl, options, onLoadFn);
  });

  // queue the callback if there are no images to download.
  // We do this because if your code is structured to wait for
  // images to download but then you comment out all the async
  // images your code would break.
  callCallbackIfReady();

  return textures;
}

var textures = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setTextureDefaults_: setDefaults$1,
  createSampler: createSampler,
  createSamplers: createSamplers,
  setSamplerParameters: setSamplerParameters,
  createTexture: createTexture,
  setEmptyTexture: setEmptyTexture,
  setTextureFromArray: setTextureFromArray,
  loadTextureFromUrl: loadTextureFromUrl,
  setTextureFromElement: setTextureFromElement,
  setTextureFilteringForSize: setTextureFilteringForSize,
  setTextureParameters: setTextureParameters,
  setDefaultTextureColor: setDefaultTextureColor,
  createTextures: createTextures,
  resizeTexture: resizeTexture,
  canGenerateMipmap: canGenerateMipmap,
  canFilter: canFilter,
  getNumComponentsForFormat: getNumComponentsForFormat,
  getBytesPerElementForInternalFormat: getBytesPerElementForInternalFormat,
  getFormatAndTypeForInternalFormat: getFormatAndTypeForInternalFormat
});

/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

/**
 * Low level shader program related functions
 *
 * You should generally not need to use these functions. They are provided
 * for those cases where you're doing something out of the ordinary
 * and you need lower level access.
 *
 * For backward compatibility they are available at both `twgl.programs` and `twgl`
 * itself
 *
 * See {@link module:twgl} for core functions
 *
 * @module twgl/programs
 */

const error$1 = error;
const warn$1 = warn;
function getElementById(id) {
  return (typeof document !== 'undefined' && document.getElementById)
      ? document.getElementById(id)
      : null;
}

const TEXTURE0                       = 0x84c0;
const DYNAMIC_DRAW                   = 0x88e8;

const ARRAY_BUFFER$1                   = 0x8892;
const ELEMENT_ARRAY_BUFFER$1           = 0x8893;
const UNIFORM_BUFFER                 = 0x8a11;
const TRANSFORM_FEEDBACK_BUFFER      = 0x8c8e;

const TRANSFORM_FEEDBACK             = 0x8e22;

const COMPILE_STATUS                 = 0x8b81;
const LINK_STATUS                    = 0x8b82;
const FRAGMENT_SHADER                = 0x8b30;
const VERTEX_SHADER                  = 0x8b31;
const SEPARATE_ATTRIBS               = 0x8c8d;

const ACTIVE_UNIFORMS                = 0x8b86;
const ACTIVE_ATTRIBUTES              = 0x8b89;
const TRANSFORM_FEEDBACK_VARYINGS    = 0x8c83;
const ACTIVE_UNIFORM_BLOCKS          = 0x8a36;
const UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER   = 0x8a44;
const UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER = 0x8a46;
const UNIFORM_BLOCK_DATA_SIZE                     = 0x8a40;
const UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES        = 0x8a43;

const FLOAT$3                         = 0x1406;
const FLOAT_VEC2                    = 0x8B50;
const FLOAT_VEC3                    = 0x8B51;
const FLOAT_VEC4                    = 0x8B52;
const INT$3                           = 0x1404;
const INT_VEC2                      = 0x8B53;
const INT_VEC3                      = 0x8B54;
const INT_VEC4                      = 0x8B55;
const BOOL                          = 0x8B56;
const BOOL_VEC2                     = 0x8B57;
const BOOL_VEC3                     = 0x8B58;
const BOOL_VEC4                     = 0x8B59;
const FLOAT_MAT2                    = 0x8B5A;
const FLOAT_MAT3                    = 0x8B5B;
const FLOAT_MAT4                    = 0x8B5C;
const SAMPLER_2D                    = 0x8B5E;
const SAMPLER_CUBE                  = 0x8B60;
const SAMPLER_3D                    = 0x8B5F;
const SAMPLER_2D_SHADOW             = 0x8B62;
const FLOAT_MAT2x3                  = 0x8B65;
const FLOAT_MAT2x4                  = 0x8B66;
const FLOAT_MAT3x2                  = 0x8B67;
const FLOAT_MAT3x4                  = 0x8B68;
const FLOAT_MAT4x2                  = 0x8B69;
const FLOAT_MAT4x3                  = 0x8B6A;
const SAMPLER_2D_ARRAY              = 0x8DC1;
const SAMPLER_2D_ARRAY_SHADOW       = 0x8DC4;
const SAMPLER_CUBE_SHADOW           = 0x8DC5;
const UNSIGNED_INT$3                  = 0x1405;
const UNSIGNED_INT_VEC2             = 0x8DC6;
const UNSIGNED_INT_VEC3             = 0x8DC7;
const UNSIGNED_INT_VEC4             = 0x8DC8;
const INT_SAMPLER_2D                = 0x8DCA;
const INT_SAMPLER_3D                = 0x8DCB;
const INT_SAMPLER_CUBE              = 0x8DCC;
const INT_SAMPLER_2D_ARRAY          = 0x8DCF;
const UNSIGNED_INT_SAMPLER_2D       = 0x8DD2;
const UNSIGNED_INT_SAMPLER_3D       = 0x8DD3;
const UNSIGNED_INT_SAMPLER_CUBE     = 0x8DD4;
const UNSIGNED_INT_SAMPLER_2D_ARRAY = 0x8DD7;

const TEXTURE_2D$1                    = 0x0DE1;
const TEXTURE_CUBE_MAP$1              = 0x8513;
const TEXTURE_3D$1                    = 0x806F;
const TEXTURE_2D_ARRAY$1              = 0x8C1A;

const typeMap = {};

/**
 * Returns the corresponding bind point for a given sampler type
 * @private
 */
function getBindPointForSamplerType(gl, type) {
  return typeMap[type].bindPoint;
}

// This kind of sucks! If you could compose functions as in `var fn = gl[name];`
// this code could be a lot smaller but that is sadly really slow (T_T)

function floatSetter(gl, location) {
  return function(v) {
    gl.uniform1f(location, v);
  };
}

function floatArraySetter(gl, location) {
  return function(v) {
    gl.uniform1fv(location, v);
  };
}

function floatVec2Setter(gl, location) {
  return function(v) {
    gl.uniform2fv(location, v);
  };
}

function floatVec3Setter(gl, location) {
  return function(v) {
    gl.uniform3fv(location, v);
  };
}

function floatVec4Setter(gl, location) {
  return function(v) {
    gl.uniform4fv(location, v);
  };
}

function intSetter(gl, location) {
  return function(v) {
    gl.uniform1i(location, v);
  };
}

function intArraySetter(gl, location) {
  return function(v) {
    gl.uniform1iv(location, v);
  };
}

function intVec2Setter(gl, location) {
  return function(v) {
    gl.uniform2iv(location, v);
  };
}

function intVec3Setter(gl, location) {
  return function(v) {
    gl.uniform3iv(location, v);
  };
}

function intVec4Setter(gl, location) {
  return function(v) {
    gl.uniform4iv(location, v);
  };
}

function uintSetter(gl, location) {
  return function(v) {
    gl.uniform1ui(location, v);
  };
}

function uintArraySetter(gl, location) {
  return function(v) {
    gl.uniform1uiv(location, v);
  };
}

function uintVec2Setter(gl, location) {
  return function(v) {
    gl.uniform2uiv(location, v);
  };
}

function uintVec3Setter(gl, location) {
  return function(v) {
    gl.uniform3uiv(location, v);
  };
}

function uintVec4Setter(gl, location) {
  return function(v) {
    gl.uniform4uiv(location, v);
  };
}

function floatMat2Setter(gl, location) {
  return function(v) {
    gl.uniformMatrix2fv(location, false, v);
  };
}

function floatMat3Setter(gl, location) {
  return function(v) {
    gl.uniformMatrix3fv(location, false, v);
  };
}

function floatMat4Setter(gl, location) {
  return function(v) {
    gl.uniformMatrix4fv(location, false, v);
  };
}

function floatMat23Setter(gl, location) {
  return function(v) {
    gl.uniformMatrix2x3fv(location, false, v);
  };
}

function floatMat32Setter(gl, location) {
  return function(v) {
    gl.uniformMatrix3x2fv(location, false, v);
  };
}

function floatMat24Setter(gl, location) {
  return function(v) {
    gl.uniformMatrix2x4fv(location, false, v);
  };
}

function floatMat42Setter(gl, location) {
  return function(v) {
    gl.uniformMatrix4x2fv(location, false, v);
  };
}

function floatMat34Setter(gl, location) {
  return function(v) {
    gl.uniformMatrix3x4fv(location, false, v);
  };
}

function floatMat43Setter(gl, location) {
  return function(v) {
    gl.uniformMatrix4x3fv(location, false, v);
  };
}

function samplerSetter(gl, type, unit, location) {
  const bindPoint = getBindPointForSamplerType(gl, type);
  return isWebGL2(gl) ? function(textureOrPair) {
    let texture;
    let sampler;
    if (isTexture(gl, textureOrPair)) {
      texture = textureOrPair;
      sampler = null;
    } else {
      texture = textureOrPair.texture;
      sampler = textureOrPair.sampler;
    }
    gl.uniform1i(location, unit);
    gl.activeTexture(TEXTURE0 + unit);
    gl.bindTexture(bindPoint, texture);
    gl.bindSampler(unit, sampler);
  } : function(texture) {
    gl.uniform1i(location, unit);
    gl.activeTexture(TEXTURE0 + unit);
    gl.bindTexture(bindPoint, texture);
  };
}

function samplerArraySetter(gl, type, unit, location, size) {
  const bindPoint = getBindPointForSamplerType(gl, type);
  const units = new Int32Array(size);
  for (let ii = 0; ii < size; ++ii) {
    units[ii] = unit + ii;
  }

  return isWebGL2(gl) ? function(textures) {
    gl.uniform1iv(location, units);
    textures.forEach(function(textureOrPair, index) {
      gl.activeTexture(TEXTURE0 + units[index]);
      let texture;
      let sampler;
      if (isTexture(gl, textureOrPair)) {
        texture = textureOrPair;
        sampler = null;
      } else {
        texture = textureOrPair.texture;
        sampler = textureOrPair.sampler;
      }
      gl.bindSampler(unit, sampler);
      gl.bindTexture(bindPoint, texture);
    });
  } : function(textures) {
    gl.uniform1iv(location, units);
    textures.forEach(function(texture, index) {
      gl.activeTexture(TEXTURE0 + units[index]);
      gl.bindTexture(bindPoint, texture);
    });
  };
}

typeMap[FLOAT$3]                         = { Type: Float32Array, size:  4, setter: floatSetter,      arraySetter: floatArraySetter, };
typeMap[FLOAT_VEC2]                    = { Type: Float32Array, size:  8, setter: floatVec2Setter,  cols: 2, };
typeMap[FLOAT_VEC3]                    = { Type: Float32Array, size: 12, setter: floatVec3Setter,  cols: 3, };
typeMap[FLOAT_VEC4]                    = { Type: Float32Array, size: 16, setter: floatVec4Setter,  cols: 4, };
typeMap[INT$3]                           = { Type: Int32Array,   size:  4, setter: intSetter,        arraySetter: intArraySetter, };
typeMap[INT_VEC2]                      = { Type: Int32Array,   size:  8, setter: intVec2Setter,    cols: 2, };
typeMap[INT_VEC3]                      = { Type: Int32Array,   size: 12, setter: intVec3Setter,    cols: 3, };
typeMap[INT_VEC4]                      = { Type: Int32Array,   size: 16, setter: intVec4Setter,    cols: 4, };
typeMap[UNSIGNED_INT$3]                  = { Type: Uint32Array,  size:  4, setter: uintSetter,       arraySetter: uintArraySetter, };
typeMap[UNSIGNED_INT_VEC2]             = { Type: Uint32Array,  size:  8, setter: uintVec2Setter,   cols: 2, };
typeMap[UNSIGNED_INT_VEC3]             = { Type: Uint32Array,  size: 12, setter: uintVec3Setter,   cols: 3, };
typeMap[UNSIGNED_INT_VEC4]             = { Type: Uint32Array,  size: 16, setter: uintVec4Setter,   cols: 4, };
typeMap[BOOL]                          = { Type: Uint32Array,  size:  4, setter: intSetter,        arraySetter: intArraySetter, };
typeMap[BOOL_VEC2]                     = { Type: Uint32Array,  size:  8, setter: intVec2Setter,    cols: 2, };
typeMap[BOOL_VEC3]                     = { Type: Uint32Array,  size: 12, setter: intVec3Setter,    cols: 3, };
typeMap[BOOL_VEC4]                     = { Type: Uint32Array,  size: 16, setter: intVec4Setter,    cols: 4, };
typeMap[FLOAT_MAT2]                    = { Type: Float32Array, size: 32, setter: floatMat2Setter,  rows: 2, cols: 2, };
typeMap[FLOAT_MAT3]                    = { Type: Float32Array, size: 48, setter: floatMat3Setter,  rows: 3, cols: 3, };
typeMap[FLOAT_MAT4]                    = { Type: Float32Array, size: 64, setter: floatMat4Setter,  rows: 4, cols: 4, };
typeMap[FLOAT_MAT2x3]                  = { Type: Float32Array, size: 32, setter: floatMat23Setter, rows: 2, cols: 3, };
typeMap[FLOAT_MAT2x4]                  = { Type: Float32Array, size: 32, setter: floatMat24Setter, rows: 2, cols: 4, };
typeMap[FLOAT_MAT3x2]                  = { Type: Float32Array, size: 48, setter: floatMat32Setter, rows: 3, cols: 2, };
typeMap[FLOAT_MAT3x4]                  = { Type: Float32Array, size: 48, setter: floatMat34Setter, rows: 3, cols: 4, };
typeMap[FLOAT_MAT4x2]                  = { Type: Float32Array, size: 64, setter: floatMat42Setter, rows: 4, cols: 2, };
typeMap[FLOAT_MAT4x3]                  = { Type: Float32Array, size: 64, setter: floatMat43Setter, rows: 4, cols: 3, };
typeMap[SAMPLER_2D]                    = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_2D$1,       };
typeMap[SAMPLER_CUBE]                  = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_CUBE_MAP$1, };
typeMap[SAMPLER_3D]                    = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_3D$1,       };
typeMap[SAMPLER_2D_SHADOW]             = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_2D$1,       };
typeMap[SAMPLER_2D_ARRAY]              = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_2D_ARRAY$1, };
typeMap[SAMPLER_2D_ARRAY_SHADOW]       = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_2D_ARRAY$1, };
typeMap[SAMPLER_CUBE_SHADOW]           = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_CUBE_MAP$1, };
typeMap[INT_SAMPLER_2D]                = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_2D$1,       };
typeMap[INT_SAMPLER_3D]                = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_3D$1,       };
typeMap[INT_SAMPLER_CUBE]              = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_CUBE_MAP$1, };
typeMap[INT_SAMPLER_2D_ARRAY]          = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_2D_ARRAY$1, };
typeMap[UNSIGNED_INT_SAMPLER_2D]       = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_2D$1,       };
typeMap[UNSIGNED_INT_SAMPLER_3D]       = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_3D$1,       };
typeMap[UNSIGNED_INT_SAMPLER_CUBE]     = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_CUBE_MAP$1, };
typeMap[UNSIGNED_INT_SAMPLER_2D_ARRAY] = { Type: null,         size:  0, setter: samplerSetter,    arraySetter: samplerArraySetter, bindPoint: TEXTURE_2D_ARRAY$1, };

function floatAttribSetter(gl, index) {
  return function(b) {
    if (b.value) {
      gl.disableVertexAttribArray(index);
      switch (b.value.length) {
        case 4:
          gl.vertexAttrib4fv(index, b.value);
          break;
        case 3:
          gl.vertexAttrib3fv(index, b.value);
          break;
        case 2:
          gl.vertexAttrib2fv(index, b.value);
          break;
        case 1:
          gl.vertexAttrib1fv(index, b.value);
          break;
        default:
          throw new Error('the length of a float constant value must be between 1 and 4!');
      }
    } else {
      gl.bindBuffer(ARRAY_BUFFER$1, b.buffer);
      gl.enableVertexAttribArray(index);
      gl.vertexAttribPointer(
          index, b.numComponents || b.size, b.type || FLOAT$3, b.normalize || false, b.stride || 0, b.offset || 0);
      if (b.divisor !== undefined) {
        gl.vertexAttribDivisor(index, b.divisor);
      }
    }
  };
}

function intAttribSetter(gl, index) {
  return function(b) {
    if (b.value) {
      gl.disableVertexAttribArray(index);
      if (b.value.length === 4) {
        gl.vertexAttrib4iv(index, b.value);
      } else {
        throw new Error('The length of an integer constant value must be 4!');
      }
    } else {
      gl.bindBuffer(ARRAY_BUFFER$1, b.buffer);
      gl.enableVertexAttribArray(index);
      gl.vertexAttribIPointer(
          index, b.numComponents || b.size, b.type || INT$3, b.stride || 0, b.offset || 0);
      if (b.divisor !== undefined) {
        gl.vertexAttribDivisor(index, b.divisor);
      }
    }
  };
}

function uintAttribSetter(gl, index) {
  return function(b) {
    if (b.value) {
      gl.disableVertexAttribArray(index);
      if (b.value.length === 4) {
        gl.vertexAttrib4uiv(index, b.value);
      } else {
        throw new Error('The length of an unsigned integer constant value must be 4!');
      }
    } else {
      gl.bindBuffer(ARRAY_BUFFER$1, b.buffer);
      gl.enableVertexAttribArray(index);
      gl.vertexAttribIPointer(
          index, b.numComponents || b.size, b.type || UNSIGNED_INT$3, b.stride || 0, b.offset || 0);
      if (b.divisor !== undefined) {
        gl.vertexAttribDivisor(index, b.divisor);
      }
    }
  };
}

function matAttribSetter(gl, index, typeInfo) {
  const defaultSize = typeInfo.size;
  const count = typeInfo.count;

  return function(b) {
    gl.bindBuffer(ARRAY_BUFFER$1, b.buffer);
    const numComponents = b.size || b.numComponents || defaultSize;
    const size = numComponents / count;
    const type = b.type || FLOAT$3;
    const typeInfo = typeMap[type];
    const stride = typeInfo.size * numComponents;
    const normalize = b.normalize || false;
    const offset = b.offset || 0;
    const rowOffset = stride / count;
    for (let i = 0; i < count; ++i) {
      gl.enableVertexAttribArray(index + i);
      gl.vertexAttribPointer(
          index + i, size, type, normalize, stride, offset + rowOffset * i);
      if (b.divisor !== undefined) {
        gl.vertexAttribDivisor(index + i, b.divisor);
      }
    }
  };
}



const attrTypeMap = {};
attrTypeMap[FLOAT$3]             = { size:  4, setter: floatAttribSetter, };
attrTypeMap[FLOAT_VEC2]        = { size:  8, setter: floatAttribSetter, };
attrTypeMap[FLOAT_VEC3]        = { size: 12, setter: floatAttribSetter, };
attrTypeMap[FLOAT_VEC4]        = { size: 16, setter: floatAttribSetter, };
attrTypeMap[INT$3]               = { size:  4, setter: intAttribSetter,   };
attrTypeMap[INT_VEC2]          = { size:  8, setter: intAttribSetter,   };
attrTypeMap[INT_VEC3]          = { size: 12, setter: intAttribSetter,   };
attrTypeMap[INT_VEC4]          = { size: 16, setter: intAttribSetter,   };
attrTypeMap[UNSIGNED_INT$3]      = { size:  4, setter: uintAttribSetter,  };
attrTypeMap[UNSIGNED_INT_VEC2] = { size:  8, setter: uintAttribSetter,  };
attrTypeMap[UNSIGNED_INT_VEC3] = { size: 12, setter: uintAttribSetter,  };
attrTypeMap[UNSIGNED_INT_VEC4] = { size: 16, setter: uintAttribSetter,  };
attrTypeMap[BOOL]              = { size:  4, setter: intAttribSetter,   };
attrTypeMap[BOOL_VEC2]         = { size:  8, setter: intAttribSetter,   };
attrTypeMap[BOOL_VEC3]         = { size: 12, setter: intAttribSetter,   };
attrTypeMap[BOOL_VEC4]         = { size: 16, setter: intAttribSetter,   };
attrTypeMap[FLOAT_MAT2]        = { size:  4, setter: matAttribSetter,   count: 2, };
attrTypeMap[FLOAT_MAT3]        = { size:  9, setter: matAttribSetter,   count: 3, };
attrTypeMap[FLOAT_MAT4]        = { size: 16, setter: matAttribSetter,   count: 4, };

const errorRE = /ERROR:\s*\d+:(\d+)/gi;
function addLineNumbersWithError(src, log = '', lineOffset = 0) {
  // Note: Error message formats are not defined by any spec so this may or may not work.
  const matches = [...log.matchAll(errorRE)];
  const lineNoToErrorMap = new Map(matches.map((m, ndx) => {
    const lineNo = parseInt(m[1]);
    const next = matches[ndx + 1];
    const end = next ? next.index : log.length;
    const msg = log.substring(m.index, end);
    return [lineNo - 1, msg];
  }));
  return src.split('\n').map((line, lineNo) => {
    const err = lineNoToErrorMap.get(lineNo);
    return `${lineNo + 1 + lineOffset}: ${line}${err ? `\n\n^^^ ${err}` : ''}`;
  }).join('\n');
}

/**
 * Error Callback
 * @callback ErrorCallback
 * @param {string} msg error message.
 * @param {number} [lineOffset] amount to add to line number
 * @memberOf module:twgl
 */

/**
 * Program Callback
 * @callback ProgramCallback
 * @param {string} [err] error message, falsy if no error
 * @param {WebGLProgram|module:twgl.ProgramInfo} [result] the program or programInfo
 */

const spaceRE = /^[ \t]*\n/;

/**
 * Remove the first end of line because WebGL 2.0 requires
 * #version 300 es
 * as the first line. No whitespace allowed before that line
 * so
 *
 * <script>
 * #version 300 es
 * </script>
 *
 * Has one line before it which is invalid according to GLSL ES 3.00
 *
 * @param {string} shaderSource The source of the shader
 * @returns {{shaderSource: string, lineOffset: number}}
 * @private
 */
function prepShaderSource(shaderSource) {
  let lineOffset = 0;
  if (spaceRE.test(shaderSource)) {
    lineOffset = 1;
    shaderSource = shaderSource.replace(spaceRE, '');
  }
  return {lineOffset, shaderSource};
}

/**
 * @param {module:twgl.ProgramOptions} progOptions
 * @param {string} msg
 * @return null
 * @private
 */
function reportError(progOptions, msg) {
  progOptions.errorCallback(msg);
  if (progOptions.callback) {
    setTimeout(() => {
      progOptions.callback(`${msg}\n${progOptions.errors.join('\n')}`);
    });
  }
  return null;
}

/**
 * Loads a shader.
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {string} shaderSource The shader source.
 * @param {number} shaderType The type of shader.
 * @param {module:twgl.ProgramOptions} progOptions
 * @return {WebGLShader} The created shader.
 * @private
 */
function loadShader(gl, shaderSource, shaderType, progOptions) {
  // Create the shader object
  const shader = gl.createShader(shaderType);

  // Load the shader source
  gl.shaderSource(shader, prepShaderSource(shaderSource).shaderSource);

  // Compile the shader
  gl.compileShader(shader);

  if (!progOptions.callback && !checkShaderStatus(gl, shaderType, shader, progOptions.errorCallback)) {
    gl.deleteShader(shader);
    return null;
  }

  return shader;
}

/**
 * Check Shader status
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {number} shaderType The shader type
 * @param {WebGLShader} shader The shader
 * @param {ErrorCallback} [errFn] function to receive error message.
 * @return {bool} true if shader is ok.
 * @private
 */
function checkShaderStatus(gl, shaderType, shader, errFn) {
  errFn = errFn || error$1;
  // Check the compile status
  const compiled = gl.getShaderParameter(shader, COMPILE_STATUS);
  if (!compiled) {
    // Something went wrong during compilation; get the error
    const lastError = gl.getShaderInfoLog(shader);
    const {lineOffset, shaderSource} = prepShaderSource(gl.getShaderSource(shader));
    errFn(`${addLineNumbersWithError(shaderSource, lastError, lineOffset)}\nError compiling ${glEnumToString(gl, shaderType)}: ${lastError}`);
  }
  return compiled;
}

/**
 * @typedef {Object} ProgramOptions
 * @property {function(string)} [errorCallback] callback for errors
 * @property {Object.<string,number>} [attribLocations] a attribute name to location map
 * @property {(module:twgl.BufferInfo|Object.<string,module:twgl.AttribInfo>|string[])} [transformFeedbackVaryings] If passed
 *   a BufferInfo will use the attribs names inside. If passed an object of AttribInfos will use the names from that object. Otherwise
 *   you can pass an array of names.
 * @property {number} [transformFeedbackMode] the mode to pass `gl.transformFeedbackVaryings`. Defaults to `SEPARATE_ATTRIBS`.
 * @property {ProgramCallback} [callback] callback for async program compilation.
 * @memberOf module:twgl
 */

/**
 * Gets the program options based on all these optional arguments
 * @param {module:twgl.ProgramOptions|string[]} [opt_attribs] Options for the program or an array of attribs names. Locations will be assigned by index if not passed in
 * @param {number[]} [opt_locations] The locations for the. A parallel array to opt_attribs letting you assign locations.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {module:twgl.ProgramOptions} an instance of ProgramOptions based on the arguments passed in
 * @private
 */
function getProgramOptions(opt_attribs, opt_locations, opt_errorCallback) {
  let transformFeedbackVaryings;
  let transformFeedbackMode;
  let callback;
  if (typeof opt_locations === 'function') {
    opt_errorCallback = opt_locations;
    opt_locations = undefined;
  }
  if (typeof opt_attribs === 'function') {
    opt_errorCallback = opt_attribs;
    opt_attribs = undefined;
  } else if (opt_attribs && !Array.isArray(opt_attribs)) {
    // If we have an errorCallback we can just return this object
    // Otherwise we need to construct one with default errorCallback
    if (opt_attribs.errorCallback && opt_attribs.errors) {
      return opt_attribs;
    }
    const opt = opt_attribs;
    opt_errorCallback = opt.errorCallback;
    opt_attribs = opt.attribLocations;
    transformFeedbackVaryings = opt.transformFeedbackVaryings;
    transformFeedbackMode = opt.transformFeedbackMode;
    callback = opt.callback;
  }

  const errorCallback = opt_errorCallback || error$1;
  const errors = [];
  const options = {
    errorCallback(msg, ...args) {
      errors.push(msg);
      errorCallback(msg, ...args);
    },
    transformFeedbackVaryings,
    transformFeedbackMode,
    callback,
    errors,
  };

  if (opt_attribs) {
    let attribLocations = {};
    if (Array.isArray(opt_attribs)) {
      opt_attribs.forEach(function(attrib,  ndx) {
        attribLocations[attrib] = opt_locations ? opt_locations[ndx] : ndx;
      });
    } else {
      attribLocations = opt_attribs;
    }
    options.attribLocations = attribLocations;
  }

  return options;
}

const defaultShaderType = [
  "VERTEX_SHADER",
  "FRAGMENT_SHADER",
];

function getShaderTypeFromScriptType(gl, scriptType) {
  if (scriptType.indexOf("frag") >= 0) {
    return FRAGMENT_SHADER;
  } else if (scriptType.indexOf("vert") >= 0) {
    return VERTEX_SHADER;
  }
  return undefined;
}

function deleteShaders(gl, shaders) {
  shaders.forEach(function(shader) {
    gl.deleteShader(shader);
  });
}

const wait = (ms = 0) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Creates a program, attaches (and/or compiles) shaders, binds attrib locations, links the
 * program.
 *
 * NOTE: There are 4 signatures for this function
 *
 *     twgl.createProgram(gl, [vs, fs], options);
 *     twgl.createProgram(gl, [vs, fs], opt_errFunc);
 *     twgl.createProgram(gl, [vs, fs], opt_attribs, opt_errFunc);
 *     twgl.createProgram(gl, [vs, fs], opt_attribs, opt_locations, opt_errFunc);
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {WebGLShader[]|string[]} shaders The shaders to attach, or element ids for their source, or strings that contain their source
 * @param {module:twgl.ProgramOptions|string[]|module:twgl.ErrorCallback} [opt_attribs] Options for the program or an array of attribs names or an error callback. Locations will be assigned by index if not passed in
 * @param {number[]} [opt_locations|module:twgl.ErrorCallback] The locations for the. A parallel array to opt_attribs letting you assign locations or an error callback.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {WebGLProgram?} the created program or null if error of a callback was provided.
 * @memberOf module:twgl/programs
 */
function createProgram(
    gl, shaders, opt_attribs, opt_locations, opt_errorCallback) {
  // This code is really convoluted, because it may or may not be async
  // Maybe it would be better to have a separate function
  const progOptions = getProgramOptions(opt_attribs, opt_locations, opt_errorCallback);
  const realShaders = [];
  const newShaders = [];
  for (let ndx = 0; ndx < shaders.length; ++ndx) {
    let shader = shaders[ndx];
    if (typeof (shader) === 'string') {
      const elem = getElementById(shader);
      const src = elem ? elem.text : shader;
      let type = gl[defaultShaderType[ndx]];
      if (elem && elem.type) {
        type = getShaderTypeFromScriptType(gl, elem.type) || type;
      }
      shader = loadShader(gl, src, type, progOptions);
      newShaders.push(shader);
    }
    if (isShader(gl, shader)) {
      realShaders.push(shader);
    }
  }

  if (realShaders.length !== shaders.length) {
    deleteShaders(gl, newShaders);
    return reportError(progOptions, "not enough shaders for program");
  }

  const program = gl.createProgram();
  realShaders.forEach(function(shader) {
    gl.attachShader(program, shader);
  });
  if (progOptions.attribLocations) {
    Object.keys(progOptions.attribLocations).forEach(function(attrib) {
      gl.bindAttribLocation(program, progOptions.attribLocations[attrib], attrib);
    });
  }
  let varyings = progOptions.transformFeedbackVaryings;
  if (varyings) {
    if (varyings.attribs) {
      varyings = varyings.attribs;
    }
    if (!Array.isArray(varyings)) {
      varyings = Object.keys(varyings);
    }
    gl.transformFeedbackVaryings(program, varyings, progOptions.transformFeedbackMode || SEPARATE_ATTRIBS);
  }

  gl.linkProgram(program);
  if (progOptions.callback) {
    checkForProgramLinkCompletionAsync(gl, program, progOptions);
    return null;
  } else {
    if (!checkProgramStatus(gl, program, progOptions.errorCallback)) {
      gl.deleteProgram(program);
      deleteShaders(gl, newShaders);
      return null;
    }
    return program;
  }
}

/**
 * Same as createProgram but returns a promise
 *
 * NOTE: There are 4 signatures for this function
 *
 *     twgl.createProgramAsync(gl, [vs, fs], options);
 *     twgl.createProgramAsync(gl, [vs, fs], opt_errFunc);
 *     twgl.createProgramAsync(gl, [vs, fs], opt_attribs, opt_errFunc);
 *     twgl.createProgramAsync(gl, [vs, fs], opt_attribs, opt_locations, opt_errFunc);
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {WebGLShader[]|string[]} shaders The shaders to attach, or element ids for their source, or strings that contain their source
 * @param {module:twgl.ProgramOptions|string[]|module:twgl.ErrorCallback} [opt_attribs] Options for the program or an array of attribs names or an error callback. Locations will be assigned by index if not passed in
 * @param {number[]} [opt_locations|module:twgl.ErrorCallback] The locations for the. A parallel array to opt_attribs letting you assign locations or an error callback.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {Promise<WebGLProgram>} The created program
 * @memberOf module:twgl/programs
 */
function createProgramAsync(gl, shaders, ...args) {
  return new Promise((resolve, reject) => {
    const programOptions = getProgramOptions(...args);
    programOptions.callback = (err, program) => {
      if (err) {
        reject(err);
      } else {
        resolve(program);
      }
    };
    createProgram(gl, shaders, programOptions);
  });
}

/**
 * Same as createProgramInfo but returns a promise
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext
 *        to use.
 * @param {string[]} shaderSources Array of sources for the
 *        shaders or ids. The first is assumed to be the vertex shader,
 *        the second the fragment shader.
 * @param {module:twgl.ProgramOptions|string[]|module:twgl.ErrorCallback} [opt_attribs] Options for the program or an array of attribs names or an error callback. Locations will be assigned by index if not passed in
 * @param {number[]} [opt_locations|module:twgl.ErrorCallback] The locations for the. A parallel array to opt_attribs letting you assign locations or an error callback.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {Promise<module:twgl.ProgramInfo>} The created ProgramInfo
 * @memberOf module:twgl/programs
 */
function createProgramInfoAsync(gl, shaders, ...args) {
  return new Promise((resolve, reject) => {
    const programOptions = getProgramOptions(...args);
    programOptions.callback = (err, programInfo) => {
      if (err) {
        reject(err);
      } else {
        resolve(programInfo);
      }
    };
    createProgramInfo(gl, shaders, programOptions);
  });
}


/**
 * Asynchronously wait for program to link.
 * Note: if 'KHR_parallel_shader_compile' extension does not
 * exist then compilation will not be truly async.
 * @param {WebGLRenderingContext} gl The context
 * @param {WebGLProgram} program The program
 * @param {module:twgl.ProgramOptions} progOptions Options for the program or an array of attribs names or an error callback. Locations will be assigned by index if not passed in
 * @private
 */
async function checkForProgramLinkCompletionAsync(gl, program, progOptions) {
  const ext = gl.getExtension('KHR_parallel_shader_compile');
  const checkFn = ext
      ? (gl, program) => gl.getProgramParameter(program, ext.COMPLETION_STATUS_KHR)
      : () => true;

  let waitTime = 0;
  do {
    await wait(waitTime);  // must wait at least once
    waitTime = 1000 / 60;
  } while (!checkFn(gl, program));

  const success = checkProgramStatus(gl, program, progOptions.errorCallback);
  const err = success ? undefined : progOptions.errors.join('\n');
  if (!success) {
    const errFn = progOptions.errorCallback || error$1;
    errFn(err);
    gl.deleteProgram(program);
    // TODO: delete shaders, but only shaders that were created newly for this
    // program
    program = null;
  }
  progOptions.callback(err, program);
}

/**
 * Check a program's link status
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {WebGLProgram} program Program to check
 * @param {ErrorCallback} [errFn] func for errors
 * @return {bool} true if program is ok
 * @private
 */
function checkProgramStatus(gl, program, errFn) {
  errFn = errFn || error$1;
  // Check the link status
  const linked = gl.getProgramParameter(program, LINK_STATUS);
  if (!linked) {
    // something went wrong with the link
    const lastError = gl.getProgramInfoLog(program);
    errFn(`Error in program linking: ${lastError}`);
  }
  return linked;
}

/**
 * Loads a shader from a script tag.
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {string} scriptId The id of the script tag.
 * @param {number} [opt_shaderType] The type of shader. If not passed in it will
 *     be derived from the type of the script tag.
 * @param {module:twgl.ProgramOptions} [progOptions] callback for errors.
 * @return {WebGLShader?} The created shader or null if error.
 * @private
 */
function createShaderFromScript(
    gl, scriptId, opt_shaderType, progOptions) {
  let shaderSource = "";
  const shaderScript = getElementById(scriptId);
  if (!shaderScript) {
    return reportError(progOptions, `unknown script element: ${scriptId}`);
  }
  shaderSource = shaderScript.text;

  const shaderType = opt_shaderType || getShaderTypeFromScriptType(gl, shaderScript.type);
  if (!shaderType) {
    return reportError(progOptions, 'unknown shader type');
  }

  return loadShader(gl, shaderSource, shaderType, progOptions);
}

/**
 * Creates a program from 2 script tags.
 *
 * NOTE: There are 4 signatures for this function
 *
 *     twgl.createProgramFromScripts(gl, [vs, fs], opt_options);
 *     twgl.createProgramFromScripts(gl, [vs, fs], opt_errFunc);
 *     twgl.createProgramFromScripts(gl, [vs, fs], opt_attribs, opt_errFunc);
 *     twgl.createProgramFromScripts(gl, [vs, fs], opt_attribs, opt_locations, opt_errFunc);
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext
 *        to use.
 * @param {string[]} shaderScriptIds Array of ids of the script
 *        tags for the shaders. The first is assumed to be the
 *        vertex shader, the second the fragment shader.
 * @param {module:twgl.ProgramOptions|string[]|module:twgl.ErrorCallback} [opt_attribs] Options for the program or an array of attribs names or an error callback. Locations will be assigned by index if not passed in
 * @param {number[]} [opt_locations|module:twgl.ErrorCallback] The locations for the. A parallel array to opt_attribs letting you assign locations or an error callback.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {WebGLProgram?} the created program or null if error or a callback was provided.
 * @memberOf module:twgl/programs
 */
function createProgramFromScripts(
    gl, shaderScriptIds, opt_attribs, opt_locations, opt_errorCallback) {
  const progOptions = getProgramOptions(opt_attribs, opt_locations, opt_errorCallback);
  const shaders = [];
  for (let ii = 0; ii < shaderScriptIds.length; ++ii) {
    const shader = createShaderFromScript(
        gl, shaderScriptIds[ii], gl[defaultShaderType[ii]], progOptions);
    if (!shader) {
      return null;
    }
    shaders.push(shader);
  }
  return createProgram(gl, shaders, progOptions);
}

/**
 * Creates a program from 2 sources.
 *
 * NOTE: There are 4 signatures for this function
 *
 *     twgl.createProgramFromSource(gl, [vs, fs], opt_options);
 *     twgl.createProgramFromSource(gl, [vs, fs], opt_errFunc);
 *     twgl.createProgramFromSource(gl, [vs, fs], opt_attribs, opt_errFunc);
 *     twgl.createProgramFromSource(gl, [vs, fs], opt_attribs, opt_locations, opt_errFunc);
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext
 *        to use.
 * @param {string[]} shaderSources Array of sources for the
 *        shaders. The first is assumed to be the vertex shader,
 *        the second the fragment shader.
 * @param {module:twgl.ProgramOptions|string[]|module:twgl.ErrorCallback} [opt_attribs] Options for the program or an array of attribs names or an error callback. Locations will be assigned by index if not passed in
 * @param {number[]} [opt_locations|module:twgl.ErrorCallback] The locations for the. A parallel array to opt_attribs letting you assign locations or an error callback.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {WebGLProgram?} the created program or null if error or a callback was provided.
 * @memberOf module:twgl/programs
 */
function createProgramFromSources(
    gl, shaderSources, opt_attribs, opt_locations, opt_errorCallback) {
  const progOptions = getProgramOptions(opt_attribs, opt_locations, opt_errorCallback);
  const shaders = [];
  for (let ii = 0; ii < shaderSources.length; ++ii) {
    const shader = loadShader(gl, shaderSources[ii], gl[defaultShaderType[ii]], progOptions);
    if (!progOptions.callback && !shader) {
      return null;
    }
    shaders.push(shader);
  }
  return createProgram(gl, shaders, progOptions);
}

/**
 * Returns true if attribute/uniform is a reserved/built in
 *
 * It makes no sense to me why GL returns these because it's
 * illegal to call `gl.getUniformLocation` and `gl.getAttribLocation`
 * with names that start with `gl_` (and `webgl_` in WebGL)
 *
 * I can only assume they are there because they might count
 * when computing the number of uniforms/attributes used when you want to
 * know if you are near the limit. That doesn't really make sense
 * to me but the fact that these get returned are in the spec.
 *
 * @param {WebGLActiveInfo} info As returned from `gl.getActiveUniform` or
 *    `gl.getActiveAttrib`.
 * @return {bool} true if it's reserved
 * @private
 */
function isBuiltIn(info) {
  const name = info.name;
  return name.startsWith("gl_") || name.startsWith("webgl_");
}

const tokenRE = /(\.|\[|]|\w+)/g;
const isDigit = s => s >= '0' && s <= '9';
function addSetterToUniformTree(fullPath, setter, node, uniformSetters) {
  const tokens = fullPath.split(tokenRE).filter(s => s !== '');
  let tokenNdx = 0;
  let path = '';

  for (;;) {
    const token = tokens[tokenNdx++];  // has to be name or number
    path += token;
    const isArrayIndex = isDigit(token[0]);
    const accessor = isArrayIndex
        ? parseInt(token)
        : token;
    if (isArrayIndex) {
      path += tokens[tokenNdx++];  // skip ']'
    }
    const isLastToken = tokenNdx === tokens.length;
    if (isLastToken) {
      node[accessor] = setter;
      break;
    } else {
      const token = tokens[tokenNdx++];  // has to be . or [
      const isArray = token === '[';
      const child = node[accessor] || (isArray ? [] : {});
      node[accessor] = child;
      node = child;
      uniformSetters[path] = uniformSetters[path] || function(node) {
        return function(value) {
          setUniformTree(node, value);
        };
      }(child);
      path += token;
    }
  }
}

/**
 * Creates setter functions for all uniforms of a shader
 * program.
 *
 * @see {@link module:twgl.setUniforms}
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {WebGLProgram} program the program to create setters for.
 * @returns {Object.<string, function>} an object with a setter by name for each uniform
 * @memberOf module:twgl/programs
 */
function createUniformSetters(gl, program) {
  let textureUnit = 0;

  /**
   * Creates a setter for a uniform of the given program with it's
   * location embedded in the setter.
   * @param {WebGLProgram} program
   * @param {WebGLUniformInfo} uniformInfo
   * @returns {function} the created setter.
   */
  function createUniformSetter(program, uniformInfo, location) {
    const isArray = uniformInfo.name.endsWith("[0]");
    const type = uniformInfo.type;
    const typeInfo = typeMap[type];
    if (!typeInfo) {
      throw new Error(`unknown type: 0x${type.toString(16)}`); // we should never get here.
    }
    let setter;
    if (typeInfo.bindPoint) {
      // it's a sampler
      const unit = textureUnit;
      textureUnit += uniformInfo.size;
      if (isArray) {
        setter = typeInfo.arraySetter(gl, type, unit, location, uniformInfo.size);
      } else {
        setter = typeInfo.setter(gl, type, unit, location, uniformInfo.size);
      }
    } else {
      if (typeInfo.arraySetter && isArray) {
        setter = typeInfo.arraySetter(gl, location);
      } else {
        setter = typeInfo.setter(gl, location);
      }
    }
    setter.location = location;
    return setter;
  }

  const uniformSetters = {};
  const uniformTree = {};
  const numUniforms = gl.getProgramParameter(program, ACTIVE_UNIFORMS);

  for (let ii = 0; ii < numUniforms; ++ii) {
    const uniformInfo = gl.getActiveUniform(program, ii);
    if (isBuiltIn(uniformInfo)) {
      continue;
    }
    let name = uniformInfo.name;
    // remove the array suffix.
    if (name.endsWith("[0]")) {
      name = name.substr(0, name.length - 3);
    }
    const location = gl.getUniformLocation(program, uniformInfo.name);
    // the uniform will have no location if it's in a uniform block
    if (location) {
      const setter = createUniformSetter(program, uniformInfo, location);
      uniformSetters[name] = setter;
      addSetterToUniformTree(name, setter, uniformTree, uniformSetters);
    }
  }

  return uniformSetters;
}

/**
 * @typedef {Object} TransformFeedbackInfo
 * @property {number} index index of transform feedback
 * @property {number} type GL type
 * @property {number} size 1 - 4
 * @memberOf module:twgl
 */

/**
 * Create TransformFeedbackInfo for passing to bindTransformFeedbackInfo.
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {WebGLProgram} program an existing WebGLProgram.
 * @return {Object<string, module:twgl.TransformFeedbackInfo>}
 * @memberOf module:twgl
 */
function createTransformFeedbackInfo(gl, program) {
  const info = {};
  const numVaryings = gl.getProgramParameter(program, TRANSFORM_FEEDBACK_VARYINGS);
  for (let ii = 0; ii < numVaryings; ++ii) {
    const varying = gl.getTransformFeedbackVarying(program, ii);
    info[varying.name] = {
      index: ii,
      type: varying.type,
      size: varying.size,
    };
  }
  return info;
}

/**
 * Binds buffers for transform feedback.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {(module:twgl.ProgramInfo|Object<string, module:twgl.TransformFeedbackInfo>)} transformFeedbackInfo A ProgramInfo or TransformFeedbackInfo.
 * @param {(module:twgl.BufferInfo|Object<string, module:twgl.AttribInfo>)} [bufferInfo] A BufferInfo or set of AttribInfos.
 * @memberOf module:twgl
 */
function bindTransformFeedbackInfo(gl, transformFeedbackInfo, bufferInfo) {
  if (transformFeedbackInfo.transformFeedbackInfo) {
    transformFeedbackInfo = transformFeedbackInfo.transformFeedbackInfo;
  }
  if (bufferInfo.attribs) {
    bufferInfo = bufferInfo.attribs;
  }
  for (const name in bufferInfo) {
    const varying = transformFeedbackInfo[name];
    if (varying) {
      const buf = bufferInfo[name];
      if (buf.offset) {
        gl.bindBufferRange(TRANSFORM_FEEDBACK_BUFFER, varying.index, buf.buffer, buf.offset, buf.size);
      } else {
        gl.bindBufferBase(TRANSFORM_FEEDBACK_BUFFER, varying.index, buf.buffer);
      }
    }
  }
}

/**
 * Creates a transform feedback and sets the buffers
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {module:twgl.ProgramInfo} programInfo A ProgramInfo as returned from {@link module:twgl.createProgramInfo}
 * @param {(module:twgl.BufferInfo|Object<string, module:twgl.AttribInfo>)} [bufferInfo] A BufferInfo or set of AttribInfos.
 * @return {WebGLTransformFeedback} the created transform feedback
 * @memberOf module:twgl
 */
function createTransformFeedback(gl, programInfo, bufferInfo) {
  const tf = gl.createTransformFeedback();
  gl.bindTransformFeedback(TRANSFORM_FEEDBACK, tf);
  gl.useProgram(programInfo.program);
  bindTransformFeedbackInfo(gl, programInfo, bufferInfo);
  gl.bindTransformFeedback(TRANSFORM_FEEDBACK, null);
  return tf;
}

/**
 * @typedef {Object} UniformData
 * @property {string} name The name of the uniform
 * @property {number} type The WebGL type enum for this uniform
 * @property {number} size The number of elements for this uniform
 * @property {number} blockNdx The block index this uniform appears in
 * @property {number} offset The byte offset in the block for this uniform's value
 * @memberOf module:twgl
 */

/**
 * The specification for one UniformBlockObject
 *
 * @typedef {Object} BlockSpec
 * @property {number} index The index of the block.
 * @property {number} size The size in bytes needed for the block
 * @property {number[]} uniformIndices The indices of the uniforms used by the block. These indices
 *    correspond to entries in a UniformData array in the {@link module:twgl.UniformBlockSpec}.
 * @property {bool} usedByVertexShader Self explanatory
 * @property {bool} usedByFragmentShader Self explanatory
 * @property {bool} used Self explanatory
 * @memberOf module:twgl
 */

/**
 * A `UniformBlockSpec` represents the data needed to create and bind
 * UniformBlockObjects for a given program
 *
 * @typedef {Object} UniformBlockSpec
 * @property {Object.<string, module:twgl.BlockSpec>} blockSpecs The BlockSpec for each block by block name
 * @property {UniformData[]} uniformData An array of data for each uniform by uniform index.
 * @memberOf module:twgl
 */

/**
 * Creates a UniformBlockSpec for the given program.
 *
 * A UniformBlockSpec represents the data needed to create and bind
 * UniformBlockObjects
 *
 * @param {WebGL2RenderingContext} gl A WebGL2 Rendering Context
 * @param {WebGLProgram} program A WebGLProgram for a successfully linked program
 * @return {module:twgl.UniformBlockSpec} The created UniformBlockSpec
 * @memberOf module:twgl/programs
 */
function createUniformBlockSpecFromProgram(gl, program) {
  const numUniforms = gl.getProgramParameter(program, ACTIVE_UNIFORMS);
  const uniformData = [];
  const uniformIndices = [];

  for (let ii = 0; ii < numUniforms; ++ii) {
    uniformIndices.push(ii);
    uniformData.push({});
    const uniformInfo = gl.getActiveUniform(program, ii);
    uniformData[ii].name = uniformInfo.name;
  }

  [
    [ "UNIFORM_TYPE", "type" ],
    [ "UNIFORM_SIZE", "size" ],  // num elements
    [ "UNIFORM_BLOCK_INDEX", "blockNdx" ],
    [ "UNIFORM_OFFSET", "offset", ],
  ].forEach(function(pair) {
    const pname = pair[0];
    const key = pair[1];
    gl.getActiveUniforms(program, uniformIndices, gl[pname]).forEach(function(value, ndx) {
      uniformData[ndx][key] = value;
    });
  });

  const blockSpecs = {};

  const numUniformBlocks = gl.getProgramParameter(program, ACTIVE_UNIFORM_BLOCKS);
  for (let ii = 0; ii < numUniformBlocks; ++ii) {
    const name = gl.getActiveUniformBlockName(program, ii);
    const blockSpec = {
      index: gl.getUniformBlockIndex(program, name),
      usedByVertexShader: gl.getActiveUniformBlockParameter(program, ii, UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER),
      usedByFragmentShader: gl.getActiveUniformBlockParameter(program, ii, UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER),
      size: gl.getActiveUniformBlockParameter(program, ii, UNIFORM_BLOCK_DATA_SIZE),
      uniformIndices: gl.getActiveUniformBlockParameter(program, ii, UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES),
    };
    blockSpec.used = blockSpec.usedByVertexShader || blockSpec.usedByFragmentShader;
    blockSpecs[name] = blockSpec;
  }

  return {
    blockSpecs: blockSpecs,
    uniformData: uniformData,
  };
}

const arraySuffixRE = /\[\d+\]\.$/;  // better way to check?

const pad = (v, padding) => ((v + (padding - 1)) / padding | 0) * padding;

function createUniformBlockUniformSetter(view, isArray, rows, cols) {
  if (isArray || rows) {
    cols = cols || 1;
    const numElements = view.length;
    const totalRows = numElements / 4;
    return function(value) {
      let dst = 0;
      let src = 0;
      for (let row = 0; row < totalRows; ++row) {
        for (let col = 0; col < cols; ++col) {
          view[dst++] = value[src++];
        }
        dst += 4 - cols;
      }
    };
  } else {
    return function(value) {
      if (value.length) {
        view.set(value);
      } else {
        view[0] = value;
      }
    };
  }
}

/**
 * Represents a UniformBlockObject including an ArrayBuffer with all the uniform values
 * and a corresponding WebGLBuffer to hold those values on the GPU
 *
 * @typedef {Object} UniformBlockInfo
 * @property {string} name The name of the block
 * @property {ArrayBuffer} array The array buffer that contains the uniform values
 * @property {Float32Array} asFloat A float view on the array buffer. This is useful
 *    inspecting the contents of the buffer in the debugger.
 * @property {WebGLBuffer} buffer A WebGL buffer that will hold a copy of the uniform values for rendering.
 * @property {number} [offset] offset into buffer
 * @property {Object<string, ArrayBufferView>} uniforms A uniform name to ArrayBufferView map.
 *   each Uniform has a correctly typed `ArrayBufferView` into array at the correct offset
 *   and length of that uniform. So for example a float uniform would have a 1 float `Float32Array`
 *   view. A single mat4 would have a 16 element `Float32Array` view. An ivec2 would have an
 *   `Int32Array` view, etc.
 * @property {Object<string, function>} setters A setter for this uniform.
 *   The reason to use setters is elements of arrays are padded to vec4 sizes which
 *   means if you want to set an array of 4 floats you'd need to set 16 values
 *   (or set elements 0, 4, 8, 12). In other words
 *   `someBlockInfo.uniforms.some4FloatArrayUniform.set([0, , , , 1, , , , 2, , , , 3])`
 *   where as the setter handles just passing in [0, 1, 2, 3] either directly as in
 *   `someBlockInfo.setter.some4FloatArrayUniform.set([0, 1, 2, 3])` (not recommended)
 *   or via {@link module:twgl.setBlockUniforms}
 * @memberOf module:twgl
 */

/**
 * Creates a `UniformBlockInfo` for the specified block
 *
 * Note: **If the blockName matches no existing blocks a warning is printed to the console and a dummy
 * `UniformBlockInfo` is returned**. This is because when debugging GLSL
 * it is common to comment out large portions of a shader or for example set
 * the final output to a constant. When that happens blocks get optimized out.
 * If this function did not create dummy blocks your code would crash when debugging.
 *
 * @param {WebGL2RenderingContext} gl A WebGL2RenderingContext
 * @param {WebGLProgram} program A WebGLProgram
 * @param {module:twgl.UniformBlockSpec} uniformBlockSpec. A UniformBlockSpec as returned
 *     from {@link module:twgl.createUniformBlockSpecFromProgram}.
 * @param {string} blockName The name of the block.
 * @return {module:twgl.UniformBlockInfo} The created UniformBlockInfo
 * @memberOf module:twgl/programs
 */
function createUniformBlockInfoFromProgram(gl, program, uniformBlockSpec, blockName) {
  const blockSpecs = uniformBlockSpec.blockSpecs;
  const uniformData = uniformBlockSpec.uniformData;
  const blockSpec = blockSpecs[blockName];
  if (!blockSpec) {
    warn$1("no uniform block object named:", blockName);
    return {
      name: blockName,
      uniforms: {},
    };
  }
  const array = new ArrayBuffer(blockSpec.size);
  const buffer = gl.createBuffer();
  const uniformBufferIndex = blockSpec.index;
  gl.bindBuffer(UNIFORM_BUFFER, buffer);
  gl.uniformBlockBinding(program, blockSpec.index, uniformBufferIndex);

  let prefix = blockName + ".";
  if (arraySuffixRE.test(prefix)) {
    prefix = prefix.replace(arraySuffixRE, ".");
  }
  const uniforms = {};
  const setters = {};
  const setterTree = {};
  blockSpec.uniformIndices.forEach(function(uniformNdx) {
    const data = uniformData[uniformNdx];
    let name = data.name;
    if (name.startsWith(prefix)) {
      name = name.substr(prefix.length);
    }
    const isArray = name.endsWith('[0]');
    if (isArray) {
      name = name.substr(0, name.length - 3);
    }
    const typeInfo = typeMap[data.type];
    const Type = typeInfo.Type;
    const byteLength = isArray
        ? pad(typeInfo.size, 16) * data.size
        : typeInfo.size * data.size;
    const uniformView = new Type(array, data.offset, byteLength / Type.BYTES_PER_ELEMENT);
    uniforms[name] = uniformView;
    // Note: I'm not sure what to do here. The original
    // idea was to create TypedArray views into each part
    // of the block. This is useful, for example if you have
    // a block with { mat4: model; mat4 view; mat4 projection; }
    // you'll get a Float32Array for each one suitable for
    // passing to most JS math libraries including twgl's and glMatrix.js.
    //
    // But, if you have a an array of structures, especially if that
    // array is large, you get a whole bunch of TypedArray views.
    // Every one of them has overhead and switching between them all
    // is probably a cache miss. In that case it would really be better
    // to just have one view (asFloat) and have all the setters
    // just reference the correct portion. But, then you can't easily
    // treat a matrix, or a vec4, as a standalone thing like you can
    // with all the views.
    //
    // Another problem with the views is they are not shared. With
    // uniforms you have one set of setters. With UniformBlockInfo
    // you have a set of setters *pre block instance*. That's because
    // TypedArray views can't be mapped to different buffers.
    //
    // My gut right now is if you really want the speed and compactness
    // then you should probably roll your own solution. TWGL's goal
    // here is ease of use as AFAICT there is no simple generic efficient
    // solution.
    const setter = createUniformBlockUniformSetter(uniformView, isArray, typeInfo.rows, typeInfo.cols);
    setters[name] = setter;
    addSetterToUniformTree(name, setter, setterTree, setters);
  });
  return {
    name: blockName,
    array,
    asFloat: new Float32Array(array),  // for debugging
    buffer,
    uniforms,
    setters,
  };
}

/**
 * Creates a `UniformBlockInfo` for the specified block
 *
 * Note: **If the blockName matches no existing blocks a warning is printed to the console and a dummy
 * `UniformBlockInfo` is returned**. This is because when debugging GLSL
 * it is common to comment out large portions of a shader or for example set
 * the final output to a constant. When that happens blocks get optimized out.
 * If this function did not create dummy blocks your code would crash when debugging.
 *
 * @param {WebGL2RenderingContext} gl A WebGL2RenderingContext
 * @param {module:twgl.ProgramInfo} programInfo a `ProgramInfo`
 *     as returned from {@link module:twgl.createProgramInfo}
 * @param {string} blockName The name of the block.
 * @return {module:twgl.UniformBlockInfo} The created UniformBlockInfo
 * @memberOf module:twgl/programs
 */
function createUniformBlockInfo(gl, programInfo, blockName) {
  return createUniformBlockInfoFromProgram(gl, programInfo.program, programInfo.uniformBlockSpec, blockName);
}

/**
 * Binds a uniform block to the matching uniform block point.
 * Matches by blocks by name so blocks must have the same name not just the same
 * structure.
 *
 * If you have changed any values and you upload the values into the corresponding WebGLBuffer
 * call {@link module:twgl.setUniformBlock} instead.
 *
 * @param {WebGL2RenderingContext} gl A WebGL 2 rendering context.
 * @param {(module:twgl.ProgramInfo|module:twgl.UniformBlockSpec)} programInfo a `ProgramInfo`
 *     as returned from {@link module:twgl.createProgramInfo} or or `UniformBlockSpec` as
 *     returned from {@link module:twgl.createUniformBlockSpecFromProgram}.
 * @param {module:twgl.UniformBlockInfo} uniformBlockInfo a `UniformBlockInfo` as returned from
 *     {@link module:twgl.createUniformBlockInfo}.
 * @return {bool} true if buffer was bound. If the programInfo has no block with the same block name
 *     no buffer is bound.
 * @memberOf module:twgl/programs
 */
function bindUniformBlock(gl, programInfo, uniformBlockInfo) {
  const uniformBlockSpec = programInfo.uniformBlockSpec || programInfo;
  const blockSpec = uniformBlockSpec.blockSpecs[uniformBlockInfo.name];
  if (blockSpec) {
    const bufferBindIndex = blockSpec.index;
    gl.bindBufferRange(UNIFORM_BUFFER, bufferBindIndex, uniformBlockInfo.buffer, uniformBlockInfo.offset || 0, uniformBlockInfo.array.byteLength);
    return true;
  }
  return false;
}

/**
 * Uploads the current uniform values to the corresponding WebGLBuffer
 * and binds that buffer to the program's corresponding bind point for the uniform block object.
 *
 * If you haven't changed any values and you only need to bind the uniform block object
 * call {@link module:twgl.bindUniformBlock} instead.
 *
 * @param {WebGL2RenderingContext} gl A WebGL 2 rendering context.
 * @param {(module:twgl.ProgramInfo|module:twgl.UniformBlockSpec)} programInfo a `ProgramInfo`
 *     as returned from {@link module:twgl.createProgramInfo} or or `UniformBlockSpec` as
 *     returned from {@link module:twgl.createUniformBlockSpecFromProgram}.
 * @param {module:twgl.UniformBlockInfo} uniformBlockInfo a `UniformBlockInfo` as returned from
 *     {@link module:twgl.createUniformBlockInfo}.
 * @memberOf module:twgl/programs
 */
function setUniformBlock(gl, programInfo, uniformBlockInfo) {
  if (bindUniformBlock(gl, programInfo, uniformBlockInfo)) {
    gl.bufferData(UNIFORM_BUFFER, uniformBlockInfo.array, DYNAMIC_DRAW);
  }
}

/**
 * Sets values of a uniform block object
 *
 * @param {module:twgl.UniformBlockInfo} uniformBlockInfo A UniformBlockInfo as returned by {@link module:twgl.createUniformBlockInfo}.
 * @param {Object.<string, ?>} values A uniform name to value map where the value is correct for the given
 *    type of uniform. So for example given a block like
 *
 *       uniform SomeBlock {
 *         float someFloat;
 *         vec2 someVec2;
 *         vec3 someVec3Array[2];
 *         int someInt;
 *       }
 *
 *  You can set the values of the uniform block with
 *
 *       twgl.setBlockUniforms(someBlockInfo, {
 *          someFloat: 12.3,
 *          someVec2: [1, 2],
 *          someVec3Array: [1, 2, 3, 4, 5, 6],
 *          someInt: 5,
 *       }
 *
 *  Arrays can be JavaScript arrays or typed arrays
 *
 *  You can also fill out structure and array values either via
 *  shortcut. Example
 *
 *     // -- in shader --
 *     struct Light {
 *       float intensity;
 *       vec4 color;
 *       float nearFar[2];
 *     };
 *     uniform Lights {
 *       Light lights[2];
 *     };
 *
 *     // in JavaScript
 *
 *     twgl.setBlockUniforms(someBlockInfo, {
 *       lights: [
 *         { intensity: 5.0, color: [1, 0, 0, 1], nearFar[0.1, 10] },
 *         { intensity: 2.0, color: [0, 0, 1, 1], nearFar[0.2, 15] },
 *       ],
 *     });
 *
 *   or the more traditional way
 *
 *     twgl.setBlockUniforms(someBlockInfo, {
 *       "lights[0].intensity": 5.0,
 *       "lights[0].color": [1, 0, 0, 1],
 *       "lights[0].nearFar": [0.1, 10],
 *       "lights[1].intensity": 2.0,
 *       "lights[1].color": [0, 0, 1, 1],
 *       "lights[1].nearFar": [0.2, 15],
 *     });
 *
 *   You can also specify partial paths
 *
 *     twgl.setBlockUniforms(someBlockInfo, {
 *       'lights[1]': { intensity: 5.0, color: [1, 0, 0, 1], nearFar[0.2, 15] },
 *     });
 *
 *   But you can not specify leaf array indices.
 *
 *     twgl.setBlockUniforms(someBlockInfo, {
 *       'lights[1].nearFar[1]': 15,     // BAD! nearFar is a leaf
 *       'lights[1].nearFar': [0.2, 15], // GOOD
 *     });
 *
 *  **IMPORTANT!**, packing in a UniformBlock is unintuitive.
 *  For example the actual layout of `someVec3Array` above in memory
 *  is `1, 2, 3, unused, 4, 5, 6, unused`. twgl takes in 6 values
 *  as shown about and copies them, skipping the padding. This might
 *  be confusing if you're already familiar with Uniform blocks.
 *
 *  If you want to deal with the padding yourself you can access the array
 *  buffer views directly. eg:
 *
 *      someBlockInfo.someVec3Array.set([1, 2, 3, 0, 4, 5, 6, 0]);
 *
 *  Any name that doesn't match will be ignored
 * @memberOf module:twgl/programs
 */
function setBlockUniforms(uniformBlockInfo, values) {
  const setters = uniformBlockInfo.setters;
  for (const name in values) {
    const setter = setters[name];
    if (setter) {
      const value = values[name];
      setter(value);
    }
  }
}

function setUniformTree(tree, values) {
  for (const name in values) {
    const prop = tree[name];
    if (typeof prop === 'function') {
      prop(values[name]);
    } else {
      setUniformTree(tree[name], values[name]);
    }
  }
}

/**
 * Set uniforms and binds related textures.
 *
 * example:
 *
 *     const programInfo = createProgramInfo(
 *         gl, ["some-vs", "some-fs"]);
 *
 *     const tex1 = gl.createTexture();
 *     const tex2 = gl.createTexture();
 *
 *     ... assume we setup the textures with data ...
 *
 *     const uniforms = {
 *       u_someSampler: tex1,
 *       u_someOtherSampler: tex2,
 *       u_someColor: [1,0,0,1],
 *       u_somePosition: [0,1,1],
 *       u_someMatrix: [
 *         1,0,0,0,
 *         0,1,0,0,
 *         0,0,1,0,
 *         0,0,0,0,
 *       ],
 *     };
 *
 *     gl.useProgram(program);
 *
 * This will automatically bind the textures AND set the
 * uniforms.
 *
 *     twgl.setUniforms(programInfo, uniforms);
 *
 * For the example above it is equivalent to
 *
 *     var texUnit = 0;
 *     gl.activeTexture(gl.TEXTURE0 + texUnit);
 *     gl.bindTexture(gl.TEXTURE_2D, tex1);
 *     gl.uniform1i(u_someSamplerLocation, texUnit++);
 *     gl.activeTexture(gl.TEXTURE0 + texUnit);
 *     gl.bindTexture(gl.TEXTURE_2D, tex2);
 *     gl.uniform1i(u_someSamplerLocation, texUnit++);
 *     gl.uniform4fv(u_someColorLocation, [1, 0, 0, 1]);
 *     gl.uniform3fv(u_somePositionLocation, [0, 1, 1]);
 *     gl.uniformMatrix4fv(u_someMatrix, false, [
 *         1,0,0,0,
 *         0,1,0,0,
 *         0,0,1,0,
 *         0,0,0,0,
 *       ]);
 *
 * Note it is perfectly reasonable to call `setUniforms` multiple times. For example
 *
 *     const uniforms = {
 *       u_someSampler: tex1,
 *       u_someOtherSampler: tex2,
 *     };
 *
 *     const moreUniforms {
 *       u_someColor: [1,0,0,1],
 *       u_somePosition: [0,1,1],
 *       u_someMatrix: [
 *         1,0,0,0,
 *         0,1,0,0,
 *         0,0,1,0,
 *         0,0,0,0,
 *       ],
 *     };
 *
 *     twgl.setUniforms(programInfo, uniforms);
 *     twgl.setUniforms(programInfo, moreUniforms);
 *
 * You can also add WebGLSamplers to uniform samplers as in
 *
 *     const uniforms = {
 *       u_someSampler: {
 *         texture: someWebGLTexture,
 *         sampler: someWebGLSampler,
 *       },
 *     };
 *
 * In which case both the sampler and texture will be bound to the
 * same unit.
 *
 * @param {(module:twgl.ProgramInfo|Object.<string, function>)} setters a `ProgramInfo` as returned from `createProgramInfo` or the setters returned from
 *        `createUniformSetters`.
 * @param {Object.<string, ?>} values an object with values for the
 *        uniforms.
 *   You can pass multiple objects by putting them in an array or by calling with more arguments.For example
 *
 *     const sharedUniforms = {
 *       u_fogNear: 10,
 *       u_projection: ...
 *       ...
 *     };
 *
 *     const localUniforms = {
 *       u_world: ...
 *       u_diffuseColor: ...
 *     };
 *
 *     twgl.setUniforms(programInfo, sharedUniforms, localUniforms);
 *
 *     // is the same as
 *
 *     twgl.setUniforms(programInfo, [sharedUniforms, localUniforms]);
 *
 *     // is the same as
 *
 *     twgl.setUniforms(programInfo, sharedUniforms);
 *     twgl.setUniforms(programInfo, localUniforms};
 *
 *   You can also fill out structure and array values either via
 *   shortcut. Example
 *
 *     // -- in shader --
 *     struct Light {
 *       float intensity;
 *       vec4 color;
 *       float nearFar[2];
 *     };
 *     uniform Light lights[2];
 *
 *     // in JavaScript
 *
 *     twgl.setUniforms(programInfo, {
 *       lights: [
 *         { intensity: 5.0, color: [1, 0, 0, 1], nearFar[0.1, 10] },
 *         { intensity: 2.0, color: [0, 0, 1, 1], nearFar[0.2, 15] },
 *       ],
 *     });
 *
 *   or the more traditional way
 *
 *     twgl.setUniforms(programInfo, {
 *       "lights[0].intensity": 5.0,
 *       "lights[0].color": [1, 0, 0, 1],
 *       "lights[0].nearFar": [0.1, 10],
 *       "lights[1].intensity": 2.0,
 *       "lights[1].color": [0, 0, 1, 1],
 *       "lights[1].nearFar": [0.2, 15],
 *     });
 *
 *   You can also specify partial paths
 *
 *     twgl.setUniforms(programInfo, {
 *       'lights[1]': { intensity: 5.0, color: [1, 0, 0, 1], nearFar[0.2, 15] },
 *     });
 *
 *   But you can not specify leaf array indices
 *
 *     twgl.setUniforms(programInfo, {
 *       'lights[1].nearFar[1]': 15,     // BAD! nearFar is a leaf
 *       'lights[1].nearFar': [0.2, 15], // GOOD
 *     });
 *
 * @memberOf module:twgl/programs
 */
function setUniforms(setters, ...args) {  // eslint-disable-line
  const actualSetters = setters.uniformSetters || setters;
  const numArgs = args.length;
  for (let aNdx = 0; aNdx < numArgs; ++aNdx) {
    const values = args[aNdx];
    if (Array.isArray(values)) {
      const numValues = values.length;
      for (let ii = 0; ii < numValues; ++ii) {
        setUniforms(actualSetters, values[ii]);
      }
    } else {
      for (const name in values) {
        const setter = actualSetters[name];
        if (setter) {
          setter(values[name]);
        }
      }
    }
  }
}

/**
 * Alias for `setUniforms`
 * @function
 * @param {(module:twgl.ProgramInfo|Object.<string, function>)} setters a `ProgramInfo` as returned from `createProgramInfo` or the setters returned from
 *        `createUniformSetters`.
 * @param {Object.<string, ?>} values an object with values for the
 * @memberOf module:twgl/programs
 */
const setUniformsAndBindTextures = setUniforms;

/**
 * Creates setter functions for all attributes of a shader
 * program. You can pass this to {@link module:twgl.setBuffersAndAttributes} to set all your buffers and attributes.
 *
 * @see {@link module:twgl.setAttributes} for example
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {WebGLProgram} program the program to create setters for.
 * @return {Object.<string, function>} an object with a setter for each attribute by name.
 * @memberOf module:twgl/programs
 */
function createAttributeSetters(gl, program) {
  const attribSetters = {
  };

  const numAttribs = gl.getProgramParameter(program, ACTIVE_ATTRIBUTES);
  for (let ii = 0; ii < numAttribs; ++ii) {
    const attribInfo = gl.getActiveAttrib(program, ii);
    if (isBuiltIn(attribInfo)) {
      continue;
    }
    const index = gl.getAttribLocation(program, attribInfo.name);
    const typeInfo = attrTypeMap[attribInfo.type];
    const setter = typeInfo.setter(gl, index, typeInfo);
    setter.location = index;
    attribSetters[attribInfo.name] = setter;
  }

  return attribSetters;
}

/**
 * Sets attributes and binds buffers (deprecated... use {@link module:twgl.setBuffersAndAttributes})
 *
 * Example:
 *
 *     const program = createProgramFromScripts(
 *         gl, ["some-vs", "some-fs");
 *
 *     const attribSetters = createAttributeSetters(program);
 *
 *     const positionBuffer = gl.createBuffer();
 *     const texcoordBuffer = gl.createBuffer();
 *
 *     const attribs = {
 *       a_position: {buffer: positionBuffer, numComponents: 3},
 *       a_texcoord: {buffer: texcoordBuffer, numComponents: 2},
 *     };
 *
 *     gl.useProgram(program);
 *
 * This will automatically bind the buffers AND set the
 * attributes.
 *
 *     setAttributes(attribSetters, attribs);
 *
 * Properties of attribs. For each attrib you can add
 * properties:
 *
 * *   type: the type of data in the buffer. Default = gl.FLOAT
 * *   normalize: whether or not to normalize the data. Default = false
 * *   stride: the stride. Default = 0
 * *   offset: offset into the buffer. Default = 0
 * *   divisor: the divisor for instances. Default = undefined
 *
 * For example if you had 3 value float positions, 2 value
 * float texcoord and 4 value uint8 colors you'd setup your
 * attribs like this
 *
 *     const attribs = {
 *       a_position: {buffer: positionBuffer, numComponents: 3},
 *       a_texcoord: {buffer: texcoordBuffer, numComponents: 2},
 *       a_color: {
 *         buffer: colorBuffer,
 *         numComponents: 4,
 *         type: gl.UNSIGNED_BYTE,
 *         normalize: true,
 *       },
 *     };
 *
 * @param {Object.<string, function>} setters Attribute setters as returned from createAttributeSetters
 * @param {Object.<string, module:twgl.AttribInfo>} buffers AttribInfos mapped by attribute name.
 * @memberOf module:twgl/programs
 * @deprecated use {@link module:twgl.setBuffersAndAttributes}
 * @private
 */
function setAttributes(setters, buffers) {
  for (const name in buffers) {
    const setter = setters[name];
    if (setter) {
      setter(buffers[name]);
    }
  }
}

/**
 * Sets attributes and buffers including the `ELEMENT_ARRAY_BUFFER` if appropriate
 *
 * Example:
 *
 *     const programInfo = createProgramInfo(
 *         gl, ["some-vs", "some-fs");
 *
 *     const arrays = {
 *       position: { numComponents: 3, data: [0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0], },
 *       texcoord: { numComponents: 2, data: [0, 0, 0, 1, 1, 0, 1, 1],                 },
 *     };
 *
 *     const bufferInfo = createBufferInfoFromArrays(gl, arrays);
 *
 *     gl.useProgram(programInfo.program);
 *
 * This will automatically bind the buffers AND set the
 * attributes.
 *
 *     setBuffersAndAttributes(gl, programInfo, bufferInfo);
 *
 * For the example above it is equivalent to
 *
 *     gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
 *     gl.enableVertexAttribArray(a_positionLocation);
 *     gl.vertexAttribPointer(a_positionLocation, 3, gl.FLOAT, false, 0, 0);
 *     gl.bindBuffer(gl.ARRAY_BUFFER, texcoordBuffer);
 *     gl.enableVertexAttribArray(a_texcoordLocation);
 *     gl.vertexAttribPointer(a_texcoordLocation, 4, gl.FLOAT, false, 0, 0);
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext.
 * @param {(module:twgl.ProgramInfo|Object.<string, function>)} setters A `ProgramInfo` as returned from {@link module:twgl.createProgramInfo} or Attribute setters as returned from {@link module:twgl.createAttributeSetters}
 * @param {(module:twgl.BufferInfo|module:twgl.VertexArrayInfo)} buffers a `BufferInfo` as returned from {@link module:twgl.createBufferInfoFromArrays}.
 *   or a `VertexArrayInfo` as returned from {@link module:twgl.createVertexArrayInfo}
 * @memberOf module:twgl/programs
 */
function setBuffersAndAttributes(gl, programInfo, buffers) {
  if (buffers.vertexArrayObject) {
    gl.bindVertexArray(buffers.vertexArrayObject);
  } else {
    setAttributes(programInfo.attribSetters || programInfo, buffers.attribs);
    if (buffers.indices) {
      gl.bindBuffer(ELEMENT_ARRAY_BUFFER$1, buffers.indices);
    }
  }
}

/**
 * @typedef {Object} ProgramInfo
 * @property {WebGLProgram} program A shader program
 * @property {Object<string, function>} uniformSetters object of setters as returned from createUniformSetters,
 * @property {Object<string, function>} attribSetters object of setters as returned from createAttribSetters,
 * @property {module:twgl.UniformBlockSpec} [uniformBlockSpec] a uniform block spec for making UniformBlockInfos with createUniformBlockInfo etc..
 * @property {Object<string, module:twgl.TransformFeedbackInfo>} [transformFeedbackInfo] info for transform feedbacks
 * @memberOf module:twgl
 */

/**
 * Creates a ProgramInfo from an existing program.
 *
 * A ProgramInfo contains
 *
 *     programInfo = {
 *        program: WebGLProgram,
 *        uniformSetters: object of setters as returned from createUniformSetters,
 *        attribSetters: object of setters as returned from createAttribSetters,
 *     }
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext
 *        to use.
 * @param {WebGLProgram} program an existing WebGLProgram.
 * @return {module:twgl.ProgramInfo} The created ProgramInfo.
 * @memberOf module:twgl/programs
 */
function createProgramInfoFromProgram(gl, program) {
  const uniformSetters = createUniformSetters(gl, program);
  const attribSetters = createAttributeSetters(gl, program);
  const programInfo = {
    program,
    uniformSetters,
    attribSetters,
  };

  if (isWebGL2(gl)) {
    programInfo.uniformBlockSpec = createUniformBlockSpecFromProgram(gl, program);
    programInfo.transformFeedbackInfo = createTransformFeedbackInfo(gl, program);
  }

  return programInfo;
}

const notIdRE = /\s|{|}|;/;

/**
 * Creates a ProgramInfo from 2 sources.
 *
 * A ProgramInfo contains
 *
 *     programInfo = {
 *        program: WebGLProgram,
 *        uniformSetters: object of setters as returned from createUniformSetters,
 *        attribSetters: object of setters as returned from createAttribSetters,
 *     }
 *
 * NOTE: There are 4 signatures for this function
 *
 *     twgl.createProgramInfo(gl, [vs, fs], options);
 *     twgl.createProgramInfo(gl, [vs, fs], opt_errFunc);
 *     twgl.createProgramInfo(gl, [vs, fs], opt_attribs, opt_errFunc);
 *     twgl.createProgramInfo(gl, [vs, fs], opt_attribs, opt_locations, opt_errFunc);
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext
 *        to use.
 * @param {string[]} shaderSources Array of sources for the
 *        shaders or ids. The first is assumed to be the vertex shader,
 *        the second the fragment shader.
 * @param {module:twgl.ProgramOptions|string[]|module:twgl.ErrorCallback} [opt_attribs] Options for the program or an array of attribs names or an error callback. Locations will be assigned by index if not passed in
 * @param {number[]} [opt_locations|module:twgl.ErrorCallback] The locations for the. A parallel array to opt_attribs letting you assign locations or an error callback.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {module:twgl.ProgramInfo?} The created ProgramInfo or null if it failed to link or compile
 * @memberOf module:twgl/programs
 */
function createProgramInfo(
    gl, shaderSources, opt_attribs, opt_locations, opt_errorCallback) {
  const progOptions = getProgramOptions(opt_attribs, opt_locations, opt_errorCallback);
  const errors = [];
  shaderSources = shaderSources.map(function(source) {
    // Lets assume if there is no \n it's an id
    if (!notIdRE.test(source)) {
      const script = getElementById(source);
      if (!script) {
        const err = `no element with id: ${source}`;
        progOptions.errorCallback(err);
        errors.push(err);
      } else {
        source = script.text;
      }
    }
    return source;
  });
  if (errors.length) {
    return reportError(progOptions, '');
  }
  const origCallback = progOptions.callback;
  if (origCallback) {
    progOptions.callback = (err, program) => {
      let programInfo;
      if (!err) {
        programInfo = createProgramInfoFromProgram(gl, program);
      }
      origCallback(err, programInfo);
    };
  }
  const program = createProgramFromSources(gl, shaderSources, progOptions);
  if (!program) {
    return null;
  }
  return createProgramInfoFromProgram(gl, program);
}

var programs = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createAttributeSetters: createAttributeSetters,
  createProgram: createProgram,
  createProgramAsync: createProgramAsync,
  createProgramFromScripts: createProgramFromScripts,
  createProgramFromSources: createProgramFromSources,
  createProgramInfo: createProgramInfo,
  createProgramInfoAsync: createProgramInfoAsync,
  createProgramInfoFromProgram: createProgramInfoFromProgram,
  createUniformSetters: createUniformSetters,
  createUniformBlockSpecFromProgram: createUniformBlockSpecFromProgram,
  createUniformBlockInfoFromProgram: createUniformBlockInfoFromProgram,
  createUniformBlockInfo: createUniformBlockInfo,
  createTransformFeedback: createTransformFeedback,
  createTransformFeedbackInfo: createTransformFeedbackInfo,
  bindTransformFeedbackInfo: bindTransformFeedbackInfo,
  setAttributes: setAttributes,
  setBuffersAndAttributes: setBuffersAndAttributes,
  setUniforms: setUniforms,
  setUniformsAndBindTextures: setUniformsAndBindTextures,
  setUniformBlock: setUniformBlock,
  setBlockUniforms: setBlockUniforms,
  bindUniformBlock: bindUniformBlock
});

/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

const TRIANGLES                      = 0x0004;
const UNSIGNED_SHORT$3                 = 0x1403;

/**
 * Drawing related functions
 *
 * For backward compatibility they are available at both `twgl.draw` and `twgl`
 * itself
 *
 * See {@link module:twgl} for core functions
 *
 * @module twgl/draw
 */

/**
 * Calls `gl.drawElements` or `gl.drawArrays`, whichever is appropriate
 *
 * normally you'd call `gl.drawElements` or `gl.drawArrays` yourself
 * but calling this means if you switch from indexed data to non-indexed
 * data you don't have to remember to update your draw call.
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @param {(module:twgl.BufferInfo|module:twgl.VertexArrayInfo)} bufferInfo A BufferInfo as returned from {@link module:twgl.createBufferInfoFromArrays} or
 *   a VertexArrayInfo as returned from {@link module:twgl.createVertexArrayInfo}
 * @param {number} [type] eg (gl.TRIANGLES, gl.LINES, gl.POINTS, gl.TRIANGLE_STRIP, ...). Defaults to `gl.TRIANGLES`
 * @param {number} [count] An optional count. Defaults to bufferInfo.numElements
 * @param {number} [offset] An optional offset. Defaults to 0.
 * @param {number} [instanceCount] An optional instanceCount. if set then `drawArraysInstanced` or `drawElementsInstanced` will be called
 * @memberOf module:twgl/draw
 */
function drawBufferInfo(gl, bufferInfo, type, count, offset, instanceCount) {
  type = type === undefined ? TRIANGLES : type;
  const indices = bufferInfo.indices;
  const elementType = bufferInfo.elementType;
  const numElements = count === undefined ? bufferInfo.numElements : count;
  offset = offset === undefined ? 0 : offset;
  if (elementType || indices) {
    if (instanceCount !== undefined) {
      gl.drawElementsInstanced(type, numElements, elementType === undefined ? UNSIGNED_SHORT$3 : bufferInfo.elementType, offset, instanceCount);
    } else {
      gl.drawElements(type, numElements, elementType === undefined ? UNSIGNED_SHORT$3 : bufferInfo.elementType, offset);
    }
  } else {
    if (instanceCount !== undefined) {
      gl.drawArraysInstanced(type, offset, numElements, instanceCount);
    } else {
      gl.drawArrays(type, offset, numElements);
    }
  }
}

/**
 * A DrawObject is useful for putting objects in to an array and passing them to {@link module:twgl.drawObjectList}.
 *
 * You need either a `BufferInfo` or a `VertexArrayInfo`.
 *
 * @typedef {Object} DrawObject
 * @property {boolean} [active] whether or not to draw. Default = `true` (must be `false` to be not true). In other words `undefined` = `true`
 * @property {number} [type] type to draw eg. `gl.TRIANGLES`, `gl.LINES`, etc...
 * @property {module:twgl.ProgramInfo} programInfo A ProgramInfo as returned from {@link module:twgl.createProgramInfo}
 * @property {module:twgl.BufferInfo} [bufferInfo] A BufferInfo as returned from {@link module:twgl.createBufferInfoFromArrays}
 * @property {module:twgl.VertexArrayInfo} [vertexArrayInfo] A VertexArrayInfo as returned from {@link module:twgl.createVertexArrayInfo}
 * @property {Object<string, ?>} uniforms The values for the uniforms.
 *   You can pass multiple objects by putting them in an array. For example
 *
 *     var sharedUniforms = {
 *       u_fogNear: 10,
 *       u_projection: ...
 *       ...
 *     };
 *
 *     var localUniforms = {
 *       u_world: ...
 *       u_diffuseColor: ...
 *     };
 *
 *     var drawObj = {
 *       ...
 *       uniforms: [sharedUniforms, localUniforms],
 *     };
 *
 * @property {number} [offset] the offset to pass to `gl.drawArrays` or `gl.drawElements`. Defaults to 0.
 * @property {number} [count] the count to pass to `gl.drawArrays` or `gl.drawElements`. Defaults to bufferInfo.numElements.
 * @property {number} [instanceCount] the number of instances. Defaults to undefined.
 * @memberOf module:twgl
 */

/**
 * Draws a list of objects
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @param {DrawObject[]} objectsToDraw an array of objects to draw.
 * @memberOf module:twgl/draw
 */
function drawObjectList(gl, objectsToDraw) {
  let lastUsedProgramInfo = null;
  let lastUsedBufferInfo = null;

  objectsToDraw.forEach(function(object) {
    if (object.active === false) {
      return;
    }

    const programInfo = object.programInfo;
    const bufferInfo = object.vertexArrayInfo || object.bufferInfo;
    let bindBuffers = false;
    const type = object.type === undefined ? TRIANGLES : object.type;

    if (programInfo !== lastUsedProgramInfo) {
      lastUsedProgramInfo = programInfo;
      gl.useProgram(programInfo.program);

      // We have to rebind buffers when changing programs because we
      // only bind buffers the program uses. So if 2 programs use the same
      // bufferInfo but the 1st one uses only positions the when the
      // we switch to the 2nd one some of the attributes will not be on.
      bindBuffers = true;
    }

    // Setup all the needed attributes.
    if (bindBuffers || bufferInfo !== lastUsedBufferInfo) {
      if (lastUsedBufferInfo && lastUsedBufferInfo.vertexArrayObject && !bufferInfo.vertexArrayObject) {
        gl.bindVertexArray(null);
      }
      lastUsedBufferInfo = bufferInfo;
      setBuffersAndAttributes(gl, programInfo, bufferInfo);
    }

    // Set the uniforms.
    setUniforms(programInfo, object.uniforms);

    // Draw
    drawBufferInfo(gl, bufferInfo, type, object.count, object.offset, object.instanceCount);
  });

  if (lastUsedBufferInfo && lastUsedBufferInfo.vertexArrayObject) {
    gl.bindVertexArray(null);
  }
}

var draw = /*#__PURE__*/Object.freeze({
  __proto__: null,
  drawBufferInfo: drawBufferInfo,
  drawObjectList: drawObjectList
});

/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

const FRAMEBUFFER                    = 0x8d40;
const RENDERBUFFER                   = 0x8d41;
const TEXTURE_2D$2                     = 0x0de1;

const UNSIGNED_BYTE$3                  = 0x1401;

/* PixelFormat */
const DEPTH_COMPONENT$1                = 0x1902;
const RGBA$1                           = 0x1908;
const DEPTH_COMPONENT24$1              = 0x81a6;
const DEPTH_COMPONENT32F$1             = 0x8cac;
const DEPTH24_STENCIL8$1               = 0x88f0;
const DEPTH32F_STENCIL8$1              = 0x8cad;

/* Framebuffer Object. */
const RGBA4$1                          = 0x8056;
const RGB5_A1$1                        = 0x8057;
const RGB565$1                         = 0x8D62;
const DEPTH_COMPONENT16$1              = 0x81A5;
const STENCIL_INDEX                  = 0x1901;
const STENCIL_INDEX8                 = 0x8D48;
const DEPTH_STENCIL$1                  = 0x84F9;
const COLOR_ATTACHMENT0              = 0x8CE0;
const DEPTH_ATTACHMENT               = 0x8D00;
const STENCIL_ATTACHMENT             = 0x8D20;
const DEPTH_STENCIL_ATTACHMENT       = 0x821A;

/* TextureWrapMode */
const CLAMP_TO_EDGE$1                  = 0x812F;

/* TextureMagFilter */
const LINEAR$1                         = 0x2601;

/**
 * The options for a framebuffer attachment.
 *
 * Note: For a `format` that is a texture include all the texture
 * options from {@link module:twgl.TextureOptions} for example
 * `min`, `mag`, `clamp`, etc... Note that unlike {@link module:twgl.TextureOptions}
 * `auto` defaults to `false` for attachment textures but `min` and `mag` default
 * to `gl.LINEAR` and `wrap` defaults to `CLAMP_TO_EDGE`
 *
 * @typedef {Object} AttachmentOptions
 * @property {number} [attachmentPoint] The attachment point. Defaults
 *   to `gl.COLOR_ATTACHMENT0 + ndx` unless type is a depth or stencil type
 *   then it's gl.DEPTH_ATTACHMENT or `gl.DEPTH_STENCIL_ATTACHMENT` depending
 *   on the format or attachment type.
 * @property {number} [format] The format. If one of `gl.RGBA4`,
 *   `gl.RGB565`, `gl.RGB5_A1`, `gl.DEPTH_COMPONENT16`,
 *   `gl.STENCIL_INDEX8` or `gl.DEPTH_STENCIL` then will create a
 *   renderbuffer. Otherwise will create a texture. Default = `gl.RGBA`
 * @property {number} [type] The type. Used for texture. Default = `gl.UNSIGNED_BYTE`.
 * @property {number} [target] The texture target for `gl.framebufferTexture2D`.
 *   Defaults to `gl.TEXTURE_2D`. Set to appropriate face for cube maps.
 * @property {number} [samples] The number of samples. Default = 1
 * @property {number} [level] level for `gl.framebufferTexture2D`. Defaults to 0.
 * @property {number} [layer] layer for `gl.framebufferTextureLayer`. Defaults to undefined.
 *   If set then `gl.framebufferTextureLayer` is called, if not then `gl.framebufferTexture2D`
 * @property {(WebGLRenderbuffer | WebGLTexture)} [attachment] An existing renderbuffer or texture.
 *    If provided will attach this Object. This allows you to share
 *    attachments across framebuffers.
 * @memberOf module:twgl
 * @mixes module:twgl.TextureOptions
 */

const defaultAttachments = [
  { format: RGBA$1, type: UNSIGNED_BYTE$3, min: LINEAR$1, wrap: CLAMP_TO_EDGE$1, },
  { format: DEPTH_STENCIL$1, },
];

const attachmentsByFormat = {};
attachmentsByFormat[DEPTH_STENCIL$1] = DEPTH_STENCIL_ATTACHMENT;
attachmentsByFormat[STENCIL_INDEX] = STENCIL_ATTACHMENT;
attachmentsByFormat[STENCIL_INDEX8] = STENCIL_ATTACHMENT;
attachmentsByFormat[DEPTH_COMPONENT$1] = DEPTH_ATTACHMENT;
attachmentsByFormat[DEPTH_COMPONENT16$1] = DEPTH_ATTACHMENT;
attachmentsByFormat[DEPTH_COMPONENT24$1] = DEPTH_ATTACHMENT;
attachmentsByFormat[DEPTH_COMPONENT32F$1] = DEPTH_ATTACHMENT;
attachmentsByFormat[DEPTH24_STENCIL8$1] = DEPTH_STENCIL_ATTACHMENT;
attachmentsByFormat[DEPTH32F_STENCIL8$1] = DEPTH_STENCIL_ATTACHMENT;

function getAttachmentPointForFormat(format, internalFormat) {
  return attachmentsByFormat[format] || attachmentsByFormat[internalFormat];
}

const renderbufferFormats = {};
renderbufferFormats[RGBA4$1] = true;
renderbufferFormats[RGB5_A1$1] = true;
renderbufferFormats[RGB565$1] = true;
renderbufferFormats[DEPTH_STENCIL$1] = true;
renderbufferFormats[DEPTH_COMPONENT16$1] = true;
renderbufferFormats[STENCIL_INDEX] = true;
renderbufferFormats[STENCIL_INDEX8] = true;

function isRenderbufferFormat(format) {
  return renderbufferFormats[format];
}

const MAX_COLOR_ATTACHMENT_POINTS = 32;  // even an 3090 only supports 8 but WebGL/OpenGL ES define constants for 32

function isColorAttachmentPoint(attachmentPoint) {
  return attachmentPoint >= COLOR_ATTACHMENT0 && attachmentPoint < COLOR_ATTACHMENT0 + MAX_COLOR_ATTACHMENT_POINTS;
}

/**
 * @typedef {Object} FramebufferInfo
 * @property {WebGLFramebuffer} framebuffer The WebGLFramebuffer for this framebufferInfo
 * @property {Array.<(WebGLRenderbuffer | WebGLTexture)>} attachments The created attachments in the same order as passed in to {@link module:twgl.createFramebufferInfo}.
 * @property {number} width The width of the framebuffer and its attachments
 * @property {number} height The width of the framebuffer and its attachments
 * @memberOf module:twgl
 */

/**
 * Creates a framebuffer and attachments.
 *
 * This returns a {@link module:twgl.FramebufferInfo} because it needs to return the attachments as well as the framebuffer.
 * It also leaves the framebuffer it just created as the currently bound `FRAMEBUFFER`.
 * Note: If this is WebGL2 or if you called {@link module:twgl.addExtensionsToContext} then it will set the drawBuffers
 * to `[COLOR_ATTACHMENT0, COLOR_ATTACHMENT1, ...]` for how ever many color attachments were created.
 *
 * The simplest usage
 *
 *     // create an RGBA/UNSIGNED_BYTE texture and DEPTH_STENCIL renderbuffer
 *     const fbi = twgl.createFramebufferInfo(gl);
 *
 * More complex usage
 *
 *     // create an RGB565 renderbuffer and a STENCIL_INDEX8 renderbuffer
 *     const attachments = [
 *       { format: RGB565, mag: NEAREST },
 *       { format: STENCIL_INDEX8 },
 *     ]
 *     const fbi = twgl.createFramebufferInfo(gl, attachments);
 *
 * Passing in a specific size
 *
 *     const width = 256;
 *     const height = 256;
 *     const fbi = twgl.createFramebufferInfo(gl, attachments, width, height);
 *
 * **Note!!** It is up to you to check if the framebuffer is renderable by calling `gl.checkFramebufferStatus`.
 * [WebGL1 only guarantees 3 combinations of attachments work](https://www.khronos.org/registry/webgl/specs/latest/1.0/#6.6).
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.AttachmentOptions[]} [attachments] which attachments to create. If not provided the default is a framebuffer with an
 *    `RGBA`, `UNSIGNED_BYTE` texture `COLOR_ATTACHMENT0` and a `DEPTH_STENCIL` renderbuffer `DEPTH_STENCIL_ATTACHMENT`.
 * @param {number} [width] the width for the attachments. Default = size of drawingBuffer
 * @param {number} [height] the height for the attachments. Default = size of drawingBuffer
 * @return {module:twgl.FramebufferInfo} the framebuffer and attachments.
 * @memberOf module:twgl/framebuffers
 */
function createFramebufferInfo(gl, attachments, width, height) {
  const target = FRAMEBUFFER;
  const fb = gl.createFramebuffer();
  gl.bindFramebuffer(target, fb);
  width  = width  || gl.drawingBufferWidth;
  height = height || gl.drawingBufferHeight;
  attachments = attachments || defaultAttachments;
  const usedColorAttachmentsPoints = [];
  const framebufferInfo = {
    framebuffer: fb,
    attachments: [],
    width: width,
    height: height,
  };

  attachments.forEach(function(attachmentOptions, i) {
    let attachment = attachmentOptions.attachment;
    const samples = attachmentOptions.samples;
    const format = attachmentOptions.format;
    let attachmentPoint = attachmentOptions.attachmentPoint || getAttachmentPointForFormat(format, attachmentOptions.internalFormat);
    if (!attachmentPoint) {
      attachmentPoint = COLOR_ATTACHMENT0 + i;
    }
    if (isColorAttachmentPoint(attachmentPoint)) {
      usedColorAttachmentsPoints.push(attachmentPoint);
    }
    if (!attachment) {
      if (samples !== undefined || isRenderbufferFormat(format)) {
        attachment = gl.createRenderbuffer();
        gl.bindRenderbuffer(RENDERBUFFER, attachment);
        if (samples > 1) {
          gl.renderbufferStorageMultisample(RENDERBUFFER, samples, format, width, height);
        } else {
          gl.renderbufferStorage(RENDERBUFFER, format, width, height);
        }
      } else {
        const textureOptions = Object.assign({}, attachmentOptions);
        textureOptions.width = width;
        textureOptions.height = height;
        if (textureOptions.auto === undefined) {
          textureOptions.auto = false;
          textureOptions.min = textureOptions.min || textureOptions.minMag || LINEAR$1;
          textureOptions.mag = textureOptions.mag || textureOptions.minMag || LINEAR$1;
          textureOptions.wrapS = textureOptions.wrapS || textureOptions.wrap || CLAMP_TO_EDGE$1;
          textureOptions.wrapT = textureOptions.wrapT || textureOptions.wrap || CLAMP_TO_EDGE$1;
        }
        attachment = createTexture(gl, textureOptions);
      }
    }
    if (isRenderbuffer(gl, attachment)) {
      gl.framebufferRenderbuffer(target, attachmentPoint, RENDERBUFFER, attachment);
    } else if (isTexture(gl, attachment)) {
      if (attachmentOptions.layer !== undefined) {
        gl.framebufferTextureLayer(
          target,
          attachmentPoint,
          attachment,
          attachmentOptions.level || 0,
          attachmentOptions.layer);
      } else {
        gl.framebufferTexture2D(
            target,
            attachmentPoint,
            attachmentOptions.target || TEXTURE_2D$2,
            attachment,
            attachmentOptions.level || 0);
      }
    } else {
      throw new Error('unknown attachment type');
    }
    framebufferInfo.attachments.push(attachment);
  });
  if (gl.drawBuffers) {
    gl.drawBuffers(usedColorAttachmentsPoints);
  }
  return framebufferInfo;
}

/**
 * Resizes the attachments of a framebuffer.
 *
 * You need to pass in the same `attachments` as you passed in {@link module:twgl.createFramebufferInfo}
 * because TWGL has no idea the format/type of each attachment.
 *
 * The simplest usage
 *
 *     // create an RGBA/UNSIGNED_BYTE texture and DEPTH_STENCIL renderbuffer
 *     const fbi = twgl.createFramebufferInfo(gl);
 *
 *     ...
 *
 *     function render() {
 *       if (twgl.resizeCanvasToDisplaySize(gl.canvas)) {
 *         // resize the attachments
 *         twgl.resizeFramebufferInfo(gl, fbi);
 *       }
 *
 * More complex usage
 *
 *     // create an RGB565 renderbuffer and a STENCIL_INDEX8 renderbuffer
 *     const attachments = [
 *       { format: RGB565, mag: NEAREST },
 *       { format: STENCIL_INDEX8 },
 *     ]
 *     const fbi = twgl.createFramebufferInfo(gl, attachments);
 *
 *     ...
 *
 *     function render() {
 *       if (twgl.resizeCanvasToDisplaySize(gl.canvas)) {
 *         // resize the attachments to match
 *         twgl.resizeFramebufferInfo(gl, fbi, attachments);
 *       }
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.FramebufferInfo} framebufferInfo a framebufferInfo as returned from {@link module:twgl.createFramebufferInfo}.
 * @param {module:twgl.AttachmentOptions[]} [attachments] the same attachments options as passed to {@link module:twgl.createFramebufferInfo}.
 * @param {number} [width] the width for the attachments. Default = size of drawingBuffer
 * @param {number} [height] the height for the attachments. Default = size of drawingBuffer
 * @memberOf module:twgl/framebuffers
 */
function resizeFramebufferInfo(gl, framebufferInfo, attachments, width, height) {
  width  = width  || gl.drawingBufferWidth;
  height = height || gl.drawingBufferHeight;
  framebufferInfo.width = width;
  framebufferInfo.height = height;
  attachments = attachments || defaultAttachments;
  attachments.forEach(function(attachmentOptions, ndx) {
    const attachment = framebufferInfo.attachments[ndx];
    const format = attachmentOptions.format;
    const samples = attachmentOptions.samples;
    if (samples !== undefined || isRenderbuffer(gl, attachment)) {
      gl.bindRenderbuffer(RENDERBUFFER, attachment);
      if (samples > 1) {
        gl.renderbufferStorageMultisample(RENDERBUFFER, samples, format, width, height);
      } else {
        gl.renderbufferStorage(RENDERBUFFER, format, width, height);
      }
    } else if (isTexture(gl, attachment)) {
      resizeTexture(gl, attachment, attachmentOptions, width, height);
    } else {
      throw new Error('unknown attachment type');
    }
  });
}

/**
 * Binds a framebuffer
 *
 * This function pretty much solely exists because I spent hours
 * trying to figure out why something I wrote wasn't working only
 * to realize I forget to set the viewport dimensions.
 * My hope is this function will fix that.
 *
 * It is effectively the same as
 *
 *     gl.bindFramebuffer(gl.FRAMEBUFFER, someFramebufferInfo.framebuffer);
 *     gl.viewport(0, 0, someFramebufferInfo.width, someFramebufferInfo.height);
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.FramebufferInfo|null} [framebufferInfo] a framebufferInfo as returned from {@link module:twgl.createFramebufferInfo}.
 *   If falsy will bind the canvas.
 * @param {number} [target] The target. If not passed `gl.FRAMEBUFFER` will be used.
 * @memberOf module:twgl/framebuffers
 */

function bindFramebufferInfo(gl, framebufferInfo, target) {
  target = target || FRAMEBUFFER;
  if (framebufferInfo) {
    gl.bindFramebuffer(target, framebufferInfo.framebuffer);
    gl.viewport(0, 0, framebufferInfo.width, framebufferInfo.height);
  } else {
    gl.bindFramebuffer(target, null);
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
  }
}

var framebuffers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  bindFramebufferInfo: bindFramebufferInfo,
  createFramebufferInfo: createFramebufferInfo,
  resizeFramebufferInfo: resizeFramebufferInfo
});

/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

/**
 * vertex array object related functions
 *
 * You should generally not need to use these functions. They are provided
 * for those cases where you're doing something out of the ordinary
 * and you need lower level access.
 *
 * For backward compatibility they are available at both `twgl.attributes` and `twgl`
 * itself
 *
 * See {@link module:twgl} for core functions
 *
 * @module twgl/vertexArrays
 */

const ELEMENT_ARRAY_BUFFER$2           = 0x8893;

/**
 * @typedef {Object} VertexArrayInfo
 * @property {number} numElements The number of elements to pass to `gl.drawArrays` or `gl.drawElements`.
 * @property {number} [elementType] The type of indices `UNSIGNED_BYTE`, `UNSIGNED_SHORT` etc..
 * @property {WebGLVertexArrayObject} [vertexArrayObject] a vertex array object
 * @memberOf module:twgl
 */

/**
 * Creates a VertexArrayInfo from a BufferInfo and one or more ProgramInfos
 *
 * This can be passed to {@link module:twgl.setBuffersAndAttributes} and to
 * {@link module:twgl:drawBufferInfo}.
 *
 * > **IMPORTANT:** Vertex Array Objects are **not** a direct analog for a BufferInfo. Vertex Array Objects
 *   assign buffers to specific attributes at creation time. That means they can only be used with programs
 *   who's attributes use the same attribute locations for the same purposes.
 *
 * > Bind your attribute locations by passing an array of attribute names to {@link module:twgl.createProgramInfo}
 *   or use WebGL 2's GLSL ES 3's `layout(location = <num>)` to make sure locations match.
 *
 * also
 *
 * > **IMPORTANT:** After calling twgl.setBuffersAndAttribute with a BufferInfo that uses a Vertex Array Object
 *   that Vertex Array Object will be bound. That means **ANY MANIPULATION OF ELEMENT_ARRAY_BUFFER or ATTRIBUTES**
 *   will affect the Vertex Array Object state.
 *
 * > Call `gl.bindVertexArray(null)` to get back manipulating the global attributes and ELEMENT_ARRAY_BUFFER.
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @param {module:twgl.ProgramInfo|module:twgl.ProgramInfo[]} programInfo a programInfo or array of programInfos
 * @param {module:twgl.BufferInfo} bufferInfo BufferInfo as returned from createBufferInfoFromArrays etc...
 *
 *    You need to make sure every attribute that will be used is bound. So for example assume shader 1
 *    uses attributes A, B, C and shader 2 uses attributes A, B, D. If you only pass in the programInfo
 *    for shader 1 then only attributes A, B, and C will have their attributes set because TWGL doesn't
 *    now attribute D's location.
 *
 *    So, you can pass in both shader 1 and shader 2's programInfo
 *
 * @return {module:twgl.VertexArrayInfo} The created VertexArrayInfo
 *
 * @memberOf module:twgl/vertexArrays
 */
function createVertexArrayInfo(gl, programInfos, bufferInfo) {
  const vao = gl.createVertexArray();
  gl.bindVertexArray(vao);
  if (!programInfos.length) {
    programInfos = [programInfos];
  }
  programInfos.forEach(function(programInfo) {
    setBuffersAndAttributes(gl, programInfo, bufferInfo);
  });
  gl.bindVertexArray(null);
  return {
    numElements: bufferInfo.numElements,
    elementType: bufferInfo.elementType,
    vertexArrayObject: vao,
  };
}

/**
 * Creates a vertex array object and then sets the attributes on it
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {Object.<string, function>} setters Attribute setters as returned from createAttributeSetters
 * @param {Object.<string, module:twgl.AttribInfo>} attribs AttribInfos mapped by attribute name.
 * @param {WebGLBuffer} [indices] an optional ELEMENT_ARRAY_BUFFER of indices
 *
 * @return {WebGLVertexArrayObject|null} The created WebGLVertexArrayObject
 *
 * @memberOf module:twgl/vertexArrays
 */
function createVAOAndSetAttributes(gl, setters, attribs, indices) {
  const vao = gl.createVertexArray();
  gl.bindVertexArray(vao);
  setAttributes(setters, attribs);
  if (indices) {
    gl.bindBuffer(ELEMENT_ARRAY_BUFFER$2, indices);
  }
  // We unbind this because otherwise any change to ELEMENT_ARRAY_BUFFER
  // like when creating buffers for other stuff will mess up this VAO's binding
  gl.bindVertexArray(null);
  return vao;
}

/**
 * Creates a vertex array object and then sets the attributes
 * on it
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext
 *        to use.
 * @param {Object.<string, function>| module:twgl.ProgramInfo} programInfo as returned from createProgramInfo or Attribute setters as returned from createAttributeSetters
 * @param {module:twgl.BufferInfo} bufferInfo BufferInfo as returned from createBufferInfoFromArrays etc...
 * @param {WebGLBuffer} [indices] an optional ELEMENT_ARRAY_BUFFER of indices
 *
 * @return {WebGLVertexArrayObject|null} The created WebGLVertexArrayObject
 *
 * @memberOf module:twgl/vertexArrays
 */
function createVAOFromBufferInfo(gl, programInfo, bufferInfo) {
  return createVAOAndSetAttributes(gl, programInfo.attribSetters || programInfo, bufferInfo.attribs, bufferInfo.indices);
}

var vertexArrays = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createVertexArrayInfo: createVertexArrayInfo,
  createVAOAndSetAttributes: createVAOAndSetAttributes,
  createVAOFromBufferInfo: createVAOFromBufferInfo
});

/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */
const defaults$2 = {
  addExtensionsToContext: true,
};

/**
 * Various default settings for twgl.
 *
 * Note: You can call this any number of times. Example:
 *
 *     twgl.setDefaults({ textureColor: [1, 0, 0, 1] });
 *     twgl.setDefaults({ attribPrefix: 'a_' });
 *
 * is equivalent to
 *
 *     twgl.setDefaults({
 *       textureColor: [1, 0, 0, 1],
 *       attribPrefix: 'a_',
 *     });
 *
 * @typedef {Object} Defaults
 * @property {string} [attribPrefix] The prefix to stick on attributes
 *
 *   When writing shaders I prefer to name attributes with `a_`, uniforms with `u_` and varyings with `v_`
 *   as it makes it clear where they came from. But, when building geometry I prefer using un-prefixed names.
 *
 *   In other words I'll create arrays of geometry like this
 *
 *       const arrays = {
 *         position: ...
 *         normal: ...
 *         texcoord: ...
 *       };
 *
 *   But need those mapped to attributes and my attributes start with `a_`.
 *
 *   Default: `""`
 *
 * @property {number[]} [textureColor] Array of 4 values in the range 0 to 1
 *
 *   The default texture color is used when loading textures from
 *   urls. Because the URL will be loaded async we'd like to be
 *   able to use the texture immediately. By putting a 1x1 pixel
 *   color in the texture we can start using the texture before
 *   the URL has loaded.
 *
 *   Default: `[0.5, 0.75, 1, 1]`
 *
 * @property {string} [crossOrigin]
 *
 *   If not undefined sets the crossOrigin attribute on images
 *   that twgl creates when downloading images for textures.
 *
 *   Also see {@link module:twgl.TextureOptions}.
 *
 * @property {bool} [addExtensionsToContext]
 *
 *   If true, then, when twgl will try to add any supported WebGL extensions
 *   directly to the context under their normal GL names. For example
 *   if ANGLE_instances_arrays exists then twgl would enable it,
 *   add the functions `vertexAttribDivisor`, `drawArraysInstanced`,
 *   `drawElementsInstanced`, and the constant `VERTEX_ATTRIB_ARRAY_DIVISOR`
 *   to the `WebGLRenderingContext`.
 *
 * @memberOf module:twgl
 */

/**
 * Sets various defaults for twgl.
 *
 * In the interest of terseness which is kind of the point
 * of twgl I've integrated a few of the older functions here
 *
 * @param {module:twgl.Defaults} newDefaults The default settings.
 * @memberOf module:twgl
 */
function setDefaults$2(newDefaults) {
  copyExistingProperties(newDefaults, defaults$2);
  setDefaults(newDefaults);  // eslint-disable-line
  setDefaults$1(newDefaults);  // eslint-disable-line
}

const prefixRE = /^(.*?)_/;
function addExtensionToContext(gl, extensionName) {
  glEnumToString(gl, 0);
  const ext = gl.getExtension(extensionName);
  if (ext) {
    const enums = {};
    const fnSuffix = prefixRE.exec(extensionName)[1];
    const enumSuffix = '_' + fnSuffix;
    for (const key in ext) {
      const value = ext[key];
      const isFunc = typeof (value) === 'function';
      const suffix = isFunc ? fnSuffix : enumSuffix;
      let name = key;
      // examples of where this is not true are WEBGL_compressed_texture_s3tc
      // and WEBGL_compressed_texture_pvrtc
      if (key.endsWith(suffix)) {
        name = key.substring(0, key.length - suffix.length);
      }
      if (gl[name] !== undefined) {
        if (!isFunc && gl[name] !== value) {
          warn(name, gl[name], value, key);
        }
      } else {
        if (isFunc) {
          gl[name] = function(origFn) {
            return function() {
              return origFn.apply(ext, arguments);
            };
          }(value);
        } else {
          gl[name] = value;
          enums[name] = value;
        }
      }
    }
    // pass the modified enums to glEnumToString
    enums.constructor = {
      name: ext.constructor.name,
    };
    glEnumToString(enums, 0);
  }
  return ext;
}

/*
 * If you're wondering why the code doesn't just iterate
 * over all extensions using `gl.getExtensions` is that it's possible
 * some future extension is incompatible with this code. Rather than
 * have thing suddenly break it seems better to manually add to this
 * list.
 *
 */
const supportedExtensions = [
  'ANGLE_instanced_arrays',
  'EXT_blend_minmax',
  'EXT_color_buffer_float',
  'EXT_color_buffer_half_float',
  'EXT_disjoint_timer_query',
  'EXT_disjoint_timer_query_webgl2',
  'EXT_frag_depth',
  'EXT_sRGB',
  'EXT_shader_texture_lod',
  'EXT_texture_filter_anisotropic',
  'OES_element_index_uint',
  'OES_standard_derivatives',
  'OES_texture_float',
  'OES_texture_float_linear',
  'OES_texture_half_float',
  'OES_texture_half_float_linear',
  'OES_vertex_array_object',
  'WEBGL_color_buffer_float',
  'WEBGL_compressed_texture_atc',
  'WEBGL_compressed_texture_etc1',
  'WEBGL_compressed_texture_pvrtc',
  'WEBGL_compressed_texture_s3tc',
  'WEBGL_compressed_texture_s3tc_srgb',
  'WEBGL_depth_texture',
  'WEBGL_draw_buffers',
];

/**
 * Attempts to enable all of the following extensions
 * and add their functions and constants to the
 * `WebGLRenderingContext` using their normal non-extension like names.
 *
 *      ANGLE_instanced_arrays
 *      EXT_blend_minmax
 *      EXT_color_buffer_float
 *      EXT_color_buffer_half_float
 *      EXT_disjoint_timer_query
 *      EXT_disjoint_timer_query_webgl2
 *      EXT_frag_depth
 *      EXT_sRGB
 *      EXT_shader_texture_lod
 *      EXT_texture_filter_anisotropic
 *      OES_element_index_uint
 *      OES_standard_derivatives
 *      OES_texture_float
 *      OES_texture_float_linear
 *      OES_texture_half_float
 *      OES_texture_half_float_linear
 *      OES_vertex_array_object
 *      WEBGL_color_buffer_float
 *      WEBGL_compressed_texture_atc
 *      WEBGL_compressed_texture_etc1
 *      WEBGL_compressed_texture_pvrtc
 *      WEBGL_compressed_texture_s3tc
 *      WEBGL_compressed_texture_s3tc_srgb
 *      WEBGL_depth_texture
 *      WEBGL_draw_buffers
 *
 * For example if `ANGLE_instanced_arrays` exists then the functions
 * `drawArraysInstanced`, `drawElementsInstanced`, `vertexAttribDivisor`
 * and the constant `VERTEX_ATTRIB_ARRAY_DIVISOR` are added to the
 * `WebGLRenderingContext`.
 *
 * Note that if you want to know if the extension exists you should
 * probably call `gl.getExtension` for each extension. Alternatively
 * you can check for the existence of the functions or constants that
 * are expected to be added. For example
 *
 *    if (gl.drawBuffers) {
 *      // Either WEBGL_draw_buffers was enabled OR you're running in WebGL2
 *      ....
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @memberOf module:twgl
 */
function addExtensionsToContext(gl) {
  for (let ii = 0; ii < supportedExtensions.length; ++ii) {
    addExtensionToContext(gl, supportedExtensions[ii]);
  }
}

/**
 * Creates a webgl context.
 * @param {HTMLCanvasElement} canvas The canvas tag to get
 *     context from. If one is not passed in one will be
 *     created.
 * @return {WebGLRenderingContext} The created context.
 * @private
 */
function create3DContext(canvas, opt_attribs) {
  const names = ["webgl", "experimental-webgl"];
  let context = null;
  for (let ii = 0; ii < names.length; ++ii) {
    context = canvas.getContext(names[ii], opt_attribs);
    if (context) {
      if (defaults$2.addExtensionsToContext) {
        addExtensionsToContext(context);
      }
      break;
    }
  }
  return context;
}

/**
 * Gets a WebGL1 context.
 *
 * Note: Will attempt to enable Vertex Array Objects
 * and add WebGL2 entry points. (unless you first set defaults with
 * `twgl.setDefaults({enableVertexArrayObjects: false})`;
 *
 * @param {HTMLCanvasElement} canvas a canvas element.
 * @param {WebGLContextAttributes} [opt_attribs] optional webgl context creation attributes
 * @return {WebGLRenderingContext} The created context.
 * @memberOf module:twgl
 * @deprecated
 * @private
 */
function getWebGLContext(canvas, opt_attribs) {
  const gl = create3DContext(canvas, opt_attribs);
  return gl;
}

/**
 * Creates a webgl context.
 *
 * Will return a WebGL2 context if possible.
 *
 * You can check if it's WebGL2 with
 *
 *     twgl.isWebGL2(gl);
 *
 * @param {HTMLCanvasElement} canvas The canvas tag to get
 *     context from. If one is not passed in one will be
 *     created.
 * @return {WebGLRenderingContext} The created context.
 */
function createContext(canvas, opt_attribs) {
  const names = ["webgl2", "webgl", "experimental-webgl"];
  let context = null;
  for (let ii = 0; ii < names.length; ++ii) {
    context = canvas.getContext(names[ii], opt_attribs);
    if (context) {
      if (defaults$2.addExtensionsToContext) {
        addExtensionsToContext(context);
      }
      break;
    }
  }
  return context;
}

/**
 * Gets a WebGL context.  Will create a WebGL2 context if possible.
 *
 * You can check if it's WebGL2 with
 *
 *    function isWebGL2(gl) {
 *      return gl.getParameter(gl.VERSION).indexOf("WebGL 2.0 ") == 0;
 *    }
 *
 * Note: For a WebGL1 context will attempt to enable Vertex Array Objects
 * and add WebGL2 entry points. (unless you first set defaults with
 * `twgl.setDefaults({enableVertexArrayObjects: false})`;
 *
 * @param {HTMLCanvasElement} canvas a canvas element.
 * @param {WebGLContextAttributes} [opt_attribs] optional webgl context creation attributes
 * @return {WebGLRenderingContext} The created context.
 * @memberOf module:twgl
 */
function getContext(canvas, opt_attribs) {
  const gl = createContext(canvas, opt_attribs);
  return gl;
}

/**
 * Resize a canvas to match the size it's displayed.
 * @param {HTMLCanvasElement} canvas The canvas to resize.
 * @param {number} [multiplier] So you can pass in `window.devicePixelRatio` or other scale value if you want to.
 * @return {boolean} true if the canvas was resized.
 * @memberOf module:twgl
 */
function resizeCanvasToDisplaySize(canvas, multiplier) {
  multiplier = multiplier || 1;
  multiplier = Math.max(0, multiplier);
  const width  = canvas.clientWidth  * multiplier | 0;
  const height = canvas.clientHeight * multiplier | 0;
  if (canvas.width !== width || canvas.height !== height) {
    canvas.width = width;
    canvas.height = height;
    return true;
  }
  return false;
}




/***/ }),

/***/ "./node_modules/unicode-trie/index.js":
/*!********************************************!*\
  !*** ./node_modules/unicode-trie/index.js ***!
  \********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
var UnicodeTrie, inflate;

inflate = __webpack_require__(/*! tiny-inflate */ "./node_modules/tiny-inflate/index.js");

UnicodeTrie = (function() {
  var DATA_BLOCK_LENGTH, DATA_GRANULARITY, DATA_MASK, INDEX_1_OFFSET, INDEX_2_BLOCK_LENGTH, INDEX_2_BMP_LENGTH, INDEX_2_MASK, INDEX_SHIFT, LSCP_INDEX_2_LENGTH, LSCP_INDEX_2_OFFSET, OMITTED_BMP_INDEX_1_LENGTH, SHIFT_1, SHIFT_1_2, SHIFT_2, UTF8_2B_INDEX_2_LENGTH, UTF8_2B_INDEX_2_OFFSET;

  SHIFT_1 = 6 + 5;

  SHIFT_2 = 5;

  SHIFT_1_2 = SHIFT_1 - SHIFT_2;

  OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;

  INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;

  INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;

  INDEX_SHIFT = 2;

  DATA_BLOCK_LENGTH = 1 << SHIFT_2;

  DATA_MASK = DATA_BLOCK_LENGTH - 1;

  LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;

  LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;

  INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;

  UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;

  UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6;

  INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;

  DATA_GRANULARITY = 1 << INDEX_SHIFT;

  function UnicodeTrie(data) {
    var isBuffer, uncompressedLength, view;
    isBuffer = typeof data.readUInt32BE === 'function' && typeof data.slice === 'function';
    if (isBuffer || data instanceof Uint8Array) {
      if (isBuffer) {
        this.highStart = data.readUInt32BE(0);
        this.errorValue = data.readUInt32BE(4);
        uncompressedLength = data.readUInt32BE(8);
        data = data.slice(12);
      } else {
        view = new DataView(data.buffer);
        this.highStart = view.getUint32(0);
        this.errorValue = view.getUint32(4);
        uncompressedLength = view.getUint32(8);
        data = data.subarray(12);
      }
      data = inflate(data, new Uint8Array(uncompressedLength));
      data = inflate(data, new Uint8Array(uncompressedLength));
      this.data = new Uint32Array(data.buffer);
    } else {
      this.data = data.data, this.highStart = data.highStart, this.errorValue = data.errorValue;
    }
  }

  UnicodeTrie.prototype.get = function(codePoint) {
    var index;
    if (codePoint < 0 || codePoint > 0x10ffff) {
      return this.errorValue;
    }
    if (codePoint < 0xd800 || (codePoint > 0xdbff && codePoint <= 0xffff)) {
      index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }
    if (codePoint <= 0xffff) {
      index = (this.data[LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }
    if (codePoint < this.highStart) {
      index = this.data[(INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH) + (codePoint >> SHIFT_1)];
      index = this.data[index + ((codePoint >> SHIFT_2) & INDEX_2_MASK)];
      index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }
    return this.data[this.data.length - DATA_GRANULARITY];
  };

  return UnicodeTrie;

})();

module.exports = UnicodeTrie;


/***/ }),

/***/ "./node_modules/css-tree/data/patch.json":
/*!***********************************************!*\
  !*** ./node_modules/css-tree/data/patch.json ***!
  \***********************************************/
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"atrules":{"charset":{"prelude":"<string>"},"font-face":{"descriptors":{"unicode-range":{"comment":"replaces <unicode-range>, an old production name","syntax":"<urange>#"}}}},"properties":{"-moz-background-clip":{"comment":"deprecated syntax in old Firefox, https://developer.mozilla.org/en/docs/Web/CSS/background-clip","syntax":"padding | border"},"-moz-border-radius-bottomleft":{"comment":"https://developer.mozilla.org/en-US/docs/Web/CSS/border-bottom-left-radius","syntax":"<\'border-bottom-left-radius\'>"},"-moz-border-radius-bottomright":{"comment":"https://developer.mozilla.org/en-US/docs/Web/CSS/border-bottom-right-radius","syntax":"<\'border-bottom-right-radius\'>"},"-moz-border-radius-topleft":{"comment":"https://developer.mozilla.org/en-US/docs/Web/CSS/border-top-left-radius","syntax":"<\'border-top-left-radius\'>"},"-moz-border-radius-topright":{"comment":"https://developer.mozilla.org/en-US/docs/Web/CSS/border-bottom-right-radius","syntax":"<\'border-bottom-right-radius\'>"},"-moz-control-character-visibility":{"comment":"firefox specific keywords, https://bugzilla.mozilla.org/show_bug.cgi?id=947588","syntax":"visible | hidden"},"-moz-osx-font-smoothing":{"comment":"misssed old syntax https://developer.mozilla.org/en-US/docs/Web/CSS/font-smooth","syntax":"auto | grayscale"},"-moz-user-select":{"comment":"https://developer.mozilla.org/en-US/docs/Web/CSS/user-select","syntax":"none | text | all | -moz-none"},"-ms-flex-align":{"comment":"misssed old syntax implemented in IE, https://www.w3.org/TR/2012/WD-css3-flexbox-20120322/#flex-align","syntax":"start | end | center | baseline | stretch"},"-ms-flex-item-align":{"comment":"misssed old syntax implemented in IE, https://www.w3.org/TR/2012/WD-css3-flexbox-20120322/#flex-align","syntax":"auto | start | end | center | baseline | stretch"},"-ms-flex-line-pack":{"comment":"misssed old syntax implemented in IE, https://www.w3.org/TR/2012/WD-css3-flexbox-20120322/#flex-line-pack","syntax":"start | end | center | justify | distribute | stretch"},"-ms-flex-negative":{"comment":"misssed old syntax implemented in IE; TODO: find references for comfirmation","syntax":"<\'flex-shrink\'>"},"-ms-flex-pack":{"comment":"misssed old syntax implemented in IE, https://www.w3.org/TR/2012/WD-css3-flexbox-20120322/#flex-pack","syntax":"start | end | center | justify | distribute"},"-ms-flex-order":{"comment":"misssed old syntax implemented in IE; https://msdn.microsoft.com/en-us/library/jj127303(v=vs.85).aspx","syntax":"<integer>"},"-ms-flex-positive":{"comment":"misssed old syntax implemented in IE; TODO: find references for comfirmation","syntax":"<\'flex-grow\'>"},"-ms-flex-preferred-size":{"comment":"misssed old syntax implemented in IE; TODO: find references for comfirmation","syntax":"<\'flex-basis\'>"},"-ms-interpolation-mode":{"comment":"https://msdn.microsoft.com/en-us/library/ff521095(v=vs.85).aspx","syntax":"nearest-neighbor | bicubic"},"-ms-grid-column-align":{"comment":"add this property first since it uses as fallback for flexbox, https://msdn.microsoft.com/en-us/library/windows/apps/hh466338.aspx","syntax":"start | end | center | stretch"},"-ms-grid-row-align":{"comment":"add this property first since it uses as fallback for flexbox, https://msdn.microsoft.com/en-us/library/windows/apps/hh466348.aspx","syntax":"start | end | center | stretch"},"-ms-hyphenate-limit-last":{"comment":"misssed old syntax implemented in IE; https://www.w3.org/TR/css-text-4/#hyphenate-line-limits","syntax":"none | always | column | page | spread"},"-webkit-appearance":{"comment":"webkit specific keywords","references":["http://css-infos.net/property/-webkit-appearance"],"syntax":"none | button | button-bevel | caps-lock-indicator | caret | checkbox | default-button | inner-spin-button | listbox | listitem | media-controls-background | media-controls-fullscreen-background | media-current-time-display | media-enter-fullscreen-button | media-exit-fullscreen-button | media-fullscreen-button | media-mute-button | media-overlay-play-button | media-play-button | media-seek-back-button | media-seek-forward-button | media-slider | media-sliderthumb | media-time-remaining-display | media-toggle-closed-captions-button | media-volume-slider | media-volume-slider-container | media-volume-sliderthumb | menulist | menulist-button | menulist-text | menulist-textfield | meter | progress-bar | progress-bar-value | push-button | radio | scrollbarbutton-down | scrollbarbutton-left | scrollbarbutton-right | scrollbarbutton-up | scrollbargripper-horizontal | scrollbargripper-vertical | scrollbarthumb-horizontal | scrollbarthumb-vertical | scrollbartrack-horizontal | scrollbartrack-vertical | searchfield | searchfield-cancel-button | searchfield-decoration | searchfield-results-button | searchfield-results-decoration | slider-horizontal | slider-vertical | sliderthumb-horizontal | sliderthumb-vertical | square-button | textarea | textfield | -apple-pay-button"},"-webkit-background-clip":{"comment":"https://developer.mozilla.org/en/docs/Web/CSS/background-clip","syntax":"[ <box> | border | padding | content | text ]#"},"-webkit-column-break-after":{"comment":"added, http://help.dottoro.com/lcrthhhv.php","syntax":"always | auto | avoid"},"-webkit-column-break-before":{"comment":"added, http://help.dottoro.com/lcxquvkf.php","syntax":"always | auto | avoid"},"-webkit-column-break-inside":{"comment":"added, http://help.dottoro.com/lclhnthl.php","syntax":"always | auto | avoid"},"-webkit-font-smoothing":{"comment":"https://developer.mozilla.org/en-US/docs/Web/CSS/font-smooth","syntax":"auto | none | antialiased | subpixel-antialiased"},"-webkit-mask-box-image":{"comment":"missed; https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-mask-box-image","syntax":"[ <url> | <gradient> | none ] [ <length-percentage>{4} <-webkit-mask-box-repeat>{2} ]?"},"-webkit-print-color-adjust":{"comment":"missed","references":["https://developer.mozilla.org/en/docs/Web/CSS/-webkit-print-color-adjust"],"syntax":"economy | exact"},"-webkit-text-security":{"comment":"missed; http://help.dottoro.com/lcbkewgt.php","syntax":"none | circle | disc | square"},"-webkit-user-drag":{"comment":"missed; http://help.dottoro.com/lcbixvwm.php","syntax":"none | element | auto"},"-webkit-user-select":{"comment":"auto is supported by old webkit, https://developer.mozilla.org/en-US/docs/Web/CSS/user-select","syntax":"auto | none | text | all"},"alignment-baseline":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/text.html#AlignmentBaselineProperty"],"syntax":"auto | baseline | before-edge | text-before-edge | middle | central | after-edge | text-after-edge | ideographic | alphabetic | hanging | mathematical"},"baseline-shift":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/text.html#BaselineShiftProperty"],"syntax":"baseline | sub | super | <svg-length>"},"behavior":{"comment":"added old IE property https://msdn.microsoft.com/en-us/library/ms530723(v=vs.85).aspx","syntax":"<url>+"},"clip-rule":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/masking.html#ClipRuleProperty"],"syntax":"nonzero | evenodd"},"cue":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"<\'cue-before\'> <\'cue-after\'>?"},"cue-after":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"<url> <decibel>? | none"},"cue-before":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"<url> <decibel>? | none"},"cursor":{"comment":"added legacy keywords: hand, -webkit-grab. -webkit-grabbing, -webkit-zoom-in, -webkit-zoom-out, -moz-grab, -moz-grabbing, -moz-zoom-in, -moz-zoom-out","references":["https://www.sitepoint.com/css3-cursor-styles/"],"syntax":"[ [ <url> [ <x> <y> ]? , ]* [ auto | default | none | context-menu | help | pointer | progress | wait | cell | crosshair | text | vertical-text | alias | copy | move | no-drop | not-allowed | e-resize | n-resize | ne-resize | nw-resize | s-resize | se-resize | sw-resize | w-resize | ew-resize | ns-resize | nesw-resize | nwse-resize | col-resize | row-resize | all-scroll | zoom-in | zoom-out | grab | grabbing | hand | -webkit-grab | -webkit-grabbing | -webkit-zoom-in | -webkit-zoom-out | -moz-grab | -moz-grabbing | -moz-zoom-in | -moz-zoom-out ] ]"},"display":{"comment":"extended with -ms-flexbox","syntax":"| <-non-standard-display>"},"position":{"comment":"extended with -webkit-sticky","syntax":"| -webkit-sticky"},"dominant-baseline":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/text.html#DominantBaselineProperty"],"syntax":"auto | use-script | no-change | reset-size | ideographic | alphabetic | hanging | mathematical | central | middle | text-after-edge | text-before-edge"},"image-rendering":{"comment":"extended with <-non-standard-image-rendering>, added SVG keywords optimizeSpeed and optimizeQuality","references":["https://developer.mozilla.org/en/docs/Web/CSS/image-rendering","https://www.w3.org/TR/SVG/painting.html#ImageRenderingProperty"],"syntax":"| optimizeSpeed | optimizeQuality | <-non-standard-image-rendering>"},"fill":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#FillProperty"],"syntax":"<paint>"},"fill-opacity":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#FillProperty"],"syntax":"<number-zero-one>"},"fill-rule":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#FillProperty"],"syntax":"nonzero | evenodd"},"filter":{"comment":"extend with IE legacy syntaxes","syntax":"| <-ms-filter-function-list>"},"glyph-orientation-horizontal":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/text.html#GlyphOrientationHorizontalProperty"],"syntax":"<angle>"},"glyph-orientation-vertical":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/text.html#GlyphOrientationVerticalProperty"],"syntax":"<angle>"},"kerning":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/text.html#KerningProperty"],"syntax":"auto | <svg-length>"},"letter-spacing":{"comment":"fix syntax <length> -> <length-percentage>","references":["https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/letter-spacing"],"syntax":"normal | <length-percentage>"},"marker":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#MarkerProperties"],"syntax":"none | <url>"},"marker-end":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#MarkerProperties"],"syntax":"none | <url>"},"marker-mid":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#MarkerProperties"],"syntax":"none | <url>"},"marker-start":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#MarkerProperties"],"syntax":"none | <url>"},"max-width":{"comment":"fix auto -> none (https://github.com/mdn/data/pull/431); extend by non-standard width keywords https://developer.mozilla.org/en-US/docs/Web/CSS/max-width","syntax":"none | <length-percentage> | min-content | max-content | fit-content(<length-percentage>) | <-non-standard-width>"},"width":{"comment":"per spec fit-content should be a function, however browsers are supporting it as a keyword (https://github.com/csstree/stylelint-validator/issues/29)","syntax":"| fit-content | -moz-fit-content | -webkit-fit-content"},"min-width":{"comment":"extend by non-standard width keywords https://developer.mozilla.org/en-US/docs/Web/CSS/width","syntax":"auto | <length-percentage> | min-content | max-content | fit-content(<length-percentage>) | <-non-standard-width>"},"overflow":{"comment":"extend by vendor keywords https://developer.mozilla.org/en-US/docs/Web/CSS/overflow","syntax":"| <-non-standard-overflow>"},"pause":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"<\'pause-before\'> <\'pause-after\'>?"},"pause-after":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"<time> | none | x-weak | weak | medium | strong | x-strong"},"pause-before":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"<time> | none | x-weak | weak | medium | strong | x-strong"},"rest":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"<\'rest-before\'> <\'rest-after\'>?"},"rest-after":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"<time> | none | x-weak | weak | medium | strong | x-strong"},"rest-before":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"<time> | none | x-weak | weak | medium | strong | x-strong"},"shape-rendering":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#ShapeRenderingPropert"],"syntax":"auto | optimizeSpeed | crispEdges | geometricPrecision"},"src":{"comment":"added @font-face\'s src property https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/src","syntax":"[ <url> [ format( <string># ) ]? | local( <family-name> ) ]#"},"speak":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"auto | none | normal"},"speak-as":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"normal | spell-out || digits || [ literal-punctuation | no-punctuation ]"},"stroke":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#StrokeProperties"],"syntax":"<paint>"},"stroke-dasharray":{"comment":"added SVG property; a list of comma and/or white space separated <length>s and <percentage>s","references":["https://www.w3.org/TR/SVG/painting.html#StrokeProperties"],"syntax":"none | [ <svg-length>+ ]#"},"stroke-dashoffset":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#StrokeProperties"],"syntax":"<svg-length>"},"stroke-linecap":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#StrokeProperties"],"syntax":"butt | round | square"},"stroke-linejoin":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#StrokeProperties"],"syntax":"miter | round | bevel"},"stroke-miterlimit":{"comment":"added SVG property (<miterlimit> = <number-one-or-greater>) ","references":["https://www.w3.org/TR/SVG/painting.html#StrokeProperties"],"syntax":"<number-one-or-greater>"},"stroke-opacity":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#StrokeProperties"],"syntax":"<number-zero-one>"},"stroke-width":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/painting.html#StrokeProperties"],"syntax":"<svg-length>"},"text-anchor":{"comment":"added SVG property","references":["https://www.w3.org/TR/SVG/text.html#TextAlignmentProperties"],"syntax":"start | middle | end"},"unicode-bidi":{"comment":"added prefixed keywords https://developer.mozilla.org/en-US/docs/Web/CSS/unicode-bidi","syntax":"| -moz-isolate | -moz-isolate-override | -moz-plaintext | -webkit-isolate | -webkit-isolate-override | -webkit-plaintext"},"unicode-range":{"comment":"added missed property https://developer.mozilla.org/en-US/docs/Web/CSS/%40font-face/unicode-range","syntax":"<urange>#"},"voice-balance":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"<number> | left | center | right | leftwards | rightwards"},"voice-duration":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"auto | <time>"},"voice-family":{"comment":"<name> -> <family-name>, https://www.w3.org/TR/css3-speech/#property-index","syntax":"[ [ <family-name> | <generic-voice> ] , ]* [ <family-name> | <generic-voice> ] | preserve"},"voice-pitch":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"<frequency> && absolute | [ [ x-low | low | medium | high | x-high ] || [ <frequency> | <semitones> | <percentage> ] ]"},"voice-range":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"<frequency> && absolute | [ [ x-low | low | medium | high | x-high ] || [ <frequency> | <semitones> | <percentage> ] ]"},"voice-rate":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"[ normal | x-slow | slow | medium | fast | x-fast ] || <percentage>"},"voice-stress":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"normal | strong | moderate | none | reduced"},"voice-volume":{"comment":"https://www.w3.org/TR/css3-speech/#property-index","syntax":"silent | [ [ x-soft | soft | medium | loud | x-loud ] || <decibel> ]"},"writing-mode":{"comment":"extend with SVG keywords","syntax":"| <svg-writing-mode>"}},"syntaxes":{"-legacy-gradient":{"comment":"added collection of legacy gradient syntaxes","syntax":"<-webkit-gradient()> | <-legacy-linear-gradient> | <-legacy-repeating-linear-gradient> | <-legacy-radial-gradient> | <-legacy-repeating-radial-gradient>"},"-legacy-linear-gradient":{"comment":"like standard syntax but w/o `to` keyword https://developer.mozilla.org/en-US/docs/Web/CSS/linear-gradient","syntax":"-moz-linear-gradient( <-legacy-linear-gradient-arguments> ) | -webkit-linear-gradient( <-legacy-linear-gradient-arguments> ) | -o-linear-gradient( <-legacy-linear-gradient-arguments> )"},"-legacy-repeating-linear-gradient":{"comment":"like standard syntax but w/o `to` keyword https://developer.mozilla.org/en-US/docs/Web/CSS/linear-gradient","syntax":"-moz-repeating-linear-gradient( <-legacy-linear-gradient-arguments> ) | -webkit-repeating-linear-gradient( <-legacy-linear-gradient-arguments> ) | -o-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )"},"-legacy-linear-gradient-arguments":{"comment":"like standard syntax but w/o `to` keyword https://developer.mozilla.org/en-US/docs/Web/CSS/linear-gradient","syntax":"[ <angle> | <side-or-corner> ]? , <color-stop-list>"},"-legacy-radial-gradient":{"comment":"deprecated syntax that implemented by some browsers https://www.w3.org/TR/2011/WD-css3-images-20110908/#radial-gradients","syntax":"-moz-radial-gradient( <-legacy-radial-gradient-arguments> ) | -webkit-radial-gradient( <-legacy-radial-gradient-arguments> ) | -o-radial-gradient( <-legacy-radial-gradient-arguments> )"},"-legacy-repeating-radial-gradient":{"comment":"deprecated syntax that implemented by some browsers https://www.w3.org/TR/2011/WD-css3-images-20110908/#radial-gradients","syntax":"-moz-repeating-radial-gradient( <-legacy-radial-gradient-arguments> ) | -webkit-repeating-radial-gradient( <-legacy-radial-gradient-arguments> ) | -o-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )"},"-legacy-radial-gradient-arguments":{"comment":"deprecated syntax that implemented by some browsers https://www.w3.org/TR/2011/WD-css3-images-20110908/#radial-gradients","syntax":"[ <position> , ]? [ [ [ <-legacy-radial-gradient-shape> || <-legacy-radial-gradient-size> ] | [ <length> | <percentage> ]{2} ] , ]? <color-stop-list>"},"-legacy-radial-gradient-size":{"comment":"before a standard it contains 2 extra keywords (`contain` and `cover`) https://www.w3.org/TR/2011/WD-css3-images-20110908/#ltsize","syntax":"closest-side | closest-corner | farthest-side | farthest-corner | contain | cover"},"-legacy-radial-gradient-shape":{"comment":"define to double sure it doesn\'t extends in future https://www.w3.org/TR/2011/WD-css3-images-20110908/#ltshape","syntax":"circle | ellipse"},"-non-standard-font":{"comment":"non standard fonts","references":["https://webkit.org/blog/3709/using-the-system-font-in-web-content/"],"syntax":"-apple-system-body | -apple-system-headline | -apple-system-subheadline | -apple-system-caption1 | -apple-system-caption2 | -apple-system-footnote | -apple-system-short-body | -apple-system-short-headline | -apple-system-short-subheadline | -apple-system-short-caption1 | -apple-system-short-footnote | -apple-system-tall-body"},"-non-standard-color":{"comment":"non standard colors","references":["http://cssdot.ru/%D0%A1%D0%BF%D1%80%D0%B0%D0%B2%D0%BE%D1%87%D0%BD%D0%B8%D0%BA_CSS/color-i305.html","https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#Mozilla_Color_Preference_Extensions"],"syntax":"-moz-ButtonDefault | -moz-ButtonHoverFace | -moz-ButtonHoverText | -moz-CellHighlight | -moz-CellHighlightText | -moz-Combobox | -moz-ComboboxText | -moz-Dialog | -moz-DialogText | -moz-dragtargetzone | -moz-EvenTreeRow | -moz-Field | -moz-FieldText | -moz-html-CellHighlight | -moz-html-CellHighlightText | -moz-mac-accentdarkestshadow | -moz-mac-accentdarkshadow | -moz-mac-accentface | -moz-mac-accentlightesthighlight | -moz-mac-accentlightshadow | -moz-mac-accentregularhighlight | -moz-mac-accentregularshadow | -moz-mac-chrome-active | -moz-mac-chrome-inactive | -moz-mac-focusring | -moz-mac-menuselect | -moz-mac-menushadow | -moz-mac-menutextselect | -moz-MenuHover | -moz-MenuHoverText | -moz-MenuBarText | -moz-MenuBarHoverText | -moz-nativehyperlinktext | -moz-OddTreeRow | -moz-win-communicationstext | -moz-win-mediatext | -moz-activehyperlinktext | -moz-default-background-color | -moz-default-color | -moz-hyperlinktext | -moz-visitedhyperlinktext | -webkit-activelink | -webkit-focus-ring-color | -webkit-link | -webkit-text"},"-non-standard-image-rendering":{"comment":"non-standard keywords http://phrogz.net/tmp/canvas_image_zoom.html","syntax":"optimize-contrast | -moz-crisp-edges | -o-crisp-edges | -webkit-optimize-contrast"},"-non-standard-overflow":{"comment":"non-standard keywords https://developer.mozilla.org/en-US/docs/Web/CSS/overflow","syntax":"-moz-scrollbars-none | -moz-scrollbars-horizontal | -moz-scrollbars-vertical | -moz-hidden-unscrollable"},"-non-standard-width":{"comment":"non-standard keywords https://developer.mozilla.org/en-US/docs/Web/CSS/width","syntax":"fill-available | min-intrinsic | intrinsic | -moz-available | -moz-fit-content | -moz-min-content | -moz-max-content | -webkit-min-content | -webkit-max-content"},"-webkit-gradient()":{"comment":"first Apple proposal gradient syntax https://webkit.org/blog/175/introducing-css-gradients/ - TODO: simplify when after match algorithm improvement ( [, point, radius | , point] -> [, radius]? , point )","syntax":"-webkit-gradient( <-webkit-gradient-type>, <-webkit-gradient-point> [, <-webkit-gradient-point> | , <-webkit-gradient-radius>, <-webkit-gradient-point> ] [, <-webkit-gradient-radius>]? [, <-webkit-gradient-color-stop>]* )"},"-webkit-gradient-color-stop":{"comment":"first Apple proposal gradient syntax https://webkit.org/blog/175/introducing-css-gradients/","syntax":"from( <color> ) | color-stop( [ <number-zero-one> | <percentage> ] , <color> ) | to( <color> )"},"-webkit-gradient-point":{"comment":"first Apple proposal gradient syntax https://webkit.org/blog/175/introducing-css-gradients/","syntax":"[ left | center | right | <length-percentage> ] [ top | center | bottom | <length-percentage> ]"},"-webkit-gradient-radius":{"comment":"first Apple proposal gradient syntax https://webkit.org/blog/175/introducing-css-gradients/","syntax":"<length> | <percentage>"},"-webkit-gradient-type":{"comment":"first Apple proposal gradient syntax https://webkit.org/blog/175/introducing-css-gradients/","syntax":"linear | radial"},"-webkit-mask-box-repeat":{"comment":"missed; https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-mask-box-image","syntax":"repeat | stretch | round"},"-webkit-mask-clip-style":{"comment":"missed; there is no enough information about `-webkit-mask-clip` property, but looks like all those keywords are working","syntax":"border | border-box | padding | padding-box | content | content-box | text"},"-ms-filter-function-list":{"comment":"https://developer.mozilla.org/en-US/docs/Web/CSS/-ms-filter","syntax":"<-ms-filter-function>+"},"-ms-filter-function":{"comment":"https://developer.mozilla.org/en-US/docs/Web/CSS/-ms-filter","syntax":"<-ms-filter-function-progid> | <-ms-filter-function-legacy>"},"-ms-filter-function-progid":{"comment":"https://developer.mozilla.org/en-US/docs/Web/CSS/-ms-filter","syntax":"\'progid:\' [ <ident-token> \'.\' ]* [ <ident-token> | <function-token> <any-value>? ) ]"},"-ms-filter-function-legacy":{"comment":"https://developer.mozilla.org/en-US/docs/Web/CSS/-ms-filter","syntax":"<ident-token> | <function-token> <any-value>? )"},"-ms-filter":{"syntax":"<string>"},"age":{"comment":"https://www.w3.org/TR/css3-speech/#voice-family","syntax":"child | young | old"},"attr-name":{"syntax":"<wq-name>"},"attr-fallback":{"syntax":"<any-value>"},"border-radius":{"comment":"missed, https://drafts.csswg.org/css-backgrounds-3/#the-border-radius","syntax":"<length-percentage>{1,2}"},"bottom":{"comment":"missed; not sure we should add it, but no others except `shape` is using it so it\'s ok for now; https://drafts.fxtf.org/css-masking-1/#funcdef-clip-rect","syntax":"<length> | auto"},"content-list":{"comment":"missed -> https://drafts.csswg.org/css-content/#typedef-content-list (document-url, <target> and leader() is omitted util stabilization)","syntax":"[ <string> | contents | <image> | <quote> | <target> | <leader()> | <attr()> | counter( <ident>, <\'list-style-type\'>? ) ]+"},"element()":{"comment":"https://drafts.csswg.org/css-gcpm/#element-syntax & https://drafts.csswg.org/css-images-4/#element-notation","syntax":"element( <custom-ident> , [ first | start | last | first-except ]? ) | element( <id-selector> )"},"generic-voice":{"comment":"https://www.w3.org/TR/css3-speech/#voice-family","syntax":"[ <age>? <gender> <integer>? ]"},"gender":{"comment":"https://www.w3.org/TR/css3-speech/#voice-family","syntax":"male | female | neutral"},"generic-family":{"comment":"added -apple-system","references":["https://webkit.org/blog/3709/using-the-system-font-in-web-content/"],"syntax":"| -apple-system"},"gradient":{"comment":"added legacy syntaxes support","syntax":"| <-legacy-gradient>"},"left":{"comment":"missed; not sure we should add it, but no others except `shape` is using it so it\'s ok for now; https://drafts.fxtf.org/css-masking-1/#funcdef-clip-rect","syntax":"<length> | auto"},"mask-image":{"comment":"missed; https://drafts.fxtf.org/css-masking-1/#the-mask-image","syntax":"<mask-reference>#"},"name-repeat":{"comment":"missed, and looks like obsolete, keep it as is since other property syntaxes should be changed too; https://www.w3.org/TR/2015/WD-css-grid-1-20150917/#typedef-name-repeat","syntax":"repeat( [ <positive-integer> | auto-fill ], <line-names>+)"},"named-color":{"comment":"added non standard color names","syntax":"| <-non-standard-color>"},"paint":{"comment":"used by SVG https://www.w3.org/TR/SVG/painting.html#SpecifyingPaint","syntax":"none | <color> | <url> [ none | <color> ]? | context-fill | context-stroke"},"page-size":{"comment":"https://www.w3.org/TR/css-page-3/#typedef-page-size-page-size","syntax":"A5 | A4 | A3 | B5 | B4 | JIS-B5 | JIS-B4 | letter | legal | ledger"},"ratio":{"comment":"missed, https://drafts.csswg.org/mediaqueries-4/#typedef-ratio","syntax":"<integer> / <integer>"},"right":{"comment":"missed; not sure we should add it, but no others except `shape` is using it so it\'s ok for now; https://drafts.fxtf.org/css-masking-1/#funcdef-clip-rect","syntax":"<length> | auto"},"shape":{"comment":"missed spaces in function body and add backwards compatible syntax","syntax":"rect( <top>, <right>, <bottom>, <left> ) | rect( <top> <right> <bottom> <left> )"},"svg-length":{"comment":"All coordinates and lengths in SVG can be specified with or without a unit identifier","references":["https://www.w3.org/TR/SVG11/coords.html#Units"],"syntax":"<percentage> | <length> | <number>"},"svg-writing-mode":{"comment":"SVG specific keywords (deprecated for CSS)","references":["https://developer.mozilla.org/en/docs/Web/CSS/writing-mode","https://www.w3.org/TR/SVG/text.html#WritingModeProperty"],"syntax":"lr-tb | rl-tb | tb-rl | lr | rl | tb"},"top":{"comment":"missed; not sure we should add it, but no others except `shape` is using it so it\'s ok for now; https://drafts.fxtf.org/css-masking-1/#funcdef-clip-rect","syntax":"<length> | auto"},"track-group":{"comment":"used by old grid-columns and grid-rows syntax v0","syntax":"\'(\' [ <string>* <track-minmax> <string>* ]+ \')\' [ \'[\' <positive-integer> \']\' ]? | <track-minmax>"},"track-list-v0":{"comment":"used by old grid-columns and grid-rows syntax v0","syntax":"[ <string>* <track-group> <string>* ]+ | none"},"track-minmax":{"comment":"used by old grid-columns and grid-rows syntax v0","syntax":"minmax( <track-breadth> , <track-breadth> ) | auto | <track-breadth> | fit-content"},"x":{"comment":"missed; not sure we should add it, but no others except `cursor` is using it so it\'s ok for now; https://drafts.csswg.org/css-ui-3/#cursor","syntax":"<number>"},"y":{"comment":"missed; not sure we should add it, but no others except `cursor` is using so it\'s ok for now; https://drafts.csswg.org/css-ui-3/#cursor","syntax":"<number>"},"declaration":{"comment":"missed, restored by https://drafts.csswg.org/css-syntax","syntax":"<ident-token> : <declaration-value>? [ \'!\' important ]?"},"declaration-list":{"comment":"missed, restored by https://drafts.csswg.org/css-syntax","syntax":"[ <declaration>? \';\' ]* <declaration>?"},"url":{"comment":"https://drafts.csswg.org/css-values-4/#urls","syntax":"url( <string> <url-modifier>* ) | <url-token>"},"url-modifier":{"comment":"https://drafts.csswg.org/css-values-4/#typedef-url-modifier","syntax":"<ident> | <function-token> <any-value> )"},"number-zero-one":{"syntax":"<number [0,1]>"},"number-one-or-greater":{"syntax":"<number [1,∞]>"},"positive-integer":{"syntax":"<integer [0,∞]>"},"-non-standard-display":{"syntax":"-ms-inline-flexbox | -ms-grid | -ms-inline-grid | -webkit-flex | -webkit-inline-flex | -webkit-box | -webkit-inline-box | -moz-inline-stack | -moz-box | -moz-inline-box"}}}');

/***/ }),

/***/ "./node_modules/css-tree/package.json":
/*!********************************************!*\
  !*** ./node_modules/css-tree/package.json ***!
  \********************************************/
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"name":"css-tree","version":"1.1.3","description":"A tool set for CSS: fast detailed parser (CSS → AST), walker (AST traversal), generator (AST → CSS) and lexer (validation and matching) based on specs and browser implementations","author":"Roman Dvornov <rdvornov@gmail.com> (https://github.com/lahmatiy)","license":"MIT","repository":"csstree/csstree","keywords":["css","ast","tokenizer","parser","walker","lexer","generator","utils","syntax","validation"],"main":"lib/index.js","unpkg":"dist/csstree.min.js","jsdelivr":"dist/csstree.min.js","scripts":{"build":"rollup --config","lint":"eslint data lib scripts test && node scripts/review-syntax-patch --lint && node scripts/update-docs --lint","lint-and-test":"npm run lint && npm test","update:docs":"node scripts/update-docs","review:syntax-patch":"node scripts/review-syntax-patch","test":"mocha --reporter progress","coverage":"nyc npm test","travis":"nyc npm run lint-and-test && npm run coveralls","coveralls":"nyc report --reporter=text-lcov | coveralls","prepublishOnly":"npm run build","hydrogen":"node --trace-hydrogen --trace-phase=Z --trace-deopt --code-comments --hydrogen-track-positions --redirect-code-traces --redirect-code-traces-to=code.asm --trace_hydrogen_file=code.cfg --print-opt-code bin/parse --stat -o /dev/null"},"dependencies":{"mdn-data":"2.0.14","source-map":"^0.6.1"},"devDependencies":{"@rollup/plugin-commonjs":"^11.0.2","@rollup/plugin-json":"^4.0.2","@rollup/plugin-node-resolve":"^7.1.1","coveralls":"^3.0.9","eslint":"^6.8.0","json-to-ast":"^2.1.0","mocha":"^6.2.3","nyc":"^14.1.1","rollup":"^1.32.1","rollup-plugin-terser":"^5.3.0"},"engines":{"node":">=8.0.0"},"files":["data","dist","lib"]}');

/***/ }),

/***/ "./node_modules/grapheme-breaker/src/classes.json":
/*!********************************************************!*\
  !*** ./node_modules/grapheme-breaker/src/classes.json ***!
  \********************************************************/
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"Other":0,"CR":1,"LF":2,"Control":3,"Extend":4,"Regional_Indicator":5,"SpacingMark":6,"L":7,"V":8,"T":9,"LV":10,"LVT":11}');

/***/ }),

/***/ "./node_modules/mdn-data/css/at-rules.json":
/*!*************************************************!*\
  !*** ./node_modules/mdn-data/css/at-rules.json ***!
  \*************************************************/
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"@charset":{"syntax":"@charset \\"<charset>\\";","groups":["CSS Charsets"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/@charset"},"@counter-style":{"syntax":"@counter-style <counter-style-name> {\\n  [ system: <counter-system>; ] ||\\n  [ symbols: <counter-symbols>; ] ||\\n  [ additive-symbols: <additive-symbols>; ] ||\\n  [ negative: <negative-symbol>; ] ||\\n  [ prefix: <prefix>; ] ||\\n  [ suffix: <suffix>; ] ||\\n  [ range: <range>; ] ||\\n  [ pad: <padding>; ] ||\\n  [ speak-as: <speak-as>; ] ||\\n  [ fallback: <counter-style-name>; ]\\n}","interfaces":["CSSCounterStyleRule"],"groups":["CSS Counter Styles"],"descriptors":{"additive-symbols":{"syntax":"[ <integer> && <symbol> ]#","media":"all","initial":"n/a (required)","percentages":"no","computed":"asSpecified","order":"orderOfAppearance","status":"standard"},"fallback":{"syntax":"<counter-style-name>","media":"all","initial":"decimal","percentages":"no","computed":"asSpecified","order":"uniqueOrder","status":"standard"},"negative":{"syntax":"<symbol> <symbol>?","media":"all","initial":"\\"-\\" hyphen-minus","percentages":"no","computed":"asSpecified","order":"orderOfAppearance","status":"standard"},"pad":{"syntax":"<integer> && <symbol>","media":"all","initial":"0 \\"\\"","percentages":"no","computed":"asSpecified","order":"uniqueOrder","status":"standard"},"prefix":{"syntax":"<symbol>","media":"all","initial":"\\"\\"","percentages":"no","computed":"asSpecified","order":"uniqueOrder","status":"standard"},"range":{"syntax":"[ [ <integer> | infinite ]{2} ]# | auto","media":"all","initial":"auto","percentages":"no","computed":"asSpecified","order":"orderOfAppearance","status":"standard"},"speak-as":{"syntax":"auto | bullets | numbers | words | spell-out | <counter-style-name>","media":"all","initial":"auto","percentages":"no","computed":"asSpecified","order":"uniqueOrder","status":"standard"},"suffix":{"syntax":"<symbol>","media":"all","initial":"\\". \\"","percentages":"no","computed":"asSpecified","order":"uniqueOrder","status":"standard"},"symbols":{"syntax":"<symbol>+","media":"all","initial":"n/a (required)","percentages":"no","computed":"asSpecified","order":"orderOfAppearance","status":"standard"},"system":{"syntax":"cyclic | numeric | alphabetic | symbolic | additive | [ fixed <integer>? ] | [ extends <counter-style-name> ]","media":"all","initial":"symbolic","percentages":"no","computed":"asSpecified","order":"uniqueOrder","status":"standard"}},"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/@counter-style"},"@document":{"syntax":"@document [ <url> | url-prefix(<string>) | domain(<string>) | media-document(<string>) | regexp(<string>) ]# {\\n  <group-rule-body>\\n}","interfaces":["CSSGroupingRule","CSSConditionRule"],"groups":["CSS Conditional Rules"],"status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/@document"},"@font-face":{"syntax":"@font-face {\\n  [ font-family: <family-name>; ] ||\\n  [ src: <src>; ] ||\\n  [ unicode-range: <unicode-range>; ] ||\\n  [ font-variant: <font-variant>; ] ||\\n  [ font-feature-settings: <font-feature-settings>; ] ||\\n  [ font-variation-settings: <font-variation-settings>; ] ||\\n  [ font-stretch: <font-stretch>; ] ||\\n  [ font-weight: <font-weight>; ] ||\\n  [ font-style: <font-style>; ]\\n}","interfaces":["CSSFontFaceRule"],"groups":["CSS Fonts"],"descriptors":{"font-display":{"syntax":"[ auto | block | swap | fallback | optional ]","media":"visual","percentages":"no","initial":"auto","computed":"asSpecified","order":"uniqueOrder","status":"experimental"},"font-family":{"syntax":"<family-name>","media":"all","initial":"n/a (required)","percentages":"no","computed":"asSpecified","order":"uniqueOrder","status":"standard"},"font-feature-settings":{"syntax":"normal | <feature-tag-value>#","media":"all","initial":"normal","percentages":"no","computed":"asSpecified","order":"orderOfAppearance","status":"standard"},"font-variation-settings":{"syntax":"normal | [ <string> <number> ]#","media":"all","initial":"normal","percentages":"no","computed":"asSpecified","order":"orderOfAppearance","status":"standard"},"font-stretch":{"syntax":"<font-stretch-absolute>{1,2}","media":"all","initial":"normal","percentages":"no","computed":"asSpecified","order":"uniqueOrder","status":"standard"},"font-style":{"syntax":"normal | italic | oblique <angle>{0,2}","media":"all","initial":"normal","percentages":"no","computed":"asSpecified","order":"uniqueOrder","status":"standard"},"font-weight":{"syntax":"<font-weight-absolute>{1,2}","media":"all","initial":"normal","percentages":"no","computed":"asSpecified","order":"uniqueOrder","status":"standard"},"font-variant":{"syntax":"normal | none | [ <common-lig-values> || <discretionary-lig-values> || <historical-lig-values> || <contextual-alt-values> || stylistic(<feature-value-name>) || historical-forms || styleset(<feature-value-name>#) || character-variant(<feature-value-name>#) || swash(<feature-value-name>) || ornaments(<feature-value-name>) || annotation(<feature-value-name>) || [ small-caps | all-small-caps | petite-caps | all-petite-caps | unicase | titling-caps ] || <numeric-figure-values> || <numeric-spacing-values> || <numeric-fraction-values> || ordinal || slashed-zero || <east-asian-variant-values> || <east-asian-width-values> || ruby ]","media":"all","initial":"normal","percentages":"no","computed":"asSpecified","order":"orderOfAppearance","status":"standard"},"src":{"syntax":"[ <url> [ format( <string># ) ]? | local( <family-name> ) ]#","media":"all","initial":"n/a (required)","percentages":"no","computed":"asSpecified","order":"orderOfAppearance","status":"standard"},"unicode-range":{"syntax":"<unicode-range>#","media":"all","initial":"U+0-10FFFF","percentages":"no","computed":"asSpecified","order":"orderOfAppearance","status":"standard"}},"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/@font-face"},"@font-feature-values":{"syntax":"@font-feature-values <family-name># {\\n  <feature-value-block-list>\\n}","interfaces":["CSSFontFeatureValuesRule"],"groups":["CSS Fonts"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/@font-feature-values"},"@import":{"syntax":"@import [ <string> | <url> ] [ <media-query-list> ]?;","groups":["Media Queries"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/@import"},"@keyframes":{"syntax":"@keyframes <keyframes-name> {\\n  <keyframe-block-list>\\n}","interfaces":["CSSKeyframeRule","CSSKeyframesRule"],"groups":["CSS Animations"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/@keyframes"},"@media":{"syntax":"@media <media-query-list> {\\n  <group-rule-body>\\n}","interfaces":["CSSGroupingRule","CSSConditionRule","CSSMediaRule","CSSCustomMediaRule"],"groups":["CSS Conditional Rules","Media Queries"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/@media"},"@namespace":{"syntax":"@namespace <namespace-prefix>? [ <string> | <url> ];","groups":["CSS Namespaces"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/@namespace"},"@page":{"syntax":"@page <page-selector-list> {\\n  <page-body>\\n}","interfaces":["CSSPageRule"],"groups":["CSS Pages"],"descriptors":{"bleed":{"syntax":"auto | <length>","media":["visual","paged"],"initial":"auto","percentages":"no","computed":"asSpecified","order":"uniqueOrder","status":"standard"},"marks":{"syntax":"none | [ crop || cross ]","media":["visual","paged"],"initial":"none","percentages":"no","computed":"asSpecified","order":"orderOfAppearance","status":"standard"},"size":{"syntax":"<length>{1,2} | auto | [ <page-size> || [ portrait | landscape ] ]","media":["visual","paged"],"initial":"auto","percentages":"no","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"orderOfAppearance","status":"standard"}},"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/@page"},"@property":{"syntax":"@property <custom-property-name> {\\n  <declaration-list>\\n}","interfaces":["CSS","CSSPropertyRule"],"groups":["CSS Houdini"],"descriptors":{"syntax":{"syntax":"<string>","media":"all","percentages":"no","initial":"n/a (required)","computed":"asSpecified","order":"uniqueOrder","status":"experimental"},"inherits":{"syntax":"true | false","media":"all","percentages":"no","initial":"auto","computed":"asSpecified","order":"uniqueOrder","status":"experimental"},"initial-value":{"syntax":"<string>","media":"all","initial":"n/a (required)","percentages":"no","computed":"asSpecified","order":"uniqueOrder","status":"experimental"}},"status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/@property"},"@supports":{"syntax":"@supports <supports-condition> {\\n  <group-rule-body>\\n}","interfaces":["CSSGroupingRule","CSSConditionRule","CSSSupportsRule"],"groups":["CSS Conditional Rules"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/@supports"},"@viewport":{"syntax":"@viewport {\\n  <group-rule-body>\\n}","interfaces":["CSSViewportRule"],"groups":["CSS Device Adaptation"],"descriptors":{"height":{"syntax":"<viewport-length>{1,2}","media":["visual","continuous"],"initial":["min-height","max-height"],"percentages":["min-height","max-height"],"computed":["min-height","max-height"],"order":"orderOfAppearance","status":"standard"},"max-height":{"syntax":"<viewport-length>","media":["visual","continuous"],"initial":"auto","percentages":"referToHeightOfInitialViewport","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard"},"max-width":{"syntax":"<viewport-length>","media":["visual","continuous"],"initial":"auto","percentages":"referToWidthOfInitialViewport","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard"},"max-zoom":{"syntax":"auto | <number> | <percentage>","media":["visual","continuous"],"initial":"auto","percentages":"the zoom factor itself","computed":"autoNonNegativeOrPercentage","order":"uniqueOrder","status":"standard"},"min-height":{"syntax":"<viewport-length>","media":["visual","continuous"],"initial":"auto","percentages":"referToHeightOfInitialViewport","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard"},"min-width":{"syntax":"<viewport-length>","media":["visual","continuous"],"initial":"auto","percentages":"referToWidthOfInitialViewport","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard"},"min-zoom":{"syntax":"auto | <number> | <percentage>","media":["visual","continuous"],"initial":"auto","percentages":"the zoom factor itself","computed":"autoNonNegativeOrPercentage","order":"uniqueOrder","status":"standard"},"orientation":{"syntax":"auto | portrait | landscape","media":["visual","continuous"],"initial":"auto","percentages":"referToSizeOfBoundingBox","computed":"asSpecified","order":"uniqueOrder","status":"standard"},"user-zoom":{"syntax":"zoom | fixed","media":["visual","continuous"],"initial":"zoom","percentages":"referToSizeOfBoundingBox","computed":"asSpecified","order":"uniqueOrder","status":"standard"},"viewport-fit":{"syntax":"auto | contain | cover","media":["visual","continuous"],"initial":"auto","percentages":"no","computed":"asSpecified","order":"uniqueOrder","status":"standard"},"width":{"syntax":"<viewport-length>{1,2}","media":["visual","continuous"],"initial":["min-width","max-width"],"percentages":["min-width","max-width"],"computed":["min-width","max-width"],"order":"orderOfAppearance","status":"standard"},"zoom":{"syntax":"auto | <number> | <percentage>","media":["visual","continuous"],"initial":"auto","percentages":"the zoom factor itself","computed":"autoNonNegativeOrPercentage","order":"uniqueOrder","status":"standard"}},"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/@viewport"}}');

/***/ }),

/***/ "./node_modules/mdn-data/css/properties.json":
/*!***************************************************!*\
  !*** ./node_modules/mdn-data/css/properties.json ***!
  \***************************************************/
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"--*":{"syntax":"<declaration-value>","media":"all","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Variables"],"initial":"seeProse","appliesto":"allElements","computed":"asSpecifiedWithVarsSubstituted","order":"perGrammar","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/--*"},"-ms-accelerator":{"syntax":"false | true","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"false","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-accelerator"},"-ms-block-progression":{"syntax":"tb | rl | bt | lr","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"tb","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-block-progression"},"-ms-content-zoom-chaining":{"syntax":"none | chained","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"none","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-content-zoom-chaining"},"-ms-content-zooming":{"syntax":"none | zoom","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"zoomForTheTopLevelNoneForTheRest","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-content-zooming"},"-ms-content-zoom-limit":{"syntax":"<\'-ms-content-zoom-limit-min\'> <\'-ms-content-zoom-limit-max\'>","media":"interactive","inherited":false,"animationType":"discrete","percentages":["-ms-content-zoom-limit-max","-ms-content-zoom-limit-min"],"groups":["Microsoft Extensions"],"initial":["-ms-content-zoom-limit-max","-ms-content-zoom-limit-min"],"appliesto":"nonReplacedBlockAndInlineBlockElements","computed":["-ms-content-zoom-limit-max","-ms-content-zoom-limit-min"],"order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-content-zoom-limit"},"-ms-content-zoom-limit-max":{"syntax":"<percentage>","media":"interactive","inherited":false,"animationType":"discrete","percentages":"maxZoomFactor","groups":["Microsoft Extensions"],"initial":"400%","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-content-zoom-limit-max"},"-ms-content-zoom-limit-min":{"syntax":"<percentage>","media":"interactive","inherited":false,"animationType":"discrete","percentages":"minZoomFactor","groups":["Microsoft Extensions"],"initial":"100%","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-content-zoom-limit-min"},"-ms-content-zoom-snap":{"syntax":"<\'-ms-content-zoom-snap-type\'> || <\'-ms-content-zoom-snap-points\'>","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":["-ms-content-zoom-snap-type","-ms-content-zoom-snap-points"],"appliesto":"nonReplacedBlockAndInlineBlockElements","computed":["-ms-content-zoom-snap-type","-ms-content-zoom-snap-points"],"order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-content-zoom-snap"},"-ms-content-zoom-snap-points":{"syntax":"snapInterval( <percentage>, <percentage> ) | snapList( <percentage># )","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"snapInterval(0%, 100%)","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-content-zoom-snap-points"},"-ms-content-zoom-snap-type":{"syntax":"none | proximity | mandatory","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"none","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-content-zoom-snap-type"},"-ms-filter":{"syntax":"<string>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"\\"\\"","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-filter"},"-ms-flow-from":{"syntax":"[ none | <custom-ident> ]#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"none","appliesto":"nonReplacedElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-flow-from"},"-ms-flow-into":{"syntax":"[ none | <custom-ident> ]#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"none","appliesto":"iframeElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-flow-into"},"-ms-grid-columns":{"syntax":"none | <track-list> | <auto-track-list>","media":"visual","inherited":false,"animationType":"simpleListOfLpcDifferenceLpc","percentages":"referToDimensionOfContentArea","groups":["CSS Grid Layout"],"initial":"none","appliesto":"gridContainers","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-grid-columns"},"-ms-grid-rows":{"syntax":"none | <track-list> | <auto-track-list>","media":"visual","inherited":false,"animationType":"simpleListOfLpcDifferenceLpc","percentages":"referToDimensionOfContentArea","groups":["CSS Grid Layout"],"initial":"none","appliesto":"gridContainers","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-grid-rows"},"-ms-high-contrast-adjust":{"syntax":"auto | none","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-high-contrast-adjust"},"-ms-hyphenate-limit-chars":{"syntax":"auto | <integer>{1,3}","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-hyphenate-limit-chars"},"-ms-hyphenate-limit-lines":{"syntax":"no-limit | <integer>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"no-limit","appliesto":"blockContainerElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-hyphenate-limit-lines"},"-ms-hyphenate-limit-zone":{"syntax":"<percentage> | <length>","media":"visual","inherited":true,"animationType":"discrete","percentages":"referToLineBoxWidth","groups":["Microsoft Extensions"],"initial":"0","appliesto":"blockContainerElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-hyphenate-limit-zone"},"-ms-ime-align":{"syntax":"auto | after","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-ime-align"},"-ms-overflow-style":{"syntax":"auto | none | scrollbar | -ms-autohiding-scrollbar","media":"interactive","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"auto","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-overflow-style"},"-ms-scrollbar-3dlight-color":{"syntax":"<color>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"dependsOnUserAgent","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scrollbar-3dlight-color"},"-ms-scrollbar-arrow-color":{"syntax":"<color>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"ButtonText","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scrollbar-arrow-color"},"-ms-scrollbar-base-color":{"syntax":"<color>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"dependsOnUserAgent","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scrollbar-base-color"},"-ms-scrollbar-darkshadow-color":{"syntax":"<color>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"ThreeDDarkShadow","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scrollbar-darkshadow-color"},"-ms-scrollbar-face-color":{"syntax":"<color>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"ThreeDFace","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scrollbar-face-color"},"-ms-scrollbar-highlight-color":{"syntax":"<color>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"ThreeDHighlight","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scrollbar-highlight-color"},"-ms-scrollbar-shadow-color":{"syntax":"<color>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"ThreeDDarkShadow","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scrollbar-shadow-color"},"-ms-scrollbar-track-color":{"syntax":"<color>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"Scrollbar","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scrollbar-track-color"},"-ms-scroll-chaining":{"syntax":"chained | none","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"chained","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scroll-chaining"},"-ms-scroll-limit":{"syntax":"<\'-ms-scroll-limit-x-min\'> <\'-ms-scroll-limit-y-min\'> <\'-ms-scroll-limit-x-max\'> <\'-ms-scroll-limit-y-max\'>","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":["-ms-scroll-limit-x-min","-ms-scroll-limit-y-min","-ms-scroll-limit-x-max","-ms-scroll-limit-y-max"],"appliesto":"nonReplacedBlockAndInlineBlockElements","computed":["-ms-scroll-limit-x-min","-ms-scroll-limit-y-min","-ms-scroll-limit-x-max","-ms-scroll-limit-y-max"],"order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scroll-limit"},"-ms-scroll-limit-x-max":{"syntax":"auto | <length>","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"auto","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scroll-limit-x-max"},"-ms-scroll-limit-x-min":{"syntax":"<length>","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"0","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scroll-limit-x-min"},"-ms-scroll-limit-y-max":{"syntax":"auto | <length>","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"auto","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scroll-limit-y-max"},"-ms-scroll-limit-y-min":{"syntax":"<length>","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"0","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scroll-limit-y-min"},"-ms-scroll-rails":{"syntax":"none | railed","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"railed","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scroll-rails"},"-ms-scroll-snap-points-x":{"syntax":"snapInterval( <length-percentage>, <length-percentage> ) | snapList( <length-percentage># )","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"snapInterval(0px, 100%)","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scroll-snap-points-x"},"-ms-scroll-snap-points-y":{"syntax":"snapInterval( <length-percentage>, <length-percentage> ) | snapList( <length-percentage># )","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"snapInterval(0px, 100%)","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scroll-snap-points-y"},"-ms-scroll-snap-type":{"syntax":"none | proximity | mandatory","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"none","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scroll-snap-type"},"-ms-scroll-snap-x":{"syntax":"<\'-ms-scroll-snap-type\'> <\'-ms-scroll-snap-points-x\'>","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":["-ms-scroll-snap-type","-ms-scroll-snap-points-x"],"appliesto":"nonReplacedBlockAndInlineBlockElements","computed":["-ms-scroll-snap-type","-ms-scroll-snap-points-x"],"order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scroll-snap-x"},"-ms-scroll-snap-y":{"syntax":"<\'-ms-scroll-snap-type\'> <\'-ms-scroll-snap-points-y\'>","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":["-ms-scroll-snap-type","-ms-scroll-snap-points-y"],"appliesto":"nonReplacedBlockAndInlineBlockElements","computed":["-ms-scroll-snap-type","-ms-scroll-snap-points-y"],"order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scroll-snap-y"},"-ms-scroll-translation":{"syntax":"none | vertical-to-horizontal","media":"interactive","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-scroll-translation"},"-ms-text-autospace":{"syntax":"none | ideograph-alpha | ideograph-numeric | ideograph-parenthesis | ideograph-space","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-text-autospace"},"-ms-touch-select":{"syntax":"grippers | none","media":"interactive","inherited":true,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"grippers","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-touch-select"},"-ms-user-select":{"syntax":"none | element | text","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"text","appliesto":"nonReplacedElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-user-select"},"-ms-wrap-flow":{"syntax":"auto | both | start | end | maximum | clear","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"auto","appliesto":"blockLevelElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-wrap-flow"},"-ms-wrap-margin":{"syntax":"<length>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"0","appliesto":"exclusionElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-wrap-margin"},"-ms-wrap-through":{"syntax":"wrap | none","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Microsoft Extensions"],"initial":"wrap","appliesto":"blockLevelElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-ms-wrap-through"},"-moz-appearance":{"syntax":"none | button | button-arrow-down | button-arrow-next | button-arrow-previous | button-arrow-up | button-bevel | button-focus | caret | checkbox | checkbox-container | checkbox-label | checkmenuitem | dualbutton | groupbox | listbox | listitem | menuarrow | menubar | menucheckbox | menuimage | menuitem | menuitemtext | menulist | menulist-button | menulist-text | menulist-textfield | menupopup | menuradio | menuseparator | meterbar | meterchunk | progressbar | progressbar-vertical | progresschunk | progresschunk-vertical | radio | radio-container | radio-label | radiomenuitem | range | range-thumb | resizer | resizerpanel | scale-horizontal | scalethumbend | scalethumb-horizontal | scalethumbstart | scalethumbtick | scalethumb-vertical | scale-vertical | scrollbarbutton-down | scrollbarbutton-left | scrollbarbutton-right | scrollbarbutton-up | scrollbarthumb-horizontal | scrollbarthumb-vertical | scrollbartrack-horizontal | scrollbartrack-vertical | searchfield | separator | sheet | spinner | spinner-downbutton | spinner-textfield | spinner-upbutton | splitter | statusbar | statusbarpanel | tab | tabpanel | tabpanels | tab-scroll-arrow-back | tab-scroll-arrow-forward | textfield | textfield-multiline | toolbar | toolbarbutton | toolbarbutton-dropdown | toolbargripper | toolbox | tooltip | treeheader | treeheadercell | treeheadersortarrow | treeitem | treeline | treetwisty | treetwistyopen | treeview | -moz-mac-unified-toolbar | -moz-win-borderless-glass | -moz-win-browsertabbar-toolbox | -moz-win-communicationstext | -moz-win-communications-toolbox | -moz-win-exclude-glass | -moz-win-glass | -moz-win-mediatext | -moz-win-media-toolbox | -moz-window-button-box | -moz-window-button-box-maximized | -moz-window-button-close | -moz-window-button-maximize | -moz-window-button-minimize | -moz-window-button-restore | -moz-window-frame-bottom | -moz-window-frame-left | -moz-window-frame-right | -moz-window-titlebar | -moz-window-titlebar-maximized","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions","WebKit Extensions"],"initial":"noneButOverriddenInUserAgentCSS","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/appearance"},"-moz-binding":{"syntax":"<url> | none","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"none","appliesto":"allElementsExceptGeneratedContentOrPseudoElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-binding"},"-moz-border-bottom-colors":{"syntax":"<color>+ | none","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-border-bottom-colors"},"-moz-border-left-colors":{"syntax":"<color>+ | none","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-border-left-colors"},"-moz-border-right-colors":{"syntax":"<color>+ | none","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-border-right-colors"},"-moz-border-top-colors":{"syntax":"<color>+ | none","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-border-top-colors"},"-moz-context-properties":{"syntax":"none | [ fill | fill-opacity | stroke | stroke-opacity ]#","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"none","appliesto":"allElementsThatCanReferenceImages","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-context-properties"},"-moz-float-edge":{"syntax":"border-box | content-box | margin-box | padding-box","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"content-box","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-float-edge"},"-moz-force-broken-image-icon":{"syntax":"<integer [0,1]>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"0","appliesto":"images","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-force-broken-image-icon"},"-moz-image-region":{"syntax":"<shape> | auto","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"auto","appliesto":"xulImageElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-image-region"},"-moz-orient":{"syntax":"inline | block | horizontal | vertical","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"inline","appliesto":"anyElementEffectOnProgressAndMeter","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-orient"},"-moz-outline-radius":{"syntax":"<outline-radius>{1,4} [ / <outline-radius>{1,4} ]?","media":"visual","inherited":false,"animationType":["-moz-outline-radius-topleft","-moz-outline-radius-topright","-moz-outline-radius-bottomright","-moz-outline-radius-bottomleft"],"percentages":["-moz-outline-radius-topleft","-moz-outline-radius-topright","-moz-outline-radius-bottomright","-moz-outline-radius-bottomleft"],"groups":["Mozilla Extensions"],"initial":["-moz-outline-radius-topleft","-moz-outline-radius-topright","-moz-outline-radius-bottomright","-moz-outline-radius-bottomleft"],"appliesto":"allElements","computed":["-moz-outline-radius-topleft","-moz-outline-radius-topright","-moz-outline-radius-bottomright","-moz-outline-radius-bottomleft"],"order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-outline-radius"},"-moz-outline-radius-bottomleft":{"syntax":"<outline-radius>","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfBorderBox","groups":["Mozilla Extensions"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-outline-radius-bottomleft"},"-moz-outline-radius-bottomright":{"syntax":"<outline-radius>","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfBorderBox","groups":["Mozilla Extensions"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-outline-radius-bottomright"},"-moz-outline-radius-topleft":{"syntax":"<outline-radius>","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfBorderBox","groups":["Mozilla Extensions"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-outline-radius-topleft"},"-moz-outline-radius-topright":{"syntax":"<outline-radius>","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfBorderBox","groups":["Mozilla Extensions"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-outline-radius-topright"},"-moz-stack-sizing":{"syntax":"ignore | stretch-to-fit","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"stretch-to-fit","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-stack-sizing"},"-moz-text-blink":{"syntax":"none | blink","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-text-blink"},"-moz-user-focus":{"syntax":"ignore | normal | select-after | select-before | select-menu | select-same | select-all | none","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-user-focus"},"-moz-user-input":{"syntax":"auto | none | enabled | disabled","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-user-input"},"-moz-user-modify":{"syntax":"read-only | read-write | write-only","media":"interactive","inherited":true,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"read-only","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-user-modify"},"-moz-window-dragging":{"syntax":"drag | no-drag","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"drag","appliesto":"allElementsCreatingNativeWindows","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-window-dragging"},"-moz-window-shadow":{"syntax":"default | menu | tooltip | sheet | none","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"default","appliesto":"allElementsCreatingNativeWindows","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-moz-window-shadow"},"-webkit-appearance":{"syntax":"none | button | button-bevel | caret | checkbox | default-button | inner-spin-button | listbox | listitem | media-controls-background | media-controls-fullscreen-background | media-current-time-display | media-enter-fullscreen-button | media-exit-fullscreen-button | media-fullscreen-button | media-mute-button | media-overlay-play-button | media-play-button | media-seek-back-button | media-seek-forward-button | media-slider | media-sliderthumb | media-time-remaining-display | media-toggle-closed-captions-button | media-volume-slider | media-volume-slider-container | media-volume-sliderthumb | menulist | menulist-button | menulist-text | menulist-textfield | meter | progress-bar | progress-bar-value | push-button | radio | searchfield | searchfield-cancel-button | searchfield-decoration | searchfield-results-button | searchfield-results-decoration | slider-horizontal | slider-vertical | sliderthumb-horizontal | sliderthumb-vertical | square-button | textarea | textfield | -apple-pay-button","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"noneButOverriddenInUserAgentCSS","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/appearance"},"-webkit-border-before":{"syntax":"<\'border-width\'> || <\'border-style\'> || <\'color\'>","media":"visual","inherited":true,"animationType":"discrete","percentages":["-webkit-border-before-width"],"groups":["WebKit Extensions"],"initial":["border-width","border-style","color"],"appliesto":"allElements","computed":["border-width","border-style","color"],"order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-border-before"},"-webkit-border-before-color":{"syntax":"<\'color\'>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","status":"nonstandard"},"-webkit-border-before-style":{"syntax":"<\'border-style\'>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard"},"-webkit-border-before-width":{"syntax":"<\'border-width\'>","media":"visual","inherited":true,"animationType":"discrete","percentages":"logicalWidthOfContainingBlock","groups":["WebKit Extensions"],"initial":"medium","appliesto":"allElements","computed":"absoluteLengthZeroIfBorderStyleNoneOrHidden","order":"uniqueOrder","status":"nonstandard"},"-webkit-box-reflect":{"syntax":"[ above | below | right | left ]? <length>? <image>?","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-box-reflect"},"-webkit-line-clamp":{"syntax":"none | <integer>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"no","groups":["WebKit Extensions","CSS Overflow"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-line-clamp"},"-webkit-mask":{"syntax":"[ <mask-reference> || <position> [ / <bg-size> ]? || <repeat-style> || [ <box> | border | padding | content | text ] || [ <box> | border | padding | content ] ]#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":["-webkit-mask-image","-webkit-mask-repeat","-webkit-mask-attachment","-webkit-mask-position","-webkit-mask-origin","-webkit-mask-clip"],"appliesto":"allElements","computed":["-webkit-mask-image","-webkit-mask-repeat","-webkit-mask-attachment","-webkit-mask-position","-webkit-mask-origin","-webkit-mask-clip"],"order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask"},"-webkit-mask-attachment":{"syntax":"<attachment>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"scroll","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-mask-attachment"},"-webkit-mask-clip":{"syntax":"[ <box> | border | padding | content | text ]#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"border","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-clip"},"-webkit-mask-composite":{"syntax":"<composite-style>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"source-over","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-mask-composite"},"-webkit-mask-image":{"syntax":"<mask-reference>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"none","appliesto":"allElements","computed":"absoluteURIOrNone","order":"orderOfAppearance","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-image"},"-webkit-mask-origin":{"syntax":"[ <box> | border | padding | content ]#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"padding","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-origin"},"-webkit-mask-position":{"syntax":"<position>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"referToSizeOfElement","groups":["WebKit Extensions"],"initial":"0% 0%","appliesto":"allElements","computed":"absoluteLengthOrPercentage","order":"orderOfAppearance","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-position"},"-webkit-mask-position-x":{"syntax":"[ <length-percentage> | left | center | right ]#","media":"visual","inherited":false,"animationType":"discrete","percentages":"referToSizeOfElement","groups":["WebKit Extensions"],"initial":"0%","appliesto":"allElements","computed":"absoluteLengthOrPercentage","order":"orderOfAppearance","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-mask-position-x"},"-webkit-mask-position-y":{"syntax":"[ <length-percentage> | top | center | bottom ]#","media":"visual","inherited":false,"animationType":"discrete","percentages":"referToSizeOfElement","groups":["WebKit Extensions"],"initial":"0%","appliesto":"allElements","computed":"absoluteLengthOrPercentage","order":"orderOfAppearance","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-mask-position-y"},"-webkit-mask-repeat":{"syntax":"<repeat-style>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"repeat","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-repeat"},"-webkit-mask-repeat-x":{"syntax":"repeat | no-repeat | space | round","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"repeat","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-mask-repeat-x"},"-webkit-mask-repeat-y":{"syntax":"repeat | no-repeat | space | round","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"repeat","appliesto":"allElements","computed":"absoluteLengthOrPercentage","order":"orderOfAppearance","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-mask-repeat-y"},"-webkit-mask-size":{"syntax":"<bg-size>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"relativeToBackgroundPositioningArea","groups":["WebKit Extensions"],"initial":"auto auto","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-size"},"-webkit-overflow-scrolling":{"syntax":"auto | touch","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"auto","appliesto":"scrollingBoxes","computed":"asSpecified","order":"orderOfAppearance","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-overflow-scrolling"},"-webkit-tap-highlight-color":{"syntax":"<color>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"black","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-tap-highlight-color"},"-webkit-text-fill-color":{"syntax":"<color>","media":"visual","inherited":true,"animationType":"color","percentages":"no","groups":["WebKit Extensions"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-text-fill-color"},"-webkit-text-stroke":{"syntax":"<length> || <color>","media":"visual","inherited":true,"animationType":["-webkit-text-stroke-width","-webkit-text-stroke-color"],"percentages":"no","groups":["WebKit Extensions"],"initial":["-webkit-text-stroke-width","-webkit-text-stroke-color"],"appliesto":"allElements","computed":["-webkit-text-stroke-width","-webkit-text-stroke-color"],"order":"canonicalOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-text-stroke"},"-webkit-text-stroke-color":{"syntax":"<color>","media":"visual","inherited":true,"animationType":"color","percentages":"no","groups":["WebKit Extensions"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-text-stroke-color"},"-webkit-text-stroke-width":{"syntax":"<length>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"0","appliesto":"allElements","computed":"absoluteLength","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-text-stroke-width"},"-webkit-touch-callout":{"syntax":"default | none","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"default","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/-webkit-touch-callout"},"-webkit-user-modify":{"syntax":"read-only | read-write | read-write-plaintext-only","media":"interactive","inherited":true,"animationType":"discrete","percentages":"no","groups":["WebKit Extensions"],"initial":"read-only","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard"},"align-content":{"syntax":"normal | <baseline-position> | <content-distribution> | <overflow-position>? <content-position>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Alignment"],"initial":"normal","appliesto":"multilineFlexContainers","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/align-content"},"align-items":{"syntax":"normal | stretch | <baseline-position> | [ <overflow-position>? <self-position> ]","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Alignment"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/align-items"},"align-self":{"syntax":"auto | normal | stretch | <baseline-position> | <overflow-position>? <self-position>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Alignment"],"initial":"auto","appliesto":"flexItemsGridItemsAndAbsolutelyPositionedBoxes","computed":"autoOnAbsolutelyPositionedElementsValueOfAlignItemsOnParent","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/align-self"},"align-tracks":{"syntax":"[ normal | <baseline-position> | <content-distribution> | <overflow-position>? <content-position> ]#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Grid Layout"],"initial":"normal","appliesto":"gridContainersWithMasonryLayoutInTheirBlockAxis","computed":"asSpecified","order":"uniqueOrder","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/align-tracks"},"all":{"syntax":"initial | inherit | unset | revert","media":"noPracticalMedia","inherited":false,"animationType":"eachOfShorthandPropertiesExceptUnicodeBiDiAndDirection","percentages":"no","groups":["CSS Miscellaneous"],"initial":"noPracticalInitialValue","appliesto":"allElements","computed":"asSpecifiedAppliesToEachProperty","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/all"},"animation":{"syntax":"<single-animation>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Animations"],"initial":["animation-name","animation-duration","animation-timing-function","animation-delay","animation-iteration-count","animation-direction","animation-fill-mode","animation-play-state"],"appliesto":"allElementsAndPseudos","computed":["animation-name","animation-duration","animation-timing-function","animation-delay","animation-direction","animation-iteration-count","animation-fill-mode","animation-play-state"],"order":"orderOfAppearance","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/animation"},"animation-delay":{"syntax":"<time>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Animations"],"initial":"0s","appliesto":"allElementsAndPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/animation-delay"},"animation-direction":{"syntax":"<single-animation-direction>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Animations"],"initial":"normal","appliesto":"allElementsAndPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/animation-direction"},"animation-duration":{"syntax":"<time>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Animations"],"initial":"0s","appliesto":"allElementsAndPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/animation-duration"},"animation-fill-mode":{"syntax":"<single-animation-fill-mode>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Animations"],"initial":"none","appliesto":"allElementsAndPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/animation-fill-mode"},"animation-iteration-count":{"syntax":"<single-animation-iteration-count>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Animations"],"initial":"1","appliesto":"allElementsAndPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/animation-iteration-count"},"animation-name":{"syntax":"[ none | <keyframes-name> ]#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Animations"],"initial":"none","appliesto":"allElementsAndPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/animation-name"},"animation-play-state":{"syntax":"<single-animation-play-state>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Animations"],"initial":"running","appliesto":"allElementsAndPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/animation-play-state"},"animation-timing-function":{"syntax":"<timing-function>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Animations"],"initial":"ease","appliesto":"allElementsAndPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/animation-timing-function"},"appearance":{"syntax":"none | auto | textfield | menulist-button | <compat-auto>","media":"all","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Basic User Interface"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/appearance"},"aspect-ratio":{"syntax":"auto | <ratio>","media":"all","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Basic User Interface"],"initial":"auto","appliesto":"allElementsExceptInlineBoxesAndInternalRubyOrTableBoxes","computed":"asSpecified","order":"perGrammar","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/aspect-ratio"},"azimuth":{"syntax":"<angle> | [ [ left-side | far-left | left | center-left | center | center-right | right | far-right | right-side ] || behind ] | leftwards | rightwards","media":"aural","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Speech"],"initial":"center","appliesto":"allElements","computed":"normalizedAngle","order":"orderOfAppearance","status":"obsolete","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/azimuth"},"backdrop-filter":{"syntax":"none | <filter-function-list>","media":"visual","inherited":false,"animationType":"filterList","percentages":"no","groups":["Filter Effects"],"initial":"none","appliesto":"allElementsSVGContainerElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/backdrop-filter"},"backface-visibility":{"syntax":"visible | hidden","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Transforms"],"initial":"visible","appliesto":"transformableElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/backface-visibility"},"background":{"syntax":"[ <bg-layer> , ]* <final-bg-layer>","media":"visual","inherited":false,"animationType":["background-color","background-image","background-clip","background-position","background-size","background-repeat","background-attachment"],"percentages":["background-position","background-size"],"groups":["CSS Backgrounds and Borders"],"initial":["background-image","background-position","background-size","background-repeat","background-origin","background-clip","background-attachment","background-color"],"appliesto":"allElements","computed":["background-image","background-position","background-size","background-repeat","background-origin","background-clip","background-attachment","background-color"],"order":"orderOfAppearance","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/background"},"background-attachment":{"syntax":"<attachment>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"scroll","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/background-attachment"},"background-blend-mode":{"syntax":"<blend-mode>#","media":"none","inherited":false,"animationType":"discrete","percentages":"no","groups":["Compositing and Blending"],"initial":"normal","appliesto":"allElementsSVGContainerGraphicsAndGraphicsReferencingElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/background-blend-mode"},"background-clip":{"syntax":"<box>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"border-box","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/background-clip"},"background-color":{"syntax":"<color>","media":"visual","inherited":false,"animationType":"color","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"transparent","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/background-color"},"background-image":{"syntax":"<bg-image>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"none","appliesto":"allElements","computed":"asSpecifiedURLsAbsolute","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/background-image"},"background-origin":{"syntax":"<box>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"padding-box","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/background-origin"},"background-position":{"syntax":"<bg-position>#","media":"visual","inherited":false,"animationType":"repeatableListOfSimpleListOfLpc","percentages":"referToSizeOfBackgroundPositioningAreaMinusBackgroundImageSize","groups":["CSS Backgrounds and Borders"],"initial":"0% 0%","appliesto":"allElements","computed":"listEachItemTwoKeywordsOriginOffsets","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/background-position"},"background-position-x":{"syntax":"[ center | [ [ left | right | x-start | x-end ]? <length-percentage>? ]! ]#","media":"visual","inherited":false,"animationType":"discrete","percentages":"referToWidthOfBackgroundPositioningAreaMinusBackgroundImageHeight","groups":["CSS Backgrounds and Borders"],"initial":"left","appliesto":"allElements","computed":"listEachItemConsistingOfAbsoluteLengthPercentageAndOrigin","order":"uniqueOrder","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/background-position-x"},"background-position-y":{"syntax":"[ center | [ [ top | bottom | y-start | y-end ]? <length-percentage>? ]! ]#","media":"visual","inherited":false,"animationType":"discrete","percentages":"referToHeightOfBackgroundPositioningAreaMinusBackgroundImageHeight","groups":["CSS Backgrounds and Borders"],"initial":"top","appliesto":"allElements","computed":"listEachItemConsistingOfAbsoluteLengthPercentageAndOrigin","order":"uniqueOrder","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/background-position-y"},"background-repeat":{"syntax":"<repeat-style>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"repeat","appliesto":"allElements","computed":"listEachItemHasTwoKeywordsOnePerDimension","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/background-repeat"},"background-size":{"syntax":"<bg-size>#","media":"visual","inherited":false,"animationType":"repeatableListOfSimpleListOfLpc","percentages":"relativeToBackgroundPositioningArea","groups":["CSS Backgrounds and Borders"],"initial":"auto auto","appliesto":"allElements","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/background-size"},"block-overflow":{"syntax":"clip | ellipsis | <string>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Overflow"],"initial":"clip","appliesto":"blockContainers","computed":"asSpecified","order":"perGrammar","status":"experimental"},"block-size":{"syntax":"<\'width\'>","media":"visual","inherited":false,"animationType":"lpc","percentages":"blockSizeOfContainingBlock","groups":["CSS Logical Properties"],"initial":"auto","appliesto":"sameAsWidthAndHeight","computed":"sameAsWidthAndHeight","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/block-size"},"border":{"syntax":"<line-width> || <line-style> || <color>","media":"visual","inherited":false,"animationType":["border-color","border-style","border-width"],"percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":["border-width","border-style","border-color"],"appliesto":"allElements","computed":["border-width","border-style","border-color"],"order":"orderOfAppearance","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border"},"border-block":{"syntax":"<\'border-top-width\'> || <\'border-top-style\'> || <\'color\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Logical Properties"],"initial":["border-top-width","border-top-style","border-top-color"],"appliesto":"allElements","computed":["border-top-width","border-top-style","border-top-color"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-block"},"border-block-color":{"syntax":"<\'border-top-color\'>{1,2}","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Logical Properties"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-block-color"},"border-block-style":{"syntax":"<\'border-top-style\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Logical Properties"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-block-style"},"border-block-width":{"syntax":"<\'border-top-width\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"medium","appliesto":"allElements","computed":"absoluteLengthZeroIfBorderStyleNoneOrHidden","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-block-width"},"border-block-end":{"syntax":"<\'border-top-width\'> || <\'border-top-style\'> || <\'color\'>","media":"visual","inherited":false,"animationType":["border-block-end-color","border-block-end-style","border-block-end-width"],"percentages":"no","groups":["CSS Logical Properties"],"initial":["border-top-width","border-top-style","border-top-color"],"appliesto":"allElements","computed":["border-top-width","border-top-style","border-top-color"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-block-end"},"border-block-end-color":{"syntax":"<\'border-top-color\'>","media":"visual","inherited":false,"animationType":"color","percentages":"no","groups":["CSS Logical Properties"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-block-end-color"},"border-block-end-style":{"syntax":"<\'border-top-style\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Logical Properties"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-block-end-style"},"border-block-end-width":{"syntax":"<\'border-top-width\'>","media":"visual","inherited":false,"animationType":"length","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"medium","appliesto":"allElements","computed":"absoluteLengthZeroIfBorderStyleNoneOrHidden","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-block-end-width"},"border-block-start":{"syntax":"<\'border-top-width\'> || <\'border-top-style\'> || <\'color\'>","media":"visual","inherited":false,"animationType":["border-block-start-color","border-block-start-style","border-block-start-width"],"percentages":"no","groups":["CSS Logical Properties"],"initial":["border-width","border-style","color"],"appliesto":"allElements","computed":["border-width","border-style","border-block-start-color"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-block-start"},"border-block-start-color":{"syntax":"<\'border-top-color\'>","media":"visual","inherited":false,"animationType":"color","percentages":"no","groups":["CSS Logical Properties"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-block-start-color"},"border-block-start-style":{"syntax":"<\'border-top-style\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Logical Properties"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-block-start-style"},"border-block-start-width":{"syntax":"<\'border-top-width\'>","media":"visual","inherited":false,"animationType":"length","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"medium","appliesto":"allElements","computed":"absoluteLengthZeroIfBorderStyleNoneOrHidden","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-block-start-width"},"border-bottom":{"syntax":"<line-width> || <line-style> || <color>","media":"visual","inherited":false,"animationType":["border-bottom-color","border-bottom-style","border-bottom-width"],"percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":["border-bottom-width","border-bottom-style","border-bottom-color"],"appliesto":"allElements","computed":["border-bottom-width","border-bottom-style","border-bottom-color"],"order":"orderOfAppearance","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-bottom"},"border-bottom-color":{"syntax":"<\'border-top-color\'>","media":"visual","inherited":false,"animationType":"color","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-bottom-color"},"border-bottom-left-radius":{"syntax":"<length-percentage>{1,2}","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfBorderBox","groups":["CSS Backgrounds and Borders"],"initial":"0","appliesto":"allElementsUAsNotRequiredWhenCollapse","computed":"twoAbsoluteLengthOrPercentages","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-bottom-left-radius"},"border-bottom-right-radius":{"syntax":"<length-percentage>{1,2}","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfBorderBox","groups":["CSS Backgrounds and Borders"],"initial":"0","appliesto":"allElementsUAsNotRequiredWhenCollapse","computed":"twoAbsoluteLengthOrPercentages","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-bottom-right-radius"},"border-bottom-style":{"syntax":"<line-style>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-bottom-style"},"border-bottom-width":{"syntax":"<line-width>","media":"visual","inherited":false,"animationType":"length","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"medium","appliesto":"allElements","computed":"absoluteLengthOr0IfBorderBottomStyleNoneOrHidden","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-bottom-width"},"border-collapse":{"syntax":"collapse | separate","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Table"],"initial":"separate","appliesto":"tableElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-collapse"},"border-color":{"syntax":"<color>{1,4}","media":"visual","inherited":false,"animationType":["border-bottom-color","border-left-color","border-right-color","border-top-color"],"percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":["border-top-color","border-right-color","border-bottom-color","border-left-color"],"appliesto":"allElements","computed":["border-bottom-color","border-left-color","border-right-color","border-top-color"],"order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-color"},"border-end-end-radius":{"syntax":"<length-percentage>{1,2}","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfBorderBox","groups":["CSS Logical Properties"],"initial":"0","appliesto":"allElementsUAsNotRequiredWhenCollapse","computed":"twoAbsoluteLengthOrPercentages","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-end-end-radius"},"border-end-start-radius":{"syntax":"<length-percentage>{1,2}","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfBorderBox","groups":["CSS Logical Properties"],"initial":"0","appliesto":"allElementsUAsNotRequiredWhenCollapse","computed":"twoAbsoluteLengthOrPercentages","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-end-start-radius"},"border-image":{"syntax":"<\'border-image-source\'> || <\'border-image-slice\'> [ / <\'border-image-width\'> | / <\'border-image-width\'>? / <\'border-image-outset\'> ]? || <\'border-image-repeat\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":["border-image-slice","border-image-width"],"groups":["CSS Backgrounds and Borders"],"initial":["border-image-source","border-image-slice","border-image-width","border-image-outset","border-image-repeat"],"appliesto":"allElementsExceptTableElementsWhenCollapse","computed":["border-image-outset","border-image-repeat","border-image-slice","border-image-source","border-image-width"],"order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-image"},"border-image-outset":{"syntax":"[ <length> | <number> ]{1,4}","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"0","appliesto":"allElementsExceptTableElementsWhenCollapse","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-image-outset"},"border-image-repeat":{"syntax":"[ stretch | repeat | round | space ]{1,2}","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"stretch","appliesto":"allElementsExceptTableElementsWhenCollapse","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-image-repeat"},"border-image-slice":{"syntax":"<number-percentage>{1,4} && fill?","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"referToSizeOfBorderImage","groups":["CSS Backgrounds and Borders"],"initial":"100%","appliesto":"allElementsExceptTableElementsWhenCollapse","computed":"oneToFourPercentagesOrAbsoluteLengthsPlusFill","order":"percentagesOrLengthsFollowedByFill","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-image-slice"},"border-image-source":{"syntax":"none | <image>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"none","appliesto":"allElementsExceptTableElementsWhenCollapse","computed":"noneOrImageWithAbsoluteURI","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-image-source"},"border-image-width":{"syntax":"[ <length-percentage> | <number> | auto ]{1,4}","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"referToWidthOrHeightOfBorderImageArea","groups":["CSS Backgrounds and Borders"],"initial":"1","appliesto":"allElementsExceptTableElementsWhenCollapse","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-image-width"},"border-inline":{"syntax":"<\'border-top-width\'> || <\'border-top-style\'> || <\'color\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Logical Properties"],"initial":["border-top-width","border-top-style","border-top-color"],"appliesto":"allElements","computed":["border-top-width","border-top-style","border-top-color"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-inline"},"border-inline-end":{"syntax":"<\'border-top-width\'> || <\'border-top-style\'> || <\'color\'>","media":"visual","inherited":false,"animationType":["border-inline-end-color","border-inline-end-style","border-inline-end-width"],"percentages":"no","groups":["CSS Logical Properties"],"initial":["border-width","border-style","color"],"appliesto":"allElements","computed":["border-width","border-style","border-inline-end-color"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-inline-end"},"border-inline-color":{"syntax":"<\'border-top-color\'>{1,2}","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Logical Properties"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-inline-color"},"border-inline-style":{"syntax":"<\'border-top-style\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Logical Properties"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-inline-style"},"border-inline-width":{"syntax":"<\'border-top-width\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"medium","appliesto":"allElements","computed":"absoluteLengthZeroIfBorderStyleNoneOrHidden","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-inline-width"},"border-inline-end-color":{"syntax":"<\'border-top-color\'>","media":"visual","inherited":false,"animationType":"color","percentages":"no","groups":["CSS Logical Properties"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-inline-end-color"},"border-inline-end-style":{"syntax":"<\'border-top-style\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Logical Properties"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-inline-end-style"},"border-inline-end-width":{"syntax":"<\'border-top-width\'>","media":"visual","inherited":false,"animationType":"length","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"medium","appliesto":"allElements","computed":"absoluteLengthZeroIfBorderStyleNoneOrHidden","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-inline-end-width"},"border-inline-start":{"syntax":"<\'border-top-width\'> || <\'border-top-style\'> || <\'color\'>","media":"visual","inherited":false,"animationType":["border-inline-start-color","border-inline-start-style","border-inline-start-width"],"percentages":"no","groups":["CSS Logical Properties"],"initial":["border-width","border-style","color"],"appliesto":"allElements","computed":["border-width","border-style","border-inline-start-color"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-inline-start"},"border-inline-start-color":{"syntax":"<\'border-top-color\'>","media":"visual","inherited":false,"animationType":"color","percentages":"no","groups":["CSS Logical Properties"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-inline-start-color"},"border-inline-start-style":{"syntax":"<\'border-top-style\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Logical Properties"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-inline-start-style"},"border-inline-start-width":{"syntax":"<\'border-top-width\'>","media":"visual","inherited":false,"animationType":"length","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"medium","appliesto":"allElements","computed":"absoluteLengthZeroIfBorderStyleNoneOrHidden","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-inline-start-width"},"border-left":{"syntax":"<line-width> || <line-style> || <color>","media":"visual","inherited":false,"animationType":["border-left-color","border-left-style","border-left-width"],"percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":["border-left-width","border-left-style","border-left-color"],"appliesto":"allElements","computed":["border-left-width","border-left-style","border-left-color"],"order":"orderOfAppearance","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-left"},"border-left-color":{"syntax":"<color>","media":"visual","inherited":false,"animationType":"color","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-left-color"},"border-left-style":{"syntax":"<line-style>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-left-style"},"border-left-width":{"syntax":"<line-width>","media":"visual","inherited":false,"animationType":"length","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"medium","appliesto":"allElements","computed":"absoluteLengthOr0IfBorderLeftStyleNoneOrHidden","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-left-width"},"border-radius":{"syntax":"<length-percentage>{1,4} [ / <length-percentage>{1,4} ]?","media":"visual","inherited":false,"animationType":["border-top-left-radius","border-top-right-radius","border-bottom-right-radius","border-bottom-left-radius"],"percentages":"referToDimensionOfBorderBox","groups":["CSS Backgrounds and Borders"],"initial":["border-top-left-radius","border-top-right-radius","border-bottom-right-radius","border-bottom-left-radius"],"appliesto":"allElementsUAsNotRequiredWhenCollapse","computed":["border-bottom-left-radius","border-bottom-right-radius","border-top-left-radius","border-top-right-radius"],"order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-radius"},"border-right":{"syntax":"<line-width> || <line-style> || <color>","media":"visual","inherited":false,"animationType":["border-right-color","border-right-style","border-right-width"],"percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":["border-right-width","border-right-style","border-right-color"],"appliesto":"allElements","computed":["border-right-width","border-right-style","border-right-color"],"order":"orderOfAppearance","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-right"},"border-right-color":{"syntax":"<color>","media":"visual","inherited":false,"animationType":"color","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-right-color"},"border-right-style":{"syntax":"<line-style>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-right-style"},"border-right-width":{"syntax":"<line-width>","media":"visual","inherited":false,"animationType":"length","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"medium","appliesto":"allElements","computed":"absoluteLengthOr0IfBorderRightStyleNoneOrHidden","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-right-width"},"border-spacing":{"syntax":"<length> <length>?","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Table"],"initial":"0","appliesto":"tableElements","computed":"twoAbsoluteLengths","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-spacing"},"border-start-end-radius":{"syntax":"<length-percentage>{1,2}","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfBorderBox","groups":["CSS Logical Properties"],"initial":"0","appliesto":"allElementsUAsNotRequiredWhenCollapse","computed":"twoAbsoluteLengthOrPercentages","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-start-end-radius"},"border-start-start-radius":{"syntax":"<length-percentage>{1,2}","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfBorderBox","groups":["CSS Logical Properties"],"initial":"0","appliesto":"allElementsUAsNotRequiredWhenCollapse","computed":"twoAbsoluteLengthOrPercentages","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-start-start-radius"},"border-style":{"syntax":"<line-style>{1,4}","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":["border-top-style","border-right-style","border-bottom-style","border-left-style"],"appliesto":"allElements","computed":["border-bottom-style","border-left-style","border-right-style","border-top-style"],"order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-style"},"border-top":{"syntax":"<line-width> || <line-style> || <color>","media":"visual","inherited":false,"animationType":["border-top-color","border-top-style","border-top-width"],"percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":["border-top-width","border-top-style","border-top-color"],"appliesto":"allElements","computed":["border-top-width","border-top-style","border-top-color"],"order":"orderOfAppearance","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-top"},"border-top-color":{"syntax":"<color>","media":"visual","inherited":false,"animationType":"color","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-top-color"},"border-top-left-radius":{"syntax":"<length-percentage>{1,2}","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfBorderBox","groups":["CSS Backgrounds and Borders"],"initial":"0","appliesto":"allElementsUAsNotRequiredWhenCollapse","computed":"twoAbsoluteLengthOrPercentages","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-top-left-radius"},"border-top-right-radius":{"syntax":"<length-percentage>{1,2}","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfBorderBox","groups":["CSS Backgrounds and Borders"],"initial":"0","appliesto":"allElementsUAsNotRequiredWhenCollapse","computed":"twoAbsoluteLengthOrPercentages","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-top-right-radius"},"border-top-style":{"syntax":"<line-style>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-top-style"},"border-top-width":{"syntax":"<line-width>","media":"visual","inherited":false,"animationType":"length","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"medium","appliesto":"allElements","computed":"absoluteLengthOr0IfBorderTopStyleNoneOrHidden","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-top-width"},"border-width":{"syntax":"<line-width>{1,4}","media":"visual","inherited":false,"animationType":["border-bottom-width","border-left-width","border-right-width","border-top-width"],"percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":["border-top-width","border-right-width","border-bottom-width","border-left-width"],"appliesto":"allElements","computed":["border-bottom-width","border-left-width","border-right-width","border-top-width"],"order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/border-width"},"bottom":{"syntax":"<length> | <percentage> | auto","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToContainingBlockHeight","groups":["CSS Positioning"],"initial":"auto","appliesto":"positionedElements","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/bottom"},"box-align":{"syntax":"start | center | end | baseline | stretch","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions","WebKit Extensions"],"initial":"stretch","appliesto":"elementsWithDisplayBoxOrInlineBox","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/box-align"},"box-decoration-break":{"syntax":"slice | clone","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Fragmentation"],"initial":"slice","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/box-decoration-break"},"box-direction":{"syntax":"normal | reverse | inherit","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions","WebKit Extensions"],"initial":"normal","appliesto":"elementsWithDisplayBoxOrInlineBox","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/box-direction"},"box-flex":{"syntax":"<number>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions","WebKit Extensions"],"initial":"0","appliesto":"directChildrenOfElementsWithDisplayMozBoxMozInlineBox","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/box-flex"},"box-flex-group":{"syntax":"<integer>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions","WebKit Extensions"],"initial":"1","appliesto":"inFlowChildrenOfBoxElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/box-flex-group"},"box-lines":{"syntax":"single | multiple","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions","WebKit Extensions"],"initial":"single","appliesto":"boxElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/box-lines"},"box-ordinal-group":{"syntax":"<integer>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions","WebKit Extensions"],"initial":"1","appliesto":"childrenOfBoxElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/box-ordinal-group"},"box-orient":{"syntax":"horizontal | vertical | inline-axis | block-axis | inherit","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions","WebKit Extensions"],"initial":"inlineAxisHorizontalInXUL","appliesto":"elementsWithDisplayBoxOrInlineBox","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/box-orient"},"box-pack":{"syntax":"start | center | end | justify","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions","WebKit Extensions"],"initial":"start","appliesto":"elementsWithDisplayMozBoxMozInlineBox","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/box-pack"},"box-shadow":{"syntax":"none | <shadow>#","media":"visual","inherited":false,"animationType":"shadowList","percentages":"no","groups":["CSS Backgrounds and Borders"],"initial":"none","appliesto":"allElements","computed":"absoluteLengthsSpecifiedColorAsSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/box-shadow"},"box-sizing":{"syntax":"content-box | border-box","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Basic User Interface"],"initial":"content-box","appliesto":"allElementsAcceptingWidthOrHeight","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/box-sizing"},"break-after":{"syntax":"auto | avoid | always | all | avoid-page | page | left | right | recto | verso | avoid-column | column | avoid-region | region","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Fragmentation"],"initial":"auto","appliesto":"blockLevelElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/break-after"},"break-before":{"syntax":"auto | avoid | always | all | avoid-page | page | left | right | recto | verso | avoid-column | column | avoid-region | region","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Fragmentation"],"initial":"auto","appliesto":"blockLevelElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/break-before"},"break-inside":{"syntax":"auto | avoid | avoid-page | avoid-column | avoid-region","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Fragmentation"],"initial":"auto","appliesto":"blockLevelElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/break-inside"},"caption-side":{"syntax":"top | bottom | block-start | block-end | inline-start | inline-end","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Table"],"initial":"top","appliesto":"tableCaptionElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/caption-side"},"caret-color":{"syntax":"auto | <color>","media":"interactive","inherited":true,"animationType":"color","percentages":"no","groups":["CSS Basic User Interface"],"initial":"auto","appliesto":"allElements","computed":"asAutoOrColor","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/caret-color"},"clear":{"syntax":"none | left | right | both | inline-start | inline-end","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Positioning"],"initial":"none","appliesto":"blockLevelElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/clear"},"clip":{"syntax":"<shape> | auto","media":"visual","inherited":false,"animationType":"rectangle","percentages":"no","groups":["CSS Masking"],"initial":"auto","appliesto":"absolutelyPositionedElements","computed":"autoOrRectangle","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/clip"},"clip-path":{"syntax":"<clip-source> | [ <basic-shape> || <geometry-box> ] | none","media":"visual","inherited":false,"animationType":"basicShapeOtherwiseNo","percentages":"referToReferenceBoxWhenSpecifiedOtherwiseBorderBox","groups":["CSS Masking"],"initial":"none","appliesto":"allElementsSVGContainerElements","computed":"asSpecifiedURLsAbsolute","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/clip-path"},"color":{"syntax":"<color>","media":"visual","inherited":true,"animationType":"color","percentages":"no","groups":["CSS Color"],"initial":"variesFromBrowserToBrowser","appliesto":"allElements","computed":"translucentValuesRGBAOtherwiseRGB","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/color"},"color-adjust":{"syntax":"economy | exact","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Color"],"initial":"economy","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/color-adjust"},"column-count":{"syntax":"<integer> | auto","media":"visual","inherited":false,"animationType":"integer","percentages":"no","groups":["CSS Columns"],"initial":"auto","appliesto":"blockContainersExceptTableWrappers","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/column-count"},"column-fill":{"syntax":"auto | balance | balance-all","media":"visualInContinuousMediaNoEffectInOverflowColumns","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Columns"],"initial":"balance","appliesto":"multicolElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/column-fill"},"column-gap":{"syntax":"normal | <length-percentage>","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfContentArea","groups":["CSS Box Alignment"],"initial":"normal","appliesto":"multiColumnElementsFlexContainersGridContainers","computed":"asSpecifiedWithLengthsAbsoluteAndNormalComputingToZeroExceptMultiColumn","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/column-gap"},"column-rule":{"syntax":"<\'column-rule-width\'> || <\'column-rule-style\'> || <\'column-rule-color\'>","media":"visual","inherited":false,"animationType":["column-rule-color","column-rule-style","column-rule-width"],"percentages":"no","groups":["CSS Columns"],"initial":["column-rule-width","column-rule-style","column-rule-color"],"appliesto":"multicolElements","computed":["column-rule-color","column-rule-style","column-rule-width"],"order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/column-rule"},"column-rule-color":{"syntax":"<color>","media":"visual","inherited":false,"animationType":"color","percentages":"no","groups":["CSS Columns"],"initial":"currentcolor","appliesto":"multicolElements","computed":"computedColor","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/column-rule-color"},"column-rule-style":{"syntax":"<\'border-style\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Columns"],"initial":"none","appliesto":"multicolElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/column-rule-style"},"column-rule-width":{"syntax":"<\'border-width\'>","media":"visual","inherited":false,"animationType":"length","percentages":"no","groups":["CSS Columns"],"initial":"medium","appliesto":"multicolElements","computed":"absoluteLength0IfColumnRuleStyleNoneOrHidden","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/column-rule-width"},"column-span":{"syntax":"none | all","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Columns"],"initial":"none","appliesto":"inFlowBlockLevelElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/column-span"},"column-width":{"syntax":"<length> | auto","media":"visual","inherited":false,"animationType":"length","percentages":"no","groups":["CSS Columns"],"initial":"auto","appliesto":"blockContainersExceptTableWrappers","computed":"absoluteLengthZeroOrLarger","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/column-width"},"columns":{"syntax":"<\'column-width\'> || <\'column-count\'>","media":"visual","inherited":false,"animationType":["column-width","column-count"],"percentages":"no","groups":["CSS Columns"],"initial":["column-width","column-count"],"appliesto":"blockContainersExceptTableWrappers","computed":["column-width","column-count"],"order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/columns"},"contain":{"syntax":"none | strict | content | [ size || layout || style || paint ]","media":"all","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Containment"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/contain"},"content":{"syntax":"normal | none | [ <content-replacement> | <content-list> ] [/ <string> ]?","media":"all","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Generated Content"],"initial":"normal","appliesto":"beforeAndAfterPseudos","computed":"normalOnElementsForPseudosNoneAbsoluteURIStringOrAsSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/content"},"counter-increment":{"syntax":"[ <custom-ident> <integer>? ]+ | none","media":"all","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Counter Styles"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/counter-increment"},"counter-reset":{"syntax":"[ <custom-ident> <integer>? ]+ | none","media":"all","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Counter Styles"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/counter-reset"},"counter-set":{"syntax":"[ <custom-ident> <integer>? ]+ | none","media":"all","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Counter Styles"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/counter-set"},"cursor":{"syntax":"[ [ <url> [ <x> <y> ]? , ]* [ auto | default | none | context-menu | help | pointer | progress | wait | cell | crosshair | text | vertical-text | alias | copy | move | no-drop | not-allowed | e-resize | n-resize | ne-resize | nw-resize | s-resize | se-resize | sw-resize | w-resize | ew-resize | ns-resize | nesw-resize | nwse-resize | col-resize | row-resize | all-scroll | zoom-in | zoom-out | grab | grabbing ] ]","media":["visual","interactive"],"inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Basic User Interface"],"initial":"auto","appliesto":"allElements","computed":"asSpecifiedURLsAbsolute","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/cursor"},"direction":{"syntax":"ltr | rtl","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Writing Modes"],"initial":"ltr","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/direction"},"display":{"syntax":"[ <display-outside> || <display-inside> ] | <display-listitem> | <display-internal> | <display-box> | <display-legacy>","media":"all","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Display"],"initial":"inline","appliesto":"allElements","computed":"asSpecifiedExceptPositionedFloatingAndRootElementsKeywordMaybeDifferent","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/display"},"empty-cells":{"syntax":"show | hide","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Table"],"initial":"show","appliesto":"tableCellElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/empty-cells"},"filter":{"syntax":"none | <filter-function-list>","media":"visual","inherited":false,"animationType":"filterList","percentages":"no","groups":["Filter Effects"],"initial":"none","appliesto":"allElementsSVGContainerElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/filter"},"flex":{"syntax":"none | [ <\'flex-grow\'> <\'flex-shrink\'>? || <\'flex-basis\'> ]","media":"visual","inherited":false,"animationType":["flex-grow","flex-shrink","flex-basis"],"percentages":"no","groups":["CSS Flexible Box Layout"],"initial":["flex-grow","flex-shrink","flex-basis"],"appliesto":"flexItemsAndInFlowPseudos","computed":["flex-grow","flex-shrink","flex-basis"],"order":"orderOfAppearance","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/flex"},"flex-basis":{"syntax":"content | <\'width\'>","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToFlexContainersInnerMainSize","groups":["CSS Flexible Box Layout"],"initial":"auto","appliesto":"flexItemsAndInFlowPseudos","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"lengthOrPercentageBeforeKeywordIfBothPresent","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/flex-basis"},"flex-direction":{"syntax":"row | row-reverse | column | column-reverse","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Flexible Box Layout"],"initial":"row","appliesto":"flexContainers","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/flex-direction"},"flex-flow":{"syntax":"<\'flex-direction\'> || <\'flex-wrap\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Flexible Box Layout"],"initial":["flex-direction","flex-wrap"],"appliesto":"flexContainers","computed":["flex-direction","flex-wrap"],"order":"orderOfAppearance","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/flex-flow"},"flex-grow":{"syntax":"<number>","media":"visual","inherited":false,"animationType":"number","percentages":"no","groups":["CSS Flexible Box Layout"],"initial":"0","appliesto":"flexItemsAndInFlowPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/flex-grow"},"flex-shrink":{"syntax":"<number>","media":"visual","inherited":false,"animationType":"number","percentages":"no","groups":["CSS Flexible Box Layout"],"initial":"1","appliesto":"flexItemsAndInFlowPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/flex-shrink"},"flex-wrap":{"syntax":"nowrap | wrap | wrap-reverse","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Flexible Box Layout"],"initial":"nowrap","appliesto":"flexContainers","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/flex-wrap"},"float":{"syntax":"left | right | none | inline-start | inline-end","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Positioning"],"initial":"none","appliesto":"allElementsNoEffectIfDisplayNone","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/float"},"font":{"syntax":"[ [ <\'font-style\'> || <font-variant-css21> || <\'font-weight\'> || <\'font-stretch\'> ]? <\'font-size\'> [ / <\'line-height\'> ]? <\'font-family\'> ] | caption | icon | menu | message-box | small-caption | status-bar","media":"visual","inherited":true,"animationType":["font-style","font-variant","font-weight","font-stretch","font-size","line-height","font-family"],"percentages":["font-size","line-height"],"groups":["CSS Fonts"],"initial":["font-style","font-variant","font-weight","font-stretch","font-size","line-height","font-family"],"appliesto":"allElements","computed":["font-style","font-variant","font-weight","font-stretch","font-size","line-height","font-family"],"order":"orderOfAppearance","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font"},"font-family":{"syntax":"[ <family-name> | <generic-family> ]#","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"dependsOnUserAgent","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-family"},"font-feature-settings":{"syntax":"normal | <feature-tag-value>#","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-feature-settings"},"font-kerning":{"syntax":"auto | normal | none","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-kerning"},"font-language-override":{"syntax":"normal | <string>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-language-override"},"font-optical-sizing":{"syntax":"auto | none","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-optical-sizing"},"font-variation-settings":{"syntax":"normal | [ <string> <number> ]#","media":"visual","inherited":true,"animationType":"transform","percentages":"no","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-variation-settings"},"font-size":{"syntax":"<absolute-size> | <relative-size> | <length-percentage>","media":"visual","inherited":true,"animationType":"length","percentages":"referToParentElementsFontSize","groups":["CSS Fonts"],"initial":"medium","appliesto":"allElements","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-size"},"font-size-adjust":{"syntax":"none | <number>","media":"visual","inherited":true,"animationType":"number","percentages":"no","groups":["CSS Fonts"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-size-adjust"},"font-smooth":{"syntax":"auto | never | always | <absolute-size> | <length>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-smooth"},"font-stretch":{"syntax":"<font-stretch-absolute>","media":"visual","inherited":true,"animationType":"fontStretch","percentages":"no","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-stretch"},"font-style":{"syntax":"normal | italic | oblique <angle>?","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-style"},"font-synthesis":{"syntax":"none | [ weight || style ]","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"weight style","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-synthesis"},"font-variant":{"syntax":"normal | none | [ <common-lig-values> || <discretionary-lig-values> || <historical-lig-values> || <contextual-alt-values> || stylistic( <feature-value-name> ) || historical-forms || styleset( <feature-value-name># ) || character-variant( <feature-value-name># ) || swash( <feature-value-name> ) || ornaments( <feature-value-name> ) || annotation( <feature-value-name> ) || [ small-caps | all-small-caps | petite-caps | all-petite-caps | unicase | titling-caps ] || <numeric-figure-values> || <numeric-spacing-values> || <numeric-fraction-values> || ordinal || slashed-zero || <east-asian-variant-values> || <east-asian-width-values> || ruby ]","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-variant"},"font-variant-alternates":{"syntax":"normal | [ stylistic( <feature-value-name> ) || historical-forms || styleset( <feature-value-name># ) || character-variant( <feature-value-name># ) || swash( <feature-value-name> ) || ornaments( <feature-value-name> ) || annotation( <feature-value-name> ) ]","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-variant-alternates"},"font-variant-caps":{"syntax":"normal | small-caps | all-small-caps | petite-caps | all-petite-caps | unicase | titling-caps","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-variant-caps"},"font-variant-east-asian":{"syntax":"normal | [ <east-asian-variant-values> || <east-asian-width-values> || ruby ]","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-variant-east-asian"},"font-variant-ligatures":{"syntax":"normal | none | [ <common-lig-values> || <discretionary-lig-values> || <historical-lig-values> || <contextual-alt-values> ]","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-variant-ligatures"},"font-variant-numeric":{"syntax":"normal | [ <numeric-figure-values> || <numeric-spacing-values> || <numeric-fraction-values> || ordinal || slashed-zero ]","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-variant-numeric"},"font-variant-position":{"syntax":"normal | sub | super","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-variant-position"},"font-weight":{"syntax":"<font-weight-absolute> | bolder | lighter","media":"visual","inherited":true,"animationType":"fontWeight","percentages":"no","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"keywordOrNumericalValueBolderLighterTransformedToRealValue","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/font-weight"},"gap":{"syntax":"<\'row-gap\'> <\'column-gap\'>?","media":"visual","inherited":false,"animationType":["row-gap","column-gap"],"percentages":"no","groups":["CSS Box Alignment"],"initial":["row-gap","column-gap"],"appliesto":"multiColumnElementsFlexContainersGridContainers","computed":["row-gap","column-gap"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/gap"},"grid":{"syntax":"<\'grid-template\'> | <\'grid-template-rows\'> / [ auto-flow && dense? ] <\'grid-auto-columns\'>? | [ auto-flow && dense? ] <\'grid-auto-rows\'>? / <\'grid-template-columns\'>","media":"visual","inherited":false,"animationType":"discrete","percentages":["grid-template-rows","grid-template-columns","grid-auto-rows","grid-auto-columns"],"groups":["CSS Grid Layout"],"initial":["grid-template-rows","grid-template-columns","grid-template-areas","grid-auto-rows","grid-auto-columns","grid-auto-flow","grid-column-gap","grid-row-gap","column-gap","row-gap"],"appliesto":"gridContainers","computed":["grid-template-rows","grid-template-columns","grid-template-areas","grid-auto-rows","grid-auto-columns","grid-auto-flow","grid-column-gap","grid-row-gap","column-gap","row-gap"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid"},"grid-area":{"syntax":"<grid-line> [ / <grid-line> ]{0,3}","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Grid Layout"],"initial":["grid-row-start","grid-column-start","grid-row-end","grid-column-end"],"appliesto":"gridItemsAndBoxesWithinGridContainer","computed":["grid-row-start","grid-column-start","grid-row-end","grid-column-end"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-area"},"grid-auto-columns":{"syntax":"<track-size>+","media":"visual","inherited":false,"animationType":"discrete","percentages":"referToDimensionOfContentArea","groups":["CSS Grid Layout"],"initial":"auto","appliesto":"gridContainers","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-auto-columns"},"grid-auto-flow":{"syntax":"[ row | column ] || dense","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Grid Layout"],"initial":"row","appliesto":"gridContainers","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-auto-flow"},"grid-auto-rows":{"syntax":"<track-size>+","media":"visual","inherited":false,"animationType":"discrete","percentages":"referToDimensionOfContentArea","groups":["CSS Grid Layout"],"initial":"auto","appliesto":"gridContainers","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-auto-rows"},"grid-column":{"syntax":"<grid-line> [ / <grid-line> ]?","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Grid Layout"],"initial":["grid-column-start","grid-column-end"],"appliesto":"gridItemsAndBoxesWithinGridContainer","computed":["grid-column-start","grid-column-end"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-column"},"grid-column-end":{"syntax":"<grid-line>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Grid Layout"],"initial":"auto","appliesto":"gridItemsAndBoxesWithinGridContainer","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-column-end"},"grid-column-gap":{"syntax":"<length-percentage>","media":"visual","inherited":false,"animationType":"length","percentages":"referToDimensionOfContentArea","groups":["CSS Grid Layout"],"initial":"0","appliesto":"gridContainers","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","status":"obsolete","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/column-gap"},"grid-column-start":{"syntax":"<grid-line>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Grid Layout"],"initial":"auto","appliesto":"gridItemsAndBoxesWithinGridContainer","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-column-start"},"grid-gap":{"syntax":"<\'grid-row-gap\'> <\'grid-column-gap\'>?","media":"visual","inherited":false,"animationType":["grid-row-gap","grid-column-gap"],"percentages":"no","groups":["CSS Grid Layout"],"initial":["grid-row-gap","grid-column-gap"],"appliesto":"gridContainers","computed":["grid-row-gap","grid-column-gap"],"order":"uniqueOrder","status":"obsolete","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/gap"},"grid-row":{"syntax":"<grid-line> [ / <grid-line> ]?","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Grid Layout"],"initial":["grid-row-start","grid-row-end"],"appliesto":"gridItemsAndBoxesWithinGridContainer","computed":["grid-row-start","grid-row-end"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-row"},"grid-row-end":{"syntax":"<grid-line>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Grid Layout"],"initial":"auto","appliesto":"gridItemsAndBoxesWithinGridContainer","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-row-end"},"grid-row-gap":{"syntax":"<length-percentage>","media":"visual","inherited":false,"animationType":"length","percentages":"referToDimensionOfContentArea","groups":["CSS Grid Layout"],"initial":"0","appliesto":"gridContainers","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","status":"obsolete","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/row-gap"},"grid-row-start":{"syntax":"<grid-line>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Grid Layout"],"initial":"auto","appliesto":"gridItemsAndBoxesWithinGridContainer","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-row-start"},"grid-template":{"syntax":"none | [ <\'grid-template-rows\'> / <\'grid-template-columns\'> ] | [ <line-names>? <string> <track-size>? <line-names>? ]+ [ / <explicit-track-list> ]?","media":"visual","inherited":false,"animationType":"discrete","percentages":["grid-template-columns","grid-template-rows"],"groups":["CSS Grid Layout"],"initial":["grid-template-columns","grid-template-rows","grid-template-areas"],"appliesto":"gridContainers","computed":["grid-template-columns","grid-template-rows","grid-template-areas"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-template"},"grid-template-areas":{"syntax":"none | <string>+","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Grid Layout"],"initial":"none","appliesto":"gridContainers","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-template-areas"},"grid-template-columns":{"syntax":"none | <track-list> | <auto-track-list> | subgrid <line-name-list>?","media":"visual","inherited":false,"animationType":"simpleListOfLpcDifferenceLpc","percentages":"referToDimensionOfContentArea","groups":["CSS Grid Layout"],"initial":"none","appliesto":"gridContainers","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-template-columns"},"grid-template-rows":{"syntax":"none | <track-list> | <auto-track-list> | subgrid <line-name-list>?","media":"visual","inherited":false,"animationType":"simpleListOfLpcDifferenceLpc","percentages":"referToDimensionOfContentArea","groups":["CSS Grid Layout"],"initial":"none","appliesto":"gridContainers","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/grid-template-rows"},"hanging-punctuation":{"syntax":"none | [ first || [ force-end | allow-end ] || last ]","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/hanging-punctuation"},"height":{"syntax":"auto | <length> | <percentage> | min-content | max-content | fit-content(<length-percentage>)","media":"visual","inherited":false,"animationType":"lpc","percentages":"regardingHeightOfGeneratedBoxContainingBlockPercentagesRelativeToContainingBlock","groups":["CSS Box Model"],"initial":"auto","appliesto":"allElementsButNonReplacedAndTableColumns","computed":"percentageAutoOrAbsoluteLength","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/height"},"hyphens":{"syntax":"none | manual | auto","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text"],"initial":"manual","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/hyphens"},"image-orientation":{"syntax":"from-image | <angle> | [ <angle>? flip ]","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Images"],"initial":"from-image","appliesto":"allElements","computed":"angleRoundedToNextQuarter","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/image-orientation"},"image-rendering":{"syntax":"auto | crisp-edges | pixelated","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Images"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/image-rendering"},"image-resolution":{"syntax":"[ from-image || <resolution> ] && snap?","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Images"],"initial":"1dppx","appliesto":"allElements","computed":"asSpecifiedWithExceptionOfResolution","order":"uniqueOrder","status":"experimental"},"ime-mode":{"syntax":"auto | normal | active | inactive | disabled","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Basic User Interface"],"initial":"auto","appliesto":"textFields","computed":"asSpecified","order":"uniqueOrder","status":"obsolete","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/ime-mode"},"initial-letter":{"syntax":"normal | [ <number> <integer>? ]","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Inline"],"initial":"normal","appliesto":"firstLetterPseudoElementsAndInlineLevelFirstChildren","computed":"asSpecified","order":"uniqueOrder","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/initial-letter"},"initial-letter-align":{"syntax":"[ auto | alphabetic | hanging | ideographic ]","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Inline"],"initial":"auto","appliesto":"firstLetterPseudoElementsAndInlineLevelFirstChildren","computed":"asSpecified","order":"uniqueOrder","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/initial-letter-align"},"inline-size":{"syntax":"<\'width\'>","media":"visual","inherited":false,"animationType":"lpc","percentages":"inlineSizeOfContainingBlock","groups":["CSS Logical Properties"],"initial":"auto","appliesto":"sameAsWidthAndHeight","computed":"sameAsWidthAndHeight","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/inline-size"},"inset":{"syntax":"<\'top\'>{1,4}","media":"visual","inherited":false,"animationType":"lpc","percentages":"logicalHeightOfContainingBlock","groups":["CSS Logical Properties"],"initial":"auto","appliesto":"positionedElements","computed":"sameAsBoxOffsets","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/inset"},"inset-block":{"syntax":"<\'top\'>{1,2}","media":"visual","inherited":false,"animationType":"lpc","percentages":"logicalHeightOfContainingBlock","groups":["CSS Logical Properties"],"initial":"auto","appliesto":"positionedElements","computed":"sameAsBoxOffsets","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/inset-block"},"inset-block-end":{"syntax":"<\'top\'>","media":"visual","inherited":false,"animationType":"lpc","percentages":"logicalHeightOfContainingBlock","groups":["CSS Logical Properties"],"initial":"auto","appliesto":"positionedElements","computed":"sameAsBoxOffsets","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/inset-block-end"},"inset-block-start":{"syntax":"<\'top\'>","media":"visual","inherited":false,"animationType":"lpc","percentages":"logicalHeightOfContainingBlock","groups":["CSS Logical Properties"],"initial":"auto","appliesto":"positionedElements","computed":"sameAsBoxOffsets","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/inset-block-start"},"inset-inline":{"syntax":"<\'top\'>{1,2}","media":"visual","inherited":false,"animationType":"lpc","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"auto","appliesto":"positionedElements","computed":"sameAsBoxOffsets","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/inset-inline"},"inset-inline-end":{"syntax":"<\'top\'>","media":"visual","inherited":false,"animationType":"lpc","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"auto","appliesto":"positionedElements","computed":"sameAsBoxOffsets","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/inset-inline-end"},"inset-inline-start":{"syntax":"<\'top\'>","media":"visual","inherited":false,"animationType":"lpc","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"auto","appliesto":"positionedElements","computed":"sameAsBoxOffsets","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/inset-inline-start"},"isolation":{"syntax":"auto | isolate","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Compositing and Blending"],"initial":"auto","appliesto":"allElementsSVGContainerGraphicsAndGraphicsReferencingElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/isolation"},"justify-content":{"syntax":"normal | <content-distribution> | <overflow-position>? [ <content-position> | left | right ]","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Alignment"],"initial":"normal","appliesto":"flexContainers","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/justify-content"},"justify-items":{"syntax":"normal | stretch | <baseline-position> | <overflow-position>? [ <self-position> | left | right ] | legacy | legacy && [ left | right | center ]","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Alignment"],"initial":"legacy","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/justify-items"},"justify-self":{"syntax":"auto | normal | stretch | <baseline-position> | <overflow-position>? [ <self-position> | left | right ]","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Alignment"],"initial":"auto","appliesto":"blockLevelBoxesAndAbsolutelyPositionedBoxesAndGridItems","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/justify-self"},"justify-tracks":{"syntax":"[ normal | <content-distribution> | <overflow-position>? [ <content-position> | left | right ] ]#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Grid Layout"],"initial":"normal","appliesto":"gridContainersWithMasonryLayoutInTheirInlineAxis","computed":"asSpecified","order":"uniqueOrder","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/justify-tracks"},"left":{"syntax":"<length> | <percentage> | auto","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToWidthOfContainingBlock","groups":["CSS Positioning"],"initial":"auto","appliesto":"positionedElements","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/left"},"letter-spacing":{"syntax":"normal | <length>","media":"visual","inherited":true,"animationType":"length","percentages":"no","groups":["CSS Text"],"initial":"normal","appliesto":"allElements","computed":"optimumValueOfAbsoluteLengthOrNormal","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/letter-spacing"},"line-break":{"syntax":"auto | loose | normal | strict | anywhere","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/line-break"},"line-clamp":{"syntax":"none | <integer>","media":"visual","inherited":false,"animationType":"integer","percentages":"no","groups":["CSS Overflow"],"initial":"none","appliesto":"blockContainersExceptMultiColumnContainers","computed":"asSpecified","order":"perGrammar","status":"experimental"},"line-height":{"syntax":"normal | <number> | <length> | <percentage>","media":"visual","inherited":true,"animationType":"numberOrLength","percentages":"referToElementFontSize","groups":["CSS Fonts"],"initial":"normal","appliesto":"allElements","computed":"absoluteLengthOrAsSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/line-height"},"line-height-step":{"syntax":"<length>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fonts"],"initial":"0","appliesto":"blockContainers","computed":"absoluteLength","order":"perGrammar","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/line-height-step"},"list-style":{"syntax":"<\'list-style-type\'> || <\'list-style-position\'> || <\'list-style-image\'>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Lists and Counters"],"initial":["list-style-type","list-style-position","list-style-image"],"appliesto":"listItems","computed":["list-style-image","list-style-position","list-style-type"],"order":"orderOfAppearance","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/list-style"},"list-style-image":{"syntax":"<url> | none","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Lists and Counters"],"initial":"none","appliesto":"listItems","computed":"noneOrImageWithAbsoluteURI","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/list-style-image"},"list-style-position":{"syntax":"inside | outside","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Lists and Counters"],"initial":"outside","appliesto":"listItems","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/list-style-position"},"list-style-type":{"syntax":"<counter-style> | <string> | none","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Lists and Counters"],"initial":"disc","appliesto":"listItems","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/list-style-type"},"margin":{"syntax":"[ <length> | <percentage> | auto ]{1,4}","media":"visual","inherited":false,"animationType":"length","percentages":"referToWidthOfContainingBlock","groups":["CSS Box Model"],"initial":["margin-bottom","margin-left","margin-right","margin-top"],"appliesto":"allElementsExceptTableDisplayTypes","computed":["margin-bottom","margin-left","margin-right","margin-top"],"order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/margin"},"margin-block":{"syntax":"<\'margin-left\'>{1,2}","media":"visual","inherited":false,"animationType":"discrete","percentages":"dependsOnLayoutModel","groups":["CSS Logical Properties"],"initial":"0","appliesto":"sameAsMargin","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/margin-block"},"margin-block-end":{"syntax":"<\'margin-left\'>","media":"visual","inherited":false,"animationType":"length","percentages":"dependsOnLayoutModel","groups":["CSS Logical Properties"],"initial":"0","appliesto":"sameAsMargin","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/margin-block-end"},"margin-block-start":{"syntax":"<\'margin-left\'>","media":"visual","inherited":false,"animationType":"length","percentages":"dependsOnLayoutModel","groups":["CSS Logical Properties"],"initial":"0","appliesto":"sameAsMargin","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/margin-block-start"},"margin-bottom":{"syntax":"<length> | <percentage> | auto","media":"visual","inherited":false,"animationType":"length","percentages":"referToWidthOfContainingBlock","groups":["CSS Box Model"],"initial":"0","appliesto":"allElementsExceptTableDisplayTypes","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/margin-bottom"},"margin-inline":{"syntax":"<\'margin-left\'>{1,2}","media":"visual","inherited":false,"animationType":"discrete","percentages":"dependsOnLayoutModel","groups":["CSS Logical Properties"],"initial":"0","appliesto":"sameAsMargin","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/margin-inline"},"margin-inline-end":{"syntax":"<\'margin-left\'>","media":"visual","inherited":false,"animationType":"length","percentages":"dependsOnLayoutModel","groups":["CSS Logical Properties"],"initial":"0","appliesto":"sameAsMargin","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/margin-inline-end"},"margin-inline-start":{"syntax":"<\'margin-left\'>","media":"visual","inherited":false,"animationType":"length","percentages":"dependsOnLayoutModel","groups":["CSS Logical Properties"],"initial":"0","appliesto":"sameAsMargin","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/margin-inline-start"},"margin-left":{"syntax":"<length> | <percentage> | auto","media":"visual","inherited":false,"animationType":"length","percentages":"referToWidthOfContainingBlock","groups":["CSS Box Model"],"initial":"0","appliesto":"allElementsExceptTableDisplayTypes","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/margin-left"},"margin-right":{"syntax":"<length> | <percentage> | auto","media":"visual","inherited":false,"animationType":"length","percentages":"referToWidthOfContainingBlock","groups":["CSS Box Model"],"initial":"0","appliesto":"allElementsExceptTableDisplayTypes","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/margin-right"},"margin-top":{"syntax":"<length> | <percentage> | auto","media":"visual","inherited":false,"animationType":"length","percentages":"referToWidthOfContainingBlock","groups":["CSS Box Model"],"initial":"0","appliesto":"allElementsExceptTableDisplayTypes","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/margin-top"},"margin-trim":{"syntax":"none | in-flow | all","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Model"],"initial":"none","appliesto":"blockContainersAndMultiColumnContainers","computed":"asSpecified","order":"perGrammar","alsoAppliesTo":["::first-letter","::first-line"],"status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/margin-trim"},"mask":{"syntax":"<mask-layer>#","media":"visual","inherited":false,"animationType":["mask-image","mask-mode","mask-repeat","mask-position","mask-clip","mask-origin","mask-size","mask-composite"],"percentages":["mask-position"],"groups":["CSS Masking"],"initial":["mask-image","mask-mode","mask-repeat","mask-position","mask-clip","mask-origin","mask-size","mask-composite"],"appliesto":"allElementsSVGContainerElements","computed":["mask-image","mask-mode","mask-repeat","mask-position","mask-clip","mask-origin","mask-size","mask-composite"],"order":"perGrammar","stacking":true,"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask"},"mask-border":{"syntax":"<\'mask-border-source\'> || <\'mask-border-slice\'> [ / <\'mask-border-width\'>? [ / <\'mask-border-outset\'> ]? ]? || <\'mask-border-repeat\'> || <\'mask-border-mode\'>","media":"visual","inherited":false,"animationType":["mask-border-mode","mask-border-outset","mask-border-repeat","mask-border-slice","mask-border-source","mask-border-width"],"percentages":["mask-border-slice","mask-border-width"],"groups":["CSS Masking"],"initial":["mask-border-mode","mask-border-outset","mask-border-repeat","mask-border-slice","mask-border-source","mask-border-width"],"appliesto":"allElementsSVGContainerElements","computed":["mask-border-mode","mask-border-outset","mask-border-repeat","mask-border-slice","mask-border-source","mask-border-width"],"order":"perGrammar","stacking":true,"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-border"},"mask-border-mode":{"syntax":"luminance | alpha","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Masking"],"initial":"alpha","appliesto":"allElementsSVGContainerElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-border-mode"},"mask-border-outset":{"syntax":"[ <length> | <number> ]{1,4}","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Masking"],"initial":"0","appliesto":"allElementsSVGContainerElements","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-border-outset"},"mask-border-repeat":{"syntax":"[ stretch | repeat | round | space ]{1,2}","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Masking"],"initial":"stretch","appliesto":"allElementsSVGContainerElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-border-repeat"},"mask-border-slice":{"syntax":"<number-percentage>{1,4} fill?","media":"visual","inherited":false,"animationType":"discrete","percentages":"referToSizeOfMaskBorderImage","groups":["CSS Masking"],"initial":"0","appliesto":"allElementsSVGContainerElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-border-slice"},"mask-border-source":{"syntax":"none | <image>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Masking"],"initial":"none","appliesto":"allElementsSVGContainerElements","computed":"asSpecifiedURLsAbsolute","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-border-source"},"mask-border-width":{"syntax":"[ <length-percentage> | <number> | auto ]{1,4}","media":"visual","inherited":false,"animationType":"discrete","percentages":"relativeToMaskBorderImageArea","groups":["CSS Masking"],"initial":"auto","appliesto":"allElementsSVGContainerElements","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-border-width"},"mask-clip":{"syntax":"[ <geometry-box> | no-clip ]#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Masking"],"initial":"border-box","appliesto":"allElementsSVGContainerElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-clip"},"mask-composite":{"syntax":"<compositing-operator>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Masking"],"initial":"add","appliesto":"allElementsSVGContainerElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-composite"},"mask-image":{"syntax":"<mask-reference>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Masking"],"initial":"none","appliesto":"allElementsSVGContainerElements","computed":"asSpecifiedURLsAbsolute","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-image"},"mask-mode":{"syntax":"<masking-mode>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Masking"],"initial":"match-source","appliesto":"allElementsSVGContainerElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-mode"},"mask-origin":{"syntax":"<geometry-box>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Masking"],"initial":"border-box","appliesto":"allElementsSVGContainerElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-origin"},"mask-position":{"syntax":"<position>#","media":"visual","inherited":false,"animationType":"repeatableListOfSimpleListOfLpc","percentages":"referToSizeOfMaskPaintingArea","groups":["CSS Masking"],"initial":"center","appliesto":"allElementsSVGContainerElements","computed":"consistsOfTwoKeywordsForOriginAndOffsets","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-position"},"mask-repeat":{"syntax":"<repeat-style>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Masking"],"initial":"no-repeat","appliesto":"allElementsSVGContainerElements","computed":"consistsOfTwoDimensionKeywords","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-repeat"},"mask-size":{"syntax":"<bg-size>#","media":"visual","inherited":false,"animationType":"repeatableListOfSimpleListOfLpc","percentages":"no","groups":["CSS Masking"],"initial":"auto","appliesto":"allElementsSVGContainerElements","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-size"},"mask-type":{"syntax":"luminance | alpha","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Masking"],"initial":"luminance","appliesto":"maskElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mask-type"},"masonry-auto-flow":{"syntax":"[ pack | next ] || [ definite-first | ordered ]","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Grid Layout"],"initial":"pack","appliesto":"gridContainersWithMasonryLayout","computed":"asSpecified","order":"uniqueOrder","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/masonry-auto-flow"},"math-style":{"syntax":"normal | compact","media":"visual","inherited":true,"animationType":"notAnimatable","percentages":"no","groups":["MathML"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/math-style"},"max-block-size":{"syntax":"<\'max-width\'>","media":"visual","inherited":false,"animationType":"lpc","percentages":"blockSizeOfContainingBlock","groups":["CSS Logical Properties"],"initial":"0","appliesto":"sameAsWidthAndHeight","computed":"sameAsMaxWidthAndMaxHeight","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/max-block-size"},"max-height":{"syntax":"none | <length-percentage> | min-content | max-content | fit-content(<length-percentage>)","media":"visual","inherited":false,"animationType":"lpc","percentages":"regardingHeightOfGeneratedBoxContainingBlockPercentagesNone","groups":["CSS Box Model"],"initial":"none","appliesto":"allElementsButNonReplacedAndTableColumns","computed":"percentageAsSpecifiedAbsoluteLengthOrNone","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/max-height"},"max-inline-size":{"syntax":"<\'max-width\'>","media":"visual","inherited":false,"animationType":"lpc","percentages":"inlineSizeOfContainingBlock","groups":["CSS Logical Properties"],"initial":"0","appliesto":"sameAsWidthAndHeight","computed":"sameAsMaxWidthAndMaxHeight","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/max-inline-size"},"max-lines":{"syntax":"none | <integer>","media":"visual","inherited":false,"animationType":"integer","percentages":"no","groups":["CSS Overflow"],"initial":"none","appliesto":"blockContainersExceptMultiColumnContainers","computed":"asSpecified","order":"perGrammar","status":"experimental"},"max-width":{"syntax":"none | <length-percentage> | min-content | max-content | fit-content(<length-percentage>)","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToWidthOfContainingBlock","groups":["CSS Box Model"],"initial":"none","appliesto":"allElementsButNonReplacedAndTableRows","computed":"percentageAsSpecifiedAbsoluteLengthOrNone","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/max-width"},"min-block-size":{"syntax":"<\'min-width\'>","media":"visual","inherited":false,"animationType":"lpc","percentages":"blockSizeOfContainingBlock","groups":["CSS Logical Properties"],"initial":"0","appliesto":"sameAsWidthAndHeight","computed":"sameAsMinWidthAndMinHeight","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/min-block-size"},"min-height":{"syntax":"auto | <length> | <percentage> | min-content | max-content | fit-content(<length-percentage>)","media":"visual","inherited":false,"animationType":"lpc","percentages":"regardingHeightOfGeneratedBoxContainingBlockPercentages0","groups":["CSS Box Model"],"initial":"auto","appliesto":"allElementsButNonReplacedAndTableColumns","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/min-height"},"min-inline-size":{"syntax":"<\'min-width\'>","media":"visual","inherited":false,"animationType":"lpc","percentages":"inlineSizeOfContainingBlock","groups":["CSS Logical Properties"],"initial":"0","appliesto":"sameAsWidthAndHeight","computed":"sameAsMinWidthAndMinHeight","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/min-inline-size"},"min-width":{"syntax":"auto | <length> | <percentage> | min-content | max-content | fit-content(<length-percentage>)","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToWidthOfContainingBlock","groups":["CSS Box Model"],"initial":"auto","appliesto":"allElementsButNonReplacedAndTableRows","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/min-width"},"mix-blend-mode":{"syntax":"<blend-mode>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Compositing and Blending"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","stacking":true,"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/mix-blend-mode"},"object-fit":{"syntax":"fill | contain | cover | none | scale-down","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Images"],"initial":"fill","appliesto":"replacedElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/object-fit"},"object-position":{"syntax":"<position>","media":"visual","inherited":true,"animationType":"repeatableListOfSimpleListOfLpc","percentages":"referToWidthAndHeightOfElement","groups":["CSS Images"],"initial":"50% 50%","appliesto":"replacedElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/object-position"},"offset":{"syntax":"[ <\'offset-position\'>? [ <\'offset-path\'> [ <\'offset-distance\'> || <\'offset-rotate\'> ]? ]? ]! [ / <\'offset-anchor\'> ]?","media":"visual","inherited":false,"animationType":["offset-position","offset-path","offset-distance","offset-anchor","offset-rotate"],"percentages":["offset-position","offset-distance","offset-anchor"],"groups":["CSS Motion Path"],"initial":["offset-position","offset-path","offset-distance","offset-anchor","offset-rotate"],"appliesto":"transformableElements","computed":["offset-position","offset-path","offset-distance","offset-anchor","offset-rotate"],"order":"perGrammar","stacking":true,"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/offset"},"offset-anchor":{"syntax":"auto | <position>","media":"visual","inherited":false,"animationType":"position","percentages":"relativeToWidthAndHeight","groups":["CSS Motion Path"],"initial":"auto","appliesto":"transformableElements","computed":"forLengthAbsoluteValueOtherwisePercentage","order":"perGrammar","status":"standard"},"offset-distance":{"syntax":"<length-percentage>","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToTotalPathLength","groups":["CSS Motion Path"],"initial":"0","appliesto":"transformableElements","computed":"forLengthAbsoluteValueOtherwisePercentage","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/offset-distance"},"offset-path":{"syntax":"none | ray( [ <angle> && <size> && contain? ] ) | <path()> | <url> | [ <basic-shape> || <geometry-box> ]","media":"visual","inherited":false,"animationType":"angleOrBasicShapeOrPath","percentages":"no","groups":["CSS Motion Path"],"initial":"none","appliesto":"transformableElements","computed":"asSpecified","order":"perGrammar","stacking":true,"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/offset-path"},"offset-position":{"syntax":"auto | <position>","media":"visual","inherited":false,"animationType":"position","percentages":"referToSizeOfContainingBlock","groups":["CSS Motion Path"],"initial":"auto","appliesto":"transformableElements","computed":"forLengthAbsoluteValueOtherwisePercentage","order":"perGrammar","status":"experimental"},"offset-rotate":{"syntax":"[ auto | reverse ] || <angle>","media":"visual","inherited":false,"animationType":"angleOrBasicShapeOrPath","percentages":"no","groups":["CSS Motion Path"],"initial":"auto","appliesto":"transformableElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/offset-rotate"},"opacity":{"syntax":"<alpha-value>","media":"visual","inherited":false,"animationType":"number","percentages":"no","groups":["CSS Color"],"initial":"1.0","appliesto":"allElements","computed":"specifiedValueClipped0To1","order":"uniqueOrder","alsoAppliesTo":["::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/opacity"},"order":{"syntax":"<integer>","media":"visual","inherited":false,"animationType":"integer","percentages":"no","groups":["CSS Flexible Box Layout"],"initial":"0","appliesto":"flexItemsGridItemsAbsolutelyPositionedContainerChildren","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/order"},"orphans":{"syntax":"<integer>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fragmentation"],"initial":"2","appliesto":"blockContainerElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/orphans"},"outline":{"syntax":"[ <\'outline-color\'> || <\'outline-style\'> || <\'outline-width\'> ]","media":["visual","interactive"],"inherited":false,"animationType":["outline-color","outline-width","outline-style"],"percentages":"no","groups":["CSS Basic User Interface"],"initial":["outline-color","outline-style","outline-width"],"appliesto":"allElements","computed":["outline-color","outline-width","outline-style"],"order":"orderOfAppearance","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/outline"},"outline-color":{"syntax":"<color> | invert","media":["visual","interactive"],"inherited":false,"animationType":"color","percentages":"no","groups":["CSS Basic User Interface"],"initial":"invertOrCurrentColor","appliesto":"allElements","computed":"invertForTranslucentColorRGBAOtherwiseRGB","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/outline-color"},"outline-offset":{"syntax":"<length>","media":["visual","interactive"],"inherited":false,"animationType":"length","percentages":"no","groups":["CSS Basic User Interface"],"initial":"0","appliesto":"allElements","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/outline-offset"},"outline-style":{"syntax":"auto | <\'border-style\'>","media":["visual","interactive"],"inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Basic User Interface"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/outline-style"},"outline-width":{"syntax":"<line-width>","media":["visual","interactive"],"inherited":false,"animationType":"length","percentages":"no","groups":["CSS Basic User Interface"],"initial":"medium","appliesto":"allElements","computed":"absoluteLength0ForNone","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/outline-width"},"overflow":{"syntax":"[ visible | hidden | clip | scroll | auto ]{1,2}","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Overflow"],"initial":"visible","appliesto":"blockContainersFlexContainersGridContainers","computed":["overflow-x","overflow-y"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/overflow"},"overflow-anchor":{"syntax":"auto | none","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Scroll Anchoring"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard"},"overflow-block":{"syntax":"visible | hidden | clip | scroll | auto","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Overflow"],"initial":"auto","appliesto":"blockContainersFlexContainersGridContainers","computed":"asSpecifiedButVisibleOrClipReplacedToAutoOrHiddenIfOtherValueDifferent","order":"perGrammar","status":"standard"},"overflow-clip-box":{"syntax":"padding-box | content-box","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Mozilla Extensions"],"initial":"padding-box","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Mozilla/CSS/overflow-clip-box"},"overflow-inline":{"syntax":"visible | hidden | clip | scroll | auto","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Overflow"],"initial":"auto","appliesto":"blockContainersFlexContainersGridContainers","computed":"asSpecifiedButVisibleOrClipReplacedToAutoOrHiddenIfOtherValueDifferent","order":"perGrammar","status":"standard"},"overflow-wrap":{"syntax":"normal | break-word | anywhere","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text"],"initial":"normal","appliesto":"nonReplacedInlineElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/overflow-wrap"},"overflow-x":{"syntax":"visible | hidden | clip | scroll | auto","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Overflow"],"initial":"visible","appliesto":"blockContainersFlexContainersGridContainers","computed":"asSpecifiedButVisibleOrClipReplacedToAutoOrHiddenIfOtherValueDifferent","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/overflow-x"},"overflow-y":{"syntax":"visible | hidden | clip | scroll | auto","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Overflow"],"initial":"visible","appliesto":"blockContainersFlexContainersGridContainers","computed":"asSpecifiedButVisibleOrClipReplacedToAutoOrHiddenIfOtherValueDifferent","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/overflow-y"},"overscroll-behavior":{"syntax":"[ contain | none | auto ]{1,2}","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Model"],"initial":"auto","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/overscroll-behavior"},"overscroll-behavior-block":{"syntax":"contain | none | auto","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Model"],"initial":"auto","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/overscroll-behavior-block"},"overscroll-behavior-inline":{"syntax":"contain | none | auto","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Model"],"initial":"auto","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/overscroll-behavior-inline"},"overscroll-behavior-x":{"syntax":"contain | none | auto","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Model"],"initial":"auto","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/overscroll-behavior-x"},"overscroll-behavior-y":{"syntax":"contain | none | auto","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Model"],"initial":"auto","appliesto":"nonReplacedBlockAndInlineBlockElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/overscroll-behavior-y"},"padding":{"syntax":"[ <length> | <percentage> ]{1,4}","media":"visual","inherited":false,"animationType":"length","percentages":"referToWidthOfContainingBlock","groups":["CSS Box Model"],"initial":["padding-bottom","padding-left","padding-right","padding-top"],"appliesto":"allElementsExceptInternalTableDisplayTypes","computed":["padding-bottom","padding-left","padding-right","padding-top"],"order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/padding"},"padding-block":{"syntax":"<\'padding-left\'>{1,2}","media":"visual","inherited":false,"animationType":"discrete","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"0","appliesto":"allElements","computed":"asLength","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/padding-block"},"padding-block-end":{"syntax":"<\'padding-left\'>","media":"visual","inherited":false,"animationType":"length","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"0","appliesto":"allElements","computed":"asLength","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/padding-block-end"},"padding-block-start":{"syntax":"<\'padding-left\'>","media":"visual","inherited":false,"animationType":"length","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"0","appliesto":"allElements","computed":"asLength","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/padding-block-start"},"padding-bottom":{"syntax":"<length> | <percentage>","media":"visual","inherited":false,"animationType":"length","percentages":"referToWidthOfContainingBlock","groups":["CSS Box Model"],"initial":"0","appliesto":"allElementsExceptInternalTableDisplayTypes","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/padding-bottom"},"padding-inline":{"syntax":"<\'padding-left\'>{1,2}","media":"visual","inherited":false,"animationType":"discrete","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"0","appliesto":"allElements","computed":"asLength","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/padding-inline"},"padding-inline-end":{"syntax":"<\'padding-left\'>","media":"visual","inherited":false,"animationType":"length","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"0","appliesto":"allElements","computed":"asLength","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/padding-inline-end"},"padding-inline-start":{"syntax":"<\'padding-left\'>","media":"visual","inherited":false,"animationType":"length","percentages":"logicalWidthOfContainingBlock","groups":["CSS Logical Properties"],"initial":"0","appliesto":"allElements","computed":"asLength","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/padding-inline-start"},"padding-left":{"syntax":"<length> | <percentage>","media":"visual","inherited":false,"animationType":"length","percentages":"referToWidthOfContainingBlock","groups":["CSS Box Model"],"initial":"0","appliesto":"allElementsExceptInternalTableDisplayTypes","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/padding-left"},"padding-right":{"syntax":"<length> | <percentage>","media":"visual","inherited":false,"animationType":"length","percentages":"referToWidthOfContainingBlock","groups":["CSS Box Model"],"initial":"0","appliesto":"allElementsExceptInternalTableDisplayTypes","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/padding-right"},"padding-top":{"syntax":"<length> | <percentage>","media":"visual","inherited":false,"animationType":"length","percentages":"referToWidthOfContainingBlock","groups":["CSS Box Model"],"initial":"0","appliesto":"allElementsExceptInternalTableDisplayTypes","computed":"percentageAsSpecifiedOrAbsoluteLength","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/padding-top"},"page-break-after":{"syntax":"auto | always | avoid | left | right | recto | verso","media":["visual","paged"],"inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Pages"],"initial":"auto","appliesto":"blockElementsInNormalFlow","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/page-break-after"},"page-break-before":{"syntax":"auto | always | avoid | left | right | recto | verso","media":["visual","paged"],"inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Pages"],"initial":"auto","appliesto":"blockElementsInNormalFlow","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/page-break-before"},"page-break-inside":{"syntax":"auto | avoid","media":["visual","paged"],"inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Pages"],"initial":"auto","appliesto":"blockElementsInNormalFlow","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/page-break-inside"},"paint-order":{"syntax":"normal | [ fill || stroke || markers ]","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text"],"initial":"normal","appliesto":"textElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/paint-order"},"perspective":{"syntax":"none | <length>","media":"visual","inherited":false,"animationType":"length","percentages":"no","groups":["CSS Transforms"],"initial":"none","appliesto":"transformableElements","computed":"absoluteLengthOrNone","order":"uniqueOrder","stacking":true,"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/perspective"},"perspective-origin":{"syntax":"<position>","media":"visual","inherited":false,"animationType":"simpleListOfLpc","percentages":"referToSizeOfBoundingBox","groups":["CSS Transforms"],"initial":"50% 50%","appliesto":"transformableElements","computed":"forLengthAbsoluteValueOtherwisePercentage","order":"oneOrTwoValuesLengthAbsoluteKeywordsPercentages","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/perspective-origin"},"place-content":{"syntax":"<\'align-content\'> <\'justify-content\'>?","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Alignment"],"initial":"normal","appliesto":"multilineFlexContainers","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/place-content"},"place-items":{"syntax":"<\'align-items\'> <\'justify-items\'>?","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Alignment"],"initial":["align-items","justify-items"],"appliesto":"allElements","computed":["align-items","justify-items"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/place-items"},"place-self":{"syntax":"<\'align-self\'> <\'justify-self\'>?","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Box Alignment"],"initial":["align-self","justify-self"],"appliesto":"blockLevelBoxesAndAbsolutelyPositionedBoxesAndGridItems","computed":["align-self","justify-self"],"order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/place-self"},"pointer-events":{"syntax":"auto | none | visiblePainted | visibleFill | visibleStroke | visible | painted | fill | stroke | all | inherit","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["Pointer Events"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/pointer-events"},"position":{"syntax":"static | relative | absolute | sticky | fixed","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Positioning"],"initial":"static","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","stacking":true,"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/position"},"quotes":{"syntax":"none | auto | [ <string> <string> ]+","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Generated Content"],"initial":"dependsOnUserAgent","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/quotes"},"resize":{"syntax":"none | both | horizontal | vertical | block | inline","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Basic User Interface"],"initial":"none","appliesto":"elementsWithOverflowNotVisibleAndReplacedElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/resize"},"right":{"syntax":"<length> | <percentage> | auto","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToWidthOfContainingBlock","groups":["CSS Positioning"],"initial":"auto","appliesto":"positionedElements","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/right"},"rotate":{"syntax":"none | <angle> | [ x | y | z | <number>{3} ] && <angle>","media":"visual","inherited":false,"animationType":"transform","percentages":"no","groups":["CSS Transforms"],"initial":"none","appliesto":"transformableElements","computed":"asSpecified","order":"perGrammar","stacking":true,"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/rotate"},"row-gap":{"syntax":"normal | <length-percentage>","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToDimensionOfContentArea","groups":["CSS Box Alignment"],"initial":"normal","appliesto":"multiColumnElementsFlexContainersGridContainers","computed":"asSpecifiedWithLengthsAbsoluteAndNormalComputingToZeroExceptMultiColumn","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/row-gap"},"ruby-align":{"syntax":"start | center | space-between | space-around","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Ruby"],"initial":"space-around","appliesto":"rubyBasesAnnotationsBaseAnnotationContainers","computed":"asSpecified","order":"uniqueOrder","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/ruby-align"},"ruby-merge":{"syntax":"separate | collapse | auto","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Ruby"],"initial":"separate","appliesto":"rubyAnnotationsContainers","computed":"asSpecified","order":"uniqueOrder","status":"experimental"},"ruby-position":{"syntax":"over | under | inter-character","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Ruby"],"initial":"over","appliesto":"rubyAnnotationsContainers","computed":"asSpecified","order":"uniqueOrder","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/ruby-position"},"scale":{"syntax":"none | <number>{1,3}","media":"visual","inherited":false,"animationType":"transform","percentages":"no","groups":["CSS Transforms"],"initial":"none","appliesto":"transformableElements","computed":"asSpecified","order":"perGrammar","stacking":true,"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scale"},"scrollbar-color":{"syntax":"auto | dark | light | <color>{2}","media":"visual","inherited":true,"animationType":"color","percentages":"no","groups":["CSS Scrollbars"],"initial":"auto","appliesto":"scrollingBoxes","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scrollbar-color"},"scrollbar-gutter":{"syntax":"auto | [ stable | always ] && both? && force?","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Overflow"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scrollbar-gutter"},"scrollbar-width":{"syntax":"auto | thin | none","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Scrollbars"],"initial":"auto","appliesto":"scrollingBoxes","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scrollbar-width"},"scroll-behavior":{"syntax":"auto | smooth","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSSOM View"],"initial":"auto","appliesto":"scrollingBoxes","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-behavior"},"scroll-margin":{"syntax":"<length>{1,4}","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"no","groups":["CSS Scroll Snap"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-margin"},"scroll-margin-block":{"syntax":"<length>{1,2}","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"no","groups":["CSS Scroll Snap"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-margin-block"},"scroll-margin-block-start":{"syntax":"<length>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"no","groups":["CSS Scroll Snap"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-margin-block-start"},"scroll-margin-block-end":{"syntax":"<length>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"no","groups":["CSS Scroll Snap"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-margin-block-end"},"scroll-margin-bottom":{"syntax":"<length>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"no","groups":["CSS Scroll Snap"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-margin-bottom"},"scroll-margin-inline":{"syntax":"<length>{1,2}","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"no","groups":["CSS Scroll Snap"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-margin-inline"},"scroll-margin-inline-start":{"syntax":"<length>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"no","groups":["CSS Scroll Snap"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-margin-inline-start"},"scroll-margin-inline-end":{"syntax":"<length>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"no","groups":["CSS Scroll Snap"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-margin-inline-end"},"scroll-margin-left":{"syntax":"<length>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"no","groups":["CSS Scroll Snap"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-margin-left"},"scroll-margin-right":{"syntax":"<length>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"no","groups":["CSS Scroll Snap"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-margin-right"},"scroll-margin-top":{"syntax":"<length>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"no","groups":["CSS Scroll Snap"],"initial":"0","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-margin-top"},"scroll-padding":{"syntax":"[ auto | <length-percentage> ]{1,4}","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"relativeToTheScrollContainersScrollport","groups":["CSS Scroll Snap"],"initial":"auto","appliesto":"scrollContainers","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-padding"},"scroll-padding-block":{"syntax":"[ auto | <length-percentage> ]{1,2}","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"relativeToTheScrollContainersScrollport","groups":["CSS Scroll Snap"],"initial":"auto","appliesto":"scrollContainers","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-padding-block"},"scroll-padding-block-start":{"syntax":"auto | <length-percentage>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"relativeToTheScrollContainersScrollport","groups":["CSS Scroll Snap"],"initial":"auto","appliesto":"scrollContainers","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-padding-block-start"},"scroll-padding-block-end":{"syntax":"auto | <length-percentage>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"relativeToTheScrollContainersScrollport","groups":["CSS Scroll Snap"],"initial":"auto","appliesto":"scrollContainers","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-padding-block-end"},"scroll-padding-bottom":{"syntax":"auto | <length-percentage>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"relativeToTheScrollContainersScrollport","groups":["CSS Scroll Snap"],"initial":"auto","appliesto":"scrollContainers","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-padding-bottom"},"scroll-padding-inline":{"syntax":"[ auto | <length-percentage> ]{1,2}","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"relativeToTheScrollContainersScrollport","groups":["CSS Scroll Snap"],"initial":"auto","appliesto":"scrollContainers","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-padding-inline"},"scroll-padding-inline-start":{"syntax":"auto | <length-percentage>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"relativeToTheScrollContainersScrollport","groups":["CSS Scroll Snap"],"initial":"auto","appliesto":"scrollContainers","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-padding-inline-start"},"scroll-padding-inline-end":{"syntax":"auto | <length-percentage>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"relativeToTheScrollContainersScrollport","groups":["CSS Scroll Snap"],"initial":"auto","appliesto":"scrollContainers","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-padding-inline-end"},"scroll-padding-left":{"syntax":"auto | <length-percentage>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"relativeToTheScrollContainersScrollport","groups":["CSS Scroll Snap"],"initial":"auto","appliesto":"scrollContainers","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-padding-left"},"scroll-padding-right":{"syntax":"auto | <length-percentage>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"relativeToTheScrollContainersScrollport","groups":["CSS Scroll Snap"],"initial":"auto","appliesto":"scrollContainers","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-padding-right"},"scroll-padding-top":{"syntax":"auto | <length-percentage>","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"relativeToTheScrollContainersScrollport","groups":["CSS Scroll Snap"],"initial":"auto","appliesto":"scrollContainers","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-padding-top"},"scroll-snap-align":{"syntax":"[ none | start | end | center ]{1,2}","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Scroll Snap"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-snap-align"},"scroll-snap-coordinate":{"syntax":"none | <position>#","media":"interactive","inherited":false,"animationType":"position","percentages":"referToBorderBox","groups":["CSS Scroll Snap"],"initial":"none","appliesto":"allElements","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","status":"obsolete","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-snap-coordinate"},"scroll-snap-destination":{"syntax":"<position>","media":"interactive","inherited":false,"animationType":"position","percentages":"relativeToScrollContainerPaddingBoxAxis","groups":["CSS Scroll Snap"],"initial":"0px 0px","appliesto":"scrollContainers","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","status":"obsolete","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-snap-destination"},"scroll-snap-points-x":{"syntax":"none | repeat( <length-percentage> )","media":"interactive","inherited":false,"animationType":"discrete","percentages":"relativeToScrollContainerPaddingBoxAxis","groups":["CSS Scroll Snap"],"initial":"none","appliesto":"scrollContainers","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","status":"obsolete","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-snap-points-x"},"scroll-snap-points-y":{"syntax":"none | repeat( <length-percentage> )","media":"interactive","inherited":false,"animationType":"discrete","percentages":"relativeToScrollContainerPaddingBoxAxis","groups":["CSS Scroll Snap"],"initial":"none","appliesto":"scrollContainers","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","status":"obsolete","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-snap-points-y"},"scroll-snap-stop":{"syntax":"normal | always","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Scroll Snap"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-snap-stop"},"scroll-snap-type":{"syntax":"none | [ x | y | block | inline | both ] [ mandatory | proximity ]?","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Scroll Snap"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-snap-type"},"scroll-snap-type-x":{"syntax":"none | mandatory | proximity","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Scroll Snap"],"initial":"none","appliesto":"scrollContainers","computed":"asSpecified","order":"uniqueOrder","status":"obsolete","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-snap-type-x"},"scroll-snap-type-y":{"syntax":"none | mandatory | proximity","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Scroll Snap"],"initial":"none","appliesto":"scrollContainers","computed":"asSpecified","order":"uniqueOrder","status":"obsolete","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/scroll-snap-type-y"},"shape-image-threshold":{"syntax":"<alpha-value>","media":"visual","inherited":false,"animationType":"number","percentages":"no","groups":["CSS Shapes"],"initial":"0.0","appliesto":"floats","computed":"specifiedValueNumberClipped0To1","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/shape-image-threshold"},"shape-margin":{"syntax":"<length-percentage>","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToWidthOfContainingBlock","groups":["CSS Shapes"],"initial":"0","appliesto":"floats","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/shape-margin"},"shape-outside":{"syntax":"none | <shape-box> || <basic-shape> | <image>","media":"visual","inherited":false,"animationType":"basicShapeOtherwiseNo","percentages":"no","groups":["CSS Shapes"],"initial":"none","appliesto":"floats","computed":"asDefinedForBasicShapeWithAbsoluteURIOtherwiseAsSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/shape-outside"},"tab-size":{"syntax":"<integer> | <length>","media":"visual","inherited":true,"animationType":"length","percentages":"no","groups":["CSS Text"],"initial":"8","appliesto":"blockContainers","computed":"specifiedIntegerOrAbsoluteLength","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/tab-size"},"table-layout":{"syntax":"auto | fixed","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Table"],"initial":"auto","appliesto":"tableElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/table-layout"},"text-align":{"syntax":"start | end | left | right | center | justify | match-parent","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text"],"initial":"startOrNamelessValueIfLTRRightIfRTL","appliesto":"blockContainers","computed":"asSpecifiedExceptMatchParent","order":"orderOfAppearance","alsoAppliesTo":["::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-align"},"text-align-last":{"syntax":"auto | start | end | left | right | center | justify","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text"],"initial":"auto","appliesto":"blockContainers","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-align-last"},"text-combine-upright":{"syntax":"none | all | [ digits <integer>? ]","media":"visual","inherited":true,"animationType":"notAnimatable","percentages":"no","groups":["CSS Writing Modes"],"initial":"none","appliesto":"nonReplacedInlineElements","computed":"keywordPlusIntegerIfDigits","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-combine-upright"},"text-decoration":{"syntax":"<\'text-decoration-line\'> || <\'text-decoration-style\'> || <\'text-decoration-color\'> || <\'text-decoration-thickness\'>","media":"visual","inherited":false,"animationType":["text-decoration-color","text-decoration-style","text-decoration-line","text-decoration-thickness"],"percentages":"no","groups":["CSS Text Decoration"],"initial":["text-decoration-color","text-decoration-style","text-decoration-line"],"appliesto":"allElements","computed":["text-decoration-line","text-decoration-style","text-decoration-color","text-decoration-thickness"],"order":"orderOfAppearance","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-decoration"},"text-decoration-color":{"syntax":"<color>","media":"visual","inherited":false,"animationType":"color","percentages":"no","groups":["CSS Text Decoration"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-decoration-color"},"text-decoration-line":{"syntax":"none | [ underline || overline || line-through || blink ] | spelling-error | grammar-error","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Text Decoration"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-decoration-line"},"text-decoration-skip":{"syntax":"none | [ objects || [ spaces | [ leading-spaces || trailing-spaces ] ] || edges || box-decoration ]","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text Decoration"],"initial":"objects","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-decoration-skip"},"text-decoration-skip-ink":{"syntax":"auto | all | none","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text Decoration"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-decoration-skip-ink"},"text-decoration-style":{"syntax":"solid | double | dotted | dashed | wavy","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Text Decoration"],"initial":"solid","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-decoration-style"},"text-decoration-thickness":{"syntax":"auto | from-font | <length> | <percentage> ","media":"visual","inherited":false,"animationType":"byComputedValueType","percentages":"referToElementFontSize","groups":["CSS Text Decoration"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-decoration-thickness"},"text-emphasis":{"syntax":"<\'text-emphasis-style\'> || <\'text-emphasis-color\'>","media":"visual","inherited":false,"animationType":["text-emphasis-color","text-emphasis-style"],"percentages":"no","groups":["CSS Text Decoration"],"initial":["text-emphasis-style","text-emphasis-color"],"appliesto":"allElements","computed":["text-emphasis-style","text-emphasis-color"],"order":"orderOfAppearance","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-emphasis"},"text-emphasis-color":{"syntax":"<color>","media":"visual","inherited":false,"animationType":"color","percentages":"no","groups":["CSS Text Decoration"],"initial":"currentcolor","appliesto":"allElements","computed":"computedColor","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-emphasis-color"},"text-emphasis-position":{"syntax":"[ over | under ] && [ right | left ]","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Text Decoration"],"initial":"over right","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-emphasis-position"},"text-emphasis-style":{"syntax":"none | [ [ filled | open ] || [ dot | circle | double-circle | triangle | sesame ] ] | <string>","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Text Decoration"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-emphasis-style"},"text-indent":{"syntax":"<length-percentage> && hanging? && each-line?","media":"visual","inherited":true,"animationType":"lpc","percentages":"referToWidthOfContainingBlock","groups":["CSS Text"],"initial":"0","appliesto":"blockContainers","computed":"percentageOrAbsoluteLengthPlusKeywords","order":"lengthOrPercentageBeforeKeywords","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-indent"},"text-justify":{"syntax":"auto | inter-character | inter-word | none","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text"],"initial":"auto","appliesto":"inlineLevelAndTableCellElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-justify"},"text-orientation":{"syntax":"mixed | upright | sideways","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Writing Modes"],"initial":"mixed","appliesto":"allElementsExceptTableRowGroupsRowsColumnGroupsAndColumns","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-orientation"},"text-overflow":{"syntax":"[ clip | ellipsis | <string> ]{1,2}","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Basic User Interface"],"initial":"clip","appliesto":"blockContainerElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-overflow"},"text-rendering":{"syntax":"auto | optimizeSpeed | optimizeLegibility | geometricPrecision","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Miscellaneous"],"initial":"auto","appliesto":"textElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-rendering"},"text-shadow":{"syntax":"none | <shadow-t>#","media":"visual","inherited":true,"animationType":"shadowList","percentages":"no","groups":["CSS Text Decoration"],"initial":"none","appliesto":"allElements","computed":"colorPlusThreeAbsoluteLengths","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-shadow"},"text-size-adjust":{"syntax":"none | auto | <percentage>","media":"visual","inherited":true,"animationType":"discrete","percentages":"referToSizeOfFont","groups":["CSS Text"],"initial":"autoForSmartphoneBrowsersSupportingInflation","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"experimental","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-size-adjust"},"text-transform":{"syntax":"none | capitalize | uppercase | lowercase | full-width | full-size-kana","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text"],"initial":"none","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-transform"},"text-underline-offset":{"syntax":"auto | <length> | <percentage> ","media":"visual","inherited":true,"animationType":"byComputedValueType","percentages":"referToElementFontSize","groups":["CSS Text Decoration"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-underline-offset"},"text-underline-position":{"syntax":"auto | from-font | [ under || [ left | right ] ]","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text Decoration"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"orderOfAppearance","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/text-underline-position"},"top":{"syntax":"<length> | <percentage> | auto","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToContainingBlockHeight","groups":["CSS Positioning"],"initial":"auto","appliesto":"positionedElements","computed":"lengthAbsolutePercentageAsSpecifiedOtherwiseAuto","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/top"},"touch-action":{"syntax":"auto | none | [ [ pan-x | pan-left | pan-right ] || [ pan-y | pan-up | pan-down ] || pinch-zoom ] | manipulation","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["Pointer Events"],"initial":"auto","appliesto":"allElementsExceptNonReplacedInlineElementsTableRowsColumnsRowColumnGroups","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/touch-action"},"transform":{"syntax":"none | <transform-list>","media":"visual","inherited":false,"animationType":"transform","percentages":"referToSizeOfBoundingBox","groups":["CSS Transforms"],"initial":"none","appliesto":"transformableElements","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"uniqueOrder","stacking":true,"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/transform"},"transform-box":{"syntax":"content-box | border-box | fill-box | stroke-box | view-box","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Transforms"],"initial":"view-box","appliesto":"transformableElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/transform-box"},"transform-origin":{"syntax":"[ <length-percentage> | left | center | right | top | bottom ] | [ [ <length-percentage> | left | center | right ] && [ <length-percentage> | top | center | bottom ] ] <length>?","media":"visual","inherited":false,"animationType":"simpleListOfLpc","percentages":"referToSizeOfBoundingBox","groups":["CSS Transforms"],"initial":"50% 50% 0","appliesto":"transformableElements","computed":"forLengthAbsoluteValueOtherwisePercentage","order":"oneOrTwoValuesLengthAbsoluteKeywordsPercentages","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/transform-origin"},"transform-style":{"syntax":"flat | preserve-3d","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Transforms"],"initial":"flat","appliesto":"transformableElements","computed":"asSpecified","order":"uniqueOrder","stacking":true,"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/transform-style"},"transition":{"syntax":"<single-transition>#","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Transitions"],"initial":["transition-delay","transition-duration","transition-property","transition-timing-function"],"appliesto":"allElementsAndPseudos","computed":["transition-delay","transition-duration","transition-property","transition-timing-function"],"order":"orderOfAppearance","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/transition"},"transition-delay":{"syntax":"<time>#","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Transitions"],"initial":"0s","appliesto":"allElementsAndPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/transition-delay"},"transition-duration":{"syntax":"<time>#","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Transitions"],"initial":"0s","appliesto":"allElementsAndPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/transition-duration"},"transition-property":{"syntax":"none | <single-transition-property>#","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Transitions"],"initial":"all","appliesto":"allElementsAndPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/transition-property"},"transition-timing-function":{"syntax":"<timing-function>#","media":"interactive","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Transitions"],"initial":"ease","appliesto":"allElementsAndPseudos","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/transition-timing-function"},"translate":{"syntax":"none | <length-percentage> [ <length-percentage> <length>? ]?","media":"visual","inherited":false,"animationType":"transform","percentages":"referToSizeOfBoundingBox","groups":["CSS Transforms"],"initial":"none","appliesto":"transformableElements","computed":"asSpecifiedRelativeToAbsoluteLengths","order":"perGrammar","stacking":true,"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/translate"},"unicode-bidi":{"syntax":"normal | embed | isolate | bidi-override | isolate-override | plaintext","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Writing Modes"],"initial":"normal","appliesto":"allElementsSomeValuesNoEffectOnNonInlineElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/unicode-bidi"},"user-select":{"syntax":"auto | text | none | contain | all","media":"visual","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Basic User Interface"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/user-select"},"vertical-align":{"syntax":"baseline | sub | super | text-top | text-bottom | middle | top | bottom | <percentage> | <length>","media":"visual","inherited":false,"animationType":"length","percentages":"referToLineHeight","groups":["CSS Table"],"initial":"baseline","appliesto":"inlineLevelAndTableCellElements","computed":"absoluteLengthOrKeyword","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/vertical-align"},"visibility":{"syntax":"visible | hidden | collapse","media":"visual","inherited":true,"animationType":"visibility","percentages":"no","groups":["CSS Box Model"],"initial":"visible","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/visibility"},"white-space":{"syntax":"normal | pre | nowrap | pre-wrap | pre-line | break-spaces","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/white-space"},"widows":{"syntax":"<integer>","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Fragmentation"],"initial":"2","appliesto":"blockContainerElements","computed":"asSpecified","order":"perGrammar","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/widows"},"width":{"syntax":"auto | <length> | <percentage> | min-content | max-content | fit-content(<length-percentage>)","media":"visual","inherited":false,"animationType":"lpc","percentages":"referToWidthOfContainingBlock","groups":["CSS Box Model"],"initial":"auto","appliesto":"allElementsButNonReplacedAndTableRows","computed":"percentageAutoOrAbsoluteLength","order":"lengthOrPercentageBeforeKeywordIfBothPresent","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/width"},"will-change":{"syntax":"auto | <animateable-feature>#","media":"all","inherited":false,"animationType":"discrete","percentages":"no","groups":["CSS Will Change"],"initial":"auto","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/will-change"},"word-break":{"syntax":"normal | break-all | keep-all | break-word","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/word-break"},"word-spacing":{"syntax":"normal | <length-percentage>","media":"visual","inherited":true,"animationType":"length","percentages":"referToWidthOfAffectedGlyph","groups":["CSS Text"],"initial":"normal","appliesto":"allElements","computed":"optimumMinAndMaxValueOfAbsoluteLengthPercentageOrNormal","order":"uniqueOrder","alsoAppliesTo":["::first-letter","::first-line","::placeholder"],"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/word-spacing"},"word-wrap":{"syntax":"normal | break-word","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Text"],"initial":"normal","appliesto":"nonReplacedInlineElements","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/overflow-wrap"},"writing-mode":{"syntax":"horizontal-tb | vertical-rl | vertical-lr | sideways-rl | sideways-lr","media":"visual","inherited":true,"animationType":"discrete","percentages":"no","groups":["CSS Writing Modes"],"initial":"horizontal-tb","appliesto":"allElementsExceptTableRowColumnGroupsTableRowsColumns","computed":"asSpecified","order":"uniqueOrder","status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/writing-mode"},"z-index":{"syntax":"auto | <integer>","media":"visual","inherited":false,"animationType":"integer","percentages":"no","groups":["CSS Positioning"],"initial":"auto","appliesto":"positionedElements","computed":"asSpecified","order":"uniqueOrder","stacking":true,"status":"standard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/z-index"},"zoom":{"syntax":"normal | reset | <number> | <percentage>","media":"visual","inherited":false,"animationType":"integer","percentages":"no","groups":["Microsoft Extensions"],"initial":"normal","appliesto":"allElements","computed":"asSpecified","order":"uniqueOrder","status":"nonstandard","mdn_url":"https://developer.mozilla.org/docs/Web/CSS/zoom"}}');

/***/ }),

/***/ "./node_modules/mdn-data/css/syntaxes.json":
/*!*************************************************!*\
  !*** ./node_modules/mdn-data/css/syntaxes.json ***!
  \*************************************************/
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"absolute-size":{"syntax":"xx-small | x-small | small | medium | large | x-large | xx-large | xxx-large"},"alpha-value":{"syntax":"<number> | <percentage>"},"angle-percentage":{"syntax":"<angle> | <percentage>"},"angular-color-hint":{"syntax":"<angle-percentage>"},"angular-color-stop":{"syntax":"<color> && <color-stop-angle>?"},"angular-color-stop-list":{"syntax":"[ <angular-color-stop> [, <angular-color-hint>]? ]# , <angular-color-stop>"},"animateable-feature":{"syntax":"scroll-position | contents | <custom-ident>"},"attachment":{"syntax":"scroll | fixed | local"},"attr()":{"syntax":"attr( <attr-name> <type-or-unit>? [, <attr-fallback> ]? )"},"attr-matcher":{"syntax":"[ \'~\' | \'|\' | \'^\' | \'$\' | \'*\' ]? \'=\'"},"attr-modifier":{"syntax":"i | s"},"attribute-selector":{"syntax":"\'[\' <wq-name> \']\' | \'[\' <wq-name> <attr-matcher> [ <string-token> | <ident-token> ] <attr-modifier>? \']\'"},"auto-repeat":{"syntax":"repeat( [ auto-fill | auto-fit ] , [ <line-names>? <fixed-size> ]+ <line-names>? )"},"auto-track-list":{"syntax":"[ <line-names>? [ <fixed-size> | <fixed-repeat> ] ]* <line-names>? <auto-repeat>\\n[ <line-names>? [ <fixed-size> | <fixed-repeat> ] ]* <line-names>?"},"baseline-position":{"syntax":"[ first | last ]? baseline"},"basic-shape":{"syntax":"<inset()> | <circle()> | <ellipse()> | <polygon()> | <path()>"},"bg-image":{"syntax":"none | <image>"},"bg-layer":{"syntax":"<bg-image> || <bg-position> [ / <bg-size> ]? || <repeat-style> || <attachment> || <box> || <box>"},"bg-position":{"syntax":"[ [ left | center | right | top | bottom | <length-percentage> ] | [ left | center | right | <length-percentage> ] [ top | center | bottom | <length-percentage> ] | [ center | [ left | right ] <length-percentage>? ] && [ center | [ top | bottom ] <length-percentage>? ] ]"},"bg-size":{"syntax":"[ <length-percentage> | auto ]{1,2} | cover | contain"},"blur()":{"syntax":"blur( <length> )"},"blend-mode":{"syntax":"normal | multiply | screen | overlay | darken | lighten | color-dodge | color-burn | hard-light | soft-light | difference | exclusion | hue | saturation | color | luminosity"},"box":{"syntax":"border-box | padding-box | content-box"},"brightness()":{"syntax":"brightness( <number-percentage> )"},"calc()":{"syntax":"calc( <calc-sum> )"},"calc-sum":{"syntax":"<calc-product> [ [ \'+\' | \'-\' ] <calc-product> ]*"},"calc-product":{"syntax":"<calc-value> [ \'*\' <calc-value> | \'/\' <number> ]*"},"calc-value":{"syntax":"<number> | <dimension> | <percentage> | ( <calc-sum> )"},"cf-final-image":{"syntax":"<image> | <color>"},"cf-mixing-image":{"syntax":"<percentage>? && <image>"},"circle()":{"syntax":"circle( [ <shape-radius> ]? [ at <position> ]? )"},"clamp()":{"syntax":"clamp( <calc-sum>#{3} )"},"class-selector":{"syntax":"\'.\' <ident-token>"},"clip-source":{"syntax":"<url>"},"color":{"syntax":"<rgb()> | <rgba()> | <hsl()> | <hsla()> | <hex-color> | <named-color> | currentcolor | <deprecated-system-color>"},"color-stop":{"syntax":"<color-stop-length> | <color-stop-angle>"},"color-stop-angle":{"syntax":"<angle-percentage>{1,2}"},"color-stop-length":{"syntax":"<length-percentage>{1,2}"},"color-stop-list":{"syntax":"[ <linear-color-stop> [, <linear-color-hint>]? ]# , <linear-color-stop>"},"combinator":{"syntax":"\'>\' | \'+\' | \'~\' | [ \'||\' ]"},"common-lig-values":{"syntax":"[ common-ligatures | no-common-ligatures ]"},"compat-auto":{"syntax":"searchfield | textarea | push-button | slider-horizontal | checkbox | radio | square-button | menulist | listbox | meter | progress-bar | button"},"composite-style":{"syntax":"clear | copy | source-over | source-in | source-out | source-atop | destination-over | destination-in | destination-out | destination-atop | xor"},"compositing-operator":{"syntax":"add | subtract | intersect | exclude"},"compound-selector":{"syntax":"[ <type-selector>? <subclass-selector>* [ <pseudo-element-selector> <pseudo-class-selector>* ]* ]!"},"compound-selector-list":{"syntax":"<compound-selector>#"},"complex-selector":{"syntax":"<compound-selector> [ <combinator>? <compound-selector> ]*"},"complex-selector-list":{"syntax":"<complex-selector>#"},"conic-gradient()":{"syntax":"conic-gradient( [ from <angle> ]? [ at <position> ]?, <angular-color-stop-list> )"},"contextual-alt-values":{"syntax":"[ contextual | no-contextual ]"},"content-distribution":{"syntax":"space-between | space-around | space-evenly | stretch"},"content-list":{"syntax":"[ <string> | contents | <image> | <quote> | <target> | <leader()> ]+"},"content-position":{"syntax":"center | start | end | flex-start | flex-end"},"content-replacement":{"syntax":"<image>"},"contrast()":{"syntax":"contrast( [ <number-percentage> ] )"},"counter()":{"syntax":"counter( <custom-ident>, <counter-style>? )"},"counter-style":{"syntax":"<counter-style-name> | symbols()"},"counter-style-name":{"syntax":"<custom-ident>"},"counters()":{"syntax":"counters( <custom-ident>, <string>, <counter-style>? )"},"cross-fade()":{"syntax":"cross-fade( <cf-mixing-image> , <cf-final-image>? )"},"cubic-bezier-timing-function":{"syntax":"ease | ease-in | ease-out | ease-in-out | cubic-bezier(<number [0,1]>, <number>, <number [0,1]>, <number>)"},"deprecated-system-color":{"syntax":"ActiveBorder | ActiveCaption | AppWorkspace | Background | ButtonFace | ButtonHighlight | ButtonShadow | ButtonText | CaptionText | GrayText | Highlight | HighlightText | InactiveBorder | InactiveCaption | InactiveCaptionText | InfoBackground | InfoText | Menu | MenuText | Scrollbar | ThreeDDarkShadow | ThreeDFace | ThreeDHighlight | ThreeDLightShadow | ThreeDShadow | Window | WindowFrame | WindowText"},"discretionary-lig-values":{"syntax":"[ discretionary-ligatures | no-discretionary-ligatures ]"},"display-box":{"syntax":"contents | none"},"display-inside":{"syntax":"flow | flow-root | table | flex | grid | ruby"},"display-internal":{"syntax":"table-row-group | table-header-group | table-footer-group | table-row | table-cell | table-column-group | table-column | table-caption | ruby-base | ruby-text | ruby-base-container | ruby-text-container"},"display-legacy":{"syntax":"inline-block | inline-list-item | inline-table | inline-flex | inline-grid"},"display-listitem":{"syntax":"<display-outside>? && [ flow | flow-root ]? && list-item"},"display-outside":{"syntax":"block | inline | run-in"},"drop-shadow()":{"syntax":"drop-shadow( <length>{2,3} <color>? )"},"east-asian-variant-values":{"syntax":"[ jis78 | jis83 | jis90 | jis04 | simplified | traditional ]"},"east-asian-width-values":{"syntax":"[ full-width | proportional-width ]"},"element()":{"syntax":"element( <id-selector> )"},"ellipse()":{"syntax":"ellipse( [ <shape-radius>{2} ]? [ at <position> ]? )"},"ending-shape":{"syntax":"circle | ellipse"},"env()":{"syntax":"env( <custom-ident> , <declaration-value>? )"},"explicit-track-list":{"syntax":"[ <line-names>? <track-size> ]+ <line-names>?"},"family-name":{"syntax":"<string> | <custom-ident>+"},"feature-tag-value":{"syntax":"<string> [ <integer> | on | off ]?"},"feature-type":{"syntax":"@stylistic | @historical-forms | @styleset | @character-variant | @swash | @ornaments | @annotation"},"feature-value-block":{"syntax":"<feature-type> \'{\' <feature-value-declaration-list> \'}\'"},"feature-value-block-list":{"syntax":"<feature-value-block>+"},"feature-value-declaration":{"syntax":"<custom-ident>: <integer>+;"},"feature-value-declaration-list":{"syntax":"<feature-value-declaration>"},"feature-value-name":{"syntax":"<custom-ident>"},"fill-rule":{"syntax":"nonzero | evenodd"},"filter-function":{"syntax":"<blur()> | <brightness()> | <contrast()> | <drop-shadow()> | <grayscale()> | <hue-rotate()> | <invert()> | <opacity()> | <saturate()> | <sepia()>"},"filter-function-list":{"syntax":"[ <filter-function> | <url> ]+"},"final-bg-layer":{"syntax":"<\'background-color\'> || <bg-image> || <bg-position> [ / <bg-size> ]? || <repeat-style> || <attachment> || <box> || <box>"},"fit-content()":{"syntax":"fit-content( [ <length> | <percentage> ] )"},"fixed-breadth":{"syntax":"<length-percentage>"},"fixed-repeat":{"syntax":"repeat( [ <positive-integer> ] , [ <line-names>? <fixed-size> ]+ <line-names>? )"},"fixed-size":{"syntax":"<fixed-breadth> | minmax( <fixed-breadth> , <track-breadth> ) | minmax( <inflexible-breadth> , <fixed-breadth> )"},"font-stretch-absolute":{"syntax":"normal | ultra-condensed | extra-condensed | condensed | semi-condensed | semi-expanded | expanded | extra-expanded | ultra-expanded | <percentage>"},"font-variant-css21":{"syntax":"[ normal | small-caps ]"},"font-weight-absolute":{"syntax":"normal | bold | <number [1,1000]>"},"frequency-percentage":{"syntax":"<frequency> | <percentage>"},"general-enclosed":{"syntax":"[ <function-token> <any-value> ) ] | ( <ident> <any-value> )"},"generic-family":{"syntax":"serif | sans-serif | cursive | fantasy | monospace"},"generic-name":{"syntax":"serif | sans-serif | cursive | fantasy | monospace"},"geometry-box":{"syntax":"<shape-box> | fill-box | stroke-box | view-box"},"gradient":{"syntax":"<linear-gradient()> | <repeating-linear-gradient()> | <radial-gradient()> | <repeating-radial-gradient()> | <conic-gradient()>"},"grayscale()":{"syntax":"grayscale( <number-percentage> )"},"grid-line":{"syntax":"auto | <custom-ident> | [ <integer> && <custom-ident>? ] | [ span && [ <integer> || <custom-ident> ] ]"},"historical-lig-values":{"syntax":"[ historical-ligatures | no-historical-ligatures ]"},"hsl()":{"syntax":"hsl( <hue> <percentage> <percentage> [ / <alpha-value> ]? ) | hsl( <hue>, <percentage>, <percentage>, <alpha-value>? )"},"hsla()":{"syntax":"hsla( <hue> <percentage> <percentage> [ / <alpha-value> ]? ) | hsla( <hue>, <percentage>, <percentage>, <alpha-value>? )"},"hue":{"syntax":"<number> | <angle>"},"hue-rotate()":{"syntax":"hue-rotate( <angle> )"},"id-selector":{"syntax":"<hash-token>"},"image":{"syntax":"<url> | <image()> | <image-set()> | <element()> | <paint()> | <cross-fade()> | <gradient>"},"image()":{"syntax":"image( <image-tags>? [ <image-src>? , <color>? ]! )"},"image-set()":{"syntax":"image-set( <image-set-option># )"},"image-set-option":{"syntax":"[ <image> | <string> ] <resolution>"},"image-src":{"syntax":"<url> | <string>"},"image-tags":{"syntax":"ltr | rtl"},"inflexible-breadth":{"syntax":"<length> | <percentage> | min-content | max-content | auto"},"inset()":{"syntax":"inset( <length-percentage>{1,4} [ round <\'border-radius\'> ]? )"},"invert()":{"syntax":"invert( <number-percentage> )"},"keyframes-name":{"syntax":"<custom-ident> | <string>"},"keyframe-block":{"syntax":"<keyframe-selector># {\\n  <declaration-list>\\n}"},"keyframe-block-list":{"syntax":"<keyframe-block>+"},"keyframe-selector":{"syntax":"from | to | <percentage>"},"leader()":{"syntax":"leader( <leader-type> )"},"leader-type":{"syntax":"dotted | solid | space | <string>"},"length-percentage":{"syntax":"<length> | <percentage>"},"line-names":{"syntax":"\'[\' <custom-ident>* \']\'"},"line-name-list":{"syntax":"[ <line-names> | <name-repeat> ]+"},"line-style":{"syntax":"none | hidden | dotted | dashed | solid | double | groove | ridge | inset | outset"},"line-width":{"syntax":"<length> | thin | medium | thick"},"linear-color-hint":{"syntax":"<length-percentage>"},"linear-color-stop":{"syntax":"<color> <color-stop-length>?"},"linear-gradient()":{"syntax":"linear-gradient( [ <angle> | to <side-or-corner> ]? , <color-stop-list> )"},"mask-layer":{"syntax":"<mask-reference> || <position> [ / <bg-size> ]? || <repeat-style> || <geometry-box> || [ <geometry-box> | no-clip ] || <compositing-operator> || <masking-mode>"},"mask-position":{"syntax":"[ <length-percentage> | left | center | right ] [ <length-percentage> | top | center | bottom ]?"},"mask-reference":{"syntax":"none | <image> | <mask-source>"},"mask-source":{"syntax":"<url>"},"masking-mode":{"syntax":"alpha | luminance | match-source"},"matrix()":{"syntax":"matrix( <number>#{6} )"},"matrix3d()":{"syntax":"matrix3d( <number>#{16} )"},"max()":{"syntax":"max( <calc-sum># )"},"media-and":{"syntax":"<media-in-parens> [ and <media-in-parens> ]+"},"media-condition":{"syntax":"<media-not> | <media-and> | <media-or> | <media-in-parens>"},"media-condition-without-or":{"syntax":"<media-not> | <media-and> | <media-in-parens>"},"media-feature":{"syntax":"( [ <mf-plain> | <mf-boolean> | <mf-range> ] )"},"media-in-parens":{"syntax":"( <media-condition> ) | <media-feature> | <general-enclosed>"},"media-not":{"syntax":"not <media-in-parens>"},"media-or":{"syntax":"<media-in-parens> [ or <media-in-parens> ]+"},"media-query":{"syntax":"<media-condition> | [ not | only ]? <media-type> [ and <media-condition-without-or> ]?"},"media-query-list":{"syntax":"<media-query>#"},"media-type":{"syntax":"<ident>"},"mf-boolean":{"syntax":"<mf-name>"},"mf-name":{"syntax":"<ident>"},"mf-plain":{"syntax":"<mf-name> : <mf-value>"},"mf-range":{"syntax":"<mf-name> [ \'<\' | \'>\' ]? \'=\'? <mf-value>\\n| <mf-value> [ \'<\' | \'>\' ]? \'=\'? <mf-name>\\n| <mf-value> \'<\' \'=\'? <mf-name> \'<\' \'=\'? <mf-value>\\n| <mf-value> \'>\' \'=\'? <mf-name> \'>\' \'=\'? <mf-value>"},"mf-value":{"syntax":"<number> | <dimension> | <ident> | <ratio>"},"min()":{"syntax":"min( <calc-sum># )"},"minmax()":{"syntax":"minmax( [ <length> | <percentage> | min-content | max-content | auto ] , [ <length> | <percentage> | <flex> | min-content | max-content | auto ] )"},"named-color":{"syntax":"transparent | aliceblue | antiquewhite | aqua | aquamarine | azure | beige | bisque | black | blanchedalmond | blue | blueviolet | brown | burlywood | cadetblue | chartreuse | chocolate | coral | cornflowerblue | cornsilk | crimson | cyan | darkblue | darkcyan | darkgoldenrod | darkgray | darkgreen | darkgrey | darkkhaki | darkmagenta | darkolivegreen | darkorange | darkorchid | darkred | darksalmon | darkseagreen | darkslateblue | darkslategray | darkslategrey | darkturquoise | darkviolet | deeppink | deepskyblue | dimgray | dimgrey | dodgerblue | firebrick | floralwhite | forestgreen | fuchsia | gainsboro | ghostwhite | gold | goldenrod | gray | green | greenyellow | grey | honeydew | hotpink | indianred | indigo | ivory | khaki | lavender | lavenderblush | lawngreen | lemonchiffon | lightblue | lightcoral | lightcyan | lightgoldenrodyellow | lightgray | lightgreen | lightgrey | lightpink | lightsalmon | lightseagreen | lightskyblue | lightslategray | lightslategrey | lightsteelblue | lightyellow | lime | limegreen | linen | magenta | maroon | mediumaquamarine | mediumblue | mediumorchid | mediumpurple | mediumseagreen | mediumslateblue | mediumspringgreen | mediumturquoise | mediumvioletred | midnightblue | mintcream | mistyrose | moccasin | navajowhite | navy | oldlace | olive | olivedrab | orange | orangered | orchid | palegoldenrod | palegreen | paleturquoise | palevioletred | papayawhip | peachpuff | peru | pink | plum | powderblue | purple | rebeccapurple | red | rosybrown | royalblue | saddlebrown | salmon | sandybrown | seagreen | seashell | sienna | silver | skyblue | slateblue | slategray | slategrey | snow | springgreen | steelblue | tan | teal | thistle | tomato | turquoise | violet | wheat | white | whitesmoke | yellow | yellowgreen"},"namespace-prefix":{"syntax":"<ident>"},"ns-prefix":{"syntax":"[ <ident-token> | \'*\' ]? \'|\'"},"number-percentage":{"syntax":"<number> | <percentage>"},"numeric-figure-values":{"syntax":"[ lining-nums | oldstyle-nums ]"},"numeric-fraction-values":{"syntax":"[ diagonal-fractions | stacked-fractions ]"},"numeric-spacing-values":{"syntax":"[ proportional-nums | tabular-nums ]"},"nth":{"syntax":"<an-plus-b> | even | odd"},"opacity()":{"syntax":"opacity( [ <number-percentage> ] )"},"overflow-position":{"syntax":"unsafe | safe"},"outline-radius":{"syntax":"<length> | <percentage>"},"page-body":{"syntax":"<declaration>? [ ; <page-body> ]? | <page-margin-box> <page-body>"},"page-margin-box":{"syntax":"<page-margin-box-type> \'{\' <declaration-list> \'}\'"},"page-margin-box-type":{"syntax":"@top-left-corner | @top-left | @top-center | @top-right | @top-right-corner | @bottom-left-corner | @bottom-left | @bottom-center | @bottom-right | @bottom-right-corner | @left-top | @left-middle | @left-bottom | @right-top | @right-middle | @right-bottom"},"page-selector-list":{"syntax":"[ <page-selector># ]?"},"page-selector":{"syntax":"<pseudo-page>+ | <ident> <pseudo-page>*"},"path()":{"syntax":"path( [ <fill-rule>, ]? <string> )"},"paint()":{"syntax":"paint( <ident>, <declaration-value>? )"},"perspective()":{"syntax":"perspective( <length> )"},"polygon()":{"syntax":"polygon( <fill-rule>? , [ <length-percentage> <length-percentage> ]# )"},"position":{"syntax":"[ [ left | center | right ] || [ top | center | bottom ] | [ left | center | right | <length-percentage> ] [ top | center | bottom | <length-percentage> ]? | [ [ left | right ] <length-percentage> ] && [ [ top | bottom ] <length-percentage> ] ]"},"pseudo-class-selector":{"syntax":"\':\' <ident-token> | \':\' <function-token> <any-value> \')\'"},"pseudo-element-selector":{"syntax":"\':\' <pseudo-class-selector>"},"pseudo-page":{"syntax":": [ left | right | first | blank ]"},"quote":{"syntax":"open-quote | close-quote | no-open-quote | no-close-quote"},"radial-gradient()":{"syntax":"radial-gradient( [ <ending-shape> || <size> ]? [ at <position> ]? , <color-stop-list> )"},"relative-selector":{"syntax":"<combinator>? <complex-selector>"},"relative-selector-list":{"syntax":"<relative-selector>#"},"relative-size":{"syntax":"larger | smaller"},"repeat-style":{"syntax":"repeat-x | repeat-y | [ repeat | space | round | no-repeat ]{1,2}"},"repeating-linear-gradient()":{"syntax":"repeating-linear-gradient( [ <angle> | to <side-or-corner> ]? , <color-stop-list> )"},"repeating-radial-gradient()":{"syntax":"repeating-radial-gradient( [ <ending-shape> || <size> ]? [ at <position> ]? , <color-stop-list> )"},"rgb()":{"syntax":"rgb( <percentage>{3} [ / <alpha-value> ]? ) | rgb( <number>{3} [ / <alpha-value> ]? ) | rgb( <percentage>#{3} , <alpha-value>? ) | rgb( <number>#{3} , <alpha-value>? )"},"rgba()":{"syntax":"rgba( <percentage>{3} [ / <alpha-value> ]? ) | rgba( <number>{3} [ / <alpha-value> ]? ) | rgba( <percentage>#{3} , <alpha-value>? ) | rgba( <number>#{3} , <alpha-value>? )"},"rotate()":{"syntax":"rotate( [ <angle> | <zero> ] )"},"rotate3d()":{"syntax":"rotate3d( <number> , <number> , <number> , [ <angle> | <zero> ] )"},"rotateX()":{"syntax":"rotateX( [ <angle> | <zero> ] )"},"rotateY()":{"syntax":"rotateY( [ <angle> | <zero> ] )"},"rotateZ()":{"syntax":"rotateZ( [ <angle> | <zero> ] )"},"saturate()":{"syntax":"saturate( <number-percentage> )"},"scale()":{"syntax":"scale( <number> , <number>? )"},"scale3d()":{"syntax":"scale3d( <number> , <number> , <number> )"},"scaleX()":{"syntax":"scaleX( <number> )"},"scaleY()":{"syntax":"scaleY( <number> )"},"scaleZ()":{"syntax":"scaleZ( <number> )"},"self-position":{"syntax":"center | start | end | self-start | self-end | flex-start | flex-end"},"shape-radius":{"syntax":"<length-percentage> | closest-side | farthest-side"},"skew()":{"syntax":"skew( [ <angle> | <zero> ] , [ <angle> | <zero> ]? )"},"skewX()":{"syntax":"skewX( [ <angle> | <zero> ] )"},"skewY()":{"syntax":"skewY( [ <angle> | <zero> ] )"},"sepia()":{"syntax":"sepia( <number-percentage> )"},"shadow":{"syntax":"inset? && <length>{2,4} && <color>?"},"shadow-t":{"syntax":"[ <length>{2,3} && <color>? ]"},"shape":{"syntax":"rect(<top>, <right>, <bottom>, <left>)"},"shape-box":{"syntax":"<box> | margin-box"},"side-or-corner":{"syntax":"[ left | right ] || [ top | bottom ]"},"single-animation":{"syntax":"<time> || <timing-function> || <time> || <single-animation-iteration-count> || <single-animation-direction> || <single-animation-fill-mode> || <single-animation-play-state> || [ none | <keyframes-name> ]"},"single-animation-direction":{"syntax":"normal | reverse | alternate | alternate-reverse"},"single-animation-fill-mode":{"syntax":"none | forwards | backwards | both"},"single-animation-iteration-count":{"syntax":"infinite | <number>"},"single-animation-play-state":{"syntax":"running | paused"},"single-transition":{"syntax":"[ none | <single-transition-property> ] || <time> || <timing-function> || <time>"},"single-transition-property":{"syntax":"all | <custom-ident>"},"size":{"syntax":"closest-side | farthest-side | closest-corner | farthest-corner | <length> | <length-percentage>{2}"},"step-position":{"syntax":"jump-start | jump-end | jump-none | jump-both | start | end"},"step-timing-function":{"syntax":"step-start | step-end | steps(<integer>[, <step-position>]?)"},"subclass-selector":{"syntax":"<id-selector> | <class-selector> | <attribute-selector> | <pseudo-class-selector>"},"supports-condition":{"syntax":"not <supports-in-parens> | <supports-in-parens> [ and <supports-in-parens> ]* | <supports-in-parens> [ or <supports-in-parens> ]*"},"supports-in-parens":{"syntax":"( <supports-condition> ) | <supports-feature> | <general-enclosed>"},"supports-feature":{"syntax":"<supports-decl> | <supports-selector-fn>"},"supports-decl":{"syntax":"( <declaration> )"},"supports-selector-fn":{"syntax":"selector( <complex-selector> )"},"symbol":{"syntax":"<string> | <image> | <custom-ident>"},"target":{"syntax":"<target-counter()> | <target-counters()> | <target-text()>"},"target-counter()":{"syntax":"target-counter( [ <string> | <url> ] , <custom-ident> , <counter-style>? )"},"target-counters()":{"syntax":"target-counters( [ <string> | <url> ] , <custom-ident> , <string> , <counter-style>? )"},"target-text()":{"syntax":"target-text( [ <string> | <url> ] , [ content | before | after | first-letter ]? )"},"time-percentage":{"syntax":"<time> | <percentage>"},"timing-function":{"syntax":"linear | <cubic-bezier-timing-function> | <step-timing-function>"},"track-breadth":{"syntax":"<length-percentage> | <flex> | min-content | max-content | auto"},"track-list":{"syntax":"[ <line-names>? [ <track-size> | <track-repeat> ] ]+ <line-names>?"},"track-repeat":{"syntax":"repeat( [ <positive-integer> ] , [ <line-names>? <track-size> ]+ <line-names>? )"},"track-size":{"syntax":"<track-breadth> | minmax( <inflexible-breadth> , <track-breadth> ) | fit-content( [ <length> | <percentage> ] )"},"transform-function":{"syntax":"<matrix()> | <translate()> | <translateX()> | <translateY()> | <scale()> | <scaleX()> | <scaleY()> | <rotate()> | <skew()> | <skewX()> | <skewY()> | <matrix3d()> | <translate3d()> | <translateZ()> | <scale3d()> | <scaleZ()> | <rotate3d()> | <rotateX()> | <rotateY()> | <rotateZ()> | <perspective()>"},"transform-list":{"syntax":"<transform-function>+"},"translate()":{"syntax":"translate( <length-percentage> , <length-percentage>? )"},"translate3d()":{"syntax":"translate3d( <length-percentage> , <length-percentage> , <length> )"},"translateX()":{"syntax":"translateX( <length-percentage> )"},"translateY()":{"syntax":"translateY( <length-percentage> )"},"translateZ()":{"syntax":"translateZ( <length> )"},"type-or-unit":{"syntax":"string | color | url | integer | number | length | angle | time | frequency | cap | ch | em | ex | ic | lh | rlh | rem | vb | vi | vw | vh | vmin | vmax | mm | Q | cm | in | pt | pc | px | deg | grad | rad | turn | ms | s | Hz | kHz | %"},"type-selector":{"syntax":"<wq-name> | <ns-prefix>? \'*\'"},"var()":{"syntax":"var( <custom-property-name> , <declaration-value>? )"},"viewport-length":{"syntax":"auto | <length-percentage>"},"wq-name":{"syntax":"<ns-prefix>? <ident-token>"}}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		if (!(moduleId in __webpack_modules__)) {
/******/ 			delete __webpack_module_cache__[moduleId];
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.js");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=scratch-render.js.map